// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"7OB19":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddContext", ()=>AddContext);
parcelHelpers.export(exports, "Anchor", ()=>Anchor);
parcelHelpers.export(exports, "AnchorMdx", ()=>AnchorMdx);
parcelHelpers.export(exports, "ArgTypes", ()=>ArgTypes);
parcelHelpers.export(exports, "ArgsTable", ()=>ArgsTable2);
parcelHelpers.export(exports, "BooleanControl", ()=>BooleanControl);
parcelHelpers.export(exports, "Canvas", ()=>Canvas);
parcelHelpers.export(exports, "CodeOrSourceMdx", ()=>CodeOrSourceMdx);
parcelHelpers.export(exports, "ColorControl", ()=>ColorControl);
parcelHelpers.export(exports, "ColorItem", ()=>ColorItem);
parcelHelpers.export(exports, "ColorPalette", ()=>ColorPalette);
parcelHelpers.export(exports, "ComponentsTable", ()=>ComponentsTable);
parcelHelpers.export(exports, "Controls", ()=>Controls3);
parcelHelpers.export(exports, "DateControl", ()=>DateControl);
parcelHelpers.export(exports, "Description", ()=>DescriptionContainer);
parcelHelpers.export(exports, "DescriptionType", ()=>DescriptionType);
parcelHelpers.export(exports, "Docs", ()=>Docs);
parcelHelpers.export(exports, "DocsContainer", ()=>DocsContainer);
parcelHelpers.export(exports, "DocsContext", ()=>DocsContext);
parcelHelpers.export(exports, "DocsPage", ()=>DocsPage);
parcelHelpers.export(exports, "DocsStory", ()=>DocsStory);
parcelHelpers.export(exports, "ExternalDocs", ()=>ExternalDocs);
parcelHelpers.export(exports, "ExternalDocsContainer", ()=>ExternalDocsContainer);
parcelHelpers.export(exports, "FilesControl", ()=>FilesControl);
parcelHelpers.export(exports, "HeaderMdx", ()=>HeaderMdx);
parcelHelpers.export(exports, "HeadersMdx", ()=>HeadersMdx);
parcelHelpers.export(exports, "Heading", ()=>Heading2);
parcelHelpers.export(exports, "IconGallery", ()=>IconGallery);
parcelHelpers.export(exports, "IconItem", ()=>IconItem);
parcelHelpers.export(exports, "Markdown", ()=>Markdown2);
parcelHelpers.export(exports, "Meta", ()=>Meta);
parcelHelpers.export(exports, "NumberControl", ()=>NumberControl);
parcelHelpers.export(exports, "ObjectControl", ()=>ObjectControl);
parcelHelpers.export(exports, "OptionsControl", ()=>OptionsControl);
parcelHelpers.export(exports, "PRIMARY_STORY", ()=>PRIMARY_STORY);
parcelHelpers.export(exports, "Primary", ()=>Primary);
parcelHelpers.export(exports, "PureArgsTable", ()=>ArgsTable);
parcelHelpers.export(exports, "RangeControl", ()=>RangeControl);
parcelHelpers.export(exports, "Source", ()=>Source2);
parcelHelpers.export(exports, "SourceContainer", ()=>SourceContainer);
parcelHelpers.export(exports, "SourceContext", ()=>SourceContext);
parcelHelpers.export(exports, "SourceState", ()=>SourceState);
parcelHelpers.export(exports, "Stories", ()=>Stories);
parcelHelpers.export(exports, "Story", ()=>Story2);
parcelHelpers.export(exports, "StoryTable", ()=>StoryTable);
parcelHelpers.export(exports, "Subheading", ()=>Subheading);
parcelHelpers.export(exports, "Subtitle", ()=>Subtitle2);
parcelHelpers.export(exports, "TextControl", ()=>TextControl);
parcelHelpers.export(exports, "Title", ()=>Title3);
parcelHelpers.export(exports, "Typeset", ()=>Typeset);
parcelHelpers.export(exports, "UNKNOWN_ARGS_HASH", ()=>UNKNOWN_ARGS_HASH);
parcelHelpers.export(exports, "Unstyled", ()=>Unstyled);
parcelHelpers.export(exports, "Wrapper", ()=>Wrapper10);
parcelHelpers.export(exports, "anchorBlockIdFromId", ()=>anchorBlockIdFromId);
parcelHelpers.export(exports, "argsHash", ()=>argsHash);
parcelHelpers.export(exports, "assertIsFn", ()=>assertIsFn);
parcelHelpers.export(exports, "extractComponentArgTypes", ()=>extractComponentArgTypes2);
parcelHelpers.export(exports, "extractTitle", ()=>extractTitle);
parcelHelpers.export(exports, "format", ()=>format);
parcelHelpers.export(exports, "formatDate", ()=>formatDate);
parcelHelpers.export(exports, "formatTime", ()=>formatTime);
parcelHelpers.export(exports, "getComponent", ()=>getComponent);
parcelHelpers.export(exports, "getStoryId", ()=>getStoryId2);
parcelHelpers.export(exports, "getStoryProps", ()=>getStoryProps);
parcelHelpers.export(exports, "parse", ()=>parse2);
parcelHelpers.export(exports, "parseDate", ()=>parseDate);
parcelHelpers.export(exports, "parseTime", ()=>parseTime);
parcelHelpers.export(exports, "useOf", ()=>useOf);
parcelHelpers.export(exports, "useSourceProps", ()=>useSourceProps);
var _chunkGWAJ4KRUMjs = require("./chunk-GWAJ4KRU.mjs");
var _theming = require("@storybook/theming");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("@storybook/components");
var _polished = require("polished");
var _global = require("@storybook/global");
var _pickByJs = require("lodash/pickBy.js");
var _pickByJsDefault = parcelHelpers.interopDefault(_pickByJs);
var _csf = require("@storybook/csf");
var _clientLogger = require("@storybook/client-logger");
var _markdownToJsx = require("markdown-to-jsx");
var _markdownToJsxDefault = parcelHelpers.interopDefault(_markdownToJsx);
var _memoizerific = require("memoizerific");
var _memoizerificDefault = parcelHelpers.interopDefault(_memoizerific);
var _uniqJs = require("lodash/uniq.js");
var _uniqJsDefault = parcelHelpers.interopDefault(_uniqJs);
var _cloneDeepJs = require("lodash/cloneDeep.js");
var _cloneDeepJsDefault = parcelHelpers.interopDefault(_cloneDeepJs);
var _previewApi = require("@storybook/preview-api");
var _mapValuesJs = require("lodash/mapValues.js");
var _mapValuesJsDefault = parcelHelpers.interopDefault(_mapValuesJs);
var _coreEvents = require("@storybook/core-events");
var _tsDedent = require("ts-dedent");
var _tsDedentDefault = parcelHelpers.interopDefault(_tsDedent);
var _docsTools = require("@storybook/docs-tools");
var _telejson = require("telejson");
var _tocbot = require("tocbot");
var _channels = require("@storybook/channels");
var Wrapper = (0, _theming.styled).div((0, _components.withReset), ({ theme })=>({
        backgroundColor: theme.base === "light" ? "rgba(0,0,0,.01)" : "rgba(255,255,255,.01)",
        borderRadius: theme.appBorderRadius,
        border: `1px dashed ${theme.appBorderColor}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
        margin: "25px 0 40px",
        color: (0, _polished.transparentize)(.3, theme.color.defaultText),
        fontSize: theme.typography.size.s2
    })), EmptyBlock = (props)=>(0, _reactDefault.default).createElement(Wrapper, {
        ...props,
        className: "docblock-emptyblock sb-unstyled"
    });
var StyledSyntaxHighlighter = (0, _theming.styled)((0, _components.SyntaxHighlighter))(({ theme })=>({
        fontSize: `${theme.typography.size.s2 - 1}px`,
        lineHeight: "19px",
        margin: "25px 0 40px",
        borderRadius: theme.appBorderRadius,
        boxShadow: theme.base === "light" ? "rgba(0, 0, 0, 0.10) 0 1px 3px 0" : "rgba(0, 0, 0, 0.20) 0 2px 5px 0",
        "pre.prismjs": {
            padding: 20,
            background: "inherit"
        }
    }));
var SourceSkeletonWrapper = (0, _theming.styled).div(({ theme })=>({
        background: theme.background.content,
        borderRadius: theme.appBorderRadius,
        border: `1px solid ${theme.appBorderColor}`,
        boxShadow: theme.base === "light" ? "rgba(0, 0, 0, 0.10) 0 1px 3px 0" : "rgba(0, 0, 0, 0.20) 0 2px 5px 0",
        margin: "25px 0 40px",
        padding: "20px 20px 20px 22px"
    })), SourceSkeletonPlaceholder = (0, _theming.styled).div(({ theme })=>({
        animation: `${theme.animation.glow} 1.5s ease-in-out infinite`,
        background: theme.appBorderColor,
        height: 17,
        marginTop: 1,
        width: "60%",
        [`&:first-child${0, _theming.ignoreSsrWarning}`]: {
            margin: 0
        }
    })), SourceSkeleton = ()=>(0, _reactDefault.default).createElement(SourceSkeletonWrapper, null, (0, _reactDefault.default).createElement(SourceSkeletonPlaceholder, null), (0, _reactDefault.default).createElement(SourceSkeletonPlaceholder, {
        style: {
            width: "80%"
        }
    }), (0, _reactDefault.default).createElement(SourceSkeletonPlaceholder, {
        style: {
            width: "30%"
        }
    }), (0, _reactDefault.default).createElement(SourceSkeletonPlaceholder, {
        style: {
            width: "80%"
        }
    })), Source = ({ isLoading, error, language, code, dark, format: format2, ...rest })=>{
    if (isLoading) return (0, _reactDefault.default).createElement(SourceSkeleton, null);
    if (error) return (0, _reactDefault.default).createElement(EmptyBlock, null, error);
    let syntaxHighlighter = (0, _reactDefault.default).createElement(StyledSyntaxHighlighter, {
        bordered: !0,
        copyable: !0,
        format: format2,
        language,
        className: "docblock-source sb-unstyled",
        ...rest
    }, code);
    if (typeof dark > "u") return syntaxHighlighter;
    let overrideTheme = dark ? (0, _theming.themes).dark : (0, _theming.themes).light;
    return (0, _reactDefault.default).createElement((0, _theming.ThemeProvider), {
        theme: (0, _theming.convert)(overrideTheme)
    }, syntaxHighlighter);
};
Source.defaultProps = {
    format: !1
};
var toGlobalSelector = (element)=>`& :where(${element}:not(.sb-anchor, .sb-unstyled, .sb-unstyled ${element}))`, breakpoint = 600, Title = (0, _theming.styled).h1((0, _components.withReset), ({ theme })=>({
        color: theme.color.defaultText,
        fontSize: theme.typography.size.m3,
        fontWeight: theme.typography.weight.bold,
        lineHeight: "32px",
        [`@media (min-width: ${breakpoint}px)`]: {
            fontSize: theme.typography.size.l1,
            lineHeight: "36px",
            marginBottom: "16px"
        }
    })), Subtitle = (0, _theming.styled).h2((0, _components.withReset), ({ theme })=>({
        fontWeight: theme.typography.weight.regular,
        fontSize: theme.typography.size.s3,
        lineHeight: "20px",
        borderBottom: "none",
        marginBottom: 15,
        [`@media (min-width: ${breakpoint}px)`]: {
            fontSize: theme.typography.size.m1,
            lineHeight: "28px",
            marginBottom: 24
        },
        color: (0, _polished.transparentize)(.25, theme.color.defaultText)
    })), DocsContent = (0, _theming.styled).div(({ theme })=>{
    let reset = {
        fontFamily: theme.typography.fonts.base,
        fontSize: theme.typography.size.s3,
        margin: 0,
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
        WebkitOverflowScrolling: "touch"
    }, headers = {
        margin: "20px 0 8px",
        padding: 0,
        cursor: "text",
        position: "relative",
        color: theme.color.defaultText,
        "&:first-of-type": {
            marginTop: 0,
            paddingTop: 0
        },
        "&:hover a.anchor": {
            textDecoration: "none"
        },
        "& code": {
            fontSize: "inherit"
        }
    }, code = {
        lineHeight: 1,
        margin: "0 2px",
        padding: "3px 5px",
        whiteSpace: "nowrap",
        borderRadius: 3,
        fontSize: theme.typography.size.s2 - 1,
        border: theme.base === "light" ? `1px solid ${theme.color.mediumlight}` : `1px solid ${theme.color.darker}`,
        color: theme.base === "light" ? (0, _polished.transparentize)(.1, theme.color.defaultText) : (0, _polished.transparentize)(.3, theme.color.defaultText),
        backgroundColor: theme.base === "light" ? theme.color.lighter : theme.color.border
    };
    return {
        maxWidth: 1e3,
        width: "100%",
        [toGlobalSelector("a")]: {
            ...reset,
            fontSize: "inherit",
            lineHeight: "24px",
            color: theme.color.secondary,
            textDecoration: "none",
            "&.absent": {
                color: "#cc0000"
            },
            "&.anchor": {
                display: "block",
                paddingLeft: 30,
                marginLeft: -30,
                cursor: "pointer",
                position: "absolute",
                top: 0,
                left: 0,
                bottom: 0
            }
        },
        [toGlobalSelector("blockquote")]: {
            ...reset,
            margin: "16px 0",
            borderLeft: `4px solid ${theme.color.medium}`,
            padding: "0 15px",
            color: theme.color.dark,
            "& > :first-of-type": {
                marginTop: 0
            },
            "& > :last-child": {
                marginBottom: 0
            }
        },
        [toGlobalSelector("div")]: reset,
        [toGlobalSelector("dl")]: {
            ...reset,
            margin: "16px 0",
            padding: 0,
            "& dt": {
                fontSize: "14px",
                fontWeight: "bold",
                fontStyle: "italic",
                padding: 0,
                margin: "16px 0 4px"
            },
            "& dt:first-of-type": {
                padding: 0
            },
            "& dt > :first-of-type": {
                marginTop: 0
            },
            "& dt > :last-child": {
                marginBottom: 0
            },
            "& dd": {
                margin: "0 0 16px",
                padding: "0 15px"
            },
            "& dd > :first-of-type": {
                marginTop: 0
            },
            "& dd > :last-child": {
                marginBottom: 0
            }
        },
        [toGlobalSelector("h1")]: {
            ...reset,
            ...headers,
            fontSize: `${theme.typography.size.l1}px`,
            fontWeight: theme.typography.weight.bold
        },
        [toGlobalSelector("h2")]: {
            ...reset,
            ...headers,
            fontSize: `${theme.typography.size.m2}px`,
            paddingBottom: 4,
            borderBottom: `1px solid ${theme.appBorderColor}`
        },
        [toGlobalSelector("h3")]: {
            ...reset,
            ...headers,
            fontSize: `${theme.typography.size.m1}px`,
            fontWeight: theme.typography.weight.bold
        },
        [toGlobalSelector("h4")]: {
            ...reset,
            ...headers,
            fontSize: `${theme.typography.size.s3}px`
        },
        [toGlobalSelector("h5")]: {
            ...reset,
            ...headers,
            fontSize: `${theme.typography.size.s2}px`
        },
        [toGlobalSelector("h6")]: {
            ...reset,
            ...headers,
            fontSize: `${theme.typography.size.s2}px`,
            color: theme.color.dark
        },
        [toGlobalSelector("hr")]: {
            border: "0 none",
            borderTop: `1px solid ${theme.appBorderColor}`,
            height: 4,
            padding: 0
        },
        [toGlobalSelector("img")]: {
            maxWidth: "100%"
        },
        [toGlobalSelector("li")]: {
            ...reset,
            fontSize: theme.typography.size.s2,
            color: theme.color.defaultText,
            lineHeight: "24px",
            "& + li": {
                marginTop: ".25em"
            },
            "& ul, & ol": {
                marginTop: ".25em",
                marginBottom: 0
            },
            "& code": code
        },
        [toGlobalSelector("ol")]: {
            ...reset,
            margin: "16px 0",
            paddingLeft: 30,
            "& :first-of-type": {
                marginTop: 0
            },
            "& :last-child": {
                marginBottom: 0
            }
        },
        [toGlobalSelector("p")]: {
            ...reset,
            margin: "16px 0",
            fontSize: theme.typography.size.s2,
            lineHeight: "24px",
            color: theme.color.defaultText,
            "& code": code
        },
        [toGlobalSelector("pre")]: {
            ...reset,
            fontFamily: theme.typography.fonts.mono,
            WebkitFontSmoothing: "antialiased",
            MozOsxFontSmoothing: "grayscale",
            lineHeight: "18px",
            padding: "11px 1rem",
            whiteSpace: "pre-wrap",
            color: "inherit",
            borderRadius: 3,
            margin: "1rem 0",
            "&:not(.prismjs)": {
                background: "transparent",
                border: "none",
                borderRadius: 0,
                padding: 0,
                margin: 0
            },
            "& pre, &.prismjs": {
                padding: 15,
                margin: 0,
                whiteSpace: "pre-wrap",
                color: "inherit",
                fontSize: "13px",
                lineHeight: "19px",
                code: {
                    color: "inherit",
                    fontSize: "inherit"
                }
            },
            "& code": {
                whiteSpace: "pre"
            },
            "& code, & tt": {
                border: "none"
            }
        },
        [toGlobalSelector("span")]: {
            ...reset,
            "&.frame": {
                display: "block",
                overflow: "hidden",
                "& > span": {
                    border: `1px solid ${theme.color.medium}`,
                    display: "block",
                    float: "left",
                    overflow: "hidden",
                    margin: "13px 0 0",
                    padding: 7,
                    width: "auto"
                },
                "& span img": {
                    display: "block",
                    float: "left"
                },
                "& span span": {
                    clear: "both",
                    color: theme.color.darkest,
                    display: "block",
                    padding: "5px 0 0"
                }
            },
            "&.align-center": {
                display: "block",
                overflow: "hidden",
                clear: "both",
                "& > span": {
                    display: "block",
                    overflow: "hidden",
                    margin: "13px auto 0",
                    textAlign: "center"
                },
                "& span img": {
                    margin: "0 auto",
                    textAlign: "center"
                }
            },
            "&.align-right": {
                display: "block",
                overflow: "hidden",
                clear: "both",
                "& > span": {
                    display: "block",
                    overflow: "hidden",
                    margin: "13px 0 0",
                    textAlign: "right"
                },
                "& span img": {
                    margin: 0,
                    textAlign: "right"
                }
            },
            "&.float-left": {
                display: "block",
                marginRight: 13,
                overflow: "hidden",
                float: "left",
                "& span": {
                    margin: "13px 0 0"
                }
            },
            "&.float-right": {
                display: "block",
                marginLeft: 13,
                overflow: "hidden",
                float: "right",
                "& > span": {
                    display: "block",
                    overflow: "hidden",
                    margin: "13px auto 0",
                    textAlign: "right"
                }
            }
        },
        [toGlobalSelector("table")]: {
            ...reset,
            margin: "16px 0",
            fontSize: theme.typography.size.s2,
            lineHeight: "24px",
            padding: 0,
            borderCollapse: "collapse",
            "& tr": {
                borderTop: `1px solid ${theme.appBorderColor}`,
                backgroundColor: theme.appContentBg,
                margin: 0,
                padding: 0
            },
            "& tr:nth-of-type(2n)": {
                backgroundColor: theme.base === "dark" ? theme.color.darker : theme.color.lighter
            },
            "& tr th": {
                fontWeight: "bold",
                color: theme.color.defaultText,
                border: `1px solid ${theme.appBorderColor}`,
                margin: 0,
                padding: "6px 13px"
            },
            "& tr td": {
                border: `1px solid ${theme.appBorderColor}`,
                color: theme.color.defaultText,
                margin: 0,
                padding: "6px 13px"
            },
            "& tr th :first-of-type, & tr td :first-of-type": {
                marginTop: 0
            },
            "& tr th :last-child, & tr td :last-child": {
                marginBottom: 0
            }
        },
        [toGlobalSelector("ul")]: {
            ...reset,
            margin: "16px 0",
            paddingLeft: 30,
            "& :first-of-type": {
                marginTop: 0
            },
            "& :last-child": {
                marginBottom: 0
            },
            listStyle: "disc"
        }
    };
}), DocsWrapper = (0, _theming.styled).div(({ theme })=>({
        background: theme.background.content,
        display: "flex",
        justifyContent: "center",
        padding: "4rem 20px",
        minHeight: "100vh",
        boxSizing: "border-box",
        gap: "3rem",
        [`@media (min-width: ${breakpoint}px)`]: {}
    })), DocsPageWrapper = ({ children, toc })=>(0, _reactDefault.default).createElement(DocsWrapper, {
        className: "sbdocs sbdocs-wrapper"
    }, (0, _reactDefault.default).createElement(DocsContent, {
        className: "sbdocs sbdocs-content"
    }, children), toc);
var getBlockBackgroundStyle = (theme)=>({
        borderRadius: theme.appBorderRadius,
        background: theme.background.content,
        boxShadow: theme.base === "light" ? "rgba(0, 0, 0, 0.10) 0 1px 3px 0" : "rgba(0, 0, 0, 0.20) 0 2px 5px 0",
        border: `1px solid ${theme.appBorderColor}`
    });
var Zoom = ({ zoom, resetZoom })=>(0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement((0, _components.IconButton), {
        key: "zoomin",
        onClick: (e)=>{
            e.preventDefault(), zoom(.8);
        },
        title: "Zoom in"
    }, (0, _reactDefault.default).createElement((0, _components.Icons), {
        icon: "zoom"
    })), (0, _reactDefault.default).createElement((0, _components.IconButton), {
        key: "zoomout",
        onClick: (e)=>{
            e.preventDefault(), zoom(1.25);
        },
        title: "Zoom out"
    }, (0, _reactDefault.default).createElement((0, _components.Icons), {
        icon: "zoomout"
    })), (0, _reactDefault.default).createElement((0, _components.IconButton), {
        key: "zoomreset",
        onClick: (e)=>{
            e.preventDefault(), resetZoom();
        },
        title: "Reset zoom"
    }, (0, _reactDefault.default).createElement((0, _components.Icons), {
        icon: "zoomreset"
    }))), Bar = (0, _theming.styled)((0, _components.FlexBar))({
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    transition: "transform .2s linear"
}), Toolbar = ({ isLoading, storyId, baseUrl, zoom, resetZoom, ...rest })=>(0, _reactDefault.default).createElement(Bar, {
        ...rest
    }, (0, _reactDefault.default).createElement((0, _react.Fragment), {
        key: "left"
    }, isLoading ? [
        1,
        2,
        3
    ].map((key)=>(0, _reactDefault.default).createElement((0, _components.IconButtonSkeleton), {
            key
        })) : (0, _reactDefault.default).createElement(Zoom, {
        zoom,
        resetZoom
    })));
var ZoomContext = (0, _react.createContext)({
    scale: 1
});
var { window: globalWindow } = (0, _global.global), IFrame = class extends (0, _react.Component) {
    constructor(){
        super(...arguments);
        this.iframe = null;
    }
    componentDidMount() {
        let { id } = this.props;
        this.iframe = globalWindow.document.getElementById(id);
    }
    shouldComponentUpdate(nextProps) {
        let { scale } = nextProps;
        return scale !== this.props.scale && this.setIframeBodyStyle({
            width: `${scale * 100}%`,
            height: `${scale * 100}%`,
            transform: `scale(${1 / scale})`,
            transformOrigin: "top left"
        }), !1;
    }
    setIframeBodyStyle(style) {
        return Object.assign(this.iframe.contentDocument.body.style, style);
    }
    render() {
        let { id, title, src, allowFullScreen, scale, ...rest } = this.props;
        return (0, _reactDefault.default).createElement("iframe", {
            id,
            title,
            src,
            ...allowFullScreen ? {
                allow: "fullscreen"
            } : {},
            loading: "lazy",
            ...rest
        });
    }
};
var { PREVIEW_URL } = (0, _global.global), BASE_URL = PREVIEW_URL || "iframe.html", storyBlockIdFromId = ({ story, primary })=>`story--${story.id}${primary ? "--primary" : ""}`, InlineStory = (props)=>{
    let storyRef = (0, _react.useRef)(), [showLoader, setShowLoader] = (0, _react.useState)(!0), [error, setError] = (0, _react.useState)(), { story, height, autoplay, forceInitialArgs, renderStoryToElement } = props;
    return (0, _react.useEffect)(()=>{
        if (!(story && storyRef.current)) return ()=>{};
        let element = storyRef.current, cleanup = renderStoryToElement(story, element, {
            showMain: ()=>{},
            showError: ({ title, description })=>setError(new Error(`${title} - ${description}`)),
            showException: (err)=>setError(err)
        }, {
            autoplay,
            forceInitialArgs
        });
        return setShowLoader(!1), ()=>{
            Promise.resolve().then(()=>cleanup());
        };
    }, [
        autoplay,
        renderStoryToElement,
        story
    ]), error ? (0, _reactDefault.default).createElement("pre", null, (0, _reactDefault.default).createElement((0, _components.ErrorFormatter), {
        error
    })) : (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, height ? (0, _reactDefault.default).createElement("style", null, `#${storyBlockIdFromId(props)} { min-height: ${height}; transform: translateZ(0); overflow: auto }`) : null, showLoader && (0, _reactDefault.default).createElement(StorySkeleton, null), (0, _reactDefault.default).createElement("div", {
        ref: storyRef,
        id: `${storyBlockIdFromId(props)}-inner`,
        "data-name": story.name
    }));
}, IFrameStory = ({ story, height = "500px" })=>(0, _reactDefault.default).createElement("div", {
        style: {
            width: "100%",
            height
        }
    }, (0, _reactDefault.default).createElement(ZoomContext.Consumer, null, ({ scale })=>(0, _reactDefault.default).createElement(IFrame, {
            key: "iframe",
            id: `iframe--${story.id}`,
            title: story.name,
            src: (0, _components.getStoryHref)(BASE_URL, story.id, {
                viewMode: "story"
            }),
            allowFullScreen: !0,
            scale,
            style: {
                width: "100%",
                height: "100%",
                border: "0 none"
            }
        }))), Story = (props)=>{
    let { inline } = props;
    return (0, _reactDefault.default).createElement("div", {
        id: storyBlockIdFromId(props),
        className: "sb-story sb-unstyled",
        "data-story-block": "true"
    }, inline ? (0, _reactDefault.default).createElement(InlineStory, {
        ...props
    }) : (0, _reactDefault.default).createElement(IFrameStory, {
        ...props
    }));
}, StorySkeleton = ()=>(0, _reactDefault.default).createElement((0, _components.Loader), null);
var ChildrenContainer = (0, _theming.styled).div(({ isColumn, columns, layout })=>({
        display: isColumn || !columns ? "block" : "flex",
        position: "relative",
        flexWrap: "wrap",
        overflow: "auto",
        flexDirection: isColumn ? "column" : "row",
        "& .innerZoomElementWrapper > *": isColumn ? {
            width: layout !== "fullscreen" ? "calc(100% - 20px)" : "100%",
            display: "block"
        } : {
            maxWidth: layout !== "fullscreen" ? "calc(100% - 20px)" : "100%",
            display: "inline-block"
        }
    }), ({ layout = "padded" })=>layout === "centered" || layout === "padded" ? {
        padding: "30px 20px",
        "& .innerZoomElementWrapper > *": {
            width: "auto",
            border: "10px solid transparent!important"
        }
    } : {}, ({ layout = "padded" })=>layout === "centered" ? {
        display: "flex",
        justifyContent: "center",
        justifyItems: "center",
        alignContent: "center",
        alignItems: "center"
    } : {}, ({ columns })=>columns && columns > 1 ? {
        ".innerZoomElementWrapper > *": {
            minWidth: `calc(100% / ${columns} - 20px)`
        }
    } : {}), StyledSource = (0, _theming.styled)(Source)(({ theme })=>({
        margin: 0,
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
        borderBottomLeftRadius: theme.appBorderRadius,
        borderBottomRightRadius: theme.appBorderRadius,
        border: "none",
        background: theme.base === "light" ? "rgba(0, 0, 0, 0.85)" : (0, _polished.darken)(.05, theme.background.content),
        color: theme.color.lightest,
        button: {
            background: theme.base === "light" ? "rgba(0, 0, 0, 0.85)" : (0, _polished.darken)(.05, theme.background.content)
        }
    })), PreviewContainer = (0, _theming.styled).div(({ theme, withSource, isExpanded })=>({
        position: "relative",
        overflow: "hidden",
        margin: "25px 0 40px",
        ...getBlockBackgroundStyle(theme),
        borderBottomLeftRadius: withSource && isExpanded && 0,
        borderBottomRightRadius: withSource && isExpanded && 0,
        borderBottomWidth: isExpanded && 0,
        "h3 + &": {
            marginTop: "16px"
        }
    }), ({ withToolbar })=>withToolbar && {
        paddingTop: 40
    }), getSource = (withSource, expanded, setExpanded)=>{
    switch(!0){
        case !!(withSource && withSource.error):
            return {
                source: null,
                actionItem: {
                    title: "No code available",
                    className: "docblock-code-toggle docblock-code-toggle--disabled",
                    disabled: !0,
                    onClick: ()=>setExpanded(!1)
                }
            };
        case expanded:
            return {
                source: (0, _reactDefault.default).createElement(StyledSource, {
                    ...withSource,
                    dark: !0
                }),
                actionItem: {
                    title: "Hide code",
                    className: "docblock-code-toggle docblock-code-toggle--expanded",
                    onClick: ()=>setExpanded(!1)
                }
            };
        default:
            return {
                source: (0, _reactDefault.default).createElement(StyledSource, {
                    ...withSource,
                    dark: !0
                }),
                actionItem: {
                    title: "Show code",
                    className: "docblock-code-toggle",
                    onClick: ()=>setExpanded(!0)
                }
            };
    }
};
function getStoryId(children) {
    if ((0, _react.Children).count(children) === 1) {
        let elt = children;
        if (elt.props) return elt.props.id;
    }
    return null;
}
var PositionedToolbar = (0, _theming.styled)(Toolbar)({
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: 40
}), Relative = (0, _theming.styled).div({
    overflow: "hidden",
    position: "relative"
}), Preview = ({ isLoading, isColumn, columns, children, withSource, withToolbar = !1, isExpanded = !1, additionalActions, className, layout = "padded", ...props })=>{
    let [expanded, setExpanded] = (0, _react.useState)(isExpanded), { source, actionItem } = getSource(withSource, expanded, setExpanded), [scale, setScale] = (0, _react.useState)(1), previewClasses = [
        className
    ].concat([
        "sbdocs",
        "sbdocs-preview",
        "sb-unstyled"
    ]), defaultActionItems = withSource ? [
        actionItem
    ] : [], [additionalActionItems, setAdditionalActionItems] = (0, _react.useState)(additionalActions ? [
        ...additionalActions
    ] : []), actionItems = [
        ...defaultActionItems,
        ...additionalActionItems
    ], { window: globalWindow4 } = (0, _global.global), copyToClipboard = (0, _react.useCallback)(async (text)=>{
        let { createCopyToClipboardFunction } = await require("d9b4475be0045a5a");
        createCopyToClipboardFunction();
    }, []), onCopyCapture = (e)=>{
        let selection = globalWindow4.getSelection();
        selection && selection.type === "Range" || (e.preventDefault(), additionalActionItems.filter((item)=>item.title === "Copied").length === 0 && copyToClipboard(source.props.code).then(()=>{
            setAdditionalActionItems([
                ...additionalActionItems,
                {
                    title: "Copied",
                    onClick: ()=>{}
                }
            ]), globalWindow4.setTimeout(()=>setAdditionalActionItems(additionalActionItems.filter((item)=>item.title !== "Copied")), 1500);
        }));
    };
    return (0, _reactDefault.default).createElement(PreviewContainer, {
        withSource,
        withToolbar,
        ...props,
        className: previewClasses.join(" ")
    }, withToolbar && (0, _reactDefault.default).createElement(PositionedToolbar, {
        isLoading,
        border: !0,
        zoom: (z)=>setScale(scale * z),
        resetZoom: ()=>setScale(1),
        storyId: getStoryId(children),
        baseUrl: "./iframe.html"
    }), (0, _reactDefault.default).createElement(ZoomContext.Provider, {
        value: {
            scale
        }
    }, (0, _reactDefault.default).createElement(Relative, {
        className: "docs-story",
        onCopyCapture: withSource && onCopyCapture
    }, (0, _reactDefault.default).createElement(ChildrenContainer, {
        isColumn: isColumn || !Array.isArray(children),
        columns,
        layout
    }, (0, _reactDefault.default).createElement((0, _components.Zoom).Element, {
        scale
    }, Array.isArray(children) ? children.map((child, i)=>(0, _reactDefault.default).createElement("div", {
            key: i
        }, child)) : (0, _reactDefault.default).createElement("div", null, children))), (0, _reactDefault.default).createElement((0, _components.ActionBar), {
        actionItems
    }))), withSource && expanded && source);
}, StyledPreview = (0, _theming.styled)(Preview)(()=>({
        ".docs-story": {
            paddingTop: 32,
            paddingBottom: 40
        }
    })), PreviewSkeleton = ()=>(0, _reactDefault.default).createElement(StyledPreview, {
        isLoading: !0,
        withToolbar: !0
    }, (0, _reactDefault.default).createElement(StorySkeleton, null));
var Table = (0, _theming.styled).table(({ theme })=>({
        "&&": {
            borderCollapse: "collapse",
            borderSpacing: 0,
            border: "none",
            tr: {
                border: "none !important",
                background: "none"
            },
            "td, th": {
                padding: 0,
                border: "none",
                width: "auto!important"
            },
            marginTop: 0,
            marginBottom: 0,
            "th:first-of-type, td:first-of-type": {
                paddingLeft: 0
            },
            "th:last-of-type, td:last-of-type": {
                paddingRight: 0
            },
            td: {
                paddingTop: 0,
                paddingBottom: 4,
                "&:not(:first-of-type)": {
                    paddingLeft: 10,
                    paddingRight: 0
                }
            },
            tbody: {
                boxShadow: "none",
                border: "none"
            },
            code: (0, _components.codeCommon)({
                theme
            }),
            div: {
                span: {
                    fontWeight: "bold"
                }
            },
            "& code": {
                margin: 0,
                display: "inline-block",
                fontSize: theme.typography.size.s1
            }
        }
    })), ArgJsDoc = ({ tags })=>{
    let params = (tags.params || []).filter((x)=>x.description), hasDisplayableParams = params.length !== 0, hasDisplayableDeprecated = tags.deprecated != null, hasDisplayableReturns = tags.returns != null && tags.returns.description != null;
    return !hasDisplayableParams && !hasDisplayableReturns && !hasDisplayableDeprecated ? null : (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement(Table, null, (0, _reactDefault.default).createElement("tbody", null, hasDisplayableDeprecated && (0, _reactDefault.default).createElement("tr", {
        key: "deprecated"
    }, (0, _reactDefault.default).createElement("td", {
        colSpan: 2
    }, (0, _reactDefault.default).createElement("strong", null, "Deprecated"), ": ", tags.deprecated)), hasDisplayableParams && params.map((x)=>(0, _reactDefault.default).createElement("tr", {
            key: x.name
        }, (0, _reactDefault.default).createElement("td", null, (0, _reactDefault.default).createElement("code", null, x.name)), (0, _reactDefault.default).createElement("td", null, x.description))), hasDisplayableReturns && (0, _reactDefault.default).createElement("tr", {
        key: "returns"
    }, (0, _reactDefault.default).createElement("td", null, (0, _reactDefault.default).createElement("code", null, "Returns")), (0, _reactDefault.default).createElement("td", null, tags.returns.description)))));
};
var ITEMS_BEFORE_EXPANSION = 8, Summary = (0, _theming.styled).div(({ isExpanded })=>({
        display: "flex",
        flexDirection: isExpanded ? "column" : "row",
        flexWrap: "wrap",
        alignItems: "flex-start",
        marginBottom: "-4px",
        minWidth: 100
    })), Text = (0, _theming.styled).span((0, _components.codeCommon), ({ theme, simple = !1 })=>({
        flex: "0 0 auto",
        fontFamily: theme.typography.fonts.mono,
        fontSize: theme.typography.size.s1,
        wordBreak: "break-word",
        whiteSpace: "normal",
        maxWidth: "100%",
        margin: 0,
        marginRight: "4px",
        marginBottom: "4px",
        paddingTop: "2px",
        paddingBottom: "2px",
        lineHeight: "13px",
        ...simple && {
            background: "transparent",
            border: "0 none",
            paddingLeft: 0
        }
    })), ExpandButton = (0, _theming.styled).button(({ theme })=>({
        fontFamily: theme.typography.fonts.mono,
        color: theme.color.secondary,
        marginBottom: "4px",
        background: "none",
        border: "none"
    })), Expandable = (0, _theming.styled).div((0, _components.codeCommon), ({ theme })=>({
        fontFamily: theme.typography.fonts.mono,
        color: theme.color.secondary,
        fontSize: theme.typography.size.s1,
        margin: 0,
        whiteSpace: "nowrap",
        display: "flex",
        alignItems: "center"
    })), Detail = (0, _theming.styled).div(({ theme, width })=>({
        width,
        minWidth: 200,
        maxWidth: 800,
        padding: 15,
        fontFamily: theme.typography.fonts.mono,
        fontSize: theme.typography.size.s1,
        boxSizing: "content-box",
        "& code": {
            padding: "0 !important"
        }
    })), ArrowIcon = (0, _theming.styled)((0, _components.Icons))({
    height: 10,
    width: 10,
    minWidth: 10,
    marginLeft: 4
}), EmptyArg = ()=>(0, _reactDefault.default).createElement("span", null, "-"), ArgText = ({ text, simple })=>(0, _reactDefault.default).createElement(Text, {
        simple
    }, text), calculateDetailWidth = (0, _memoizerificDefault.default)(1e3)((detail)=>{
    let lines = detail.split(/\r?\n/);
    return `${Math.max(...lines.map((x)=>x.length))}ch`;
}), getSummaryItems = (summary)=>{
    if (!summary) return [
        summary
    ];
    let summaryItems = summary.split("|").map((value2)=>value2.trim());
    return (0, _uniqJsDefault.default)(summaryItems);
}, renderSummaryItems = (summaryItems, isExpanded = !0)=>{
    let items = summaryItems;
    return isExpanded || (items = summaryItems.slice(0, ITEMS_BEFORE_EXPANSION)), items.map((item)=>(0, _reactDefault.default).createElement(ArgText, {
            key: item,
            text: item === "" ? '""' : item
        }));
}, ArgSummary = ({ value: value2, initialExpandedArgs })=>{
    let { summary, detail } = value2, [isOpen, setIsOpen] = (0, _react.useState)(!1), [isExpanded, setIsExpanded] = (0, _react.useState)(initialExpandedArgs || !1);
    if (summary == null) return null;
    let summaryAsString = typeof summary.toString == "function" ? summary.toString() : summary;
    if (detail == null) {
        if (/[(){}[\]<>]/.test(summaryAsString)) return (0, _reactDefault.default).createElement(ArgText, {
            text: summaryAsString
        });
        let summaryItems = getSummaryItems(summaryAsString), itemsCount = summaryItems.length;
        return itemsCount > ITEMS_BEFORE_EXPANSION ? (0, _reactDefault.default).createElement(Summary, {
            isExpanded
        }, renderSummaryItems(summaryItems, isExpanded), (0, _reactDefault.default).createElement(ExpandButton, {
            onClick: ()=>setIsExpanded(!isExpanded)
        }, isExpanded ? "Show less..." : `Show ${itemsCount - ITEMS_BEFORE_EXPANSION} more...`)) : (0, _reactDefault.default).createElement(Summary, null, renderSummaryItems(summaryItems));
    }
    return (0, _reactDefault.default).createElement((0, _components.WithTooltipPure), {
        closeOnOutsideClick: !0,
        placement: "bottom",
        visible: isOpen,
        onVisibleChange: (isVisible)=>{
            setIsOpen(isVisible);
        },
        tooltip: (0, _reactDefault.default).createElement(Detail, {
            width: calculateDetailWidth(detail)
        }, (0, _reactDefault.default).createElement((0, _components.SyntaxHighlighter), {
            language: "jsx",
            format: !1
        }, detail))
    }, (0, _reactDefault.default).createElement(Expandable, {
        className: "sbdocs-expandable"
    }, (0, _reactDefault.default).createElement("span", null, summaryAsString), (0, _reactDefault.default).createElement(ArrowIcon, {
        icon: isOpen ? "arrowup" : "arrowdown"
    })));
}, ArgValue = ({ value: value2, initialExpandedArgs })=>value2 == null ? (0, _reactDefault.default).createElement(EmptyArg, null) : (0, _reactDefault.default).createElement(ArgSummary, {
        value: value2,
        initialExpandedArgs
    });
var Label = (0, _theming.styled).label(({ theme })=>({
        lineHeight: "18px",
        alignItems: "center",
        marginBottom: 8,
        display: "inline-block",
        position: "relative",
        whiteSpace: "nowrap",
        background: theme.boolean.background,
        borderRadius: "3em",
        padding: 1,
        input: {
            appearance: "none",
            width: "100%",
            height: "100%",
            position: "absolute",
            left: 0,
            top: 0,
            margin: 0,
            padding: 0,
            border: "none",
            background: "transparent",
            cursor: "pointer",
            borderRadius: "3em",
            "&:focus": {
                outline: "none",
                boxShadow: `${theme.color.secondary} 0 0 0 1px inset !important`
            }
        },
        span: {
            textAlign: "center",
            fontSize: theme.typography.size.s1,
            fontWeight: theme.typography.weight.bold,
            lineHeight: "1",
            cursor: "pointer",
            display: "inline-block",
            padding: "7px 15px",
            transition: "all 100ms ease-out",
            userSelect: "none",
            borderRadius: "3em",
            color: (0, _polished.transparentize)(.5, theme.color.defaultText),
            background: "transparent",
            "&:hover": {
                boxShadow: `${(0, _polished.opacify)(.3, theme.appBorderColor)} 0 0 0 1px inset`
            },
            "&:active": {
                boxShadow: `${(0, _polished.opacify)(.05, theme.appBorderColor)} 0 0 0 2px inset`,
                color: (0, _polished.opacify)(1, theme.appBorderColor)
            },
            "&:first-of-type": {
                paddingRight: 8
            },
            "&:last-of-type": {
                paddingLeft: 8
            }
        },
        "input:checked ~ span:last-of-type, input:not(:checked) ~ span:first-of-type": {
            background: theme.boolean.selectedBackground,
            boxShadow: theme.base === "light" ? `${(0, _polished.opacify)(.1, theme.appBorderColor)} 0 0 2px` : `${theme.appBorderColor} 0 0 0 1px`,
            color: theme.color.defaultText,
            padding: "7px 15px"
        }
    })), parse = (value2)=>value2 === "true", BooleanControl = ({ name, value: value2, onChange, onBlur, onFocus })=>{
    let onSetFalse = (0, _react.useCallback)(()=>onChange(!1), [
        onChange
    ]);
    if (value2 === void 0) return (0, _reactDefault.default).createElement((0, _components.Form).Button, {
        id: (0, _chunkGWAJ4KRUMjs.getControlSetterButtonId)(name),
        onClick: onSetFalse
    }, "Set boolean");
    let controlId = (0, _chunkGWAJ4KRUMjs.getControlId)(name), parsedValue = typeof value2 == "string" ? parse(value2) : value2;
    return (0, _reactDefault.default).createElement(Label, {
        htmlFor: controlId,
        "aria-label": name
    }, (0, _reactDefault.default).createElement("input", {
        id: controlId,
        type: "checkbox",
        onChange: (e)=>onChange(e.target.checked),
        checked: parsedValue,
        role: "switch",
        name,
        onBlur,
        onFocus
    }), (0, _reactDefault.default).createElement("span", {
        "aria-hidden": "true"
    }, "False"), (0, _reactDefault.default).createElement("span", {
        "aria-hidden": "true"
    }, "True"));
};
var parseDate = (value2)=>{
    let [year, month, day] = value2.split("-"), result = new Date;
    return result.setFullYear(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10)), result;
}, parseTime = (value2)=>{
    let [hours, minutes] = value2.split(":"), result = new Date;
    return result.setHours(parseInt(hours, 10)), result.setMinutes(parseInt(minutes, 10)), result;
}, formatDate = (value2)=>{
    let date = new Date(value2), year = `000${date.getFullYear()}`.slice(-4), month = `0${date.getMonth() + 1}`.slice(-2), day = `0${date.getDate()}`.slice(-2);
    return `${year}-${month}-${day}`;
}, formatTime = (value2)=>{
    let date = new Date(value2), hours = `0${date.getHours()}`.slice(-2), minutes = `0${date.getMinutes()}`.slice(-2);
    return `${hours}:${minutes}`;
}, FlexSpaced = (0, _theming.styled).div(({ theme })=>({
        flex: 1,
        display: "flex",
        input: {
            marginLeft: 10,
            flex: 1,
            height: 32,
            "&::-webkit-calendar-picker-indicator": {
                opacity: .5,
                height: 12,
                filter: theme.base === "light" ? void 0 : "invert(1)"
            }
        },
        "input:first-of-type": {
            marginLeft: 0,
            flexGrow: 4
        },
        "input:last-of-type": {
            flexGrow: 3
        }
    })), DateControl = ({ name, value: value2, onChange, onFocus, onBlur })=>{
    let [valid, setValid] = (0, _react.useState)(!0), dateRef = (0, _react.useRef)(), timeRef = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        valid !== !1 && (dateRef && dateRef.current && (dateRef.current.value = formatDate(value2)), timeRef && timeRef.current && (timeRef.current.value = formatTime(value2)));
    }, [
        value2
    ]);
    let onDateChange = (e)=>{
        let parsed = parseDate(e.target.value), result = new Date(value2);
        result.setFullYear(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
        let time = result.getTime();
        time && onChange(time), setValid(!!time);
    }, onTimeChange = (e)=>{
        let parsed = parseTime(e.target.value), result = new Date(value2);
        result.setHours(parsed.getHours()), result.setMinutes(parsed.getMinutes());
        let time = result.getTime();
        time && onChange(time), setValid(!!time);
    }, controlId = (0, _chunkGWAJ4KRUMjs.getControlId)(name);
    return (0, _reactDefault.default).createElement(FlexSpaced, null, (0, _reactDefault.default).createElement((0, _components.Form).Input, {
        type: "date",
        max: "9999-12-31",
        ref: dateRef,
        id: `${controlId}-date`,
        name: `${controlId}-date`,
        onChange: onDateChange,
        onFocus,
        onBlur
    }), (0, _reactDefault.default).createElement((0, _components.Form).Input, {
        type: "time",
        id: `${controlId}-time`,
        name: `${controlId}-time`,
        ref: timeRef,
        onChange: onTimeChange,
        onFocus,
        onBlur
    }), valid ? null : (0, _reactDefault.default).createElement("div", null, "invalid"));
};
var Wrapper2 = (0, _theming.styled).label({
    display: "flex"
}), parse2 = (value2)=>{
    let result = parseFloat(value2);
    return Number.isNaN(result) ? void 0 : result;
}, format = (value2)=>value2 != null ? String(value2) : "", NumberControl = ({ name, value: value2, onChange, min, max, step, onBlur, onFocus })=>{
    let [inputValue, setInputValue] = (0, _react.useState)(typeof value2 == "number" ? value2 : ""), [forceVisible, setForceVisible] = (0, _react.useState)(!1), [parseError, setParseError] = (0, _react.useState)(null), handleChange = (0, _react.useCallback)((event)=>{
        setInputValue(event.target.value);
        let result = parseFloat(event.target.value);
        Number.isNaN(result) ? setParseError(new Error(`'${event.target.value}' is not a number`)) : (onChange(result), setParseError(null));
    }, [
        onChange,
        setParseError
    ]), onForceVisible = (0, _react.useCallback)(()=>{
        setInputValue("0"), onChange(0), setForceVisible(!0);
    }, [
        setForceVisible
    ]), htmlElRef = (0, _react.useRef)(null);
    return (0, _react.useEffect)(()=>{
        forceVisible && htmlElRef.current && htmlElRef.current.select();
    }, [
        forceVisible
    ]), (0, _react.useEffect)(()=>{
        inputValue !== (typeof value2 == "number" ? value2 : "") && setInputValue(value2);
    }, [
        value2
    ]), !forceVisible && value2 === void 0 ? (0, _reactDefault.default).createElement((0, _components.Form).Button, {
        id: (0, _chunkGWAJ4KRUMjs.getControlSetterButtonId)(name),
        onClick: onForceVisible
    }, "Set number") : (0, _reactDefault.default).createElement(Wrapper2, null, (0, _reactDefault.default).createElement((0, _components.Form).Input, {
        ref: htmlElRef,
        id: (0, _chunkGWAJ4KRUMjs.getControlId)(name),
        type: "number",
        onChange: handleChange,
        size: "flex",
        placeholder: "Edit number...",
        value: inputValue,
        valid: parseError ? "error" : null,
        autoFocus: forceVisible,
        name,
        min,
        max,
        step,
        onFocus,
        onBlur
    }));
};
var selectedKey = (value2, options)=>{
    let entry = options && Object.entries(options).find(([_key, val])=>val === value2);
    return entry ? entry[0] : void 0;
}, selectedKeys = (value2, options)=>value2 && options ? Object.entries(options).filter((entry)=>value2.includes(entry[1])).map((entry)=>entry[0]) : [], selectedValues = (keys, options)=>keys && options && keys.map((key)=>options[key]);
var Wrapper3 = (0, _theming.styled).div(({ isInline })=>isInline ? {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        label: {
            display: "inline-flex",
            marginRight: 15
        }
    } : {
        label: {
            display: "flex"
        }
    }), Text2 = (0, _theming.styled).span({}), Label2 = (0, _theming.styled).label({
    lineHeight: "20px",
    alignItems: "center",
    marginBottom: 8,
    "&:last-child": {
        marginBottom: 0
    },
    input: {
        margin: 0,
        marginRight: 6
    }
}), CheckboxControl = ({ name, options, value: value2, onChange, isInline })=>{
    if (!options) return (0, _clientLogger.logger).warn(`Checkbox with no options: ${name}`), (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, "-");
    let initial = selectedKeys(value2, options), [selected, setSelected] = (0, _react.useState)(initial), handleChange = (e)=>{
        let option = e.target.value, updated = [
            ...selected
        ];
        updated.includes(option) ? updated.splice(updated.indexOf(option), 1) : updated.push(option), onChange(selectedValues(updated, options)), setSelected(updated);
    };
    (0, _react.useEffect)(()=>{
        setSelected(selectedKeys(value2, options));
    }, [
        value2
    ]);
    let controlId = (0, _chunkGWAJ4KRUMjs.getControlId)(name);
    return (0, _reactDefault.default).createElement(Wrapper3, {
        isInline
    }, Object.keys(options).map((key, index)=>{
        let id = `${controlId}-${index}`;
        return (0, _reactDefault.default).createElement(Label2, {
            key: id,
            htmlFor: id
        }, (0, _reactDefault.default).createElement("input", {
            type: "checkbox",
            id,
            name: id,
            value: key,
            onChange: handleChange,
            checked: selected?.includes(key)
        }), (0, _reactDefault.default).createElement(Text2, null, key));
    }));
};
var Wrapper4 = (0, _theming.styled).div(({ isInline })=>isInline ? {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        label: {
            display: "inline-flex",
            marginRight: 15
        }
    } : {
        label: {
            display: "flex"
        }
    }), Text3 = (0, _theming.styled).span({}), Label3 = (0, _theming.styled).label({
    lineHeight: "20px",
    alignItems: "center",
    marginBottom: 8,
    "&:last-child": {
        marginBottom: 0
    },
    input: {
        margin: 0,
        marginRight: 6
    }
}), RadioControl = ({ name, options, value: value2, onChange, isInline })=>{
    if (!options) return (0, _clientLogger.logger).warn(`Radio with no options: ${name}`), (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, "-");
    let selection = selectedKey(value2, options), controlId = (0, _chunkGWAJ4KRUMjs.getControlId)(name);
    return (0, _reactDefault.default).createElement(Wrapper4, {
        isInline
    }, Object.keys(options).map((key, index)=>{
        let id = `${controlId}-${index}`;
        return (0, _reactDefault.default).createElement(Label3, {
            key: id,
            htmlFor: id
        }, (0, _reactDefault.default).createElement("input", {
            type: "radio",
            id,
            name: id,
            value: key,
            onChange: (e)=>onChange(options[e.currentTarget.value]),
            checked: key === selection
        }), (0, _reactDefault.default).createElement(Text3, null, key));
    }));
};
var styleResets = {
    appearance: "none",
    border: "0 none",
    boxSizing: "inherit",
    display: " block",
    margin: " 0",
    background: "transparent",
    padding: 0,
    fontSize: "inherit",
    position: "relative"
}, OptionsSelect = (0, _theming.styled).select(styleResets, ({ theme })=>({
        boxSizing: "border-box",
        position: "relative",
        padding: "6px 10px",
        width: "100%",
        color: theme.input.color || "inherit",
        background: theme.input.background,
        borderRadius: theme.input.borderRadius,
        boxShadow: `${theme.input.border} 0 0 0 1px inset`,
        fontSize: theme.typography.size.s2 - 1,
        lineHeight: "20px",
        "&:focus": {
            boxShadow: `${theme.color.secondary} 0 0 0 1px inset`,
            outline: "none"
        },
        "&[disabled]": {
            cursor: "not-allowed",
            opacity: .5
        },
        "::placeholder": {
            color: theme.textMutedColor
        },
        "&[multiple]": {
            overflow: "auto",
            padding: 0,
            option: {
                display: "block",
                padding: "6px 10px",
                marginLeft: 1,
                marginRight: 1
            }
        }
    })), SelectWrapper = (0, _theming.styled).span(({ theme })=>({
        display: "inline-block",
        lineHeight: "normal",
        overflow: "hidden",
        position: "relative",
        verticalAlign: "top",
        width: "100%",
        svg: {
            position: "absolute",
            zIndex: 1,
            pointerEvents: "none",
            height: "12px",
            marginTop: "-6px",
            right: "12px",
            top: "50%",
            fill: theme.textMutedColor,
            path: {
                fill: theme.textMutedColor
            }
        }
    })), NO_SELECTION = "Choose option...", SingleSelect = ({ name, value: value2, options, onChange })=>{
    let handleChange = (e)=>{
        onChange(options[e.currentTarget.value]);
    }, selection = selectedKey(value2, options) || NO_SELECTION, controlId = (0, _chunkGWAJ4KRUMjs.getControlId)(name);
    return (0, _reactDefault.default).createElement(SelectWrapper, null, (0, _reactDefault.default).createElement((0, _components.Icons), {
        icon: "arrowdown"
    }), (0, _reactDefault.default).createElement(OptionsSelect, {
        id: controlId,
        value: selection,
        onChange: handleChange
    }, (0, _reactDefault.default).createElement("option", {
        key: "no-selection",
        disabled: !0
    }, NO_SELECTION), Object.keys(options).map((key)=>(0, _reactDefault.default).createElement("option", {
            key,
            value: key
        }, key))));
}, MultiSelect = ({ name, value: value2, options, onChange })=>{
    let handleChange = (e)=>{
        let selection2 = Array.from(e.currentTarget.options).filter((option)=>option.selected).map((option)=>option.value);
        onChange(selectedValues(selection2, options));
    }, selection = selectedKeys(value2, options), controlId = (0, _chunkGWAJ4KRUMjs.getControlId)(name);
    return (0, _reactDefault.default).createElement(SelectWrapper, null, (0, _reactDefault.default).createElement(OptionsSelect, {
        id: controlId,
        multiple: !0,
        value: selection,
        onChange: handleChange
    }, Object.keys(options).map((key)=>(0, _reactDefault.default).createElement("option", {
            key,
            value: key
        }, key))));
}, SelectControl = (props)=>{
    let { name, options } = props;
    return options ? props.isMulti ? (0, _reactDefault.default).createElement(MultiSelect, {
        ...props
    }) : (0, _reactDefault.default).createElement(SingleSelect, {
        ...props
    }) : ((0, _clientLogger.logger).warn(`Select with no options: ${name}`), (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, "-"));
};
var normalizeOptions = (options, labels)=>Array.isArray(options) ? options.reduce((acc, item)=>(acc[labels?.[item] || String(item)] = item, acc), {}) : options, Controls = {
    check: CheckboxControl,
    "inline-check": CheckboxControl,
    radio: RadioControl,
    "inline-radio": RadioControl,
    select: SelectControl,
    "multi-select": SelectControl
}, OptionsControl = (props)=>{
    let { type = "select", labels, argType } = props, normalized = {
        ...props,
        options: argType ? normalizeOptions(argType.options, labels) : {},
        isInline: type.includes("inline"),
        isMulti: type.includes("multi")
    }, Control = Controls[type];
    if (Control) return (0, _reactDefault.default).createElement(Control, {
        ...normalized
    });
    throw new Error(`Unknown options type: ${type}`);
};
var VALUE = "value", KEY = "key";
var ERROR = "Error", OBJECT = "Object", ARRAY = "Array", STRING = "String", NUMBER = "Number", BOOLEAN = "Boolean", DATE = "Date", NULL = "Null", UNDEFINED = "Undefined", FUNCTION = "Function", SYMBOL = "Symbol";
var ADD_DELTA_TYPE = "ADD_DELTA_TYPE", REMOVE_DELTA_TYPE = "REMOVE_DELTA_TYPE", UPDATE_DELTA_TYPE = "UPDATE_DELTA_TYPE";
function getObjectType(obj) {
    return obj !== null && typeof obj == "object" && !Array.isArray(obj) && typeof obj[Symbol.iterator] == "function" ? "Iterable" : Object.prototype.toString.call(obj).slice(8, -1);
}
function isComponentWillChange(oldValue, newValue) {
    let oldType = getObjectType(oldValue), newType = getObjectType(newValue);
    return (oldType === "Function" || newType === "Function") && newType !== oldType;
}
var JsonAddValue = class extends (0, _react.Component) {
    constructor(props){
        super(props), this.state = {
            inputRefKey: null,
            inputRefValue: null
        }, this.refInputValue = this.refInputValue.bind(this), this.refInputKey = this.refInputKey.bind(this), this.onKeydown = this.onKeydown.bind(this), this.onSubmit = this.onSubmit.bind(this);
    }
    componentDidMount() {
        let { inputRefKey, inputRefValue } = this.state, { onlyValue } = this.props;
        inputRefKey && typeof inputRefKey.focus == "function" && inputRefKey.focus(), onlyValue && inputRefValue && typeof inputRefValue.focus == "function" && inputRefValue.focus(), document.addEventListener("keydown", this.onKeydown);
    }
    componentWillUnmount() {
        document.removeEventListener("keydown", this.onKeydown);
    }
    onKeydown(event) {
        event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.repeat || ((event.code === "Enter" || event.key === "Enter") && (event.preventDefault(), this.onSubmit()), (event.code === "Escape" || event.key === "Escape") && (event.preventDefault(), this.props.handleCancel()));
    }
    onSubmit() {
        let { handleAdd, onlyValue, onSubmitValueParser, keyPath, deep } = this.props, { inputRefKey, inputRefValue } = this.state, result = {};
        if (!onlyValue) {
            if (!inputRefKey.value) return;
            result.key = inputRefKey.value;
        }
        result.newValue = onSubmitValueParser(!1, keyPath, deep, result.key, inputRefValue.value), handleAdd(result);
    }
    refInputKey(node) {
        this.state.inputRefKey = node;
    }
    refInputValue(node) {
        this.state.inputRefValue = node;
    }
    render() {
        let { handleCancel, onlyValue, addButtonElement, cancelButtonElement, inputElementGenerator, keyPath, deep } = this.props, addButtonElementLayout = (0, _react.cloneElement)(addButtonElement, {
            onClick: this.onSubmit
        }), cancelButtonElementLayout = (0, _react.cloneElement)(cancelButtonElement, {
            onClick: handleCancel
        }), inputElementValue = inputElementGenerator(VALUE, keyPath, deep), inputElementValueLayout = (0, _react.cloneElement)(inputElementValue, {
            placeholder: "Value",
            ref: this.refInputValue
        }), inputElementKeyLayout = null;
        if (!onlyValue) {
            let inputElementKey = inputElementGenerator(KEY, keyPath, deep);
            inputElementKeyLayout = (0, _react.cloneElement)(inputElementKey, {
                placeholder: "Key",
                ref: this.refInputKey
            });
        }
        return (0, _reactDefault.default).createElement("span", {
            className: "rejt-add-value-node"
        }, inputElementKeyLayout, inputElementValueLayout, cancelButtonElementLayout, addButtonElementLayout);
    }
};
JsonAddValue.defaultProps = {
    onlyValue: !1,
    addButtonElement: (0, _reactDefault.default).createElement("button", null, "+"),
    cancelButtonElement: (0, _reactDefault.default).createElement("button", null, "c")
};
var JsonArray = class extends (0, _react.Component) {
    constructor(props){
        super(props);
        let keyPath = [
            ...props.keyPath,
            props.name
        ];
        this.state = {
            data: props.data,
            name: props.name,
            keyPath,
            deep: props.deep,
            nextDeep: props.deep + 1,
            collapsed: props.isCollapsed(keyPath, props.deep, props.data),
            addFormVisible: !1
        }, this.handleCollapseMode = this.handleCollapseMode.bind(this), this.handleRemoveItem = this.handleRemoveItem.bind(this), this.handleAddMode = this.handleAddMode.bind(this), this.handleAddValueAdd = this.handleAddValueAdd.bind(this), this.handleAddValueCancel = this.handleAddValueCancel.bind(this), this.handleEditValue = this.handleEditValue.bind(this), this.onChildUpdate = this.onChildUpdate.bind(this), this.renderCollapsed = this.renderCollapsed.bind(this), this.renderNotCollapsed = this.renderNotCollapsed.bind(this);
    }
    static getDerivedStateFromProps(props, state) {
        return props.data !== state.data ? {
            data: props.data
        } : null;
    }
    onChildUpdate(childKey, childData) {
        let { data, keyPath } = this.state;
        data[childKey] = childData, this.setState({
            data
        });
        let { onUpdate } = this.props, size = keyPath.length;
        onUpdate(keyPath[size - 1], data);
    }
    handleAddMode() {
        this.setState({
            addFormVisible: !0
        });
    }
    handleCollapseMode() {
        this.setState((state)=>({
                collapsed: !state.collapsed
            }));
    }
    handleRemoveItem(index) {
        return ()=>{
            let { beforeRemoveAction, logger: logger4 } = this.props, { data, keyPath, nextDeep: deep } = this.state, oldValue = data[index];
            beforeRemoveAction(index, keyPath, deep, oldValue).then(()=>{
                let deltaUpdateResult = {
                    keyPath,
                    deep,
                    key: index,
                    oldValue,
                    type: REMOVE_DELTA_TYPE
                };
                data.splice(index, 1), this.setState({
                    data
                });
                let { onUpdate, onDeltaUpdate } = this.props;
                onUpdate(keyPath[keyPath.length - 1], data), onDeltaUpdate(deltaUpdateResult);
            }).catch(logger4.error);
        };
    }
    handleAddValueAdd({ newValue }) {
        let { data, keyPath, nextDeep: deep } = this.state, { beforeAddAction, logger: logger4 } = this.props;
        beforeAddAction(data.length, keyPath, deep, newValue).then(()=>{
            let newData = [
                ...data,
                newValue
            ];
            this.setState({
                data: newData
            }), this.handleAddValueCancel();
            let { onUpdate, onDeltaUpdate } = this.props;
            onUpdate(keyPath[keyPath.length - 1], newData), onDeltaUpdate({
                type: ADD_DELTA_TYPE,
                keyPath,
                deep,
                key: newData.length - 1,
                newValue
            });
        }).catch(logger4.error);
    }
    handleAddValueCancel() {
        this.setState({
            addFormVisible: !1
        });
    }
    handleEditValue({ key, value: value2 }) {
        return new Promise((resolve, reject)=>{
            let { beforeUpdateAction } = this.props, { data, keyPath, nextDeep: deep } = this.state, oldValue = data[key];
            beforeUpdateAction(key, keyPath, deep, oldValue, value2).then(()=>{
                data[key] = value2, this.setState({
                    data
                });
                let { onUpdate, onDeltaUpdate } = this.props;
                onUpdate(keyPath[keyPath.length - 1], data), onDeltaUpdate({
                    type: UPDATE_DELTA_TYPE,
                    keyPath,
                    deep,
                    key,
                    newValue: value2,
                    oldValue
                }), resolve(void 0);
            }).catch(reject);
        });
    }
    renderCollapsed() {
        let { name, data, keyPath, deep } = this.state, { handleRemove, readOnly, getStyle, dataType, minusMenuElement } = this.props, { minus, collapsed } = getStyle(name, data, keyPath, deep, dataType), isReadOnly = readOnly(name, data, keyPath, deep, dataType), removeItemButton = (0, _react.cloneElement)(minusMenuElement, {
            onClick: handleRemove,
            className: "rejt-minus-menu",
            style: minus
        });
        return (0, _reactDefault.default).createElement("span", {
            className: "rejt-collapsed"
        }, (0, _reactDefault.default).createElement("span", {
            className: "rejt-collapsed-text",
            style: collapsed,
            onClick: this.handleCollapseMode
        }, "[...] ", data.length, " ", data.length === 1 ? "item" : "items"), !isReadOnly && removeItemButton);
    }
    renderNotCollapsed() {
        let { name, data, keyPath, deep, addFormVisible, nextDeep } = this.state, { isCollapsed, handleRemove, onDeltaUpdate, readOnly, getStyle, dataType, addButtonElement, cancelButtonElement, editButtonElement, inputElementGenerator, textareaElementGenerator, minusMenuElement, plusMenuElement, beforeRemoveAction, beforeAddAction, beforeUpdateAction, logger: logger4, onSubmitValueParser } = this.props, { minus, plus, delimiter, ul, addForm } = getStyle(name, data, keyPath, deep, dataType), isReadOnly = readOnly(name, data, keyPath, deep, dataType), addItemButton = (0, _react.cloneElement)(plusMenuElement, {
            onClick: this.handleAddMode,
            className: "rejt-plus-menu",
            style: plus
        }), removeItemButton = (0, _react.cloneElement)(minusMenuElement, {
            onClick: handleRemove,
            className: "rejt-minus-menu",
            style: minus
        }), onlyValue = !0, startObject = "[", endObject = "]";
        return (0, _reactDefault.default).createElement("span", {
            className: "rejt-not-collapsed"
        }, (0, _reactDefault.default).createElement("span", {
            className: "rejt-not-collapsed-delimiter",
            style: delimiter
        }, startObject), !addFormVisible && addItemButton, (0, _reactDefault.default).createElement("ul", {
            className: "rejt-not-collapsed-list",
            style: ul
        }, data.map((item, index)=>(0, _reactDefault.default).createElement(JsonNode, {
                key: index,
                name: index.toString(),
                data: item,
                keyPath,
                deep: nextDeep,
                isCollapsed,
                handleRemove: this.handleRemoveItem(index),
                handleUpdateValue: this.handleEditValue,
                onUpdate: this.onChildUpdate,
                onDeltaUpdate,
                readOnly,
                getStyle,
                addButtonElement,
                cancelButtonElement,
                editButtonElement,
                inputElementGenerator,
                textareaElementGenerator,
                minusMenuElement,
                plusMenuElement,
                beforeRemoveAction,
                beforeAddAction,
                beforeUpdateAction,
                logger: logger4,
                onSubmitValueParser
            }))), !isReadOnly && addFormVisible && (0, _reactDefault.default).createElement("div", {
            className: "rejt-add-form",
            style: addForm
        }, (0, _reactDefault.default).createElement(JsonAddValue, {
            handleAdd: this.handleAddValueAdd,
            handleCancel: this.handleAddValueCancel,
            onlyValue,
            addButtonElement,
            cancelButtonElement,
            inputElementGenerator,
            keyPath,
            deep,
            onSubmitValueParser
        })), (0, _reactDefault.default).createElement("span", {
            className: "rejt-not-collapsed-delimiter",
            style: delimiter
        }, endObject), !isReadOnly && removeItemButton);
    }
    render() {
        let { name, collapsed, data, keyPath, deep } = this.state, { dataType, getStyle } = this.props, value2 = collapsed ? this.renderCollapsed() : this.renderNotCollapsed(), style = getStyle(name, data, keyPath, deep, dataType);
        return (0, _reactDefault.default).createElement("div", {
            className: "rejt-array-node"
        }, (0, _reactDefault.default).createElement("span", {
            onClick: this.handleCollapseMode
        }, (0, _reactDefault.default).createElement("span", {
            className: "rejt-name",
            style: style.name
        }, name, " :", " ")), value2);
    }
};
JsonArray.defaultProps = {
    keyPath: [],
    deep: 0,
    minusMenuElement: (0, _reactDefault.default).createElement("span", null, " - "),
    plusMenuElement: (0, _reactDefault.default).createElement("span", null, " + ")
};
var JsonFunctionValue = class extends (0, _react.Component) {
    constructor(props){
        super(props);
        let keyPath = [
            ...props.keyPath,
            props.name
        ];
        this.state = {
            value: props.value,
            name: props.name,
            keyPath,
            deep: props.deep,
            editEnabled: !1,
            inputRef: null
        }, this.handleEditMode = this.handleEditMode.bind(this), this.refInput = this.refInput.bind(this), this.handleCancelEdit = this.handleCancelEdit.bind(this), this.handleEdit = this.handleEdit.bind(this), this.onKeydown = this.onKeydown.bind(this);
    }
    static getDerivedStateFromProps(props, state) {
        return props.value !== state.value ? {
            value: props.value
        } : null;
    }
    componentDidUpdate() {
        let { editEnabled, inputRef, name, value: value2, keyPath, deep } = this.state, { readOnly, dataType } = this.props, readOnlyResult = readOnly(name, value2, keyPath, deep, dataType);
        editEnabled && !readOnlyResult && typeof inputRef.focus == "function" && inputRef.focus();
    }
    componentDidMount() {
        document.addEventListener("keydown", this.onKeydown);
    }
    componentWillUnmount() {
        document.removeEventListener("keydown", this.onKeydown);
    }
    onKeydown(event) {
        event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.repeat || ((event.code === "Enter" || event.key === "Enter") && (event.preventDefault(), this.handleEdit()), (event.code === "Escape" || event.key === "Escape") && (event.preventDefault(), this.handleCancelEdit()));
    }
    handleEdit() {
        let { handleUpdateValue, originalValue, logger: logger4, onSubmitValueParser, keyPath } = this.props, { inputRef, name, deep } = this.state;
        if (!inputRef) return;
        let newValue = onSubmitValueParser(!0, keyPath, deep, name, inputRef.value);
        handleUpdateValue({
            value: newValue,
            key: name
        }).then(()=>{
            isComponentWillChange(originalValue, newValue) || this.handleCancelEdit();
        }).catch(logger4.error);
    }
    handleEditMode() {
        this.setState({
            editEnabled: !0
        });
    }
    refInput(node) {
        this.state.inputRef = node;
    }
    handleCancelEdit() {
        this.setState({
            editEnabled: !1
        });
    }
    render() {
        let { name, value: value2, editEnabled, keyPath, deep } = this.state, { handleRemove, originalValue, readOnly, dataType, getStyle, editButtonElement, cancelButtonElement, textareaElementGenerator, minusMenuElement, keyPath: comeFromKeyPath } = this.props, style = getStyle(name, originalValue, keyPath, deep, dataType), result = null, minusElement = null, resultOnlyResult = readOnly(name, originalValue, keyPath, deep, dataType);
        if (editEnabled && !resultOnlyResult) {
            let textareaElement = textareaElementGenerator(VALUE, comeFromKeyPath, deep, name, originalValue, dataType), editButtonElementLayout = (0, _react.cloneElement)(editButtonElement, {
                onClick: this.handleEdit
            }), cancelButtonElementLayout = (0, _react.cloneElement)(cancelButtonElement, {
                onClick: this.handleCancelEdit
            }), textareaElementLayout = (0, _react.cloneElement)(textareaElement, {
                ref: this.refInput,
                defaultValue: originalValue
            });
            result = (0, _reactDefault.default).createElement("span", {
                className: "rejt-edit-form",
                style: style.editForm
            }, textareaElementLayout, " ", cancelButtonElementLayout, editButtonElementLayout), minusElement = null;
        } else {
            result = (0, _reactDefault.default).createElement("span", {
                className: "rejt-value",
                style: style.value,
                onClick: resultOnlyResult ? null : this.handleEditMode
            }, value2);
            let minusMenuLayout = (0, _react.cloneElement)(minusMenuElement, {
                onClick: handleRemove,
                className: "rejt-minus-menu",
                style: style.minus
            });
            minusElement = resultOnlyResult ? null : minusMenuLayout;
        }
        return (0, _reactDefault.default).createElement("li", {
            className: "rejt-function-value-node",
            style: style.li
        }, (0, _reactDefault.default).createElement("span", {
            className: "rejt-name",
            style: style.name
        }, name, " :", " "), result, minusElement);
    }
};
JsonFunctionValue.defaultProps = {
    keyPath: [],
    deep: 0,
    handleUpdateValue: ()=>{},
    editButtonElement: (0, _reactDefault.default).createElement("button", null, "e"),
    cancelButtonElement: (0, _reactDefault.default).createElement("button", null, "c"),
    minusMenuElement: (0, _reactDefault.default).createElement("span", null, " - ")
};
var JsonNode = class extends (0, _react.Component) {
    constructor(props){
        super(props), this.state = {
            data: props.data,
            name: props.name,
            keyPath: props.keyPath,
            deep: props.deep
        };
    }
    static getDerivedStateFromProps(props, state) {
        return props.data !== state.data ? {
            data: props.data
        } : null;
    }
    render() {
        let { data, name, keyPath, deep } = this.state, { isCollapsed, handleRemove, handleUpdateValue, onUpdate, onDeltaUpdate, readOnly, getStyle, addButtonElement, cancelButtonElement, editButtonElement, inputElementGenerator, textareaElementGenerator, minusMenuElement, plusMenuElement, beforeRemoveAction, beforeAddAction, beforeUpdateAction, logger: logger4, onSubmitValueParser } = this.props, readOnlyTrue = ()=>!0, dataType = getObjectType(data);
        switch(dataType){
            case ERROR:
                return (0, _reactDefault.default).createElement(JsonObject, {
                    data,
                    name,
                    isCollapsed,
                    keyPath,
                    deep,
                    handleRemove,
                    onUpdate,
                    onDeltaUpdate,
                    readOnly: readOnlyTrue,
                    dataType,
                    getStyle,
                    addButtonElement,
                    cancelButtonElement,
                    editButtonElement,
                    inputElementGenerator,
                    textareaElementGenerator,
                    minusMenuElement,
                    plusMenuElement,
                    beforeRemoveAction,
                    beforeAddAction,
                    beforeUpdateAction,
                    logger: logger4,
                    onSubmitValueParser
                });
            case OBJECT:
                return (0, _reactDefault.default).createElement(JsonObject, {
                    data,
                    name,
                    isCollapsed,
                    keyPath,
                    deep,
                    handleRemove,
                    onUpdate,
                    onDeltaUpdate,
                    readOnly,
                    dataType,
                    getStyle,
                    addButtonElement,
                    cancelButtonElement,
                    editButtonElement,
                    inputElementGenerator,
                    textareaElementGenerator,
                    minusMenuElement,
                    plusMenuElement,
                    beforeRemoveAction,
                    beforeAddAction,
                    beforeUpdateAction,
                    logger: logger4,
                    onSubmitValueParser
                });
            case ARRAY:
                return (0, _reactDefault.default).createElement(JsonArray, {
                    data,
                    name,
                    isCollapsed,
                    keyPath,
                    deep,
                    handleRemove,
                    onUpdate,
                    onDeltaUpdate,
                    readOnly,
                    dataType,
                    getStyle,
                    addButtonElement,
                    cancelButtonElement,
                    editButtonElement,
                    inputElementGenerator,
                    textareaElementGenerator,
                    minusMenuElement,
                    plusMenuElement,
                    beforeRemoveAction,
                    beforeAddAction,
                    beforeUpdateAction,
                    logger: logger4,
                    onSubmitValueParser
                });
            case STRING:
                return (0, _reactDefault.default).createElement(JsonValue, {
                    name,
                    value: `"${data}"`,
                    originalValue: data,
                    keyPath,
                    deep,
                    handleRemove,
                    handleUpdateValue,
                    readOnly,
                    dataType,
                    getStyle,
                    cancelButtonElement,
                    editButtonElement,
                    inputElementGenerator,
                    minusMenuElement,
                    logger: logger4,
                    onSubmitValueParser
                });
            case NUMBER:
                return (0, _reactDefault.default).createElement(JsonValue, {
                    name,
                    value: data,
                    originalValue: data,
                    keyPath,
                    deep,
                    handleRemove,
                    handleUpdateValue,
                    readOnly,
                    dataType,
                    getStyle,
                    cancelButtonElement,
                    editButtonElement,
                    inputElementGenerator,
                    minusMenuElement,
                    logger: logger4,
                    onSubmitValueParser
                });
            case BOOLEAN:
                return (0, _reactDefault.default).createElement(JsonValue, {
                    name,
                    value: data ? "true" : "false",
                    originalValue: data,
                    keyPath,
                    deep,
                    handleRemove,
                    handleUpdateValue,
                    readOnly,
                    dataType,
                    getStyle,
                    cancelButtonElement,
                    editButtonElement,
                    inputElementGenerator,
                    minusMenuElement,
                    logger: logger4,
                    onSubmitValueParser
                });
            case DATE:
                return (0, _reactDefault.default).createElement(JsonValue, {
                    name,
                    value: data.toISOString(),
                    originalValue: data,
                    keyPath,
                    deep,
                    handleRemove,
                    handleUpdateValue,
                    readOnly: readOnlyTrue,
                    dataType,
                    getStyle,
                    cancelButtonElement,
                    editButtonElement,
                    inputElementGenerator,
                    minusMenuElement,
                    logger: logger4,
                    onSubmitValueParser
                });
            case NULL:
                return (0, _reactDefault.default).createElement(JsonValue, {
                    name,
                    value: "null",
                    originalValue: "null",
                    keyPath,
                    deep,
                    handleRemove,
                    handleUpdateValue,
                    readOnly,
                    dataType,
                    getStyle,
                    cancelButtonElement,
                    editButtonElement,
                    inputElementGenerator,
                    minusMenuElement,
                    logger: logger4,
                    onSubmitValueParser
                });
            case UNDEFINED:
                return (0, _reactDefault.default).createElement(JsonValue, {
                    name,
                    value: "undefined",
                    originalValue: "undefined",
                    keyPath,
                    deep,
                    handleRemove,
                    handleUpdateValue,
                    readOnly,
                    dataType,
                    getStyle,
                    cancelButtonElement,
                    editButtonElement,
                    inputElementGenerator,
                    minusMenuElement,
                    logger: logger4,
                    onSubmitValueParser
                });
            case FUNCTION:
                return (0, _reactDefault.default).createElement(JsonFunctionValue, {
                    name,
                    value: data.toString(),
                    originalValue: data,
                    keyPath,
                    deep,
                    handleRemove,
                    handleUpdateValue,
                    readOnly,
                    dataType,
                    getStyle,
                    cancelButtonElement,
                    editButtonElement,
                    textareaElementGenerator,
                    minusMenuElement,
                    logger: logger4,
                    onSubmitValueParser
                });
            case SYMBOL:
                return (0, _reactDefault.default).createElement(JsonValue, {
                    name,
                    value: data.toString(),
                    originalValue: data,
                    keyPath,
                    deep,
                    handleRemove,
                    handleUpdateValue,
                    readOnly: readOnlyTrue,
                    dataType,
                    getStyle,
                    cancelButtonElement,
                    editButtonElement,
                    inputElementGenerator,
                    minusMenuElement,
                    logger: logger4,
                    onSubmitValueParser
                });
            default:
                return null;
        }
    }
};
JsonNode.defaultProps = {
    keyPath: [],
    deep: 0
};
var JsonObject = class extends (0, _react.Component) {
    constructor(props){
        super(props);
        let keyPath = props.deep === -1 ? [] : [
            ...props.keyPath,
            props.name
        ];
        this.state = {
            name: props.name,
            data: props.data,
            keyPath,
            deep: props.deep,
            nextDeep: props.deep + 1,
            collapsed: props.isCollapsed(keyPath, props.deep, props.data),
            addFormVisible: !1
        }, this.handleCollapseMode = this.handleCollapseMode.bind(this), this.handleRemoveValue = this.handleRemoveValue.bind(this), this.handleAddMode = this.handleAddMode.bind(this), this.handleAddValueAdd = this.handleAddValueAdd.bind(this), this.handleAddValueCancel = this.handleAddValueCancel.bind(this), this.handleEditValue = this.handleEditValue.bind(this), this.onChildUpdate = this.onChildUpdate.bind(this), this.renderCollapsed = this.renderCollapsed.bind(this), this.renderNotCollapsed = this.renderNotCollapsed.bind(this);
    }
    static getDerivedStateFromProps(props, state) {
        return props.data !== state.data ? {
            data: props.data
        } : null;
    }
    onChildUpdate(childKey, childData) {
        let { data, keyPath } = this.state;
        data[childKey] = childData, this.setState({
            data
        });
        let { onUpdate } = this.props, size = keyPath.length;
        onUpdate(keyPath[size - 1], data);
    }
    handleAddMode() {
        this.setState({
            addFormVisible: !0
        });
    }
    handleAddValueCancel() {
        this.setState({
            addFormVisible: !1
        });
    }
    handleAddValueAdd({ key, newValue }) {
        let { data, keyPath, nextDeep: deep } = this.state, { beforeAddAction, logger: logger4 } = this.props;
        beforeAddAction(key, keyPath, deep, newValue).then(()=>{
            data[key] = newValue, this.setState({
                data
            }), this.handleAddValueCancel();
            let { onUpdate, onDeltaUpdate } = this.props;
            onUpdate(keyPath[keyPath.length - 1], data), onDeltaUpdate({
                type: ADD_DELTA_TYPE,
                keyPath,
                deep,
                key,
                newValue
            });
        }).catch(logger4.error);
    }
    handleRemoveValue(key) {
        return ()=>{
            let { beforeRemoveAction, logger: logger4 } = this.props, { data, keyPath, nextDeep: deep } = this.state, oldValue = data[key];
            beforeRemoveAction(key, keyPath, deep, oldValue).then(()=>{
                let deltaUpdateResult = {
                    keyPath,
                    deep,
                    key,
                    oldValue,
                    type: REMOVE_DELTA_TYPE
                };
                delete data[key], this.setState({
                    data
                });
                let { onUpdate, onDeltaUpdate } = this.props;
                onUpdate(keyPath[keyPath.length - 1], data), onDeltaUpdate(deltaUpdateResult);
            }).catch(logger4.error);
        };
    }
    handleCollapseMode() {
        this.setState((state)=>({
                collapsed: !state.collapsed
            }));
    }
    handleEditValue({ key, value: value2 }) {
        return new Promise((resolve, reject)=>{
            let { beforeUpdateAction } = this.props, { data, keyPath, nextDeep: deep } = this.state, oldValue = data[key];
            beforeUpdateAction(key, keyPath, deep, oldValue, value2).then(()=>{
                data[key] = value2, this.setState({
                    data
                });
                let { onUpdate, onDeltaUpdate } = this.props;
                onUpdate(keyPath[keyPath.length - 1], data), onDeltaUpdate({
                    type: UPDATE_DELTA_TYPE,
                    keyPath,
                    deep,
                    key,
                    newValue: value2,
                    oldValue
                }), resolve();
            }).catch(reject);
        });
    }
    renderCollapsed() {
        let { name, keyPath, deep, data } = this.state, { handleRemove, readOnly, dataType, getStyle, minusMenuElement } = this.props, { minus, collapsed } = getStyle(name, data, keyPath, deep, dataType), keyList = Object.getOwnPropertyNames(data), isReadOnly = readOnly(name, data, keyPath, deep, dataType), removeItemButton = (0, _react.cloneElement)(minusMenuElement, {
            onClick: handleRemove,
            className: "rejt-minus-menu",
            style: minus
        });
        return (0, _reactDefault.default).createElement("span", {
            className: "rejt-collapsed"
        }, (0, _reactDefault.default).createElement("span", {
            className: "rejt-collapsed-text",
            style: collapsed,
            onClick: this.handleCollapseMode
        }, "{...}", " ", keyList.length, " ", keyList.length === 1 ? "key" : "keys"), !isReadOnly && removeItemButton);
    }
    renderNotCollapsed() {
        let { name, data, keyPath, deep, nextDeep, addFormVisible } = this.state, { isCollapsed, handleRemove, onDeltaUpdate, readOnly, getStyle, dataType, addButtonElement, cancelButtonElement, editButtonElement, inputElementGenerator, textareaElementGenerator, minusMenuElement, plusMenuElement, beforeRemoveAction, beforeAddAction, beforeUpdateAction, logger: logger4, onSubmitValueParser } = this.props, { minus, plus, addForm, ul, delimiter } = getStyle(name, data, keyPath, deep, dataType), keyList = Object.getOwnPropertyNames(data), isReadOnly = readOnly(name, data, keyPath, deep, dataType), addItemButton = (0, _react.cloneElement)(plusMenuElement, {
            onClick: this.handleAddMode,
            className: "rejt-plus-menu",
            style: plus
        }), removeItemButton = (0, _react.cloneElement)(minusMenuElement, {
            onClick: handleRemove,
            className: "rejt-minus-menu",
            style: minus
        }), list = keyList.map((key)=>(0, _reactDefault.default).createElement(JsonNode, {
                key,
                name: key,
                data: data[key],
                keyPath,
                deep: nextDeep,
                isCollapsed,
                handleRemove: this.handleRemoveValue(key),
                handleUpdateValue: this.handleEditValue,
                onUpdate: this.onChildUpdate,
                onDeltaUpdate,
                readOnly,
                getStyle,
                addButtonElement,
                cancelButtonElement,
                editButtonElement,
                inputElementGenerator,
                textareaElementGenerator,
                minusMenuElement,
                plusMenuElement,
                beforeRemoveAction,
                beforeAddAction,
                beforeUpdateAction,
                logger: logger4,
                onSubmitValueParser
            })), startObject = "{", endObject = "}";
        return (0, _reactDefault.default).createElement("span", {
            className: "rejt-not-collapsed"
        }, (0, _reactDefault.default).createElement("span", {
            className: "rejt-not-collapsed-delimiter",
            style: delimiter
        }, startObject), !isReadOnly && addItemButton, (0, _reactDefault.default).createElement("ul", {
            className: "rejt-not-collapsed-list",
            style: ul
        }, list), !isReadOnly && addFormVisible && (0, _reactDefault.default).createElement("div", {
            className: "rejt-add-form",
            style: addForm
        }, (0, _reactDefault.default).createElement(JsonAddValue, {
            handleAdd: this.handleAddValueAdd,
            handleCancel: this.handleAddValueCancel,
            addButtonElement,
            cancelButtonElement,
            inputElementGenerator,
            keyPath,
            deep,
            onSubmitValueParser
        })), (0, _reactDefault.default).createElement("span", {
            className: "rejt-not-collapsed-delimiter",
            style: delimiter
        }, endObject), !isReadOnly && removeItemButton);
    }
    render() {
        let { name, collapsed, data, keyPath, deep } = this.state, { getStyle, dataType } = this.props, value2 = collapsed ? this.renderCollapsed() : this.renderNotCollapsed(), style = getStyle(name, data, keyPath, deep, dataType);
        return (0, _reactDefault.default).createElement("div", {
            className: "rejt-object-node"
        }, (0, _reactDefault.default).createElement("span", {
            onClick: this.handleCollapseMode
        }, (0, _reactDefault.default).createElement("span", {
            className: "rejt-name",
            style: style.name
        }, name, " :", " ")), value2);
    }
};
JsonObject.defaultProps = {
    keyPath: [],
    deep: 0,
    minusMenuElement: (0, _reactDefault.default).createElement("span", null, " - "),
    plusMenuElement: (0, _reactDefault.default).createElement("span", null, " + ")
};
var JsonValue = class extends (0, _react.Component) {
    constructor(props){
        super(props);
        let keyPath = [
            ...props.keyPath,
            props.name
        ];
        this.state = {
            value: props.value,
            name: props.name,
            keyPath,
            deep: props.deep,
            editEnabled: !1,
            inputRef: null
        }, this.handleEditMode = this.handleEditMode.bind(this), this.refInput = this.refInput.bind(this), this.handleCancelEdit = this.handleCancelEdit.bind(this), this.handleEdit = this.handleEdit.bind(this), this.onKeydown = this.onKeydown.bind(this);
    }
    static getDerivedStateFromProps(props, state) {
        return props.value !== state.value ? {
            value: props.value
        } : null;
    }
    componentDidUpdate() {
        let { editEnabled, inputRef, name, value: value2, keyPath, deep } = this.state, { readOnly, dataType } = this.props, isReadOnly = readOnly(name, value2, keyPath, deep, dataType);
        editEnabled && !isReadOnly && typeof inputRef.focus == "function" && inputRef.focus();
    }
    componentDidMount() {
        document.addEventListener("keydown", this.onKeydown);
    }
    componentWillUnmount() {
        document.removeEventListener("keydown", this.onKeydown);
    }
    onKeydown(event) {
        event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.repeat || ((event.code === "Enter" || event.key === "Enter") && (event.preventDefault(), this.handleEdit()), (event.code === "Escape" || event.key === "Escape") && (event.preventDefault(), this.handleCancelEdit()));
    }
    handleEdit() {
        let { handleUpdateValue, originalValue, logger: logger4, onSubmitValueParser, keyPath } = this.props, { inputRef, name, deep } = this.state;
        if (!inputRef) return;
        let newValue = onSubmitValueParser(!0, keyPath, deep, name, inputRef.value);
        handleUpdateValue({
            value: newValue,
            key: name
        }).then(()=>{
            isComponentWillChange(originalValue, newValue) || this.handleCancelEdit();
        }).catch(logger4.error);
    }
    handleEditMode() {
        this.setState({
            editEnabled: !0
        });
    }
    refInput(node) {
        this.state.inputRef = node;
    }
    handleCancelEdit() {
        this.setState({
            editEnabled: !1
        });
    }
    render() {
        let { name, value: value2, editEnabled, keyPath, deep } = this.state, { handleRemove, originalValue, readOnly, dataType, getStyle, editButtonElement, cancelButtonElement, inputElementGenerator, minusMenuElement, keyPath: comeFromKeyPath } = this.props, style = getStyle(name, originalValue, keyPath, deep, dataType), isReadOnly = readOnly(name, originalValue, keyPath, deep, dataType), isEditing = editEnabled && !isReadOnly, inputElement = inputElementGenerator(VALUE, comeFromKeyPath, deep, name, originalValue, dataType), editButtonElementLayout = (0, _react.cloneElement)(editButtonElement, {
            onClick: this.handleEdit
        }), cancelButtonElementLayout = (0, _react.cloneElement)(cancelButtonElement, {
            onClick: this.handleCancelEdit
        }), inputElementLayout = (0, _react.cloneElement)(inputElement, {
            ref: this.refInput,
            defaultValue: JSON.stringify(originalValue)
        }), minusMenuLayout = (0, _react.cloneElement)(minusMenuElement, {
            onClick: handleRemove,
            className: "rejt-minus-menu",
            style: style.minus
        });
        return (0, _reactDefault.default).createElement("li", {
            className: "rejt-value-node",
            style: style.li
        }, (0, _reactDefault.default).createElement("span", {
            className: "rejt-name",
            style: style.name
        }, name, " : "), isEditing ? (0, _reactDefault.default).createElement("span", {
            className: "rejt-edit-form",
            style: style.editForm
        }, inputElementLayout, " ", cancelButtonElementLayout, editButtonElementLayout) : (0, _reactDefault.default).createElement("span", {
            className: "rejt-value",
            style: style.value,
            onClick: isReadOnly ? null : this.handleEditMode
        }, String(value2)), !isReadOnly && !isEditing && minusMenuLayout);
    }
};
JsonValue.defaultProps = {
    keyPath: [],
    deep: 0,
    handleUpdateValue: ()=>Promise.resolve(),
    editButtonElement: (0, _reactDefault.default).createElement("button", null, "e"),
    cancelButtonElement: (0, _reactDefault.default).createElement("button", null, "c"),
    minusMenuElement: (0, _reactDefault.default).createElement("span", null, " - ")
};
var object = {
    minus: {
        color: "red"
    },
    plus: {
        color: "green"
    },
    collapsed: {
        color: "grey"
    },
    delimiter: {},
    ul: {
        padding: "0px",
        margin: "0 0 0 25px",
        listStyle: "none"
    },
    name: {
        color: "#2287CD"
    },
    addForm: {}
}, array = {
    minus: {
        color: "red"
    },
    plus: {
        color: "green"
    },
    collapsed: {
        color: "grey"
    },
    delimiter: {},
    ul: {
        padding: "0px",
        margin: "0 0 0 25px",
        listStyle: "none"
    },
    name: {
        color: "#2287CD"
    },
    addForm: {}
}, value = {
    minus: {
        color: "red"
    },
    editForm: {},
    value: {
        color: "#7bba3d"
    },
    li: {
        minHeight: "22px",
        lineHeight: "22px",
        outline: "0px"
    },
    name: {
        color: "#2287CD"
    }
};
function parse3(string) {
    let result = string;
    if (result.indexOf("function") === 0) return (0, eval)(`(${result})`);
    try {
        result = JSON.parse(string);
    } catch  {}
    return result;
}
var JsonTree = class extends (0, _react.Component) {
    constructor(props){
        super(props), this.state = {
            data: props.data,
            rootName: props.rootName
        }, this.onUpdate = this.onUpdate.bind(this), this.removeRoot = this.removeRoot.bind(this);
    }
    static getDerivedStateFromProps(props, state) {
        return props.data !== state.data || props.rootName !== state.rootName ? {
            data: props.data,
            rootName: props.rootName
        } : null;
    }
    onUpdate(key, data) {
        this.setState({
            data
        }), this.props.onFullyUpdate(data);
    }
    removeRoot() {
        this.onUpdate(null, null);
    }
    render() {
        let { data, rootName } = this.state, { isCollapsed, onDeltaUpdate, readOnly, getStyle, addButtonElement, cancelButtonElement, editButtonElement, inputElement, textareaElement, minusMenuElement, plusMenuElement, beforeRemoveAction, beforeAddAction, beforeUpdateAction, logger: logger4, onSubmitValueParser, fallback = null } = this.props, dataType = getObjectType(data), readOnlyFunction = readOnly;
        getObjectType(readOnly) === "Boolean" && (readOnlyFunction = ()=>readOnly);
        let inputElementFunction = inputElement;
        inputElement && getObjectType(inputElement) !== "Function" && (inputElementFunction = ()=>inputElement);
        let textareaElementFunction = textareaElement;
        return textareaElement && getObjectType(textareaElement) !== "Function" && (textareaElementFunction = ()=>textareaElement), dataType === "Object" || dataType === "Array" ? (0, _reactDefault.default).createElement("div", {
            className: "rejt-tree"
        }, (0, _reactDefault.default).createElement(JsonNode, {
            data,
            name: rootName,
            deep: -1,
            isCollapsed,
            onUpdate: this.onUpdate,
            onDeltaUpdate,
            readOnly: readOnlyFunction,
            getStyle,
            addButtonElement,
            cancelButtonElement,
            editButtonElement,
            inputElementGenerator: inputElementFunction,
            textareaElementGenerator: textareaElementFunction,
            minusMenuElement,
            plusMenuElement,
            handleRemove: this.removeRoot,
            beforeRemoveAction,
            beforeAddAction,
            beforeUpdateAction,
            logger: logger4,
            onSubmitValueParser
        })) : fallback;
    }
};
JsonTree.defaultProps = {
    rootName: "root",
    isCollapsed: (keyPath, deep)=>deep !== -1,
    getStyle: (keyName, data, keyPath, deep, dataType)=>{
        switch(dataType){
            case "Object":
            case "Error":
                return object;
            case "Array":
                return array;
            default:
                return value;
        }
    },
    readOnly: ()=>!1,
    onFullyUpdate: ()=>{},
    onDeltaUpdate: ()=>{},
    beforeRemoveAction: ()=>Promise.resolve(),
    beforeAddAction: ()=>Promise.resolve(),
    beforeUpdateAction: ()=>Promise.resolve(),
    logger: {
        error: ()=>{}
    },
    onSubmitValueParser: (isEditMode, keyPath, deep, name, rawValue)=>parse3(rawValue),
    inputElement: ()=>(0, _reactDefault.default).createElement("input", null),
    textareaElement: ()=>(0, _reactDefault.default).createElement("textarea", null),
    fallback: null
};
var { window: globalWindow2 } = (0, _global.global), Wrapper5 = (0, _theming.styled).div(({ theme })=>({
        position: "relative",
        display: "flex",
        ".rejt-tree": {
            marginLeft: "1rem",
            fontSize: "13px"
        },
        ".rejt-value-node, .rejt-object-node > .rejt-collapsed, .rejt-array-node > .rejt-collapsed, .rejt-object-node > .rejt-not-collapsed, .rejt-array-node > .rejt-not-collapsed": {
            "& > svg": {
                opacity: 0,
                transition: "opacity 0.2s"
            }
        },
        ".rejt-value-node:hover, .rejt-object-node:hover > .rejt-collapsed, .rejt-array-node:hover > .rejt-collapsed, .rejt-object-node:hover > .rejt-not-collapsed, .rejt-array-node:hover > .rejt-not-collapsed": {
            "& > svg": {
                opacity: 1
            }
        },
        ".rejt-edit-form button": {
            display: "none"
        },
        ".rejt-add-form": {
            marginLeft: 10
        },
        ".rejt-add-value-node": {
            display: "inline-flex",
            alignItems: "center"
        },
        ".rejt-name": {
            lineHeight: "22px"
        },
        ".rejt-not-collapsed-delimiter": {
            lineHeight: "22px"
        },
        ".rejt-plus-menu": {
            marginLeft: 5
        },
        ".rejt-object-node > span > *, .rejt-array-node > span > *": {
            position: "relative",
            zIndex: 2
        },
        ".rejt-object-node, .rejt-array-node": {
            position: "relative"
        },
        ".rejt-object-node > span:first-of-type::after, .rejt-array-node > span:first-of-type::after, .rejt-collapsed::before, .rejt-not-collapsed::before": {
            content: '""',
            position: "absolute",
            top: 0,
            display: "block",
            width: "100%",
            marginLeft: "-1rem",
            padding: "0 4px 0 1rem",
            height: 22
        },
        ".rejt-collapsed::before, .rejt-not-collapsed::before": {
            zIndex: 1,
            background: "transparent",
            borderRadius: 4,
            transition: "background 0.2s",
            pointerEvents: "none",
            opacity: .1
        },
        ".rejt-object-node:hover, .rejt-array-node:hover": {
            "& > .rejt-collapsed::before, & > .rejt-not-collapsed::before": {
                background: theme.color.secondary
            }
        },
        ".rejt-collapsed::after, .rejt-not-collapsed::after": {
            content: '""',
            position: "absolute",
            display: "inline-block",
            pointerEvents: "none",
            width: 0,
            height: 0
        },
        ".rejt-collapsed::after": {
            left: -8,
            top: 8,
            borderTop: "3px solid transparent",
            borderBottom: "3px solid transparent",
            borderLeft: "3px solid rgba(153,153,153,0.6)"
        },
        ".rejt-not-collapsed::after": {
            left: -10,
            top: 10,
            borderTop: "3px solid rgba(153,153,153,0.6)",
            borderLeft: "3px solid transparent",
            borderRight: "3px solid transparent"
        },
        ".rejt-value": {
            display: "inline-block",
            border: "1px solid transparent",
            borderRadius: 4,
            margin: "1px 0",
            padding: "0 4px",
            cursor: "text",
            color: theme.color.defaultText
        },
        ".rejt-value-node:hover > .rejt-value": {
            background: theme.color.lighter,
            borderColor: theme.appBorderColor
        }
    })), Button = (0, _theming.styled).button(({ theme, primary })=>({
        border: 0,
        height: 20,
        margin: 1,
        borderRadius: 4,
        background: primary ? theme.color.secondary : "transparent",
        color: primary ? theme.color.lightest : theme.color.dark,
        fontWeight: primary ? "bold" : "normal",
        cursor: "pointer",
        order: primary ? "initial" : 9
    })), ActionIcon = (0, _theming.styled)((0, _components.Icons))(({ theme, icon, disabled })=>({
        display: "inline-block",
        verticalAlign: "middle",
        width: 15,
        height: 15,
        padding: 3,
        marginLeft: 5,
        cursor: disabled ? "not-allowed" : "pointer",
        color: theme.textMutedColor,
        "&:hover": disabled ? {} : {
            color: icon === "subtract" ? theme.color.negative : theme.color.ancillary
        },
        "svg + &": {
            marginLeft: 0
        }
    })), Input = (0, _theming.styled).input(({ theme, placeholder })=>({
        outline: 0,
        margin: placeholder ? 1 : "1px 0",
        padding: "3px 4px",
        color: theme.color.defaultText,
        background: theme.background.app,
        border: `1px solid ${theme.appBorderColor}`,
        borderRadius: 4,
        lineHeight: "14px",
        width: placeholder === "Key" ? 80 : 120,
        "&:focus": {
            border: `1px solid ${theme.color.secondary}`
        }
    })), RawButton = (0, _theming.styled)((0, _components.IconButton))(({ theme })=>({
        position: "absolute",
        zIndex: 2,
        top: 2,
        right: 2,
        height: 21,
        padding: "0 3px",
        background: theme.background.bar,
        border: `1px solid ${theme.appBorderColor}`,
        borderRadius: 3,
        color: theme.textMutedColor,
        fontSize: "9px",
        fontWeight: "bold",
        textDecoration: "none",
        span: {
            marginLeft: 3,
            marginTop: 1
        }
    })), RawInput = (0, _theming.styled)((0, _components.Form).Textarea)(({ theme })=>({
        flex: 1,
        padding: "7px 6px",
        fontFamily: theme.typography.fonts.mono,
        fontSize: "12px",
        lineHeight: "18px",
        "&::placeholder": {
            fontFamily: theme.typography.fonts.base,
            fontSize: "13px"
        },
        "&:placeholder-shown": {
            padding: "7px 10px"
        }
    })), ENTER_EVENT = {
    bubbles: !0,
    cancelable: !0,
    key: "Enter",
    code: "Enter",
    keyCode: 13
}, dispatchEnterKey = (event)=>{
    event.currentTarget.dispatchEvent(new globalWindow2.KeyboardEvent("keydown", ENTER_EVENT));
}, selectValue = (event)=>{
    event.currentTarget.select();
}, getCustomStyleFunction = (theme)=>()=>({
            name: {
                color: theme.color.secondary
            },
            collapsed: {
                color: theme.color.dark
            },
            ul: {
                listStyle: "none",
                margin: "0 0 0 1rem",
                padding: 0
            },
            li: {
                outline: 0
            }
        }), ObjectControl = ({ name, value: value2, onChange })=>{
    let theme = (0, _theming.useTheme)(), data = (0, _react.useMemo)(()=>value2 && (0, _cloneDeepJsDefault.default)(value2), [
        value2
    ]), hasData = data != null, [showRaw, setShowRaw] = (0, _react.useState)(!hasData), [parseError, setParseError] = (0, _react.useState)(null), updateRaw = (0, _react.useCallback)((raw)=>{
        try {
            raw && onChange(JSON.parse(raw)), setParseError(void 0);
        } catch (e) {
            setParseError(e);
        }
    }, [
        onChange
    ]), [forceVisible, setForceVisible] = (0, _react.useState)(!1), onForceVisible = (0, _react.useCallback)(()=>{
        onChange({}), setForceVisible(!0);
    }, [
        setForceVisible
    ]), htmlElRef = (0, _react.useRef)(null);
    if ((0, _react.useEffect)(()=>{
        forceVisible && htmlElRef.current && htmlElRef.current.select();
    }, [
        forceVisible
    ]), !hasData) return (0, _reactDefault.default).createElement((0, _components.Form).Button, {
        id: (0, _chunkGWAJ4KRUMjs.getControlSetterButtonId)(name),
        onClick: onForceVisible
    }, "Set object");
    let rawJSONForm = (0, _reactDefault.default).createElement(RawInput, {
        ref: htmlElRef,
        id: (0, _chunkGWAJ4KRUMjs.getControlId)(name),
        name,
        defaultValue: value2 === null ? "" : JSON.stringify(value2, null, 2),
        onBlur: (event)=>updateRaw(event.target.value),
        placeholder: "Edit JSON string...",
        autoFocus: forceVisible,
        valid: parseError ? "error" : null
    });
    return (0, _reactDefault.default).createElement(Wrapper5, null, [
        "Object",
        "Array"
    ].includes(getObjectType(data)) && (0, _reactDefault.default).createElement(RawButton, {
        href: "#",
        onClick: (e)=>{
            e.preventDefault(), setShowRaw((v)=>!v);
        }
    }, (0, _reactDefault.default).createElement((0, _components.Icons), {
        icon: showRaw ? "eyeclose" : "eye"
    }), (0, _reactDefault.default).createElement("span", null, "RAW")), showRaw ? rawJSONForm : (0, _reactDefault.default).createElement(JsonTree, {
        data,
        rootName: name,
        onFullyUpdate: onChange,
        getStyle: getCustomStyleFunction(theme),
        cancelButtonElement: (0, _reactDefault.default).createElement(Button, {
            type: "button"
        }, "Cancel"),
        editButtonElement: (0, _reactDefault.default).createElement(Button, {
            type: "submit"
        }, "Save"),
        addButtonElement: (0, _reactDefault.default).createElement(Button, {
            type: "submit",
            primary: !0
        }, "Save"),
        plusMenuElement: (0, _reactDefault.default).createElement(ActionIcon, {
            icon: "add"
        }),
        minusMenuElement: (0, _reactDefault.default).createElement(ActionIcon, {
            icon: "subtract"
        }),
        inputElement: (_, __, ___, key)=>key ? (0, _reactDefault.default).createElement(Input, {
                onFocus: selectValue,
                onBlur: dispatchEnterKey
            }) : (0, _reactDefault.default).createElement(Input, null),
        fallback: rawJSONForm
    }));
};
var RangeInput = (0, _theming.styled).input(({ theme, min, max, value: value2 })=>({
        "&": {
            width: "100%",
            backgroundColor: "transparent",
            appearance: "none"
        },
        "&::-webkit-slider-runnable-track": {
            background: theme.base === "light" ? `linear-gradient(to right, 
            ${theme.color.green} 0%, ${theme.color.green} ${(value2 - min) / (max - min) * 100}%, 
            ${(0, _polished.darken)(.02, theme.input.background)} ${(value2 - min) / (max - min) * 100}%, 
            ${(0, _polished.darken)(.02, theme.input.background)} 100%)` : `linear-gradient(to right, 
            ${theme.color.green} 0%, ${theme.color.green} ${(value2 - min) / (max - min) * 100}%, 
            ${(0, _polished.lighten)(.02, theme.input.background)} ${(value2 - min) / (max - min) * 100}%, 
            ${(0, _polished.lighten)(.02, theme.input.background)} 100%)`,
            boxShadow: `${theme.appBorderColor} 0 0 0 1px inset`,
            borderRadius: 6,
            width: "100%",
            height: 6,
            cursor: "pointer"
        },
        "&::-webkit-slider-thumb": {
            marginTop: "-6px",
            width: 16,
            height: 16,
            border: `1px solid ${(0, _polished.rgba)(theme.appBorderColor, .2)}`,
            borderRadius: "50px",
            boxShadow: `0 1px 3px 0px ${(0, _polished.rgba)(theme.appBorderColor, .2)}`,
            cursor: "grab",
            appearance: "none",
            background: `${theme.input.background}`,
            transition: "all 150ms ease-out",
            "&:hover": {
                background: `${(0, _polished.darken)(.05, theme.input.background)}`,
                transform: "scale3d(1.1, 1.1, 1.1) translateY(-1px)",
                transition: "all 50ms ease-out"
            },
            "&:active": {
                background: `${theme.input.background}`,
                transform: "scale3d(1, 1, 1) translateY(0px)",
                cursor: "grabbing"
            }
        },
        "&:focus": {
            outline: "none",
            "&::-webkit-slider-runnable-track": {
                borderColor: (0, _polished.rgba)(theme.color.secondary, .4)
            },
            "&::-webkit-slider-thumb": {
                borderColor: theme.color.secondary,
                boxShadow: `0 0px 5px 0px ${theme.color.secondary}`
            }
        },
        "&::-moz-range-track": {
            background: theme.base === "light" ? `linear-gradient(to right, 
            ${theme.color.green} 0%, ${theme.color.green} ${(value2 - min) / (max - min) * 100}%, 
            ${(0, _polished.darken)(.02, theme.input.background)} ${(value2 - min) / (max - min) * 100}%, 
            ${(0, _polished.darken)(.02, theme.input.background)} 100%)` : `linear-gradient(to right, 
            ${theme.color.green} 0%, ${theme.color.green} ${(value2 - min) / (max - min) * 100}%, 
            ${(0, _polished.lighten)(.02, theme.input.background)} ${(value2 - min) / (max - min) * 100}%, 
            ${(0, _polished.lighten)(.02, theme.input.background)} 100%)`,
            boxShadow: `${theme.appBorderColor} 0 0 0 1px inset`,
            borderRadius: 6,
            width: "100%",
            height: 6,
            cursor: "pointer",
            outline: "none"
        },
        "&::-moz-range-thumb": {
            width: 16,
            height: 16,
            border: `1px solid ${(0, _polished.rgba)(theme.appBorderColor, .2)}`,
            borderRadius: "50px",
            boxShadow: `0 1px 3px 0px ${(0, _polished.rgba)(theme.appBorderColor, .2)}`,
            cursor: "grab",
            background: `${theme.input.background}`,
            transition: "all 150ms ease-out",
            "&:hover": {
                background: `${(0, _polished.darken)(.05, theme.input.background)}`,
                transform: "scale3d(1.1, 1.1, 1.1) translateY(-1px)",
                transition: "all 50ms ease-out"
            },
            "&:active": {
                background: `${theme.input.background}`,
                transform: "scale3d(1, 1, 1) translateY(0px)",
                cursor: "grabbing"
            }
        },
        "&::-ms-track": {
            background: theme.base === "light" ? `linear-gradient(to right, 
            ${theme.color.green} 0%, ${theme.color.green} ${(value2 - min) / (max - min) * 100}%, 
            ${(0, _polished.darken)(.02, theme.input.background)} ${(value2 - min) / (max - min) * 100}%, 
            ${(0, _polished.darken)(.02, theme.input.background)} 100%)` : `linear-gradient(to right, 
            ${theme.color.green} 0%, ${theme.color.green} ${(value2 - min) / (max - min) * 100}%, 
            ${(0, _polished.lighten)(.02, theme.input.background)} ${(value2 - min) / (max - min) * 100}%, 
            ${(0, _polished.lighten)(.02, theme.input.background)} 100%)`,
            boxShadow: `${theme.appBorderColor} 0 0 0 1px inset`,
            color: "transparent",
            width: "100%",
            height: "6px",
            cursor: "pointer"
        },
        "&::-ms-fill-lower": {
            borderRadius: 6
        },
        "&::-ms-fill-upper": {
            borderRadius: 6
        },
        "&::-ms-thumb": {
            width: 16,
            height: 16,
            background: `${theme.input.background}`,
            border: `1px solid ${(0, _polished.rgba)(theme.appBorderColor, .2)}`,
            borderRadius: 50,
            cursor: "grab",
            marginTop: 0
        },
        "@supports (-ms-ime-align:auto)": {
            "input[type=range]": {
                margin: "0"
            }
        }
    })), RangeLabel = (0, _theming.styled).span({
    paddingLeft: 5,
    paddingRight: 5,
    fontSize: 12,
    whiteSpace: "nowrap",
    fontFeatureSettings: "tnum",
    fontVariantNumeric: "tabular-nums"
}), RangeCurrentAndMaxLabel = (0, _theming.styled)(RangeLabel)(({ numberOFDecimalsPlaces, max })=>({
        width: `${numberOFDecimalsPlaces + max.toString().length * 2 + 3}ch`,
        textAlign: "right",
        flexShrink: 0
    })), RangeWrapper = (0, _theming.styled).div({
    display: "flex",
    alignItems: "center",
    width: "100%"
});
function getNumberOfDecimalPlaces(number) {
    let match = number.toString().match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    return match ? Math.max(0, (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0)) : 0;
}
var RangeControl = ({ name, value: value2, onChange, min = 0, max = 100, step = 1, onBlur, onFocus })=>{
    let handleChange = (event)=>{
        onChange(parse2(event.target.value));
    }, hasValue = value2 !== void 0, numberOFDecimalsPlaces = (0, _react.useMemo)(()=>getNumberOfDecimalPlaces(step), [
        step
    ]);
    return (0, _reactDefault.default).createElement(RangeWrapper, null, (0, _reactDefault.default).createElement(RangeLabel, null, min), (0, _reactDefault.default).createElement(RangeInput, {
        id: (0, _chunkGWAJ4KRUMjs.getControlId)(name),
        type: "range",
        onChange: handleChange,
        name,
        value: value2,
        min,
        max,
        step,
        onFocus,
        onBlur
    }), (0, _reactDefault.default).createElement(RangeCurrentAndMaxLabel, {
        numberOFDecimalsPlaces,
        max
    }, hasValue ? value2.toFixed(numberOFDecimalsPlaces) : "--", " / ", max));
};
var Wrapper6 = (0, _theming.styled).label({
    display: "flex"
}), MaxLength = (0, _theming.styled).div(({ isMaxed })=>({
        marginLeft: "0.75rem",
        paddingTop: "0.35rem",
        color: isMaxed ? "red" : void 0
    })), TextControl = ({ name, value: value2, onChange, onFocus, onBlur, maxLength })=>{
    let handleChange = (event)=>{
        onChange(event.target.value);
    }, [forceVisible, setForceVisible] = (0, _react.useState)(!1), onForceVisible = (0, _react.useCallback)(()=>{
        onChange(""), setForceVisible(!0);
    }, [
        setForceVisible
    ]);
    if (value2 === void 0) return (0, _reactDefault.default).createElement((0, _components.Form).Button, {
        id: (0, _chunkGWAJ4KRUMjs.getControlSetterButtonId)(name),
        onClick: onForceVisible
    }, "Set string");
    let isValid = typeof value2 == "string";
    return (0, _reactDefault.default).createElement(Wrapper6, null, (0, _reactDefault.default).createElement((0, _components.Form).Textarea, {
        id: (0, _chunkGWAJ4KRUMjs.getControlId)(name),
        maxLength,
        onChange: handleChange,
        size: "flex",
        placeholder: "Edit string...",
        autoFocus: forceVisible,
        valid: isValid ? null : "error",
        name,
        value: isValid ? value2 : "",
        onFocus,
        onBlur
    }), maxLength && (0, _reactDefault.default).createElement(MaxLength, {
        isMaxed: value2?.length === maxLength
    }, value2?.length ?? 0, " / ", maxLength));
};
var FileInput = (0, _theming.styled)((0, _components.Form).Input)({
    padding: 10
});
function revokeOldUrls(urls) {
    urls.forEach((url)=>{
        url.startsWith("blob:") && URL.revokeObjectURL(url);
    });
}
var FilesControl = ({ onChange, name, accept = "image/*", value: value2 })=>{
    let inputElement = (0, _react.useRef)(null);
    function handleFileChange(e) {
        if (!e.target.files) return;
        let fileUrls = Array.from(e.target.files).map((file)=>URL.createObjectURL(file));
        onChange(fileUrls), revokeOldUrls(value2);
    }
    return (0, _react.useEffect)(()=>{
        value2 == null && inputElement.current && (inputElement.current.value = null);
    }, [
        value2,
        name
    ]), (0, _reactDefault.default).createElement(FileInput, {
        ref: inputElement,
        id: (0, _chunkGWAJ4KRUMjs.getControlId)(name),
        type: "file",
        name,
        multiple: !0,
        onChange: handleFileChange,
        accept,
        size: "flex"
    });
};
var LazyColorControl = (0, _react.lazy)(()=>require("8866e43278e7898b")), ColorControl = (props)=>(0, _reactDefault.default).createElement((0, _react.Suspense), {
        fallback: (0, _reactDefault.default).createElement("div", null)
    }, (0, _reactDefault.default).createElement(LazyColorControl, {
        ...props
    }));
var Controls2 = {
    array: ObjectControl,
    object: ObjectControl,
    boolean: BooleanControl,
    color: ColorControl,
    date: DateControl,
    number: NumberControl,
    check: OptionsControl,
    "inline-check": OptionsControl,
    radio: OptionsControl,
    "inline-radio": OptionsControl,
    select: OptionsControl,
    "multi-select": OptionsControl,
    range: RangeControl,
    text: TextControl,
    file: FilesControl
}, NoControl = ()=>(0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, "-"), ArgControl = ({ row, arg, updateArgs, isHovered })=>{
    let { key, control } = row, [isFocused, setFocused] = (0, _react.useState)(!1), [boxedValue, setBoxedValue] = (0, _react.useState)({
        value: arg
    });
    (0, _react.useEffect)(()=>{
        isFocused || setBoxedValue({
            value: arg
        });
    }, [
        isFocused,
        arg
    ]);
    let onChange = (0, _react.useCallback)((argVal)=>(setBoxedValue({
            value: argVal
        }), updateArgs({
            [key]: argVal
        }), argVal), [
        updateArgs,
        key
    ]), onBlur = (0, _react.useCallback)(()=>setFocused(!1), []), onFocus = (0, _react.useCallback)(()=>setFocused(!0), []);
    if (!control || control.disable) return isHovered ? (0, _reactDefault.default).createElement((0, _components.Link), {
        href: "https://storybook.js.org/docs/react/essentials/controls",
        target: "_blank",
        withArrow: !0
    }, "Setup controls") : (0, _reactDefault.default).createElement(NoControl, null);
    let props = {
        name: key,
        argType: row,
        value: boxedValue.value,
        onChange,
        onBlur,
        onFocus
    }, Control = Controls2[control.type] || NoControl;
    return (0, _reactDefault.default).createElement(Control, {
        ...props,
        ...control,
        controlType: control.type
    });
};
var Name = (0, _theming.styled).span({
    fontWeight: "bold"
}), Required = (0, _theming.styled).span(({ theme })=>({
        color: theme.color.negative,
        fontFamily: theme.typography.fonts.mono,
        cursor: "help"
    })), Description = (0, _theming.styled).div(({ theme })=>({
        "&&": {
            p: {
                margin: "0 0 10px 0"
            },
            a: {
                color: theme.color.secondary
            }
        },
        code: {
            ...(0, _components.codeCommon)({
                theme
            }),
            fontSize: 12,
            fontFamily: theme.typography.fonts.mono
        },
        "& code": {
            margin: 0,
            display: "inline-block"
        },
        "& pre > code": {
            whiteSpace: "pre-wrap"
        }
    })), Type = (0, _theming.styled).div(({ theme, hasDescription })=>({
        color: theme.base === "light" ? (0, _polished.transparentize)(.1, theme.color.defaultText) : (0, _polished.transparentize)(.2, theme.color.defaultText),
        marginTop: hasDescription ? 4 : 0
    })), TypeWithJsDoc = (0, _theming.styled).div(({ theme, hasDescription })=>({
        color: theme.base === "light" ? (0, _polished.transparentize)(.1, theme.color.defaultText) : (0, _polished.transparentize)(.2, theme.color.defaultText),
        marginTop: hasDescription ? 12 : 0,
        marginBottom: 12
    })), StyledTd = (0, _theming.styled).td(({ theme, expandable })=>({
        paddingLeft: expandable ? "40px !important" : "20px !important"
    })), ArgRow = (props)=>{
    let [isHovered, setIsHovered] = (0, _react.useState)(!1), { row, updateArgs, compact, expandable, initialExpandedArgs } = props, { name, description } = row, table = row.table || {}, type = table.type || row.type, defaultValue = table.defaultValue || row.defaultValue, required = row.type?.required, hasDescription = description != null && description !== "";
    return (0, _reactDefault.default).createElement("tr", {
        onMouseEnter: ()=>setIsHovered(!0),
        onMouseLeave: ()=>setIsHovered(!1)
    }, (0, _reactDefault.default).createElement(StyledTd, {
        expandable
    }, (0, _reactDefault.default).createElement(Name, null, name), required ? (0, _reactDefault.default).createElement(Required, {
        title: "Required"
    }, "*") : null), compact ? null : (0, _reactDefault.default).createElement("td", null, hasDescription && (0, _reactDefault.default).createElement(Description, null, (0, _reactDefault.default).createElement((0, _markdownToJsxDefault.default), null, description)), table.jsDocTags != null ? (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement(TypeWithJsDoc, {
        hasDescription
    }, (0, _reactDefault.default).createElement(ArgValue, {
        value: type,
        initialExpandedArgs
    })), (0, _reactDefault.default).createElement(ArgJsDoc, {
        tags: table.jsDocTags
    })) : (0, _reactDefault.default).createElement(Type, {
        hasDescription
    }, (0, _reactDefault.default).createElement(ArgValue, {
        value: type,
        initialExpandedArgs
    }))), compact ? null : (0, _reactDefault.default).createElement("td", null, (0, _reactDefault.default).createElement(ArgValue, {
        value: defaultValue,
        initialExpandedArgs
    })), updateArgs ? (0, _reactDefault.default).createElement("td", null, (0, _reactDefault.default).createElement(ArgControl, {
        ...props,
        isHovered
    })) : null);
};
var ExpanderIcon = (0, _theming.styled)((0, _components.Icons))(({ theme })=>({
        marginRight: 8,
        marginLeft: -10,
        marginTop: -2,
        height: 12,
        width: 12,
        color: theme.base === "light" ? (0, _polished.transparentize)(.25, theme.color.defaultText) : (0, _polished.transparentize)(.3, theme.color.defaultText),
        border: "none",
        display: "inline-block"
    })), FlexWrapper = (0, _theming.styled).span(({ theme })=>({
        display: "flex",
        lineHeight: "20px",
        alignItems: "center"
    })), Section = (0, _theming.styled).td(({ theme })=>({
        position: "relative",
        letterSpacing: "0.35em",
        textTransform: "uppercase",
        fontWeight: theme.typography.weight.bold,
        fontSize: theme.typography.size.s1 - 1,
        color: theme.base === "light" ? (0, _polished.transparentize)(.4, theme.color.defaultText) : (0, _polished.transparentize)(.6, theme.color.defaultText),
        background: `${theme.background.app} !important`,
        "& ~ td": {
            background: `${theme.background.app} !important`
        }
    })), Subsection = (0, _theming.styled).td(({ theme })=>({
        position: "relative",
        fontWeight: theme.typography.weight.bold,
        fontSize: theme.typography.size.s2 - 1,
        background: theme.background.app
    })), StyledTd2 = (0, _theming.styled).td(()=>({
        position: "relative"
    })), StyledTr = (0, _theming.styled).tr(({ theme })=>({
        "&:hover > td": {
            backgroundColor: `${(0, _polished.lighten)(.005, theme.background.app)} !important`,
            boxShadow: `${theme.color.mediumlight} 0 - 1px 0 0 inset`,
            cursor: "row-resize"
        }
    })), ClickIntercept = (0, _theming.styled).button(()=>({
        background: "none",
        border: "none",
        padding: "0",
        font: "inherit",
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        height: "100%",
        width: "100%",
        color: "transparent",
        cursor: "row-resize !important"
    })), SectionRow = ({ level = "section", label, children, initialExpanded = !0, colSpan = 3 })=>{
    let [expanded, setExpanded] = (0, _react.useState)(initialExpanded), Level = level === "subsection" ? Subsection : Section, itemCount = children?.length || 0, caption = level === "subsection" ? `${itemCount} item${itemCount !== 1 ? "s" : ""}` : "", icon = expanded ? "arrowdown" : "arrowright", helperText = `${expanded ? "Hide" : "Show"} ${level === "subsection" ? itemCount : label} item${itemCount !== 1 ? "s" : ""}`;
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement(StyledTr, {
        title: helperText
    }, (0, _reactDefault.default).createElement(Level, {
        colSpan: 1
    }, (0, _reactDefault.default).createElement(ClickIntercept, {
        onClick: (e)=>setExpanded(!expanded),
        tabIndex: 0
    }, helperText), (0, _reactDefault.default).createElement(FlexWrapper, null, (0, _reactDefault.default).createElement(ExpanderIcon, {
        icon
    }), label)), (0, _reactDefault.default).createElement(StyledTd2, {
        colSpan: colSpan - 1
    }, (0, _reactDefault.default).createElement(ClickIntercept, {
        onClick: (e)=>setExpanded(!expanded),
        tabIndex: -1,
        style: {
            outline: "none"
        }
    }, helperText), expanded ? null : caption)), expanded ? children : null);
};
var Row = (0, _theming.styled).div(({ theme })=>({
        display: "flex",
        gap: 16,
        borderBottom: `1px solid ${theme.appBorderColor}`,
        "&:last-child": {
            borderBottom: 0
        }
    })), Column = (0, _theming.styled).div(({ numColumn })=>({
        display: "flex",
        flexDirection: "column",
        flex: numColumn || 1,
        gap: 5,
        padding: "12px 20px"
    })), SkeletonText = (0, _theming.styled).div(({ theme, width, height })=>({
        animation: `${theme.animation.glow} 1.5s ease-in-out infinite`,
        background: theme.appBorderColor,
        width: width || "100%",
        height: height || 16,
        borderRadius: 3
    })), columnWidth = [
    2,
    4,
    2,
    2
], Skeleton = ()=>(0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement(Row, null, (0, _reactDefault.default).createElement(Column, {
        numColumn: columnWidth[0]
    }, (0, _reactDefault.default).createElement(SkeletonText, {
        width: "60%"
    })), (0, _reactDefault.default).createElement(Column, {
        numColumn: columnWidth[1]
    }, (0, _reactDefault.default).createElement(SkeletonText, {
        width: "30%"
    })), (0, _reactDefault.default).createElement(Column, {
        numColumn: columnWidth[2]
    }, (0, _reactDefault.default).createElement(SkeletonText, {
        width: "60%"
    })), (0, _reactDefault.default).createElement(Column, {
        numColumn: columnWidth[3]
    }, (0, _reactDefault.default).createElement(SkeletonText, {
        width: "60%"
    }))), (0, _reactDefault.default).createElement(Row, null, (0, _reactDefault.default).createElement(Column, {
        numColumn: columnWidth[0]
    }, (0, _reactDefault.default).createElement(SkeletonText, {
        width: "60%"
    })), (0, _reactDefault.default).createElement(Column, {
        numColumn: columnWidth[1]
    }, (0, _reactDefault.default).createElement(SkeletonText, {
        width: "80%"
    }), (0, _reactDefault.default).createElement(SkeletonText, {
        width: "30%"
    })), (0, _reactDefault.default).createElement(Column, {
        numColumn: columnWidth[2]
    }, (0, _reactDefault.default).createElement(SkeletonText, {
        width: "60%"
    })), (0, _reactDefault.default).createElement(Column, {
        numColumn: columnWidth[3]
    }, (0, _reactDefault.default).createElement(SkeletonText, {
        width: "60%"
    }))), (0, _reactDefault.default).createElement(Row, null, (0, _reactDefault.default).createElement(Column, {
        numColumn: columnWidth[0]
    }, (0, _reactDefault.default).createElement(SkeletonText, {
        width: "60%"
    })), (0, _reactDefault.default).createElement(Column, {
        numColumn: columnWidth[1]
    }, (0, _reactDefault.default).createElement(SkeletonText, {
        width: "80%"
    }), (0, _reactDefault.default).createElement(SkeletonText, {
        width: "30%"
    })), (0, _reactDefault.default).createElement(Column, {
        numColumn: columnWidth[2]
    }, (0, _reactDefault.default).createElement(SkeletonText, {
        width: "60%"
    })), (0, _reactDefault.default).createElement(Column, {
        numColumn: columnWidth[3]
    }, (0, _reactDefault.default).createElement(SkeletonText, {
        width: "60%"
    }))), (0, _reactDefault.default).createElement(Row, null, (0, _reactDefault.default).createElement(Column, {
        numColumn: columnWidth[0]
    }, (0, _reactDefault.default).createElement(SkeletonText, {
        width: "60%"
    })), (0, _reactDefault.default).createElement(Column, {
        numColumn: columnWidth[1]
    }, (0, _reactDefault.default).createElement(SkeletonText, {
        width: "80%"
    }), (0, _reactDefault.default).createElement(SkeletonText, {
        width: "30%"
    })), (0, _reactDefault.default).createElement(Column, {
        numColumn: columnWidth[2]
    }, (0, _reactDefault.default).createElement(SkeletonText, {
        width: "60%"
    })), (0, _reactDefault.default).createElement(Column, {
        numColumn: columnWidth[3]
    }, (0, _reactDefault.default).createElement(SkeletonText, {
        width: "60%"
    }))));
var Wrapper7 = (0, _theming.styled).div(({ inAddonPanel, theme })=>({
        height: inAddonPanel ? "100%" : "auto",
        display: "flex",
        border: inAddonPanel ? "none" : `1px solid ${theme.appBorderColor}`,
        borderRadius: inAddonPanel ? 0 : theme.appBorderRadius,
        padding: inAddonPanel ? 0 : 40,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        gap: 15,
        background: theme.background.content,
        boxShadow: "rgba(0, 0, 0, 0.10) 0 1px 3px 0"
    })), Content = (0, _theming.styled).div({
    display: "flex",
    flexDirection: "column",
    gap: 4,
    maxWidth: 415
}), Title2 = (0, _theming.styled).div(({ theme })=>({
        fontWeight: theme.typography.weight.bold,
        fontSize: theme.typography.size.s2 - 1,
        textAlign: "center",
        color: theme.textColor
    })), Description2 = (0, _theming.styled).div(({ theme })=>({
        fontWeight: theme.typography.weight.regular,
        fontSize: theme.typography.size.s2 - 1,
        textAlign: "center",
        color: theme.textMutedColor
    })), Links = (0, _theming.styled).div(({ theme })=>({
        display: "flex",
        fontSize: theme.typography.size.s2 - 1,
        gap: 25
    })), Divider = (0, _theming.styled).div(({ theme })=>({
        width: 1,
        height: 16,
        backgroundColor: theme.appBorderColor
    })), Empty = ({ inAddonPanel })=>{
    let [isLoading, setIsLoading] = (0, _react.useState)(!0);
    return (0, _react.useEffect)(()=>{
        let load = setTimeout(()=>{
            setIsLoading(!1);
        }, 100);
        return ()=>clearTimeout(load);
    }, []), isLoading ? null : (0, _reactDefault.default).createElement(Wrapper7, {
        inAddonPanel
    }, (0, _reactDefault.default).createElement(Content, null, (0, _reactDefault.default).createElement(Title2, null, inAddonPanel ? "Interactive story playground" : "Args table with interactive controls couldn't be auto-generated"), (0, _reactDefault.default).createElement(Description2, null, "Controls give you an easy to use interface to test your components. Set your story args and you'll see controls appearing here automatically.")), (0, _reactDefault.default).createElement(Links, null, inAddonPanel && (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement((0, _components.Link), {
        href: "https://youtu.be/0gOfS6K0x0E",
        target: "_blank",
        withArrow: !0
    }, (0, _reactDefault.default).createElement((0, _components.Icons), {
        icon: "video"
    }), " Watch 5m video"), (0, _reactDefault.default).createElement(Divider, null), (0, _reactDefault.default).createElement((0, _components.Link), {
        href: "https://storybook.js.org/docs/react/essentials/controls",
        target: "_blank",
        withArrow: !0
    }, "Read docs")), !inAddonPanel && (0, _reactDefault.default).createElement((0, _components.Link), {
        href: "https://storybook.js.org/docs/react/essentials/controls",
        target: "_blank",
        withArrow: !0
    }, "Learn how to set that up")));
};
var TableWrapper = (0, _theming.styled).table(({ theme, compact, inAddonPanel })=>({
        "&&": {
            borderSpacing: 0,
            color: theme.color.defaultText,
            "td, th": {
                padding: 0,
                border: "none",
                verticalAlign: "top",
                textOverflow: "ellipsis"
            },
            fontSize: theme.typography.size.s2 - 1,
            lineHeight: "20px",
            textAlign: "left",
            width: "100%",
            marginTop: inAddonPanel ? 0 : 25,
            marginBottom: inAddonPanel ? 0 : 40,
            "thead th:first-of-type, td:first-of-type": {
                width: "25%"
            },
            "th:first-of-type, td:first-of-type": {
                paddingLeft: 20
            },
            "th:nth-of-type(2), td:nth-of-type(2)": {
                ...compact ? null : {
                    width: "35%"
                }
            },
            "td:nth-of-type(3)": {
                ...compact ? null : {
                    width: "15%"
                }
            },
            "th:last-of-type, td:last-of-type": {
                paddingRight: 20,
                ...compact ? null : {
                    width: "25%"
                }
            },
            th: {
                color: theme.base === "light" ? (0, _polished.transparentize)(.25, theme.color.defaultText) : (0, _polished.transparentize)(.45, theme.color.defaultText),
                paddingTop: 10,
                paddingBottom: 10,
                paddingLeft: 15,
                paddingRight: 15
            },
            td: {
                paddingTop: "10px",
                paddingBottom: "10px",
                "&:not(:first-of-type)": {
                    paddingLeft: 15,
                    paddingRight: 15
                },
                "&:last-of-type": {
                    paddingRight: 20
                }
            },
            marginLeft: inAddonPanel ? 0 : 1,
            marginRight: inAddonPanel ? 0 : 1,
            tbody: {
                ...inAddonPanel ? null : {
                    filter: theme.base === "light" ? "drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.10))" : "drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.20))"
                },
                "> tr > *": {
                    background: theme.background.content,
                    borderTop: `1px solid ${theme.appBorderColor}`
                },
                ...inAddonPanel ? null : {
                    "> tr:first-of-type > *": {
                        borderBlockStart: `1px solid ${theme.appBorderColor}`
                    },
                    "> tr:last-of-type > *": {
                        borderBlockEnd: `1px solid ${theme.appBorderColor}`
                    },
                    "> tr > *:first-of-type": {
                        borderInlineStart: `1px solid ${theme.appBorderColor}`
                    },
                    "> tr > *:last-of-type": {
                        borderInlineEnd: `1px solid ${theme.appBorderColor}`
                    },
                    "> tr:first-of-type > td:first-of-type": {
                        borderTopLeftRadius: theme.appBorderRadius
                    },
                    "> tr:first-of-type > td:last-of-type": {
                        borderTopRightRadius: theme.appBorderRadius
                    },
                    "> tr:last-of-type > td:first-of-type": {
                        borderBottomLeftRadius: theme.appBorderRadius
                    },
                    "> tr:last-of-type > td:last-of-type": {
                        borderBottomRightRadius: theme.appBorderRadius
                    }
                }
            }
        }
    })), StyledIconButton = (0, _theming.styled)((0, _components.IconButton))(({ theme })=>({
        color: theme.barTextColor,
        margin: "-4px -12px -4px 0"
    })), ControlHeadingWrapper = (0, _theming.styled).span({
    display: "flex",
    justifyContent: "space-between"
});
var sortFns = {
    alpha: (a, b)=>a.name.localeCompare(b.name),
    requiredFirst: (a, b)=>+!!b.type?.required - +!!a.type?.required || a.name.localeCompare(b.name),
    none: void 0
}, groupRows = (rows, sort)=>{
    let sections = {
        ungrouped: [],
        ungroupedSubsections: {},
        sections: {}
    };
    if (!rows) return sections;
    Object.entries(rows).forEach(([key, row])=>{
        let { category, subcategory } = row?.table || {};
        if (category) {
            let section = sections.sections[category] || {
                ungrouped: [],
                subsections: {}
            };
            if (!subcategory) section.ungrouped.push({
                key,
                ...row
            });
            else {
                let subsection = section.subsections[subcategory] || [];
                subsection.push({
                    key,
                    ...row
                }), section.subsections[subcategory] = subsection;
            }
            sections.sections[category] = section;
        } else if (subcategory) {
            let subsection = sections.ungroupedSubsections[subcategory] || [];
            subsection.push({
                key,
                ...row
            }), sections.ungroupedSubsections[subcategory] = subsection;
        } else sections.ungrouped.push({
            key,
            ...row
        });
    });
    let sortFn = sortFns[sort], sortSubsection = (record)=>sortFn ? Object.keys(record).reduce((acc, cur)=>({
                ...acc,
                [cur]: record[cur].sort(sortFn)
            }), {}) : record;
    return {
        ungrouped: sections.ungrouped.sort(sortFn),
        ungroupedSubsections: sortSubsection(sections.ungroupedSubsections),
        sections: Object.keys(sections.sections).reduce((acc, cur)=>({
                ...acc,
                [cur]: {
                    ungrouped: sections.sections[cur].ungrouped.sort(sortFn),
                    subsections: sortSubsection(sections.sections[cur].subsections)
                }
            }), {})
    };
}, safeIncludeConditionalArg = (row, args, globals)=>{
    try {
        return (0, _csf.includeConditionalArg)(row, args, globals);
    } catch (err) {
        return (0, _clientLogger.once).warn(err.message), !1;
    }
}, ArgsTable = (props)=>{
    let { updateArgs, resetArgs, compact, inAddonPanel, initialExpandedArgs, sort = "none", isLoading } = props;
    if ("error" in props) {
        let { error } = props;
        return (0, _reactDefault.default).createElement(EmptyBlock, null, error, "\xA0", (0, _reactDefault.default).createElement((0, _components.Link), {
            href: "http://storybook.js.org/docs/",
            target: "_blank",
            withArrow: !0
        }, "Read the docs"));
    }
    if (isLoading) return (0, _reactDefault.default).createElement(Skeleton, null);
    let { rows, args, globals } = "rows" in props && props, groups = groupRows((0, _pickByJsDefault.default)(rows, (row)=>!row?.table?.disable && safeIncludeConditionalArg(row, args || {}, globals || {})), sort), hasNoUngrouped = groups.ungrouped.length === 0, hasNoSections = Object.entries(groups.sections).length === 0, hasNoUngroupedSubsections = Object.entries(groups.ungroupedSubsections).length === 0;
    if (hasNoUngrouped && hasNoSections && hasNoUngroupedSubsections) return (0, _reactDefault.default).createElement(Empty, {
        inAddonPanel
    });
    let colSpan = 1;
    updateArgs && (colSpan += 1), compact || (colSpan += 2);
    let expandable = Object.keys(groups.sections).length > 0, common = {
        updateArgs,
        compact,
        inAddonPanel,
        initialExpandedArgs
    };
    return (0, _reactDefault.default).createElement((0, _components.ResetWrapper), null, (0, _reactDefault.default).createElement(TableWrapper, {
        compact,
        inAddonPanel,
        className: "docblock-argstable sb-unstyled"
    }, (0, _reactDefault.default).createElement("thead", {
        className: "docblock-argstable-head"
    }, (0, _reactDefault.default).createElement("tr", null, (0, _reactDefault.default).createElement("th", null, (0, _reactDefault.default).createElement("span", null, "Name")), compact ? null : (0, _reactDefault.default).createElement("th", null, (0, _reactDefault.default).createElement("span", null, "Description")), compact ? null : (0, _reactDefault.default).createElement("th", null, (0, _reactDefault.default).createElement("span", null, "Default")), updateArgs ? (0, _reactDefault.default).createElement("th", null, (0, _reactDefault.default).createElement(ControlHeadingWrapper, null, "Control", " ", !isLoading && resetArgs && (0, _reactDefault.default).createElement(StyledIconButton, {
        onClick: ()=>resetArgs(),
        title: "Reset controls"
    }, (0, _reactDefault.default).createElement((0, _components.Icons), {
        icon: "undo",
        "aria-hidden": !0
    })))) : null)), (0, _reactDefault.default).createElement("tbody", {
        className: "docblock-argstable-body"
    }, groups.ungrouped.map((row)=>(0, _reactDefault.default).createElement(ArgRow, {
            key: row.key,
            row,
            arg: args && args[row.key],
            ...common
        })), Object.entries(groups.ungroupedSubsections).map(([subcategory, subsection])=>(0, _reactDefault.default).createElement(SectionRow, {
            key: subcategory,
            label: subcategory,
            level: "subsection",
            colSpan
        }, subsection.map((row)=>(0, _reactDefault.default).createElement(ArgRow, {
                key: row.key,
                row,
                arg: args && args[row.key],
                expandable,
                ...common
            })))), Object.entries(groups.sections).map(([category, section])=>(0, _reactDefault.default).createElement(SectionRow, {
            key: category,
            label: category,
            level: "section",
            colSpan
        }, section.ungrouped.map((row)=>(0, _reactDefault.default).createElement(ArgRow, {
                key: row.key,
                row,
                arg: args && args[row.key],
                ...common
            })), Object.entries(section.subsections).map(([subcategory, subsection])=>(0, _reactDefault.default).createElement(SectionRow, {
                key: subcategory,
                label: subcategory,
                level: "subsection",
                colSpan
            }, subsection.map((row)=>(0, _reactDefault.default).createElement(ArgRow, {
                    key: row.key,
                    row,
                    arg: args && args[row.key],
                    expandable,
                    ...common
                })))))))));
};
var TabbedArgsTable = ({ tabs, ...props })=>{
    let entries = Object.entries(tabs);
    return entries.length === 1 ? (0, _reactDefault.default).createElement(ArgsTable, {
        ...entries[0][1],
        ...props
    }) : (0, _reactDefault.default).createElement((0, _components.TabsState), null, entries.map((entry)=>{
        let [label, table] = entry, id = `prop_table_div_${label}`;
        return (0, _reactDefault.default).createElement("div", {
            key: id,
            id,
            title: label
        }, ({ active })=>active ? (0, _reactDefault.default).createElement(ArgsTable, {
                key: `prop_table_${label}`,
                ...table,
                ...props
            }) : null);
    }));
};
var Label4 = (0, _theming.styled).div(({ theme })=>({
        marginRight: 30,
        fontSize: `${theme.typography.size.s1}px`,
        color: theme.base === "light" ? (0, _polished.transparentize)(.4, theme.color.defaultText) : (0, _polished.transparentize)(.6, theme.color.defaultText)
    })), Sample = (0, _theming.styled).div({
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
}), TypeSpecimen = (0, _theming.styled).div({
    display: "flex",
    flexDirection: "row",
    alignItems: "baseline",
    "&:not(:last-child)": {
        marginBottom: "1rem"
    }
}), Wrapper8 = (0, _theming.styled).div((0, _components.withReset), ({ theme })=>({
        ...getBlockBackgroundStyle(theme),
        margin: "25px 0 40px",
        padding: "30px 20px"
    })), Typeset = ({ fontFamily, fontSizes, fontWeight, sampleText, ...props })=>(0, _reactDefault.default).createElement(Wrapper8, {
        ...props,
        className: "docblock-typeset sb-unstyled"
    }, fontSizes.map((size)=>(0, _reactDefault.default).createElement(TypeSpecimen, {
            key: size
        }, (0, _reactDefault.default).createElement(Label4, null, size), (0, _reactDefault.default).createElement(Sample, {
            style: {
                fontFamily,
                fontSize: size,
                fontWeight,
                lineHeight: 1.2
            }
        }, sampleText || "Was he a beast if music could move him so?"))));
var ItemTitle = (0, _theming.styled).div(({ theme })=>({
        fontWeight: theme.typography.weight.bold,
        color: theme.color.defaultText
    })), ItemSubtitle = (0, _theming.styled).div(({ theme })=>({
        color: theme.base === "light" ? (0, _polished.transparentize)(.2, theme.color.defaultText) : (0, _polished.transparentize)(.6, theme.color.defaultText)
    })), ItemDescription = (0, _theming.styled).div({
    flex: "0 0 30%",
    lineHeight: "20px",
    marginTop: 5
}), SwatchLabel = (0, _theming.styled).div(({ theme })=>({
        flex: 1,
        textAlign: "center",
        fontFamily: theme.typography.fonts.mono,
        fontSize: theme.typography.size.s1,
        lineHeight: 1,
        overflow: "hidden",
        color: theme.base === "light" ? (0, _polished.transparentize)(.4, theme.color.defaultText) : (0, _polished.transparentize)(.6, theme.color.defaultText),
        "> div": {
            display: "inline-block",
            overflow: "hidden",
            maxWidth: "100%",
            textOverflow: "ellipsis"
        },
        span: {
            display: "block",
            marginTop: 2
        }
    })), SwatchLabels = (0, _theming.styled).div({
    display: "flex",
    flexDirection: "row"
}), Swatch = (0, _theming.styled).div(({ background })=>({
        position: "relative",
        flex: 1,
        "&::before": {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background,
            content: '""'
        }
    })), SwatchColors = (0, _theming.styled).div(({ theme })=>({
        ...getBlockBackgroundStyle(theme),
        display: "flex",
        flexDirection: "row",
        height: 50,
        marginBottom: 5,
        overflow: "hidden",
        backgroundColor: "white",
        backgroundImage: "repeating-linear-gradient(-45deg, #ccc, #ccc 1px, #fff 1px, #fff 16px)",
        backgroundClip: "padding-box"
    })), SwatchSpecimen = (0, _theming.styled).div({
    display: "flex",
    flexDirection: "column",
    flex: 1,
    position: "relative",
    marginBottom: 30
}), Swatches = (0, _theming.styled).div({
    flex: 1,
    display: "flex",
    flexDirection: "row"
}), Item = (0, _theming.styled).div({
    display: "flex",
    alignItems: "flex-start"
}), ListName = (0, _theming.styled).div({
    flex: "0 0 30%"
}), ListSwatches = (0, _theming.styled).div({
    flex: 1
}), ListHeading = (0, _theming.styled).div(({ theme })=>({
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        paddingBottom: 20,
        fontWeight: theme.typography.weight.bold,
        color: theme.base === "light" ? (0, _polished.transparentize)(.4, theme.color.defaultText) : (0, _polished.transparentize)(.6, theme.color.defaultText)
    })), List = (0, _theming.styled).div(({ theme })=>({
        fontSize: theme.typography.size.s2,
        lineHeight: "20px",
        display: "flex",
        flexDirection: "column"
    }));
function renderSwatch(color, index) {
    return (0, _reactDefault.default).createElement(Swatch, {
        key: `${color}-${index}`,
        title: color,
        background: color
    });
}
function renderSwatchLabel(color, index, colorDescription) {
    return (0, _reactDefault.default).createElement(SwatchLabel, {
        key: `${color}-${index}`,
        title: color
    }, (0, _reactDefault.default).createElement("div", null, color, colorDescription && (0, _reactDefault.default).createElement("span", null, colorDescription)));
}
function renderSwatchSpecimen(colors) {
    return Array.isArray(colors) ? (0, _reactDefault.default).createElement(SwatchSpecimen, null, (0, _reactDefault.default).createElement(SwatchColors, null, colors.map((color, index)=>renderSwatch(color, index))), (0, _reactDefault.default).createElement(SwatchLabels, null, colors.map((color, index)=>renderSwatchLabel(color, index)))) : (0, _reactDefault.default).createElement(SwatchSpecimen, null, (0, _reactDefault.default).createElement(SwatchColors, null, Object.values(colors).map((color, index)=>renderSwatch(color, index))), (0, _reactDefault.default).createElement(SwatchLabels, null, Object.keys(colors).map((color, index)=>renderSwatchLabel(color, index, colors[color]))));
}
var ColorItem = ({ title, subtitle, colors })=>(0, _reactDefault.default).createElement(Item, null, (0, _reactDefault.default).createElement(ItemDescription, null, (0, _reactDefault.default).createElement(ItemTitle, null, title), (0, _reactDefault.default).createElement(ItemSubtitle, null, subtitle)), (0, _reactDefault.default).createElement(Swatches, null, renderSwatchSpecimen(colors))), ColorPalette = ({ children, ...props })=>(0, _reactDefault.default).createElement((0, _components.ResetWrapper), null, (0, _reactDefault.default).createElement(List, {
        ...props,
        className: "docblock-colorpalette sb-unstyled"
    }, (0, _reactDefault.default).createElement(ListHeading, null, (0, _reactDefault.default).createElement(ListName, null, "Name"), (0, _reactDefault.default).createElement(ListSwatches, null, "Swatches")), children));
var ItemLabel = (0, _theming.styled).div(({ theme })=>({
        fontFamily: theme.typography.fonts.base,
        fontSize: theme.typography.size.s2,
        color: theme.color.defaultText,
        marginLeft: 10,
        lineHeight: 1.2
    })), ItemSpecimen = (0, _theming.styled).div(({ theme })=>({
        ...getBlockBackgroundStyle(theme),
        overflow: "hidden",
        height: 40,
        width: 40,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flex: "none",
        "> img, > svg": {
            width: 20,
            height: 20
        }
    })), Item2 = (0, _theming.styled).div({
    display: "inline-flex",
    flexDirection: "row",
    alignItems: "center",
    flex: "0 1 calc(20% - 10px)",
    minWidth: 120,
    margin: "0px 10px 30px 0"
}), List2 = (0, _theming.styled).div({
    display: "flex",
    flexFlow: "row wrap"
}), IconItem = ({ name, children })=>(0, _reactDefault.default).createElement(Item2, null, (0, _reactDefault.default).createElement(ItemSpecimen, null, children), (0, _reactDefault.default).createElement(ItemLabel, null, name)), IconGallery = ({ children, ...props })=>(0, _reactDefault.default).createElement((0, _components.ResetWrapper), null, (0, _reactDefault.default).createElement(List2, {
        ...props,
        className: "docblock-icongallery sb-unstyled"
    }, children));
var anchorBlockIdFromId = (storyId)=>`anchor--${storyId}`, Anchor = ({ storyId, children })=>(0, _reactDefault.default).createElement("div", {
        id: anchorBlockIdFromId(storyId),
        className: "sb-anchor"
    }, children);
(0, _global.global) && (0, _global.global).__DOCS_CONTEXT__ === void 0 && ((0, _global.global).__DOCS_CONTEXT__ = (0, _react.createContext)(null), (0, _global.global).__DOCS_CONTEXT__.displayName = "DocsContext");
var DocsContext = (0, _global.global) ? (0, _global.global).__DOCS_CONTEXT__ : (0, _react.createContext)(null);
var useOf = (moduleExportOrType, validTypes)=>(0, _react.useContext)(DocsContext).resolveOf(moduleExportOrType, validTypes);
function extractComponentArgTypes(component, parameters) {
    let { extractArgTypes } = parameters.docs || {};
    if (!extractArgTypes) throw new Error("Args unsupported. See Args documentation for your framework.");
    return extractArgTypes(component);
}
function getArgTypesFromResolved(resolved, props) {
    if (resolved.type === "component") {
        let { component, projectAnnotations: { parameters: parameters2 } } = resolved;
        return {
            argTypes: extractComponentArgTypes(component, parameters2),
            parameters: parameters2
        };
    }
    if (resolved.type === "meta") {
        let { preparedMeta: { argTypes: argTypes2, parameters: parameters2 } } = resolved;
        return {
            argTypes: argTypes2,
            parameters: parameters2
        };
    }
    let { story: { argTypes, parameters } } = resolved;
    return {
        argTypes,
        parameters
    };
}
var ArgTypes = (props)=>{
    let { of } = props;
    if ("of" in props && of === void 0) throw new Error("Unexpected `of={undefined}`, did you mistype a CSF file reference?");
    let resolved = useOf(of || "meta"), { argTypes, parameters } = getArgTypesFromResolved(resolved), argTypesParameters = parameters.docs?.argTypes || {}, include = props.include ?? argTypesParameters.include, exclude = props.exclude ?? argTypesParameters.exclude, sort = props.sort ?? argTypesParameters.sort, filteredArgTypes = (0, _previewApi.filterArgTypes)(argTypes, include, exclude);
    return (0, _reactDefault.default).createElement(ArgsTable, {
        rows: filteredArgTypes,
        sort
    });
};
var PRIMARY_STORY = "^";
var titleCase = (str2)=>str2.split("-").map((part)=>part.charAt(0).toUpperCase() + part.slice(1)).join(""), getComponentName = (component)=>{
    if (component) return typeof component == "string" ? component.includes("-") ? titleCase(component) : component : component.__docgenInfo && component.__docgenInfo.displayName ? component.__docgenInfo.displayName : component.name;
};
function scrollToElement(element, block = "start") {
    element.scrollIntoView({
        behavior: "smooth",
        block,
        inline: "nearest"
    });
}
function useStory(storyId, context) {
    let stories = useStories([
        storyId
    ], context);
    return stories && stories[0];
}
function useStories(storyIds, context) {
    let [storiesById, setStories] = (0, _react.useState)({});
    return (0, _react.useEffect)(()=>{
        Promise.all(storyIds.map(async (storyId)=>{
            let story = await context.loadStory(storyId);
            setStories((current)=>current[storyId] === story ? current : {
                    ...current,
                    [storyId]: story
                });
        }));
    }), storyIds.map((storyId)=>{
        if (storiesById[storyId]) return storiesById[storyId];
        try {
            return context.storyById(storyId);
        } catch  {
            return null;
        }
    });
}
var useArgs = (storyId, context)=>{
    let storyContext = context.getStoryContext(context.storyById()), [args, setArgs] = (0, _react.useState)(storyContext.args);
    (0, _react.useEffect)(()=>{
        let cb = (changed)=>{
            changed.storyId === storyId && setArgs(changed.args);
        };
        return context.channel.on((0, _coreEvents.STORY_ARGS_UPDATED), cb), ()=>context.channel.off((0, _coreEvents.STORY_ARGS_UPDATED), cb);
    }, [
        storyId
    ]);
    let updateArgs = (0, _react.useCallback)((updatedArgs)=>context.channel.emit((0, _coreEvents.UPDATE_STORY_ARGS), {
            storyId,
            updatedArgs
        }), [
        storyId
    ]), resetArgs = (0, _react.useCallback)((argNames)=>context.channel.emit((0, _coreEvents.RESET_STORY_ARGS), {
            storyId,
            argNames
        }), [
        storyId
    ]);
    return [
        args,
        updateArgs,
        resetArgs
    ];
}, useGlobals = (context)=>{
    let storyContext = context.getStoryContext(context.storyById()), [globals, setGlobals] = (0, _react.useState)(storyContext.globals);
    return (0, _react.useEffect)(()=>{
        let cb = (changed)=>{
            setGlobals(changed.globals);
        };
        return context.channel.on((0, _coreEvents.GLOBALS_UPDATED), cb), ()=>context.channel.off((0, _coreEvents.GLOBALS_UPDATED), cb);
    }, []), [
        globals
    ];
}, extractComponentArgTypes2 = (component, parameters, include, exclude)=>{
    let { extractArgTypes } = parameters.docs || {};
    if (!extractArgTypes) throw new Error("Args unsupported. See Args documentation for your framework.");
    let argTypes = extractArgTypes(component);
    return argTypes = (0, _previewApi.filterArgTypes)(argTypes, include, exclude), argTypes;
}, isShortcut = (value2)=>value2 && [
        PRIMARY_STORY
    ].includes(value2), getComponent = (props = {}, component)=>{
    let { of } = props, { story } = props;
    if (isShortcut(of) || isShortcut(story)) return component || null;
    if (!of) throw new Error("No component found.");
    return of;
}, addComponentTabs = (tabs, components2, parameters, include, exclude, sort)=>({
        ...tabs,
        ...(0, _mapValuesJsDefault.default)(components2, (comp)=>({
                rows: extractComponentArgTypes2(comp, parameters, include, exclude),
                sort
            }))
    }), StoryTable = (props)=>{
    let context = (0, _react.useContext)(DocsContext), { story: storyName, component, subcomponents, showComponent, include, exclude, sort } = props;
    try {
        let storyId;
        switch(storyName){
            case PRIMARY_STORY:
                storyId = context.storyById().id;
                break;
            default:
                storyId = context.storyIdByName(storyName);
        }
        let story = useStory(storyId, context), [args, updateArgs, resetArgs] = useArgs(storyId, context), [globals] = useGlobals(context);
        if (!story) return (0, _reactDefault.default).createElement(ArgsTable, {
            isLoading: !0,
            updateArgs,
            resetArgs
        });
        let argTypes = (0, _previewApi.filterArgTypes)(story.argTypes, include, exclude), mainLabel = getComponentName(component) || "Story", tabs = {
            [mainLabel]: {
                rows: argTypes,
                args,
                globals,
                updateArgs,
                resetArgs
            }
        }, storyHasArgsWithControls = argTypes && Object.values(argTypes).find((v)=>!!v?.control);
        if (storyHasArgsWithControls || (updateArgs = null, resetArgs = null, tabs = {}), component && (!storyHasArgsWithControls || showComponent) && (tabs = addComponentTabs(tabs, {
            [mainLabel]: component
        }, story.parameters, include, exclude)), subcomponents) {
            if (Array.isArray(subcomponents)) throw new Error("Unexpected subcomponents array. Expected an object whose keys are tab labels and whose values are components.");
            tabs = addComponentTabs(tabs, subcomponents, story.parameters, include, exclude);
        }
        return (0, _reactDefault.default).createElement(TabbedArgsTable, {
            tabs,
            sort
        });
    } catch (err) {
        return (0, _reactDefault.default).createElement(ArgsTable, {
            error: err.message
        });
    }
}, ComponentsTable = (props)=>{
    let { components: components2, include, exclude, sort, parameters } = props, tabs = addComponentTabs({}, components2, parameters, include, exclude);
    return (0, _reactDefault.default).createElement(TabbedArgsTable, {
        tabs,
        sort
    });
}, ArgsTable2 = (props)=>{
    (0, _clientLogger.deprecate)((0, _tsDedentDefault.default)`The ArgsTable doc block is deprecated. Instead use the ArgTypes doc block for static tables or the Controls doc block for tables with controls.
    
  Please refer to the migration guide: https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#argstable-block
  `);
    let context = (0, _react.useContext)(DocsContext), parameters, component, subcomponents;
    try {
        ({ parameters, component, subcomponents } = context.storyById());
    } catch  {
        let { of } = props;
        if ("of" in props && of === void 0) throw new Error("Unexpected `of={undefined}`, did you mistype a CSF file reference?");
        ({ projectAnnotations: { parameters } } = context.resolveOf(of, [
            "component"
        ]));
    }
    let { include, exclude, components: components2, sort: sortProp } = props, { story: storyName } = props, sort = sortProp || parameters.controls?.sort, main = getComponent(props, component);
    if (storyName) return (0, _reactDefault.default).createElement(StoryTable, {
        ...props,
        component: main,
        subcomponents,
        sort
    });
    if (!components2 && !subcomponents) {
        let mainProps;
        try {
            mainProps = {
                rows: extractComponentArgTypes2(main, parameters, include, exclude)
            };
        } catch (err) {
            mainProps = {
                error: err.message
            };
        }
        return (0, _reactDefault.default).createElement(ArgsTable, {
            ...mainProps,
            sort
        });
    }
    if (components2) return (0, _reactDefault.default).createElement(ComponentsTable, {
        ...props,
        components: components2,
        sort,
        parameters
    });
    let mainLabel = getComponentName(main);
    return (0, _reactDefault.default).createElement(ComponentsTable, {
        ...props,
        components: {
            [mainLabel]: main,
            ...subcomponents
        },
        sort,
        parameters
    });
};
ArgsTable2.defaultProps = {
    of: PRIMARY_STORY
};
function argsHash(args) {
    return (0, _telejson.stringify)(args);
}
var SourceContext = (0, _react.createContext)({
    sources: {}
}), UNKNOWN_ARGS_HASH = "--unknown--", SourceContainer = ({ children, channel })=>{
    let [sources, setSources] = (0, _react.useState)({});
    return (0, _react.useEffect)(()=>{
        let handleSnippetRendered = (idOrEvent, inputSource = null, inputFormat = !1)=>{
            let { id, args, source, format: format2 } = typeof idOrEvent == "string" ? {
                id: idOrEvent,
                source: inputSource,
                format: inputFormat
            } : idOrEvent, hash = args ? argsHash(args) : UNKNOWN_ARGS_HASH;
            setSources((current)=>({
                    ...current,
                    [id]: {
                        ...current[id],
                        [hash]: {
                            code: source,
                            format: format2
                        }
                    }
                }));
        };
        return channel.on((0, _docsTools.SNIPPET_RENDERED), handleSnippetRendered), ()=>channel.off((0, _docsTools.SNIPPET_RENDERED), handleSnippetRendered);
    }, []), (0, _reactDefault.default).createElement(SourceContext.Provider, {
        value: {
            sources
        }
    }, children);
};
var SourceState = ((SourceState2)=>(SourceState2.OPEN = "open", SourceState2.CLOSED = "closed", SourceState2.NONE = "none", SourceState2))(SourceState || {}), getSourceState = (stories)=>{
    let states = stories.map((story)=>story.parameters.docs?.source?.state).filter(Boolean);
    return states.length === 0 ? "closed" : states[0];
}, getStorySource = (storyId, args, sourceContext)=>{
    let { sources } = sourceContext, sourceMap = sources?.[storyId];
    return sourceMap?.[argsHash(args)] || sourceMap?.[UNKNOWN_ARGS_HASH] || {
        code: ""
    };
}, getSnippet = ({ snippet, storyContext, typeFromProps, transformFromProps })=>{
    let { __isArgsStory: isArgsStory } = storyContext.parameters, sourceParameters = storyContext.parameters.docs?.source || {}, type = typeFromProps || sourceParameters.type || (0, _docsTools.SourceType).AUTO;
    if (sourceParameters.code !== void 0) return sourceParameters.code;
    let code = type === (0, _docsTools.SourceType).DYNAMIC || type === (0, _docsTools.SourceType).AUTO && snippet && isArgsStory ? snippet : sourceParameters.originalSource || "";
    return sourceParameters.transformSource && (0, _clientLogger.deprecate)((0, _tsDedentDefault.default)`The \`transformSource\` parameter at \`parameters.docs.source.transformSource\` is deprecated, please use \`parameters.docs.source.transform\` instead. 
    
    Please refer to the migration guide: https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#source-block
  `), storyContext.parameters.docs?.transformSource && (0, _clientLogger.deprecate)((0, _tsDedentDefault.default)`The \`transformSource\` parameter at \`parameters.docs.transformSource\` is deprecated, please use \`parameters.docs.source.transform\` instead. 
    
    Please refer to the migration guide: https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#source-block
  `), storyContext.parameters.jsx?.transformSource && (0, _clientLogger.deprecate)((0, _tsDedentDefault.default)`The \`transformSource\` parameter at \`parameters.jsx.transformSource\` is deprecated, please use \`parameters.docs.source.transform\` instead. 
    
    Please refer to the migration guide: https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#source-block
  `), (transformFromProps ?? sourceParameters.transform ?? sourceParameters.transformSource ?? storyContext.parameters.docs?.transformSource ?? storyContext.parameters.jsx?.transformSource)?.(code, storyContext) || code;
}, useSourceProps = (props, docsContext, sourceContext)=>{
    let storyIds = props.ids || (props.id ? [
        props.id
    ] : []), storiesFromIds = useStories(storyIds, docsContext), stories = storiesFromIds, { of } = props;
    if ("of" in props && of === void 0) throw new Error("Unexpected `of={undefined}`, did you mistype a CSF file reference?");
    if (of) stories = [
        docsContext.resolveOf(of, [
            "story"
        ]).story
    ];
    else if (stories.length === 0) try {
        stories = [
            docsContext.storyById()
        ];
    } catch  {}
    if (!storiesFromIds.every(Boolean)) return {
        error: "Oh no! The source is not available.",
        state: "none"
    };
    let sourceParameters = stories[0]?.parameters?.docs?.source || {}, { code } = props, format2 = props.format ?? sourceParameters.format, language = props.language ?? sourceParameters.language ?? "jsx", dark = props.dark ?? sourceParameters.dark ?? !1;
    code || (code = stories.map((story, index)=>{
        if (!story) return "";
        let storyContext = docsContext.getStoryContext(story), argsForSource = props.__forceInitialArgs ? storyContext.initialArgs : storyContext.unmappedArgs, source = getStorySource(story.id, argsForSource, sourceContext);
        return index === 0 && (format2 = source.format ?? story.parameters.docs?.source?.format ?? !1), getSnippet({
            snippet: source.code,
            storyContext: {
                ...storyContext,
                args: argsForSource
            },
            typeFromProps: props.type,
            transformFromProps: props.transform
        });
    }).join(`

`));
    let state = getSourceState(stories);
    return code ? {
        code,
        format: format2,
        language,
        dark,
        state
    } : {
        error: "Oh no! The source is not available.",
        state
    };
}, Source2 = (props)=>{
    props.id && (0, _clientLogger.deprecate)((0, _tsDedentDefault.default)`The \`id\` prop on Source is deprecated, please use the \`of\` prop instead to reference a story. 
    
    Please refer to the migration guide: https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#source-block
  `), props.ids && (0, _clientLogger.deprecate)((0, _tsDedentDefault.default)`The \`ids\` prop on Source is deprecated, please use the \`of\` prop instead to reference a story. 
    
    Please refer to the migration guide: https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#source-block
  `);
    let sourceContext = (0, _react.useContext)(SourceContext), docsContext = (0, _react.useContext)(DocsContext), { state, ...sourceProps } = useSourceProps(props, docsContext, sourceContext);
    return (0, _reactDefault.default).createElement(Source, {
        ...sourceProps
    });
};
var getStoryId2 = (props, context)=>{
    let { id, of, meta, story } = props;
    if ("of" in props && of === void 0) throw new Error("Unexpected `of={undefined}`, did you mistype a CSF file reference?");
    if (id) return (0, _clientLogger.deprecate)((0, _tsDedentDefault.default)`Referencing stories by \`id\` is deprecated, please use \`of\` instead. 
    
      Please refer to the migration guide: https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#story-block'`), id;
    let { name } = props;
    return name ? ((0, _clientLogger.deprecate)((0, _tsDedentDefault.default)`Referencing stories by \`name\` is deprecated, please use \`of\` instead. 
    
      Please refer to the migration guide: https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#story-block'`), context.storyIdByName(name)) : (story && (0, _clientLogger.deprecate)((0, _tsDedentDefault.default)`The \`story\` prop is deprecated, please export your stories from CSF files and reference them with \`of={}\`.

      Please refer to the migration guide: https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#story-block'`), meta && context.referenceMeta(meta, !1), context.resolveOf(of || story || "story", [
        "story"
    ]).story.id);
}, getStoryProps = (props, story, context)=>{
    let { parameters = {} } = story || {}, { docs = {} } = parameters, storyParameters = docs.story || {};
    if (docs.disable) return null;
    let { inlineStories, iframeHeight } = docs;
    typeof inlineStories < "u" && (0, _clientLogger.deprecate)((0, _tsDedentDefault.default)`The \`docs.inlineStories\` parameter is deprecated, use \`docs.story.inline\` instead. 
    
      Please refer to the migration guide: https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#autodocs-changes'
    `);
    let inline = props.inline ?? storyParameters.inline ?? inlineStories ?? !1;
    if (typeof iframeHeight < "u" && (0, _clientLogger.deprecate)((0, _tsDedentDefault.default)`The \`docs.iframeHeight\` parameter is deprecated, use \`docs.story.iframeHeight\` instead. 
    
      Please refer to the migration guide: https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#autodocs-changes'
    `), inline) {
        let height2 = props.height ?? storyParameters.height, autoplay = props.autoplay ?? storyParameters.autoplay ?? !1;
        return {
            story,
            inline: !0,
            height: height2,
            autoplay,
            forceInitialArgs: !!props.__forceInitialArgs,
            primary: !!props.__primary,
            renderStoryToElement: context.renderStoryToElement
        };
    }
    let height = props.height ?? storyParameters.height ?? storyParameters.iframeHeight ?? iframeHeight ?? "100px";
    return {
        story,
        inline: !1,
        height,
        primary: !!props.__primary
    };
}, Story2 = (props = {
    __forceInitialArgs: !1,
    __primary: !1
})=>{
    let context = (0, _react.useContext)(DocsContext), storyId = getStoryId2(props, context), story = useStory(storyId, context);
    if (!story) return (0, _reactDefault.default).createElement(StorySkeleton, null);
    let storyProps = getStoryProps(props, story, context);
    return storyProps ? (0, _reactDefault.default).createElement(Story, {
        ...storyProps
    }) : null;
};
var useDeprecatedPreviewProps = ({ withSource, mdxSource, children, layout: layoutProp, ...props }, docsContext, sourceContext)=>{
    let storyIds = (0, _react.Children).toArray(children).filter((c)=>c.props && (c.props.id || c.props.name || c.props.of)).map((c)=>getStoryId2(c.props, docsContext)), stories = useStories(storyIds, docsContext), isLoading = stories.some((s)=>!s), sourceProps = useSourceProps({
        ...mdxSource ? {
            code: decodeURI(mdxSource)
        } : {
            ids: storyIds
        },
        ...props.of && {
            of: props.of
        }
    }, docsContext, sourceContext);
    if (withSource === "none") return {
        isLoading,
        previewProps: props
    };
    let layout = layoutProp;
    return (0, _react.Children).forEach(children, (child)=>{
        layout || (layout = child?.props?.parameters?.layout);
    }), stories.forEach((story)=>{
        layout || !story || (layout = story?.parameters.layout ?? story.parameters.docs?.canvas?.layout);
    }), {
        isLoading,
        previewProps: {
            ...props,
            layout: layout ?? "padded",
            withSource: sourceProps,
            isExpanded: (withSource || sourceProps.state) === "open"
        }
    };
}, Canvas = (props)=>{
    let docsContext = (0, _react.useContext)(DocsContext), sourceContext = (0, _react.useContext)(SourceContext), { children, of, source } = props;
    if ("of" in props && of === void 0) throw new Error("Unexpected `of={undefined}`, did you mistype a CSF file reference?");
    let { isLoading, previewProps } = useDeprecatedPreviewProps(props, docsContext, sourceContext), story, sourceProps, hookError;
    try {
        ({ story } = useOf(of || "story", [
            "story"
        ]));
    } catch (error) {
        children || (hookError = error);
    }
    try {
        sourceProps = useSourceProps({
            ...source,
            ...of && {
                of
            }
        }, docsContext, sourceContext);
    } catch (error) {
        children || (hookError = error);
    }
    if (hookError) throw hookError;
    if (props.withSource && (0, _clientLogger.deprecate)((0, _tsDedentDefault.default)`Setting source state with \`withSource\` is deprecated, please use \`sourceState\` with 'hidden', 'shown' or 'none' instead. 
    
    Please refer to the migration guide: https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#canvas-block
    `), props.mdxSource && (0, _clientLogger.deprecate)((0, _tsDedentDefault.default)`Setting source code with \`mdxSource\` is deprecated, please use source={{code: '...'}} instead. 
    
    Please refer to the migration guide: https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#canvas-block
    `), (props.isColumn !== void 0 || props.columns !== void 0) && (0, _clientLogger.deprecate)((0, _tsDedentDefault.default)`\`isColumn\` and \`columns\` props are deprecated as the Canvas block now only supports showing a single story. 
    
    Please refer to the migration guide: https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#canvas-block
    `), children) return (0, _clientLogger.deprecate)((0, _tsDedentDefault.default)`Passing children to Canvas is deprecated, please use the \`of\` prop instead to reference a story. 
    
    Please refer to the migration guide: https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#canvas-block
  `), isLoading ? (0, _reactDefault.default).createElement(PreviewSkeleton, null) : (0, _reactDefault.default).createElement(Preview, {
        ...previewProps
    }, children);
    let layout = props.layout ?? story.parameters.layout ?? story.parameters.docs?.canvas?.layout ?? "padded", withToolbar = props.withToolbar ?? story.parameters.docs?.canvas?.withToolbar ?? !1, additionalActions = props.additionalActions ?? story.parameters.docs?.canvas?.additionalActions, sourceState = props.sourceState ?? story.parameters.docs?.canvas?.sourceState ?? "hidden", className = props.className ?? story.parameters.docs?.canvas?.className;
    return (0, _reactDefault.default).createElement(Preview, {
        withSource: sourceState === "none" ? void 0 : sourceProps,
        isExpanded: sourceState === "shown",
        withToolbar,
        additionalActions,
        className,
        layout
    }, (0, _reactDefault.default).createElement(Story2, {
        of: of || story.moduleExport,
        meta: props.meta,
        ...props.story
    }));
};
var useGlobals2 = (story, context)=>{
    let storyContext = context.getStoryContext(story), [globals, setGlobals] = (0, _react.useState)(storyContext.globals);
    return (0, _react.useEffect)(()=>{
        let onGlobalsUpdated = (changed)=>{
            setGlobals(changed.globals);
        };
        return context.channel.on((0, _coreEvents.GLOBALS_UPDATED), onGlobalsUpdated), ()=>context.channel.off((0, _coreEvents.GLOBALS_UPDATED), onGlobalsUpdated);
    }, [
        context.channel
    ]), [
        globals
    ];
};
var useArgs2 = (story, context)=>{
    let result = useArgsIfDefined(story, context);
    if (!result) throw new Error("No result when story was defined");
    return result;
}, useArgsIfDefined = (story, context)=>{
    let storyContext = story ? context.getStoryContext(story) : {
        args: {}
    }, { id: storyId } = story || {
        id: "none"
    }, [args, setArgs] = (0, _react.useState)(storyContext.args);
    (0, _react.useEffect)(()=>{
        let onArgsUpdated = (changed)=>{
            changed.storyId === storyId && setArgs(changed.args);
        };
        return context.channel.on((0, _coreEvents.STORY_ARGS_UPDATED), onArgsUpdated), ()=>context.channel.off((0, _coreEvents.STORY_ARGS_UPDATED), onArgsUpdated);
    }, [
        storyId,
        context.channel
    ]);
    let updateArgs = (0, _react.useCallback)((updatedArgs)=>context.channel.emit((0, _coreEvents.UPDATE_STORY_ARGS), {
            storyId,
            updatedArgs
        }), [
        storyId,
        context.channel
    ]), resetArgs = (0, _react.useCallback)((argNames)=>context.channel.emit((0, _coreEvents.RESET_STORY_ARGS), {
            storyId,
            argNames
        }), [
        storyId,
        context.channel
    ]);
    return story && [
        args,
        updateArgs,
        resetArgs
    ];
};
var Controls3 = (props)=>{
    let { of } = props;
    if ("of" in props && of === void 0) throw new Error("Unexpected `of={undefined}`, did you mistype a CSF file reference?");
    let context = (0, _react.useContext)(DocsContext), { story } = context.resolveOf(of || "story", [
        "story"
    ]), { parameters, argTypes } = story, controlsParameters = parameters.docs?.controls || {}, include = props.include ?? controlsParameters.include, exclude = props.exclude ?? controlsParameters.exclude, sort = props.sort ?? controlsParameters.sort, [args, updateArgs, resetArgs] = useArgs2(story, context), [globals] = useGlobals2(story, context), filteredArgTypes = (0, _previewApi.filterArgTypes)(argTypes, include, exclude);
    return (0, _reactDefault.default).createElement(ArgsTable, {
        rows: filteredArgTypes,
        args,
        globals,
        updateArgs,
        resetArgs,
        sort
    });
};
var { document: document2 } = (0, _global.global), assertIsFn = (val)=>{
    if (typeof val != "function") throw new Error(`Expected story function, got: ${val}`);
    return val;
}, AddContext = (props)=>{
    let { children, ...rest } = props, parentContext = (0, _reactDefault.default).useContext(DocsContext);
    return (0, _reactDefault.default).createElement(DocsContext.Provider, {
        value: {
            ...parentContext,
            ...rest
        }
    }, children);
}, CodeOrSourceMdx = ({ className, children, ...rest })=>{
    if (typeof className != "string" && (typeof children != "string" || !children.match(/[\n\r]/g))) return (0, _reactDefault.default).createElement((0, _components.Code), null, children);
    let language = className && className.split("-");
    return (0, _reactDefault.default).createElement(Source, {
        language: language && language[1] || "plaintext",
        format: !1,
        code: children,
        ...rest
    });
};
function navigate(context, url) {
    context.channel.emit((0, _coreEvents.NAVIGATE_URL), url);
}
var A = (0, _components.components).a, AnchorInPage = ({ hash, children })=>{
    let context = (0, _react.useContext)(DocsContext);
    return (0, _reactDefault.default).createElement(A, {
        href: hash,
        target: "_self",
        onClick: (event)=>{
            let id = hash.substring(1);
            document2.getElementById(id) && navigate(context, hash);
        }
    }, children);
}, AnchorMdx = (props)=>{
    let { href, target, children, ...rest } = props, context = (0, _react.useContext)(DocsContext);
    if (href) {
        if (href.startsWith("#")) return (0, _reactDefault.default).createElement(AnchorInPage, {
            hash: href
        }, children);
        if (target !== "_blank" && !href.startsWith("https://")) return (0, _reactDefault.default).createElement(A, {
            href,
            onClick: (event)=>{
                event.button === 0 && !event.altKey && !event.ctrlKey && !event.metaKey && !event.shiftKey && (event.preventDefault(), navigate(context, event.currentTarget.getAttribute("href")));
            },
            target,
            ...rest
        }, children);
    }
    return (0, _reactDefault.default).createElement(A, {
        ...props
    });
}, SUPPORTED_MDX_HEADERS = [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
], OcticonHeaders = SUPPORTED_MDX_HEADERS.reduce((acc, headerType)=>({
        ...acc,
        [headerType]: (0, _theming.styled)(headerType)({
            "& svg": {
                position: "relative",
                top: "-0.1em",
                visibility: "hidden"
            },
            "&:hover svg": {
                visibility: "visible"
            }
        })
    }), {}), OcticonAnchor = (0, _theming.styled).a(()=>({
        float: "left",
        lineHeight: "inherit",
        paddingRight: "10px",
        marginLeft: "-24px",
        color: "inherit"
    })), HeaderWithOcticonAnchor = ({ as, id, children, ...rest })=>{
    let context = (0, _react.useContext)(DocsContext), OcticonHeader = OcticonHeaders[as], hash = `#${id}`;
    return (0, _reactDefault.default).createElement(OcticonHeader, {
        id,
        ...rest
    }, (0, _reactDefault.default).createElement(OcticonAnchor, {
        "aria-hidden": "true",
        href: hash,
        tabIndex: -1,
        target: "_self",
        onClick: (event)=>{
            document2.getElementById(id) && navigate(context, hash);
        }
    }, (0, _reactDefault.default).createElement((0, _components.Icons), {
        icon: "link"
    })), children);
}, HeaderMdx = (props)=>{
    let { as, id, children, ...rest } = props;
    if (id) return (0, _reactDefault.default).createElement(HeaderWithOcticonAnchor, {
        as,
        id,
        ...rest
    }, children);
    let Component4 = as, { as: omittedAs, ...withoutAs } = props;
    return (0, _reactDefault.default).createElement(Component4, {
        ...(0, _components.nameSpaceClassNames)(withoutAs, as)
    });
}, HeadersMdx = SUPPORTED_MDX_HEADERS.reduce((acc, headerType)=>({
        ...acc,
        [headerType]: (props)=>(0, _reactDefault.default).createElement(HeaderMdx, {
                as: headerType,
                ...props
            })
    }), {});
var Markdown2 = (props)=>{
    if (!props.children) return null;
    if (typeof props.children != "string") throw new Error((0, _tsDedentDefault.default)`The Markdown block only accepts children as a single string, but children were of type: '${typeof props.children}'
        This is often caused by not wrapping the child in a template string.
        
        This is invalid:
        <Markdown>
          # Some heading
          A paragraph
        </Markdown>

        Instead do:
        <Markdown>
        {\`
          # Some heading
          A paragraph
        \`}
        </Markdown>
      `);
    return (0, _reactDefault.default).createElement((0, _markdownToJsxDefault.default), {
        ...props,
        options: {
            forceBlock: !0,
            overrides: {
                code: CodeOrSourceMdx,
                a: AnchorMdx,
                ...HeadersMdx,
                ...props?.options?.overrides
            },
            ...props?.options
        }
    });
};
var DescriptionType = ((DescriptionType2)=>(DescriptionType2.INFO = "info", DescriptionType2.NOTES = "notes", DescriptionType2.DOCGEN = "docgen", DescriptionType2.AUTO = "auto", DescriptionType2))(DescriptionType || {}), DEPRECATION_MIGRATION_LINK = "https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#description-block-parametersnotes-and-parametersinfo", getNotes = (notes)=>notes && (typeof notes == "string" ? notes : (0, _docsTools.str)(notes.markdown) || (0, _docsTools.str)(notes.text)), getInfo = (info)=>info && (typeof info == "string" ? info : (0, _docsTools.str)(info.text)), noDescription = (component)=>null, getDescriptionFromResolvedOf = (resolvedOf)=>{
    switch(resolvedOf.type){
        case "story":
            return resolvedOf.story.parameters.docs?.description?.story || null;
        case "meta":
            {
                let { parameters, component } = resolvedOf.preparedMeta, metaDescription = parameters.docs?.description?.component;
                return metaDescription || parameters.docs?.extractComponentDescription?.(component, {
                    component,
                    parameters
                }) || null;
            }
        case "component":
            {
                let { component, projectAnnotations: { parameters } } = resolvedOf;
                return parameters.docs?.extractComponentDescription?.(component, {
                    component,
                    parameters
                }) || null;
            }
        default:
            throw new Error(`Unrecognized module type resolved from 'useOf', got: ${resolvedOf.type}`);
    }
}, getDescriptionFromDeprecatedProps = ({ type, markdown, children }, { storyById })=>{
    let { component, parameters } = storyById();
    if (children || markdown) return children || markdown;
    let { notes, info, docs } = parameters;
    (notes || info) && (0, _clientLogger.deprecate)(`Using 'parameters.notes' or 'parameters.info' properties to describe stories is deprecated. See ${DEPRECATION_MIGRATION_LINK}`);
    let { extractComponentDescription = noDescription, description } = docs || {}, componentDescriptionParameter = description?.component;
    if (componentDescriptionParameter) return componentDescriptionParameter;
    switch(type){
        case "info":
            return getInfo(info);
        case "notes":
            return getNotes(notes);
        case "docgen":
        case "auto":
        default:
            return extractComponentDescription(component, {
                component,
                ...parameters
            });
    }
}, DescriptionContainer = (props)=>{
    let { of, type, markdown: markdownProp, children } = props;
    if ("of" in props && of === void 0) throw new Error("Unexpected `of={undefined}`, did you mistype a CSF file reference?");
    let context = (0, _react.useContext)(DocsContext), resolvedOf = useOf(of || "meta"), markdown;
    return type || markdownProp || children ? markdown = getDescriptionFromDeprecatedProps(props, context) : markdown = getDescriptionFromResolvedOf(resolvedOf), type && (0, _clientLogger.deprecate)(`Manually specifying description type is deprecated. See ${DEPRECATION_MIGRATION_LINK}`), markdownProp && (0, _clientLogger.deprecate)(`The 'markdown' prop on the Description block is deprecated. See ${DEPRECATION_MIGRATION_LINK}`), children && (0, _clientLogger.deprecate)(`The 'children' prop on the Description block is deprecated. See ${DEPRECATION_MIGRATION_LINK}`), markdown ? (0, _reactDefault.default).createElement(Markdown2, null, markdown) : null;
};
var Wrapper9 = (0, _theming.styled).div(({ theme })=>({
        width: "10rem",
        "@media (max-width: 768px)": {
            display: "none"
        }
    })), Content2 = (0, _theming.styled).div(({ theme })=>({
        position: "fixed",
        bottom: 0,
        top: 0,
        width: "10rem",
        paddingTop: "4rem",
        paddingBottom: "2rem",
        overflowY: "auto",
        fontFamily: theme.typography.fonts.base,
        fontSize: theme.typography.size.s2,
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
        WebkitOverflowScrolling: "touch",
        "& *": {
            boxSizing: "border-box"
        },
        "& > .toc-wrapper > .toc-list": {
            paddingLeft: 0,
            borderLeft: `solid 2px ${theme.color.mediumlight}`,
            ".toc-list": {
                paddingLeft: 0,
                borderLeft: `solid 2px ${theme.color.mediumlight}`,
                ".toc-list": {
                    paddingLeft: 0,
                    borderLeft: `solid 2px ${theme.color.mediumlight}`
                }
            }
        },
        "& .toc-list-item": {
            position: "relative",
            listStyleType: "none",
            marginLeft: 20,
            paddingTop: 3,
            paddingBottom: 3
        },
        "& .toc-list-item::before": {
            content: '""',
            position: "absolute",
            height: "100%",
            top: 0,
            left: 0,
            transform: "translateX(calc(-2px - 20px))",
            borderLeft: `solid 2px ${theme.color.mediumdark}`,
            opacity: 0,
            transition: "opacity 0.2s"
        },
        "& .toc-list-item.is-active-li::before": {
            opacity: 1
        },
        "& .toc-list-item > a": {
            color: theme.color.defaultText,
            textDecoration: "none"
        },
        "& .toc-list-item.is-active-li > a": {
            fontWeight: 600,
            color: theme.color.secondary,
            textDecoration: "none"
        }
    })), Heading = (0, _theming.styled).p(({ theme })=>({
        fontWeight: 600,
        fontSize: "0.875em",
        color: theme.textColor,
        textTransform: "uppercase",
        marginBottom: 10
    })), OptionalTitle = ({ title })=>title === null ? null : typeof title == "string" ? (0, _reactDefault.default).createElement(Heading, null, title) : title, TableOfContents = ({ title, disable, headingSelector, contentsSelector, ignoreSelector, unsafeTocbotOptions })=>((0, _react.useEffect)(()=>{
        let configuration = {
            tocSelector: ".toc-wrapper",
            contentSelector: contentsSelector ?? ".sbdocs-content",
            headingSelector: headingSelector ?? "h3",
            ignoreSelector: ignoreSelector ?? ".docs-story *, .skip-toc",
            headingsOffset: 40,
            scrollSmoothOffset: -40,
            orderedList: !1,
            onClick: ()=>!1,
            ...unsafeTocbotOptions
        }, timeout = setTimeout(()=>_tocbot.init(configuration), 100);
        return ()=>{
            clearTimeout(timeout), _tocbot.destroy();
        };
    }, [
        disable
    ]), (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement(Wrapper9, null, disable ? null : (0, _reactDefault.default).createElement(Content2, null, (0, _reactDefault.default).createElement(OptionalTitle, {
        title: title || null
    }), (0, _reactDefault.default).createElement("div", {
        className: "toc-wrapper"
    })))));
var { document: document3, window: globalWindow3 } = (0, _global.global), DocsContainer = ({ context, theme, children })=>{
    let toc;
    try {
        toc = context.resolveOf("meta", [
            "meta"
        ]).preparedMeta.parameters?.docs?.toc;
    } catch  {
        toc = context?.projectAnnotations?.parameters?.docs?.toc;
    }
    return (0, _react.useEffect)(()=>{
        let url;
        try {
            if (url = new URL(globalWindow3.parent.location.toString()), url.hash) {
                let element = document3.getElementById(url.hash.substring(1));
                element && setTimeout(()=>{
                    scrollToElement(element);
                }, 200);
            }
        } catch  {}
    }), (0, _reactDefault.default).createElement(DocsContext.Provider, {
        value: context
    }, (0, _reactDefault.default).createElement(SourceContainer, {
        channel: context.channel
    }, (0, _reactDefault.default).createElement((0, _theming.ThemeProvider), {
        theme: (0, _theming.ensure)(theme)
    }, (0, _reactDefault.default).createElement(DocsPageWrapper, {
        toc: toc ? (0, _reactDefault.default).createElement(TableOfContents, {
            className: "sbdocs sbdocs-toc--custom",
            ...toc
        }) : null
    }, children))));
};
var STORY_KIND_PATH_SEPARATOR = /\s*\/\s*/, extractTitle = (title)=>{
    let groups = title.trim().split(STORY_KIND_PATH_SEPARATOR);
    return groups && groups[groups.length - 1] || title;
}, Title3 = ({ children })=>{
    let context = (0, _react.useContext)(DocsContext), content = children || extractTitle(context.storyById().title);
    return content ? (0, _reactDefault.default).createElement(Title, {
        className: "sbdocs-title sb-unstyled"
    }, content) : null;
};
var Subtitle2 = ({ children })=>{
    let docsContext = (0, _react.useContext)(DocsContext), content = children || docsContext.storyById().parameters?.componentSubtitle;
    return content ? (0, _reactDefault.default).createElement(Subtitle, {
        className: "sbdocs-subtitle sb-unstyled"
    }, content) : null;
};
var Subheading = ({ children, disableAnchor })=>{
    if (disableAnchor || typeof children != "string") return (0, _reactDefault.default).createElement((0, _components.H3), null, children);
    let tagID = children.toLowerCase().replace(/[^a-z0-9]/gi, "-");
    return (0, _reactDefault.default).createElement(HeaderMdx, {
        as: "h3",
        id: tagID
    }, children);
};
var DocsStory = ({ of, expanded = !0, withToolbar: withToolbarProp = !1, __forceInitialArgs = !1, __primary = !1 })=>{
    let { story } = useOf(of || "story", [
        "story"
    ]), withToolbar = story.parameters.docs?.canvas?.withToolbar ?? withToolbarProp;
    return (0, _reactDefault.default).createElement(Anchor, {
        storyId: story.id
    }, expanded && (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement(Subheading, null, story.name), (0, _reactDefault.default).createElement(DescriptionContainer, {
        of
    })), (0, _reactDefault.default).createElement(Canvas, {
        of,
        withToolbar,
        story: {
            __forceInitialArgs,
            __primary
        },
        source: {
            __forceInitialArgs
        }
    }));
};
var Primary = (props)=>{
    let { name, of } = props;
    if ("of" in props && of === void 0) throw new Error("Unexpected `of={undefined}`, did you mistype a CSF file reference?");
    let docsContext = (0, _react.useContext)(DocsContext), story;
    if (of && (story = useOf(of || "meta", [
        "meta"
    ]).csfFile.stories[0] || null), !story) {
        let storyId = name && docsContext.storyIdByName(name);
        story = docsContext.storyById(storyId);
    }
    return name && (0, _clientLogger.deprecate)((0, _tsDedentDefault.default)`\`name\` prop is deprecated on the Primary block.
    The Primary block should only be used to render the primary story, which is automatically found.
    `), story ? (0, _reactDefault.default).createElement(DocsStory, {
        of: story.moduleExport,
        expanded: !1,
        __primary: !0,
        withToolbar: !0
    }) : null;
};
var Heading2 = ({ children, disableAnchor, ...props })=>{
    if (disableAnchor || typeof children != "string") return (0, _reactDefault.default).createElement((0, _components.H2), null, children);
    let tagID = children.toLowerCase().replace(/[^a-z0-9]/gi, "-");
    return (0, _reactDefault.default).createElement(HeaderMdx, {
        as: "h2",
        id: tagID,
        ...props
    }, children);
};
var StyledHeading = (0, _theming.styled)(Heading2)(({ theme })=>({
        fontSize: `${theme.typography.size.s2 - 1}px`,
        fontWeight: theme.typography.weight.bold,
        lineHeight: "16px",
        letterSpacing: "0.35em",
        textTransform: "uppercase",
        color: theme.textMutedColor,
        border: 0,
        marginBottom: "12px",
        "&:first-of-type": {
            marginTop: "56px"
        }
    })), Stories = ({ title = "Stories", includePrimary = !0 })=>{
    let { componentStories } = (0, _react.useContext)(DocsContext), stories = componentStories().filter((story)=>!story.parameters?.docs?.disable);
    return includePrimary || (stories = stories.slice(1)), !stories || stories.length === 0 ? null : (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement(StyledHeading, null, title), stories.map((story)=>story && (0, _reactDefault.default).createElement(DocsStory, {
            key: story.id,
            of: story.moduleExport,
            expanded: !0,
            __forceInitialArgs: !0
        })));
};
var DocsPage = ()=>{
    let resolvedOf = useOf("meta", [
        "meta"
    ]), { stories } = resolvedOf.csfFile, isSingleStory = Object.keys(stories).length === 1;
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement(Title3, null), (0, _reactDefault.default).createElement(Subtitle2, null), (0, _reactDefault.default).createElement(DescriptionContainer, {
        of: "meta"
    }), isSingleStory ? (0, _reactDefault.default).createElement(DescriptionContainer, {
        of: "story"
    }) : null, (0, _reactDefault.default).createElement(Primary, null), (0, _reactDefault.default).createElement(Controls3, null), isSingleStory ? null : (0, _reactDefault.default).createElement(Stories, null));
};
function Docs({ context, docsParameter }) {
    let Container = docsParameter.container || DocsContainer, Page = docsParameter.page || DocsPage;
    return (0, _reactDefault.default).createElement(Container, {
        context,
        theme: docsParameter.theme
    }, (0, _reactDefault.default).createElement(Page, null));
}
var ExternalDocsContext = class extends (0, _previewApi.DocsContext) {
    constructor(channel, store, renderStoryToElement, processMetaExports){
        super(channel, store, renderStoryToElement, []);
        this.channel = channel;
        this.store = store;
        this.renderStoryToElement = renderStoryToElement;
        this.processMetaExports = processMetaExports;
        this.referenceMeta = (metaExports, attach)=>{
            let csfFile = this.processMetaExports(metaExports);
            this.referenceCSFFile(csfFile), super.referenceMeta(metaExports, attach);
        };
    }
};
var ConstantMap = class {
    constructor(prefix){
        this.prefix = prefix;
        this.entries = new Map;
    }
    get(key) {
        return this.entries.has(key) || this.entries.set(key, `${this.prefix}${this.entries.size}`), this.entries.get(key);
    }
}, ExternalPreview = class extends (0, _previewApi.Preview) {
    constructor(projectAnnotations){
        super(new (0, _channels.Channel)({}));
        this.projectAnnotations = projectAnnotations;
        this.importPaths = new ConstantMap("./importPath/");
        this.titles = new ConstantMap("title-");
        this.storyIndex = {
            v: 4,
            entries: {}
        };
        this.moduleExportsByImportPath = {};
        this.processMetaExports = (metaExports)=>{
            let importPath = this.importPaths.get(metaExports);
            this.moduleExportsByImportPath[importPath] = metaExports;
            let title = metaExports.default.title || this.titles.get(metaExports), csfFile = this.storyStore.processCSFFileWithCache(metaExports, importPath, title);
            return Object.values(csfFile.stories).forEach(({ id, name })=>{
                this.storyIndex.entries[id] = {
                    id,
                    importPath,
                    title,
                    name,
                    type: "story"
                };
            }), this.onStoriesChanged({
                storyIndex: this.storyIndex
            }), csfFile;
        };
        this.docsContext = ()=>new ExternalDocsContext(this.channel, this.storyStore, this.renderStoryToElement.bind(this), this.processMetaExports.bind(this));
        this.initialize({
            getStoryIndex: ()=>this.storyIndex,
            importFn: (path)=>Promise.resolve(this.moduleExportsByImportPath[path]),
            getProjectAnnotations: ()=>(0, _previewApi.composeConfigs)([
                    {
                        parameters: {
                            docs: {
                                story: {
                                    inline: !0
                                }
                            }
                        }
                    },
                    this.projectAnnotations
                ])
        });
    }
};
function usePreview(projectAnnotations) {
    let previewRef = (0, _react.useRef)();
    return previewRef.current || (previewRef.current = new ExternalPreview(projectAnnotations)), previewRef.current;
}
function ExternalDocs({ projectAnnotationsList, children }) {
    let projectAnnotations = (0, _previewApi.composeConfigs)(projectAnnotationsList), preview2 = usePreview(projectAnnotations), docsParameter = {
        ...projectAnnotations.parameters?.docs,
        page: ()=>children
    };
    return (0, _reactDefault.default).createElement(Docs, {
        docsParameter,
        context: preview2.docsContext()
    });
}
var preview, ExternalDocsContainer = ({ projectAnnotations, children })=>(preview || (preview = new ExternalPreview(projectAnnotations)), (0, _reactDefault.default).createElement(DocsContext.Provider, {
        value: preview.docsContext()
    }, (0, _reactDefault.default).createElement((0, _theming.ThemeProvider), {
        theme: (0, _theming.ensure)((0, _theming.themes).light)
    }, children)));
var Meta = ({ of })=>{
    let context = (0, _react.useContext)(DocsContext);
    of && context.referenceMeta(of, !0);
    try {
        let primary = context.storyById();
        return (0, _reactDefault.default).createElement(Anchor, {
            storyId: primary.id
        });
    } catch  {
        return null;
    }
};
var Unstyled = (props)=>(0, _reactDefault.default).createElement("div", {
        ...props,
        className: "sb-unstyled"
    });
var Wrapper10 = ({ children })=>(0, _reactDefault.default).createElement("div", {
        style: {
            fontFamily: "sans-serif"
        }
    }, children);

},{"./chunk-GWAJ4KRU.mjs":"feT0W","@storybook/theming":"bYlbs","react":"jEiK2","@storybook/components":"2BItW","polished":"5ONsA","@storybook/global":"4g4co","lodash/pickBy.js":"gdnlQ","@storybook/csf":"9PLwP","@storybook/client-logger":"7OFBO","markdown-to-jsx":"hzDtQ","memoizerific":"aOMtb","lodash/uniq.js":"8xN3e","lodash/cloneDeep.js":"cxaW8","@storybook/preview-api":"uDWyg","lodash/mapValues.js":"dFo84","@storybook/core-events":"ZHxpZ","ts-dedent":"lKwH2","@storybook/docs-tools":"ccjkZ","telejson":"fQ9bI","tocbot":"7RlvG","@storybook/channels":"9dkSr","d9b4475be0045a5a":"lDgfX","8866e43278e7898b":"lFuTV","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"feT0W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getControlId", ()=>getControlId);
parcelHelpers.export(exports, "getControlSetterButtonId", ()=>getControlSetterButtonId);
var getControlId = (value)=>`control-${value.replace(/\s+/g, "-")}`, getControlSetterButtonId = (value)=>`set-${value.replace(/\s+/g, "-")}`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"bYlbs":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "background", ()=>(0, _chunkEIRT5I3ZMjs.background));
parcelHelpers.export(exports, "color", ()=>(0, _chunkEIRT5I3ZMjs.color));
parcelHelpers.export(exports, "create", ()=>(0, _chunkEIRT5I3ZMjs.create));
parcelHelpers.export(exports, "darken", ()=>(0, _chunkEIRT5I3ZMjs.darkenColor));
parcelHelpers.export(exports, "lighten", ()=>(0, _chunkEIRT5I3ZMjs.lightenColor));
parcelHelpers.export(exports, "themes", ()=>(0, _chunkEIRT5I3ZMjs.themes));
parcelHelpers.export(exports, "typography", ()=>(0, _chunkEIRT5I3ZMjs.typography));
parcelHelpers.export(exports, "CacheProvider", ()=>CacheProvider);
parcelHelpers.export(exports, "ClassNames", ()=>ClassNames);
parcelHelpers.export(exports, "Global", ()=>Global);
parcelHelpers.export(exports, "ThemeProvider", ()=>ThemeProvider);
parcelHelpers.export(exports, "convert", ()=>convert);
parcelHelpers.export(exports, "createCache", ()=>createCache);
parcelHelpers.export(exports, "createGlobal", ()=>createGlobal);
parcelHelpers.export(exports, "createReset", ()=>createReset);
parcelHelpers.export(exports, "css", ()=>css);
parcelHelpers.export(exports, "ensure", ()=>ensure);
parcelHelpers.export(exports, "ignoreSsrWarning", ()=>ignoreSsrWarning);
parcelHelpers.export(exports, "isPropValid", ()=>isPropValid);
parcelHelpers.export(exports, "jsx", ()=>jsx);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
parcelHelpers.export(exports, "styled", ()=>newStyled);
parcelHelpers.export(exports, "useTheme", ()=>useTheme);
parcelHelpers.export(exports, "withTheme", ()=>withTheme);
var _chunkEIRT5I3ZMjs = require("./chunk-EIRT5I3Z.mjs");
var _react = require("react");
var _useInsertionEffectWithFallbacks = require("@emotion/use-insertion-effect-with-fallbacks");
var _memoizerific = require("memoizerific");
var _memoizerificDefault = parcelHelpers.interopDefault(_memoizerific);
var _clientLogger = require("@storybook/client-logger");
var global = arguments[3];
var require_react_is_development = (0, _chunkEIRT5I3ZMjs.__commonJS)({
    "../../node_modules/react-is/cjs/react-is.development.js" (exports) {
        (function() {
            var hasSymbol = typeof Symbol == "function" && Symbol.for, REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 60103, REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 60106, REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 60107, REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 60108, REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 60114, REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 60109, REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 60110, REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 60111, REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 60111, REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 60112, REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 60113, REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 60120, REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 60115, REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 60116, REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 60121, REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 60117, REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 60118, REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 60119;
            function isValidElementType(type) {
                return typeof type == "string" || typeof type == "function" || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type == "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
            }
            function typeOf(object) {
                if (typeof object == "object" && object !== null) {
                    var $$typeof = object.$$typeof;
                    switch($$typeof){
                        case REACT_ELEMENT_TYPE:
                            var type = object.type;
                            switch(type){
                                case REACT_ASYNC_MODE_TYPE:
                                case REACT_CONCURRENT_MODE_TYPE:
                                case REACT_FRAGMENT_TYPE:
                                case REACT_PROFILER_TYPE:
                                case REACT_STRICT_MODE_TYPE:
                                case REACT_SUSPENSE_TYPE:
                                    return type;
                                default:
                                    var $$typeofType = type && type.$$typeof;
                                    switch($$typeofType){
                                        case REACT_CONTEXT_TYPE:
                                        case REACT_FORWARD_REF_TYPE:
                                        case REACT_LAZY_TYPE:
                                        case REACT_MEMO_TYPE:
                                        case REACT_PROVIDER_TYPE:
                                            return $$typeofType;
                                        default:
                                            return $$typeof;
                                    }
                            }
                        case REACT_PORTAL_TYPE:
                            return $$typeof;
                    }
                }
            }
            var AsyncMode = REACT_ASYNC_MODE_TYPE, ConcurrentMode = REACT_CONCURRENT_MODE_TYPE, ContextConsumer = REACT_CONTEXT_TYPE, ContextProvider = REACT_PROVIDER_TYPE, Element = REACT_ELEMENT_TYPE, ForwardRef = REACT_FORWARD_REF_TYPE, Fragment4 = REACT_FRAGMENT_TYPE, Lazy = REACT_LAZY_TYPE, Memo = REACT_MEMO_TYPE, Portal = REACT_PORTAL_TYPE, Profiler = REACT_PROFILER_TYPE, StrictMode = REACT_STRICT_MODE_TYPE, Suspense = REACT_SUSPENSE_TYPE, hasWarnedAboutDeprecatedIsAsyncMode = !1;
            function isAsyncMode(object) {
                return hasWarnedAboutDeprecatedIsAsyncMode || (hasWarnedAboutDeprecatedIsAsyncMode = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
            }
            function isConcurrentMode(object) {
                return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
            }
            function isContextConsumer(object) {
                return typeOf(object) === REACT_CONTEXT_TYPE;
            }
            function isContextProvider(object) {
                return typeOf(object) === REACT_PROVIDER_TYPE;
            }
            function isElement(object) {
                return typeof object == "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
            }
            function isForwardRef(object) {
                return typeOf(object) === REACT_FORWARD_REF_TYPE;
            }
            function isFragment(object) {
                return typeOf(object) === REACT_FRAGMENT_TYPE;
            }
            function isLazy(object) {
                return typeOf(object) === REACT_LAZY_TYPE;
            }
            function isMemo(object) {
                return typeOf(object) === REACT_MEMO_TYPE;
            }
            function isPortal(object) {
                return typeOf(object) === REACT_PORTAL_TYPE;
            }
            function isProfiler(object) {
                return typeOf(object) === REACT_PROFILER_TYPE;
            }
            function isStrictMode(object) {
                return typeOf(object) === REACT_STRICT_MODE_TYPE;
            }
            function isSuspense(object) {
                return typeOf(object) === REACT_SUSPENSE_TYPE;
            }
            exports.AsyncMode = AsyncMode, exports.ConcurrentMode = ConcurrentMode, exports.ContextConsumer = ContextConsumer, exports.ContextProvider = ContextProvider, exports.Element = Element, exports.ForwardRef = ForwardRef, exports.Fragment = Fragment4, exports.Lazy = Lazy, exports.Memo = Memo, exports.Portal = Portal, exports.Profiler = Profiler, exports.StrictMode = StrictMode, exports.Suspense = Suspense, exports.isAsyncMode = isAsyncMode, exports.isConcurrentMode = isConcurrentMode, exports.isContextConsumer = isContextConsumer, exports.isContextProvider = isContextProvider, exports.isElement = isElement, exports.isForwardRef = isForwardRef, exports.isFragment = isFragment, exports.isLazy = isLazy, exports.isMemo = isMemo, exports.isPortal = isPortal, exports.isProfiler = isProfiler, exports.isStrictMode = isStrictMode, exports.isSuspense = isSuspense, exports.isValidElementType = isValidElementType, exports.typeOf = typeOf;
        })();
    }
});
var require_react_is = (0, _chunkEIRT5I3ZMjs.__commonJS)({
    "../../node_modules/react-is/index.js" (exports, module) {
        module.exports = require_react_is_development();
    }
});
var require_hoist_non_react_statics_cjs = (0, _chunkEIRT5I3ZMjs.__commonJS)({
    "../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js" (exports, module) {
        var reactIs = require_react_is(), REACT_STATICS = {
            childContextTypes: !0,
            contextType: !0,
            contextTypes: !0,
            defaultProps: !0,
            displayName: !0,
            getDefaultProps: !0,
            getDerivedStateFromError: !0,
            getDerivedStateFromProps: !0,
            mixins: !0,
            propTypes: !0,
            type: !0
        }, KNOWN_STATICS = {
            name: !0,
            length: !0,
            prototype: !0,
            caller: !0,
            callee: !0,
            arguments: !0,
            arity: !0
        }, FORWARD_REF_STATICS = {
            $$typeof: !0,
            render: !0,
            defaultProps: !0,
            displayName: !0,
            propTypes: !0
        }, MEMO_STATICS = {
            $$typeof: !0,
            compare: !0,
            defaultProps: !0,
            displayName: !0,
            propTypes: !0,
            type: !0
        }, TYPE_STATICS = {};
        TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
        TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
        function getStatics(component) {
            return reactIs.isMemo(component) ? MEMO_STATICS : TYPE_STATICS[component.$$typeof] || REACT_STATICS;
        }
        var defineProperty = Object.defineProperty, getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, getPrototypeOf = Object.getPrototypeOf, objectPrototype = Object.prototype;
        function hoistNonReactStatics2(targetComponent, sourceComponent, blacklist) {
            if (typeof sourceComponent != "string") {
                if (objectPrototype) {
                    var inheritedComponent = getPrototypeOf(sourceComponent);
                    inheritedComponent && inheritedComponent !== objectPrototype && hoistNonReactStatics2(targetComponent, inheritedComponent, blacklist);
                }
                var keys = getOwnPropertyNames(sourceComponent);
                getOwnPropertySymbols && (keys = keys.concat(getOwnPropertySymbols(sourceComponent)));
                for(var targetStatics = getStatics(targetComponent), sourceStatics = getStatics(sourceComponent), i = 0; i < keys.length; ++i){
                    var key = keys[i];
                    if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                        try {
                            defineProperty(targetComponent, key, descriptor);
                        } catch  {}
                    }
                }
            }
            return targetComponent;
        }
        module.exports = hoistNonReactStatics2;
    }
});
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
        }
        return target;
    }, _extends.apply(this, arguments);
}
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        return cache[arg] === void 0 && (cache[arg] = fn(arg)), cache[arg];
    };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, isPropValid = memoize(function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
function sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
    for(var i = 0; i < document.styleSheets.length; i++)if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
}
function createStyleElement(options) {
    var tag = document.createElement("style");
    return tag.setAttribute("data-emotion", options.key), options.nonce !== void 0 && tag.setAttribute("nonce", options.nonce), tag.appendChild(document.createTextNode("")), tag.setAttribute("data-s", ""), tag;
}
var StyleSheet = function() {
    function StyleSheet2(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            _this.tags.length === 0 ? _this.insertionPoint ? before = _this.insertionPoint.nextSibling : _this.prepend ? before = _this.container.firstChild : before = _this.before : before = _this.tags[_this.tags.length - 1].nextSibling, _this.container.insertBefore(tag, before), _this.tags.push(tag);
        }, this.isSpeedy = options.speedy === void 0 ? !1 : options.speedy, this.tags = [], this.ctr = 0, this.nonce = options.nonce, this.key = options.key, this.container = options.container, this.prepend = options.prepend, this.insertionPoint = options.insertionPoint, this.before = null;
    }
    var _proto = StyleSheet2.prototype;
    return _proto.hydrate = function(nodes) {
        nodes.forEach(this._insertTag);
    }, _proto.insert = function(rule) {
        this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(createStyleElement(this));
        var tag = this.tags[this.tags.length - 1], isImportRule3 = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;
        if (isImportRule3 && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + rule + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule3, this.isSpeedy) {
            var sheet = sheetForTag(tag);
            try {
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {
                /:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(rule) || console.error('There was a problem inserting the following rule: "' + rule + '"', e);
            }
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    }, _proto.flush = function() {
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        }), this.tags = [], this.ctr = 0, this._alreadyInsertedOrderInsensitiveRule = !1;
    }, StyleSheet2;
}();
var MS = "-ms-", MOZ = "-moz-", WEBKIT = "-webkit-", COMMENT = "comm", RULESET = "rule", DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";
var LAYER = "@layer";
var abs = Math.abs, from = String.fromCharCode, assign = Object.assign;
function hash(value, length2) {
    return charat(value, 0) ^ 45 ? (((length2 << 2 ^ charat(value, 0)) << 2 ^ charat(value, 1)) << 2 ^ charat(value, 2)) << 2 ^ charat(value, 3) : 0;
}
function trim(value) {
    return value.trim();
}
function match(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function replace(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function indexof(value, search) {
    return value.indexOf(search);
}
function charat(value, index) {
    return value.charCodeAt(index) | 0;
}
function substr(value, begin, end) {
    return value.slice(begin, end);
}
function strlen(value) {
    return value.length;
}
function sizeof(value) {
    return value.length;
}
function append(value, array) {
    return array.push(value), value;
}
function combine(array, callback) {
    return array.map(callback).join("");
}
var line = 1, column = 1, length = 0, position = 0, character = 0, characters = "";
function node(value, root, parent, type, props, children, length2) {
    return {
        value,
        root,
        parent,
        type,
        props,
        children,
        line,
        column,
        length: length2,
        return: ""
    };
}
function copy(root, props) {
    return assign(node("", null, null, "", null, null, 0), root, {
        length: -root.length
    }, props);
}
function char() {
    return character;
}
function prev() {
    return character = position > 0 ? charat(characters, --position) : 0, column--, character === 10 && (column = 1, line--), character;
}
function next() {
    return character = position < length ? charat(characters, position++) : 0, column++, character === 10 && (column = 1, line++), character;
}
function peek() {
    return charat(characters, position);
}
function caret() {
    return position;
}
function slice(begin, end) {
    return substr(characters, begin, end);
}
function token(type) {
    switch(type){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function alloc(value) {
    return line = column = 1, length = strlen(characters = value), position = 0, [];
}
function dealloc(value) {
    return characters = "", value;
}
function delimit(type) {
    return trim(slice(position - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function whitespace(type) {
    for(; (character = peek()) && character < 33;)next();
    return token(type) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(index, count) {
    for(; --count && next() && !(character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97););
    return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32));
}
function delimiter(type) {
    for(; next();)switch(character){
        case type:
            return position;
        case 34:
        case 39:
            type !== 34 && type !== 39 && delimiter(character);
            break;
        case 40:
            type === 41 && delimiter(type);
            break;
        case 92:
            next();
            break;
    }
    return position;
}
function commenter(type, index) {
    for(; next() && type + character !== 57;)if (type + character === 84 && peek() === 47) break;
    return "/*" + slice(index, position - 1) + "*" + from(type === 47 ? type : next());
}
function identifier(index) {
    for(; !token(peek());)next();
    return slice(index, position);
}
function compile(value) {
    return dealloc(parse("", null, null, null, [
        ""
    ], value = alloc(value), 0, [
        0
    ], value));
}
function parse(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    for(var index = 0, offset = 0, length2 = pseudo, atrule = 0, property = 0, previous = 0, variable = 1, scanning = 1, ampersand = 1, character2 = 0, type = "", props = rules, children = rulesets, reference = rule, characters2 = type; scanning;)switch(previous = character2, character2 = next()){
        case 40:
            if (previous != 108 && charat(characters2, length2 - 1) == 58) {
                indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f") != -1 && (ampersand = -1);
                break;
            }
        case 34:
        case 39:
        case 91:
            characters2 += delimit(character2);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            characters2 += whitespace(previous);
            break;
        case 92:
            characters2 += escaping(caret() - 1, 7);
            continue;
        case 47:
            switch(peek()){
                case 42:
                case 47:
                    append(comment(commenter(next(), caret()), root, parent), declarations);
                    break;
                default:
                    characters2 += "/";
            }
            break;
        case 123 * variable:
            points[index++] = strlen(characters2) * ampersand;
        case 125 * variable:
        case 59:
        case 0:
            switch(character2){
                case 0:
                case 125:
                    scanning = 0;
                case 59 + offset:
                    ampersand == -1 && (characters2 = replace(characters2, /\f/g, "")), property > 0 && strlen(characters2) - length2 && append(property > 32 ? declaration(characters2 + ";", rule, parent, length2 - 1) : declaration(replace(characters2, " ", "") + ";", rule, parent, length2 - 2), declarations);
                    break;
                case 59:
                    characters2 += ";";
                default:
                    if (append(reference = ruleset(characters2, root, parent, index, offset, rules, points, type, props = [], children = [], length2), rulesets), character2 === 123) {
                        if (offset === 0) parse(characters2, root, reference, reference, props, rulesets, length2, points, children);
                        else switch(atrule === 99 && charat(characters2, 3) === 110 ? 100 : atrule){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length2), children), rules, children, length2, points, rule ? props : children);
                                break;
                            default:
                                parse(characters2, reference, reference, reference, [
                                    ""
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters2 = "", length2 = pseudo;
            break;
        case 58:
            length2 = 1 + strlen(characters2), property = previous;
        default:
            if (variable < 1) {
                if (character2 == 123) --variable;
                else if (character2 == 125 && variable++ == 0 && prev() == 125) continue;
            }
            switch(characters2 += from(character2), character2 * variable){
                case 38:
                    ampersand = offset > 0 ? 1 : (characters2 += "\f", -1);
                    break;
                case 44:
                    points[index++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
                    break;
                case 64:
                    peek() === 45 && (characters2 += delimit(next())), atrule = peek(), offset = length2 = strlen(type = characters2 += identifier(caret())), character2++;
                    break;
                case 45:
                    previous === 45 && strlen(characters2) == 2 && (variable = 0);
            }
    }
    return rulesets;
}
function ruleset(value, root, parent, index, offset, rules, points, type, props, children, length2) {
    for(var post = offset - 1, rule = offset === 0 ? rules : [
        ""
    ], size = sizeof(rule), i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)(z = trim(j > 0 ? rule[x] + " " + y : replace(y, /&\f/g, rule[x]))) && (props[k++] = z);
    return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length2);
}
function comment(value, root, parent) {
    return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0);
}
function declaration(value, root, parent, length2) {
    return node(value, root, parent, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2);
}
function serialize(children, callback) {
    for(var output = "", length2 = sizeof(children), i = 0; i < length2; i++)output += callback(children[i], i, children, callback) || "";
    return output;
}
function stringify(element, index, children, callback) {
    switch(element.type){
        case LAYER:
            if (element.children.length) break;
        case IMPORT:
        case DECLARATION:
            return element.return = element.return || element.value;
        case COMMENT:
            return "";
        case KEYFRAMES:
            return element.return = element.value + "{" + serialize(element.children, callback) + "}";
        case RULESET:
            element.value = element.props.join(",");
    }
    return strlen(children = serialize(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}
function middleware(collection) {
    var length2 = sizeof(collection);
    return function(element, index, children, callback) {
        for(var output = "", i = 0; i < length2; i++)output += collection[i](element, index, children, callback) || "";
        return output;
    };
}
var weakMemoize = function(func) {
    var cache = new WeakMap;
    return function(arg) {
        if (cache.has(arg)) return cache.get(arg);
        var ret = func(arg);
        return cache.set(arg, ret), ret;
    };
};
var identifierWithPointTracking = function(begin, points, index) {
    for(var previous = 0, character2 = 0; previous = character2, character2 = peek(), previous === 38 && character2 === 12 && (points[index] = 1), !token(character2);)next();
    return slice(begin, position);
}, toRules = function(parsed, points) {
    var index = -1, character2 = 44;
    do switch(token(character2)){
        case 0:
            character2 === 38 && peek() === 12 && (points[index] = 1), parsed[index] += identifierWithPointTracking(position - 1, points, index);
            break;
        case 2:
            parsed[index] += delimit(character2);
            break;
        case 4:
            if (character2 === 44) {
                parsed[++index] = peek() === 58 ? "&\f" : "", points[index] = parsed[index].length;
                break;
            }
        default:
            parsed[index] += from(character2);
    }
    while (character2 = next());
    return parsed;
}, getRules = function(value, points) {
    return dealloc(toRules(alloc(value), points));
}, fixedElements = new WeakMap, compat = function(element) {
    if (!(element.type !== "rule" || !element.parent || element.length < 1)) {
        for(var value = element.value, parent = element.parent, isImplicitRule = element.column === parent.column && element.line === parent.line; parent.type !== "rule";)if (parent = parent.parent, !parent) return;
        if (!(element.props.length === 1 && value.charCodeAt(0) !== 58 && !fixedElements.get(parent)) && !isImplicitRule) {
            fixedElements.set(element, !0);
            for(var points = [], rules = getRules(value, points), parentRules = parent.props, i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
        }
    }
}, removeLabel = function(element) {
    if (element.type === "decl") {
        var value = element.value;
        value.charCodeAt(0) === 108 && value.charCodeAt(2) === 98 && (element.return = "", element.value = "");
    }
}, ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", isIgnoringComment = function(element) {
    return element.type === "comm" && element.children.indexOf(ignoreFlag) > -1;
}, createUnsafeSelectorsAlarm = function(cache) {
    return function(element, index, children) {
        if (!(element.type !== "rule" || cache.compat)) {
            var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
            if (unsafePseudoClasses) {
                for(var isNested = !!element.parent, commentContainer = isNested ? element.parent.children : children, i = commentContainer.length - 1; i >= 0; i--){
                    var node2 = commentContainer[i];
                    if (node2.line < element.line) break;
                    if (node2.column < element.column) {
                        if (isIgnoringComment(node2)) return;
                        break;
                    }
                }
                unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                    console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
                });
            }
        }
    };
}, isImportRule = function(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
}, isPrependedWithRegularRules = function(index, children) {
    for(var i = index - 1; i >= 0; i--)if (!isImportRule(children[i])) return !0;
    return !1;
}, nullifyElement = function(element) {
    element.type = "", element.value = "", element.return = "", element.children = "", element.props = "";
}, incorrectImportAlarm = function(element, index, children) {
    isImportRule(element) && (element.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), nullifyElement(element)) : isPrependedWithRegularRules(index, children) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), nullifyElement(element)));
};
function prefix(value, length2) {
    switch(hash(value, length2)){
        case 5103:
            return WEBKIT + "print-" + value + value;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return WEBKIT + value + value;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return WEBKIT + value + MOZ + value + MS + value + value;
        case 6828:
        case 4268:
            return WEBKIT + value + MS + value + value;
        case 6165:
            return WEBKIT + value + MS + "flex-" + value + value;
        case 5187:
            return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + value;
        case 5443:
            return WEBKIT + value + MS + "flex-item-" + replace(value, /flex-|-self/, "") + value;
        case 4675:
            return WEBKIT + value + MS + "flex-line-pack" + replace(value, /align-content|flex-|-self/, "") + value;
        case 5548:
            return WEBKIT + value + MS + replace(value, "shrink", "negative") + value;
        case 5292:
            return WEBKIT + value + MS + replace(value, "basis", "preferred-size") + value;
        case 6060:
            return WEBKIT + "box-" + replace(value, "-grow", "") + WEBKIT + value + MS + replace(value, "grow", "positive") + value;
        case 4554:
            return WEBKIT + replace(value, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + value;
        case 6187:
            return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), value, "") + value;
        case 5495:
        case 3959:
            return replace(value, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
        case 4968:
            return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + value + value;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return replace(value, /(.+)-inline(.+)/, WEBKIT + "$1$2") + value;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if (strlen(value) - 1 - length2 > 6) switch(charat(value, length2 + 1)){
                case 109:
                    if (charat(value, length2 + 4) !== 45) break;
                case 102:
                    return replace(value, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(value, length2 + 3) == 108 ? "$3" : "$2-$3")) + value;
                case 115:
                    return ~indexof(value, "stretch") ? prefix(replace(value, "stretch", "fill-available"), length2) + value : value;
            }
            break;
        case 4949:
            if (charat(value, length2 + 1) !== 115) break;
        case 6444:
            switch(charat(value, strlen(value) - 3 - (~indexof(value, "!important") && 10))){
                case 107:
                    return replace(value, ":", ":" + WEBKIT) + value;
                case 101:
                    return replace(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(value, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + value;
            }
            break;
        case 5936:
            switch(charat(value, length2 + 11)){
                case 114:
                    return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                case 108:
                    return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                case 45:
                    return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return WEBKIT + value + MS + value + value;
    }
    return value;
}
var prefixer = function(element, index, children, callback) {
    if (element.length > -1 && !element.return) switch(element.type){
        case DECLARATION:
            element.return = prefix(element.value, element.length);
            break;
        case KEYFRAMES:
            return serialize([
                copy(element, {
                    value: replace(element.value, "@", "@" + WEBKIT)
                })
            ], callback);
        case RULESET:
            if (element.length) return combine(element.props, function(value) {
                switch(match(value, /(::plac\w+|:read-\w+)/)){
                    case ":read-only":
                    case ":read-write":
                        return serialize([
                            copy(element, {
                                props: [
                                    replace(value, /:(read-\w+)/, ":" + MOZ + "$1")
                                ]
                            })
                        ], callback);
                    case "::placeholder":
                        return serialize([
                            copy(element, {
                                props: [
                                    replace(value, /:(plac\w+)/, ":" + WEBKIT + "input-$1")
                                ]
                            }),
                            copy(element, {
                                props: [
                                    replace(value, /:(plac\w+)/, ":" + MOZ + "$1")
                                ]
                            }),
                            copy(element, {
                                props: [
                                    replace(value, /:(plac\w+)/, MS + "input-$1")
                                ]
                            })
                        ], callback);
                }
                return "";
            });
    }
}, defaultStylisPlugins = [
    prefixer
], createCache = function(options) {
    var key = options.key;
    if (!key) throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])");
        Array.prototype.forEach.call(ssrStyles, function(node2) {
            var dataEmotionAttribute = node2.getAttribute("data-emotion");
            dataEmotionAttribute.indexOf(" ") !== -1 && (document.head.appendChild(node2), node2.setAttribute("data-s", ""));
        });
    }
    var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;
    if (/[^a-z-]/.test(key)) throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + key + '" was passed');
    var inserted = {}, container, nodesToHydrate = [];
    container = options.container || document.head, Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node2) {
        for(var attrib = node2.getAttribute("data-emotion").split(" "), i = 1; i < attrib.length; i++)inserted[attrib[i]] = !0;
        nodesToHydrate.push(node2);
    });
    var _insert, omnipresentPlugins = [
        compat,
        removeLabel
    ];
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
        get compat () {
            return cache.compat;
        }
    }), incorrectImportAlarm);
    var currentSheet, finalizingPlugins = [
        stringify,
        function(element) {
            element.root || (element.return ? currentSheet.insert(element.return) : element.value && element.type !== COMMENT && currentSheet.insert(element.value + "{}"));
        }
    ], serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins)), stylis = function(styles) {
        return serialize(compile(styles), serializer);
    };
    _insert = function(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet, serialized.map !== void 0 && (currentSheet = {
            insert: function(rule) {
                sheet.insert(rule + serialized.map);
            }
        }), stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles), shouldCache && (cache.inserted[serialized.name] = !0);
    };
    var cache = {
        key,
        sheet: new StyleSheet({
            key,
            container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted,
        registered: {},
        insert: _insert
    };
    return cache.sheet.hydrate(nodesToHydrate), cache;
};
function _extends2() {
    return _extends2 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
        }
        return target;
    }, _extends2.apply(this, arguments);
}
var import_hoist_non_react_statics = (0, _chunkEIRT5I3ZMjs.__toESM)(require_hoist_non_react_statics_cjs()), hoistNonReactStatics = function(targetComponent, sourceComponent) {
    return (0, import_hoist_non_react_statics.default)(targetComponent, sourceComponent);
};
var isBrowser = !0;
function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = "";
    return classNames.split(" ").forEach(function(className) {
        registered[className] !== void 0 ? registeredStyles.push(registered[className] + ";") : rawClassName += className + " ";
    }), rawClassName;
}
var registerStyles = function(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    (isStringTag === !1 || isBrowser === !1) && cache.registered[className] === void 0 && (cache.registered[className] = serialized.styles);
}, insertStyles = function(cache, serialized, isStringTag) {
    registerStyles(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === void 0) {
        var current = serialized;
        do cache.insert(serialized === current ? "." + className : "", current, cache.sheet, !0), current = current.next;
        while (current !== void 0);
    }
};
function murmur2(str) {
    for(var h = 0, k, i = 0, len = str.length; len >= 4; ++i, len -= 4)k = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24, k = (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16), k ^= k >>> 24, h = (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16) ^ (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 255) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 255) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 255, h = (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
    }
    return h ^= h >>> 13, h = (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16), ((h ^ h >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var ILLEGAL_ESCAPE_SEQUENCE_ERROR = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", hyphenateRegex = /[A-Z]|^ms/g, animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g, isCustomProperty = function(property) {
    return property.charCodeAt(1) === 45;
}, isProcessableValue = function(value) {
    return value != null && typeof value != "boolean";
}, processStyleName = memoize(function(styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
}), processStyleValue = function(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value == "string") return value.replace(animationRegex, function(match2, p1, p2) {
                return cursor = {
                    name: p1,
                    styles: p2,
                    next: cursor
                }, p1;
            });
    }
    return unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value == "number" && value !== 0 ? value + "px" : value;
};
contentValuePattern = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, contentValues = [
    "normal",
    "none",
    "initial",
    "inherit",
    "unset"
], oldProcessStyleValue = processStyleValue, msPattern = /^-ms-/, hyphenPattern = /-(.)/g, hyphenatedCache = {}, processStyleValue = function(key, value) {
    if (key === "content" && (typeof value != "string" || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'"))) throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
    var processed = oldProcessStyleValue(key, value);
    return processed !== "" && !isCustomProperty(key) && key.indexOf("-") !== -1 && hyphenatedCache[key] === void 0 && (hyphenatedCache[key] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, "ms-").replace(hyphenPattern, function(str, _char) {
        return _char.toUpperCase();
    }) + "?")), processed;
};
var contentValuePattern, contentValues, oldProcessStyleValue, msPattern, hyphenPattern, hyphenatedCache, noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== void 0) {
        if (interpolation.toString() === "NO_COMPONENT_SELECTOR") throw new Error(noComponentSelectorMessage);
        return interpolation;
    }
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) return cursor = {
                name: interpolation.name,
                styles: interpolation.styles,
                next: cursor
            }, interpolation.name;
            if (interpolation.styles !== void 0) {
                var next2 = interpolation.next;
                if (next2 !== void 0) for(; next2 !== void 0;)cursor = {
                    name: next2.name,
                    styles: next2.styles,
                    next: cursor
                }, next2 = next2.next;
                var styles = interpolation.styles + ";";
                return interpolation.map !== void 0 && (styles += interpolation.map), styles;
            }
            return createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== void 0) {
                var previousCursor = cursor, result = interpolation(mergedProps);
                return cursor = previousCursor, handleInterpolation(mergedProps, registered, result);
            } else console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
            break;
        case "string":
            var matched = [], replaced = interpolation.replace(animationRegex, function(match2, p1, p2) {
                var fakeVarName = "animation" + matched.length;
                return matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + fakeVarName + "}";
            });
            matched.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(matched, [
                "`" + replaced + "`"
            ]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + replaced + "`"));
            break;
    }
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== void 0 ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value != "object") registered != null && registered[value] !== void 0 ? string += _key + "{" + registered[value] + "}" : isProcessableValue(value) && (string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";");
        else {
            if (_key === "NO_COMPONENT_SELECTOR") throw new Error(noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] == "string" && (registered == null || registered[value[0]] === void 0)) for(var _i = 0; _i < value.length; _i++)isProcessableValue(value[_i]) && (string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";");
            else {
                var interpolated = handleInterpolation(mergedProps, registered, value);
                switch(_key){
                    case "animation":
                    case "animationName":
                        string += processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        _key === "undefined" && console.error(UNDEFINED_AS_OBJECT_KEY_ERROR), string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g, sourceMapPattern;
sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
var cursor, serializeStyles = function(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] == "object" && args[0] !== null && args[0].styles !== void 0) return args[0];
    var stringMode = !0, styles = "";
    cursor = void 0;
    var strings = args[0];
    strings == null || strings.raw === void 0 ? (stringMode = !1, styles += handleInterpolation(mergedProps, registered, strings)) : (strings[0] === void 0 && console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR), styles += strings[0]);
    for(var i = 1; i < args.length; i++)styles += handleInterpolation(mergedProps, registered, args[i]), stringMode && (strings[i] === void 0 && console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR), styles += strings[i]);
    var sourceMap;
    styles = styles.replace(sourceMapPattern, function(match3) {
        return sourceMap = match3, "";
    }), labelPattern.lastIndex = 0;
    for(var identifierName = "", match2; (match2 = labelPattern.exec(styles)) !== null;)identifierName += "-" + match2[1];
    var name = murmur2(styles) + identifierName;
    return {
        name,
        styles,
        map: sourceMap,
        next: cursor,
        toString: function() {
            return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
        }
    };
};
var hasOwnProperty = {}.hasOwnProperty, EmotionCacheContext = _react.createContext(typeof HTMLElement < "u" ? createCache({
    key: "css"
}) : null);
EmotionCacheContext.displayName = "EmotionCacheContext";
var CacheProvider = EmotionCacheContext.Provider;
var withEmotionCache = function(func) {
    return (0, _react.forwardRef)(function(props, ref) {
        var cache = (0, _react.useContext)(EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var ThemeContext = _react.createContext({});
ThemeContext.displayName = "EmotionThemeContext";
var useTheme = function() {
    return _react.useContext(ThemeContext);
}, getTheme = function(outerTheme, theme) {
    if (typeof theme == "function") {
        var mergedTheme = theme(outerTheme);
        if (mergedTheme == null || typeof mergedTheme != "object" || Array.isArray(mergedTheme)) throw new Error("[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!");
        return mergedTheme;
    }
    if (theme == null || typeof theme != "object" || Array.isArray(theme)) throw new Error("[ThemeProvider] Please make your theme prop a plain object");
    return _extends2({}, outerTheme, theme);
}, createCacheWithTheme = weakMemoize(function(outerTheme) {
    return weakMemoize(function(theme) {
        return getTheme(outerTheme, theme);
    });
}), ThemeProvider = function(props) {
    var theme = _react.useContext(ThemeContext);
    return props.theme !== theme && (theme = createCacheWithTheme(theme)(props.theme)), _react.createElement(ThemeContext.Provider, {
        value: theme
    }, props.children);
};
function withTheme(Component) {
    var componentName = Component.displayName || Component.name || "Component", render = function(props, ref) {
        var theme = _react.useContext(ThemeContext);
        return _react.createElement(Component, _extends2({
            theme,
            ref
        }, props));
    }, WithTheme = _react.forwardRef(render);
    return WithTheme.displayName = "WithTheme(" + componentName + ")", hoistNonReactStatics(WithTheme, Component);
}
var getLastPart = function(functionName) {
    var parts = functionName.split(".");
    return parts[parts.length - 1];
}, getFunctionNameFromStackTraceLine = function(line2) {
    var match2 = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line2);
    if (match2 || (match2 = /^([A-Za-z0-9$.]+)@/.exec(line2), match2)) return getLastPart(match2[1]);
}, internalReactFunctionNames = new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]), sanitizeIdentifier = function(identifier2) {
    return identifier2.replace(/\$/g, "-");
}, getLabelFromStackTrace = function(stackTrace) {
    if (stackTrace) for(var lines = stackTrace.split(`
`), i = 0; i < lines.length; i++){
        var functionName = getFunctionNameFromStackTraceLine(lines[i]);
        if (functionName) {
            if (internalReactFunctionNames.has(functionName)) break;
            if (/^[A-Z]/.test(functionName)) return sanitizeIdentifier(functionName);
        }
    }
}, typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", createEmotionProps = function(type, props) {
    if (typeof props.css == "string" && props.css.indexOf(":") !== -1) throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + props.css + "`");
    var newProps = {};
    for(var key in props)hasOwnProperty.call(props, key) && (newProps[key] = props[key]);
    if (newProps[typePropName] = type, props.css && (typeof props.css != "object" || typeof props.css.name != "string" || props.css.name.indexOf("-") === -1)) {
        var label = getLabelFromStackTrace(new Error().stack);
        label && (newProps[labelPropName] = label);
    }
    return newProps;
}, Insertion = function(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    return registerStyles(cache, serialized, isStringTag), (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return insertStyles(cache, serialized, isStringTag);
    }), null;
}, Emotion = withEmotionCache(function(props, cache, ref) {
    var cssProp = props.css;
    typeof cssProp == "string" && cache.registered[cssProp] !== void 0 && (cssProp = cache.registered[cssProp]);
    var WrappedComponent = props[typePropName], registeredStyles = [
        cssProp
    ], className = "";
    typeof props.className == "string" ? className = getRegisteredStyles(cache.registered, registeredStyles, props.className) : props.className != null && (className = props.className + " ");
    var serialized = serializeStyles(registeredStyles, void 0, _react.useContext(ThemeContext));
    if (serialized.name.indexOf("-") === -1) {
        var labelFromStack = props[labelPropName];
        labelFromStack && (serialized = serializeStyles([
            serialized,
            "label:" + labelFromStack + ";"
        ]));
    }
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)hasOwnProperty.call(props, key) && key !== "css" && key !== typePropName && key !== labelPropName && (newProps[key] = props[key]);
    return newProps.ref = ref, newProps.className = className, _react.createElement(_react.Fragment, null, _react.createElement(Insertion, {
        cache,
        serialized,
        isStringTag: typeof WrappedComponent == "string"
    }), _react.createElement(WrappedComponent, newProps));
});
Emotion.displayName = "EmotionCssPropInternal";
var Emotion$1 = Emotion;
(0, _chunkEIRT5I3ZMjs.__toESM)(require_hoist_non_react_statics_cjs());
var pkg = {
    name: "@emotion/react",
    version: "11.11.1",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                default: "./dist/emotion-react.esm.js"
            },
            import: "./dist/emotion-react.cjs.mjs",
            default: "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                default: "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            import: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            default: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            import: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            import: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                import: "./macro.d.mts",
                default: "./macro.d.ts"
            },
            default: "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: !1,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.2",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: !0
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.0",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        import: "./macro.d.mts",
                        default: "./macro.d.ts"
                    },
                    default: "./macro.js"
                }
            }
        }
    }
}, jsx = function(type, props) {
    var args = arguments;
    if (props == null || !hasOwnProperty.call(props, "css")) return _react.createElement.apply(void 0, args);
    var argsLength = args.length, createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = Emotion$1, createElementArgArray[1] = createEmotionProps(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return _react.createElement.apply(null, createElementArgArray);
}, warnedAboutCssPropForGlobal = !1, Global = withEmotionCache(function(props, cache) {
    !warnedAboutCssPropForGlobal && (props.className || props.css) && (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), warnedAboutCssPropForGlobal = !0);
    var styles = props.styles, serialized = serializeStyles([
        styles
    ], void 0, _react.useContext(ThemeContext));
    var sheetRef = _react.useRef();
    return (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global", sheet = new cache.sheet.constructor({
            key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        }), rehydrating = !1, node2 = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        return cache.sheet.tags.length && (sheet.before = cache.sheet.tags[0]), node2 !== null && (rehydrating = !0, node2.setAttribute("data-emotion", key), sheet.hydrate([
            node2
        ])), sheetRef.current = [
            sheet,
            rehydrating
        ], function() {
            sheet.flush();
        };
    }, [
        cache
    ]), (0, _useInsertionEffectWithFallbacks.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current, sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = !1;
            return;
        }
        if (serialized.next !== void 0 && insertStyles(cache, serialized.next, !0), sheet.tags.length) {
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element, sheet.flush();
        }
        cache.insert("", serialized, sheet, !1);
    }, [
        cache,
        serialized.name
    ]), null;
});
Global.displayName = "EmotionGlobal";
function css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return serializeStyles(args);
}
var keyframes = function() {
    var insertable = css.apply(void 0, arguments), name = "animation-" + insertable.name;
    return {
        name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}, classnames = function classnames2(args) {
    for(var len = args.length, i = 0, cls = ""; i < len; i++){
        var arg = args[i];
        if (arg != null) {
            var toAdd = void 0;
            switch(typeof arg){
                case "boolean":
                    break;
                case "object":
                    if (Array.isArray(arg)) toAdd = classnames2(arg);
                    else {
                        arg.styles !== void 0 && arg.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), toAdd = "";
                        for(var k in arg)arg[k] && k && (toAdd && (toAdd += " "), toAdd += k);
                    }
                    break;
                default:
                    toAdd = arg;
            }
            toAdd && (cls && (cls += " "), cls += toAdd);
        }
    }
    return cls;
};
function merge(registered, css2, className) {
    var registeredStyles = [], rawClassName = getRegisteredStyles(registered, registeredStyles, className);
    return registeredStyles.length < 2 ? className : rawClassName + css2(registeredStyles);
}
var Insertion3 = function(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    return (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)insertStyles(cache, serializedArr[i], !1);
    }), null;
}, ClassNames = withEmotionCache(function(props, cache) {
    var hasRendered = !1, serializedArr = [], css2 = function() {
        if (hasRendered) throw new Error("css can only be used during render");
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = serializeStyles(args, cache.registered);
        return serializedArr.push(serialized), registerStyles(cache, serialized, !1), cache.key + "-" + serialized.name;
    }, cx = function() {
        if (hasRendered) throw new Error("cx can only be used during render");
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return merge(cache.registered, css2, classnames(args));
    }, content = {
        css: css2,
        cx,
        theme: _react.useContext(ThemeContext)
    }, ele = props.children(content);
    return hasRendered = !0, _react.createElement(_react.Fragment, null, _react.createElement(Insertion3, {
        cache,
        serializedArr
    }), ele);
});
ClassNames.displayName = "EmotionClassNames";
isBrowser3 = !0, isTestEnv = typeof jest < "u" || typeof vi < "u", isBrowser3 && !isTestEnv && (globalContext = typeof globalThis < "u" ? globalThis : isBrowser3 ? window : global, globalKey = "__EMOTION_REACT_" + pkg.version.split(".")[0] + "__", globalContext[globalKey] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), globalContext[globalKey] = !0);
var isBrowser3, isTestEnv, globalContext, globalKey;
var testOmitPropsOnStringTag = isPropValid, testOmitPropsOnComponent = function(key) {
    return key !== "theme";
}, getDefaultShouldForwardProp = function(tag) {
    return typeof tag == "string" && tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
}, composeShouldForwardProps = function(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    return typeof shouldForwardProp != "function" && isReal && (shouldForwardProp = tag.__emotion_forwardProp), shouldForwardProp;
}, ILLEGAL_ESCAPE_SEQUENCE_ERROR2 = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, Insertion5 = function(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    return registerStyles(cache, serialized, isStringTag), (0, _useInsertionEffectWithFallbacks.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return insertStyles(cache, serialized, isStringTag);
    }), null;
}, createStyled = function createStyled2(tag, options) {
    if (tag === void 0) throw new Error(`You are trying to create a styled element with an undefined component.
You may have forgotten to import it.`);
    var isReal = tag.__emotion_real === tag, baseTag = isReal && tag.__emotion_base || tag, identifierName, targetClassName;
    options !== void 0 && (identifierName = options.label, targetClassName = options.target);
    var shouldForwardProp = composeShouldForwardProps(tag, options, isReal), defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag), shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments, styles = isReal && tag.__emotion_styles !== void 0 ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== void 0 && styles.push("label:" + identifierName + ";"), args[0] == null || args[0].raw === void 0) styles.push.apply(styles, args);
        else {
            args[0][0] === void 0 && console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR2), styles.push(args[0][0]);
            for(var len = args.length, i = 1; i < len; i++)args[0][i] === void 0 && console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR2), styles.push(args[i], args[0][i]);
        }
        var Styled = withEmotionCache(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag, className = "", classInterpolations = [], mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = _react.useContext(ThemeContext);
            }
            typeof props.className == "string" ? className = getRegisteredStyles(cache.registered, classInterpolations, props.className) : props.className != null && (className = props.className + " ");
            var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name, targetClassName !== void 0 && (className += " " + targetClassName);
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === void 0 ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp, newProps = {};
            for(var _key in props)shouldUseAs && _key === "as" || finalShouldForwardProp(_key) && (newProps[_key] = props[_key]);
            return newProps.className = className, newProps.ref = ref, _react.createElement(_react.Fragment, null, _react.createElement(Insertion5, {
                cache,
                serialized,
                isStringTag: typeof FinalTag == "string"
            }), _react.createElement(FinalTag, newProps));
        });
        return Styled.displayName = identifierName !== void 0 ? identifierName : "Styled(" + (typeof baseTag == "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")", Styled.defaultProps = tag.defaultProps, Styled.__emotion_real = Styled, Styled.__emotion_base = baseTag, Styled.__emotion_styles = styles, Styled.__emotion_forwardProp = shouldForwardProp, Object.defineProperty(Styled, "toString", {
            value: function() {
                return targetClassName === void 0 ? "NO_COMPONENT_SELECTOR" : "." + targetClassName;
            }
        }), Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled2(nextTag, _extends({}, options, nextOptions, {
                shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, !0)
            })).apply(void 0, styles);
        }, Styled;
    };
};
var tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
], newStyled = createStyled.bind();
tags.forEach(function(tagName) {
    newStyled[tagName] = newStyled(tagName);
});
var createReset = (0, _memoizerificDefault.default)(1)(({ typography: typography2 })=>({
        body: {
            fontFamily: typography2.fonts.base,
            fontSize: typography2.size.s3,
            margin: 0,
            WebkitFontSmoothing: "antialiased",
            MozOsxFontSmoothing: "grayscale",
            WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
            WebkitOverflowScrolling: "touch"
        },
        "*": {
            boxSizing: "border-box"
        },
        "h1, h2, h3, h4, h5, h6": {
            fontWeight: typography2.weight.regular,
            margin: 0,
            padding: 0
        },
        "button, input, textarea, select": {
            fontFamily: "inherit",
            fontSize: "inherit",
            boxSizing: "border-box"
        },
        sub: {
            fontSize: "0.8em",
            bottom: "-0.2em"
        },
        sup: {
            fontSize: "0.8em",
            top: "-0.2em"
        },
        "b, strong": {
            fontWeight: typography2.weight.bold
        },
        hr: {
            border: "none",
            borderTop: "1px solid silver",
            clear: "both",
            marginBottom: "1.25rem"
        },
        code: {
            fontFamily: typography2.fonts.mono,
            WebkitFontSmoothing: "antialiased",
            MozOsxFontSmoothing: "grayscale",
            display: "inline-block",
            paddingLeft: 2,
            paddingRight: 2,
            verticalAlign: "baseline",
            color: "inherit"
        },
        pre: {
            fontFamily: typography2.fonts.mono,
            WebkitFontSmoothing: "antialiased",
            MozOsxFontSmoothing: "grayscale",
            lineHeight: "18px",
            padding: "11px 1rem",
            whiteSpace: "pre-wrap",
            color: "inherit",
            borderRadius: 3,
            margin: "1rem 0"
        }
    })), createGlobal = (0, _memoizerificDefault.default)(1)(({ color: color2, background: background2, typography: typography2 })=>{
    let resetStyles = createReset({
        typography: typography2
    });
    return {
        ...resetStyles,
        body: {
            ...resetStyles.body,
            color: color2.defaultText,
            background: background2.app,
            overflow: "hidden"
        },
        hr: {
            ...resetStyles.hr,
            borderTop: `1px solid ${color2.border}`
        }
    };
});
var easing = {
    rubber: "cubic-bezier(0.175, 0.885, 0.335, 1.05)"
}, rotate360 = keyframes`
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
`, glow = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: .4; }
`, float = keyframes`
  0% { transform: translateY(1px); }
  25% { transform: translateY(0px); }
  50% { transform: translateY(-3px); }
  100% { transform: translateY(1px); }
`, jiggle = keyframes`
  0%, 100% { transform:translate3d(0,0,0); }
  12.5%, 62.5% { transform:translate3d(-4px,0,0); }
  37.5%, 87.5% {  transform: translate3d(4px,0,0);  }
`, inlineGlow = css`
  animation: ${glow} 1.5s ease-in-out infinite;
  color: transparent;
  cursor: progress;
`, hoverable = css`
  transition: all 150ms ease-out;
  transform: translate3d(0, 0, 0);

  &:hover {
    transform: translate3d(0, -2px, 0);
  }

  &:active {
    transform: translate3d(0, 0, 0);
  }
`, animation = {
    rotate360,
    glow,
    float,
    jiggle,
    inlineGlow,
    hoverable
};
var chromeDark = {
    BASE_FONT_FAMILY: "Menlo, monospace",
    BASE_FONT_SIZE: "11px",
    BASE_LINE_HEIGHT: 1.2,
    BASE_BACKGROUND_COLOR: "rgb(36, 36, 36)",
    BASE_COLOR: "rgb(213, 213, 213)",
    OBJECT_PREVIEW_ARRAY_MAX_PROPERTIES: 10,
    OBJECT_PREVIEW_OBJECT_MAX_PROPERTIES: 5,
    OBJECT_NAME_COLOR: "rgb(227, 110, 236)",
    OBJECT_VALUE_NULL_COLOR: "rgb(127, 127, 127)",
    OBJECT_VALUE_UNDEFINED_COLOR: "rgb(127, 127, 127)",
    OBJECT_VALUE_REGEXP_COLOR: "rgb(233, 63, 59)",
    OBJECT_VALUE_STRING_COLOR: "rgb(233, 63, 59)",
    OBJECT_VALUE_SYMBOL_COLOR: "rgb(233, 63, 59)",
    OBJECT_VALUE_NUMBER_COLOR: "hsl(252, 100%, 75%)",
    OBJECT_VALUE_BOOLEAN_COLOR: "hsl(252, 100%, 75%)",
    OBJECT_VALUE_FUNCTION_PREFIX_COLOR: "rgb(85, 106, 242)",
    HTML_TAG_COLOR: "rgb(93, 176, 215)",
    HTML_TAGNAME_COLOR: "rgb(93, 176, 215)",
    HTML_TAGNAME_TEXT_TRANSFORM: "lowercase",
    HTML_ATTRIBUTE_NAME_COLOR: "rgb(155, 187, 220)",
    HTML_ATTRIBUTE_VALUE_COLOR: "rgb(242, 151, 102)",
    HTML_COMMENT_COLOR: "rgb(137, 137, 137)",
    HTML_DOCTYPE_COLOR: "rgb(192, 192, 192)",
    ARROW_COLOR: "rgb(145, 145, 145)",
    ARROW_MARGIN_RIGHT: 3,
    ARROW_FONT_SIZE: 12,
    ARROW_ANIMATION_DURATION: "0",
    TREENODE_FONT_FAMILY: "Menlo, monospace",
    TREENODE_FONT_SIZE: "11px",
    TREENODE_LINE_HEIGHT: 1.2,
    TREENODE_PADDING_LEFT: 12,
    TABLE_BORDER_COLOR: "rgb(85, 85, 85)",
    TABLE_TH_BACKGROUND_COLOR: "rgb(44, 44, 44)",
    TABLE_TH_HOVER_COLOR: "rgb(48, 48, 48)",
    TABLE_SORT_ICON_COLOR: "black",
    TABLE_DATA_BACKGROUND_IMAGE: "linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0) 50%, rgba(51, 139, 255, 0.0980392) 50%, rgba(51, 139, 255, 0.0980392))",
    TABLE_DATA_BACKGROUND_SIZE: "128px 32px"
}, chromeLight = {
    BASE_FONT_FAMILY: "Menlo, monospace",
    BASE_FONT_SIZE: "11px",
    BASE_LINE_HEIGHT: 1.2,
    BASE_BACKGROUND_COLOR: "white",
    BASE_COLOR: "black",
    OBJECT_PREVIEW_ARRAY_MAX_PROPERTIES: 10,
    OBJECT_PREVIEW_OBJECT_MAX_PROPERTIES: 5,
    OBJECT_NAME_COLOR: "rgb(136, 19, 145)",
    OBJECT_VALUE_NULL_COLOR: "rgb(128, 128, 128)",
    OBJECT_VALUE_UNDEFINED_COLOR: "rgb(128, 128, 128)",
    OBJECT_VALUE_REGEXP_COLOR: "rgb(196, 26, 22)",
    OBJECT_VALUE_STRING_COLOR: "rgb(196, 26, 22)",
    OBJECT_VALUE_SYMBOL_COLOR: "rgb(196, 26, 22)",
    OBJECT_VALUE_NUMBER_COLOR: "rgb(28, 0, 207)",
    OBJECT_VALUE_BOOLEAN_COLOR: "rgb(28, 0, 207)",
    OBJECT_VALUE_FUNCTION_PREFIX_COLOR: "rgb(13, 34, 170)",
    HTML_TAG_COLOR: "rgb(168, 148, 166)",
    HTML_TAGNAME_COLOR: "rgb(136, 18, 128)",
    HTML_TAGNAME_TEXT_TRANSFORM: "lowercase",
    HTML_ATTRIBUTE_NAME_COLOR: "rgb(153, 69, 0)",
    HTML_ATTRIBUTE_VALUE_COLOR: "rgb(26, 26, 166)",
    HTML_COMMENT_COLOR: "rgb(35, 110, 37)",
    HTML_DOCTYPE_COLOR: "rgb(192, 192, 192)",
    ARROW_COLOR: "#6e6e6e",
    ARROW_MARGIN_RIGHT: 3,
    ARROW_FONT_SIZE: 12,
    ARROW_ANIMATION_DURATION: "0",
    TREENODE_FONT_FAMILY: "Menlo, monospace",
    TREENODE_FONT_SIZE: "11px",
    TREENODE_LINE_HEIGHT: 1.2,
    TREENODE_PADDING_LEFT: 12,
    TABLE_BORDER_COLOR: "#aaa",
    TABLE_TH_BACKGROUND_COLOR: "#eee",
    TABLE_TH_HOVER_COLOR: "hsla(0, 0%, 90%, 1)",
    TABLE_SORT_ICON_COLOR: "#6e6e6e",
    TABLE_DATA_BACKGROUND_IMAGE: "linear-gradient(to bottom, white, white 50%, rgb(234, 243, 255) 50%, rgb(234, 243, 255))",
    TABLE_DATA_BACKGROUND_SIZE: "128px 32px"
}, convertColors = (colors)=>Object.entries(colors).reduce((acc, [k, v])=>({
            ...acc,
            [k]: (0, _chunkEIRT5I3ZMjs.mkColor)(v)
        }), {}), create2 = ({ colors, mono })=>{
    let colorsObjs = convertColors(colors);
    return {
        token: {
            fontFamily: mono,
            WebkitFontSmoothing: "antialiased",
            "&.tag": colorsObjs.red3,
            "&.comment": {
                ...colorsObjs.green1,
                fontStyle: "italic"
            },
            "&.prolog": {
                ...colorsObjs.green1,
                fontStyle: "italic"
            },
            "&.doctype": {
                ...colorsObjs.green1,
                fontStyle: "italic"
            },
            "&.cdata": {
                ...colorsObjs.green1,
                fontStyle: "italic"
            },
            "&.string": colorsObjs.red1,
            "&.url": colorsObjs.cyan1,
            "&.symbol": colorsObjs.cyan1,
            "&.number": colorsObjs.cyan1,
            "&.boolean": colorsObjs.cyan1,
            "&.variable": colorsObjs.cyan1,
            "&.constant": colorsObjs.cyan1,
            "&.inserted": colorsObjs.cyan1,
            "&.atrule": colorsObjs.blue1,
            "&.keyword": colorsObjs.blue1,
            "&.attr-value": colorsObjs.blue1,
            "&.punctuation": colorsObjs.gray1,
            "&.operator": colorsObjs.gray1,
            "&.function": colorsObjs.gray1,
            "&.deleted": colorsObjs.red2,
            "&.important": {
                fontWeight: "bold"
            },
            "&.bold": {
                fontWeight: "bold"
            },
            "&.italic": {
                fontStyle: "italic"
            },
            "&.class-name": colorsObjs.cyan2,
            "&.selector": colorsObjs.red3,
            "&.attr-name": colorsObjs.red4,
            "&.property": colorsObjs.red4,
            "&.regex": colorsObjs.red4,
            "&.entity": colorsObjs.red4,
            "&.directive.tag .tag": {
                background: "#ffff00",
                ...colorsObjs.gray1
            }
        },
        "language-json .token.boolean": colorsObjs.blue1,
        "language-json .token.number": colorsObjs.blue1,
        "language-json .token.property": colorsObjs.cyan2,
        namespace: {
            opacity: .7
        }
    };
};
var lightSyntaxColors = {
    green1: "#008000",
    red1: "#A31515",
    red2: "#9a050f",
    red3: "#800000",
    red4: "#ff0000",
    gray1: "#393A34",
    cyan1: "#36acaa",
    cyan2: "#2B91AF",
    blue1: "#0000ff",
    blue2: "#00009f"
}, darkSyntaxColors = {
    green1: "#7C7C7C",
    red1: "#92C379",
    red2: "#9a050f",
    red3: "#A8FF60",
    red4: "#96CBFE",
    gray1: "#EDEDED",
    cyan1: "#C6C5FE",
    cyan2: "#FFFFB6",
    blue1: "#B474DD",
    blue2: "#00009f"
}, createColors = (vars)=>({
        primary: vars.colorPrimary,
        secondary: vars.colorSecondary,
        tertiary: (0, _chunkEIRT5I3ZMjs.color).tertiary,
        ancillary: (0, _chunkEIRT5I3ZMjs.color).ancillary,
        orange: (0, _chunkEIRT5I3ZMjs.color).orange,
        gold: (0, _chunkEIRT5I3ZMjs.color).gold,
        green: (0, _chunkEIRT5I3ZMjs.color).green,
        seafoam: (0, _chunkEIRT5I3ZMjs.color).seafoam,
        purple: (0, _chunkEIRT5I3ZMjs.color).purple,
        ultraviolet: (0, _chunkEIRT5I3ZMjs.color).ultraviolet,
        lightest: (0, _chunkEIRT5I3ZMjs.color).lightest,
        lighter: (0, _chunkEIRT5I3ZMjs.color).lighter,
        light: (0, _chunkEIRT5I3ZMjs.color).light,
        mediumlight: (0, _chunkEIRT5I3ZMjs.color).mediumlight,
        medium: (0, _chunkEIRT5I3ZMjs.color).medium,
        mediumdark: (0, _chunkEIRT5I3ZMjs.color).mediumdark,
        dark: (0, _chunkEIRT5I3ZMjs.color).dark,
        darker: (0, _chunkEIRT5I3ZMjs.color).darker,
        darkest: (0, _chunkEIRT5I3ZMjs.color).darkest,
        border: (0, _chunkEIRT5I3ZMjs.color).border,
        positive: (0, _chunkEIRT5I3ZMjs.color).positive,
        negative: (0, _chunkEIRT5I3ZMjs.color).negative,
        warning: (0, _chunkEIRT5I3ZMjs.color).warning,
        critical: (0, _chunkEIRT5I3ZMjs.color).critical,
        defaultText: vars.textColor || (0, _chunkEIRT5I3ZMjs.color).darkest,
        inverseText: vars.textInverseColor || (0, _chunkEIRT5I3ZMjs.color).lightest,
        positiveText: (0, _chunkEIRT5I3ZMjs.color).positiveText,
        negativeText: (0, _chunkEIRT5I3ZMjs.color).negativeText,
        warningText: (0, _chunkEIRT5I3ZMjs.color).warningText
    }), convert = (inherit = (0, _chunkEIRT5I3ZMjs.themes)[(0, _chunkEIRT5I3ZMjs.getPreferredColorScheme)()])=>{
    let { base, colorPrimary, colorSecondary, appBg, appContentBg, appPreviewBg, appBorderColor, appBorderRadius, fontBase, fontCode, textColor, textInverseColor, barTextColor, barHoverColor, barSelectedColor, barBg, buttonBg, buttonBorder, booleanBg, booleanSelectedBg, inputBg, inputBorder, inputTextColor, inputBorderRadius, brandTitle, brandUrl, brandImage, brandTarget, gridCellSize, ...rest } = inherit;
    return {
        ...rest,
        base,
        color: createColors(inherit),
        background: {
            app: appBg,
            bar: barBg,
            content: appContentBg,
            preview: appPreviewBg,
            gridCellSize: gridCellSize || (0, _chunkEIRT5I3ZMjs.background).gridCellSize,
            hoverable: (0, _chunkEIRT5I3ZMjs.background).hoverable,
            positive: (0, _chunkEIRT5I3ZMjs.background).positive,
            negative: (0, _chunkEIRT5I3ZMjs.background).negative,
            warning: (0, _chunkEIRT5I3ZMjs.background).warning,
            critical: (0, _chunkEIRT5I3ZMjs.background).critical
        },
        typography: {
            fonts: {
                base: fontBase,
                mono: fontCode
            },
            weight: (0, _chunkEIRT5I3ZMjs.typography).weight,
            size: (0, _chunkEIRT5I3ZMjs.typography).size
        },
        animation,
        easing,
        input: {
            background: inputBg,
            border: inputBorder,
            borderRadius: inputBorderRadius,
            color: inputTextColor
        },
        button: {
            background: buttonBg || inputBg,
            border: buttonBorder || inputBorder
        },
        boolean: {
            background: booleanBg || inputBorder,
            selectedBackground: booleanSelectedBg || inputBg
        },
        layoutMargin: 10,
        appBorderColor,
        appBorderRadius,
        barTextColor,
        barHoverColor: barHoverColor || colorSecondary,
        barSelectedColor: barSelectedColor || colorSecondary,
        barBg,
        brand: {
            title: brandTitle,
            url: brandUrl,
            image: brandImage || (brandTitle ? null : void 0),
            target: brandTarget
        },
        code: create2({
            colors: base === "light" ? lightSyntaxColors : darkSyntaxColors,
            mono: fontCode
        }),
        addonActionsTheme: {
            ...base === "light" ? chromeLight : chromeDark,
            BASE_FONT_FAMILY: fontCode,
            BASE_FONT_SIZE: (0, _chunkEIRT5I3ZMjs.typography).size.s2 - 1,
            BASE_LINE_HEIGHT: "18px",
            BASE_BACKGROUND_COLOR: "transparent",
            BASE_COLOR: textColor,
            ARROW_COLOR: (0, _chunkEIRT5I3ZMjs.curriedOpacify$1)(.2, appBorderColor),
            ARROW_MARGIN_RIGHT: 4,
            ARROW_FONT_SIZE: 8,
            TREENODE_FONT_FAMILY: fontCode,
            TREENODE_FONT_SIZE: (0, _chunkEIRT5I3ZMjs.typography).size.s2 - 1,
            TREENODE_LINE_HEIGHT: "18px",
            TREENODE_PADDING_LEFT: 12
        }
    };
};
var isEmpty = (o)=>Object.keys(o).length === 0, isObject = (o)=>o != null && typeof o == "object", hasOwnProperty2 = (o, ...args)=>Object.prototype.hasOwnProperty.call(o, ...args);
var makeObjectWithoutPrototype = ()=>Object.create(null);
var deletedDiff = (lhs, rhs)=>lhs === rhs || !isObject(lhs) || !isObject(rhs) ? {} : Object.keys(lhs).reduce((acc, key)=>{
        if (hasOwnProperty2(rhs, key)) {
            let difference = deletedDiff(lhs[key], rhs[key]);
            return isObject(difference) && isEmpty(difference) || (acc[key] = difference), acc;
        }
        return acc[key] = void 0, acc;
    }, makeObjectWithoutPrototype()), deleted_default = deletedDiff;
function dedent(templ) {
    for(var values = [], _i = 1; _i < arguments.length; _i++)values[_i - 1] = arguments[_i];
    var strings = Array.from(typeof templ == "string" ? [
        templ
    ] : templ);
    strings[strings.length - 1] = strings[strings.length - 1].replace(/\r?\n([\t ]*)$/, "");
    var indentLengths = strings.reduce(function(arr, str) {
        var matches = str.match(/\n([\t ]+|(?!\s).)/g);
        return matches ? arr.concat(matches.map(function(match2) {
            var _a, _b;
            return (_b = (_a = match2.match(/[\t ]/g)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
        })) : arr;
    }, []);
    if (indentLengths.length) {
        var pattern_1 = new RegExp(`
[	 ]{` + Math.min.apply(Math, indentLengths) + "}", "g");
        strings = strings.map(function(str) {
            return str.replace(pattern_1, `
`);
        });
    }
    strings[0] = strings[0].replace(/^\r?\n/, "");
    var string = strings[0];
    return values.forEach(function(value, i) {
        var endentations = string.match(/(?:^|\n)( *)$/), endentation = endentations ? endentations[1] : "", indentedValue = value;
        typeof value == "string" && value.includes(`
`) && (indentedValue = String(value).split(`
`).map(function(str, i2) {
            return i2 === 0 ? str : "" + endentation + str;
        }).join(`
`)), string += indentedValue + strings[i + 1];
    }), string;
}
var ensure = (input)=>{
    if (!input) return convert((0, _chunkEIRT5I3ZMjs.light_default));
    let missing = deleted_default((0, _chunkEIRT5I3ZMjs.light_default), input);
    return Object.keys(missing).length && (0, _clientLogger.logger).warn(dedent`
          Your theme is missing properties, you should update your theme!

          theme-data missing:
        `, missing), convert(input);
};
var ignoreSsrWarning = "/* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */";

},{"./chunk-EIRT5I3Z.mjs":"23aY1","react":"jEiK2","@emotion/use-insertion-effect-with-fallbacks":"4j68w","memoizerific":"aOMtb","@storybook/client-logger":"7OFBO","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"23aY1":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__commonJS", ()=>__commonJS);
parcelHelpers.export(exports, "__toESM", ()=>__toESM);
parcelHelpers.export(exports, "background", ()=>background);
parcelHelpers.export(exports, "color", ()=>color);
parcelHelpers.export(exports, "create", ()=>create);
parcelHelpers.export(exports, "curriedOpacify$1", ()=>curriedOpacify$1);
parcelHelpers.export(exports, "darkenColor", ()=>darkenColor);
parcelHelpers.export(exports, "getPreferredColorScheme", ()=>getPreferredColorScheme);
parcelHelpers.export(exports, "light_default", ()=>light_default);
parcelHelpers.export(exports, "lightenColor", ()=>lightenColor);
parcelHelpers.export(exports, "mkColor", ()=>mkColor);
parcelHelpers.export(exports, "themes", ()=>themes);
parcelHelpers.export(exports, "typography", ()=>typography);
var _global = require("@storybook/global");
var _clientLogger = require("@storybook/client-logger");
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod)=>function() {
        return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from == "object" || typeof from == "function") for (let key of __getOwnPropNames(from))!__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, {
        get: ()=>from[key],
        enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
    });
    return to;
};
var __toESM = (mod, isNodeMode, target)=>(target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: !0
    }) : target, mod));
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
        }
        return target;
    }, _extends.apply(this, arguments);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _setPrototypeOf(o, p) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o2, p2) {
        return o2.__proto__ = p2, o2;
    }, _setPrototypeOf(o, p);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype), subClass.prototype.constructor = subClass, _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(o2) {
        return o2.__proto__ || Object.getPrototypeOf(o2);
    }, _getPrototypeOf(o);
}
function _isNativeFunction(fn) {
    try {
        return Function.toString.call(fn).indexOf("[native code]") !== -1;
    } catch  {
        return typeof fn == "function";
    }
}
function _isNativeReflectConstruct() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
    } catch  {
        return !1;
    }
}
function _construct(Parent, args, Class) {
    return _isNativeReflectConstruct() ? _construct = Reflect.construct.bind() : _construct = function(Parent2, args2, Class2) {
        var a = [
            null
        ];
        a.push.apply(a, args2);
        var Constructor = Function.bind.apply(Parent2, a), instance = new Constructor;
        return Class2 && _setPrototypeOf(instance, Class2.prototype), instance;
    }, _construct.apply(null, arguments);
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map == "function" ? new Map : void 0;
    return _wrapNativeSuper = function(Class2) {
        if (Class2 === null || !_isNativeFunction(Class2)) return Class2;
        if (typeof Class2 != "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache < "u") {
            if (_cache.has(Class2)) return _cache.get(Class2);
            _cache.set(Class2, Wrapper);
        }
        function Wrapper() {
            return _construct(Class2, arguments, _getPrototypeOf(this).constructor);
        }
        return Wrapper.prototype = Object.create(Class2.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), _setPrototypeOf(Wrapper, Class2);
    }, _wrapNativeSuper(Class);
}
var ERRORS = {
    1: `Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).

`,
    2: `Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).

`,
    3: `Passed an incorrect argument to a color function, please pass a string representation of a color.

`,
    4: `Couldn't generate valid rgb string from %s, it returned %s.

`,
    5: `Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.

`,
    6: `Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).

`,
    7: `Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).

`,
    8: `Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.

`,
    9: `Please provide a number of steps to the modularScale helper.

`,
    10: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
    11: `Invalid value passed as base to modularScale, expected number or em string but got "%s"

`,
    12: `Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.

`,
    13: `Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.

`,
    14: `Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.

`,
    15: `Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.

`,
    16: `You must provide a template to this method.

`,
    17: `You passed an unsupported selector state to this method.

`,
    18: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
    19: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
    20: `expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
    21: "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    22: "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    23: `fontFace expects a name of a font-family.

`,
    24: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
    25: `fontFace expects localFonts to be an array.

`,
    26: `fontFace expects fileFormats to be an array.

`,
    27: `radialGradient requries at least 2 color-stops to properly render.

`,
    28: `Please supply a filename to retinaImage() as the first argument.

`,
    29: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
    30: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    31: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation

`,
    32: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])
To pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')

`,
    33: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation

`,
    34: `borderRadius expects a radius value as a string or number as the second argument.

`,
    35: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
    36: `Property must be a string value.

`,
    37: `Syntax Error at %s.

`,
    38: `Formula contains a function that needs parentheses at %s.

`,
    39: `Formula is missing closing parenthesis at %s.

`,
    40: `Formula has too many closing parentheses at %s.

`,
    41: `All values in a formula must have the same unit or be unitless.

`,
    42: `Please provide a number of steps to the modularScale helper.

`,
    43: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
    44: `Invalid value passed as base to modularScale, expected number or em/rem string but got %s.

`,
    45: `Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.

`,
    46: `Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.

`,
    47: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
    48: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
    49: `Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
    50: `Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.

`,
    51: `Expects the first argument object to have the properties prop, fromSize, and toSize.

`,
    52: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
    53: `fontFace expects localFonts to be an array.

`,
    54: `fontFace expects fileFormats to be an array.

`,
    55: `fontFace expects a name of a font-family.

`,
    56: `linearGradient requries at least 2 color-stops to properly render.

`,
    57: `radialGradient requries at least 2 color-stops to properly render.

`,
    58: `Please supply a filename to retinaImage() as the first argument.

`,
    59: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
    60: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    61: `Property must be a string value.

`,
    62: `borderRadius expects a radius value as a string or number as the second argument.

`,
    63: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
    64: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.

`,
    65: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').

`,
    66: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.

`,
    67: `You must provide a template to this method.

`,
    68: `You passed an unsupported selector state to this method.

`,
    69: `Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.

`,
    70: `Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.

`,
    71: `Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.

`,
    72: `Passed invalid base value %s to %s(), please pass a value like "12px" or 12.

`,
    73: `Please provide a valid CSS variable.

`,
    74: `CSS variable not found and no default was provided.

`,
    75: `important requires a valid style object, got a %s instead.

`,
    76: `fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.

`,
    77: `remToPx expects a value in "rem" but you provided it in "%s".

`,
    78: `base must be set in "px" or "%" but you set it in "%s".
`
};
function format() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var a = args[0], b = [], c;
    for(c = 1; c < args.length; c += 1)b.push(args[c]);
    return b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    }), a;
}
var PolishedError = function(_Error) {
    _inheritsLoose(PolishedError2, _Error);
    function PolishedError2(code) {
        for(var _this, _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return _this = _Error.call(this, format.apply(void 0, [
            ERRORS[code]
        ].concat(args))) || this, _assertThisInitialized(_this);
    }
    return PolishedError2;
}(_wrapNativeSuper(Error));
function colorToInt(color2) {
    return Math.round(color2 * 255);
}
function convertToInt(red, green, blue) {
    return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}
function hslToRgb(hue, saturation, lightness, convert) {
    if (convert === void 0 && (convert = convertToInt), saturation === 0) return convert(lightness, lightness, lightness);
    var huePrime = (hue % 360 + 360) % 360 / 60, chroma = (1 - Math.abs(2 * lightness - 1)) * saturation, secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1)), red = 0, green = 0, blue = 0;
    huePrime >= 0 && huePrime < 1 ? (red = chroma, green = secondComponent) : huePrime >= 1 && huePrime < 2 ? (red = secondComponent, green = chroma) : huePrime >= 2 && huePrime < 3 ? (green = chroma, blue = secondComponent) : huePrime >= 3 && huePrime < 4 ? (green = secondComponent, blue = chroma) : huePrime >= 4 && huePrime < 5 ? (red = secondComponent, blue = chroma) : huePrime >= 5 && huePrime < 6 && (red = chroma, blue = secondComponent);
    var lightnessModification = lightness - chroma / 2, finalRed = red + lightnessModification, finalGreen = green + lightnessModification, finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
var namedColorMap = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "00ffff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "0000ff",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "00ffff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "ff00ff",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "639",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};
function nameToHex(color2) {
    if (typeof color2 != "string") return color2;
    var normalizedColorName = color2.toLowerCase();
    return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color2;
}
var hexRegex = /^#[a-fA-F0-9]{6}$/, hexRgbaRegex = /^#[a-fA-F0-9]{8}$/, reducedHexRegex = /^#[a-fA-F0-9]{3}$/, reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/, rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i, rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i, hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i, hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
function parseToRgb(color2) {
    if (typeof color2 != "string") throw new PolishedError(3);
    var normalizedColor = nameToHex(color2);
    if (normalizedColor.match(hexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match(hexRgbaRegex)) {
        var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
            green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
            blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
            alpha
        };
    }
    if (normalizedColor.match(reducedHexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
    if (normalizedColor.match(reducedRgbaHexRegex)) {
        var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
            green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
            blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
            alpha: _alpha
        };
    }
    var rgbMatched = rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt("" + rgbMatched[1], 10),
        green: parseInt("" + rgbMatched[2], 10),
        blue: parseInt("" + rgbMatched[3], 10)
    };
    var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));
    if (rgbaMatched) return {
        red: parseInt("" + rgbaMatched[1], 10),
        green: parseInt("" + rgbaMatched[2], 10),
        blue: parseInt("" + rgbaMatched[3], 10),
        alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
    var hslMatched = hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt("" + hslMatched[1], 10), saturation = parseInt("" + hslMatched[2], 10) / 100, lightness = parseInt("" + hslMatched[3], 10) / 100, rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")", hslRgbMatched = rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new PolishedError(4, normalizedColor, rgbColorString);
        return {
            red: parseInt("" + hslRgbMatched[1], 10),
            green: parseInt("" + hslRgbMatched[2], 10),
            blue: parseInt("" + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));
    if (hslaMatched) {
        var _hue = parseInt("" + hslaMatched[1], 10), _saturation = parseInt("" + hslaMatched[2], 10) / 100, _lightness = parseInt("" + hslaMatched[3], 10) / 100, _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")", _hslRgbMatched = rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new PolishedError(4, normalizedColor, _rgbColorString);
        return {
            red: parseInt("" + _hslRgbMatched[1], 10),
            green: parseInt("" + _hslRgbMatched[2], 10),
            blue: parseInt("" + _hslRgbMatched[3], 10),
            alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
        };
    }
    throw new PolishedError(5);
}
function rgbToHsl(color2) {
    var red = color2.red / 255, green = color2.green / 255, blue = color2.blue / 255, max = Math.max(red, green, blue), min = Math.min(red, green, blue), lightness = (max + min) / 2;
    if (max === min) return color2.alpha !== void 0 ? {
        hue: 0,
        saturation: 0,
        lightness,
        alpha: color2.alpha
    } : {
        hue: 0,
        saturation: 0,
        lightness
    };
    var hue, delta = max - min, saturation = lightness > .5 ? delta / (2 - max - min) : delta / (max + min);
    switch(max){
        case red:
            hue = (green - blue) / delta + (green < blue ? 6 : 0);
            break;
        case green:
            hue = (blue - red) / delta + 2;
            break;
        default:
            hue = (red - green) / delta + 4;
            break;
    }
    return hue *= 60, color2.alpha !== void 0 ? {
        hue,
        saturation,
        lightness,
        alpha: color2.alpha
    } : {
        hue,
        saturation,
        lightness
    };
}
function parseToHsl(color2) {
    return rgbToHsl(parseToRgb(color2));
}
var reduceHexValue = function(value) {
    return value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6] ? "#" + value[1] + value[3] + value[5] : value;
}, reduceHexValue$1 = reduceHexValue;
function numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
function colorToHex(color2) {
    return numberToHex(Math.round(color2 * 255));
}
function convertToHex(red, green, blue) {
    return reduceHexValue$1("#" + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}
function hslToHex(hue, saturation, lightness) {
    return hslToRgb(hue, saturation, lightness, convertToHex);
}
function hsl(value, saturation, lightness) {
    if (typeof value == "number" && typeof saturation == "number" && typeof lightness == "number") return hslToHex(value, saturation, lightness);
    if (typeof value == "object" && saturation === void 0 && lightness === void 0) return hslToHex(value.hue, value.saturation, value.lightness);
    throw new PolishedError(1);
}
function hsla(value, saturation, lightness, alpha) {
    if (typeof value == "number" && typeof saturation == "number" && typeof lightness == "number" && typeof alpha == "number") return alpha >= 1 ? hslToHex(value, saturation, lightness) : "rgba(" + hslToRgb(value, saturation, lightness) + "," + alpha + ")";
    if (typeof value == "object" && saturation === void 0 && lightness === void 0 && alpha === void 0) return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
    throw new PolishedError(2);
}
function rgb(value, green, blue) {
    if (typeof value == "number" && typeof green == "number" && typeof blue == "number") return reduceHexValue$1("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
    if (typeof value == "object" && green === void 0 && blue === void 0) return reduceHexValue$1("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
    throw new PolishedError(6);
}
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue == "string" && typeof secondValue == "number") {
        var rgbValue = parseToRgb(firstValue);
        return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
    } else {
        if (typeof firstValue == "number" && typeof secondValue == "number" && typeof thirdValue == "number" && typeof fourthValue == "number") return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
        if (typeof firstValue == "object" && secondValue === void 0 && thirdValue === void 0 && fourthValue === void 0) return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
    }
    throw new PolishedError(7);
}
var isRgb = function(color2) {
    return typeof color2.red == "number" && typeof color2.green == "number" && typeof color2.blue == "number" && (typeof color2.alpha != "number" || typeof color2.alpha > "u");
}, isRgba = function(color2) {
    return typeof color2.red == "number" && typeof color2.green == "number" && typeof color2.blue == "number" && typeof color2.alpha == "number";
}, isHsl = function(color2) {
    return typeof color2.hue == "number" && typeof color2.saturation == "number" && typeof color2.lightness == "number" && (typeof color2.alpha != "number" || typeof color2.alpha > "u");
}, isHsla = function(color2) {
    return typeof color2.hue == "number" && typeof color2.saturation == "number" && typeof color2.lightness == "number" && typeof color2.alpha == "number";
};
function toColorString(color2) {
    if (typeof color2 != "object") throw new PolishedError(8);
    if (isRgba(color2)) return rgba(color2);
    if (isRgb(color2)) return rgb(color2);
    if (isHsla(color2)) return hsla(color2);
    if (isHsl(color2)) return hsl(color2);
    throw new PolishedError(8);
}
function curried(f, length, acc) {
    return function() {
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
    };
}
function curry(f) {
    return curried(f, f.length, []);
}
function guard(lowerBoundary, upperBoundary, value) {
    return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
function darken(amount, color2) {
    if (color2 === "transparent") return color2;
    var hslColor = parseToHsl(color2);
    return toColorString(_extends({}, hslColor, {
        lightness: guard(0, 1, hslColor.lightness - parseFloat(amount))
    }));
}
var curriedDarken = curry(darken), curriedDarken$1 = curriedDarken;
function lighten(amount, color2) {
    if (color2 === "transparent") return color2;
    var hslColor = parseToHsl(color2);
    return toColorString(_extends({}, hslColor, {
        lightness: guard(0, 1, hslColor.lightness + parseFloat(amount))
    }));
}
var curriedLighten = curry(lighten), curriedLighten$1 = curriedLighten;
function opacify(amount, color2) {
    if (color2 === "transparent") return color2;
    var parsedColor = parseToRgb(color2), alpha = typeof parsedColor.alpha == "number" ? parsedColor.alpha : 1, colorWithAlpha = _extends({}, parsedColor, {
        alpha: guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
    });
    return rgba(colorWithAlpha);
}
var curriedOpacify = curry(opacify), curriedOpacify$1 = curriedOpacify;
function transparentize(amount, color2) {
    if (color2 === "transparent") return color2;
    var parsedColor = parseToRgb(color2), alpha = typeof parsedColor.alpha == "number" ? parsedColor.alpha : 1, colorWithAlpha = _extends({}, parsedColor, {
        alpha: guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
    });
    return rgba(colorWithAlpha);
}
var curriedTransparentize = curry(transparentize), curriedTransparentize$1 = curriedTransparentize;
var color = {
    primary: "#FF4785",
    secondary: "#029CFD",
    tertiary: "#FAFBFC",
    ancillary: "#22a699",
    orange: "#FC521F",
    gold: "#FFAE00",
    green: "#66BF3C",
    seafoam: "#37D5D3",
    purple: "#6F2CAC",
    ultraviolet: "#2A0481",
    lightest: "#FFFFFF",
    lighter: "#F7FAFC",
    light: "#EEF3F6",
    mediumlight: "#ECF4F9",
    medium: "#D9E8F2",
    mediumdark: "#73828C",
    dark: "#5C6870",
    darker: "#454E54",
    darkest: "#2E3438",
    border: "hsla(203, 50%, 30%, 0.15)",
    positive: "#66BF3C",
    negative: "#FF4400",
    warning: "#E69D00",
    critical: "#FFFFFF",
    defaultText: "#2E3438",
    inverseText: "#FFFFFF",
    positiveText: "#448028",
    negativeText: "#D43900",
    warningText: "#A15C20"
}, background = {
    app: "#F6F9FC",
    bar: color.lightest,
    content: color.lightest,
    preview: color.lightest,
    gridCellSize: 10,
    hoverable: curriedTransparentize$1(.9, color.secondary),
    positive: "#E1FFD4",
    negative: "#FEDED2",
    warning: "#FFF5CF",
    critical: "#FF4400"
}, typography = {
    fonts: {
        base: [
            '"Nunito Sans"',
            "-apple-system",
            '".SFNSText-Regular"',
            '"San Francisco"',
            "BlinkMacSystemFont",
            '"Segoe UI"',
            '"Helvetica Neue"',
            "Helvetica",
            "Arial",
            "sans-serif"
        ].join(", "),
        mono: [
            "ui-monospace",
            "Menlo",
            "Monaco",
            '"Roboto Mono"',
            '"Oxygen Mono"',
            '"Ubuntu Monospace"',
            '"Source Code Pro"',
            '"Droid Sans Mono"',
            '"Courier New"',
            "monospace"
        ].join(", ")
    },
    weight: {
        regular: 400,
        bold: 700
    },
    size: {
        s1: 12,
        s2: 14,
        s3: 16,
        m1: 20,
        m2: 24,
        m3: 28,
        l1: 32,
        l2: 40,
        l3: 48,
        code: 90
    }
};
var theme = {
    base: "light",
    colorPrimary: "#FF4785",
    colorSecondary: "#029CFD",
    appBg: background.app,
    appContentBg: color.lightest,
    appPreviewBg: color.lightest,
    appBorderColor: color.border,
    appBorderRadius: 4,
    fontBase: typography.fonts.base,
    fontCode: typography.fonts.mono,
    textColor: color.darkest,
    textInverseColor: color.lightest,
    textMutedColor: color.dark,
    barTextColor: color.mediumdark,
    barHoverColor: color.secondary,
    barSelectedColor: color.secondary,
    barBg: color.lightest,
    buttonBg: background.app,
    buttonBorder: color.medium,
    booleanBg: color.mediumlight,
    booleanSelectedBg: color.lightest,
    inputBg: color.lightest,
    inputBorder: color.border,
    inputTextColor: color.darkest,
    inputBorderRadius: 4
}, light_default = theme;
var theme2 = {
    base: "dark",
    colorPrimary: "#FF4785",
    colorSecondary: "#029CFD",
    appBg: "#222425",
    appContentBg: "#1B1C1D",
    appPreviewBg: color.lightest,
    appBorderColor: "rgba(255,255,255,.1)",
    appBorderRadius: 4,
    fontBase: typography.fonts.base,
    fontCode: typography.fonts.mono,
    textColor: "#C9CDCF",
    textInverseColor: "#222425",
    textMutedColor: "#798186",
    barTextColor: "#798186",
    barHoverColor: color.secondary,
    barSelectedColor: color.secondary,
    barBg: "#292C2E",
    buttonBg: "#222425",
    buttonBorder: "rgba(255,255,255,.1)",
    booleanBg: "#222425",
    booleanSelectedBg: "#2E3438",
    inputBg: "#1B1C1D",
    inputBorder: "rgba(255,255,255,.1)",
    inputTextColor: color.lightest,
    inputBorderRadius: 4
}, dark_default = theme2;
var { window: globalWindow } = (0, _global.global), mkColor = (color2)=>({
        color: color2
    }), isColorString = (color2)=>typeof color2 != "string" ? ((0, _clientLogger.logger).warn(`Color passed to theme object should be a string. Instead ${color2}(${typeof color2}) was passed.`), !1) : !0, isValidColorForPolished = (color2)=>!/(gradient|var|calc)/.test(color2), applyPolished = (type, color2)=>type === "darken" ? rgba(`${curriedDarken$1(1, color2)}`, .95) : type === "lighten" ? rgba(`${curriedLighten$1(1, color2)}`, .95) : color2, colorFactory = (type)=>(color2)=>{
        if (!isColorString(color2) || !isValidColorForPolished(color2)) return color2;
        try {
            return applyPolished(type, color2);
        } catch  {
            return color2;
        }
    }, lightenColor = colorFactory("lighten"), darkenColor = colorFactory("darken"), getPreferredColorScheme = ()=>!globalWindow || !globalWindow.matchMedia ? "light" : globalWindow.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
var themes = {
    light: light_default,
    dark: dark_default,
    normal: light_default
}, preferredColorScheme = getPreferredColorScheme(), create = (vars = {
    base: preferredColorScheme
}, rest)=>{
    let inherit = {
        ...themes[preferredColorScheme],
        ...themes[vars.base] || {},
        ...vars,
        base: themes[vars.base] ? vars.base : preferredColorScheme
    };
    return {
        ...rest,
        ...inherit,
        barSelectedColor: vars.barSelectedColor || inherit.colorSecondary
    };
};

},{"@storybook/global":"4g4co","@storybook/client-logger":"7OFBO","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"4j68w":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInsertionEffectAlwaysWithSyncFallback", ()=>useInsertionEffectAlwaysWithSyncFallback);
parcelHelpers.export(exports, "useInsertionEffectWithLayoutFallback", ()=>useInsertionEffectWithLayoutFallback);
var _react = require("react");
var syncFallback = function syncFallback(create) {
    return create();
};
var useInsertionEffect = _react["useInsertionEffect"] ? _react["useInsertionEffect"] : false;
var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
var useInsertionEffectWithLayoutFallback = useInsertionEffect || _react.useLayoutEffect;

},{"react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"2BItW":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionBar", ()=>(0, _chunkLWG3MFN2Mjs.ActionBar));
parcelHelpers.export(exports, "ScrollArea", ()=>(0, _chunkLWG3MFN2Mjs.ScrollArea));
parcelHelpers.export(exports, "createCopyToClipboardFunction", ()=>(0, _chunkLWG3MFN2Mjs.createCopyToClipboardFunction));
parcelHelpers.export(exports, "A", ()=>A);
parcelHelpers.export(exports, "AddonPanel", ()=>AddonPanel);
parcelHelpers.export(exports, "Badge", ()=>Badge);
parcelHelpers.export(exports, "Bar", ()=>Bar);
parcelHelpers.export(exports, "Blockquote", ()=>Blockquote);
parcelHelpers.export(exports, "Button", ()=>Button);
parcelHelpers.export(exports, "ClipboardCode", ()=>ClipboardCode);
parcelHelpers.export(exports, "Code", ()=>Code);
parcelHelpers.export(exports, "DL", ()=>DL);
parcelHelpers.export(exports, "Div", ()=>Div);
parcelHelpers.export(exports, "DocumentWrapper", ()=>DocumentWrapper);
parcelHelpers.export(exports, "ErrorFormatter", ()=>ErrorFormatter);
parcelHelpers.export(exports, "FlexBar", ()=>FlexBar);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "H1", ()=>H1);
parcelHelpers.export(exports, "H2", ()=>H2);
parcelHelpers.export(exports, "H3", ()=>H3);
parcelHelpers.export(exports, "H4", ()=>H4);
parcelHelpers.export(exports, "H5", ()=>H5);
parcelHelpers.export(exports, "H6", ()=>H6);
parcelHelpers.export(exports, "HR", ()=>HR);
parcelHelpers.export(exports, "IconButton", ()=>IconButton);
parcelHelpers.export(exports, "IconButtonSkeleton", ()=>IconButtonSkeleton);
parcelHelpers.export(exports, "Icons", ()=>Icons);
parcelHelpers.export(exports, "Img", ()=>Img);
parcelHelpers.export(exports, "LI", ()=>LI);
parcelHelpers.export(exports, "Link", ()=>Link2);
parcelHelpers.export(exports, "ListItem", ()=>ListItem_default);
parcelHelpers.export(exports, "Loader", ()=>Loader);
parcelHelpers.export(exports, "OL", ()=>OL);
parcelHelpers.export(exports, "P", ()=>P);
parcelHelpers.export(exports, "Placeholder", ()=>Placeholder);
parcelHelpers.export(exports, "Pre", ()=>Pre);
parcelHelpers.export(exports, "ResetWrapper", ()=>ResetWrapper);
parcelHelpers.export(exports, "Separator", ()=>Separator);
parcelHelpers.export(exports, "Spaced", ()=>Spaced);
parcelHelpers.export(exports, "Span", ()=>Span);
parcelHelpers.export(exports, "StorybookIcon", ()=>StorybookIcon);
parcelHelpers.export(exports, "StorybookLogo", ()=>StorybookLogo);
parcelHelpers.export(exports, "Symbols", ()=>Symbols);
parcelHelpers.export(exports, "SyntaxHighlighter", ()=>SyntaxHighlighter2);
parcelHelpers.export(exports, "TT", ()=>TT);
parcelHelpers.export(exports, "TabBar", ()=>TabBar);
parcelHelpers.export(exports, "TabButton", ()=>TabButton);
parcelHelpers.export(exports, "TabWrapper", ()=>TabWrapper);
parcelHelpers.export(exports, "Table", ()=>Table);
parcelHelpers.export(exports, "Tabs", ()=>Tabs);
parcelHelpers.export(exports, "TabsState", ()=>TabsState);
parcelHelpers.export(exports, "TooltipLinkList", ()=>TooltipLinkList);
parcelHelpers.export(exports, "TooltipMessage", ()=>TooltipMessage);
parcelHelpers.export(exports, "TooltipNote", ()=>TooltipNote);
parcelHelpers.export(exports, "UL", ()=>UL);
parcelHelpers.export(exports, "WithTooltip", ()=>WithTooltip);
parcelHelpers.export(exports, "WithTooltipPure", ()=>WithTooltipPure);
parcelHelpers.export(exports, "Zoom", ()=>Zoom);
parcelHelpers.export(exports, "codeCommon", ()=>codeCommon);
parcelHelpers.export(exports, "components", ()=>components2);
parcelHelpers.export(exports, "getStoryHref", ()=>getStoryHref);
parcelHelpers.export(exports, "icons", ()=>icons);
parcelHelpers.export(exports, "interleaveSeparators", ()=>interleaveSeparators);
parcelHelpers.export(exports, "nameSpaceClassNames", ()=>nameSpaceClassNames);
parcelHelpers.export(exports, "resetComponents", ()=>resetComponents);
parcelHelpers.export(exports, "withReset", ()=>withReset);
var _chunkLWG3MFN2Mjs = require("./chunk-LWG3MFN2.mjs");
var _chunkNE5YGCQBMjs = require("./chunk-NE5YGCQB.mjs");
var _chunkMUPK3MH6Mjs = require("./chunk-MUPK3MH6.mjs");
var _chunkISRAU5IPMjs = require("./chunk-ISRAU5IP.mjs");
var _chunkYU6L2YXVMjs = require("./chunk-YU6L2YXV.mjs");
var _chunkVSDH24NKMjs = require("./chunk-VSDH24NK.mjs");
var _chunkBNQCH2A2Mjs = require("./chunk-BNQCH2A2.mjs");
var _chunkUDRSICRZMjs = require("./chunk-UDRSICRZ.mjs");
var _chunkJ6EJ35VBMjs = require("./chunk-J6EJ35VB.mjs");
var _chunkHNGDCMHDMjs = require("./chunk-HNGDCMHD.mjs");
var _chunk4Y2S2TEPMjs = require("./chunk-4Y2S2TEP.mjs");
var _chunkCW4JFC2IMjs = require("./chunk-CW4JFC2I.mjs");
var _chunk7PYIL73XMjs = require("./chunk-7PYIL73X.mjs");
var _chunkSWV57YYCMjs = require("./chunk-SWV57YYC.mjs");
var _chunkMNLJ4LIXMjs = require("./chunk-MNLJ4LIX.mjs");
var _chunkDHRX2IL7Mjs = require("./chunk-DHRX2IL7.mjs");
var _chunkJRLSWQMAMjs = require("./chunk-JRLSWQMA.mjs");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _theming = require("@storybook/theming");
var _useResizeObserver = require("use-resize-observer");
var _useResizeObserverDefault = parcelHelpers.interopDefault(_useResizeObserver);
var _global = require("@storybook/global");
var _memoizerific = require("memoizerific");
var _memoizerificDefault = parcelHelpers.interopDefault(_memoizerific);
var _csf = require("@storybook/csf");
var nameSpaceClassNames = ({ ...props }, key)=>{
    let classes = [
        props.class,
        props.className
    ];
    return delete props.class, props.className = [
        "sbdocs",
        `sbdocs-${key}`,
        ...classes
    ].filter(Boolean).join(" "), props;
};
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
        }
        return target;
    }, _extends.apply(this, arguments);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _setPrototypeOf(o, p) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o2, p2) {
        return o2.__proto__ = p2, o2;
    }, _setPrototypeOf(o, p);
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype), subClass.prototype.constructor = subClass, _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(o2) {
        return o2.__proto__ || Object.getPrototypeOf(o2);
    }, _getPrototypeOf(o);
}
function _isNativeFunction(fn) {
    try {
        return Function.toString.call(fn).indexOf("[native code]") !== -1;
    } catch  {
        return typeof fn == "function";
    }
}
function _isNativeReflectConstruct() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
    } catch  {
        return !1;
    }
}
function _construct(Parent, args, Class) {
    return _isNativeReflectConstruct() ? _construct = Reflect.construct.bind() : _construct = function(Parent2, args2, Class2) {
        var a = [
            null
        ];
        a.push.apply(a, args2);
        var Constructor = Function.bind.apply(Parent2, a), instance = new Constructor;
        return Class2 && _setPrototypeOf(instance, Class2.prototype), instance;
    }, _construct.apply(null, arguments);
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map == "function" ? new Map : void 0;
    return _wrapNativeSuper = function(Class2) {
        if (Class2 === null || !_isNativeFunction(Class2)) return Class2;
        if (typeof Class2 != "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache < "u") {
            if (_cache.has(Class2)) return _cache.get(Class2);
            _cache.set(Class2, Wrapper3);
        }
        function Wrapper3() {
            return _construct(Class2, arguments, _getPrototypeOf(this).constructor);
        }
        return Wrapper3.prototype = Object.create(Class2.prototype, {
            constructor: {
                value: Wrapper3,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), _setPrototypeOf(Wrapper3, Class2);
    }, _wrapNativeSuper(Class);
}
var ERRORS = {
    1: `Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).

`,
    2: `Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).

`,
    3: `Passed an incorrect argument to a color function, please pass a string representation of a color.

`,
    4: `Couldn't generate valid rgb string from %s, it returned %s.

`,
    5: `Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.

`,
    6: `Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).

`,
    7: `Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).

`,
    8: `Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.

`,
    9: `Please provide a number of steps to the modularScale helper.

`,
    10: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
    11: `Invalid value passed as base to modularScale, expected number or em string but got "%s"

`,
    12: `Expected a string ending in "px" or a number passed as the first argument to %s(), got "%s" instead.

`,
    13: `Expected a string ending in "px" or a number passed as the second argument to %s(), got "%s" instead.

`,
    14: `Passed invalid pixel value ("%s") to %s(), please pass a value like "12px" or 12.

`,
    15: `Passed invalid base value ("%s") to %s(), please pass a value like "12px" or 12.

`,
    16: `You must provide a template to this method.

`,
    17: `You passed an unsupported selector state to this method.

`,
    18: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
    19: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
    20: `expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
    21: "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    22: "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    23: `fontFace expects a name of a font-family.

`,
    24: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
    25: `fontFace expects localFonts to be an array.

`,
    26: `fontFace expects fileFormats to be an array.

`,
    27: `radialGradient requries at least 2 color-stops to properly render.

`,
    28: `Please supply a filename to retinaImage() as the first argument.

`,
    29: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
    30: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    31: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation

`,
    32: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])
To pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')

`,
    33: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation

`,
    34: `borderRadius expects a radius value as a string or number as the second argument.

`,
    35: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
    36: `Property must be a string value.

`,
    37: `Syntax Error at %s.

`,
    38: `Formula contains a function that needs parentheses at %s.

`,
    39: `Formula is missing closing parenthesis at %s.

`,
    40: `Formula has too many closing parentheses at %s.

`,
    41: `All values in a formula must have the same unit or be unitless.

`,
    42: `Please provide a number of steps to the modularScale helper.

`,
    43: `Please pass a number or one of the predefined scales to the modularScale helper as the ratio.

`,
    44: `Invalid value passed as base to modularScale, expected number or em/rem string but got %s.

`,
    45: `Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.

`,
    46: `Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.

`,
    47: `minScreen and maxScreen must be provided as stringified numbers with the same units.

`,
    48: `fromSize and toSize must be provided as stringified numbers with the same units.

`,
    49: `Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.

`,
    50: `Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.

`,
    51: `Expects the first argument object to have the properties prop, fromSize, and toSize.

`,
    52: `fontFace expects either the path to the font file(s) or a name of a local copy.

`,
    53: `fontFace expects localFonts to be an array.

`,
    54: `fontFace expects fileFormats to be an array.

`,
    55: `fontFace expects a name of a font-family.

`,
    56: `linearGradient requries at least 2 color-stops to properly render.

`,
    57: `radialGradient requries at least 2 color-stops to properly render.

`,
    58: `Please supply a filename to retinaImage() as the first argument.

`,
    59: `Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.

`,
    60: "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    61: `Property must be a string value.

`,
    62: `borderRadius expects a radius value as a string or number as the second argument.

`,
    63: `borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.

`,
    64: `The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.

`,
    65: `To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').

`,
    66: `The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.

`,
    67: `You must provide a template to this method.

`,
    68: `You passed an unsupported selector state to this method.

`,
    69: `Expected a string ending in "px" or a number passed as the first argument to %s(), got %s instead.

`,
    70: `Expected a string ending in "px" or a number passed as the second argument to %s(), got %s instead.

`,
    71: `Passed invalid pixel value %s to %s(), please pass a value like "12px" or 12.

`,
    72: `Passed invalid base value %s to %s(), please pass a value like "12px" or 12.

`,
    73: `Please provide a valid CSS variable.

`,
    74: `CSS variable not found and no default was provided.

`,
    75: `important requires a valid style object, got a %s instead.

`,
    76: `fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.

`,
    77: `remToPx expects a value in "rem" but you provided it in "%s".

`,
    78: `base must be set in "px" or "%" but you set it in "%s".
`
};
function format() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var a = args[0], b = [], c;
    for(c = 1; c < args.length; c += 1)b.push(args[c]);
    return b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    }), a;
}
var PolishedError = function(_Error) {
    _inheritsLoose(PolishedError2, _Error);
    function PolishedError2(code) {
        var _this;
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        _this = _Error.call(this, format.apply(void 0, [
            ERRORS[code]
        ].concat(args))) || this;
        return _assertThisInitialized(_this);
    }
    return PolishedError2;
}(_wrapNativeSuper(Error));
function colorToInt(color2) {
    return Math.round(color2 * 255);
}
function convertToInt(red, green, blue) {
    return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}
function hslToRgb(hue, saturation, lightness, convert) {
    if (convert === void 0 && (convert = convertToInt), saturation === 0) return convert(lightness, lightness, lightness);
    var huePrime = (hue % 360 + 360) % 360 / 60, chroma = (1 - Math.abs(2 * lightness - 1)) * saturation, secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1)), red = 0, green = 0, blue = 0;
    huePrime >= 0 && huePrime < 1 ? (red = chroma, green = secondComponent) : huePrime >= 1 && huePrime < 2 ? (red = secondComponent, green = chroma) : huePrime >= 2 && huePrime < 3 ? (green = chroma, blue = secondComponent) : huePrime >= 3 && huePrime < 4 ? (green = secondComponent, blue = chroma) : huePrime >= 4 && huePrime < 5 ? (red = secondComponent, blue = chroma) : huePrime >= 5 && huePrime < 6 && (red = chroma, blue = secondComponent);
    var lightnessModification = lightness - chroma / 2, finalRed = red + lightnessModification, finalGreen = green + lightnessModification, finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
var namedColorMap = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "00ffff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "0000ff",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "00ffff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "ff00ff",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "639",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};
function nameToHex(color2) {
    if (typeof color2 != "string") return color2;
    var normalizedColorName = color2.toLowerCase();
    return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color2;
}
var hexRegex = /^#[a-fA-F0-9]{6}$/, hexRgbaRegex = /^#[a-fA-F0-9]{8}$/, reducedHexRegex = /^#[a-fA-F0-9]{3}$/, reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/, rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i, rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i, hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i, hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
function parseToRgb(color2) {
    if (typeof color2 != "string") throw new PolishedError(3);
    var normalizedColor = nameToHex(color2);
    if (normalizedColor.match(hexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match(hexRgbaRegex)) {
        var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
            green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
            blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
            alpha
        };
    }
    if (normalizedColor.match(reducedHexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
    if (normalizedColor.match(reducedRgbaHexRegex)) {
        var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
            green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
            blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
            alpha: _alpha
        };
    }
    var rgbMatched = rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt("" + rgbMatched[1], 10),
        green: parseInt("" + rgbMatched[2], 10),
        blue: parseInt("" + rgbMatched[3], 10)
    };
    var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));
    if (rgbaMatched) return {
        red: parseInt("" + rgbaMatched[1], 10),
        green: parseInt("" + rgbaMatched[2], 10),
        blue: parseInt("" + rgbaMatched[3], 10),
        alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
    var hslMatched = hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt("" + hslMatched[1], 10), saturation = parseInt("" + hslMatched[2], 10) / 100, lightness = parseInt("" + hslMatched[3], 10) / 100, rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")", hslRgbMatched = rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new PolishedError(4, normalizedColor, rgbColorString);
        return {
            red: parseInt("" + hslRgbMatched[1], 10),
            green: parseInt("" + hslRgbMatched[2], 10),
            blue: parseInt("" + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));
    if (hslaMatched) {
        var _hue = parseInt("" + hslaMatched[1], 10), _saturation = parseInt("" + hslaMatched[2], 10) / 100, _lightness = parseInt("" + hslaMatched[3], 10) / 100, _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")", _hslRgbMatched = rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new PolishedError(4, normalizedColor, _rgbColorString);
        return {
            red: parseInt("" + _hslRgbMatched[1], 10),
            green: parseInt("" + _hslRgbMatched[2], 10),
            blue: parseInt("" + _hslRgbMatched[3], 10),
            alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
        };
    }
    throw new PolishedError(5);
}
function rgbToHsl(color2) {
    var red = color2.red / 255, green = color2.green / 255, blue = color2.blue / 255, max = Math.max(red, green, blue), min = Math.min(red, green, blue), lightness = (max + min) / 2;
    if (max === min) return color2.alpha !== void 0 ? {
        hue: 0,
        saturation: 0,
        lightness,
        alpha: color2.alpha
    } : {
        hue: 0,
        saturation: 0,
        lightness
    };
    var hue, delta = max - min, saturation = lightness > .5 ? delta / (2 - max - min) : delta / (max + min);
    switch(max){
        case red:
            hue = (green - blue) / delta + (green < blue ? 6 : 0);
            break;
        case green:
            hue = (blue - red) / delta + 2;
            break;
        default:
            hue = (red - green) / delta + 4;
            break;
    }
    return hue *= 60, color2.alpha !== void 0 ? {
        hue,
        saturation,
        lightness,
        alpha: color2.alpha
    } : {
        hue,
        saturation,
        lightness
    };
}
function parseToHsl(color2) {
    return rgbToHsl(parseToRgb(color2));
}
var reduceHexValue = function(value) {
    return value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6] ? "#" + value[1] + value[3] + value[5] : value;
}, reduceHexValue$1 = reduceHexValue;
function numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
function colorToHex(color2) {
    return numberToHex(Math.round(color2 * 255));
}
function convertToHex(red, green, blue) {
    return reduceHexValue$1("#" + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}
function hslToHex(hue, saturation, lightness) {
    return hslToRgb(hue, saturation, lightness, convertToHex);
}
function hsl(value, saturation, lightness) {
    if (typeof value == "number" && typeof saturation == "number" && typeof lightness == "number") return hslToHex(value, saturation, lightness);
    if (typeof value == "object" && saturation === void 0 && lightness === void 0) return hslToHex(value.hue, value.saturation, value.lightness);
    throw new PolishedError(1);
}
function hsla(value, saturation, lightness, alpha) {
    if (typeof value == "number" && typeof saturation == "number" && typeof lightness == "number" && typeof alpha == "number") return alpha >= 1 ? hslToHex(value, saturation, lightness) : "rgba(" + hslToRgb(value, saturation, lightness) + "," + alpha + ")";
    if (typeof value == "object" && saturation === void 0 && lightness === void 0 && alpha === void 0) return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
    throw new PolishedError(2);
}
function rgb(value, green, blue) {
    if (typeof value == "number" && typeof green == "number" && typeof blue == "number") return reduceHexValue$1("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
    if (typeof value == "object" && green === void 0 && blue === void 0) return reduceHexValue$1("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
    throw new PolishedError(6);
}
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue == "string" && typeof secondValue == "number") {
        var rgbValue = parseToRgb(firstValue);
        return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
    } else {
        if (typeof firstValue == "number" && typeof secondValue == "number" && typeof thirdValue == "number" && typeof fourthValue == "number") return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
        if (typeof firstValue == "object" && secondValue === void 0 && thirdValue === void 0 && fourthValue === void 0) return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
    }
    throw new PolishedError(7);
}
var isRgb = function(color2) {
    return typeof color2.red == "number" && typeof color2.green == "number" && typeof color2.blue == "number" && (typeof color2.alpha != "number" || typeof color2.alpha > "u");
}, isRgba = function(color2) {
    return typeof color2.red == "number" && typeof color2.green == "number" && typeof color2.blue == "number" && typeof color2.alpha == "number";
}, isHsl = function(color2) {
    return typeof color2.hue == "number" && typeof color2.saturation == "number" && typeof color2.lightness == "number" && (typeof color2.alpha != "number" || typeof color2.alpha > "u");
}, isHsla = function(color2) {
    return typeof color2.hue == "number" && typeof color2.saturation == "number" && typeof color2.lightness == "number" && typeof color2.alpha == "number";
};
function toColorString(color2) {
    if (typeof color2 != "object") throw new PolishedError(8);
    if (isRgba(color2)) return rgba(color2);
    if (isRgb(color2)) return rgb(color2);
    if (isHsla(color2)) return hsla(color2);
    if (isHsl(color2)) return hsl(color2);
    throw new PolishedError(8);
}
function curried(f, length, acc) {
    return function() {
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
    };
}
function curry(f) {
    return curried(f, f.length, []);
}
function guard(lowerBoundary, upperBoundary, value) {
    return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
function darken(amount, color2) {
    if (color2 === "transparent") return color2;
    var hslColor = parseToHsl(color2);
    return toColorString(_extends({}, hslColor, {
        lightness: guard(0, 1, hslColor.lightness - parseFloat(amount))
    }));
}
var curriedDarken = curry(darken), curriedDarken$1 = curriedDarken;
function lighten(amount, color2) {
    if (color2 === "transparent") return color2;
    var hslColor = parseToHsl(color2);
    return toColorString(_extends({}, hslColor, {
        lightness: guard(0, 1, hslColor.lightness + parseFloat(amount))
    }));
}
var curriedLighten = curry(lighten), curriedLighten$1 = curriedLighten;
function transparentize(amount, color2) {
    if (color2 === "transparent") return color2;
    var parsedColor = parseToRgb(color2), alpha = typeof parsedColor.alpha == "number" ? parsedColor.alpha : 1, colorWithAlpha = _extends({}, parsedColor, {
        alpha: guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
    });
    return rgba(colorWithAlpha);
}
var curriedTransparentize = curry(transparentize), curriedTransparentize$1 = curriedTransparentize;
var headerCommon = ({ theme })=>({
        margin: "20px 0 8px",
        padding: 0,
        cursor: "text",
        position: "relative",
        color: theme.color.defaultText,
        "&:first-of-type": {
            marginTop: 0,
            paddingTop: 0
        },
        "&:hover a.anchor": {
            textDecoration: "none"
        },
        "& tt, & code": {
            fontSize: "inherit"
        }
    }), codeCommon = ({ theme })=>({
        lineHeight: 1,
        margin: "0 2px",
        padding: "3px 5px",
        whiteSpace: "nowrap",
        borderRadius: 3,
        fontSize: theme.typography.size.s2 - 1,
        border: theme.base === "light" ? `1px solid ${theme.color.mediumlight}` : `1px solid ${theme.color.darker}`,
        color: theme.base === "light" ? curriedTransparentize$1(.1, theme.color.defaultText) : curriedTransparentize$1(.3, theme.color.defaultText),
        backgroundColor: theme.base === "light" ? theme.color.lighter : theme.color.border
    }), withReset = ({ theme })=>({
        fontFamily: theme.typography.fonts.base,
        fontSize: theme.typography.size.s3,
        margin: 0,
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
        WebkitOverflowScrolling: "touch"
    }), withMargin = {
    margin: "16px 0"
};
var Link = ({ href: input, children, ...props })=>{
    let isStorybookPath = /^\//.test(input), isAnchorUrl = /^#.*/.test(input), href = isStorybookPath ? `./?path=${input}` : input;
    return (0, _reactDefault.default).createElement("a", {
        href,
        target: isAnchorUrl ? "_self" : "_top",
        ...props
    }, children);
};
var A = (0, _theming.styled)(Link)(withReset, ({ theme })=>({
        fontSize: "inherit",
        lineHeight: "24px",
        color: theme.color.secondary,
        textDecoration: "none",
        "&.absent": {
            color: "#cc0000"
        },
        "&.anchor": {
            display: "block",
            paddingLeft: 30,
            marginLeft: -30,
            cursor: "pointer",
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0
        }
    }));
var Blockquote = (0, _theming.styled).blockquote(withReset, withMargin, ({ theme })=>({
        borderLeft: `4px solid ${theme.color.medium}`,
        padding: "0 15px",
        color: theme.color.dark,
        "& > :first-of-type": {
            marginTop: 0
        },
        "& > :last-child": {
            marginBottom: 0
        }
    }));
var isReactChildString = (child)=>typeof child == "string";
var isInlineCodeRegex = /[\n\r]/g, DefaultCodeBlock = (0, _theming.styled).code(({ theme })=>({
        fontFamily: theme.typography.fonts.mono,
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
        display: "inline-block",
        paddingLeft: 2,
        paddingRight: 2,
        verticalAlign: "baseline",
        color: "inherit"
    }), codeCommon), StyledSyntaxHighlighter = (0, _theming.styled)((0, _chunkLWG3MFN2Mjs.SyntaxHighlighter))(({ theme })=>({
        fontFamily: theme.typography.fonts.mono,
        fontSize: `${theme.typography.size.s2 - 1}px`,
        lineHeight: "19px",
        margin: "25px 0 40px",
        borderRadius: theme.appBorderRadius,
        boxShadow: theme.base === "light" ? "rgba(0, 0, 0, 0.10) 0 1px 3px 0" : "rgba(0, 0, 0, 0.20) 0 2px 5px 0",
        "pre.prismjs": {
            padding: 20,
            background: "inherit"
        }
    })), Code = ({ className, children, ...props })=>{
    let language = (className || "").match(/lang-(\S+)/), childrenArray = (0, _react.Children).toArray(children);
    return childrenArray.filter(isReactChildString).some((child)=>child.match(isInlineCodeRegex)) ? (0, _reactDefault.default).createElement(StyledSyntaxHighlighter, {
        bordered: !0,
        copyable: !0,
        language: language?.[1] ?? "plaintext",
        format: !1,
        ...props
    }, children) : (0, _reactDefault.default).createElement(DefaultCodeBlock, {
        ...props,
        className
    }, childrenArray);
};
var Div = (0, _theming.styled).div(withReset);
var DL = (0, _theming.styled).dl(withReset, withMargin, {
    padding: 0,
    "& dt": {
        fontSize: "14px",
        fontWeight: "bold",
        fontStyle: "italic",
        padding: 0,
        margin: "16px 0 4px"
    },
    "& dt:first-of-type": {
        padding: 0
    },
    "& dt > :first-of-type": {
        marginTop: 0
    },
    "& dt > :last-child": {
        marginBottom: 0
    },
    "& dd": {
        margin: "0 0 16px",
        padding: "0 15px"
    },
    "& dd > :first-of-type": {
        marginTop: 0
    },
    "& dd > :last-child": {
        marginBottom: 0
    }
});
var H1 = (0, _theming.styled).h1(withReset, headerCommon, ({ theme })=>({
        fontSize: `${theme.typography.size.l1}px`,
        fontWeight: theme.typography.weight.bold
    }));
var H2 = (0, _theming.styled).h2(withReset, headerCommon, ({ theme })=>({
        fontSize: `${theme.typography.size.m2}px`,
        paddingBottom: 4,
        borderBottom: `1px solid ${theme.appBorderColor}`
    }));
var H3 = (0, _theming.styled).h3(withReset, headerCommon, ({ theme })=>({
        fontSize: `${theme.typography.size.m1}px`
    }));
var H4 = (0, _theming.styled).h4(withReset, headerCommon, ({ theme })=>({
        fontSize: `${theme.typography.size.s3}px`
    }));
var H5 = (0, _theming.styled).h5(withReset, headerCommon, ({ theme })=>({
        fontSize: `${theme.typography.size.s2}px`
    }));
var H6 = (0, _theming.styled).h6(withReset, headerCommon, ({ theme })=>({
        fontSize: `${theme.typography.size.s2}px`,
        color: theme.color.dark
    }));
var HR = (0, _theming.styled).hr(({ theme })=>({
        border: "0 none",
        borderTop: `1px solid ${theme.appBorderColor}`,
        height: 4,
        padding: 0
    }));
var Img = (0, _theming.styled).img({
    maxWidth: "100%"
});
var LI = (0, _theming.styled).li(withReset, ({ theme })=>({
        fontSize: theme.typography.size.s2,
        color: theme.color.defaultText,
        lineHeight: "24px",
        "& + li": {
            marginTop: ".25em"
        },
        "& ul, & ol": {
            marginTop: ".25em",
            marginBottom: 0
        },
        "& code": codeCommon({
            theme
        })
    }));
var listCommon = {
    paddingLeft: 30,
    "& :first-of-type": {
        marginTop: 0
    },
    "& :last-child": {
        marginBottom: 0
    }
}, OL = (0, _theming.styled).ol(withReset, withMargin, listCommon, {
    listStyle: "decimal"
});
var P = (0, _theming.styled).p(withReset, withMargin, ({ theme })=>({
        fontSize: theme.typography.size.s2,
        lineHeight: "24px",
        color: theme.color.defaultText,
        "& code": codeCommon({
            theme
        })
    }));
var Pre = (0, _theming.styled).pre(withReset, withMargin, ({ theme })=>({
        fontFamily: theme.typography.fonts.mono,
        WebkitFontSmoothing: "antialiased",
        MozOsxFontSmoothing: "grayscale",
        lineHeight: "18px",
        padding: "11px 1rem",
        whiteSpace: "pre-wrap",
        color: "inherit",
        borderRadius: 3,
        margin: "1rem 0",
        "&:not(.prismjs)": {
            background: "transparent",
            border: "none",
            borderRadius: 0,
            padding: 0,
            margin: 0
        },
        "& pre, &.prismjs": {
            padding: 15,
            margin: 0,
            whiteSpace: "pre-wrap",
            color: "inherit",
            fontSize: "13px",
            lineHeight: "19px",
            code: {
                color: "inherit",
                fontSize: "inherit"
            }
        },
        "& code": {
            whiteSpace: "pre"
        },
        "& code, & tt": {
            border: "none"
        }
    }));
var Span = (0, _theming.styled).span(withReset, ({ theme })=>({
        "&.frame": {
            display: "block",
            overflow: "hidden",
            "& > span": {
                border: `1px solid ${theme.color.medium}`,
                display: "block",
                float: "left",
                overflow: "hidden",
                margin: "13px 0 0",
                padding: 7,
                width: "auto"
            },
            "& span img": {
                display: "block",
                float: "left"
            },
            "& span span": {
                clear: "both",
                color: theme.color.darkest,
                display: "block",
                padding: "5px 0 0"
            }
        },
        "&.align-center": {
            display: "block",
            overflow: "hidden",
            clear: "both",
            "& > span": {
                display: "block",
                overflow: "hidden",
                margin: "13px auto 0",
                textAlign: "center"
            },
            "& span img": {
                margin: "0 auto",
                textAlign: "center"
            }
        },
        "&.align-right": {
            display: "block",
            overflow: "hidden",
            clear: "both",
            "& > span": {
                display: "block",
                overflow: "hidden",
                margin: "13px 0 0",
                textAlign: "right"
            },
            "& span img": {
                margin: 0,
                textAlign: "right"
            }
        },
        "&.float-left": {
            display: "block",
            marginRight: 13,
            overflow: "hidden",
            float: "left",
            "& span": {
                margin: "13px 0 0"
            }
        },
        "&.float-right": {
            display: "block",
            marginLeft: 13,
            overflow: "hidden",
            float: "right",
            "& > span": {
                display: "block",
                overflow: "hidden",
                margin: "13px auto 0",
                textAlign: "right"
            }
        }
    }));
var Table = (0, _theming.styled).table(withReset, withMargin, ({ theme })=>({
        fontSize: theme.typography.size.s2,
        lineHeight: "24px",
        padding: 0,
        borderCollapse: "collapse",
        "& tr": {
            borderTop: `1px solid ${theme.appBorderColor}`,
            backgroundColor: theme.appContentBg,
            margin: 0,
            padding: 0
        },
        "& tr:nth-of-type(2n)": {
            backgroundColor: theme.base === "dark" ? theme.color.darker : theme.color.lighter
        },
        "& tr th": {
            fontWeight: "bold",
            color: theme.color.defaultText,
            border: `1px solid ${theme.appBorderColor}`,
            margin: 0,
            padding: "6px 13px"
        },
        "& tr td": {
            border: `1px solid ${theme.appBorderColor}`,
            color: theme.color.defaultText,
            margin: 0,
            padding: "6px 13px"
        },
        "& tr th :first-of-type, & tr td :first-of-type": {
            marginTop: 0
        },
        "& tr th :last-child, & tr td :last-child": {
            marginBottom: 0
        }
    }));
var TT = (0, _theming.styled).title(codeCommon);
var listCommon2 = {
    paddingLeft: 30,
    "& :first-of-type": {
        marginTop: 0
    },
    "& :last-child": {
        marginBottom: 0
    }
}, UL = (0, _theming.styled).ul(withReset, withMargin, listCommon2, {
    listStyle: "disc"
});
var ResetWrapper = (0, _theming.styled).div(withReset);
var components = {
    h1: (props)=>(0, _reactDefault.default).createElement(H1, {
            ...nameSpaceClassNames(props, "h1")
        }),
    h2: (props)=>(0, _reactDefault.default).createElement(H2, {
            ...nameSpaceClassNames(props, "h2")
        }),
    h3: (props)=>(0, _reactDefault.default).createElement(H3, {
            ...nameSpaceClassNames(props, "h3")
        }),
    h4: (props)=>(0, _reactDefault.default).createElement(H4, {
            ...nameSpaceClassNames(props, "h4")
        }),
    h5: (props)=>(0, _reactDefault.default).createElement(H5, {
            ...nameSpaceClassNames(props, "h5")
        }),
    h6: (props)=>(0, _reactDefault.default).createElement(H6, {
            ...nameSpaceClassNames(props, "h6")
        }),
    pre: (props)=>(0, _reactDefault.default).createElement(Pre, {
            ...nameSpaceClassNames(props, "pre")
        }),
    a: (props)=>(0, _reactDefault.default).createElement(A, {
            ...nameSpaceClassNames(props, "a")
        }),
    hr: (props)=>(0, _reactDefault.default).createElement(HR, {
            ...nameSpaceClassNames(props, "hr")
        }),
    dl: (props)=>(0, _reactDefault.default).createElement(DL, {
            ...nameSpaceClassNames(props, "dl")
        }),
    blockquote: (props)=>(0, _reactDefault.default).createElement(Blockquote, {
            ...nameSpaceClassNames(props, "blockquote")
        }),
    table: (props)=>(0, _reactDefault.default).createElement(Table, {
            ...nameSpaceClassNames(props, "table")
        }),
    img: (props)=>(0, _reactDefault.default).createElement(Img, {
            ...nameSpaceClassNames(props, "img")
        }),
    div: (props)=>(0, _reactDefault.default).createElement(Div, {
            ...nameSpaceClassNames(props, "div")
        }),
    span: (props)=>(0, _reactDefault.default).createElement(Span, {
            ...nameSpaceClassNames(props, "span")
        }),
    li: (props)=>(0, _reactDefault.default).createElement(LI, {
            ...nameSpaceClassNames(props, "li")
        }),
    ul: (props)=>(0, _reactDefault.default).createElement(UL, {
            ...nameSpaceClassNames(props, "ul")
        }),
    ol: (props)=>(0, _reactDefault.default).createElement(OL, {
            ...nameSpaceClassNames(props, "ol")
        }),
    p: (props)=>(0, _reactDefault.default).createElement(P, {
            ...nameSpaceClassNames(props, "p")
        }),
    code: (props)=>(0, _reactDefault.default).createElement(Code, {
            ...nameSpaceClassNames(props, "code")
        }),
    tt: (props)=>(0, _reactDefault.default).createElement(TT, {
            ...nameSpaceClassNames(props, "tt")
        }),
    resetwrapper: (props)=>(0, _reactDefault.default).createElement(ResetWrapper, {
            ...nameSpaceClassNames(props, "resetwrapper")
        })
};
var BadgeWrapper = (0, _theming.styled).div(({ theme })=>({
        display: "inline-block",
        fontSize: 11,
        lineHeight: "12px",
        alignSelf: "center",
        padding: "4px 12px",
        borderRadius: "3em",
        fontWeight: theme.typography.weight.bold
    }), {
    svg: {
        height: 12,
        width: 12,
        marginRight: 4,
        marginTop: -2,
        path: {
            fill: "currentColor"
        }
    }
}, ({ theme, status })=>{
    switch(status){
        case "critical":
            return {
                color: theme.color.critical,
                background: theme.background.critical
            };
        case "negative":
            return {
                color: theme.color.negativeText,
                background: theme.background.negative,
                boxShadow: theme.base === "light" ? `inset 0 0 0 1px ${curriedTransparentize$1(.9, theme.color.negativeText)}` : "none"
            };
        case "warning":
            return {
                color: theme.color.warningText,
                background: theme.background.warning,
                boxShadow: theme.base === "light" ? `inset 0 0 0 1px ${curriedTransparentize$1(.9, theme.color.warningText)}` : "none"
            };
        case "neutral":
            return {
                color: theme.color.dark,
                background: theme.color.mediumlight,
                boxShadow: theme.base === "light" ? `inset 0 0 0 1px ${curriedTransparentize$1(.9, theme.color.dark)}` : "none"
            };
        case "positive":
            return {
                color: theme.color.positiveText,
                background: theme.background.positive,
                boxShadow: theme.base === "light" ? `inset 0 0 0 1px ${curriedTransparentize$1(.9, theme.color.positiveText)}` : "none"
            };
        default:
            return {};
    }
}), Badge = ({ ...props })=>(0, _reactDefault.default).createElement(BadgeWrapper, {
        ...props
    });
var icons = {
    user: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0ZM2.67 11.15c.7-1 2.6-1.81 3.2-1.9.22-.04.23-.66.23-.66s-.67-.66-.81-1.55c-.4 0-.63-.94-.24-1.27l-.02-.13c-.06-.6-.28-2.6 1.97-2.6s2.03 2 1.97 2.6l-.02.13c.4.33.15 1.27-.24 1.27-.14.89-.8 1.55-.8 1.55s0 .62.22.66c.6.09 2.5.9 3.2 1.9a6 6 0 1 0-8.66 0Z"
    })),
    useralt: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M7.27 13.16a11.39 11.39 0 0 0 5.18-1.23v-.25c0-1.57-3.24-3-4.1-3.13-.27-.05-.28-.79-.28-.79s.8-.78.96-1.83c.47 0 .75-1.12.29-1.52.02-.41.6-3.25-2.32-3.25S4.65 4 4.67 4.41c-.46.4-.17 1.52.29 1.52.17 1.05.96 1.83.96 1.83s0 .74-.27.79c-.86.13-4.04 1.53-4.1 3.08a11.44 11.44 0 0 0 5.72 1.53Z"
    })),
    useradd: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M1.18 11.9c-.4-.17-.8-.36-1.18-.58.06-1.44 3.02-2.74 3.82-2.87.25-.04.26-.73.26-.73s-.74-.73-.9-1.7c-.43 0-.7-1.05-.27-1.42l-.01-.14c-.07-.67-.31-2.88 2.18-2.88 2.48 0 2.24 2.2 2.17 2.88l-.01.14c.43.37.16 1.41-.27 1.41-.16.98-.9 1.71-.9 1.71s.01.69.26.73c.8.13 3.82 1.46 3.82 2.91v.24a10.63 10.63 0 0 1-8.97.3ZM11.5 2.16c.28 0 .5.22.5.5v1.5h1.5a.5.5 0 0 1 0 1H12v1.5a.5.5 0 0 1-1 0v-1.5H9.5a.5.5 0 1 1 0-1H11v-1.5c0-.28.22-.5.5-.5Z"
    })),
    users: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M9.21 11.62A10.59 10.59 0 0 1 0 11.07c.06-1.35 2.93-2.58 3.7-2.7.25-.03.26-.68.26-.68s-.72-.69-.87-1.6c-.42 0-.68-.99-.26-1.33 0-.03 0-.08-.02-.14-.07-.63-.3-2.71 2.12-2.71 2.41 0 2.18 2.08 2.11 2.71l-.01.14c.42.34.16 1.32-.26 1.32-.16.92-.87 1.6-.87 1.6s0 .66.25.7c.78.11 3.7 1.36 3.7 2.73v.22l-.64.3Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M8.81 8.42a9.64 9.64 0 0 0-.74-.4 5.2 5.2 0 0 1 1.7-.76c.17-.02.17-.47.17-.47s-.49-.47-.6-1.1c-.28 0-.46-.68-.17-.91l-.01-.1c-.05-.43-.2-1.86 1.45-1.86 1.66 0 1.5 1.43 1.45 1.86v.1c.28.23.1.9-.18.9-.11.64-.6 1.11-.6 1.11s0 .45.17.47c.54.08 2.55.94 2.55 1.89v.62a10.6 10.6 0 0 1-3.3.56 2.97 2.97 0 0 0-.58-.88c-.37-.41-.85-.76-1.31-1.03Z"
    })),
    profile: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M9.1 7.35a5.06 5.06 0 0 1-4.52-.28C4.6 6.4 6.02 5.77 6.4 5.7c.12-.02.12-.35.12-.35s-.35-.34-.43-.81c-.2 0-.33-.5-.12-.67l-.01-.07C5.93 3.48 5.81 2.42 7 2.42S8.07 3.48 8.04 3.8v.07c.2.17.07.67-.13.67-.08.47-.43.81-.43.81s0 .33.12.35c.38.06 1.82.7 1.82 1.4v.1c-.1.06-.2.1-.31.15Zm-5.35 3.9c0-.14.11-.25.25-.25h6a.25.25 0 1 1 0 .5H4a.25.25 0 0 1-.25-.25ZM4 9a.25.25 0 0 0 0 .5h6a.25.25 0 1 0 0-.5H4Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M1 .5c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5v13a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V.5ZM2 13V1h10v12H2Z"
    })),
    facehappy: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M3.97 8.75a.5.5 0 0 0-.87.5 4.5 4.5 0 0 0 7.8 0 .5.5 0 1 0-.87-.5 3.5 3.5 0 0 1-6.06 0ZM5.5 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9.5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0Zm-1 0A6 6 0 1 1 1 7a6 6 0 0 1 12 0Z"
    })),
    faceneutral: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M4.5 9a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5ZM5.5 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9.5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0Zm-1 0A6 6 0 1 1 1 7a6 6 0 0 1 12 0Z"
    })),
    facesad: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M3.97 10.25a.5.5 0 0 1-.87-.5 4.5 4.5 0 0 1 7.8 0 .5.5 0 1 1-.87.5 3.5 3.5 0 0 0-6.06 0ZM5.5 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9.5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0Zm-1 0A6 6 0 1 1 1 7a6 6 0 0 1 12 0Z"
    })),
    accessibility: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M3.53 4.84a.5.5 0 0 1 .63-.31l2.05.68a2.5 2.5 0 0 0 1.58 0l2.05-.68a.5.5 0 0 1 .32.94L7.7 6.3a.3.3 0 0 0-.21.29v.24c0 .7.16 1.39.48 2.01l.97 1.95a.5.5 0 1 1-.9.44L7 9.12l-1.05 2.1a.5.5 0 1 1-.9-.44l.97-1.95a4.5 4.5 0 0 0 .48-2.01v-.24a.3.3 0 0 0-.2-.29l-2.46-.82a.5.5 0 0 1-.31-.63Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M7 4.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14Zm0-1A6 6 0 1 0 7 1a6 6 0 0 0 0 12Z"
    })),
    accessibilityalt: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14ZM8 3.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM3.53 4.84a.5.5 0 0 1 .63-.31l2.05.68a2.5 2.5 0 0 0 1.58 0l2.05-.68a.5.5 0 0 1 .32.94L7.7 6.3a.3.3 0 0 0-.21.29v.24c0 .7.16 1.39.48 2.01l.97 1.95a.5.5 0 1 1-.9.44L7 9.12l-1.05 2.1a.5.5 0 1 1-.9-.44l.97-1.95a4.5 4.5 0 0 0 .48-2.01v-.24a.3.3 0 0 0-.2-.29l-2.46-.82a.5.5 0 0 1-.31-.63Z"
    })),
    arrowup: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "m7.35 2.9 5.5 5.5a.5.5 0 0 1-.7.7L7 3.96 1.85 9.1a.5.5 0 1 1-.7-.7l5.5-5.5c.2-.2.5-.2.7 0Z"
    })),
    arrowdown: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "m1.15 5.6 5.5 5.5c.2.2.5.2.7 0l5.5-5.5a.5.5 0 0 0-.7-.7L7 10.04 1.85 4.9a.5.5 0 1 0-.7.7Z"
    })),
    arrowleft: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M2.76 7.1c.02.09.06.18.14.25l5.5 5.5a.5.5 0 0 0 .7-.7L3.96 7 9.1 1.85a.5.5 0 1 0-.7-.7l-5.5 5.5a.5.5 0 0 0-.14.45Z"
    })),
    arrowright: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "m11.1 7.35-5.5 5.5a.5.5 0 0 1-.7-.7L10.04 7 4.9 1.85a.5.5 0 1 1 .7-.7l5.5 5.5c.2.2.2.5 0 .7Z"
    })),
    arrowupalt: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M11.85 4.65 7.35.15a.5.5 0 0 0-.7 0l-4.5 4.5a.5.5 0 1 0 .7.7L6.5 1.71V13.5a.5.5 0 0 0 1 0V1.7l3.65 3.65a.5.5 0 0 0 .7-.7Z"
    })),
    arrowdownalt: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M7.5.5a.5.5 0 0 0-1 0v11.8L2.85 8.64a.5.5 0 1 0-.7.7l4.5 4.5A.5.5 0 0 0 7 14a.5.5 0 0 0 .35-.15l4.5-4.5a.5.5 0 0 0-.7-.7L7.5 12.29V.5Z"
    })),
    arrowleftalt: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M5.35 2.15c.2.2.2.5 0 .7L1.71 6.5H13.5a.5.5 0 0 1 0 1H1.7l3.65 3.65a.5.5 0 0 1-.7.7l-4.5-4.5a.5.5 0 0 1 0-.7l4.5-4.5c.2-.2.5-.2.7 0Z"
    })),
    arrowrightalt: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M8.65 2.15c.2-.2.5-.2.7 0l4.5 4.5c.2.2.2.5 0 .7l-4.5 4.5a.5.5 0 0 1-.7-.7l3.64-3.65H.5a.5.5 0 0 1 0-1h11.8L8.64 2.85a.5.5 0 0 1 0-.7Z"
    })),
    expandalt: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "m7.35.15 4 4a.5.5 0 0 1-.7.7L7 1.21 3.35 4.85a.5.5 0 1 1-.7-.7l4-4c.2-.2.5-.2.7 0ZM11.35 9.15c.2.2.2.5 0 .7l-4 4a.5.5 0 0 1-.7 0l-4-4a.5.5 0 1 1 .7-.7L7 12.79l3.65-3.64c.2-.2.5-.2.7 0Z"
    })),
    collapse: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M3.354.146a.5.5 0 1 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0-.708-.708L7 3.793 3.354.146Zm3.292 9a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1-.708.708L7 10.207l-3.646 3.647a.5.5 0 0 1-.708-.708l4-4Z"
    })),
    expand: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M1.5 1h2a.5.5 0 0 1 0 1h-.8l3.15 3.15a.5.5 0 1 1-.7.7L2 2.71v.79a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5ZM10 1.5c0-.28.22-.5.5-.5h2c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-.8L8.85 5.86a.5.5 0 1 1-.7-.7L11.29 2h-.79a.5.5 0 0 1-.5-.5ZM12.5 10c.28 0 .5.22.5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h.8L8.14 8.85a.5.5 0 1 1 .7-.7L12 11.29v-.79c0-.28.22-.5.5-.5ZM2 11.3v-.8a.5.5 0 0 0-1 0v2c0 .28.22.5.5.5h2a.5.5 0 0 0 0-1h-.8l3.15-3.15a.5.5 0 1 0-.7-.7L2 11.29Z"
    })),
    unfold: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "m6.65.15-1.5 1.5a.5.5 0 1 0 .7.7l.65-.64V5a.5.5 0 0 0 1 0V1.7l.65.65a.5.5 0 1 0 .7-.7L7.35.15a.5.5 0 0 0-.7 0Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M1.3 4.04a.5.5 0 0 0-.16.82L3.3 7 1.15 9.15a.5.5 0 0 0 .35.85h3a.5.5 0 0 0 0-1H2.7l1.5-1.5h5.6l2.35 2.35a.5.5 0 0 0 .7-.7L10.71 7l2.14-2.15.11-.54-.1.54A.5.5 0 0 0 13 4.5a.5.5 0 0 0-.14-.35.5.5 0 0 0-.36-.15h-3a.5.5 0 0 0 0 1h1.8L9.8 6.5H4.2L2.7 5h1.8a.5.5 0 0 0 0-1h-3a.5.5 0 0 0-.2.04Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M7 8.5c.28 0 .5.22.5.5v3.3l.65-.65a.5.5 0 0 1 .7.7l-1.5 1.5a.5.5 0 0 1-.7 0l-1.5-1.5a.5.5 0 0 1 .7-.7l.65.64V9c0-.28.22-.5.5-.5ZM9 9.5c0-.28.22-.5.5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Z"
    })),
    transfer: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M10.65 2.65c.2-.2.5-.2.7 0l1.5 1.5c.2.2.2.5 0 .7l-1.5 1.5a.5.5 0 0 1-.7-.7l.64-.65H1.5a.5.5 0 0 1 0-1h9.8l-.65-.65a.5.5 0 0 1 0-.7ZM3.35 8.35 2.71 9h9.79a.5.5 0 0 1 0 1H2.7l.65.65a.5.5 0 0 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7l1.5-1.5a.5.5 0 1 1 .7.7Z"
    })),
    redirect: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M1.5 1c.28 0 .5.22.5.5V10a2 2 0 0 0 4 0V4a3 3 0 0 1 6 0v7.8l1.15-1.15a.5.5 0 0 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 0 1 .7-.7L11 11.79V4a2 2 0 1 0-4 0v6a3 3 0 0 1-6 0V1.5c0-.28.22-.5.5-.5Z"
    })),
    undo: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M1.15 3.85a.5.5 0 0 1 0-.7l2-2a.5.5 0 1 1 .7.7L2.71 3H9a4 4 0 0 1 0 8H3a.5.5 0 0 1 0-1h6a3 3 0 1 0 0-6H2.7l1.15 1.15a.5.5 0 1 1-.7.7l-2-2Z"
    })),
    reply: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M4.35 2.15c.2.2.2.5 0 .7L1.71 5.5H9.5A4.5 4.5 0 0 1 14 10v1.5a.5.5 0 0 1-1 0V10a3.5 3.5 0 0 0-3.5-3.5H1.7l2.65 2.65a.5.5 0 1 1-.7.7l-3.5-3.5a.5.5 0 0 1 0-.7l3.5-3.5c.2-.2.5-.2.7 0Z"
    })),
    sync: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M5.5 1A.5.5 0 0 0 5 .5H2a.5.5 0 0 0 0 1h1.53a6.5 6.5 0 0 0 2.39 11.91.5.5 0 1 0 .16-.99A5.5 5.5 0 0 1 4.5 2.1V4a.5.5 0 0 0 1 0V1ZM7.5 1a.5.5 0 0 1 .58-.41 6.5 6.5 0 0 1 2.39 11.91H12a.5.5 0 0 1 0 1H9a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 1 0v1.9A5.5 5.5 0 0 0 7.92 1.58.5.5 0 0 1 7.5 1Z"
    })),
    upload: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M8.65 5.85 7.5 4.71v5.79a.5.5 0 0 1-1 0V4.7L5.35 5.86a.5.5 0 1 1-.7-.7l2-2c.2-.2.5-.2.7 0l2 2a.5.5 0 1 1-.7.7Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0Zm-1 0A6 6 0 1 1 1 7a6 6 0 0 1 12 0Z"
    })),
    download: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M5.35 8.15 6.5 9.29V3.5a.5.5 0 0 1 1 0v5.8l1.15-1.15a.5.5 0 1 1 .7.7l-2 2a.5.5 0 0 1-.7 0l-2-2a.5.5 0 1 1 .7-.7Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7Zm1 0a6 6 0 1 1 12 0A6 6 0 0 1 1 7Z"
    })),
    back: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M5.85 5.35 4.71 6.5h5.79a.5.5 0 0 1 0 1H4.7l1.15 1.15a.5.5 0 1 1-.7.7l-2-2a.5.5 0 0 1 0-.7l2-2a.5.5 0 1 1 .7.7Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0Zm0 1a6 6 0 1 1 0 12A6 6 0 0 1 7 1Z"
    })),
    proceed: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M3.5 6.5h5.8L8.14 5.35a.5.5 0 1 1 .7-.7l2 2c.2.2.2.5 0 .7l-2 2a.5.5 0 1 1-.7-.7L9.29 7.5H3.5a.5.5 0 0 1 0-1Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M7 14A7 7 0 1 1 7 0a7 7 0 0 1 0 14Zm0-1A6 6 0 1 1 7 1a6 6 0 0 1 0 12Z"
    })),
    refresh: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M7.1.5H7a6.5 6.5 0 1 0 6.41 7.58.5.5 0 1 0-.99-.16A5.47 5.47 0 0 1 7 12.5a5.5 5.5 0 0 1 0-11 5.5 5.5 0 0 1 4.9 3H10a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-1 0v1.53A6.5 6.5 0 0 0 7.1.5Z"
    })),
    globe: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M14 7A7 7 0 1 0 0 7a7 7 0 0 0 14 0Zm-6.53 5.74c-.24.23-.4.26-.47.26-.08 0-.23-.03-.47-.26-.23-.24-.5-.62-.73-1.18A11.57 11.57 0 0 1 5 7.5h4a11.57 11.57 0 0 1-.8 4.06c-.24.56-.5.94-.73 1.18ZM8.99 6.5H5.01c.05-1.62.35-3.04.79-4.06.24-.56.5-.94.73-1.18.24-.23.4-.26.47-.26.08 0 .23.03.47.26.23.24.5.62.73 1.18.44 1.02.74 2.44.8 4.06Zm1 1c-.06 2.18-.56 4.08-1.28 5.25a6 6 0 0 0 4.27-5.25H9.99Zm2.99-1H9.99c-.06-2.18-.56-4.08-1.28-5.25a6 6 0 0 1 4.27 5.25ZM4 6.5c.06-2.18.56-4.08 1.28-5.25A6 6 0 0 0 1.02 6.5h2.99Zm-2.99 1a6 6 0 0 0 4.27 5.25c-.72-1.17-1.22-3.07-1.28-5.25H1.02Z"
    })),
    compass: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M10.09 3.4 5.95 5.8a.37.37 0 0 0-.11.09.38.38 0 0 0-.04.05l-2.4 4.15a.37.37 0 0 0 0 .38c.1.18.33.24.5.14l4.15-2.4a.37.37 0 0 0 .15-.15l2.4-4.15a.37.37 0 0 0-.03-.44.37.37 0 0 0-.48-.07ZM4.75 9.25 7.6 7.6 6.4 6.4 4.75 9.25Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0Zm-1 0A6 6 0 1 1 1 7a6 6 0 0 1 12 0Z"
    })),
    location: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M0 7a7 7 0 1 1 14 0A7 7 0 0 1 0 7Zm6.5 3.5v2.48A6 6 0 0 1 1.02 7.5H3.5a.5.5 0 0 0 0-1H1.02A6 6 0 0 1 6.5 1.02V3.5a.5.5 0 0 0 1 0V1.02a6 6 0 0 1 5.48 5.48H10.5a.5.5 0 0 0 0 1h2.48a6 6 0 0 1-5.48 5.48V10.5a.5.5 0 0 0-1 0Z"
    })),
    pin: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M9 5a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM8 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M12 5A5 5 0 0 0 2 5c0 2.63 2.27 6.15 4.65 8.64.2.2.5.2.7 0C9.73 11.15 12 7.64 12 5ZM7 1a4 4 0 0 1 4 4c0 1.06-.47 2.42-1.3 3.88A21.23 21.23 0 0 1 7 12.55c-1-1.1-1.97-2.39-2.7-3.67A8.46 8.46 0 0 1 3 5a4 4 0 0 1 4-4Z"
    })),
    time: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M7 2c.28 0 .5.22.5.5v4H10a.5.5 0 0 1 0 1H7a.5.5 0 0 1-.5-.5V2.5c0-.28.22-.5.5-.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14Zm0-1A6 6 0 1 0 7 1a6 6 0 0 0 0 12Z"
    })),
    dashboard: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M9.8 4.1a.5.5 0 0 1 .1.7L7.92 7.58A1 1 0 1 1 7.1 7l2-2.8a.5.5 0 0 1 .7-.12Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M2.07 12.97a7 7 0 1 1 9.86 0 12.96 12.96 0 0 0-9.86 0Zm9.58-1.18a6 6 0 1 0-9.3 0 13.98 13.98 0 0 1 9.3 0Z"
    })),
    timer: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M7.5 4.5a.5.5 0 0 0-1 0v2.63a1 1 0 1 0 1 0V4.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M5.5.5c0-.28.22-.5.5-.5h2a.5.5 0 0 1 0 1h-.5v1.02c1.28.1 2.45.61 3.37 1.4l.78-.77a.5.5 0 0 1 .7.7l-.77.78a6 6 0 1 1-5.08-2.1V1H6a.5.5 0 0 1-.5-.5ZM7 3a5 5 0 1 0 0 10A5 5 0 0 0 7 3Z"
    })),
    home: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "m7.35 1.15 5.5 5.5a.5.5 0 0 1-.7.7L12 7.21v5.29a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V9H6v3.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V7.2l-.15.15a.5.5 0 1 1-.7-.7l1-1 4.5-4.5c.2-.2.5-.2.7 0ZM3 6.2V12h2V8.5c0-.28.22-.5.5-.5h3c.28 0 .5.22.5.5V12h2V6.2l-4-4-4 4Z"
    })),
    admin: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M1.21 4.1a.5.5 0 0 1 .06-.04l5.48-3a.5.5 0 0 1 .5 0l5.48 3a.5.5 0 0 1 .27.39.5.5 0 0 1-.51.55H1.51a.5.5 0 0 1-.3-.9ZM3.46 4h7.08L7 2.07 3.46 4Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M4 6a.5.5 0 1 0-1 0v5a.5.5 0 0 0 1 0V6ZM11 6a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0V6ZM5.75 5.5c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0V6c0-.28.22-.5.5-.5ZM8.75 6a.5.5 0 1 0-1 0v5a.5.5 0 0 0 1 0V6ZM1.5 12.5c0-.27.22-.5.5-.5h10a.5.5 0 0 1 0 1H2a.5.5 0 0 1-.5-.5Z"
    })),
    info: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M7 5.5c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0V6c0-.28.22-.5.5-.5ZM7 4.5A.75.75 0 1 0 7 3a.75.75 0 0 0 0 1.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14Zm0-1A6 6 0 1 0 7 1a6 6 0 0 0 0 12Z"
    })),
    question: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M5.25 5.25A1.75 1.75 0 1 1 7 7a.5.5 0 0 0-.5.5V9a.5.5 0 0 0 1 0V7.95a2.75 2.75 0 1 0-3.25-2.7.5.5 0 0 0 1 0ZM7 11.5A.75.75 0 1 0 7 10a.75.75 0 0 0 0 1.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0Zm-1 0A6 6 0 1 1 1 7a6 6 0 0 1 12 0Z"
    })),
    support: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0Zm-3.52 4.9a5.97 5.97 0 0 1-6.96 0l1.45-1.45a3.98 3.98 0 0 0 4.06 0l1.45 1.44Zm-.03-2.87 1.44 1.45a5.97 5.97 0 0 0 0-6.96l-1.44 1.45a3.98 3.98 0 0 1 0 4.06ZM9.03 3.55l1.45-1.44a5.97 5.97 0 0 0-6.96 0l1.45 1.44a3.98 3.98 0 0 1 4.06 0ZM3.55 4.97 2.11 3.52a5.97 5.97 0 0 0 0 6.96l1.44-1.45a3.98 3.98 0 0 1 0-4.06ZM10 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
    })),
    alert: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M7 4.5c.28 0 .5.22.5.5v3.5a.5.5 0 0 1-1 0V5c0-.28.22-.5.5-.5ZM7.75 10.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M7.2 1.04a.5.5 0 0 1 .24.21l6.49 11a.5.5 0 0 1-.44.75H.51a.5.5 0 0 1-.5-.45.5.5 0 0 1 .06-.31l6.5-10.99a.5.5 0 0 1 .64-.2ZM7 2.48 1.38 12h11.24L7 2.48Z"
    })),
    email: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M0 2.5c0-.27.22-.5.5-.5h13c.28 0 .5.23.5.5v9a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-9Zm1 1.02V11h12V3.52L7.31 7.89a.5.5 0 0 1-.52.07.5.5 0 0 1-.1-.07L1 3.52ZM12.03 3H1.97L7 6.87 12.03 3Z"
    })),
    phone: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "m7.76 8.13-.05.05a.2.2 0 0 1-.28.03A6.76 6.76 0 0 1 5.8 6.56a.21.21 0 0 1 .04-.27l.05-.05c.23-.2.54-.47.71-.96.17-.47-.02-1.04-.66-1.94-.26-.38-.72-.96-1.22-1.46-.68-.69-1.2-1-1.65-1a.98.98 0 0 0-.51.13A3.23 3.23 0 0 0 .9 3.42c-.13 1.1.26 2.37 1.17 3.78a16.68 16.68 0 0 0 4.55 4.6 6.57 6.57 0 0 0 3.53 1.32A3.2 3.2 0 0 0 13 11.46c.14-.24.24-.64-.07-1.18a7.8 7.8 0 0 0-1.73-1.8c-.64-.5-1.52-1.12-2.13-1.12a.97.97 0 0 0-.34.06c-.47.17-.74.46-.95.69l-.02.02Zm4.32 2.68a6.8 6.8 0 0 0-1.48-1.54h-.02c-.3-.25-.64-.49-.95-.67a2.7 2.7 0 0 0-.56-.24h-.01c-.23.09-.34.21-.56.45l-.02.02-.04.04a1.2 1.2 0 0 1-1.6.15 7.76 7.76 0 0 1-1.86-1.89l-.01-.01-.02-.02a1.21 1.21 0 0 1 .2-1.53l.06-.06.02-.02c.22-.2.35-.31.43-.53v-.02c0-.02 0-.06-.03-.14a3.7 3.7 0 0 0-.5-.88h-.01V3.9c-.23-.33-.65-.87-1.1-1.32H4c-.31-.32-.55-.5-.72-.6a.6.6 0 0 0-.22-.1h-.03a2.23 2.23 0 0 0-1.15 1.66c-.09.78.18 1.8 1.02 3.1a15.68 15.68 0 0 0 4.27 4.33l.02.01.02.02a5.57 5.57 0 0 0 2.97 1.11 2.2 2.2 0 0 0 1.93-1.14h.01v-.05a.57.57 0 0 0-.05-.12Z"
    })),
    link: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M11.84 2.16a2.25 2.25 0 0 0-3.18 0l-2.5 2.5c-.88.88-.88 2.3 0 3.18a.5.5 0 0 1-.7.7 3.25 3.25 0 0 1 0-4.59l2.5-2.5a3.25 3.25 0 0 1 4.59 4.6L10.48 8.1c.04-.44.01-.89-.09-1.32l1.45-1.45c.88-.88.88-2.3 0-3.18Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M3.6 7.2c-.1-.42-.12-.87-.08-1.31L1.45 7.95a3.25 3.25 0 1 0 4.6 4.6l2.5-2.5a3.25 3.25 0 0 0 0-4.6.5.5 0 0 0-.7.7c.87.89.87 2.31 0 3.2l-2.5 2.5a2.25 2.25 0 1 1-3.2-3.2l1.46-1.44Z"
    })),
    unlink: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "m1.45 7.95 1.3-1.3.71.7-1.3 1.3a2.25 2.25 0 1 0 3.18 3.2l1.3-1.31.71.7-1.3 1.3a3.25 3.25 0 0 1-4.6-4.59ZM12.55 6.05l-1.3 1.3-.71-.7 1.3-1.3a2.25 2.25 0 1 0-3.18-3.2l-1.3 1.31-.71-.7 1.3-1.3a3.25 3.25 0 0 1 4.6 4.59ZM1.85 1.15a.5.5 0 1 0-.7.7l11 11a.5.5 0 0 0 .7-.7l-11-11Z"
    })),
    bell: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M8 1.11a1 1 0 1 0-1.99 0A4.5 4.5 0 0 0 2.5 5.5v3.88l-.94 1.89a.5.5 0 0 0-.06.3.5.5 0 0 0 .51.43h3.58a1.5 1.5 0 1 0 2.82 0H12a.5.5 0 0 0 .45-.73l-.94-1.89V5.5A4.5 4.5 0 0 0 8 1.11ZM2.8 11h8.4l-.5-1H3.3l-.5 1Zm7.7-2V5.5a3.5 3.5 0 1 0-7 0V9h7Zm-4 3.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Z"
    })),
    rss: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M1.5.5c0-.28.22-.5.5-.5a12 12 0 0 1 12 12 .5.5 0 0 1-1 0A11 11 0 0 0 2 1a.5.5 0 0 1-.5-.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M1.5 4.5c0-.28.22-.5.5-.5a8 8 0 0 1 8 8 .5.5 0 0 1-1 0 7 7 0 0 0-7-7 .5.5 0 0 1-.5-.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M5 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-1 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
    })),
    sharealt: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M2 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7.5a.5.5 0 0 0-1 0V12H2V2h4.5a.5.5 0 0 0 0-1H2Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M7.35 7.36 12 2.7v1.8a.5.5 0 0 0 1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 1 0 0 1h1.8L6.64 6.64a.5.5 0 1 0 .7.7Z"
    })),
    share: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M6.65.15c.2-.2.5-.2.7 0l2 2a.5.5 0 1 1-.7.7L7.5 1.72v6.8a.5.5 0 0 1-1 0V1.7L5.35 2.86a.5.5 0 1 1-.7-.71l2-2Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M2 4a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H9.5a.5.5 0 1 0 0 1H12v7H2V5h2.5a.5.5 0 0 0 0-1H2Z"
    })),
    circlehollow: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M7 13A6 6 0 1 0 7 1a6 6 0 0 0 0 12Zm0 1A7 7 0 1 0 7 0a7 7 0 0 0 0 14Z"
    })),
    circle: (0, _reactDefault.default).createElement("path", {
        d: "M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0Z"
    }),
    bookmarkhollow: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M3.5 0h7c.28 0 .5.22.5.5v13a.5.5 0 0 1-.45.5.46.46 0 0 1-.38-.12L7 11.16l-3.17 2.72a.46.46 0 0 1-.38.12.5.5 0 0 1-.45-.5V.5c0-.28.22-.5.5-.5ZM4 12.41l2.66-2.28a.45.45 0 0 1 .38-.13c.1.01.2.05.29.12l2.67 2.3V1H4v11.41Z"
    })),
    bookmark: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M3.5 0h7c.28 0 .5.22.5.5v13a.5.5 0 0 1-.45.5.46.46 0 0 1-.38-.12L7 11.16l-3.17 2.72a.46.46 0 0 1-.38.12.5.5 0 0 1-.45-.5V.5c0-.28.22-.5.5-.5Z"
    })),
    hearthollow: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M12.81 1.85 13 2a2.97 2.97 0 0 1 .75 1.17 4.39 4.39 0 0 1 .12 2.51 6.26 6.26 0 0 1-1.65 2.55l-4.78 4.6A.59.59 0 0 1 7 13a.67.67 0 0 1-.44-.17L1.78 8.22a7.84 7.84 0 0 1-1.25-1.6C.37 6.31.24 6 .14 5.67a4.32 4.32 0 0 1 .12-2.51 3.2 3.2 0 0 1 1.95-1.9c.47-.18 1-.27 1.57-.27.3 0 .61.04.91.14.3.09.59.21.86.36s.52.33.77.52c.24.19.47.38.68.58a7.56 7.56 0 0 1 1.46-1.1c.27-.15.55-.27.84-.36.3-.1.6-.14.9-.14.59 0 1.12.09 1.59.26.39.15.73.34 1.02.59ZM1.2 3.53A2.2 2.2 0 0 1 2.57 2.2M1.2 3.53c-.13.33-.2.72-.2 1.18 0 .22.03.45.1.68a3.97 3.97 0 0 0 .79 1.46c.19.23.38.45.59.65l4.51 4.36 4.52-4.35c.2-.2.4-.4.59-.65.18-.23.34-.47.49-.73.13-.23.23-.48.3-.73.08-.23.11-.46.11-.7 0-.45-.07-.84-.2-1.18-.12-.33-.3-.6-.51-.8v-.01c-.22-.2-.5-.38-.85-.51-.34-.13-.75-.2-1.24-.2-.2 0-.4.03-.6.09a4.95 4.95 0 0 0-1.9 1.22l-.68.67-.7-.65a9.97 9.97 0 0 0-.62-.53c-.2-.16-.42-.3-.63-.42h-.01c-.21-.12-.43-.22-.66-.29C4.2 2.03 4 2 3.77 2c-.48 0-.88.07-1.21.2"
    })),
    heart: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M12.81 1.85 13 2a2.97 2.97 0 0 1 .75 1.17 4.39 4.39 0 0 1 .12 2.51 6.26 6.26 0 0 1-1.65 2.55l-4.78 4.6A.59.59 0 0 1 7 13a.67.67 0 0 1-.44-.17L1.78 8.22a7.84 7.84 0 0 1-1.25-1.6C.37 6.31.24 6 .14 5.67a4.32 4.32 0 0 1 .12-2.51 3.2 3.2 0 0 1 1.95-1.9c.47-.18 1-.27 1.57-.27.3 0 .61.04.91.14.3.09.59.21.86.36s.52.33.77.52c.24.19.47.38.68.58a7.56 7.56 0 0 1 1.46-1.1c.27-.15.55-.27.84-.36.3-.1.6-.14.9-.14.59 0 1.12.09 1.59.26.39.15.73.34 1.02.59Z"
    })),
    starhollow: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M6.32.78a.75.75 0 0 1 1.36 0l1.63 3.54 3.87.46c.63.07.89.86.42 1.3l-2.86 2.64.76 3.81a.75.75 0 0 1-1.1.8L7 11.43l-3.4 1.9a.75.75 0 0 1-1.1-.8l.76-3.81L.4 6.07a.75.75 0 0 1 .42-1.3l3.87-.45L6.32.78ZM7 1.7 5.54 4.86c-.11.24-.34.4-.6.43l-3.46.42 2.56 2.37c.2.17.28.44.23.7l-.68 3.42 3.04-1.7c.23-.14.5-.14.74 0l3.04 1.7-.68-3.43a.75.75 0 0 1 .23-.7l2.56-2.36-3.47-.42a.75.75 0 0 1-.59-.43L7 1.7Z"
    })),
    star: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M7.68.78a.75.75 0 0 0-1.36 0L4.69 4.32l-3.87.46a.75.75 0 0 0-.42 1.3l2.86 2.64-.76 3.81a.75.75 0 0 0 1.1.8l3.4-1.9 3.4 1.9a.75.75 0 0 0 1.1-.8l-.76-3.81 2.86-2.65a.75.75 0 0 0-.42-1.3L9.3 4.33 7.68.78Z"
    })),
    certificate: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M10 7.85A4.49 4.49 0 0 0 7 0a4.5 4.5 0 0 0-3 7.85V13a.5.5 0 0 0 .5.5.5.5 0 0 0 .35-.15L7 11.21l2.15 2.14A.5.5 0 0 0 10 13V7.85ZM7 8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Zm-.35 2.15c.2-.2.5-.2.7 0L9 11.79V8.53a4.48 4.48 0 0 1-4 0v3.26l1.65-1.64Z"
    })),
    verified: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M6.56 13.12a1 1 0 0 1 .88 0l.98.49a1 1 0 0 0 1.31-.43l.52-.97a1 1 0 0 1 .7-.51l1.08-.2a1 1 0 0 0 .81-1.1l-.15-1.1a1 1 0 0 1 .27-.82l.76-.8a1 1 0 0 0 0-1.37l-.76-.79a1 1 0 0 1-.27-.83l.15-1.08a1 1 0 0 0-.8-1.12l-1.09-.19a1 1 0 0 1-.7-.5L9.73.81A1 1 0 0 0 8.43.4l-1 .49a1 1 0 0 1-.87 0L5.58.39a1 1 0 0 0-1.31.43l-.52.97a1 1 0 0 1-.7.51l-1.08.2a1 1 0 0 0-.81 1.1l.15 1.1a1 1 0 0 1-.27.82l-.76.8a1 1 0 0 0 0 1.37l.76.79a1 1 0 0 1 .27.83l-.15 1.08a1 1 0 0 0 .8 1.12l1.09.19a1 1 0 0 1 .7.5l.52.98a1 1 0 0 0 1.3.43l1-.49Zm4.3-8.47c.19.2.19.5 0 .7l-4.5 4.5a.5.5 0 0 1-.71 0l-2.5-2.5a.5.5 0 1 1 .7-.7L6 8.79l4.15-4.14c.2-.2.5-.2.7 0Z"
    })),
    thumbsup: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M11 12.02c-.4.37-.91.56-1.56.56h-.88a5.5 5.5 0 0 1-1.3-.16c-.42-.1-.91-.25-1.47-.45-.3-.12-.63-.21-.95-.27H2.88a.84.84 0 0 1-.62-.26.84.84 0 0 1-.26-.61V6.45c0-.24.09-.45.26-.62a.84.84 0 0 1 .62-.25h1.87c.16-.11.47-.47.93-1.06.27-.35.51-.64.74-.88.1-.11.19-.3.24-.58.05-.28.12-.57.2-.87.1-.3.24-.55.43-.74a.87.87 0 0 1 .62-.25c.38 0 .72.07 1.03.22.3.15.54.38.7.7a2.94 2.94 0 0 1 .21 1.58 3 3 0 0 1-.3 1h1.2c.47 0 .88.17 1.23.52s.52.8.52 1.22c0 .29-.04.66-.34 1.12.05.15.07.3.07.47 0 .35-.09.68-.26.98.07.54-.07 1.08-.4 1.51a1.9 1.9 0 0 1-.57 1.5Zm.47-5.33a.96.96 0 0 0 .03-.25.74.74 0 0 0-.23-.51.68.68 0 0 0-.52-.23H7.93l.73-1.45a2 2 0 0 0 .21-.87c0-.44-.07-.7-.13-.82a.53.53 0 0 0-.24-.24 1.3 1.3 0 0 0-.54-.12.99.99 0 0 0-.14.28c-.08.27-.13.52-.18.76-.06.38-.2.77-.48 1.07v.01l-.02.01c-.2.2-.4.46-.67.8l-.61.76c-.15.17-.35.38-.54.51l-.26.18H5v4.13h.02c.38.08.76.18 1.12.32.53.2.98.33 1.35.42.36.09.71.13 1.07.13h.88c.43 0 .68-.11.87-.29a.9.9 0 0 0 .26-.7l-.02-.37.22-.3c.17-.23.25-.5.2-.78l-.04-.33.17-.3a.97.97 0 0 0 .13-.48c0-.09 0-.13-.02-.15l-.15-.46.26-.4c.1-.15.13-.25.15-.33ZM3.5 10.8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
    })),
    shield: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M11.76 2.08a.5.5 0 0 1 .24.42v6a.5.5 0 0 1-.17.38l-4.5 3.99a.5.5 0 0 1-.67 0l-4.49-4A.5.5 0 0 1 2 8.5V2.5c0-.18.1-.34.24-.42l.01-.02a2.5 2.5 0 0 1 .3-.16c.22-.1.52-.24.92-.37C4.27 1.26 5.44 1 7 1c1.56 0 2.73.26 3.53.53a6.97 6.97 0 0 1 1.22.53l.01.02ZM3 2.79v5.49l1.07.94 6.59-6.58-.44-.17C9.52 2.24 8.44 2 7 2c-1.44 0-2.52.24-3.22.47-.35.12-.6.24-.78.32Zm4 9.04L4.82 9.9 11 3.71v4.57l-4 3.55Z"
    })),
    basket: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M10.35 2.85a.5.5 0 1 0-.7-.7l-3 3a.5.5 0 1 0 .7.7l3-3Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M2.09 6H4.5a.5.5 0 0 0 0-1H1.8a.75.75 0 0 0-.74.87l.8 4.88A1.5 1.5 0 0 0 3.36 12h7.3a1.5 1.5 0 0 0 1.48-1.25l.81-4.88A.75.75 0 0 0 12.2 5H10a.5.5 0 0 0 0 1h1.91l-.76 4.58a.5.5 0 0 1-.5.42h-7.3a.5.5 0 0 1-.5-.42L2.1 6Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M4.5 7c.28 0 .5.22.5.5v2a.5.5 0 0 1-1 0v-2c0-.28.22-.5.5-.5ZM10 7.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0v-2ZM6.5 9.5v-2a.5.5 0 0 1 1 0v2a.5.5 0 0 1-1 0Z"
    })),
    beaker: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M4.5 2h.75v3.87l-3.03 5.26c-.48.83.12 1.87 1.08 1.87h7.4c.96 0 1.57-1.04 1.08-1.87L8.75 5.87V2h.75a.5.5 0 0 0 0-1h-5a.5.5 0 0 0 0 1Zm1.75 4V2h1.5v4.13l.07.12 1 1.75H5.18l1.01-1.75.07-.12V6ZM4.6 9l-1.52 2.63c-.1.16.03.37.22.37h7.4c.2 0 .31-.2.22-.37L9.4 9H4.6Z"
    })),
    hourglass: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M7.5 10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M3.5 1a.5.5 0 0 0-.5.5c0 1.06.14 1.9.68 2.97.34.7.86 1.5 1.6 2.53a16.53 16.53 0 0 0-1.8 2.96A6 6 0 0 0 3 12.49v.01a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5 6 6 0 0 0-.48-2.54c-.34-.8-.9-1.71-1.8-2.96a19.78 19.78 0 0 0 1.6-2.53c.54-1.08.68-1.9.68-2.97a.5.5 0 0 0-.5-.5h-7Zm6.49 11a4.68 4.68 0 0 0-.39-1.65c-.27-.65-.73-1.4-1.5-2.5a133 133 0 0 1-.75 1 .5.5 0 0 1-.56.1.5.5 0 0 1-.2-.16l-.7-.94a14.36 14.36 0 0 0-1.5 2.5A4.68 4.68 0 0 0 4.02 12H10ZM6.3 6.72l.7.94a90.06 90.06 0 0 0 .7-.96c.49-.67.87-1.22 1.17-1.7H5.13A32.67 32.67 0 0 0 6.3 6.72ZM4.56 4h4.88c.36-.73.5-1.31.55-2H4c.04.69.19 1.27.55 2Z"
    })),
    flag: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M11.5 1h-9a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 1 0V8h8.5a.5.5 0 0 0 .35-.85L9.21 4.5l2.64-2.65A.5.5 0 0 0 11.5 1ZM8.15 4.15 10.29 2H3v5h7.3L8.14 4.85a.5.5 0 0 1 0-.7Z"
    })),
    cloudhollow: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M10 7V6a3 3 0 0 0-5.9-.74l-.18.68-.7.07A2.5 2.5 0 0 0 3.5 11h3.19l.07-.01h.08L7 11h4a2 2 0 1 0 0-4h-1ZM3.12 5.02A3.5 3.5 0 0 0 3.5 12H11a3 3 0 1 0 0-6 4 4 0 0 0-7.88-.98Z"
    })),
    cloud: (0, _reactDefault.default).createElement("path", {
        d: "M7 2a4 4 0 0 1 4 4 3 3 0 1 1 0 6H3.5a3.5 3.5 0 0 1-.38-6.98A4 4 0 0 1 7 2Z"
    }),
    edit: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "m13.85 2.15-2-2a.5.5 0 0 0-.7 0l-1.5 1.5-9 9a.5.5 0 0 0-.14.26L0 13.39a.5.5 0 0 0 .14.46.5.5 0 0 0 .46.14l2.48-.5a.5.5 0 0 0 .27-.14l9-9 1.5-1.5a.5.5 0 0 0 0-.7ZM12 3.29l.8-.79-1.3-1.3-.8.8L12 3.3Zm-2-.58L1.7 11 3 12.3 11.3 4 10 2.7ZM1.14 12.86l.17-.85.68.68-.85.17Z"
    })),
    cog: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M5.59 5.59a2 2 0 0 1 3.27 2.14.5.5 0 1 0 .93.37 3 3 0 1 0-1.7 1.7.5.5 0 1 0-.36-.94A2 2 0 0 1 5.6 5.6Z",
        fill: "#333"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M.94 6.53c.13.12.19.3.18.46 0 .17-.05.34-.18.47L0 8.39c.19.94.55 1.81 1.07 2.58h1.32c.18 0 .34.07.46.2.12.11.2.27.2.45v1.32c.76.51 1.62.88 2.55 1.06l.94-.94a.63.63 0 0 1 .45-.19h.03c.16 0 .33.07.45.19l.94.94a7.1 7.1 0 0 0 2.55-1.06v-1.33c0-.18.07-.35.2-.46.11-.12.27-.2.45-.2h1.33A7.1 7.1 0 0 0 14 8.4l-.95-.94a.64.64 0 0 1-.18-.47c0-.17.06-.34.18-.46l.95-.95a7.1 7.1 0 0 0-1.05-2.52h-1.34a.63.63 0 0 1-.46-.2.64.64 0 0 1-.2-.46V1.06A7.1 7.1 0 0 0 8.42 0l-.94.94a.63.63 0 0 1-.45.19H7a.63.63 0 0 1-.45-.19L5.6 0a7.1 7.1 0 0 0-2.56 1.06v1.33c0 .18-.07.34-.2.46a.63.63 0 0 1-.45.2H1.06A7.1 7.1 0 0 0 0 5.59l.94.94Zm.7 1.63c.33-.32.49-.75.48-1.17 0-.42-.15-.85-.47-1.17l-.54-.54c.12-.43.3-.85.51-1.23h.77c.46 0 .87-.2 1.17-.5.3-.29.48-.7.48-1.16v-.77c.4-.22.81-.39 1.25-.52l.54.55c.33.32.75.48 1.16.48h.03c.42 0 .84-.16 1.16-.48l.54-.54c.44.12.85.3 1.24.5v.8c0 .45.19.87.49 1.16.3.3.7.5 1.16.5h.78c.2.37.38.78.5 1.2l-.54.55c-.33.32-.49.75-.48 1.17 0 .42.15.85.48 1.17l.55.55c-.13.44-.3.85-.52 1.24h-.77c-.45 0-.87.2-1.16.5-.3.29-.5.7-.5 1.16v.77c-.38.21-.8.39-1.23.51l-.54-.54a1.64 1.64 0 0 0-1.16-.48H7c-.41 0-.83.16-1.16.48l-.54.55a6.1 6.1 0 0 1-1.25-.52v-.76c0-.45-.19-.87-.48-1.16-.3-.3-.71-.5-1.17-.5h-.76a6.1 6.1 0 0 1-.53-1.25l.55-.55Z"
    })),
    nut: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M5.59 8.41a2 2 0 1 1 3.27-.68.5.5 0 1 0 .93.37 3 3 0 1 0-1.7 1.7.5.5 0 0 0-.36-.94 2 2 0 0 1-2.14-.45Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M6.5.29a1 1 0 0 1 1 0l5.06 2.92c.31.18.5.51.5.87v5.84a1 1 0 0 1-.5.87L7.5 13.7a1 1 0 0 1-1 0L1.44 10.8a1 1 0 0 1-.5-.87V4.08a1 1 0 0 1 .5-.87L6.5.3Zm.5.86 5.06 2.93v5.84L7 12.85 1.94 9.92V4.08L7 1.15Z"
    })),
    wrench: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M10.5 1c.44 0 .56.52.25.83l-.8.81c-.2.2-.2.52 0 .72l.69.7c.2.2.52.2.72 0l.8-.81c.32-.31.84-.2.84.25a2.5 2.5 0 0 1-3.41 2.33L2.7 12.7a1 1 0 0 1-1.42-1.42l6.88-6.88A2.5 2.5 0 0 1 10.5 1ZM2 12.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
    })),
    ellipsis: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M4 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM13 7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0ZM7 8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
    })),
    check: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M13.85 3.35a.5.5 0 0 0-.7-.7L5 10.79.85 6.65a.5.5 0 1 0-.7.7l4.5 4.5c.2.2.5.2.7 0l8.5-8.5Z"
    })),
    form: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M2 1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6.4a.5.5 0 0 0-1 0V12H2V2h7.5a.5.5 0 0 0 0-1H2Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "m6.35 9.86 7.5-7.5a.5.5 0 0 0-.7-.71L6 8.8 3.85 6.65a.5.5 0 1 0-.7.7l2.5 2.5c.2.2.5.2.7 0Z"
    })),
    batchdeny: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M11.5 2a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2Zm-2.646.646a.5.5 0 0 1 0 .708L5.207 7l3.647 3.646a.5.5 0 0 1-.708.708L4.5 7.707.854 11.354a.5.5 0 0 1-.708-.708L3.793 7 .146 3.354a.5.5 0 1 1 .708-.708L4.5 6.293l3.646-3.647a.5.5 0 0 1 .708 0ZM11 7a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 11 7Zm.5 4a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2Z"
    })),
    batchaccept: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M11.5 2a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2Zm-2.2.6a.5.5 0 0 1 .1.7l-5.995 7.993a.505.505 0 0 1-.37.206.5.5 0 0 1-.395-.152L.146 8.854a.5.5 0 1 1 .708-.708l2.092 2.093L8.6 2.7a.5.5 0 0 1 .7-.1ZM11 7a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2A.5.5 0 0 1 11 7Zm.5 4a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2Z"
    })),
    controls: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M10.5 1c.28 0 .5.22.5.5V2h1.5a.5.5 0 0 1 0 1H11v.5a.5.5 0 0 1-1 0V3H1.5a.5.5 0 0 1 0-1H10v-.5c0-.28.22-.5.5-.5ZM1.5 11a.5.5 0 0 0 0 1H10v.5a.5.5 0 0 0 1 0V12h1.5a.5.5 0 0 0 0-1H11v-.5a.5.5 0 0 0-1 0v.5H1.5ZM1 7c0-.28.22-.5.5-.5H3V6a.5.5 0 0 1 1 0v.5h8.5a.5.5 0 0 1 0 1H4V8a.5.5 0 0 1-1 0v-.5H1.5A.5.5 0 0 1 1 7Z"
    })),
    plus: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M7.5.5a.5.5 0 0 0-1 0v6h-6a.5.5 0 0 0 0 1h6v6a.5.5 0 0 0 1 0v-6h6a.5.5 0 0 0 0-1h-6v-6Z"
    })),
    closeAlt: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M2.03.97A.75.75 0 0 0 .97 2.03L5.94 7 .97 11.97a.75.75 0 1 0 1.06 1.06L7 8.06l4.97 4.97a.75.75 0 1 0 1.06-1.06L8.06 7l4.97-4.97A.75.75 0 0 0 11.97.97L7 5.94 2.03.97Z"
    })),
    cross: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M1.85 1.15a.5.5 0 1 0-.7.7L6.29 7l-5.14 5.15a.5.5 0 0 0 .7.7L7 7.71l5.15 5.14a.5.5 0 0 0 .7-.7L7.71 7l5.14-5.15a.5.5 0 0 0-.7-.7L7 6.29 1.85 1.15Z"
    })),
    trash: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M5.5 4.5c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0V5c0-.28.22-.5.5-.5ZM9 5a.5.5 0 0 0-1 0v5a.5.5 0 0 0 1 0V5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M4.5.5c0-.28.22-.5.5-.5h4c.28 0 .5.22.5.5V2h3a.5.5 0 0 1 0 1H12v8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V3h-.5a.5.5 0 0 1 0-1h3V.5ZM3 3v8a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V3H3Zm2.5-2h3v1h-3V1Z"
    })),
    pinalt: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M13.44 4.44 9.56.56a1.5 1.5 0 0 0-2.12 0L7 1a1.41 1.41 0 0 0 0 2L5 5H3.66A4 4 0 0 0 .83 6.17l-.48.48a.5.5 0 0 0 0 .7l2.8 2.8-3 3a.5.5 0 0 0 .7.7l3-3 2.8 2.8c.2.2.5.2.7 0l.48-.48A4 4 0 0 0 9 10.34V9l2-2c.55.55 1.45.55 2 0l.44-.44a1.5 1.5 0 0 0 0-2.12ZM11 5.59l-3 3v1.75a3 3 0 0 1-.88 2.12L7 12.6 1.41 7l.13-.12A3 3 0 0 1 3.66 6H5.4l3-3-.7-.7a.41.41 0 0 1 0-.6l.44-.43c.2-.2.5-.2.7 0l3.88 3.88c.2.2.2.5 0 .7l-.44.44a.41.41 0 0 1-.58 0L11 5.6Z"
    })),
    unpin: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M13.44 4.44 9.56.56a1.5 1.5 0 0 0-2.12 0L7 1a1.41 1.41 0 0 0 0 2L5.7 4.3l.71.7 2-2-.7-.7a.41.41 0 0 1 0-.6l.44-.43c.2-.2.5-.2.7 0l3.88 3.88c.2.2.2.5 0 .7l-.44.44a.41.41 0 0 1-.58 0L11 5.6l-2 2 .7.7L11 7c.55.55 1.45.55 2 0l.44-.44a1.5 1.5 0 0 0 0-2.12ZM.83 6.17A4 4 0 0 1 3.59 5l1 1h-.93a3 3 0 0 0-2.12.88L1.4 7 7 12.59l.12-.13A3 3 0 0 0 8 10.34v-.93l1 1a4 4 0 0 1-1.17 2.76l-.48.48a.5.5 0 0 1-.7 0l-2.8-2.8-3 3a.5.5 0 0 1-.7-.7l3-3-2.8-2.8a.5.5 0 0 1 0-.7l.48-.48Zm1.02-5.02a.5.5 0 1 0-.7.7l11 11a.5.5 0 0 0 .7-.7l-11-11Z"
    })),
    add: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M7 3c.28 0 .5.22.5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3c0-.28.22-.5.5-.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14Zm0-1A6 6 0 1 0 7 1a6 6 0 0 0 0 12Z"
    })),
    subtract: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M3.5 6.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0Zm-1 0A6 6 0 1 1 1 7a6 6 0 0 1 12 0Z"
    })),
    close: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M9.85 4.15c.2.2.2.5 0 .7L7.71 7l2.14 2.15a.5.5 0 0 1-.7.7L7 7.71 4.85 9.85a.5.5 0 0 1-.7-.7L6.29 7 4.15 4.85a.5.5 0 1 1 .7-.7L7 6.29l2.15-2.14c.2-.2.5-.2.7 0Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14Zm0-1A6 6 0 1 0 7 1a6 6 0 0 0 0 12Z"
    })),
    delete: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0Zm-1 0a6 6 0 0 1-9.87 4.58l8.45-8.45A5.98 5.98 0 0 1 13 7ZM2.42 10.87l8.45-8.45a6 6 0 0 0-8.46 8.46Z"
    })),
    passed: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14Zm3.85-9.35c.2.2.2.5 0 .7l-4.5 4.5a.5.5 0 0 1-.7 0l-2.5-2.5a.5.5 0 1 1 .7-.7L6 8.79l4.15-4.14c.2-.2.5-.2.7 0Z"
    })),
    changed: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14ZM3.5 6.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Z"
    })),
    failed: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14Zm2.85-9.85c.2.2.2.5 0 .7L7.71 7l2.14 2.15a.5.5 0 0 1-.7.7L7 7.71 4.85 9.85a.5.5 0 0 1-.7-.7L6.29 7 4.15 4.85a.5.5 0 1 1 .7-.7L7 6.29l2.15-2.14c.2-.2.5-.2.7 0Z"
    })),
    clear: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M5 2h7a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-1.41-.59l-3-3a2 2 0 0 1 0-2.82l3-3A2 2 0 0 1 5 2Zm1.15 3.15c.2-.2.5-.2.7 0L8 6.29l1.15-1.14a.5.5 0 1 1 .7.7L8.71 7l1.14 1.15a.5.5 0 0 1-.7.7L8 7.71 6.85 8.85a.5.5 0 1 1-.7-.7L7.29 7 6.15 5.85a.5.5 0 0 1 0-.7Z"
    })),
    comment: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M3.5 5a.5.5 0 1 0 0 1h7a.5.5 0 0 0 0-1h-7ZM3 8.5c0-.27.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M12.5 12H5.7l-1.85 1.86a.5.5 0 0 1-.35.14.5.5 0 0 1-.5-.5V12H1.5a.5.5 0 0 1-.5-.5v-9c0-.27.22-.5.5-.5h11c.28 0 .5.23.5.5v9a.5.5 0 0 1-.5.5ZM2 11V3h10v8H2Z"
    })),
    commentadd: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M7.5 5a.5.5 0 1 0-1 0v1.5H5a.5.5 0 1 0 0 1h1.5V9a.5.5 0 0 0 1 0V7.5H9a.5.5 0 0 0 0-1H7.5V5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M3.7 13.97a.5.5 0 0 1-.7-.46V12H1.5a.5.5 0 0 1-.5-.5v-9c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5v9a.5.5 0 0 1-.5.5H5.7l-1.85 1.85a.5.5 0 0 1-.16.1ZM2 3v8h10V3H2Z"
    })),
    requestchange: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M9.85 6.65c.2.2.2.51 0 .7l-2 2a.5.5 0 1 1-.7-.7L8.3 7.5H4.5a.5.5 0 0 1 0-1h3.79L7.15 5.36a.5.5 0 1 1 .7-.71l2 2Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M3.7 13.97a.5.5 0 0 1-.7-.46V12H1.5a.5.5 0 0 1-.5-.5v-9c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5v9a.5.5 0 0 1-.5.5H5.7l-1.85 1.85a.5.5 0 0 1-.16.1ZM2 3v8h10V3H2Z"
    })),
    comments: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M8.5 7a.5.5 0 0 0 0-1h-5a.5.5 0 1 0 0 1h5ZM9 8.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1 0-1h5c.28 0 .5.23.5.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M12 11.5V10h1.5a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5V3H.5a.5.5 0 0 0-.5.5v8c0 .28.22.5.5.5H2v1.5a.5.5 0 0 0 .5.5.5.5 0 0 0 .35-.14L4.71 12h6.79a.5.5 0 0 0 .5-.5ZM3 3V2h10v7h-1V3.5a.5.5 0 0 0-.5-.5H3Zm-2 8V4h10v7H1Z"
    })),
    lock: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M8 8a1 1 0 0 1-.5.87v1.63a.5.5 0 0 1-1 0V8.87A1 1 0 1 1 8 8Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M3 4a4 4 0 1 1 8 0v1h1.5c.28 0 .5.23.5.5v8a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-8c0-.27.22-.5.5-.5H3V4Zm7 1V4a3 3 0 1 0-6 0v1h6Zm2 1H2v7h10V6Z"
    })),
    unlock: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M6.5 8.87a1 1 0 1 1 1 0v1.63a.5.5 0 0 1-1 0V8.87Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 1a3 3 0 0 0-3 3v1h8.5c.28 0 .5.23.5.5v8a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-8c0-.27.22-.5.5-.5H3V4a4 4 0 0 1 7.76-1.38.5.5 0 0 1-.94.34A3 3 0 0 0 7 1ZM2 6h10v7H2V6Z"
    })),
    key: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M11 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M7.5 8.53v.97a.5.5 0 0 1-.5.5H5.5v1.5a.5.5 0 0 1-.5.5H3.5v1.5a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .15-.36l5.12-5.11a4.5 4.5 0 1 1 2.23 2.5ZM6 4.5a3.5 3.5 0 1 1 1.5 2.87c-.29-.2-1-.37-1 .48V9H5a.5.5 0 0 0-.5.5V11H3a.5.5 0 0 0-.5.5V13H1v-1.3l5.2-5.19c.15-.16.18-.4.1-.6A3.47 3.47 0 0 1 6 4.5Z"
    })),
    outbox: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M7.35.15a.5.5 0 0 0-.7 0l-2 2a.5.5 0 1 0 .7.7L6.5 1.72v6.8a.5.5 0 0 0 1 0V1.7l1.15 1.15a.5.5 0 1 0 .7-.71l-2-2Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M2 7.5a.5.5 0 1 0-1 0v5c0 .28.22.5.5.5h11a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-1 0V12H2V7.5Z"
    })),
    credit: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M2.5 8a.5.5 0 1 0 0 1h3a.5.5 0 0 0 0-1h-3Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M0 11.5c0 .28.22.5.5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5H.5a.5.5 0 0 0-.5.5v9ZM1 3v1h12V3H1Zm0 8h12V6H1v5Z"
    })),
    button: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M1 3a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h3.5a.5.5 0 1 0 0-1H1V4h12v5h-1a.5.5 0 0 0 0 1h1a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H1Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M6.45 7a.5.5 0 0 1 .3.08l3.48 2.02a.5.5 0 0 1 0 .87l-1.08.62.75 1.3a.75.75 0 0 1-1.3.75l-.75-1.3-1.07.62a.5.5 0 0 1-.67-.13.5.5 0 0 1-.1-.3L6 7.5a.5.5 0 0 1 .45-.5Z"
    })),
    type: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M4 1.5c0-.27.22-.5.5-.5h5a.5.5 0 1 1 0 1h-2v10h2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h2V2h-2a.5.5 0 0 1-.5-.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M0 4.5c0-.27.22-.5.5-.5h4a.5.5 0 1 1 0 1H1v4h3.5a.5.5 0 1 1 0 1h-4a.5.5 0 0 1-.5-.5v-5ZM9.5 4a.5.5 0 1 0 0 1H13v4H9.5a.5.5 0 1 0 0 1h4a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-4Z"
    })),
    pointerdefault: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M5.94 12.46c.11 0 .2-.06.25-.15l1.58-3.16 2.54 2.54c.04.05.1.07.19.07a.3.3 0 0 0 .2-.07l.8-.8a.27.27 0 0 0 0-.38L8.9 7.9l3.4-1.7c.06-.03.1-.07.12-.11a.22.22 0 0 0 .04-.14.33.33 0 0 0-.06-.16.17.17 0 0 0-.09-.07h-.02L1.91 1.55a.27.27 0 0 0-.35.36l4.15 10.37c.04.09.12.16.23.17Zm-.03 1h-.02a1.28 1.28 0 0 1-1.1-.8L.62 2.29A1.27 1.27 0 0 1 2.3.63l10.35 4.15c.52.18.79.65.81 1.11.04.53-.27.98-.7 1.2l-2.17 1.08L12.2 9.8c.5.5.5 1.3 0 1.8l-.8.8v.01c-.5.46-1.3.48-1.8-.01l-1.56-1.56-.95 1.92c-.23.45-.68.7-1.15.7h-.03Z"
    })),
    pointerhand: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M11.87 6v-.02c-.03-.27-.23-.48-.47-.5a.5.5 0 0 0-.53.5v1.41c0 .25-.22.47-.47.47a.48.48 0 0 1-.47-.47V5.17a.6.6 0 0 0 0-.05c-.02-.27-.23-.5-.47-.5a.5.5 0 0 0-.52.5v1.65l-.01.1a.49.49 0 0 1-.46.37.48.48 0 0 1-.47-.47V4.62a.6.6 0 0 0 0-.05c-.03-.27-.23-.48-.47-.5a.5.5 0 0 0-.53.5v2.2c0 .25-.22.47-.47.47a.49.49 0 0 1-.47-.47V1.75c-.02-.27-.22-.5-.47-.5a.5.5 0 0 0-.52.5v6.78c0 .25-.22.47-.47.47a.48.48 0 0 1-.47-.47v-.26a.78.78 0 0 0-.06-.31.65.65 0 0 0-.16-.22l-.2-.19A6.37 6.37 0 0 0 3.06 7h-.02c-.43-.34-.62-.25-.69-.2-.26.14-.29.5-.13.74l1.73 2.6v.01h-.01l-.04.02.05-.02s1.21 2.6 3.57 2.6c3.54 0 4.2-1.9 4.31-4.42.04-.6.04-1.19.03-1.78V6Zm.97 2.38c-.06 1.29-.26 2.67-1.08 3.72-.88 1.12-2.29 1.65-4.23 1.65a4.64 4.64 0 0 1-3.4-1.62 6.96 6.96 0 0 1-1.05-1.5v-.02L1.4 8.1A1.6 1.6 0 0 1 1.15 7c.05-.38.26-.8.69-1.04.2-.13.48-.23.85-.19.36.05.68.22.98.45.14.1.27.22.4.33v-4.8A1.5 1.5 0 0 1 5.63.25c.93.04 1.43.86 1.43 1.55v1.33c.17-.05.35-.07.53-.06h.02c.5.04.91.33 1.15.71a1.5 1.5 0 0 1 .74-.16c.66.03 1.12.46 1.32.97a1.5 1.5 0 0 1 .64-.1h.02c.85.06 1.39.8 1.39 1.55v.48c0 .6 0 1.24-.03 1.86Z"
    })),
    browser: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M.5 13a.5.5 0 0 1-.5-.5v-11c0-.27.22-.5.5-.5h13c.28 0 .5.23.5.5v11a.5.5 0 0 1-.5.5H.5Zm.5-1V4h12v8H1Zm1-9.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm2 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm2 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
    })),
    tablet: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M3.5 0C2.67 0 2 .68 2 1.5v11c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-11c0-.82-.67-1.5-1.5-1.5h-7Zm0 1h7c.28 0 .5.23.5.5V11H3V1.5c0-.27.22-.5.5-.5ZM6 12a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H6Z"
    })),
    mobile: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M3 1.5C3 .68 3.67 0 4.5 0h5c.83 0 1.5.68 1.5 1.5v11c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 3 12.5v-11ZM4 12V2h6v10H4Z"
    })),
    watch: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        key: "watch",
        fillRule: "evenodd",
        d: "M4 .5c0-.27.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5A.5.5 0 0 1 4 .5ZM9.5 3h-5a.5.5 0 0 0-.5.5v7c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5Zm-5-1C3.67 2 3 2.68 3 3.5v7c0 .83.67 1.5 1.5 1.5h5c.83 0 1.5-.67 1.5-1.5v-7c0-.82-.67-1.5-1.5-1.5h-5ZM7 4c.28 0 .5.23.5.5v2h1a.5.5 0 1 1 0 1H7a.5.5 0 0 1-.5-.5V4.5c0-.27.22-.5.5-.5Zm-2.5 9a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Z"
    })),
    sidebar: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M2.5 4.5c0-.27.22-.5.5-.5h1a.5.5 0 1 1 0 1H3a.5.5 0 0 1-.5-.5ZM3 6a.5.5 0 1 0 0 1h1a.5.5 0 0 0 0-1H3Zm-.5 2.5c0-.27.22-.5.5-.5h1a.5.5 0 1 1 0 1H3a.5.5 0 0 1-.5-.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M1.5 13a.5.5 0 0 1-.5-.5v-11c0-.27.22-.5.5-.5h11c.28 0 .5.23.5.5v11a.5.5 0 0 1-.5.5h-11Zm.5-1V2h3v10H2ZM6 2h6v10H6V2Z"
    })),
    sidebaralt: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M9.5 4.5c0-.27.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5ZM10 6a.5.5 0 1 0 0 1h1a.5.5 0 0 0 0-1h-1Zm-.5 2.5c0-.27.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M1.5 13a.5.5 0 0 1-.5-.5v-11c0-.27.22-.5.5-.5h11c.28 0 .5.23.5.5v11a.5.5 0 0 1-.5.5h-11Zm.5-1V2h6v10H2ZM9 2h3v10H9V2Z"
    })),
    sidebaralttoggle: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M11.5 4.5A.5.5 0 0 0 11 4h-1a.5.5 0 1 0 0 1h1a.5.5 0 0 0 .5-.5ZM11 6a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1Zm.5 2.5A.5.5 0 0 0 11 8h-1a.5.5 0 1 0 0 1h1a.5.5 0 0 0 .5-.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M1.5 13a.5.5 0 0 1-.5-.5v-11c0-.27.22-.5.5-.5h11c.28 0 .5.23.5.5v11a.5.5 0 0 1-.5.5h-11ZM9 12h3V2H9v10Zm-1 0H2V2h6v4.5H5.2l.66-.65a.5.5 0 1 0-.71-.7l-1.5 1.5a.5.5 0 0 0 0 .7l1.5 1.5a.5.5 0 1 0 .7-.7l-.64-.65H8V12Z"
    })),
    sidebartoggle: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M2.5 4.5c0-.27.22-.5.5-.5h1a.5.5 0 1 1 0 1H3a.5.5 0 0 1-.5-.5ZM3 6a.5.5 0 1 0 0 1h1a.5.5 0 0 0 0-1H3Zm-.5 2.5c0-.27.22-.5.5-.5h1a.5.5 0 1 1 0 1H3a.5.5 0 0 1-.5-.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M1.5 13a.5.5 0 0 1-.5-.5v-11c0-.27.22-.5.5-.5h11c.28 0 .5.23.5.5v11a.5.5 0 0 1-.5.5h-11Zm.5-1V2h3v10H2Zm4 0V7.5h2.8l-.65.65a.5.5 0 1 0 .7.7l1.5-1.5a.5.5 0 0 0 0-.7l-1.5-1.5a.5.5 0 1 0-.7.7l.64.65H6V2h6v10H6Z"
    })),
    bottombar: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M3 10.5c0-.27.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Zm3.5-.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm2.5.5c0-.27.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M1 1.5c0-.27.22-.5.5-.5h11c.28 0 .5.23.5.5v11a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11ZM2 8V2h10v6H2Zm10 1v3H2V9h10Z"
    })),
    bottombartoggle: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M3.5 10a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm2.5.5c0-.27.22-.5.5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Zm3.5-.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M1 12.5v-11c0-.27.22-.5.5-.5h11c.28 0 .5.23.5.5v11a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5Zm1-.5V9h10v3H2Zm4.5-4H2V2h10v6H7.5V5.21l.65.65a.5.5 0 1 0 .7-.71l-1.5-1.5a.5.5 0 0 0-.7 0l-1.5 1.5a.5.5 0 1 0 .7.7l.65-.64v2.8Z"
    })),
    cpu: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M5 5.5c0-.27.22-.5.5-.5h3c.28 0 .5.23.5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3ZM6 8V6h2v2H6Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M5.5 0c.28 0 .5.23.5.5V2h2V.5a.5.5 0 0 1 1 0V2h2.5c.28 0 .5.23.5.5V5h1.5a.5.5 0 0 1 0 1H12v2h1.5a.5.5 0 0 1 0 1H12v2.5a.5.5 0 0 1-.5.5H9v1.5a.5.5 0 0 1-1 0V12H6v1.5a.5.5 0 0 1-1 0V12H2.5a.5.5 0 0 1-.5-.5V9H.5a.5.5 0 0 1 0-1H2V6H.5a.5.5 0 0 1 0-1H2V2.5c0-.27.22-.5.5-.5H5V.5c0-.27.22-.5.5-.5ZM11 3H3v8h8V3Z"
    })),
    database: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M12 3c0-1.1-2.24-2-5-2s-5 .9-5 2v8c0 .43.26.75.54.98.3.23.68.41 1.12.55.88.3 2.06.47 3.34.47 1.28 0 2.46-.17 3.34-.46.44-.15.83-.33 1.12-.56.28-.23.54-.55.54-.98V3Zm-1.03 0a2.45 2.45 0 0 0-.8-.49A8.88 8.88 0 0 0 7 2c-1.29 0-2.4.21-3.16.51a2.45 2.45 0 0 0-.81.49l.05.05c.13.13.37.28.76.44C4.6 3.79 5.7 4 7 4s2.4-.21 3.16-.51a2.45 2.45 0 0 0 .81-.49ZM11 5.75V4.2A8.9 8.9 0 0 1 7 5a8.98 8.98 0 0 1-4-.8v1.55l.02.04c.02.04.06.09.14.15.17.13.44.27.82.4A10 10 0 0 0 7 6.75a10 10 0 0 0 3.02-.41c.38-.13.65-.27.82-.4a.62.62 0 0 0 .14-.15.15.15 0 0 0 .02-.03v-.01ZM3 7.01c.2.1.42.2.66.28.88.29 2.06.46 3.34.46 1.28 0 2.46-.17 3.34-.46.24-.08.46-.17.66-.28V8.5l-.02.04a.62.62 0 0 1-.14.15c-.17.13-.44.27-.82.4A10 10 0 0 1 7 9.5a10 10 0 0 1-3.02-.41 2.76 2.76 0 0 1-.82-.4.62.62 0 0 1-.14-.15.15.15 0 0 1-.02-.03V7Zm0 2.75V11l.02.04c.02.04.06.09.14.15.17.13.44.27.82.4A10 10 0 0 0 7 12a10 10 0 0 0 3.02-.41c.38-.13.65-.27.82-.4a.62.62 0 0 0 .14-.15.15.15 0 0 0 .02-.03V9.76c-.2.1-.42.2-.66.28-.88.29-2.06.46-3.34.46-1.28 0-2.46-.17-3.34-.46A4.77 4.77 0 0 1 3 9.76Z"
    })),
    memory: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M5 3a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0V3Zm2-.5c.28 0 .5.22.5.5v3a.5.5 0 0 1-1 0V3c0-.28.22-.5.5-.5Zm3 2a.5.5 0 1 0-1 0V6a.5.5 0 0 0 1 0V4.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M12 3.54a.5.5 0 0 0-.15-.39l-3-3a.5.5 0 0 0-.38-.14H2.5a.5.5 0 0 0-.5.5v13c0 .27.22.5.5.5h9a.5.5 0 0 0 .5-.5V3.53ZM3 1h5.3L11 3.71v5.3H3V1Zm0 9v3h8v-3H3Z"
    })),
    structure: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M8.16 3.45a1.5 1.5 0 1 0-2.33 0l-4.02 6.58A1.5 1.5 0 1 0 2.91 12h8.18a1.5 1.5 0 1 0 1.1-1.97L8.16 3.45Zm-1.47.52a1.5 1.5 0 0 0 .62 0l4.03 6.58c-.11.14-.2.29-.25.45H2.9a1.5 1.5 0 0 0-.25-.45L6.7 3.97Z"
    })),
    box: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "m7.21.05 6.49 2.99a.5.5 0 0 1 .3.47v6.98a.5.5 0 0 1-.3.47l-6.47 2.98a.5.5 0 0 1-.46 0L.3 10.96a.5.5 0 0 1-.3-.47V3.5a.5.5 0 0 1 .3-.47L6.79.05a.5.5 0 0 1 .43 0ZM1 4.28v5.9l5.5 2.54v-5.9L1 4.28Zm6.5 8.44 5.5-2.54v-5.9L7.5 6.82v5.9Zm4.8-9.22L7 5.95 1.7 3.5 7 1.05l5.3 2.45Z"
    })),
    power: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M7.5.5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0v-6Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M4.27 2.8a.5.5 0 0 0-.54-.83 6 6 0 1 0 6.54 0 .5.5 0 0 0-.54.84 5 5 0 1 1-5.46 0Z"
    })),
    photo: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M6.25 4.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm-.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M13 1.5v11a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11c0-.27.22-.5.5-.5h11c.28 0 .5.23.5.5ZM2 9.3V2h10v5.3L9.85 5.15a.5.5 0 0 0-.7 0L6.5 7.8 5.35 6.65a.5.5 0 0 0-.7 0L2 9.3Zm7.5-3.1L12 8.7V12H2v-1.3l3-3 3.15 3.15a.5.5 0 0 0 .7-.71L7.21 8.5 9.5 6.21Z"
    })),
    component: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M3.5 1A2.5 2.5 0 0 0 1 3.5v7A2.5 2.5 0 0 0 3.5 13h7a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 10.5 1h-7ZM12 6.5H7.5V2h3c.83 0 1.5.68 1.5 1.5v3Zm0 1v3c0 .83-.67 1.5-1.5 1.5h-3V7.5H12ZM6.5 12V7.5H2v3c0 .83.67 1.5 1.5 1.5h3ZM2 6.5h4.5V2h-3C2.67 2 2 2.68 2 3.5v3Z"
    })),
    grid: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M1 1.5c0-.27.22-.5.5-.5H6c.28 0 .5.23.5.5V6a.5.5 0 0 1-.5.5H1.5A.5.5 0 0 1 1 6V1.5Zm1 4V2h3.5v3.5H2Zm5.5-4c0-.27.22-.5.5-.5h4.5c.28 0 .5.23.5.5V6a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5V1.5Zm1 4V2H12v3.5H8.5Zm-7 2A.5.5 0 0 0 1 8v4.5c0 .28.22.5.5.5H6a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5H1.5Zm.5 1V12h3.5V8.5H2ZM7.5 8c0-.27.22-.5.5-.5h4.5c.28 0 .5.23.5.5v4.5a.5.5 0 0 1-.5.5H8a.5.5 0 0 1-.5-.5V8Zm1 4V8.5H12V12H8.5Z"
    })),
    outline: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M2 2v2H1V1.5c0-.27.22-.5.5-.5H4v1H2ZM1 9V5h1v4H1Zm0 1v2.5c0 .28.22.5.5.5H4v-1H2v-2H1Zm9 3h2.5a.5.5 0 0 0 .5-.5V10h-1v2h-2v1Zm2-9h1V1.5a.5.5 0 0 0-.5-.5H10v1h2v2Zm-3 8v1H5v-1h4ZM9 1v1H5V1h4Zm4 8h-1V5h1v4ZM7 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    })),
    photodrag: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M8.25 3.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Zm-.5 0a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M14 7V.5a.5.5 0 0 0-.5-.5h-10a.5.5 0 0 0-.5.5V3H.5a.5.5 0 0 0-.5.5V6h1V4h2v6.5c0 .28.22.5.5.5H10v2H8v1h2.5a.5.5 0 0 0 .5-.5V11h2.5a.5.5 0 0 0 .5-.5V7ZM4 1v5.8l1.65-1.65c.2-.2.5-.2.7 0L7.5 6.3l2.65-2.65c.2-.2.5-.2.7 0L13 5.8V1H4Zm9 6.21-2.5-2.5-2.3 2.3 1.15 1.14a.5.5 0 1 1-.7.7L6 6.22l-2 2v1.8h9V7.2Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M0 10V7h1v3H0Zm0 3.5V11h1v2h2v1H.5a.5.5 0 0 1-.5-.5Zm7 .5H4v-1h3v1Z"
    })),
    search: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M9.54 10.2a5.5 5.5 0 1 1 .66-.66c.06.03.11.06.15.1l3 3a.5.5 0 0 1-.7.71l-3-3a.5.5 0 0 1-.1-.14ZM10.5 6a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
    })),
    zoom: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M6 3.5c.28 0 .5.22.5.5v1.5H8a.5.5 0 0 1 0 1H6.5V8a.5.5 0 0 1-1 0V6.5H4a.5.5 0 0 1 0-1h1.5V4c0-.28.22-.5.5-.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M9.54 10.2a5.5 5.5 0 1 1 .66-.66c.06.03.11.06.15.1l3 3a.5.5 0 0 1-.7.71l-3-3a.5.5 0 0 1-.1-.14ZM10.5 6a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z"
    })),
    zoomout: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M4 5.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H4Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M6 11.5c1.35 0 2.59-.49 3.54-1.3.03.06.06.11.1.15l3 3a.5.5 0 0 0 .71-.7l-3-3a.5.5 0 0 0-.14-.1A5.5 5.5 0 1 0 6 11.5Zm0-1a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Z"
    })),
    zoomreset: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M1.5 2.84V1.5a.5.5 0 0 0-1 0V4c0 .28.22.5.5.5h2.5a.5.5 0 0 0 0-1H2.26a4.5 4.5 0 1 1-.5 4.02.5.5 0 1 0-.94.33 5.5 5.5 0 0 0 8.72 2.36l.1.14 3 3a.5.5 0 0 0 .71-.7l-3-3a.5.5 0 0 0-.14-.1 5.5 5.5 0 1 0-8.7-6.7Z"
    })),
    eye: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M7 9.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "m14 7-.2.3c-.13.16-3.06 4.2-6.8 4.2C3.26 11.5.33 7.46.2 7.3L0 7l.2-.3C.34 6.55 3.27 2.5 7 2.5c3.74 0 6.67 4.04 6.8 4.2l.2.3ZM2.9 5.3A13 13 0 0 0 1.24 7 13 13 0 0 0 2.9 8.7c1.14.97 2.58 1.8 4.1 1.8 1.52 0 2.96-.83 4.1-1.8A13 13 0 0 0 12.76 7a13 13 0 0 0-1.66-1.7C9.96 4.33 8.52 3.5 7 3.5c-1.52 0-2.96.83-4.1 1.8Z"
    })),
    eyeclose: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M1.85 1.15a.5.5 0 1 0-.7.7l11 11a.5.5 0 0 0 .7-.7l-11-11ZM11.1 8.7c-.17.15-.36.3-.55.44l.72.71a13.25 13.25 0 0 0 2.52-2.56L14 7l-.2-.3c-.13-.16-3.06-4.2-6.8-4.2-.89 0-1.73.23-2.5.58l.76.76A4.86 4.86 0 0 1 7 3.5c1.52 0 2.96.83 4.1 1.8A13 13 0 0 1 12.76 7a13 13 0 0 1-1.66 1.7ZM.2 6.7c.08-.09 1.04-1.41 2.53-2.55l.72.71c-.2.14-.38.3-.55.44A13 13 0 0 0 1.24 7 13 13 0 0 0 2.9 8.7c1.14.97 2.58 1.8 4.1 1.8.6 0 1.18-.13 1.74-.34l.77.76c-.78.35-1.62.58-2.51.58C3.26 11.5.33 7.46.2 7.3L0 7l.2-.3Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M4.5 7c0-.32.06-.63.17-.91l3.24 3.24A2.5 2.5 0 0 1 4.5 7Zm4.83.91L6.09 4.67a2.5 2.5 0 0 1 3.24 3.24Z"
    })),
    lightning: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M2.52 6.6a.57.57 0 0 0-.17.54c.04.2.19.37.38.41l2.78.73-1.5 5c-.06.24.02.5.22.63a.5.5 0 0 0 .28.09.5.5 0 0 0 .35-.14L11.5 7.4c.14-.13.2-.34.15-.54a.53.53 0 0 0-.38-.4l-2.7-.7L10.79.78c.1-.23.04-.5-.15-.66a.5.5 0 0 0-.65 0L2.52 6.6Zm7.72.63-3.07-.8 1.85-4.14-5.2 4.51 2.94.77-1.27 4.28 4.75-4.62Zm-5.73 6.2.04.02Z"
    })),
    lightningoff: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M10.14 8.72 11.5 7.4c.14-.13.2-.34.15-.54a.53.53 0 0 0-.38-.4l-2.7-.7L10.79.78c.1-.23.04-.5-.15-.66a.5.5 0 0 0-.65 0L5.46 4.05l.71.7L9.02 2.3 7.38 5.97l.7.7 2.16.56-.8.79.7.7ZM2.52 6.6a.57.57 0 0 0-.17.54c.04.2.19.37.38.41l2.78.73-1.5 5c-.06.24.02.5.22.63a.5.5 0 0 0 .63-.05l3.84-3.74-.7-.7-2.51 2.43 1.13-3.81-.68-.69L3.8 6.8l.85-.73-.71-.7L2.52 6.6Zm-.67-5.45a.5.5 0 1 0-.7.7l11 11a.5.5 0 0 0 .7-.7l-11-11Z"
    })),
    contrast: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M3 3H.5a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h10a.5.5 0 0 0 .5-.5V11h2.5a.5.5 0 0 0 .5-.5V.5a.5.5 0 0 0-.5-.5h-10a.5.5 0 0 0-.5.5V3Zm1 1v2.3L6.3 4H4ZM3 4v6.5a.5.5 0 0 0 .5.5H10v2H1V4h2Zm1-1h6.5a.5.5 0 0 1 .5.5V10h2V1H4v2Zm6 7V7.71l-2.3 2.3H10Zm0-3.7V4.7L4.7 10h1.6L10 6.3ZM9.3 4H7.7L4 7.71V9.3L9.3 4Z"
    })),
    switchalt: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M3 3V.5c0-.27.22-.5.5-.5h10c.28 0 .5.23.5.5v10a.5.5 0 0 1-.5.5H11v2.5a.5.5 0 0 1-.5.5H.5a.5.5 0 0 1-.5-.5v-10c0-.27.22-.5.5-.5H3Zm1 0V1h9v9h-2V3.5a.5.5 0 0 0-.5-.5H4Zm6 8v2H1V4h2v6.5c0 .28.22.5.5.5H10Zm0-1H4V4h6v6Z"
    })),
    mirror: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M1 1.5c0-.27.22-.5.5-.5h11c.28 0 .5.23.5.5v11a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11ZM2 12h10V2L2 12Z"
    })),
    grow: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M1.5 1a.5.5 0 1 0 0 1H12v10.5a.5.5 0 0 0 1 0V2a1 1 0 0 0-1-1H1.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M1 3.5c0-.27.22-.5.5-.5H10a1 1 0 0 1 1 1v8.5a.5.5 0 0 1-1 0V4H1.5a.5.5 0 0 1-.5-.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M1.5 5a.5.5 0 0 0-.5.5v7c0 .28.22.5.5.5h7a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-7ZM2 6v6h6V6H2Z"
    })),
    paintbrush: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M11.8535.1464a.5.5 0 0 0-.7071 0L2.9827 8.3102a2.2396 2.2396 0 0 0-1.0737.599C.6772 10.141.2402 11.903.0852 12.9978 0 13.5998 0 14.0002 0 14.0002s.4004 0 1.0023-.0853c1.095-.155 2.8569-.5919 4.0887-1.8237.307-.307.5067-.6806.5992-1.0743l8.1633-8.1633a.5.5 0 0 0 0-.7071l-2-2Zm-6.253 9.546L6.543 8.75l-1.293-1.2929-.9424.9424a2.242 2.242 0 0 1 .7835.5097c.23.2302.4.4977.5095.7831ZM7.25 8.0428 12.7929 2.5 11.5 1.2071 5.957 6.75 7.25 8.0429ZM4.3839 9.6163c.4881.4882.4881 1.2796 0 1.7678-.7665.7664-1.832 1.1845-2.7791 1.403a8.6972 8.6972 0 0 1-.49.0982 8.7151 8.7151 0 0 1 .0982-.4899c.2186-.9471.6367-2.0126 1.403-2.779.4882-.4882 1.2797-.4882 1.7679 0Z"
    })),
    ruler: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M1.5 1c.28 0 .5.23.5.5V2h10v-.5a.5.5 0 0 1 1 0v2a.5.5 0 0 1-1 0V3H2v.5a.5.5 0 0 1-1 0v-2c0-.27.22-.5.5-.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M1.5 6a.5.5 0 0 0-.5.5v6c0 .28.22.5.5.5h11a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-11ZM2 7v5h10V7h-1v2.5a.5.5 0 0 1-1 0V7h-.75v1a.5.5 0 0 1-1 0V7H7.5v2.5a.5.5 0 0 1-1 0V7h-.75v1a.5.5 0 0 1-1 0V7H4v2.5a.5.5 0 0 1-1 0V7H2Z"
    })),
    stop: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M4.5 4a.5.5 0 0 0-.5.5v5c0 .28.22.5.5.5h5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M14 7A7 7 0 1 1 0 7a7 7 0 0 1 14 0Zm-1 0A6 6 0 1 1 1 7a6 6 0 0 1 12 0Z"
    })),
    camera: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M10 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM9 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M2.5 1a.5.5 0 0 0-.5.5V2H.5a.5.5 0 0 0-.5.5v9c0 .28.22.5.5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5H6v-.5a.5.5 0 0 0-.5-.5h-3ZM1 3v8h12V3H1Z"
    })),
    video: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M2.5 10a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M0 4c0-1.1.9-2 2-2h6a2 2 0 0 1 2 2v.5l3.19-2.4a.5.5 0 0 1 .81.4v9a.5.5 0 0 1-.8.4L10 9.5v.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm9 0v1.5a.5.5 0 0 0 .8.4L13 3.5v7L9.8 8.1a.5.5 0 0 0-.8.4V10a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1Z"
    })),
    speaker: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M1 4.50004V9.50004C1 9.77618 1.22386 10 1.5 10H4L7.17075 12.7744C7.49404 13.0573 8 12.8277 8 12.3982V1.60192C8 1.17235 7.49404 0.942757 7.17075 1.22564L4 4.00004H1.5C1.22386 4.00004 1 4.2239 1 4.50004ZM4 9.00004V5.00004H2V9.00004H4ZM4.99804 9.54456C4.99934 9.52989 5 9.51505 5 9.50004V4.50004C5 4.48504 4.99934 4.47019 4.99804 4.45552L7 2.70381V11.2963L4.99804 9.54456Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M10.1498 1.75202C9.88637 1.66927 9.60572 1.81577 9.52297 2.07922C9.44023 2.34267 9.58672 2.62332 9.85017 2.70607C11.6763 3.27963 13 4.98596 13 7.00014C13 9.01433 11.6763 10.7207 9.85017 11.2942C9.58672 11.377 9.44023 11.6576 9.52297 11.9211C9.60572 12.1845 9.88637 12.331 10.1498 12.2483C12.3808 11.5476 14 9.4636 14 7.00014C14 4.53669 12.3808 2.45272 10.1498 1.75202Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M10.2504 3.96861C10.0113 3.83033 9.70547 3.91201 9.5672 4.15105C9.42893 4.39008 9.51061 4.69594 9.74964 4.83421C10.4982 5.26723 11 6.07534 11 7.00006C11 7.92479 10.4982 8.7329 9.74964 9.16591C9.51061 9.30418 9.42893 9.61005 9.5672 9.84908C9.70547 10.0881 10.0113 10.1698 10.2504 10.0315C11.2952 9.42711 12 8.29619 12 7.00006C12 5.70394 11.2952 4.57302 10.2504 3.96861Z"
    })),
    play: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "m12.81 7.43-9.05 5.6A.5.5 0 0 1 3 12.6V1.4c0-.4.43-.63.76-.43l9.05 5.6a.5.5 0 0 1 0 .86Z"
    })),
    playback: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M11.24 12.04 3.7 7.42a.5.5 0 0 1-.2-.23v4.05a.75.75 0 0 1-1.5 0v-8.5a.75.75 0 0 1 1.5 0V6.8a.5.5 0 0 1 .2-.23l7.54-4.6a.5.5 0 0 1 .76.42v9.22a.5.5 0 0 1-.76.43Z"
    })),
    playnext: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "m2.76 12.04 7.54-4.61a.5.5 0 0 0 .2-.23v4.05a.75.75 0 0 0 1.5 0v-8.5a.75.75 0 0 0-1.5 0V6.8a.5.5 0 0 0-.2-.23l-7.54-4.6a.5.5 0 0 0-.76.42v9.22c0 .39.43.63.76.43Z"
    })),
    rewind: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M9 2.42v2.32L13.23 2a.5.5 0 0 1 .77.42v9.16a.5.5 0 0 1-.77.42L9 9.26v2.32a.5.5 0 0 1-.77.42L1.5 7.65v3.6a.75.75 0 0 1-1.5 0v-8.5a.75.75 0 0 1 1.5 0v3.6L8.23 2a.5.5 0 0 1 .77.42Z"
    })),
    fastforward: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M5 2.42v2.32L.77 2a.5.5 0 0 0-.77.42v9.16c0 .4.44.64.77.42L5 9.26v2.32c0 .4.44.64.77.42l6.73-4.35v3.6a.75.75 0 0 0 1.5 0v-8.5a.75.75 0 0 0-1.5 0v3.6L5.77 2a.5.5 0 0 0-.77.42Z"
    })),
    stopalt: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M1 1.5c0-.27.22-.5.5-.5h11c.28 0 .5.23.5.5v11a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11Z"
    })),
    sidebyside: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M1 1.5c0-.27.22-.5.5-.5h11c.28 0 .5.23.5.5v11a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11ZM2 12V2h5v10H2Z"
    })),
    stacked: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M12.5 1c.28 0 .5.23.5.5v11a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11c0-.27.22-.5.5-.5h11ZM2 2h10v5H2V2Z"
    })),
    sun: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M7.5.5a.5.5 0 0 0-1 0V2a.5.5 0 0 0 1 0V.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M7 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0-1a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M7 11.5c.28 0 .5.22.5.5v1.5a.5.5 0 0 1-1 0V12c0-.28.22-.5.5-.5ZM11.5 7c0-.28.22-.5.5-.5h1.5a.5.5 0 0 1 0 1H12a.5.5 0 0 1-.5-.5ZM.5 6.5a.5.5 0 0 0 0 1H2a.5.5 0 0 0 0-1H.5ZM3.82 10.18c.2.2.2.51 0 .7l-1.06 1.07a.5.5 0 1 1-.71-.7l1.06-1.07c.2-.2.51-.2.7 0ZM11.95 2.76a.5.5 0 1 0-.7-.71l-1.07 1.06a.5.5 0 1 0 .7.7l1.07-1.05ZM10.18 10.18c.2-.2.51-.2.7 0l1.07 1.06a.5.5 0 1 1-.7.71l-1.07-1.06a.5.5 0 0 1 0-.7ZM2.76 2.05a.5.5 0 1 0-.71.7l1.06 1.07a.5.5 0 0 0 .7-.7L2.77 2.04Z"
    })),
    moon: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M7.78.04a7.03 7.03 0 0 0-4.28.9 7 7 0 1 0 9.87 8.96c.1-.21-.14-.41-.36-.32a4.98 4.98 0 0 1-2 .42A5 5 0 0 1 8.53.65c.2-.12.19-.44-.04-.49a7.04 7.04 0 0 0-.72-.12Zm-1.27.98a6 6 0 0 0 4.98 9.96 6 6 0 1 1-4.98-9.96Z"
    })),
    book: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M13 2a2 2 0 0 0-2-2H1.5a.5.5 0 0 0-.5.5v13c0 .28.22.5.5.5H11a2 2 0 0 0 2-2V2ZM3 13h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H7v6a.5.5 0 0 1-.86.36L5.5 6.7l-.65.65A.5.5 0 0 1 4 7V1H3v12ZM5 1v4.8l.15-.15a.5.5 0 0 1 .74.04l.11.1V1H5Z"
    })),
    document: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M4 5.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5ZM4.5 7.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5ZM4 10.5c0-.28.22-.5.5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M1.5 0a.5.5 0 0 0-.5.5v13c0 .28.22.5.5.5h11a.5.5 0 0 0 .5-.5V3.2a.5.5 0 0 0-.15-.35l-2.7-2.7A.5.5 0 0 0 9.79 0H1.5ZM2 1h7.5v2c0 .28.22.5.5.5h2V13H2V1Z"
    })),
    copy: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M11.75.07A.5.5 0 0 0 11.5 0h-6a.5.5 0 0 0-.5.5V3H.5a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h8a.5.5 0 0 0 .5-.5V11h4.5a.5.5 0 0 0 .5-.5V2.51a.5.5 0 0 0-.15-.36l-2-2a.5.5 0 0 0-.1-.08ZM9 10h4V3h-1.5a.5.5 0 0 1-.5-.5V1H6v2h.5a.5.5 0 0 1 .36.15l1.99 2c.1.09.15.21.15.35v4.51ZM1 4v9h7V6H6.5a.5.5 0 0 1-.5-.5V4H1Z"
    })),
    category: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M3 1.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm-1 2c0-.27.22-.5.5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M1 5.5c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5v7a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-7ZM2 12V6h10v6H2Z"
    })),
    folder: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M6.59 3.5 5.09 2H1v9h12V3.5H6.59Zm.41-1L5.8 1.3a1 1 0 0 0-.71-.3H.5a.5.5 0 0 0-.5.5v10c0 .28.22.5.5.5h13a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H7Z"
    })),
    print: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M4.5 8a.5.5 0 1 0 0 1h5a.5.5 0 0 0 0-1h-5Zm0 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M2 1.5c0-.27.22-.5.5-.5h8a.5.5 0 0 1 .36.15l.99 1c.1.09.15.21.15.35v1.51h1.5c.28 0 .5.22.5.5v5a.5.5 0 0 1-.5.5H12v2.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10H.5a.5.5 0 0 1-.5-.5v-5c0-.28.22-.5.5-.5H2V1.5ZM13 9h-1V6.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5V9H1V5h12v4Zm-2-6v1H3V2h7v.5c0 .28.22.5.5.5h.5Zm-8 9h8V7H3v5Z"
    })),
    graphline: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M5.15 6.15c.2-.2.5-.2.7 0L7 7.3l2.15-2.15c.2-.2.5-.2.7 0l1 1a.5.5 0 0 1-.7.7l-.65-.64-2.15 2.15a.5.5 0 0 1-.7 0L5.5 7.2 3.85 8.86a.5.5 0 1 1-.7-.71l2-2Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M1.5 1a.5.5 0 0 0-.5.5v11c0 .28.22.5.5.5h11a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5h-11ZM2 2v10h10V2H2Z"
    })),
    calendar: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M3.5 0c.28 0 .5.22.5.5V1h6V.5a.5.5 0 0 1 1 0V1h1.5c.28 0 .5.22.5.5v11a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11c0-.28.22-.5.5-.5H3V.5c0-.28.22-.5.5-.5ZM2 4v2.3h3V4H2Zm0 5.2V6.8h3v2.4H2Zm0 .5V12h3V9.7H2Zm3.5 0V12h3V9.7h-3Zm3.5 0V12h3V9.7H9Zm3-.5H9V6.8h3v2.4Zm-3.5 0h-3V6.8h3v2.4ZM9 4v2.3h3V4H9ZM5.5 6.3h3V4h-3v2.3Z"
    })),
    graphbar: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M12 2.5a.5.5 0 0 0-1 0v10a.5.5 0 0 0 1 0v-10Zm-3 2a.5.5 0 0 0-1 0v8a.5.5 0 0 0 1 0v-8ZM5.5 7c.28 0 .5.22.5.5v5a.5.5 0 0 1-1 0v-5c0-.28.22-.5.5-.5ZM3 10.5a.5.5 0 0 0-1 0v2a.5.5 0 0 0 1 0v-2Z"
    })),
    menu: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M13 2a.5.5 0 0 1 0 1H1a.5.5 0 0 1 0-1h12Zm-3 3a.5.5 0 0 1 0 1H1a.5.5 0 0 1 0-1h9Zm1.5 3.5A.5.5 0 0 0 11 8H1a.5.5 0 0 0 0 1h10a.5.5 0 0 0 .5-.5Zm-4 2.5a.5.5 0 0 1 0 1H1a.5.5 0 0 1 0-1h6.5Z"
    })),
    menualt: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M1 2a.5.5 0 0 0 0 1h12a.5.5 0 0 0 0-1H1Zm3 3a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1H4ZM2.5 8.5c0-.28.22-.5.5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5Zm4 2.5a.5.5 0 0 0 0 1H13a.5.5 0 0 0 0-1H6.5Z"
    })),
    filter: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M1 2a.5.5 0 0 0 0 1h12a.5.5 0 0 0 0-1H1Zm2 3a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1H3Zm1.5 3.5c0-.28.22-.5.5-.5h4a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5Zm2 2.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Z"
    })),
    docchart: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M1 1.5C1 1.22386 1.22386 1 1.5 1H12.5C12.7761 1 13 1.22386 13 1.5V12.5C13 12.7761 12.7761 13 12.5 13H1.5C1.22386 13 1 12.7761 1 12.5V1.5ZM2 4V6.2998H5V4H2ZM2 9.2002V6.7998H5V9.2002H2ZM2 9.7002V12H5V9.7002H2ZM5.5 9.7002V12H8.5V9.7002H5.5ZM9 9.7002V12H12V9.7002H9ZM12 9.2002H9V6.7998H12V9.2002ZM8.5 9.2002H5.5V6.7998H8.5V9.2002ZM9 6.2998H12V4H9V6.2998ZM5.5 6.2998H8.5V4H5.5V6.2998Z"
    })),
    doclist: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M3.5 6.5c0-.28.22-.5.5-.5h6a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5ZM4 9a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H4Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M1 1.5c0-.28.22-.5.5-.5h11c.28 0 .5.22.5.5v11a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11ZM2 4v8h10V4H2Z"
    })),
    markup: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M8.98 1.63a.5.5 0 0 0-.96-.26l-3 11a.5.5 0 1 0 .96.26l3-11ZM3.32 3.62a.5.5 0 0 1 .06.7L1.15 7l2.23 2.68a.5.5 0 1 1-.76.64l-2.5-3a.5.5 0 0 1 0-.64l2.5-3a.5.5 0 0 1 .7-.06Zm7.36 0a.5.5 0 0 0-.06.7L12.85 7l-2.23 2.68a.5.5 0 0 0 .76.64l2.5-3a.5.5 0 0 0 0-.64l-2.5-3a.5.5 0 0 0-.7-.06Z"
    })),
    bold: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M3 2v1.5h1v7H3V12h5a3 3 0 0 0 1.8-5.4A2.74 2.74 0 0 0 8 2H3Zm5 5.5H5.5v3H8a1.5 1.5 0 1 0 0-3Zm-.25-4H5.5V6h2.25a1.25 1.25 0 1 0 0-2.5Z"
    })),
    italic: (0, _reactDefault.default).createElement("path", {
        d: "M5 2h6v1H8.5l-2 8H9v1H3v-1h2.5l2-8H5V2Z"
    }),
    paperclip: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M10.55 2.27a1.5 1.5 0 0 0-2.12 0L2.78 7.92a2.5 2.5 0 0 0 3.53 3.54l3.54-3.54a.5.5 0 1 1 .7.71l-3.53 3.54a3.5 3.5 0 0 1-4.96-4.94v-.01l5.66-5.66h.01a2.5 2.5 0 0 1 3.53 3.53L5.6 10.76a1.5 1.5 0 0 1-2.12-2.12L7.02 5.1a.5.5 0 1 1 .7.7L4.2 9.34a.5.5 0 0 0 .7.7l5.66-5.65a1.5 1.5 0 0 0 0-2.12Z"
    })),
    listordered: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M5 2.5c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5ZM5 7c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 7Zm.5 4a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Zm-3-9H1v1h1v3h1V2.5a.5.5 0 0 0-.5-.5ZM3 8.5v1a.5.5 0 0 1-1 0V9h-.5a.5.5 0 0 1 0-1h1c.28 0 .5.22.5.5Zm-1 2a.5.5 0 0 0-1 0V12h2v-1H2v-.5Z"
    })),
    listunordered: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M2.75 2.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0ZM5.5 2a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Zm0 9a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7ZM2 12.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5ZM5 7c0-.28.22-.5.5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 5 7Zm-3 .75a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
    })),
    paragraph: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M6 7a3 3 0 1 1 0-6h5.5a.5.5 0 0 1 0 1H10v10.5a.5.5 0 0 1-1 0V2H7v10.5a.5.5 0 0 1-1 0V7Z"
    })),
    markdown: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M2 4.5h1.5L5 6.38 6.5 4.5H8v5H6.5V7L5 8.88 3.5 7v2.5H2v-5Zm7.75 0h1.5V7h1.25l-2 2.5-2-2.5h1.25V4.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M.5 2a.5.5 0 0 0-.5.5v9c0 .28.22.5.5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5H.5ZM1 3v8h12V3H1Z"
    })),
    repository: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M5 2.5C5 2.77614 4.77614 3 4.5 3C4.22386 3 4 2.77614 4 2.5C4 2.22386 4.22386 2 4.5 2C4.77614 2 5 2.22386 5 2.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M4.5 5C4.77614 5 5 4.77614 5 4.5C5 4.22386 4.77614 4 4.5 4C4.22386 4 4 4.22386 4 4.5C4 4.77614 4.22386 5 4.5 5Z"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M5 6.5C5 6.77614 4.77614 7 4.5 7C4.22386 7 4 6.77614 4 6.5C4 6.22386 4.22386 6 4.5 6C4.77614 6 5 6.22386 5 6.5Z"
    }), (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M11 0C12.1046 0 13 0.895431 13 2V12C13 13.1046 12.1046 14 11 14H1.5C1.22386 14 1 13.7761 1 13.5V0.5C1 0.223857 1.22386 0 1.5 0H11ZM11 1H3V13H11C11.5523 13 12 12.5523 12 12V2C12 1.44772 11.5523 1 11 1Z"
    })),
    commit: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M3.03 7.5a4 4 0 0 0 7.94 0h2.53a.5.5 0 0 0 0-1h-2.53a4 4 0 0 0-7.94 0H.5a.5.5 0 0 0 0 1h2.53ZM7 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
    })),
    branch: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M6 2.5c0 .65-.42 1.2-1 1.41v4.06A3.36 3.36 0 0 1 7.5 7a2.7 2.7 0 0 0 1.81-.56c.22-.18.38-.4.48-.62a1.5 1.5 0 1 1 1.03.15c-.16.42-.43.87-.86 1.24-.57.47-1.37.79-2.46.79-1.04 0-1.64.42-2 .92-.26.37-.4.8-.47 1.18A1.5 1.5 0 1 1 4 10.09V3.9a1.5 1.5 0 1 1 2-1.4Zm-2 9a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0Zm1-9a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm6 2a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
    })),
    pullrequest: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M8.35 1.35 7.71 2h.79A2.5 2.5 0 0 1 11 4.5v5.59a1.5 1.5 0 1 1-1 0V4.5C10 3.67 9.33 3 8.5 3h-.8l.65.65a.5.5 0 1 1-.7.7l-1.5-1.5a.5.5 0 0 1 0-.7l1.5-1.5a.5.5 0 1 1 .7.7ZM11 11.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM4 3.91a1.5 1.5 0 1 0-1 0v6.18a1.5 1.5 0 1 0 1 0V3.9ZM3.5 11a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm0-8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
    })),
    merge: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M4.1 3.87a1.5 1.5 0 1 0-1.1.04v6.18a1.5 1.5 0 1 0 1 0V6.4c.26.4.57.77.93 1.08A6.57 6.57 0 0 0 9.08 9a1.5 1.5 0 1 0 0-1 5.57 5.57 0 0 1-3.5-1.25 4.74 4.74 0 0 1-1.47-2.87ZM3.5 11a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1ZM4 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm7 6a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
    })),
    apple: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M11.03 8.1a3.05 3.05 0 0 1-.2-1.74 2.7 2.7 0 0 1 1.4-1.94 3.13 3.13 0 0 0-2.35-1.4c-.84-.08-2.01.56-2.65.57h-.02c-.63 0-1.81-.65-2.64-.57-.42.04-1.75.32-2.55 1.6-.28.44-.5 1.01-.58 1.74a6.36 6.36 0 0 0 .02 1.74 7.5 7.5 0 0 0 1.35 3.33c.7 1.01 1.51 1.6 1.97 1.6.93.02 1.74-.6 2.41-.6l.02.01h.04c.67-.02 1.48.61 2.42.6.45-.02 1.26-.6 1.97-1.6a7.95 7.95 0 0 0 .97-1.86 2.6 2.6 0 0 1-1.58-1.48ZM8.86 2.13c.72-.85.7-2.07.63-2.12-.07-.06-1.25.16-1.99.98a2.78 2.78 0 0 0-.62 2.13c.06.05 1.27-.14 1.98-.99Z"
    })),
    linux: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M7 0a3 3 0 0 1 3 3v1.24c.13.13.25.27.36.42l.52.43.2.15c.32.26.7.59 1.09.97A6.28 6.28 0 0 1 14 9.54a.5.5 0 0 1-.35.44c-.31.1-.8.18-1.34.13-.33-.03-.7-.12-1.05-.3-.04.17-.1.34-.17.51a2 2 0 1 1-2.89 2.56 5.5 5.5 0 0 1-2.4 0 2 2 0 1 1-2.9-2.56 5.56 5.56 0 0 1-.16-.51c-.35.18-.72.27-1.05.3a3.4 3.4 0 0 1-1.34-.13.5.5 0 0 1-.35-.44l.01-.14a6.28 6.28 0 0 1 1.82-3.2 13.42 13.42 0 0 1 1.3-1.11c.22-.19.4-.32.5-.43.12-.15.24-.29.37-.42V3a3 3 0 0 1 3-3Zm1 11.9a2 2 0 0 1 2.14-1.9 5.5 5.5 0 0 0 .36-2c0-.51-.1-1.07-.3-1.6l-.03-.02a4.4 4.4 0 0 0-.86-.42 6.71 6.71 0 0 0-1-.31l-.86.64c-.27.2-.63.2-.9 0l-.85-.64a6.72 6.72 0 0 0-1.87.73l-.03.02A4.6 4.6 0 0 0 3.5 8c0 .68.11 1.39.36 2H4a2 2 0 0 1 2 1.9 4.49 4.49 0 0 0 2 0ZM5 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm6 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM6.1 4.3a1.5 1.5 0 0 1 1.8 0l.27.2L7 5.38 5.83 4.5l.27-.2ZM8.5 2c.28 0 .5.22.5.5V3a.5.5 0 0 1-1 0v-.5c0-.28.22-.5.5-.5ZM6 2.5a.5.5 0 0 0-1 0V3a.5.5 0 0 0 1 0v-.5Z"
    })),
    ubuntu: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M12.26 2.07c0 1.14-.89 2.06-1.99 2.06s-1.99-.92-1.99-2.06c0-1.14.9-2.07 2-2.07s1.98.93 1.98 2.07ZM3.98 6.6c0 1.14-.9 2.07-2 2.07C.9 8.67 0 7.74 0 6.6c0-1.14.9-2.07 1.99-2.07 1.1 0 1.99.93 1.99 2.07ZM6.47 11.92a4.76 4.76 0 0 1-3.3-2.62c-.53.25-1.12.33-1.7.22a6.72 6.72 0 0 0 1.84 2.63 6.38 6.38 0 0 0 4.24 1.58c-.37-.5-.57-1.1-.59-1.73a4.77 4.77 0 0 1-.49-.08ZM11.81 11.93c0 1.14-.89 2.07-1.99 2.07s-1.98-.93-1.98-2.07c0-1.14.89-2.06 1.98-2.06 1.1 0 2 .92 2 2.06ZM12.6 11.17a6.93 6.93 0 0 0 .32-7.93A2.95 2.95 0 0 1 11.8 4.6a5.23 5.23 0 0 1-.16 5.03c.47.4.8.94.95 1.54ZM1.99 3.63h-.15A6.48 6.48 0 0 1 8 .24a3.07 3.07 0 0 0-.6 1.68 4.7 4.7 0 0 0-3.9 2.17c-.46-.3-.98-.45-1.51-.45Z"
    })),
    windows: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M6.5 1H1v5.5h5.5V1ZM13 1H7.5v5.5H13V1ZM7.5 7.5H13V13H7.5V7.5ZM6.5 7.5H1V13h5.5V7.5Z"
    })),
    storybook: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M2.04.62a.7.7 0 0 0-.66.72l.44 11.56c.01.37.3.66.67.68l9.4.42h.02a.7.7 0 0 0 .7-.7V.66a.7.7 0 0 0-.74-.66l-.77.05.05 1.62a.1.1 0 0 1-.17.08l-.52-.4-.61.46a.1.1 0 0 1-.17-.09L9.75.13l-7.7.49Zm8 4.74c-.24.2-2.09.33-2.09.05.04-1.04-.43-1.09-.69-1.09-.24 0-.66.08-.66.64 0 .57.6.89 1.32 1.27 1.02.53 2.24 1.18 2.24 2.82 0 1.57-1.27 2.43-2.9 2.43-1.67 0-3.14-.68-2.97-3.03.06-.27 2.2-.2 2.2 0-.03.97.19 1.26.75 1.26.43 0 .62-.24.62-.64 0-.6-.63-.95-1.36-1.36-.99-.56-2.15-1.2-2.15-2.7 0-1.5 1.03-2.5 2.86-2.5 1.83 0 2.84.99 2.84 2.85Z"
    })),
    azuredevops: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "m0 5.18 1.31-1.73 4.9-2V.01l4.3 3.15-8.78 1.7v4.8L0 9.16V5.18Zm14-2.6v8.55l-3.36 2.86-5.42-1.79V14L1.73 9.66l8.78 1.05V3.16L14 2.58Z"
    })),
    bitbucket: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M1 1.52A.41.41 0 0 0 .59 2l1.74 10.6c.05.26.28.46.55.46h8.37c.2 0 .38-.14.42-.34l1.01-6.25H8.81l-.46 2.71H5.68L4.95 5.4h7.91L13.4 2a.41.41 0 0 0-.41-.48H1Z"
    })),
    chrome: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M13.02 3.43a.11.11 0 0 1-.1.17H7a3.4 3.4 0 0 0-3.3 2.55.11.11 0 0 1-.21.03L1.52 2.76a.11.11 0 0 1 0-.12 6.97 6.97 0 0 1 9-1.7c1.03.6 1.9 1.47 2.5 2.5ZM7 9.62a2.62 2.62 0 1 1 0-5.24 2.62 2.62 0 0 1 0 5.24Zm1.03.7a.11.11 0 0 0-.12-.04 3.4 3.4 0 0 1-4-1.84L1.1 3.57a.11.11 0 0 0-.2 0 7 7 0 0 0 5.07 10.35c.04 0 .08-.02.1-.05l1.97-3.42a.11.11 0 0 0 0-.13Zm1.43-5.95h3.95c.05 0 .1.03.1.07a6.97 6.97 0 0 1-1.53 7.48A6.96 6.96 0 0 1 7.08 14a.11.11 0 0 1-.1-.17l2.81-4.88h.01a3.38 3.38 0 0 0-.42-4.38.11.11 0 0 1 .08-.2Z"
    })),
    chromatic: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M0 7a7 7 0 1 0 14 0A7 7 0 0 0 0 7Zm5.22-3.87a1.97 1.97 0 0 1 3.75.83v1.29L5.61 3.32a2.49 2.49 0 0 0-.4-.19ZM8.7 5.71 5.35 3.78a1.97 1.97 0 0 0-2.6 2.83c.12-.1.24-.18.37-.26l1.51-.87a.27.27 0 0 1 .27 0L7 6.69l1.7-.98Zm-.32 4.97-1.52-.87a.27.27 0 0 1-.13-.23V7.15l-1.7-.97v3.86a1.97 1.97 0 0 0 3.75.83 2.5 2.5 0 0 1-.4-.19Zm.26-.46a1.97 1.97 0 0 0 2.6-2.83c-.11.1-.23.18-.36.26L7.53 9.58l1.11.64Zm-4.1.26h-.17a1.97 1.97 0 0 1-1.9-2.47 2 2 0 0 1 .92-1.2l1.11-.63v3.86c0 .14.01.29.04.44Zm6.79-5.98a1.97 1.97 0 0 0-1.87-.97c.03.14.04.29.04.43v1.75c0 .1-.05.19-.14.23l-2.1 1.22V9.1l3.35-1.93a1.97 1.97 0 0 0 .72-2.68Z"
    })),
    componentdriven: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M10.85 2.18 8.87.2a.69.69 0 0 0-.97 0L3.09 5.01a.69.69 0 0 0 0 .97l2.46 2.46-2.4 2.4a.69.69 0 0 0 0 .98l1.98 1.98c.27.27.7.27.97 0l4.8-4.81a.69.69 0 0 0 0-.97L8.45 5.56l2.4-2.4a.69.69 0 0 0 0-.98Z"
    })),
    discord: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M11.85 2.88C10.95 2.48 10 2.18 9 2a7.05 7.05 0 0 0-.4.75 10.66 10.66 0 0 0-3.2 0c-.1-.23-.24-.5-.36-.73A.04.04 0 0 0 4.99 2a11.51 11.51 0 0 0-2.86.9 11.82 11.82 0 0 0-2.05 8 11.6 11.6 0 0 0 3.5 1.77c.01 0 .03 0 .04-.02.27-.36.51-.75.72-1.16a.04.04 0 0 0-.03-.06 7.66 7.66 0 0 1-1.09-.52.04.04 0 0 1 0-.08 5.96 5.96 0 0 0 .26-.17 8.28 8.28 0 0 0 7.08 0l.22.17c.02.02.02.06 0 .08-.36.2-.72.37-1.1.52a.04.04 0 0 0-.02.06c.2.4.45.8.71 1.16.01.02.03.02.05.02a11.57 11.57 0 0 0 3.52-1.8 11.74 11.74 0 0 0-2.09-7.99Zm-7.17 6.4c-.7 0-1.26-.63-1.26-1.41 0-.78.56-1.41 1.26-1.41s1.27.64 1.26 1.4c0 .79-.56 1.42-1.26 1.42Zm4.65 0c-.69 0-1.26-.63-1.26-1.41 0-.78.56-1.41 1.26-1.41s1.27.64 1.26 1.4c0 .79-.55 1.42-1.26 1.42Z"
    })),
    facebook: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M7.4 14H5.06V7H3.5V4.59h1.56V3.17C5.06 1.2 5.53 0 7.6 0h1.72v2.41H8.25c-.8 0-.85.34-.85.97v1.2h1.93L9.11 7H7.4l-.01 7Z"
    })),
    figma: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        d: "M9.2 0H4.8a2.6 2.6 0 0 0-1.4 4.8 2.6 2.6 0 0 0 0 4.4 2.6 2.6 0 1 0 4 2.2V8.89a2.6 2.6 0 1 0 3.2-4.09A2.6 2.6 0 0 0 9.2 0ZM7.4 7A1.8 1.8 0 1 0 11 7a1.8 1.8 0 0 0-3.6 0Zm-.8 2.6H4.8a1.8 1.8 0 1 0 1.8 1.8V9.6ZM4.8 4.4h1.8V.8H4.8a1.8 1.8 0 0 0 0 3.59Zm0 .8a1.8 1.8 0 0 0 0 3.6h1.8V5.2H4.8Zm4.4-.8H7.4V.8h1.8a1.8 1.8 0 1 1 0 3.59Z"
    })),
    gdrive: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M6.37 8.77 4.33 12.3h6.75l2.04-3.54H6.38Zm6.18-1-3.5-6.08h-4.1l3.51 6.08h4.09ZM4.38 2.7.88 8.77l2.04 3.54 3.5-6.07L4.38 2.7Z"
    })),
    github: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M7 0a7 7 0 0 0-2.21 13.64c.35.06.48-.15.48-.33L5.26 12c-1.76.32-2.21-.43-2.35-.83-.08-.2-.43-.82-.72-.99-.25-.13-.6-.45-.01-.46.55 0 .94.5 1.07.72.63 1.06 1.64.76 2.04.58.07-.46.25-.77.45-.94-1.56-.18-3.19-.78-3.19-3.46 0-.76.28-1.39.72-1.88-.07-.17-.31-.9.07-1.85 0 0 .59-.19 1.93.71a6.5 6.5 0 0 1 3.5 0c1.34-.9 1.92-.71 1.92-.71.39.96.14 1.68.07 1.85.45.5.72 1.11.72 1.88 0 2.69-1.64 3.28-3.2 3.46.26.22.48.64.48 1.3l-.01 1.92c0 .18.13.4.48.33A7.01 7.01 0 0 0 7 0Z"
    })),
    gitlab: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M4.53 5.58H1.07l1.49-4.55a.26.26 0 0 1 .48 0l1.49 4.55ZM7 13.15 1.07 5.58l-.75 2.3a.5.5 0 0 0 .18.57l6.5 4.7Zm0 0 6.5-4.7a.5.5 0 0 0 .18-.57l-.75-2.3L7 13.15l2.47-7.57H4.53L7 13.15Zm2.47-7.57h3.46l-1.49-4.55a.26.26 0 0 0-.48 0L9.47 5.58Z"
    })),
    google: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M10.92 1.1H7.26c-1.64 0-3.19 1.24-3.19 2.68 0 1.47 1.12 2.66 2.8 2.66l.33-.01c-.1.2-.18.44-.18.68 0 .41.22.75.5 1.02h-.64c-2.03 0-3.6 1.3-3.6 2.64 0 1.32 1.72 2.15 3.75 2.15 2.32 0 3.6-1.31 3.6-2.64 0-1.06-.31-1.7-1.28-2.38-.33-.23-.96-.8-.96-1.14 0-.39.1-.58.7-1.04a2.46 2.46 0 0 0 1.03-1.92c0-.92-.4-1.82-1.18-2.11h1.17l.81-.6ZM9.6 10.04c.03.13.05.25.05.38 0 1.07-.7 1.9-2.67 1.9-1.4 0-2.42-.88-2.42-1.95 0-1.05 1.26-1.92 2.66-1.9a3 3 0 0 1 .92.14c.76.53 1.3.83 1.46 1.43ZM7.34 6.07c-.94-.03-1.84-1.06-2-2.3-.17-1.24.47-2.19 1.41-2.16.94.03 1.84 1.03 2 2.26.17 1.24-.47 2.23-1.41 2.2Z"
    })),
    graphql: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M7.87 11.6a1.17 1.17 0 0 0-1.7-.02l-2.71-1.56.01-.04h7.07l.02.07-2.69 1.56Zm-1.7-9.18.03.03-3.54 6.12h-.04V5.43a1.17 1.17 0 0 0 .84-1.46l2.7-1.56Zm4.38 1.56a1.17 1.17 0 0 0 .84 1.46v3.12l-.04.01-3.54-6.12c.02 0 .03-.02.04-.03l2.7 1.56ZM3.47 9.42a1.17 1.17 0 0 0-.32-.57l3.53-6.12a1.17 1.17 0 0 0 .65 0l3.54 6.12a1.17 1.17 0 0 0-.33.57H3.47Zm8.8-.74c-.1-.05-.21-.1-.32-.12V5.44a1.17 1.17 0 1 0-1.12-1.94l-2.7-1.56a1.17 1.17 0 1 0-2.24 0L3.19 3.5a1.17 1.17 0 1 0-1.13 1.94v3.12a1.17 1.17 0 1 0 1.12 1.94l2.7 1.56a1.17 1.17 0 1 0 2.24-.03l2.69-1.55a1.17 1.17 0 1 0 1.45-1.8Z"
    })),
    medium: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M0 0v14h14V0H0Zm11.63 3.32-.75.72a.22.22 0 0 0-.08.2v5.33c0 .07.03.14.08.18l.73.72v.16H7.92v-.16l.76-.74c.08-.07.08-.1.08-.21V5.24l-2.11 5.37h-.29L3.9 5.24v3.67c0 .13.05.25.14.34l.99 1.2v.16h-2.8v-.16l.98-1.2a.48.48 0 0 0 .13-.41V4.65c0-.11-.04-.2-.12-.27l-.88-1.06v-.16h2.73l2.1 4.62 1.86-4.62h2.6v.16Z"
    })),
    redux: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M4.06 9.69c.02.49.42.88.91.88H5a.91.91 0 0 0-.03-1.83h-.03c-.03 0-.08 0-.11.02a5.97 5.97 0 0 1-.85-3.62c.06-.98.39-1.82.96-2.52.47-.6 1.39-.9 2-.92 1.73-.03 2.47 2.12 2.51 2.99.22.04.57.16.82.24-.2-2.64-1.83-4-3.4-4-1.46 0-2.81 1.05-3.35 2.61a6.67 6.67 0 0 0 .65 5.68.74.74 0 0 0-.11.47Zm8.28-2.3a6.62 6.62 0 0 0-5.15-2.25h-.26a.9.9 0 0 0-.8-.49H6.1a.91.91 0 0 0 .03 1.83h.03a.92.92 0 0 0 .8-.56h.3c1.23 0 2.4.36 3.47 1.06.81.54 1.4 1.24 1.72 2.09.28.68.26 1.35-.03 1.92a2.4 2.4 0 0 1-2.23 1.34c-.65 0-1.27-.2-1.6-.34-.18.16-.5.42-.73.58.7.33 1.41.5 2.1.5 1.56 0 2.72-.85 3.16-1.72.47-.94.44-2.57-.78-3.96ZM4.9 12.9a4 4 0 0 1-.98.11c-1.2 0-2.3-.5-2.84-1.32C.38 10.6.13 8.3 2.5 6.58c.05.26.15.62.22.83-.31.23-.8.68-1.11 1.3a2.4 2.4 0 0 0 .13 2.53c.36.54.93.86 1.66.96.9.11 1.8-.05 2.66-.5a5.83 5.83 0 0 0 2.67-2.56.91.91 0 0 1 .62-1.55h.03a.92.92 0 0 1 .1 1.82 6.26 6.26 0 0 1-4.56 3.49Z"
    })),
    twitter: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M14 2.55c-.51.23-1.07.39-1.65.46.6-.36 1.05-.94 1.26-1.63-.55.34-1.17.58-1.82.72a2.84 2.84 0 0 0-2.1-.93 2.9 2.9 0 0 0-2.8 3.61 8.09 8.09 0 0 1-5.9-3.07 2.99 2.99 0 0 0 .88 3.93 2.8 2.8 0 0 1-1.3-.37v.04c0 1.42 1 2.61 2.3 2.89a2.82 2.82 0 0 1-1.3.05 2.89 2.89 0 0 0 2.7 2.04A5.67 5.67 0 0 1 0 11.51a7.98 7.98 0 0 0 4.4 1.32c5.29 0 8.17-4.48 8.17-8.38v-.38A5.93 5.93 0 0 0 14 2.55Z"
    })),
    youtube: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M13.99 8.17V5.83a14.95 14.95 0 0 0-.23-2.22c-.09-.38-.27-.7-.55-.96s-.6-.41-.97-.45A51.3 51.3 0 0 0 7 2c-2.34 0-4.09.07-5.24.2A1.78 1.78 0 0 0 .25 3.61 15.26 15.26 0 0 0 0 7v1.16a15.24 15.24 0 0 0 .24 2.22c.09.38.27.7.55.96.27.26.6.41.97.45 1.15.13 2.9.2 5.24.2 2.34 0 4.08-.06 5.24-.2.37-.04.7-.19.97-.45s.45-.58.54-.96a15.26 15.26 0 0 0 .24-2.22Zm-4.23-1.6c.16.1.24.24.24.43 0 .2-.08.33-.24.42l-4 2.5a.44.44 0 0 1-.26.08.54.54 0 0 1-.24-.06A.46.46 0 0 1 5 9.5v-5c0-.2.08-.34.26-.44.17-.1.34-.09.5.02l4 2.5Z"
    })),
    vscode: (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement("path", {
        d: "M10.24.04c.13 0 .26.03.38.09L13.5 1.5a.87.87 0 0 1 .5.8v.03-.01 9.39c0 .33-.2.63-.5.78l-2.88 1.38a.87.87 0 0 1-1-.17l-5.5-5.03-2.4 1.83a.58.58 0 0 1-.75-.04l-.77-.7a.58.58 0 0 1 0-.86L2.27 7 .2 5.1a.58.58 0 0 1 0-.86l.77-.7c.21-.2.52-.2.75-.04l2.4 1.83L9.63.3a.87.87 0 0 1 .61-.26Zm.26 3.78L6.32 7l4.18 3.18V3.82Z"
    }))
};
var Svg = (0, _theming.styled).svg`
  display: inline-block;
  shape-rendering: inherit;
  vertical-align: middle;
  fill: currentColor;

  path {
    fill: currentColor;
  }
`, Icons = ({ icon, useSymbol, ...props })=>(0, _reactDefault.default).createElement(Svg, {
        viewBox: "0 0 14 14",
        width: "14px",
        height: "14px",
        ...props
    }, useSymbol ? (0, _reactDefault.default).createElement("use", {
        xlinkHref: `#icon--${icon}`
    }) : icons[icon]), Symbols = (0, _react.memo)(function({ icons: keys = Object.keys(icons) }) {
    return (0, _reactDefault.default).createElement(Svg, {
        viewBox: "0 0 14 14",
        style: {
            position: "absolute",
            width: 0,
            height: 0
        },
        "data-chromatic": "ignore"
    }, keys.map((key)=>(0, _reactDefault.default).createElement("symbol", {
            id: `icon--${key}`,
            key
        }, icons[key])));
});
var LEFT_BUTTON = 0, isPlainLeftClick = (e)=>e.button === LEFT_BUTTON && !e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey, cancelled = (e, cb)=>{
    isPlainLeftClick(e) && (e.preventDefault(), cb(e));
}, LinkInner = (0, _theming.styled).span(({ withArrow })=>withArrow ? {
        "> svg:last-of-type": {
            height: "0.7em",
            width: "0.7em",
            marginRight: 0,
            marginLeft: "0.25em",
            bottom: "auto",
            verticalAlign: "inherit"
        }
    } : {}, ({ containsIcon })=>containsIcon ? {
        svg: {
            height: "1em",
            width: "1em",
            verticalAlign: "middle",
            position: "relative",
            bottom: 0,
            marginRight: 0
        }
    } : {}), A2 = (0, _theming.styled).a(({ theme })=>({
        display: "inline-block",
        transition: "all 150ms ease-out",
        textDecoration: "none",
        color: theme.color.secondary,
        "&:hover, &:focus": {
            cursor: "pointer",
            color: curriedDarken$1(.07, theme.color.secondary),
            "svg path:not([fill])": {
                fill: curriedDarken$1(.07, theme.color.secondary)
            }
        },
        "&:active": {
            color: curriedDarken$1(.1, theme.color.secondary),
            "svg path:not([fill])": {
                fill: curriedDarken$1(.1, theme.color.secondary)
            }
        },
        svg: {
            display: "inline-block",
            height: "1em",
            width: "1em",
            verticalAlign: "text-top",
            position: "relative",
            bottom: "-0.125em",
            marginRight: "0.4em",
            "& path": {
                fill: theme.color.secondary
            }
        }
    }), ({ theme, secondary, tertiary })=>{
    let colors;
    return secondary && (colors = [
        theme.textMutedColor,
        theme.color.dark,
        theme.color.darker
    ]), tertiary && (colors = [
        theme.color.dark,
        theme.color.darkest,
        theme.textMutedColor
    ]), colors ? {
        color: colors[0],
        "svg path:not([fill])": {
            fill: colors[0]
        },
        "&:hover": {
            color: colors[1],
            "svg path:not([fill])": {
                fill: colors[1]
            }
        },
        "&:active": {
            color: colors[2],
            "svg path:not([fill])": {
                fill: colors[2]
            }
        }
    } : {};
}, ({ nochrome })=>nochrome ? {
        color: "inherit",
        "&:hover, &:active": {
            color: "inherit",
            textDecoration: "underline"
        }
    } : {}, ({ theme, inverse })=>inverse ? {
        color: theme.color.lightest,
        ":not([fill])": {
            fill: theme.color.lightest
        },
        "&:hover": {
            color: theme.color.lighter,
            "svg path:not([fill])": {
                fill: theme.color.lighter
            }
        },
        "&:active": {
            color: theme.color.light,
            "svg path:not([fill])": {
                fill: theme.color.light
            }
        }
    } : {}, ({ isButton })=>isButton ? {
        border: 0,
        borderRadius: 0,
        background: "none",
        padding: 0,
        fontSize: "inherit"
    } : {}), Link2 = ({ cancel, children, onClick, withArrow, containsIcon, className, ...rest })=>(0, _reactDefault.default).createElement(A2, {
        ...rest,
        onClick: onClick && cancel ? (e)=>cancelled(e, onClick) : onClick,
        className
    }, (0, _reactDefault.default).createElement(LinkInner, {
        withArrow,
        containsIcon
    }, children, withArrow && (0, _reactDefault.default).createElement(Icons, {
        icon: "arrowright"
    })));
Link2.defaultProps = {
    cancel: !0,
    className: void 0,
    style: void 0,
    onClick: void 0,
    withArrow: !1,
    containsIcon: !1
};
var DocumentWrapper = (0, _theming.styled).div(({ theme })=>({
        fontSize: `${theme.typography.size.s2}px`,
        lineHeight: "1.6",
        h1: {
            fontSize: `${theme.typography.size.l1}px`,
            fontWeight: theme.typography.weight.bold
        },
        h2: {
            fontSize: `${theme.typography.size.m2}px`,
            borderBottom: `1px solid ${theme.appBorderColor}`
        },
        h3: {
            fontSize: `${theme.typography.size.m1}px`
        },
        h4: {
            fontSize: `${theme.typography.size.s3}px`
        },
        h5: {
            fontSize: `${theme.typography.size.s2}px`
        },
        h6: {
            fontSize: `${theme.typography.size.s2}px`,
            color: theme.color.dark
        },
        "pre:not(.prismjs)": {
            background: "transparent",
            border: "none",
            borderRadius: 0,
            padding: 0,
            margin: 0
        },
        "pre pre, pre.prismjs": {
            padding: 15,
            margin: 0,
            whiteSpace: "pre-wrap",
            color: "inherit",
            fontSize: "13px",
            lineHeight: "19px"
        },
        "pre pre code, pre.prismjs code": {
            color: "inherit",
            fontSize: "inherit"
        },
        "pre code": {
            margin: 0,
            padding: 0,
            whiteSpace: "pre",
            border: "none",
            background: "transparent"
        },
        "pre code, pre tt": {
            backgroundColor: "transparent",
            border: "none"
        },
        "body > *:first-of-type": {
            marginTop: "0 !important"
        },
        "body > *:last-child": {
            marginBottom: "0 !important"
        },
        a: {
            color: theme.color.secondary,
            textDecoration: "none"
        },
        "a.absent": {
            color: "#cc0000"
        },
        "a.anchor": {
            display: "block",
            paddingLeft: 30,
            marginLeft: -30,
            cursor: "pointer",
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0
        },
        "h1, h2, h3, h4, h5, h6": {
            margin: "20px 0 10px",
            padding: 0,
            cursor: "text",
            position: "relative",
            "&:first-of-type": {
                marginTop: 0,
                paddingTop: 0
            },
            "&:hover a.anchor": {
                textDecoration: "none"
            },
            "& tt, & code": {
                fontSize: "inherit"
            }
        },
        "h1:first-of-type + h2": {
            marginTop: 0,
            paddingTop: 0
        },
        "p, blockquote, ul, ol, dl, li, table, pre": {
            margin: "15px 0"
        },
        hr: {
            border: "0 none",
            borderTop: `1px solid ${theme.appBorderColor}`,
            height: 4,
            padding: 0
        },
        "body > h1:first-of-type, body > h2:first-of-type, body > h3:first-of-type, body > h4:first-of-type, body > h5:first-of-type, body > h6:first-of-type": {
            marginTop: 0,
            paddingTop: 0
        },
        "body > h1:first-of-type + h2": {
            marginTop: 0,
            paddingTop: 0
        },
        "a:first-of-type h1, a:first-of-type h2, a:first-of-type h3, a:first-of-type h4, a:first-of-type h5, a:first-of-type h6": {
            marginTop: 0,
            paddingTop: 0
        },
        "h1 p, h2 p, h3 p, h4 p, h5 p, h6 p": {
            marginTop: 0
        },
        "li p.first": {
            display: "inline-block"
        },
        "ul, ol": {
            paddingLeft: 30,
            "& :first-of-type": {
                marginTop: 0
            },
            "& :last-child": {
                marginBottom: 0
            }
        },
        dl: {
            padding: 0
        },
        "dl dt": {
            fontSize: "14px",
            fontWeight: "bold",
            fontStyle: "italic",
            margin: "0 0 15px",
            padding: "0 15px",
            "&:first-of-type": {
                padding: 0
            },
            "& > :first-of-type": {
                marginTop: 0
            },
            "& > :last-child": {
                marginBottom: 0
            }
        },
        blockquote: {
            borderLeft: `4px solid ${theme.color.medium}`,
            padding: "0 15px",
            color: theme.color.dark,
            "& > :first-of-type": {
                marginTop: 0
            },
            "& > :last-child": {
                marginBottom: 0
            }
        },
        table: {
            padding: 0,
            borderCollapse: "collapse",
            "& tr": {
                borderTop: `1px solid ${theme.appBorderColor}`,
                backgroundColor: "white",
                margin: 0,
                padding: 0,
                "& th": {
                    fontWeight: "bold",
                    border: `1px solid ${theme.appBorderColor}`,
                    textAlign: "left",
                    margin: 0,
                    padding: "6px 13px"
                },
                "& td": {
                    border: `1px solid ${theme.appBorderColor}`,
                    textAlign: "left",
                    margin: 0,
                    padding: "6px 13px"
                },
                "&:nth-of-type(2n)": {
                    backgroundColor: theme.color.lighter
                },
                "& th :first-of-type, & td :first-of-type": {
                    marginTop: 0
                },
                "& th :last-child, & td :last-child": {
                    marginBottom: 0
                }
            }
        },
        img: {
            maxWidth: "100%"
        },
        "span.frame": {
            display: "block",
            overflow: "hidden",
            "& > span": {
                border: `1px solid ${theme.color.medium}`,
                display: "block",
                float: "left",
                overflow: "hidden",
                margin: "13px 0 0",
                padding: 7,
                width: "auto"
            },
            "& span img": {
                display: "block",
                float: "left"
            },
            "& span span": {
                clear: "both",
                color: theme.color.darkest,
                display: "block",
                padding: "5px 0 0"
            }
        },
        "span.align-center": {
            display: "block",
            overflow: "hidden",
            clear: "both",
            "& > span": {
                display: "block",
                overflow: "hidden",
                margin: "13px auto 0",
                textAlign: "center"
            },
            "& span img": {
                margin: "0 auto",
                textAlign: "center"
            }
        },
        "span.align-right": {
            display: "block",
            overflow: "hidden",
            clear: "both",
            "& > span": {
                display: "block",
                overflow: "hidden",
                margin: "13px 0 0",
                textAlign: "right"
            },
            "& span img": {
                margin: 0,
                textAlign: "right"
            }
        },
        "span.float-left": {
            display: "block",
            marginRight: 13,
            overflow: "hidden",
            float: "left",
            "& span": {
                margin: "13px 0 0"
            }
        },
        "span.float-right": {
            display: "block",
            marginLeft: 13,
            overflow: "hidden",
            float: "right",
            "& > span": {
                display: "block",
                overflow: "hidden",
                margin: "13px auto 0",
                textAlign: "right"
            }
        },
        "code, tt": {
            margin: "0 2px",
            padding: "0 5px",
            whiteSpace: "nowrap",
            border: `1px solid ${theme.color.mediumlight}`,
            backgroundColor: theme.color.lighter,
            borderRadius: 3,
            color: theme.base === "dark" && theme.color.darkest
        }
    }));
var languages = [], Comp = null, LazySyntaxHighlighter = (0, _react.lazy)(async ()=>{
    let { SyntaxHighlighter: SyntaxHighlighter3 } = await require("30a1cf2d1b9d7e9d");
    return languages.length > 0 && (languages.forEach((args)=>{
        SyntaxHighlighter3.registerLanguage(...args);
    }), languages = []), Comp === null && (Comp = SyntaxHighlighter3), {
        default: (props)=>(0, _reactDefault.default).createElement(SyntaxHighlighter3, {
                ...props
            })
    };
}), LazySyntaxHighlighterWithFormatter = (0, _react.lazy)(async ()=>{
    let [{ SyntaxHighlighter: SyntaxHighlighter3 }, { formatter }] = await Promise.all([
        require("30a1cf2d1b9d7e9d"),
        require("c463b03623b6f01d")
    ]);
    return languages.length > 0 && (languages.forEach((args)=>{
        SyntaxHighlighter3.registerLanguage(...args);
    }), languages = []), Comp === null && (Comp = SyntaxHighlighter3), {
        default: (props)=>(0, _reactDefault.default).createElement(SyntaxHighlighter3, {
                ...props,
                formatter
            })
    };
}), SyntaxHighlighter2 = (props)=>(0, _reactDefault.default).createElement((0, _react.Suspense), {
        fallback: (0, _reactDefault.default).createElement("div", null)
    }, props.format !== !1 ? (0, _reactDefault.default).createElement(LazySyntaxHighlighterWithFormatter, {
        ...props
    }) : (0, _reactDefault.default).createElement(LazySyntaxHighlighter, {
        ...props
    }));
SyntaxHighlighter2.registerLanguage = (...args)=>{
    if (Comp !== null) {
        Comp.registerLanguage(...args);
        return;
    }
    languages.push(args);
};
var toNumber = (input)=>typeof input == "number" ? input : Number(input), Container = (0, _theming.styled).div(({ theme, col, row = 1 })=>col ? {
        display: "inline-block",
        verticalAlign: "inherit",
        "& > *": {
            marginLeft: col * theme.layoutMargin,
            verticalAlign: "inherit"
        },
        [`& > *:first-child${0, _theming.ignoreSsrWarning}`]: {
            marginLeft: 0
        }
    } : {
        "& > *": {
            marginTop: row * theme.layoutMargin
        },
        [`& > *:first-child${0, _theming.ignoreSsrWarning}`]: {
            marginTop: 0
        }
    }, ({ theme, outer, col, row })=>{
    switch(!0){
        case !!(outer && col):
            return {
                marginLeft: outer * theme.layoutMargin,
                marginRight: outer * theme.layoutMargin
            };
        case !!(outer && row):
            return {
                marginTop: outer * theme.layoutMargin,
                marginBottom: outer * theme.layoutMargin
            };
        default:
            return {};
    }
}), Spaced = ({ col, row, outer, children, ...rest })=>{
    let outerAmount = toNumber(typeof outer == "number" || !outer ? outer : col || row);
    return (0, _reactDefault.default).createElement(Container, {
        col,
        row,
        outer: outerAmount,
        ...rest
    }, children);
};
var Title = (0, _theming.styled).div(({ theme })=>({
        fontWeight: theme.typography.weight.bold
    })), Desc = (0, _theming.styled).div(), Message = (0, _theming.styled).div(({ theme })=>({
        padding: 30,
        textAlign: "center",
        color: theme.color.defaultText,
        fontSize: theme.typography.size.s2 - 1
    })), Placeholder = ({ children, ...props })=>{
    let [title, desc] = (0, _react.Children).toArray(children);
    return (0, _reactDefault.default).createElement(Message, {
        ...props
    }, (0, _reactDefault.default).createElement(Title, null, title), desc && (0, _reactDefault.default).createElement(Desc, null, desc));
};
var ZoomElementWrapper = (0, _theming.styled).div(({ scale = 1, elementHeight })=>({
        height: elementHeight || "auto",
        transformOrigin: "top left",
        transform: `scale(${1 / scale})`
    }));
function ZoomElement({ scale, children }) {
    let componentWrapperRef = (0, _react.useRef)(null), [elementHeight, setElementHeight] = (0, _react.useState)(0), onResize = (0, _react.useCallback)(({ height })=>{
        height && setElementHeight(height / scale);
    }, [
        scale
    ]);
    return (0, _react.useEffect)(()=>{
        componentWrapperRef.current && setElementHeight(componentWrapperRef.current.getBoundingClientRect().height);
    }, [
        scale
    ]), (0, _useResizeObserverDefault.default)({
        ref: componentWrapperRef,
        onResize
    }), (0, _reactDefault.default).createElement(ZoomElementWrapper, {
        scale,
        elementHeight
    }, (0, _reactDefault.default).createElement("div", {
        ref: componentWrapperRef,
        className: "innerZoomElementWrapper"
    }, children));
}
var ZoomIFrame = class extends (0, _react.Component) {
    constructor(){
        super(...arguments);
        this.iframe = null;
    }
    componentDidMount() {
        let { iFrameRef } = this.props;
        this.iframe = iFrameRef.current;
    }
    shouldComponentUpdate(nextProps) {
        let { scale, active } = this.props;
        return scale !== nextProps.scale && this.setIframeInnerZoom(nextProps.scale), active !== nextProps.active && this.iframe.setAttribute("data-is-storybook", nextProps.active ? "true" : "false"), nextProps.children.props.src !== this.props.children.props.src;
    }
    setIframeInnerZoom(scale) {
        try {
            Object.assign(this.iframe.contentDocument.body.style, {
                width: `${scale * 100}%`,
                height: `${scale * 100}%`,
                transform: `scale(${1 / scale})`,
                transformOrigin: "top left"
            });
        } catch  {
            this.setIframeZoom(scale);
        }
    }
    setIframeZoom(scale) {
        Object.assign(this.iframe.style, {
            width: `${scale * 100}%`,
            height: `${scale * 100}%`,
            transform: `scale(${1 / scale})`,
            transformOrigin: "top left"
        });
    }
    render() {
        let { children } = this.props;
        return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children);
    }
};
var Zoom = {
    Element: ZoomElement,
    IFrame: ZoomIFrame
};
var { document: document2 } = (0, _global.global), ErrorName = (0, _theming.styled).strong(({ theme })=>({
        color: theme.color.orange
    })), ErrorImportant = (0, _theming.styled).strong(({ theme })=>({
        color: theme.color.ancillary,
        textDecoration: "underline"
    })), ErrorDetail = (0, _theming.styled).em(({ theme })=>({
        color: theme.textMutedColor
    })), firstLineRegex = /(Error): (.*)\n/, linesRegexChromium = /at (?:(.*) )?\(?(.+)\)?/, linesRegexFirefox = /([^@]+)?(?:\/<)?@(.+)?/, linesRegexSafari = /([^@]+)?@(.+)?/, ErrorFormatter = ({ error })=>{
    if (!error) return (0, _reactDefault.default).createElement((0, _react.Fragment), null, "This error has no stack or message");
    if (!error.stack) return (0, _reactDefault.default).createElement((0, _react.Fragment), null, error.message || "This error has no stack or message");
    let input = error.stack.toString();
    input && error.message && !input.includes(error.message) && (input = `Error: ${error.message}

${input}`);
    let match = input.match(firstLineRegex);
    if (!match) return (0, _reactDefault.default).createElement((0, _react.Fragment), null, input);
    let [, type, name] = match, rawLines = input.split(/\n/).slice(1), [, ...lines] = rawLines.map((line)=>{
        let result = line.match(linesRegexChromium) || line.match(linesRegexFirefox) || line.match(linesRegexSafari);
        return result ? {
            name: (result[1] || "").replace("/<", ""),
            location: result[2].replace(document2.location.origin, "")
        } : null;
    }).filter(Boolean);
    return (0, _reactDefault.default).createElement((0, _react.Fragment), null, (0, _reactDefault.default).createElement("span", null, type), ": ", (0, _reactDefault.default).createElement(ErrorName, null, name), (0, _reactDefault.default).createElement("br", null), lines.map((l, i)=>l.name ? (0, _reactDefault.default).createElement((0, _react.Fragment), {
            key: i
        }, "  ", "at ", (0, _reactDefault.default).createElement(ErrorImportant, null, l.name), " (", (0, _reactDefault.default).createElement(ErrorDetail, null, l.location), ")", (0, _reactDefault.default).createElement("br", null)) : (0, _reactDefault.default).createElement((0, _react.Fragment), {
            key: i
        }, "  ", "at ", (0, _reactDefault.default).createElement(ErrorDetail, null, l.location), (0, _reactDefault.default).createElement("br", null))));
};
var ButtonWrapper = (0, _theming.styled).button(({ small, theme })=>({
        border: 0,
        borderRadius: "3em",
        cursor: "pointer",
        display: "inline-block",
        overflow: "hidden",
        padding: small ? "8px 16px" : "13px 20px",
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transitionProperty: "background, box-shadow",
        transitionDuration: "150ms",
        transitionTimingFunction: "ease-out",
        verticalAlign: "top",
        whiteSpace: "nowrap",
        userSelect: "none",
        opacity: 1,
        margin: 0,
        background: "transparent",
        fontSize: `${small ? theme.typography.size.s1 : theme.typography.size.s2 - 1}px`,
        fontWeight: theme.typography.weight.bold,
        lineHeight: "1",
        svg: {
            display: "inline-block",
            height: small ? 12 : 14,
            width: small ? 12 : 14,
            verticalAlign: "top",
            marginRight: small ? 4 : 6,
            marginTop: small ? 0 : -1,
            marginBottom: small ? 0 : -1,
            pointerEvents: "none",
            path: {
                fill: "currentColor"
            }
        }
    }), ({ disabled })=>disabled ? {
        cursor: "not-allowed !important",
        opacity: .5,
        "&:hover": {
            transform: "none"
        }
    } : {}, ({ containsIcon, small })=>containsIcon ? {
        svg: {
            display: "block",
            margin: 0
        },
        ...small ? {
            padding: 10
        } : {
            padding: 13
        }
    } : {}, ({ theme, primary, secondary, gray })=>{
    let color2;
    return gray ? color2 = theme.color.mediumlight : secondary ? color2 = theme.color.secondary : primary && (color2 = theme.color.primary), color2 ? {
        background: color2,
        color: gray ? theme.color.darkest : theme.color.lightest,
        "&:hover": {
            background: curriedDarken$1(.05, color2)
        },
        "&:active": {
            boxShadow: "rgba(0, 0, 0, 0.1) 0 0 0 3em inset"
        },
        "&:focus": {
            boxShadow: `${rgba(color2, 1)} 0 1px 9px 2px`,
            outline: "none"
        },
        "&:focus:hover": {
            boxShadow: `${rgba(color2, .2)} 0 8px 18px 0px`
        }
    } : {};
}, ({ theme, tertiary, inForm, small })=>tertiary ? {
        background: theme.button.background,
        color: theme.input.color,
        boxShadow: `${theme.button.border} 0 0 0 1px inset`,
        borderRadius: theme.input.borderRadius,
        ...inForm && small ? {
            padding: "10px 16px"
        } : {},
        "&:hover": {
            background: theme.base === "light" ? curriedDarken$1(.02, theme.button.background) : curriedLighten$1(.03, theme.button.background),
            ...inForm ? {} : {
                boxShadow: "rgba(0,0,0,.2) 0 2px 6px 0, rgba(0,0,0,.1) 0 0 0 1px inset"
            }
        },
        "&:active": {
            background: theme.button.background
        },
        "&:focus": {
            boxShadow: `${rgba(theme.color.secondary, 1)} 0 0 0 1px inset`,
            outline: "none"
        }
    } : {}, ({ theme, outline })=>outline ? {
        boxShadow: `${curriedTransparentize$1(.8, theme.color.defaultText)} 0 0 0 1px inset`,
        color: curriedTransparentize$1(.3, theme.color.defaultText),
        background: "transparent",
        "&:hover, &:focus": {
            boxShadow: `${curriedTransparentize$1(.5, theme.color.defaultText)} 0 0 0 1px inset`,
            outline: "none"
        },
        "&:active": {
            boxShadow: `${curriedTransparentize$1(.5, theme.color.defaultText)} 0 0 0 2px inset`,
            color: curriedTransparentize$1(0, theme.color.defaultText)
        }
    } : {}, ({ theme, outline, primary })=>{
    let color2 = theme.color.primary;
    return outline && primary ? {
        boxShadow: `${color2} 0 0 0 1px inset`,
        color: color2,
        "svg path:not([fill])": {
            fill: color2
        },
        "&:hover": {
            boxShadow: `${color2} 0 0 0 1px inset`,
            background: "transparent"
        },
        "&:active": {
            background: color2,
            boxShadow: `${color2} 0 0 0 1px inset`,
            color: theme.color.tertiary
        },
        "&:focus": {
            boxShadow: `${color2} 0 0 0 1px inset, ${rgba(color2, .4)} 0 1px 9px 2px`,
            outline: "none"
        },
        "&:focus:hover": {
            boxShadow: `${color2} 0 0 0 1px inset, ${rgba(color2, .2)} 0 8px 18px 0px`
        }
    } : {};
}, ({ theme, outline, primary, secondary })=>{
    let color2;
    return secondary ? color2 = theme.color.secondary : primary && (color2 = theme.color.primary), outline && color2 ? {
        boxShadow: `${color2} 0 0 0 1px inset`,
        color: color2,
        "svg path:not([fill])": {
            fill: color2
        },
        "&:hover": {
            boxShadow: `${color2} 0 0 0 1px inset`,
            background: "transparent"
        },
        "&:active": {
            background: color2,
            boxShadow: `${color2} 0 0 0 1px inset`,
            color: theme.color.tertiary
        },
        "&:focus": {
            boxShadow: `${color2} 0 0 0 1px inset, ${rgba(color2, .4)} 0 1px 9px 2px`,
            outline: "none"
        },
        "&:focus:hover": {
            boxShadow: `${color2} 0 0 0 1px inset, ${rgba(color2, .2)} 0 8px 18px 0px`
        }
    } : {};
}), ButtonLink = ButtonWrapper.withComponent("a"), Button = Object.assign((0, _react.forwardRef)(function({ isLink, children, ...props }, ref) {
    return isLink ? (0, _reactDefault.default).createElement(ButtonLink, {
        ...props,
        ref
    }, children) : (0, _reactDefault.default).createElement(ButtonWrapper, {
        ...props,
        ref
    }, children);
}), {
    defaultProps: {
        isLink: !1
    }
});
var Wrapper = (0, _theming.styled).label(({ theme })=>({
        display: "flex",
        borderBottom: `1px solid ${theme.appBorderColor}`,
        margin: "0 15px",
        padding: "8px 0",
        "&:last-child": {
            marginBottom: "3rem"
        }
    })), Label = (0, _theming.styled).span(({ theme })=>({
        minWidth: 100,
        fontWeight: theme.typography.weight.bold,
        marginRight: 15,
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        lineHeight: "16px"
    })), Field = ({ label, children, ...props })=>(0, _reactDefault.default).createElement(Wrapper, {
        ...props
    }, label ? (0, _reactDefault.default).createElement(Label, null, (0, _reactDefault.default).createElement("span", null, label)) : null, children);
Field.defaultProps = {
    label: void 0
};
function _extends2() {
    return _extends2 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
        }
        return target;
    }, _extends2.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.keys(source), key, i;
    for(i = 0; i < sourceKeys.length; i++)key = sourceKeys[i], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
    return target;
}
var updateRef = function(ref, value) {
    if (typeof ref == "function") {
        ref(value);
        return;
    }
    ref.current = value;
}, useComposedRef = function(libRef, userRef) {
    var prevUserRef = (0, _react.useRef)();
    return (0, _react.useCallback)(function(instance) {
        libRef.current = instance, prevUserRef.current && updateRef(prevUserRef.current, null), prevUserRef.current = userRef, userRef && updateRef(userRef, instance);
    }, [
        userRef
    ]);
}, use_composed_ref_esm_default = useComposedRef;
var noop = function() {}, _excluded = [
    "cacheMeasurements",
    "maxRows",
    "minRows",
    "onChange",
    "onHeightChange"
], TextareaAutosize = function(_ref, userRef) {
    _ref.cacheMeasurements, _ref.maxRows, _ref.minRows;
    var _ref$onChange = _ref.onChange, onChange = _ref$onChange === void 0 ? noop : _ref$onChange;
    _ref.onHeightChange;
    var props = _objectWithoutPropertiesLoose(_ref, _excluded);
    props.value;
    var libRef = _react.useRef(null), ref = use_composed_ref_esm_default(libRef, userRef);
    return _react.useRef(0), _react.useRef(), _react.createElement("textarea", _extends2({}, props, {
        onChange,
        ref
    }));
}, index = _react.forwardRef(TextareaAutosize);
var styleResets = {
    appearance: "none",
    border: "0 none",
    boxSizing: "inherit",
    display: " block",
    margin: " 0",
    background: "transparent",
    padding: 0,
    fontSize: "inherit",
    position: "relative"
}, styles = ({ theme })=>({
        ...styleResets,
        transition: "box-shadow 200ms ease-out, opacity 200ms ease-out",
        color: theme.input.color || "inherit",
        background: theme.input.background,
        boxShadow: `${theme.input.border} 0 0 0 1px inset`,
        borderRadius: theme.input.borderRadius,
        fontSize: theme.typography.size.s2 - 1,
        lineHeight: "20px",
        padding: "6px 10px",
        boxSizing: "border-box",
        height: 32,
        '&[type="file"]': {
            height: "auto"
        },
        "&:focus": {
            boxShadow: `${theme.color.secondary} 0 0 0 1px inset`,
            outline: "none"
        },
        "&[disabled]": {
            cursor: "not-allowed",
            opacity: .5
        },
        "&:-webkit-autofill": {
            WebkitBoxShadow: `0 0 0 3em ${theme.color.lightest} inset`
        },
        "&::placeholder": {
            color: theme.textMutedColor,
            opacity: 1
        }
    }), sizes = ({ size })=>{
    switch(size){
        case "100%":
            return {
                width: "100%"
            };
        case "flex":
            return {
                flex: 1
            };
        case "auto":
        default:
            return {
                display: "inline"
            };
    }
}, alignment = ({ align })=>{
    switch(align){
        case "end":
            return {
                textAlign: "right"
            };
        case "center":
            return {
                textAlign: "center"
            };
        case "start":
        default:
            return {
                textAlign: "left"
            };
    }
}, validation = ({ valid, theme })=>{
    switch(valid){
        case "valid":
            return {
                boxShadow: `${theme.color.positive} 0 0 0 1px inset !important`
            };
        case "error":
            return {
                boxShadow: `${theme.color.negative} 0 0 0 1px inset !important`
            };
        case "warn":
            return {
                boxShadow: `${theme.color.warning} 0 0 0 1px inset`
            };
        case void 0:
        case null:
        default:
            return {};
    }
}, Input = Object.assign((0, _theming.styled)((0, _react.forwardRef)(function({ size, valid, align, ...props }, ref) {
    return (0, _reactDefault.default).createElement("input", {
        ...props,
        ref
    });
}))(styles, sizes, alignment, validation, {
    minHeight: 32
}), {
    displayName: "Input"
}), Select = Object.assign((0, _theming.styled)((0, _react.forwardRef)(function({ size, valid, align, ...props }, ref) {
    return (0, _reactDefault.default).createElement("select", {
        ...props,
        ref
    });
}))(styles, sizes, validation, {
    height: 32,
    userSelect: "none",
    paddingRight: 20,
    appearance: "menulist"
}), {
    displayName: "Select"
}), Textarea = Object.assign((0, _theming.styled)((0, _react.forwardRef)(function({ size, valid, align, ...props }, ref) {
    return (0, _reactDefault.default).createElement(index, {
        ...props,
        ref
    });
}))(styles, sizes, alignment, validation, ({ height = 400 })=>({
        overflow: "visible",
        maxHeight: height
    })), {
    displayName: "Textarea"
}), ButtonStyled = (0, _theming.styled)((0, _react.forwardRef)(function({ size, valid, align, ...props }, ref) {
    return (0, _reactDefault.default).createElement(Button, {
        ...props,
        ref
    });
}))(sizes, validation, {
    userSelect: "none",
    overflow: "visible",
    zIndex: 2,
    "&:hover": {
        transform: "none"
    }
}), Button3 = Object.assign((0, _react.forwardRef)(function(props, ref) {
    return (0, _reactDefault.default).createElement(ButtonStyled, {
        ...props,
        tertiary: !0,
        small: !0,
        inForm: !0,
        ref
    });
}), {
    displayName: "Button"
});
var Form = Object.assign((0, _theming.styled).form({
    boxSizing: "border-box",
    width: "100%"
}), {
    Field,
    Input,
    Select,
    Textarea,
    Button: Button3
});
var LazyWithTooltip = (0, _react.lazy)(()=>require("b0720d09d2c0231b").then((mod)=>({
            default: mod.WithTooltip
        }))), WithTooltip = (props)=>(0, _reactDefault.default).createElement((0, _react.Suspense), {
        fallback: (0, _reactDefault.default).createElement("div", null)
    }, (0, _reactDefault.default).createElement(LazyWithTooltip, {
        ...props
    })), LazyWithTooltipPure = (0, _react.lazy)(()=>require("b0720d09d2c0231b").then((mod)=>({
            default: mod.WithTooltipPure
        }))), WithTooltipPure = (props)=>(0, _reactDefault.default).createElement((0, _react.Suspense), {
        fallback: (0, _reactDefault.default).createElement("div", null)
    }, (0, _reactDefault.default).createElement(LazyWithTooltipPure, {
        ...props
    }));
var Title2 = (0, _theming.styled).div(({ theme })=>({
        fontWeight: theme.typography.weight.bold
    })), Desc2 = (0, _theming.styled).span(), Links = (0, _theming.styled).div(({ theme })=>({
        marginTop: 8,
        textAlign: "center",
        "> *": {
            margin: "0 8px",
            fontWeight: theme.typography.weight.bold
        }
    })), Message2 = (0, _theming.styled).div(({ theme })=>({
        color: theme.color.defaultText,
        lineHeight: "18px"
    })), MessageWrapper = (0, _theming.styled).div({
    padding: 15,
    width: 280,
    boxSizing: "border-box"
}), TooltipMessage = ({ title, desc, links })=>(0, _reactDefault.default).createElement(MessageWrapper, null, (0, _reactDefault.default).createElement(Message2, null, title && (0, _reactDefault.default).createElement(Title2, null, title), desc && (0, _reactDefault.default).createElement(Desc2, null, desc)), links && (0, _reactDefault.default).createElement(Links, null, links.map(({ title: linkTitle, ...other })=>(0, _reactDefault.default).createElement(Link2, {
            ...other,
            key: linkTitle
        }, linkTitle))));
TooltipMessage.defaultProps = {
    title: null,
    desc: null,
    links: null
};
var Note = (0, _theming.styled).div(({ theme })=>({
        padding: "2px 6px",
        lineHeight: "16px",
        fontSize: 10,
        fontWeight: theme.typography.weight.bold,
        color: theme.color.lightest,
        boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.3)",
        borderRadius: 4,
        whiteSpace: "nowrap",
        pointerEvents: "none",
        zIndex: -1,
        background: theme.base === "light" ? "rgba(60, 60, 60, 0.9)" : "rgba(0, 0, 0, 0.95)",
        margin: 6
    })), TooltipNote = ({ note, ...props })=>(0, _reactDefault.default).createElement(Note, {
        ...props
    }, note);
var Title3 = (0, _theming.styled)(({ active, loading, disabled, ...rest })=>(0, _reactDefault.default).createElement("span", {
        ...rest
    }))(({ theme })=>({
        color: theme.color.defaultText,
        fontWeight: theme.typography.weight.regular
    }), ({ active, theme })=>active ? {
        color: theme.color.secondary,
        fontWeight: theme.typography.weight.bold
    } : {}, ({ loading, theme })=>loading ? {
        display: "inline-block",
        flex: "none",
        ...theme.animation.inlineGlow
    } : {}, ({ disabled, theme })=>disabled ? {
        color: curriedTransparentize$1(.7, theme.color.defaultText)
    } : {}), Right = (0, _theming.styled).span({
    display: "flex",
    "& svg": {
        height: 12,
        width: 12,
        margin: "3px 0",
        verticalAlign: "top"
    },
    "& path": {
        fill: "inherit"
    }
}), Center = (0, _theming.styled).span({
    flex: 1,
    textAlign: "left",
    display: "flex",
    flexDirection: "column"
}, ({ isIndented })=>isIndented ? {
        marginLeft: 24
    } : {}), CenterText = (0, _theming.styled).span(({ theme })=>({
        fontSize: "11px",
        lineHeight: "14px"
    }), ({ active, theme })=>active ? {
        color: theme.color.secondary
    } : {}, ({ theme, disabled })=>disabled ? {
        color: theme.textMutedColor
    } : {}), Left = (0, _theming.styled).span(({ active, theme })=>active ? {
        "& svg": {
            opacity: 1
        },
        "& svg path:not([fill])": {
            fill: theme.color.secondary
        }
    } : {}, ()=>({
        display: "flex",
        maxWidth: 14
    })), Item = (0, _theming.styled).a(({ theme })=>({
        fontSize: theme.typography.size.s1,
        transition: "all 150ms ease-out",
        color: theme.color.dark,
        textDecoration: "none",
        cursor: "pointer",
        justifyContent: "space-between",
        lineHeight: "18px",
        padding: "7px 10px",
        display: "flex",
        alignItems: "center",
        "& > * + *": {
            paddingLeft: 10
        },
        "&:hover": {
            background: theme.background.hoverable
        },
        "&:hover svg": {
            opacity: 1
        }
    }), ({ disabled })=>disabled ? {
        cursor: "not-allowed"
    } : {}), getItemProps = (0, _memoizerificDefault.default)(100)((onClick, href, LinkWrapper)=>{
    let result = {};
    return onClick && Object.assign(result, {
        onClick
    }), href && Object.assign(result, {
        href
    }), LinkWrapper && href && Object.assign(result, {
        to: href,
        as: LinkWrapper
    }), result;
}), ListItem = ({ loading, left, title, center, right, icon, active, disabled, isIndented, href, onClick, LinkWrapper, ...rest })=>{
    let itemProps = getItemProps(onClick, href, LinkWrapper), commonProps = {
        active,
        disabled
    }, isStorybookIcon = typeof icon == "string" && icons[icon];
    return (0, _reactDefault.default).createElement(Item, {
        ...commonProps,
        ...rest,
        ...itemProps
    }, icon ? (0, _reactDefault.default).createElement(Left, {
        ...commonProps
    }, isStorybookIcon ? (0, _reactDefault.default).createElement(Icons, {
        icon
    }) : icon) : left && (0, _reactDefault.default).createElement(Left, {
        ...commonProps
    }, left), title || center ? (0, _reactDefault.default).createElement(Center, {
        isIndented: !left && !icon && isIndented
    }, title && (0, _reactDefault.default).createElement(Title3, {
        ...commonProps,
        loading
    }, title), center && (0, _reactDefault.default).createElement(CenterText, {
        ...commonProps
    }, center)) : null, right && (0, _reactDefault.default).createElement(Right, {
        ...commonProps
    }, right));
};
ListItem.defaultProps = {
    loading: !1,
    left: null,
    title: (0, _reactDefault.default).createElement("span", null, "Loading state"),
    center: null,
    right: null,
    active: !1,
    disabled: !1,
    href: null,
    LinkWrapper: null,
    onClick: null
};
var ListItem_default = ListItem;
var List = (0, _theming.styled).div({
    minWidth: 180,
    overflow: "hidden",
    overflowY: "auto",
    maxHeight: 496
}, ({ theme })=>({
        borderRadius: theme.appBorderRadius
    })), Item2 = (props)=>{
    let { LinkWrapper, onClick: onClickFromProps, id, isIndented, ...rest } = props, { title, href, active } = rest, onClick = (0, _react.useCallback)((event)=>{
        onClickFromProps(event, rest);
    }, [
        onClickFromProps
    ]), hasOnClick = !!onClickFromProps;
    return (0, _reactDefault.default).createElement(ListItem_default, {
        title,
        active,
        href,
        id: `list-item-${id}`,
        LinkWrapper,
        isIndented,
        ...rest,
        ...hasOnClick ? {
            onClick
        } : {}
    });
}, TooltipLinkList = ({ links, LinkWrapper })=>{
    let hasOneLeftElement = links.some((link)=>link.left || link.icon);
    return (0, _reactDefault.default).createElement(List, null, links.map(({ isGatsby, ...p })=>(0, _reactDefault.default).createElement(Item2, {
            key: p.id,
            LinkWrapper: isGatsby ? LinkWrapper : null,
            isIndented: hasOneLeftElement,
            ...p
        })));
};
TooltipLinkList.defaultProps = {
    LinkWrapper: ListItem_default.defaultProps.LinkWrapper
};
var ButtonOrLink = (0, _reactDefault.default).forwardRef(({ children, ...restProps }, ref)=>restProps.href != null ? (0, _reactDefault.default).createElement("a", {
        ref,
        ...restProps
    }, children) : (0, _reactDefault.default).createElement("button", {
        ref,
        type: "button",
        ...restProps
    }, children));
ButtonOrLink.displayName = "ButtonOrLink";
var TabButton = (0, _theming.styled)(ButtonOrLink, {
    shouldForwardProp: (0, _theming.isPropValid)
})({
    whiteSpace: "normal",
    display: "inline-flex",
    overflow: "hidden",
    verticalAlign: "top",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    textDecoration: "none",
    "&:empty": {
        display: "none"
    }
}, ({ theme })=>({
        padding: "0 15px",
        transition: "color 0.2s linear, border-bottom-color 0.2s linear",
        height: 40,
        lineHeight: "12px",
        cursor: "pointer",
        background: "transparent",
        border: "0 solid transparent",
        borderTop: "3px solid transparent",
        borderBottom: "3px solid transparent",
        fontWeight: "bold",
        fontSize: 13,
        "&:focus": {
            outline: "0 none",
            borderBottomColor: theme.color.secondary
        }
    }), ({ active, textColor, theme })=>active ? {
        color: textColor || theme.barSelectedColor,
        borderBottomColor: theme.barSelectedColor
    } : {
        color: textColor || theme.barTextColor,
        borderBottomColor: "transparent"
    });
TabButton.displayName = "TabButton";
var IconButton = (0, _theming.styled)(ButtonOrLink, {
    shouldForwardProp: (0, _theming.isPropValid)
})(()=>({
        alignItems: "center",
        background: "transparent",
        border: "none",
        borderRadius: 4,
        color: "inherit",
        cursor: "pointer",
        display: "inline-flex",
        fontSize: 13,
        fontWeight: "bold",
        height: 28,
        justifyContent: "center",
        marginTop: 6,
        padding: "8px 7px",
        "& > svg": {
            width: 14
        }
    }), ({ active, theme })=>active ? {
        backgroundColor: theme.background.hoverable,
        color: theme.barSelectedColor
    } : {}, ({ disabled, theme })=>disabled ? {
        opacity: .5,
        cursor: "not-allowed"
    } : {
        "&:hover, &:focus-visible": {
            background: curriedTransparentize$1(.88, theme.color.secondary),
            color: theme.barHoverColor
        },
        "&:focus-visible": {
            outline: (0, _chunkNE5YGCQBMjs.auto)
        },
        "&:focus:not(:focus-visible)": {
            outline: "none"
        }
    });
IconButton.displayName = "IconButton";
var IconPlaceholder = (0, _theming.styled).div(({ theme })=>({
        width: 14,
        height: 14,
        backgroundColor: theme.appBorderColor,
        animation: `${theme.animation.glow} 1.5s ease-in-out infinite`
    })), IconButtonSkeletonWrapper = (0, _theming.styled).div(()=>({
        marginTop: 6,
        padding: 7,
        height: 28
    })), IconButtonSkeleton = ()=>(0, _reactDefault.default).createElement(IconButtonSkeletonWrapper, null, (0, _reactDefault.default).createElement(IconPlaceholder, null));
var Side = (0, _theming.styled).div({
    display: "flex",
    whiteSpace: "nowrap",
    flexBasis: "auto",
    marginLeft: 3,
    marginRight: 3
}, ({ scrollable })=>scrollable ? {
        flexShrink: 0
    } : {}, ({ left })=>left ? {
        "& > *": {
            marginLeft: 4
        }
    } : {}, ({ right })=>right ? {
        marginLeft: 30,
        "& > *": {
            marginRight: 4
        }
    } : {});
Side.displayName = "Side";
var UnstyledBar = ({ children, className, scrollable })=>scrollable ? (0, _reactDefault.default).createElement((0, _chunkLWG3MFN2Mjs.ScrollArea), {
        vertical: !1,
        className
    }, children) : (0, _reactDefault.default).createElement("div", {
        className
    }, children), Bar = (0, _theming.styled)(UnstyledBar)(({ theme, scrollable = !0 })=>({
        color: theme.barTextColor,
        width: "100%",
        height: 40,
        flexShrink: 0,
        overflow: scrollable ? "auto" : "hidden",
        overflowY: "hidden"
    }), ({ theme, border = !1 })=>border ? {
        boxShadow: `${theme.appBorderColor}  0 -1px 0 0 inset`,
        background: theme.barBg
    } : {});
Bar.displayName = "Bar";
var BarInner = (0, _theming.styled).div(({ bgColor })=>({
        display: "flex",
        justifyContent: "space-between",
        position: "relative",
        flexWrap: "nowrap",
        flexShrink: 0,
        height: 40,
        backgroundColor: bgColor || ""
    })), FlexBar = ({ children, backgroundColor, ...rest })=>{
    let [left, right] = (0, _react.Children).toArray(children);
    return (0, _reactDefault.default).createElement(Bar, {
        ...rest
    }, (0, _reactDefault.default).createElement(BarInner, {
        bgColor: backgroundColor
    }, (0, _reactDefault.default).createElement(Side, {
        scrollable: rest.scrollable,
        left: !0
    }, left), right ? (0, _reactDefault.default).createElement(Side, {
        right: !0
    }, right) : null));
};
FlexBar.displayName = "FlexBar";
var VisuallyHidden = (0, _theming.styled).div(({ active })=>active ? {
        display: "block"
    } : {
        display: "none"
    }), childrenToList = (children)=>(0, _react.Children).toArray(children).map(({ props: { title, id, color: color2, children: childrenOfChild } })=>{
        let content = Array.isArray(childrenOfChild) ? childrenOfChild[0] : childrenOfChild;
        return {
            title,
            id,
            ...color2 ? {
                color: color2
            } : {},
            render: typeof content == "function" ? content : ({ active })=>(0, _reactDefault.default).createElement(VisuallyHidden, {
                    active,
                    role: "tabpanel"
                }, content)
        };
    });
var CollapseIcon = (0, _theming.styled).span(({ theme, isActive })=>({
        display: "inline-block",
        width: 0,
        height: 0,
        marginLeft: 8,
        color: isActive ? theme.color.secondary : theme.color.mediumdark,
        borderRight: "3px solid transparent",
        borderLeft: "3px solid transparent",
        borderTop: "3px solid",
        transition: "transform .1s ease-out"
    })), AddonButton = (0, _theming.styled)(TabButton)(({ active, theme, preActive })=>`
    color: ${preActive || active ? theme.color.secondary : theme.color.mediumdark};
    &:hover {
      color: ${theme.color.secondary};
      .addon-collapsible-icon {
        color: ${theme.color.secondary};
      }
    }
  `);
function useList(list) {
    let tabBarRef = (0, _react.useRef)(), addonsRef = (0, _react.useRef)(), tabRefs = (0, _react.useRef)(new Map), { width: tabBarWidth = 1 } = (0, _useResizeObserverDefault.default)({
        ref: tabBarRef
    }), [visibleList, setVisibleList] = (0, _react.useState)(list), [invisibleList, setInvisibleList] = (0, _react.useState)([]), previousList = (0, _react.useRef)(list), AddonTab = (0, _react.useCallback)(({ menuName, actions })=>{
        let isAddonsActive = invisibleList.some(({ active })=>active), [isTooltipVisible, setTooltipVisible] = (0, _react.useState)(!1);
        return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement((0, _chunkNE5YGCQBMjs.WithToolTipState), {
            interactive: !0,
            visible: isTooltipVisible,
            onVisibleChange: setTooltipVisible,
            placement: "bottom",
            delayHide: 100,
            tooltip: (0, _reactDefault.default).createElement(TooltipLinkList, {
                links: invisibleList.map(({ title, id, color: color2, active })=>({
                        id,
                        title,
                        color: color2,
                        active,
                        onClick: (e)=>{
                            e.preventDefault(), actions.onSelect(id);
                        }
                    }))
            })
        }, (0, _reactDefault.default).createElement(AddonButton, {
            ref: addonsRef,
            active: isAddonsActive,
            preActive: isTooltipVisible,
            style: {
                visibility: invisibleList.length ? "visible" : "hidden"
            },
            "aria-hidden": !invisibleList.length,
            className: "tabbutton",
            type: "button",
            role: "tab"
        }, menuName, (0, _reactDefault.default).createElement(CollapseIcon, {
            className: "addon-collapsible-icon",
            isActive: isAddonsActive || isTooltipVisible
        }))), invisibleList.map(({ title, id, color: color2 }, index2)=>{
            let indexId = `index-${index2}`;
            return (0, _reactDefault.default).createElement(TabButton, {
                id: `tabbutton-${(0, _csf.sanitize)(id) ?? indexId}`,
                style: {
                    visibility: "hidden"
                },
                "aria-hidden": !0,
                tabIndex: -1,
                ref: (ref)=>{
                    tabRefs.current.set(id, ref);
                },
                className: "tabbutton",
                type: "button",
                key: id,
                textColor: color2,
                role: "tab"
            }, title);
        }));
    }, [
        invisibleList
    ]), setTabLists = (0, _react.useCallback)(()=>{
        if (!tabBarRef.current || !addonsRef.current) return;
        let { x, width } = tabBarRef.current.getBoundingClientRect(), { width: widthAddonsTab } = addonsRef.current.getBoundingClientRect(), rightBorder = invisibleList.length ? x + width - widthAddonsTab : x + width, newVisibleList = [], widthSum = 0, newInvisibleList = list.filter((item)=>{
            let { id } = item, tabButton = tabRefs.current.get(id), { width: tabWidth = 0 } = tabButton?.getBoundingClientRect() || {}, crossBorder = x + widthSum + tabWidth > rightBorder;
            return (!crossBorder || !tabButton) && newVisibleList.push(item), widthSum += tabWidth, crossBorder;
        });
        (newVisibleList.length !== visibleList.length || previousList.current !== list) && (setVisibleList(newVisibleList), setInvisibleList(newInvisibleList), previousList.current = list);
    }, [
        invisibleList.length,
        list,
        visibleList
    ]);
    return (0, _react.useLayoutEffect)(setTabLists, [
        setTabLists,
        tabBarWidth
    ]), {
        tabRefs,
        addonsRef,
        tabBarRef,
        visibleList,
        invisibleList,
        AddonTab
    };
}
var ignoreSsrWarning2 = "/* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */", Wrapper2 = (0, _theming.styled).div(({ theme, bordered })=>bordered ? {
        backgroundClip: "padding-box",
        border: `1px solid ${theme.appBorderColor}`,
        borderRadius: theme.appBorderRadius,
        overflow: "hidden",
        boxSizing: "border-box"
    } : {}, ({ absolute })=>absolute ? {
        width: "100%",
        height: "100%",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column"
    } : {
        display: "block"
    }), TabBar = (0, _theming.styled).div({
    overflow: "hidden",
    "&:first-of-type": {
        marginLeft: -3
    },
    whiteSpace: "nowrap",
    flexGrow: 1
});
TabBar.displayName = "TabBar";
var Content = (0, _theming.styled).div({
    display: "block",
    position: "relative"
}, ({ theme })=>({
        fontSize: theme.typography.size.s2 - 1,
        background: theme.background.content
    }), ({ bordered, theme })=>bordered ? {
        borderRadius: `0 0 ${theme.appBorderRadius - 1}px ${theme.appBorderRadius - 1}px`
    } : {}, ({ absolute, bordered })=>absolute ? {
        height: `calc(100% - ${bordered ? 42 : 40}px)`,
        position: "absolute",
        left: 0 + (bordered ? 1 : 0),
        right: 0 + (bordered ? 1 : 0),
        bottom: 0 + (bordered ? 1 : 0),
        top: 40 + (bordered ? 1 : 0),
        overflow: "auto",
        [`& > *:first-child${ignoreSsrWarning2}`]: {
            position: "absolute",
            left: 0 + (bordered ? 1 : 0),
            right: 0 + (bordered ? 1 : 0),
            bottom: 0 + (bordered ? 1 : 0),
            top: 0 + (bordered ? 1 : 0),
            height: `calc(100% - ${bordered ? 2 : 0}px)`,
            overflow: "auto"
        }
    } : {}), TabWrapper = ({ active, render, children })=>(0, _reactDefault.default).createElement(VisuallyHidden, {
        active
    }, render ? render() : children);
var Tabs = (0, _react.memo)(({ children, selected, actions, absolute, bordered, tools, backgroundColor, id: htmlId, menuName })=>{
    let idList = childrenToList(children).map((i)=>i.id), list = (0, _react.useMemo)(()=>childrenToList(children).map((i, index2)=>({
                ...i,
                active: selected ? i.id === selected : index2 === 0
            })), [
        selected,
        ...idList
    ]), { visibleList, tabBarRef, tabRefs, AddonTab } = useList(list);
    return list.length ? (0, _reactDefault.default).createElement(Wrapper2, {
        absolute,
        bordered,
        id: htmlId
    }, (0, _reactDefault.default).createElement(FlexBar, {
        scrollable: !1,
        border: !0,
        backgroundColor
    }, (0, _reactDefault.default).createElement(TabBar, {
        style: {
            whiteSpace: "normal"
        },
        ref: tabBarRef,
        role: "tablist"
    }, visibleList.map(({ title, id, active, color: color2 }, index2)=>{
        let indexId = `index-${index2}`;
        return (0, _reactDefault.default).createElement(TabButton, {
            id: `tabbutton-${(0, _csf.sanitize)(id) ?? indexId}`,
            ref: (ref)=>{
                tabRefs.current.set(id, ref);
            },
            className: `tabbutton ${active ? "tabbutton-active" : ""}`,
            type: "button",
            key: id,
            active,
            textColor: color2,
            onClick: (e)=>{
                e.preventDefault(), actions.onSelect(id);
            },
            role: "tab"
        }, typeof title == "function" ? (0, _reactDefault.default).createElement("title", null) : title);
    }), (0, _reactDefault.default).createElement(AddonTab, {
        menuName,
        actions
    })), tools), (0, _reactDefault.default).createElement(Content, {
        id: "panel-tab-content",
        bordered,
        absolute
    }, list.map(({ id, active, render })=>(0, _reactDefault.default).createElement(render, {
            key: id,
            active
        }, null)))) : (0, _reactDefault.default).createElement(Placeholder, null, (0, _reactDefault.default).createElement((0, _react.Fragment), {
        key: "title"
    }, "Nothing found"));
});
Tabs.displayName = "Tabs";
Tabs.defaultProps = {
    id: null,
    children: null,
    tools: null,
    selected: null,
    absolute: !1,
    bordered: !1,
    menuName: "Tabs"
};
var TabsState = class extends (0, _react.Component) {
    constructor(props){
        super(props);
        this.handlers = {
            onSelect: (id)=>this.setState({
                    selected: id
                })
        };
        this.state = {
            selected: props.initial
        };
    }
    render() {
        let { bordered = !1, absolute = !1, children, backgroundColor, menuName } = this.props, { selected } = this.state;
        return (0, _reactDefault.default).createElement(Tabs, {
            bordered,
            absolute,
            selected,
            backgroundColor,
            menuName,
            actions: this.handlers
        }, children);
    }
};
TabsState.defaultProps = {
    children: [],
    initial: null,
    absolute: !1,
    bordered: !1,
    backgroundColor: "",
    menuName: void 0
};
var Separator = (0, _theming.styled).span(({ theme })=>({
        width: 1,
        height: 20,
        background: theme.appBorderColor,
        marginTop: 10,
        marginLeft: 6,
        marginRight: 2
    }), ({ force })=>force ? {} : {
        "& + &": {
            display: "none"
        }
    });
Separator.displayName = "Separator";
var interleaveSeparators = (list)=>list.reduce((acc, item, index2)=>item ? (0, _reactDefault.default).createElement((0, _react.Fragment), {
            key: item.id || item.key || `f-${index2}`
        }, acc, index2 > 0 ? (0, _reactDefault.default).createElement(Separator, {
            key: `s-${index2}`
        }) : null, item.render() || item) : acc, null);
var usePrevious = (value)=>{
    let ref = (0, _react.useRef)();
    return (0, _react.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]), ref.current;
}, useUpdate = (update, value)=>{
    let previousValue = usePrevious(value);
    return update ? value : previousValue;
}, AddonPanel = ({ active, children })=>(0, _reactDefault.default).createElement("div", {
        hidden: !active
    }, useUpdate(active, children));
var StorybookLogo = ({ alt, ...props })=>(0, _reactDefault.default).createElement("svg", {
        width: "200px",
        height: "40px",
        viewBox: "0 0 200 40",
        ...props,
        role: "img"
    }, alt ? (0, _reactDefault.default).createElement("title", null, alt) : null, (0, _reactDefault.default).createElement("defs", null, (0, _reactDefault.default).createElement("path", {
        d: "M1.2 36.9L0 3.9c0-1.1.8-2 1.9-2.1l28-1.8a2 2 0 0 1 2.2 1.9 2 2 0 0 1 0 .1v36a2 2 0 0 1-2 2 2 2 0 0 1-.1 0L3.2 38.8a2 2 0 0 1-2-2z",
        id: "a"
    })), (0, _reactDefault.default).createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, (0, _reactDefault.default).createElement("path", {
        d: "M53.3 31.7c-1.7 0-3.4-.3-5-.7-1.5-.5-2.8-1.1-3.9-2l1.6-3.5c2.2 1.5 4.6 2.3 7.3 2.3 1.5 0 2.5-.2 3.3-.7.7-.5 1.1-1 1.1-1.9 0-.7-.3-1.3-1-1.7s-2-.8-3.7-1.2c-2-.4-3.6-.9-4.8-1.5-1.1-.5-2-1.2-2.6-2-.5-1-.8-2-.8-3.2 0-1.4.4-2.6 1.2-3.6.7-1.1 1.8-2 3.2-2.6 1.3-.6 2.9-.9 4.7-.9 1.6 0 3.1.3 4.6.7 1.5.5 2.7 1.1 3.5 2l-1.6 3.5c-2-1.5-4.2-2.3-6.5-2.3-1.3 0-2.3.2-3 .8-.8.5-1.2 1.1-1.2 2 0 .5.2 1 .5 1.3.2.3.7.6 1.4.9l2.9.8c2.9.6 5 1.4 6.2 2.4a5 5 0 0 1 2 4.2 6 6 0 0 1-2.5 5c-1.7 1.2-4 1.9-7 1.9zm21-3.6l1.4-.1-.2 3.5-1.9.1c-2.4 0-4.1-.5-5.2-1.5-1.1-1-1.6-2.7-1.6-4.8v-6h-3v-3.6h3V11h4.8v4.6h4v3.6h-4v6c0 1.8.9 2.8 2.6 2.8zm11.1 3.5c-1.6 0-3-.3-4.3-1a7 7 0 0 1-3-2.8c-.6-1.3-1-2.7-1-4.4 0-1.6.4-3 1-4.3a7 7 0 0 1 3-2.8c1.2-.7 2.7-1 4.3-1 1.7 0 3.2.3 4.4 1a7 7 0 0 1 3 2.8c.6 1.2 1 2.7 1 4.3 0 1.7-.4 3.1-1 4.4a7 7 0 0 1-3 2.8c-1.2.7-2.7 1-4.4 1zm0-3.6c2.4 0 3.6-1.6 3.6-4.6 0-1.5-.3-2.6-1-3.4a3.2 3.2 0 0 0-2.6-1c-2.3 0-3.5 1.4-3.5 4.4 0 3 1.2 4.6 3.5 4.6zm21.7-8.8l-2.7.3c-1.3.2-2.3.5-2.8 1.2-.6.6-.9 1.4-.9 2.5v8.2H96V15.7h4.6v2.6c.8-1.8 2.5-2.8 5-3h1.3l.3 4zm14-3.5h4.8L116.4 37h-4.9l3-6.6-6.4-14.8h5l4 10 4-10zm16-.4c1.4 0 2.6.3 3.6 1 1 .6 1.9 1.6 2.5 2.8.6 1.2.9 2.7.9 4.3 0 1.6-.3 3-1 4.3a6.9 6.9 0 0 1-2.4 2.9c-1 .7-2.2 1-3.6 1-1 0-2-.2-3-.7-.8-.4-1.5-1-2-1.9v2.4h-4.7V8.8h4.8v9c.5-.8 1.2-1.4 2-1.9.9-.4 1.8-.6 3-.6zM135.7 28c1.1 0 2-.4 2.6-1.2.6-.8 1-2 1-3.4 0-1.5-.4-2.5-1-3.3s-1.5-1.1-2.6-1.1-2 .3-2.6 1.1c-.6.8-1 2-1 3.3 0 1.5.4 2.6 1 3.4.6.8 1.5 1.2 2.6 1.2zm18.9 3.6c-1.7 0-3.2-.3-4.4-1a7 7 0 0 1-3-2.8c-.6-1.3-1-2.7-1-4.4 0-1.6.4-3 1-4.3a7 7 0 0 1 3-2.8c1.2-.7 2.7-1 4.4-1 1.6 0 3 .3 4.3 1a7 7 0 0 1 3 2.8c.6 1.2 1 2.7 1 4.3 0 1.7-.4 3.1-1 4.4a7 7 0 0 1-3 2.8c-1.2.7-2.7 1-4.3 1zm0-3.6c2.3 0 3.5-1.6 3.5-4.6 0-1.5-.3-2.6-1-3.4a3.2 3.2 0 0 0-2.5-1c-2.4 0-3.6 1.4-3.6 4.4 0 3 1.2 4.6 3.6 4.6zm18 3.6c-1.7 0-3.2-.3-4.4-1a7 7 0 0 1-3-2.8c-.6-1.3-1-2.7-1-4.4 0-1.6.4-3 1-4.3a7 7 0 0 1 3-2.8c1.2-.7 2.7-1 4.4-1 1.6 0 3 .3 4.4 1a7 7 0 0 1 2.9 2.8c.6 1.2 1 2.7 1 4.3 0 1.7-.4 3.1-1 4.4a7 7 0 0 1-3 2.8c-1.2.7-2.7 1-4.3 1zm0-3.6c2.3 0 3.5-1.6 3.5-4.6 0-1.5-.3-2.6-1-3.4a3.2 3.2 0 0 0-2.5-1c-2.4 0-3.6 1.4-3.6 4.4 0 3 1.2 4.6 3.6 4.6zm27.4 3.4h-6l-6-7v7h-4.8V8.8h4.9v13.6l5.8-6.7h5.7l-6.6 7.5 7 8.2z",
        fill: "currentColor"
    }), (0, _reactDefault.default).createElement("mask", {
        id: "b",
        fill: "#fff"
    }, (0, _reactDefault.default).createElement("use", {
        xlinkHref: "#a"
    })), (0, _reactDefault.default).createElement("use", {
        fill: "#FF4785",
        fillRule: "nonzero",
        xlinkHref: "#a"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M23.7 5L24 .2l3.9-.3.1 4.8a.3.3 0 0 1-.5.2L26 3.8l-1.7 1.4a.3.3 0 0 1-.5-.3zm-5 10c0 .9 5.3.5 6 0 0-5.4-2.8-8.2-8-8.2-5.3 0-8.2 2.8-8.2 7.1 0 7.4 10 7.6 10 11.6 0 1.2-.5 1.9-1.8 1.9-1.6 0-2.2-.9-2.1-3.6 0-.6-6.1-.8-6.3 0-.5 6.7 3.7 8.6 8.5 8.6 4.6 0 8.3-2.5 8.3-7 0-7.9-10.2-7.7-10.2-11.6 0-1.6 1.2-1.8 2-1.8.6 0 2 0 1.9 3z",
        fill: "#FFF",
        fillRule: "nonzero",
        mask: "url(#b)"
    })));
var StorybookIcon = ({ ...props })=>(0, _reactDefault.default).createElement("svg", {
        viewBox: "0 0 64 64",
        ...props
    }, (0, _reactDefault.default).createElement("title", null, "Storybook icon"), (0, _reactDefault.default).createElement("g", {
        id: "Artboard",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, (0, _reactDefault.default).createElement("path", {
        d: "M8.04798541,58.7875918 L6.07908839,6.32540407 C6.01406344,4.5927838 7.34257463,3.12440831 9.07303814,3.01625434 L53.6958037,0.227331489 C55.457209,0.117243658 56.974354,1.45590096 57.0844418,3.21730626 C57.0885895,3.28366922 57.0906648,3.35014546 57.0906648,3.41663791 L57.0906648,60.5834697 C57.0906648,62.3483119 55.6599776,63.7789992 53.8951354,63.7789992 C53.847325,63.7789992 53.7995207,63.7779262 53.7517585,63.775781 L11.0978899,61.8600599 C9.43669044,61.7854501 8.11034889,60.4492961 8.04798541,58.7875918 Z",
        id: "path-1",
        fill: "#FF4785",
        fillRule: "nonzero"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M35.9095005,24.1768792 C35.9095005,25.420127 44.2838488,24.8242707 45.4080313,23.9509748 C45.4080313,15.4847538 40.8652557,11.0358878 32.5466666,11.0358878 C24.2280775,11.0358878 19.5673077,15.553972 19.5673077,22.3311017 C19.5673077,34.1346028 35.4965208,34.3605071 35.4965208,40.7987804 C35.4965208,42.606015 34.6115646,43.6790606 32.6646607,43.6790606 C30.127786,43.6790606 29.1248356,42.3834613 29.2428298,37.9783269 C29.2428298,37.0226907 19.5673077,36.7247626 19.2723223,37.9783269 C18.5211693,48.6535354 25.1720308,51.7326752 32.7826549,51.7326752 C40.1572906,51.7326752 45.939005,47.8018145 45.939005,40.6858282 C45.939005,28.035186 29.7738035,28.3740425 29.7738035,22.1051974 C29.7738035,19.5637737 31.6617103,19.2249173 32.7826549,19.2249173 C33.9625966,19.2249173 36.0864917,19.4328883 35.9095005,24.1768792 Z",
        id: "path9_fill-path",
        fill: "#FFFFFF",
        fillRule: "nonzero"
    }), (0, _reactDefault.default).createElement("path", {
        d: "M44.0461638,0.830433986 L50.1874092,0.446606143 L50.443532,7.7810017 C50.4527198,8.04410717 50.2468789,8.26484453 49.9837734,8.27403237 C49.871115,8.27796649 49.7607078,8.24184808 49.6721567,8.17209069 L47.3089847,6.3104681 L44.5110468,8.43287463 C44.3012992,8.591981 44.0022839,8.55092814 43.8431776,8.34118051 C43.7762017,8.25288717 43.742082,8.14401677 43.7466857,8.03329059 L44.0461638,0.830433986 Z",
        id: "Path",
        fill: "#FFFFFF"
    })));
var rotate360 = (0, _theming.keyframes)`
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(360deg);
	}
`;
var LoaderWrapper = (0, _theming.styled).div(({ size = 32 })=>({
        borderRadius: "50%",
        cursor: "progress",
        display: "inline-block",
        overflow: "hidden",
        position: "absolute",
        transition: "all 200ms ease-out",
        verticalAlign: "top",
        top: "50%",
        left: "50%",
        marginTop: -(size / 2),
        marginLeft: -(size / 2),
        height: size,
        width: size,
        zIndex: 4,
        borderWidth: 2,
        borderStyle: "solid",
        borderColor: "rgba(97, 97, 97, 0.29)",
        borderTopColor: "rgb(100,100,100)",
        animation: `${rotate360} 0.7s linear infinite`,
        mixBlendMode: "difference"
    })), ProgressWrapper = (0, _theming.styled).div({
    position: "absolute",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%"
}), ProgressTrack = (0, _theming.styled).div(({ theme })=>({
        position: "relative",
        width: "80%",
        marginBottom: "0.75rem",
        maxWidth: 300,
        height: 5,
        borderRadius: 5,
        background: curriedTransparentize$1(.8, theme.color.secondary),
        overflow: "hidden",
        cursor: "progress"
    })), ProgressBar = (0, _theming.styled).div(({ theme })=>({
        position: "absolute",
        top: 0,
        left: 0,
        height: "100%",
        background: theme.color.secondary
    })), ProgressMessage = (0, _theming.styled).div(({ theme })=>({
        minHeight: "2em",
        fontSize: `${theme.typography.size.s1}px`,
        color: theme.barTextColor
    })), ErrorIcon = (0, _theming.styled)(Icons)(({ theme })=>({
        width: 20,
        height: 20,
        marginBottom: "0.5rem",
        color: theme.textMutedColor
    })), ellipsis = (0, _theming.keyframes)`
  from { content: "..." }
  33% { content: "." }
  66% { content: ".." }
  to { content: "..." }
`, Ellipsis = (0, _theming.styled).span({
    "&::after": {
        content: "'...'",
        animation: `${ellipsis} 1s linear infinite`,
        animationDelay: "1s",
        display: "inline-block",
        width: "1em",
        height: "auto"
    }
}), Loader = ({ progress, error, size, ...props })=>{
    if (error) return (0, _reactDefault.default).createElement(ProgressWrapper, {
        "aria-label": error.toString(),
        "aria-live": "polite",
        role: "status",
        ...props
    }, (0, _reactDefault.default).createElement(ErrorIcon, {
        icon: "lightningoff"
    }), (0, _reactDefault.default).createElement(ProgressMessage, null, error.message));
    if (progress) {
        let { value, modules } = progress, { message } = progress;
        return modules && (message += ` ${modules.complete} / ${modules.total} modules`), (0, _reactDefault.default).createElement(ProgressWrapper, {
            "aria-label": "Content is loading...",
            "aria-live": "polite",
            "aria-valuemin": 0,
            "aria-valuemax": 100,
            "aria-valuenow": value * 100,
            "aria-valuetext": message,
            role: "progressbar",
            ...props
        }, (0, _reactDefault.default).createElement(ProgressTrack, null, (0, _reactDefault.default).createElement(ProgressBar, {
            style: {
                width: `${value * 100}%`
            }
        })), (0, _reactDefault.default).createElement(ProgressMessage, null, message, value < 1 && (0, _reactDefault.default).createElement(Ellipsis, {
            key: message
        })));
    }
    return (0, _reactDefault.default).createElement(LoaderWrapper, {
        "aria-label": "Content is loading...",
        "aria-live": "polite",
        role: "status",
        size,
        ...props
    });
};
function parseQuery(queryString) {
    let query = {}, pairs = queryString.split("&");
    for(let i = 0; i < pairs.length; i++){
        let pair = pairs[i].split("=");
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
    }
    return query;
}
var getStoryHref = (baseUrl, storyId, additionalParams = {})=>{
    let [url, paramsStr] = baseUrl.split("?"), params = paramsStr ? {
        ...parseQuery(paramsStr),
        ...additionalParams,
        id: storyId
    } : {
        ...additionalParams,
        id: storyId
    };
    return `${url}?${Object.entries(params).map((item)=>`${item[0]}=${item[1]}`).join("&")}`;
};
var Code2 = (0, _theming.styled).pre`
  line-height: 18px;
  padding: 11px 1rem;
  white-space: pre-wrap;
  background: rgba(0, 0, 0, 0.05);
  color: ${(0, _theming.color).darkest};
  border-radius: 3px;
  margin: 1rem 0;
  width: 100%;
  display: block;
  overflow: hidden;
  font-family: ${(0, _theming.typography).fonts.mono};
  font-size: ${(0, _theming.typography).size.s2 - 1}px;
`, ClipboardCode = ({ code, ...props })=>(0, _reactDefault.default).createElement(Code2, {
        id: "clipboard-code",
        ...props
    }, code);
var components2 = components, resetComponents = {};
Object.keys(components).forEach((key)=>{
    resetComponents[key] = (0, _react.forwardRef)((props, ref)=>(0, _react.createElement)(key, {
            ...props,
            ref
        }));
});

},{"./chunk-LWG3MFN2.mjs":"buxHw","./chunk-NE5YGCQB.mjs":"k5oxb","./chunk-MUPK3MH6.mjs":"gwy2u","./chunk-ISRAU5IP.mjs":"5Dv5W","./chunk-YU6L2YXV.mjs":"2gZWj","./chunk-VSDH24NK.mjs":"dWeGM","./chunk-BNQCH2A2.mjs":"6x9ZK","./chunk-UDRSICRZ.mjs":"f54xE","./chunk-J6EJ35VB.mjs":"7Ry1g","./chunk-HNGDCMHD.mjs":"2OmDN","./chunk-4Y2S2TEP.mjs":"70Qwv","./chunk-CW4JFC2I.mjs":"2AfZu","./chunk-7PYIL73X.mjs":"iMx5F","./chunk-SWV57YYC.mjs":"iAXcz","./chunk-MNLJ4LIX.mjs":"5eeP5","./chunk-DHRX2IL7.mjs":"hGrAv","./chunk-JRLSWQMA.mjs":"cGDqS","react":"jEiK2","@storybook/theming":"bYlbs","use-resize-observer":"ah6gN","@storybook/global":"4g4co","memoizerific":"aOMtb","@storybook/csf":"9PLwP","30a1cf2d1b9d7e9d":"eJzsN","c463b03623b6f01d":"5TfLM","b0720d09d2c0231b":"g2jam","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"buxHw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionBar", ()=>ActionBar);
parcelHelpers.export(exports, "ScrollArea", ()=>ScrollArea);
parcelHelpers.export(exports, "SyntaxHighlighter", ()=>SyntaxHighlighter2);
parcelHelpers.export(exports, "createCopyToClipboardFunction", ()=>createCopyToClipboardFunction);
parcelHelpers.export(exports, "syntaxhighlighter_default", ()=>syntaxhighlighter_default);
var _chunkMUPK3MH6Mjs = require("./chunk-MUPK3MH6.mjs");
var _chunkISRAU5IPMjs = require("./chunk-ISRAU5IP.mjs");
var _chunkYU6L2YXVMjs = require("./chunk-YU6L2YXV.mjs");
var _chunkVSDH24NKMjs = require("./chunk-VSDH24NK.mjs");
var _chunkBNQCH2A2Mjs = require("./chunk-BNQCH2A2.mjs");
var _chunkHNGDCMHDMjs = require("./chunk-HNGDCMHD.mjs");
var _chunk4Y2S2TEPMjs = require("./chunk-4Y2S2TEP.mjs");
var _chunkCW4JFC2IMjs = require("./chunk-CW4JFC2I.mjs");
var _chunk7PYIL73XMjs = require("./chunk-7PYIL73X.mjs");
var _chunkSWV57YYCMjs = require("./chunk-SWV57YYC.mjs");
var _chunkMNLJ4LIXMjs = require("./chunk-MNLJ4LIX.mjs");
var _chunkDHRX2IL7Mjs = require("./chunk-DHRX2IL7.mjs");
var _chunkJRLSWQMAMjs = require("./chunk-JRLSWQMA.mjs");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clientLogger = require("@storybook/client-logger");
var _theming = require("@storybook/theming");
var _global = require("@storybook/global");
var _memoizerific = require("memoizerific");
var _memoizerificDefault = parcelHelpers.interopDefault(_memoizerific);
var _reactDom = require("react-dom");
var import_jsx = (0, _chunkJRLSWQMAMjs.__toESM)((0, _chunkHNGDCMHDMjs.require_jsx)()), jsx_default = import_jsx.default;
var import_bash = (0, _chunkJRLSWQMAMjs.__toESM)((0, _chunk4Y2S2TEPMjs.require_bash)()), bash_default = import_bash.default;
var import_css = (0, _chunkJRLSWQMAMjs.__toESM)((0, _chunkCW4JFC2IMjs.require_css)()), css_default = import_css.default;
var import_js_extras = (0, _chunkJRLSWQMAMjs.__toESM)((0, _chunk7PYIL73XMjs.require_js_extras)()), js_extras_default = import_js_extras.default;
var import_json = (0, _chunkJRLSWQMAMjs.__toESM)((0, _chunkSWV57YYCMjs.require_json)()), json_default = import_json.default;
var import_graphql = (0, _chunkJRLSWQMAMjs.__toESM)((0, _chunkMNLJ4LIXMjs.require_graphql)()), graphql_default = import_graphql.default;
var import_markup = (0, _chunkJRLSWQMAMjs.__toESM)((0, _chunkDHRX2IL7Mjs.require_markup)()), markup_default = import_markup.default;
var import_markdown = (0, _chunkJRLSWQMAMjs.__toESM)((0, _chunkMUPK3MH6Mjs.require_markdown)()), markdown_default = import_markdown.default;
var import_yaml = (0, _chunkJRLSWQMAMjs.__toESM)((0, _chunkISRAU5IPMjs.require_yaml)()), yaml_default = import_yaml.default;
var import_tsx = (0, _chunkJRLSWQMAMjs.__toESM)((0, _chunkYU6L2YXVMjs.require_tsx)()), tsx_default = import_tsx.default;
var import_typescript = (0, _chunkJRLSWQMAMjs.__toESM)((0, _chunkVSDH24NKMjs.require_typescript)()), typescript_default = import_typescript.default;
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.keys(source), key, i;
    for(i = 0; i < sourceKeys.length; i++)key = sourceKeys[i], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded), key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++)key = sourceSymbolKeys[i], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
    }
    return target;
}
function _arrayLikeToArray(arr, len) {
    (len == null || len > arr.length) && (len = arr.length);
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol < "u" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
    if (o) {
        if (typeof o == "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor && (n = o.constructor.name), n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
}
function _nonIterableSpread() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o2) {
        return typeof o2;
    } : function(o2) {
        return o2 && typeof Symbol == "function" && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
    }, _typeof(o);
}
function toPrimitive(t, r) {
    if (_typeof(t) != "object" || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (e !== void 0) {
        var i = e.call(t, r || "default");
        if (_typeof(i) != "object") return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(t);
}
function toPropertyKey(t) {
    var i = toPrimitive(t, "string");
    return _typeof(i) == "symbol" ? i : String(i);
}
function _defineProperty(obj, key, value) {
    return key = toPropertyKey(key), key in obj ? Object.defineProperty(obj, key, {
        value,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : obj[key] = value, obj;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
        }
        return target;
    }, _extends.apply(this, arguments);
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function powerSetPermutations(arr) {
    var arrLength = arr.length;
    if (arrLength === 0 || arrLength === 1) return arr;
    if (arrLength === 2) return [
        arr[0],
        arr[1],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0])
    ];
    if (arrLength === 3) return [
        arr[0],
        arr[1],
        arr[2],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0])
    ];
    if (arrLength >= 4) return [
        arr[0],
        arr[1],
        arr[2],
        arr[3],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[1], ".").concat(arr[0])
    ];
}
var classNameCombinations = {};
function getClassNameCombinations(classNames) {
    if (classNames.length === 0 || classNames.length === 1) return classNames;
    var key = classNames.join(".");
    return classNameCombinations[key] || (classNameCombinations[key] = powerSetPermutations(classNames)), classNameCombinations[key];
}
function createStyleObject(classNames) {
    var elementStyle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, stylesheet = arguments.length > 2 ? arguments[2] : void 0, nonTokenClassNames = classNames.filter(function(className) {
        return className !== "token";
    }), classNamesCombinations = getClassNameCombinations(nonTokenClassNames);
    return classNamesCombinations.reduce(function(styleObject, className) {
        return _objectSpread(_objectSpread({}, styleObject), stylesheet[className]);
    }, elementStyle);
}
function createClassNameString(classNames) {
    return classNames.join(" ");
}
function createChildren(stylesheet, useInlineStyles) {
    var childrenCount = 0;
    return function(children) {
        return childrenCount += 1, children.map(function(child, i) {
            return createElement({
                node: child,
                stylesheet,
                useInlineStyles,
                key: "code-segment-".concat(childrenCount, "-").concat(i)
            });
        });
    };
}
function createElement(_ref) {
    var node = _ref.node, stylesheet = _ref.stylesheet, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style, useInlineStyles = _ref.useInlineStyles, key = _ref.key, properties = node.properties, type = node.type, TagName = node.tagName, value = node.value;
    if (type === "text") return value;
    if (TagName) {
        var childrenCreator = createChildren(stylesheet, useInlineStyles), props;
        if (!useInlineStyles) props = _objectSpread(_objectSpread({}, properties), {}, {
            className: createClassNameString(properties.className)
        });
        else {
            var allStylesheetSelectors = Object.keys(stylesheet).reduce(function(classes, selector) {
                return selector.split(".").forEach(function(className2) {
                    classes.includes(className2) || classes.push(className2);
                }), classes;
            }, []), startingClassName = properties.className && properties.className.includes("token") ? [
                "token"
            ] : [], className = properties.className && startingClassName.concat(properties.className.filter(function(className2) {
                return !allStylesheetSelectors.includes(className2);
            }));
            props = _objectSpread(_objectSpread({}, properties), {}, {
                className: createClassNameString(className) || void 0,
                style: createStyleObject(properties.className, Object.assign({}, properties.style, style), stylesheet)
            });
        }
        var children = childrenCreator(node.children);
        return (0, _reactDefault.default).createElement(TagName, _extends({
            key
        }, props), children);
    }
}
var checkForListedLanguage_default = function(astGenerator, language) {
    var langs = astGenerator.listLanguages();
    return langs.indexOf(language) !== -1;
};
var _excluded = [
    "language",
    "children",
    "style",
    "customStyle",
    "codeTagProps",
    "useInlineStyles",
    "showLineNumbers",
    "showInlineLineNumbers",
    "startingLineNumber",
    "lineNumberContainerStyle",
    "lineNumberStyle",
    "wrapLines",
    "wrapLongLines",
    "lineProps",
    "renderer",
    "PreTag",
    "CodeTag",
    "code",
    "astGenerator"
];
function ownKeys2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        i % 2 ? ownKeys2(Object(source), !0).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var newLineRegex = /\n/g;
function getNewLines(str) {
    return str.match(newLineRegex);
}
function getAllLineNumbers(_ref) {
    var lines = _ref.lines, startingLineNumber = _ref.startingLineNumber, style = _ref.style;
    return lines.map(function(_, i) {
        var number = i + startingLineNumber;
        return (0, _reactDefault.default).createElement("span", {
            key: "line-".concat(i),
            className: "react-syntax-highlighter-line-number",
            style: typeof style == "function" ? style(number) : style
        }, "".concat(number, `
`));
    });
}
function AllLineNumbers(_ref2) {
    var codeString = _ref2.codeString, codeStyle = _ref2.codeStyle, _ref2$containerStyle = _ref2.containerStyle, containerStyle = _ref2$containerStyle === void 0 ? {
        float: "left",
        paddingRight: "10px"
    } : _ref2$containerStyle, _ref2$numberStyle = _ref2.numberStyle, numberStyle = _ref2$numberStyle === void 0 ? {} : _ref2$numberStyle, startingLineNumber = _ref2.startingLineNumber;
    return (0, _reactDefault.default).createElement("code", {
        style: Object.assign({}, codeStyle, containerStyle)
    }, getAllLineNumbers({
        lines: codeString.replace(/\n$/, "").split(`
`),
        style: numberStyle,
        startingLineNumber
    }));
}
function getEmWidthOfNumber(num) {
    return "".concat(num.toString().length, ".25em");
}
function getInlineLineNumber(lineNumber, inlineLineNumberStyle) {
    return {
        type: "element",
        tagName: "span",
        properties: {
            key: "line-number--".concat(lineNumber),
            className: [
                "comment",
                "linenumber",
                "react-syntax-highlighter-line-number"
            ],
            style: inlineLineNumberStyle
        },
        children: [
            {
                type: "text",
                value: lineNumber
            }
        ]
    };
}
function assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber) {
    var defaultLineNumberStyle = {
        display: "inline-block",
        minWidth: getEmWidthOfNumber(largestLineNumber),
        paddingRight: "1em",
        textAlign: "right",
        userSelect: "none"
    }, customLineNumberStyle = typeof lineNumberStyle == "function" ? lineNumberStyle(lineNumber) : lineNumberStyle, assembledStyle = _objectSpread2(_objectSpread2({}, defaultLineNumberStyle), customLineNumberStyle);
    return assembledStyle;
}
function createLineElement(_ref3) {
    var children = _ref3.children, lineNumber = _ref3.lineNumber, lineNumberStyle = _ref3.lineNumberStyle, largestLineNumber = _ref3.largestLineNumber, showInlineLineNumbers = _ref3.showInlineLineNumbers, _ref3$lineProps = _ref3.lineProps, lineProps = _ref3$lineProps === void 0 ? {} : _ref3$lineProps, _ref3$className = _ref3.className, className = _ref3$className === void 0 ? [] : _ref3$className, showLineNumbers = _ref3.showLineNumbers, wrapLongLines = _ref3.wrapLongLines, properties = typeof lineProps == "function" ? lineProps(lineNumber) : lineProps;
    if (properties.className = className, lineNumber && showInlineLineNumbers) {
        var inlineLineNumberStyle = assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber);
        children.unshift(getInlineLineNumber(lineNumber, inlineLineNumberStyle));
    }
    return wrapLongLines & showLineNumbers && (properties.style = _objectSpread2(_objectSpread2({}, properties.style), {}, {
        display: "flex"
    })), {
        type: "element",
        tagName: "span",
        properties,
        children
    };
}
function flattenCodeTree(tree) {
    for(var className = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], newTree = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], i = 0; i < tree.length; i++){
        var node = tree[i];
        if (node.type === "text") newTree.push(createLineElement({
            children: [
                node
            ],
            className: _toConsumableArray(new Set(className))
        }));
        else if (node.children) {
            var classNames = className.concat(node.properties.className);
            flattenCodeTree(node.children, classNames).forEach(function(i2) {
                return newTree.push(i2);
            });
        }
    }
    return newTree;
}
function processLines(codeTree, wrapLines, lineProps, showLineNumbers, showInlineLineNumbers, startingLineNumber, largestLineNumber, lineNumberStyle, wrapLongLines) {
    var _ref4, tree = flattenCodeTree(codeTree.value), newTree = [], lastLineBreakIndex = -1, index = 0;
    function createWrappedLine(children2, lineNumber2) {
        var className = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
        return createLineElement({
            children: children2,
            lineNumber: lineNumber2,
            lineNumberStyle,
            largestLineNumber,
            showInlineLineNumbers,
            lineProps,
            className,
            showLineNumbers,
            wrapLongLines
        });
    }
    function createUnwrappedLine(children2, lineNumber2) {
        if (showLineNumbers && lineNumber2 && showInlineLineNumbers) {
            var inlineLineNumberStyle = assembleLineNumberStyles(lineNumberStyle, lineNumber2, largestLineNumber);
            children2.unshift(getInlineLineNumber(lineNumber2, inlineLineNumberStyle));
        }
        return children2;
    }
    function createLine(children2, lineNumber2) {
        var className = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
        return wrapLines || className.length > 0 ? createWrappedLine(children2, lineNumber2, className) : createUnwrappedLine(children2, lineNumber2);
    }
    for(var _loop = function() {
        var node = tree[index], value = node.children[0].value, newLines = getNewLines(value);
        if (newLines) {
            var splitValue = value.split(`
`);
            splitValue.forEach(function(text, i) {
                var lineNumber2 = showLineNumbers && newTree.length + startingLineNumber, newChild = {
                    type: "text",
                    value: "".concat(text, `
`)
                };
                if (i === 0) {
                    var _children = tree.slice(lastLineBreakIndex + 1, index).concat(createLineElement({
                        children: [
                            newChild
                        ],
                        className: node.properties.className
                    })), _line = createLine(_children, lineNumber2);
                    newTree.push(_line);
                } else if (i === splitValue.length - 1) {
                    var stringChild = tree[index + 1] && tree[index + 1].children && tree[index + 1].children[0], lastLineInPreviousSpan = {
                        type: "text",
                        value: "".concat(text)
                    };
                    if (stringChild) {
                        var newElem = createLineElement({
                            children: [
                                lastLineInPreviousSpan
                            ],
                            className: node.properties.className
                        });
                        tree.splice(index + 1, 0, newElem);
                    } else {
                        var _children2 = [
                            lastLineInPreviousSpan
                        ], _line2 = createLine(_children2, lineNumber2, node.properties.className);
                        newTree.push(_line2);
                    }
                } else {
                    var _children3 = [
                        newChild
                    ], _line3 = createLine(_children3, lineNumber2, node.properties.className);
                    newTree.push(_line3);
                }
            }), lastLineBreakIndex = index;
        }
        index++;
    }; index < tree.length;)_loop();
    if (lastLineBreakIndex !== tree.length - 1) {
        var children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            var lineNumber = showLineNumbers && newTree.length + startingLineNumber, line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    return wrapLines ? newTree : (_ref4 = []).concat.apply(_ref4, newTree);
}
function defaultRenderer(_ref5) {
    var rows = _ref5.rows, stylesheet = _ref5.stylesheet, useInlineStyles = _ref5.useInlineStyles;
    return rows.map(function(node, i) {
        return createElement({
            node,
            stylesheet,
            useInlineStyles,
            key: "code-segement".concat(i)
        });
    });
}
function isHighlightJs(astGenerator) {
    return astGenerator && typeof astGenerator.highlightAuto < "u";
}
function getCodeTree(_ref6) {
    var astGenerator = _ref6.astGenerator, language = _ref6.language, code = _ref6.code, defaultCodeValue = _ref6.defaultCodeValue;
    if (isHighlightJs(astGenerator)) {
        var hasLanguage = checkForListedLanguage_default(astGenerator, language);
        return language === "text" ? {
            value: defaultCodeValue,
            language: "text"
        } : hasLanguage ? astGenerator.highlight(language, code) : astGenerator.highlightAuto(code);
    }
    try {
        return language && language !== "text" ? {
            value: astGenerator.highlight(code, language)
        } : {
            value: defaultCodeValue
        };
    } catch  {
        return {
            value: defaultCodeValue
        };
    }
}
function highlight_default(defaultAstGenerator, defaultStyle) {
    return function(_ref7) {
        var language = _ref7.language, children = _ref7.children, _ref7$style = _ref7.style, style = _ref7$style === void 0 ? defaultStyle : _ref7$style, _ref7$customStyle = _ref7.customStyle, customStyle = _ref7$customStyle === void 0 ? {} : _ref7$customStyle, _ref7$codeTagProps = _ref7.codeTagProps, codeTagProps = _ref7$codeTagProps === void 0 ? {
            className: language ? "language-".concat(language) : void 0,
            style: _objectSpread2(_objectSpread2({}, style['code[class*="language-"]']), style['code[class*="language-'.concat(language, '"]')])
        } : _ref7$codeTagProps, _ref7$useInlineStyles = _ref7.useInlineStyles, useInlineStyles = _ref7$useInlineStyles === void 0 ? !0 : _ref7$useInlineStyles, _ref7$showLineNumbers = _ref7.showLineNumbers, showLineNumbers = _ref7$showLineNumbers === void 0 ? !1 : _ref7$showLineNumbers, _ref7$showInlineLineN = _ref7.showInlineLineNumbers, showInlineLineNumbers = _ref7$showInlineLineN === void 0 ? !0 : _ref7$showInlineLineN, _ref7$startingLineNum = _ref7.startingLineNumber, startingLineNumber = _ref7$startingLineNum === void 0 ? 1 : _ref7$startingLineNum, lineNumberContainerStyle = _ref7.lineNumberContainerStyle, _ref7$lineNumberStyle = _ref7.lineNumberStyle, lineNumberStyle = _ref7$lineNumberStyle === void 0 ? {} : _ref7$lineNumberStyle, wrapLines = _ref7.wrapLines, _ref7$wrapLongLines = _ref7.wrapLongLines, wrapLongLines = _ref7$wrapLongLines === void 0 ? !1 : _ref7$wrapLongLines, _ref7$lineProps = _ref7.lineProps, lineProps = _ref7$lineProps === void 0 ? {} : _ref7$lineProps, renderer = _ref7.renderer, _ref7$PreTag = _ref7.PreTag, PreTag = _ref7$PreTag === void 0 ? "pre" : _ref7$PreTag, _ref7$CodeTag = _ref7.CodeTag, CodeTag = _ref7$CodeTag === void 0 ? "code" : _ref7$CodeTag, _ref7$code = _ref7.code, code = _ref7$code === void 0 ? (Array.isArray(children) ? children[0] : children) || "" : _ref7$code, astGenerator = _ref7.astGenerator, rest = _objectWithoutProperties(_ref7, _excluded);
        astGenerator = astGenerator || defaultAstGenerator;
        var allLineNumbers = showLineNumbers ? (0, _reactDefault.default).createElement(AllLineNumbers, {
            containerStyle: lineNumberContainerStyle,
            codeStyle: codeTagProps.style || {},
            numberStyle: lineNumberStyle,
            startingLineNumber,
            codeString: code
        }) : null, defaultPreStyle = style.hljs || style['pre[class*="language-"]'] || {
            backgroundColor: "#fff"
        }, generatorClassName = isHighlightJs(astGenerator) ? "hljs" : "prismjs", preProps = useInlineStyles ? Object.assign({}, rest, {
            style: Object.assign({}, defaultPreStyle, customStyle)
        }) : Object.assign({}, rest, {
            className: rest.className ? "".concat(generatorClassName, " ").concat(rest.className) : generatorClassName,
            style: Object.assign({}, customStyle)
        });
        if (wrapLongLines ? codeTagProps.style = _objectSpread2(_objectSpread2({}, codeTagProps.style), {}, {
            whiteSpace: "pre-wrap"
        }) : codeTagProps.style = _objectSpread2(_objectSpread2({}, codeTagProps.style), {}, {
            whiteSpace: "pre"
        }), !astGenerator) return (0, _reactDefault.default).createElement(PreTag, preProps, allLineNumbers, (0, _reactDefault.default).createElement(CodeTag, codeTagProps, code));
        (wrapLines === void 0 && renderer || wrapLongLines) && (wrapLines = !0), renderer = renderer || defaultRenderer;
        var defaultCodeValue = [
            {
                type: "text",
                value: code
            }
        ], codeTree = getCodeTree({
            astGenerator,
            language,
            code,
            defaultCodeValue
        });
        codeTree.language === null && (codeTree.value = defaultCodeValue);
        var largestLineNumber = codeTree.value.length + startingLineNumber, rows = processLines(codeTree, wrapLines, lineProps, showLineNumbers, showInlineLineNumbers, startingLineNumber, largestLineNumber, lineNumberStyle, wrapLongLines);
        return (0, _reactDefault.default).createElement(PreTag, preProps, (0, _reactDefault.default).createElement(CodeTag, codeTagProps, !showInlineLineNumbers && allLineNumbers, renderer({
            rows,
            stylesheet: style,
            useInlineStyles
        })));
    };
}
var import_core = (0, _chunkJRLSWQMAMjs.__toESM)((0, _chunkBNQCH2A2Mjs.require_core)()), SyntaxHighlighter = highlight_default(import_core.default, {});
SyntaxHighlighter.registerLanguage = function(_, language) {
    return import_core.default.register(language);
};
SyntaxHighlighter.alias = function(name, aliases) {
    return import_core.default.alias(name, aliases);
};
var prism_light_default = SyntaxHighlighter;
var Container = (0, _theming.styled).div(({ theme })=>({
        position: "absolute",
        bottom: 0,
        right: 0,
        maxWidth: "100%",
        display: "flex",
        background: theme.background.content,
        zIndex: 1
    })), ActionButton = (0, _theming.styled).button(({ theme })=>({
        margin: 0,
        border: "0 none",
        padding: "4px 10px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        color: theme.color.defaultText,
        background: theme.background.content,
        fontSize: 12,
        lineHeight: "16px",
        fontFamily: theme.typography.fonts.base,
        fontWeight: theme.typography.weight.bold,
        borderTop: `1px solid ${theme.appBorderColor}`,
        borderLeft: `1px solid ${theme.appBorderColor}`,
        marginLeft: -1,
        borderRadius: "4px 0 0 0",
        "&:not(:last-child)": {
            borderRight: `1px solid ${theme.appBorderColor}`
        },
        "& + *": {
            borderLeft: `1px solid ${theme.appBorderColor}`,
            borderRadius: 0
        },
        "&:focus": {
            boxShadow: `${theme.color.secondary} 0 -3px 0 0 inset`,
            outline: "0 none"
        }
    }), ({ disabled })=>disabled && {
        cursor: "not-allowed",
        opacity: .5
    });
ActionButton.displayName = "ActionButton";
var ActionBar = ({ actionItems, ...props })=>(0, _reactDefault.default).createElement(Container, {
        ...props
    }, actionItems.map(({ title, className, onClick, disabled }, index)=>(0, _reactDefault.default).createElement(ActionButton, {
            key: index,
            className,
            onClick,
            disabled
        }, title)));
function _extends2() {
    return _extends2 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
        }
        return target;
    }, _extends2.apply(this, arguments);
}
function _extends3() {
    return _extends3 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
        }
        return target;
    }, _extends3.apply(this, arguments);
}
function _extends4() {
    return _extends4 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
        }
        return target;
    }, _extends4.apply(this, arguments);
}
function $6ed0406888f73fc4$var$setRef(ref, value) {
    typeof ref == "function" ? ref(value) : ref != null && (ref.current = value);
}
function $6ed0406888f73fc4$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$6ed0406888f73fc4$var$setRef(ref, node));
}
function $6ed0406888f73fc4$export$c7b2cbe3552a0d05(...refs) {
    return (0, _react.useCallback)($6ed0406888f73fc4$export$43e446d32b3d21af(...refs), refs);
}
var $5e63c961fc1ce211$export$8c6ed5c666ac1360 = (0, _react.forwardRef)((props, forwardedRef)=>{
    let { children, ...slotProps } = props, childrenArray = (0, _react.Children).toArray(children), slottable = childrenArray.find($5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        let newElement = slottable.props.children, newChildren = childrenArray.map((child)=>child === slottable ? (0, _react.Children).count(newElement) > 1 ? (0, _react.Children).only(null) : (0, _react.isValidElement)(newElement) ? newElement.props.children : null : child);
        return (0, _react.createElement)($5e63c961fc1ce211$var$SlotClone, _extends4({}, slotProps, {
            ref: forwardedRef
        }), (0, _react.isValidElement)(newElement) ? (0, _react.cloneElement)(newElement, void 0, newChildren) : null);
    }
    return (0, _react.createElement)($5e63c961fc1ce211$var$SlotClone, _extends4({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$5e63c961fc1ce211$export$8c6ed5c666ac1360.displayName = "Slot";
var $5e63c961fc1ce211$var$SlotClone = (0, _react.forwardRef)((props, forwardedRef)=>{
    let { children, ...slotProps } = props;
    return (0, _react.isValidElement)(children) ? (0, _react.cloneElement)(children, {
        ...$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? $6ed0406888f73fc4$export$43e446d32b3d21af(forwardedRef, children.ref) : children.ref
    }) : (0, _react.Children).count(children) > 1 ? (0, _react.Children).only(null) : null;
});
$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
var $5e63c961fc1ce211$export$d9f1ccf0bdb05d45 = ({ children })=>(0, _react.createElement)((0, _react.Fragment), null, children);
function $5e63c961fc1ce211$var$isSlottable(child) {
    return (0, _react.isValidElement)(child) && child.type === $5e63c961fc1ce211$export$d9f1ccf0bdb05d45;
}
function $5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    let overrideProps = {
        ...childProps
    };
    for(let propName in childProps){
        let slotPropValue = slotProps[propName], childPropValue = childProps[propName];
        /^on[A-Z]/.test(propName) ? slotPropValue && childPropValue ? overrideProps[propName] = (...args)=>{
            childPropValue(...args), slotPropValue(...args);
        } : slotPropValue && (overrideProps[propName] = slotPropValue) : propName === "style" ? overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        } : propName === "className" && (overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" "));
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
var $8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
], $8927f6f2acc4f386$export$250ffa63cdc0d034 = $8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    let Node = (0, _react.forwardRef)((props, forwardedRef)=>{
        let { asChild, ...primitiveProps } = props, Comp = asChild ? $5e63c961fc1ce211$export$8c6ed5c666ac1360 : node;
        return (0, _react.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = !0;
        }, []), (0, _react.createElement)(Comp, _extends3({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    return Node.displayName = `Primitive.${node}`, {
        ...primitive,
        [node]: Node
    };
}, {});
var $9f79659886946c16$export$e5c5a5f917a5871c = globalThis?.document ? (0, _react.useLayoutEffect) : ()=>{};
function $fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, _react.useReducer)((state, event)=>{
        let nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
var $921a889cee6df7e8$export$99c2b779aa4e8b8b = (props)=>{
    let { present, children } = props, presence = $921a889cee6df7e8$var$usePresence(present), child = typeof children == "function" ? children({
        present: presence.isPresent
    }) : (0, _react.Children).only(children), ref = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(presence.ref, child.ref);
    return typeof children == "function" || presence.isPresent ? (0, _react.cloneElement)(child, {
        ref
    }) : null;
};
$921a889cee6df7e8$export$99c2b779aa4e8b8b.displayName = "Presence";
function $921a889cee6df7e8$var$usePresence(present) {
    let [node1, setNode] = (0, _react.useState)(), stylesRef = (0, _react.useRef)({}), prevPresentRef = (0, _react.useRef)(present), prevAnimationNameRef = (0, _react.useRef)("none"), initialState = present ? "mounted" : "unmounted", [state, send] = $fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    return (0, _react.useEffect)(()=>{
        let currentAnimationName = $921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]), $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        let styles = stylesRef.current, wasPresent = prevPresentRef.current;
        if (wasPresent !== present) {
            let prevAnimationName = prevAnimationNameRef.current, currentAnimationName = $921a889cee6df7e8$var$getAnimationName(styles);
            present ? send("MOUNT") : currentAnimationName === "none" || styles?.display === "none" ? send("UNMOUNT") : send(wasPresent && prevAnimationName !== currentAnimationName ? "ANIMATION_OUT" : "UNMOUNT"), prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]), $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        if (node1) {
            let handleAnimationEnd = (event)=>{
                let isCurrentAnimation = $921a889cee6df7e8$var$getAnimationName(stylesRef.current).includes(event.animationName);
                event.target === node1 && isCurrentAnimation && (0, _reactDom.flushSync)(()=>send("ANIMATION_END"));
            }, handleAnimationStart = (event)=>{
                event.target === node1 && (prevAnimationNameRef.current = $921a889cee6df7e8$var$getAnimationName(stylesRef.current));
            };
            return node1.addEventListener("animationstart", handleAnimationStart), node1.addEventListener("animationcancel", handleAnimationEnd), node1.addEventListener("animationend", handleAnimationEnd), ()=>{
                node1.removeEventListener("animationstart", handleAnimationStart), node1.removeEventListener("animationcancel", handleAnimationEnd), node1.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node1,
        send
    ]), {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: (0, _react.useCallback)((node)=>{
            node && (stylesRef.current = getComputedStyle(node)), setNode(node);
        }, [])
    };
}
function $921a889cee6df7e8$var$getAnimationName(styles) {
    return styles?.animationName || "none";
}
function $c512c27ab02ef895$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        let BaseContext = (0, _react.createContext)(defaultContext), index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            let { scope, children, ...context } = props, Context = scope?.[scopeName][index] || BaseContext, value = (0, _react.useMemo)(()=>context, Object.values(context));
            return (0, _react.createElement)(Context.Provider, {
                value
            }, children);
        }
        function useContext$1(consumerName, scope) {
            let Context = scope?.[scopeName][index] || BaseContext, context = (0, _react.useContext)(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        return Provider.displayName = rootComponentName + "Provider", [
            Provider,
            useContext$1
        ];
    }
    let createScope = ()=>{
        let scopeContexts = defaultContexts.map((defaultContext)=>(0, _react.createContext)(defaultContext));
        return function(scope) {
            let contexts = scope?.[scopeName] || scopeContexts;
            return (0, _react.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    return createScope.scopeName = scopeName, [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $c512c27ab02ef895$var$composeContextScopes(...scopes) {
    let baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    let createScope1 = ()=>{
        let scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function(overrideScopes) {
            let nextScopes1 = scopeHooks.reduce((nextScopes, { useScope, scopeName })=>{
                let currentScope = useScope(overrideScopes)[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, _react.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    return createScope1.scopeName = baseScope.scopeName, createScope1;
}
function $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback) {
    let callbackRef = (0, _react.useRef)(callback);
    return (0, _react.useEffect)(()=>{
        callbackRef.current = callback;
    }), (0, _react.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}
var $f631663db3294ace$var$DirectionContext = (0, _react.createContext)(void 0);
function $f631663db3294ace$export$b39126d51d94e6f3(localDir) {
    let globalDir = (0, _react.useContext)($f631663db3294ace$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
function $ae6933e535247d3d$export$7d15b64cf5a3a4c4(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}
function $e42e1063c40fb3ef$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented = !0 } = {}) {
    return function(event) {
        if (originalEventHandler?.(event), checkForDefaultPrevented === !1 || !event.defaultPrevented) return ourEventHandler?.(event);
    };
}
function $6c2e24571c90391f$export$3e6543de14f8614f(initialState, machine) {
    return (0, _react.useReducer)((state, event)=>{
        let nextState = machine[state][event];
        return nextState ?? state;
    }, initialState);
}
var $57acba87d6e25586$var$SCROLL_AREA_NAME = "ScrollArea", [$57acba87d6e25586$var$createScrollAreaContext, $57acba87d6e25586$export$488468afe3a6f2b1] = $c512c27ab02ef895$export$50c7b4e9d9f19c1($57acba87d6e25586$var$SCROLL_AREA_NAME), [$57acba87d6e25586$var$ScrollAreaProvider, $57acba87d6e25586$var$useScrollAreaContext] = $57acba87d6e25586$var$createScrollAreaContext($57acba87d6e25586$var$SCROLL_AREA_NAME), $57acba87d6e25586$export$ccf8d8d7bbf3c2cc = (0, _react.forwardRef)((props, forwardedRef)=>{
    let { __scopeScrollArea, type = "hover", dir, scrollHideDelay = 600, ...scrollAreaProps } = props, [scrollArea, setScrollArea] = (0, _react.useState)(null), [viewport, setViewport] = (0, _react.useState)(null), [content, setContent] = (0, _react.useState)(null), [scrollbarX, setScrollbarX] = (0, _react.useState)(null), [scrollbarY, setScrollbarY] = (0, _react.useState)(null), [cornerWidth, setCornerWidth] = (0, _react.useState)(0), [cornerHeight, setCornerHeight] = (0, _react.useState)(0), [scrollbarXEnabled, setScrollbarXEnabled] = (0, _react.useState)(!1), [scrollbarYEnabled, setScrollbarYEnabled] = (0, _react.useState)(!1), composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>setScrollArea(node)), direction = $f631663db3294ace$export$b39126d51d94e6f3(dir);
    return (0, _react.createElement)($57acba87d6e25586$var$ScrollAreaProvider, {
        scope: __scopeScrollArea,
        type,
        dir: direction,
        scrollHideDelay,
        scrollArea,
        viewport,
        onViewportChange: setViewport,
        content,
        onContentChange: setContent,
        scrollbarX,
        onScrollbarXChange: setScrollbarX,
        scrollbarXEnabled,
        onScrollbarXEnabledChange: setScrollbarXEnabled,
        scrollbarY,
        onScrollbarYChange: setScrollbarY,
        scrollbarYEnabled,
        onScrollbarYEnabledChange: setScrollbarYEnabled,
        onCornerWidthChange: setCornerWidth,
        onCornerHeightChange: setCornerHeight
    }, (0, _react.createElement)($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends2({
        dir: direction
    }, scrollAreaProps, {
        ref: composedRefs,
        style: {
            position: "relative",
            "--radix-scroll-area-corner-width": cornerWidth + "px",
            "--radix-scroll-area-corner-height": cornerHeight + "px",
            ...props.style
        }
    })));
}), $57acba87d6e25586$var$VIEWPORT_NAME = "ScrollAreaViewport", $57acba87d6e25586$export$a21cbf9f11fca853 = (0, _react.forwardRef)((props, forwardedRef)=>{
    let { __scopeScrollArea, children, ...viewportProps } = props, context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$VIEWPORT_NAME, __scopeScrollArea), ref = (0, _react.useRef)(null), composedRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref, context.onViewportChange);
    return (0, _react.createElement)((0, _react.Fragment), null, (0, _react.createElement)("style", {
        dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
        }
    }), (0, _react.createElement)($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends2({
        "data-radix-scroll-area-viewport": ""
    }, viewportProps, {
        ref: composedRefs,
        style: {
            overflowX: context.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: context.scrollbarYEnabled ? "scroll" : "hidden",
            ...props.style
        }
    }), (0, _react.createElement)("div", {
        ref: context.onContentChange,
        style: {
            minWidth: "100%",
            display: "table"
        }
    }, children)));
}), $57acba87d6e25586$var$SCROLLBAR_NAME = "ScrollAreaScrollbar", $57acba87d6e25586$export$2fabd85d0eba3c57 = (0, _react.forwardRef)((props, forwardedRef)=>{
    let { forceMount, ...scrollbarProps } = props, context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea), { onScrollbarXEnabledChange, onScrollbarYEnabledChange } = context, isHorizontal = props.orientation === "horizontal";
    return (0, _react.useEffect)(()=>(isHorizontal ? onScrollbarXEnabledChange(!0) : onScrollbarYEnabledChange(!0), ()=>{
            isHorizontal ? onScrollbarXEnabledChange(!1) : onScrollbarYEnabledChange(!1);
        }), [
        isHorizontal,
        onScrollbarXEnabledChange,
        onScrollbarYEnabledChange
    ]), context.type === "hover" ? (0, _react.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarHover, _extends2({}, scrollbarProps, {
        ref: forwardedRef,
        forceMount
    })) : context.type === "scroll" ? (0, _react.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarScroll, _extends2({}, scrollbarProps, {
        ref: forwardedRef,
        forceMount
    })) : context.type === "auto" ? (0, _react.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarAuto, _extends2({}, scrollbarProps, {
        ref: forwardedRef,
        forceMount
    })) : context.type === "always" ? (0, _react.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarVisible, _extends2({}, scrollbarProps, {
        ref: forwardedRef
    })) : null;
}), $57acba87d6e25586$var$ScrollAreaScrollbarHover = (0, _react.forwardRef)((props, forwardedRef)=>{
    let { forceMount, ...scrollbarProps } = props, context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea), [visible, setVisible] = (0, _react.useState)(!1);
    return (0, _react.useEffect)(()=>{
        let scrollArea = context.scrollArea, hideTimer = 0;
        if (scrollArea) {
            let handlePointerEnter = ()=>{
                window.clearTimeout(hideTimer), setVisible(!0);
            }, handlePointerLeave = ()=>{
                hideTimer = window.setTimeout(()=>setVisible(!1), context.scrollHideDelay);
            };
            return scrollArea.addEventListener("pointerenter", handlePointerEnter), scrollArea.addEventListener("pointerleave", handlePointerLeave), ()=>{
                window.clearTimeout(hideTimer), scrollArea.removeEventListener("pointerenter", handlePointerEnter), scrollArea.removeEventListener("pointerleave", handlePointerLeave);
            };
        }
    }, [
        context.scrollArea,
        context.scrollHideDelay
    ]), (0, _react.createElement)($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || visible
    }, (0, _react.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarAuto, _extends2({
        "data-state": visible ? "visible" : "hidden"
    }, scrollbarProps, {
        ref: forwardedRef
    })));
}), $57acba87d6e25586$var$ScrollAreaScrollbarScroll = (0, _react.forwardRef)((props, forwardedRef)=>{
    let { forceMount, ...scrollbarProps } = props, context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea), isHorizontal = props.orientation === "horizontal", debounceScrollEnd = $57acba87d6e25586$var$useDebounceCallback(()=>send("SCROLL_END"), 100), [state, send] = $6c2e24571c90391f$export$3e6543de14f8614f("hidden", {
        hidden: {
            SCROLL: "scrolling"
        },
        scrolling: {
            SCROLL_END: "idle",
            POINTER_ENTER: "interacting"
        },
        interacting: {
            SCROLL: "interacting",
            POINTER_LEAVE: "idle"
        },
        idle: {
            HIDE: "hidden",
            SCROLL: "scrolling",
            POINTER_ENTER: "interacting"
        }
    });
    return (0, _react.useEffect)(()=>{
        if (state === "idle") {
            let hideTimer = window.setTimeout(()=>send("HIDE"), context.scrollHideDelay);
            return ()=>window.clearTimeout(hideTimer);
        }
    }, [
        state,
        context.scrollHideDelay,
        send
    ]), (0, _react.useEffect)(()=>{
        let viewport = context.viewport, scrollDirection = isHorizontal ? "scrollLeft" : "scrollTop";
        if (viewport) {
            let prevScrollPos = viewport[scrollDirection], handleScroll = ()=>{
                let scrollPos = viewport[scrollDirection];
                prevScrollPos !== scrollPos && (send("SCROLL"), debounceScrollEnd()), prevScrollPos = scrollPos;
            };
            return viewport.addEventListener("scroll", handleScroll), ()=>viewport.removeEventListener("scroll", handleScroll);
        }
    }, [
        context.viewport,
        isHorizontal,
        send,
        debounceScrollEnd
    ]), (0, _react.createElement)($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || state !== "hidden"
    }, (0, _react.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarVisible, _extends2({
        "data-state": state === "hidden" ? "hidden" : "visible"
    }, scrollbarProps, {
        ref: forwardedRef,
        onPointerEnter: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerEnter, ()=>send("POINTER_ENTER")),
        onPointerLeave: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerLeave, ()=>send("POINTER_LEAVE"))
    })));
}), $57acba87d6e25586$var$ScrollAreaScrollbarAuto = (0, _react.forwardRef)((props, forwardedRef)=>{
    let context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea), { forceMount, ...scrollbarProps } = props, [visible, setVisible] = (0, _react.useState)(!1), isHorizontal = props.orientation === "horizontal", handleResize = $57acba87d6e25586$var$useDebounceCallback(()=>{
        if (context.viewport) {
            let isOverflowX = context.viewport.offsetWidth < context.viewport.scrollWidth, isOverflowY = context.viewport.offsetHeight < context.viewport.scrollHeight;
            setVisible(isHorizontal ? isOverflowX : isOverflowY);
        }
    }, 10);
    return $57acba87d6e25586$var$useResizeObserver(context.viewport, handleResize), $57acba87d6e25586$var$useResizeObserver(context.content, handleResize), (0, _react.createElement)($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || visible
    }, (0, _react.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarVisible, _extends2({
        "data-state": visible ? "visible" : "hidden"
    }, scrollbarProps, {
        ref: forwardedRef
    })));
}), $57acba87d6e25586$var$ScrollAreaScrollbarVisible = (0, _react.forwardRef)((props, forwardedRef)=>{
    let { orientation = "vertical", ...scrollbarProps } = props, context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea), thumbRef = (0, _react.useRef)(null), pointerOffsetRef = (0, _react.useRef)(0), [sizes, setSizes] = (0, _react.useState)({
        content: 0,
        viewport: 0,
        scrollbar: {
            size: 0,
            paddingStart: 0,
            paddingEnd: 0
        }
    }), thumbRatio = $57acba87d6e25586$var$getThumbRatio(sizes.viewport, sizes.content), commonProps = {
        ...scrollbarProps,
        sizes,
        onSizesChange: setSizes,
        hasThumb: thumbRatio > 0 && thumbRatio < 1,
        onThumbChange: (thumb)=>thumbRef.current = thumb,
        onThumbPointerUp: ()=>pointerOffsetRef.current = 0,
        onThumbPointerDown: (pointerPos)=>pointerOffsetRef.current = pointerPos
    };
    function getScrollPosition(pointerPos, dir) {
        return $57acba87d6e25586$var$getScrollPositionFromPointer(pointerPos, pointerOffsetRef.current, sizes, dir);
    }
    return orientation === "horizontal" ? (0, _react.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarX, _extends2({}, commonProps, {
        ref: forwardedRef,
        onThumbPositionChange: ()=>{
            if (context.viewport && thumbRef.current) {
                let scrollPos = context.viewport.scrollLeft, offset = $57acba87d6e25586$var$getThumbOffsetFromScroll(scrollPos, sizes, context.dir);
                thumbRef.current.style.transform = `translate3d(${offset}px, 0, 0)`;
            }
        },
        onWheelScroll: (scrollPos)=>{
            context.viewport && (context.viewport.scrollLeft = scrollPos);
        },
        onDragScroll: (pointerPos)=>{
            context.viewport && (context.viewport.scrollLeft = getScrollPosition(pointerPos, context.dir));
        }
    })) : orientation === "vertical" ? (0, _react.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarY, _extends2({}, commonProps, {
        ref: forwardedRef,
        onThumbPositionChange: ()=>{
            if (context.viewport && thumbRef.current) {
                let scrollPos = context.viewport.scrollTop, offset = $57acba87d6e25586$var$getThumbOffsetFromScroll(scrollPos, sizes);
                thumbRef.current.style.transform = `translate3d(0, ${offset}px, 0)`;
            }
        },
        onWheelScroll: (scrollPos)=>{
            context.viewport && (context.viewport.scrollTop = scrollPos);
        },
        onDragScroll: (pointerPos)=>{
            context.viewport && (context.viewport.scrollTop = getScrollPosition(pointerPos));
        }
    })) : null;
}), $57acba87d6e25586$var$ScrollAreaScrollbarX = (0, _react.forwardRef)((props, forwardedRef)=>{
    let { sizes, onSizesChange, ...scrollbarProps } = props, context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea), [computedStyle, setComputedStyle] = (0, _react.useState)(), ref = (0, _react.useRef)(null), composeRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref, context.onScrollbarXChange);
    return (0, _react.useEffect)(()=>{
        ref.current && setComputedStyle(getComputedStyle(ref.current));
    }, [
        ref
    ]), (0, _react.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarImpl, _extends2({
        "data-orientation": "horizontal"
    }, scrollbarProps, {
        ref: composeRefs,
        sizes,
        style: {
            bottom: 0,
            left: context.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
            right: context.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
            "--radix-scroll-area-thumb-width": $57acba87d6e25586$var$getThumbSize(sizes) + "px",
            ...props.style
        },
        onThumbPointerDown: (pointerPos)=>props.onThumbPointerDown(pointerPos.x),
        onDragScroll: (pointerPos)=>props.onDragScroll(pointerPos.x),
        onWheelScroll: (event, maxScrollPos)=>{
            if (context.viewport) {
                let scrollPos = context.viewport.scrollLeft + event.deltaX;
                props.onWheelScroll(scrollPos), $57acba87d6e25586$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos) && event.preventDefault();
            }
        },
        onResize: ()=>{
            ref.current && context.viewport && computedStyle && onSizesChange({
                content: context.viewport.scrollWidth,
                viewport: context.viewport.offsetWidth,
                scrollbar: {
                    size: ref.current.clientWidth,
                    paddingStart: $57acba87d6e25586$var$toInt(computedStyle.paddingLeft),
                    paddingEnd: $57acba87d6e25586$var$toInt(computedStyle.paddingRight)
                }
            });
        }
    }));
}), $57acba87d6e25586$var$ScrollAreaScrollbarY = (0, _react.forwardRef)((props, forwardedRef)=>{
    let { sizes, onSizesChange, ...scrollbarProps } = props, context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, props.__scopeScrollArea), [computedStyle, setComputedStyle] = (0, _react.useState)(), ref = (0, _react.useRef)(null), composeRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, ref, context.onScrollbarYChange);
    return (0, _react.useEffect)(()=>{
        ref.current && setComputedStyle(getComputedStyle(ref.current));
    }, [
        ref
    ]), (0, _react.createElement)($57acba87d6e25586$var$ScrollAreaScrollbarImpl, _extends2({
        "data-orientation": "vertical"
    }, scrollbarProps, {
        ref: composeRefs,
        sizes,
        style: {
            top: 0,
            right: context.dir === "ltr" ? 0 : void 0,
            left: context.dir === "rtl" ? 0 : void 0,
            bottom: "var(--radix-scroll-area-corner-height)",
            "--radix-scroll-area-thumb-height": $57acba87d6e25586$var$getThumbSize(sizes) + "px",
            ...props.style
        },
        onThumbPointerDown: (pointerPos)=>props.onThumbPointerDown(pointerPos.y),
        onDragScroll: (pointerPos)=>props.onDragScroll(pointerPos.y),
        onWheelScroll: (event, maxScrollPos)=>{
            if (context.viewport) {
                let scrollPos = context.viewport.scrollTop + event.deltaY;
                props.onWheelScroll(scrollPos), $57acba87d6e25586$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos) && event.preventDefault();
            }
        },
        onResize: ()=>{
            ref.current && context.viewport && computedStyle && onSizesChange({
                content: context.viewport.scrollHeight,
                viewport: context.viewport.offsetHeight,
                scrollbar: {
                    size: ref.current.clientHeight,
                    paddingStart: $57acba87d6e25586$var$toInt(computedStyle.paddingTop),
                    paddingEnd: $57acba87d6e25586$var$toInt(computedStyle.paddingBottom)
                }
            });
        }
    }));
}), [$57acba87d6e25586$var$ScrollbarProvider, $57acba87d6e25586$var$useScrollbarContext] = $57acba87d6e25586$var$createScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME), $57acba87d6e25586$var$ScrollAreaScrollbarImpl = (0, _react.forwardRef)((props, forwardedRef)=>{
    let { __scopeScrollArea, sizes, hasThumb, onThumbChange, onThumbPointerUp, onThumbPointerDown, onThumbPositionChange, onDragScroll, onWheelScroll, onResize, ...scrollbarProps } = props, context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$SCROLLBAR_NAME, __scopeScrollArea), [scrollbar, setScrollbar] = (0, _react.useState)(null), composeRefs = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>setScrollbar(node)), rectRef = (0, _react.useRef)(null), prevWebkitUserSelectRef = (0, _react.useRef)(""), viewport = context.viewport, maxScrollPos = sizes.content - sizes.viewport, handleWheelScroll = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onWheelScroll), handleThumbPositionChange = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onThumbPositionChange), handleResize = $57acba87d6e25586$var$useDebounceCallback(onResize, 10);
    function handleDragScroll(event) {
        if (rectRef.current) {
            let x = event.clientX - rectRef.current.left, y = event.clientY - rectRef.current.top;
            onDragScroll({
                x,
                y
            });
        }
    }
    return (0, _react.useEffect)(()=>{
        let handleWheel = (event)=>{
            let element = event.target;
            scrollbar?.contains(element) && handleWheelScroll(event, maxScrollPos);
        };
        return document.addEventListener("wheel", handleWheel, {
            passive: !1
        }), ()=>document.removeEventListener("wheel", handleWheel, {
                passive: !1
            });
    }, [
        viewport,
        scrollbar,
        maxScrollPos,
        handleWheelScroll
    ]), (0, _react.useEffect)(handleThumbPositionChange, [
        sizes,
        handleThumbPositionChange
    ]), $57acba87d6e25586$var$useResizeObserver(scrollbar, handleResize), $57acba87d6e25586$var$useResizeObserver(context.content, handleResize), (0, _react.createElement)($57acba87d6e25586$var$ScrollbarProvider, {
        scope: __scopeScrollArea,
        scrollbar,
        hasThumb,
        onThumbChange: $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onThumbChange),
        onThumbPointerUp: $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onThumbPointerUp),
        onThumbPositionChange: handleThumbPositionChange,
        onThumbPointerDown: $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onThumbPointerDown)
    }, (0, _react.createElement)($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends2({}, scrollbarProps, {
        ref: composeRefs,
        style: {
            position: "absolute",
            ...scrollbarProps.style
        },
        onPointerDown: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDown, (event)=>{
            event.button === 0 && (event.target.setPointerCapture(event.pointerId), rectRef.current = scrollbar.getBoundingClientRect(), prevWebkitUserSelectRef.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", context.viewport && (context.viewport.style.scrollBehavior = "auto"), handleDragScroll(event));
        }),
        onPointerMove: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerMove, handleDragScroll),
        onPointerUp: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerUp, (event)=>{
            let element = event.target;
            element.hasPointerCapture(event.pointerId) && element.releasePointerCapture(event.pointerId), document.body.style.webkitUserSelect = prevWebkitUserSelectRef.current, context.viewport && (context.viewport.style.scrollBehavior = ""), rectRef.current = null;
        })
    })));
}), $57acba87d6e25586$var$THUMB_NAME = "ScrollAreaThumb", $57acba87d6e25586$export$9fba1154677d7cd2 = (0, _react.forwardRef)((props, forwardedRef)=>{
    let { forceMount, ...thumbProps } = props, scrollbarContext = $57acba87d6e25586$var$useScrollbarContext($57acba87d6e25586$var$THUMB_NAME, props.__scopeScrollArea);
    return (0, _react.createElement)($921a889cee6df7e8$export$99c2b779aa4e8b8b, {
        present: forceMount || scrollbarContext.hasThumb
    }, (0, _react.createElement)($57acba87d6e25586$var$ScrollAreaThumbImpl, _extends2({
        ref: forwardedRef
    }, thumbProps)));
}), $57acba87d6e25586$var$ScrollAreaThumbImpl = (0, _react.forwardRef)((props, forwardedRef)=>{
    let { __scopeScrollArea, style, ...thumbProps } = props, scrollAreaContext = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$THUMB_NAME, __scopeScrollArea), scrollbarContext = $57acba87d6e25586$var$useScrollbarContext($57acba87d6e25586$var$THUMB_NAME, __scopeScrollArea), { onThumbPositionChange } = scrollbarContext, composedRef = $6ed0406888f73fc4$export$c7b2cbe3552a0d05(forwardedRef, (node)=>scrollbarContext.onThumbChange(node)), removeUnlinkedScrollListenerRef = (0, _react.useRef)(), debounceScrollEnd = $57acba87d6e25586$var$useDebounceCallback(()=>{
        removeUnlinkedScrollListenerRef.current && (removeUnlinkedScrollListenerRef.current(), removeUnlinkedScrollListenerRef.current = void 0);
    }, 100);
    return (0, _react.useEffect)(()=>{
        let viewport = scrollAreaContext.viewport;
        if (viewport) {
            let handleScroll = ()=>{
                if (debounceScrollEnd(), !removeUnlinkedScrollListenerRef.current) {
                    let listener = $57acba87d6e25586$var$addUnlinkedScrollListener(viewport, onThumbPositionChange);
                    removeUnlinkedScrollListenerRef.current = listener, onThumbPositionChange();
                }
            };
            return onThumbPositionChange(), viewport.addEventListener("scroll", handleScroll), ()=>viewport.removeEventListener("scroll", handleScroll);
        }
    }, [
        scrollAreaContext.viewport,
        debounceScrollEnd,
        onThumbPositionChange
    ]), (0, _react.createElement)($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends2({
        "data-state": scrollbarContext.hasThumb ? "visible" : "hidden"
    }, thumbProps, {
        ref: composedRef,
        style: {
            width: "var(--radix-scroll-area-thumb-width)",
            height: "var(--radix-scroll-area-thumb-height)",
            ...style
        },
        onPointerDownCapture: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerDownCapture, (event)=>{
            let thumbRect = event.target.getBoundingClientRect(), x = event.clientX - thumbRect.left, y = event.clientY - thumbRect.top;
            scrollbarContext.onThumbPointerDown({
                x,
                y
            });
        }),
        onPointerUp: $e42e1063c40fb3ef$export$b9ecd428b558ff10(props.onPointerUp, scrollbarContext.onThumbPointerUp)
    }));
}), $57acba87d6e25586$var$CORNER_NAME = "ScrollAreaCorner", $57acba87d6e25586$export$56969d565df7cc4b = (0, _react.forwardRef)((props, forwardedRef)=>{
    let context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$CORNER_NAME, props.__scopeScrollArea), hasBothScrollbarsVisible = !!(context.scrollbarX && context.scrollbarY);
    return context.type !== "scroll" && hasBothScrollbarsVisible ? (0, _react.createElement)($57acba87d6e25586$var$ScrollAreaCornerImpl, _extends2({}, props, {
        ref: forwardedRef
    })) : null;
}), $57acba87d6e25586$var$ScrollAreaCornerImpl = (0, _react.forwardRef)((props, forwardedRef)=>{
    let { __scopeScrollArea, ...cornerProps } = props, context = $57acba87d6e25586$var$useScrollAreaContext($57acba87d6e25586$var$CORNER_NAME, __scopeScrollArea), [width1, setWidth] = (0, _react.useState)(0), [height1, setHeight] = (0, _react.useState)(0), hasSize = !!(width1 && height1);
    return $57acba87d6e25586$var$useResizeObserver(context.scrollbarX, ()=>{
        var _context$scrollbarX;
        let height = ((_context$scrollbarX = context.scrollbarX) === null || _context$scrollbarX === void 0 ? void 0 : _context$scrollbarX.offsetHeight) || 0;
        context.onCornerHeightChange(height), setHeight(height);
    }), $57acba87d6e25586$var$useResizeObserver(context.scrollbarY, ()=>{
        var _context$scrollbarY;
        let width = ((_context$scrollbarY = context.scrollbarY) === null || _context$scrollbarY === void 0 ? void 0 : _context$scrollbarY.offsetWidth) || 0;
        context.onCornerWidthChange(width), setWidth(width);
    }), hasSize ? (0, _react.createElement)($8927f6f2acc4f386$export$250ffa63cdc0d034.div, _extends2({}, cornerProps, {
        ref: forwardedRef,
        style: {
            width: width1,
            height: height1,
            position: "absolute",
            right: context.dir === "ltr" ? 0 : void 0,
            left: context.dir === "rtl" ? 0 : void 0,
            bottom: 0,
            ...props.style
        }
    })) : null;
});
function $57acba87d6e25586$var$toInt(value) {
    return value ? parseInt(value, 10) : 0;
}
function $57acba87d6e25586$var$getThumbRatio(viewportSize, contentSize) {
    let ratio = viewportSize / contentSize;
    return isNaN(ratio) ? 0 : ratio;
}
function $57acba87d6e25586$var$getThumbSize(sizes) {
    let ratio = $57acba87d6e25586$var$getThumbRatio(sizes.viewport, sizes.content), scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd, thumbSize = (sizes.scrollbar.size - scrollbarPadding) * ratio;
    return Math.max(thumbSize, 18);
}
function $57acba87d6e25586$var$getScrollPositionFromPointer(pointerPos, pointerOffset, sizes, dir = "ltr") {
    let thumbSizePx = $57acba87d6e25586$var$getThumbSize(sizes), thumbCenter = thumbSizePx / 2, offset = pointerOffset || thumbCenter, thumbOffsetFromEnd = thumbSizePx - offset, minPointerPos = sizes.scrollbar.paddingStart + offset, maxPointerPos = sizes.scrollbar.size - sizes.scrollbar.paddingEnd - thumbOffsetFromEnd, maxScrollPos = sizes.content - sizes.viewport, scrollRange = dir === "ltr" ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ];
    return $57acba87d6e25586$var$linearScale([
        minPointerPos,
        maxPointerPos
    ], scrollRange)(pointerPos);
}
function $57acba87d6e25586$var$getThumbOffsetFromScroll(scrollPos, sizes, dir = "ltr") {
    let thumbSizePx = $57acba87d6e25586$var$getThumbSize(sizes), scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd, scrollbar = sizes.scrollbar.size - scrollbarPadding, maxScrollPos = sizes.content - sizes.viewport, maxThumbPos = scrollbar - thumbSizePx, scrollClampRange = dir === "ltr" ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ], scrollWithoutMomentum = $ae6933e535247d3d$export$7d15b64cf5a3a4c4(scrollPos, scrollClampRange);
    return $57acba87d6e25586$var$linearScale([
        0,
        maxScrollPos
    ], [
        0,
        maxThumbPos
    ])(scrollWithoutMomentum);
}
function $57acba87d6e25586$var$linearScale(input, output) {
    return (value)=>{
        if (input[0] === input[1] || output[0] === output[1]) return output[0];
        let ratio = (output[1] - output[0]) / (input[1] - input[0]);
        return output[0] + ratio * (value - input[0]);
    };
}
function $57acba87d6e25586$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos) {
    return scrollPos > 0 && scrollPos < maxScrollPos;
}
var $57acba87d6e25586$var$addUnlinkedScrollListener = (node, handler = ()=>{})=>{
    let prevPosition = {
        left: node.scrollLeft,
        top: node.scrollTop
    }, rAF = 0;
    return function loop() {
        let position = {
            left: node.scrollLeft,
            top: node.scrollTop
        }, isHorizontalScroll = prevPosition.left !== position.left, isVerticalScroll = prevPosition.top !== position.top;
        (isHorizontalScroll || isVerticalScroll) && handler(), prevPosition = position, rAF = window.requestAnimationFrame(loop);
    }(), ()=>window.cancelAnimationFrame(rAF);
};
function $57acba87d6e25586$var$useDebounceCallback(callback, delay) {
    let handleCallback = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(callback), debounceTimerRef = (0, _react.useRef)(0);
    return (0, _react.useEffect)(()=>()=>window.clearTimeout(debounceTimerRef.current), []), (0, _react.useCallback)(()=>{
        window.clearTimeout(debounceTimerRef.current), debounceTimerRef.current = window.setTimeout(handleCallback, delay);
    }, [
        handleCallback,
        delay
    ]);
}
function $57acba87d6e25586$var$useResizeObserver(element, onResize) {
    let handleResize = $b1b2314f5f9a1d84$export$25bec8c6f54ee79a(onResize);
    $9f79659886946c16$export$e5c5a5f917a5871c(()=>{
        let rAF = 0;
        if (element) {
            let resizeObserver = new ResizeObserver(()=>{
                cancelAnimationFrame(rAF), rAF = window.requestAnimationFrame(handleResize);
            });
            return resizeObserver.observe(element), ()=>{
                window.cancelAnimationFrame(rAF), resizeObserver.unobserve(element);
            };
        }
    }, [
        element,
        handleResize
    ]);
}
var $57acba87d6e25586$export$be92b6f5f03c0fe9 = $57acba87d6e25586$export$ccf8d8d7bbf3c2cc, $57acba87d6e25586$export$d5c6c08dc2d3ca7 = $57acba87d6e25586$export$a21cbf9f11fca853, $57acba87d6e25586$export$9a4e88b92edfce6b = $57acba87d6e25586$export$2fabd85d0eba3c57, $57acba87d6e25586$export$6521433ed15a34db = $57acba87d6e25586$export$9fba1154677d7cd2, $57acba87d6e25586$export$ac61190d9fc311a9 = $57acba87d6e25586$export$56969d565df7cc4b;
var ScrollAreaRoot = (0, _theming.styled)($57acba87d6e25586$export$be92b6f5f03c0fe9)(({ scrollbarsize, offset })=>({
        width: "100%",
        height: "100%",
        overflow: "hidden",
        "--scrollbar-size": `${scrollbarsize + offset}px`,
        "--radix-scroll-area-thumb-width": `${scrollbarsize}px`
    })), ScrollAreaViewport = (0, _theming.styled)($57acba87d6e25586$export$d5c6c08dc2d3ca7)({
    width: "100%",
    height: "100%"
}), ScrollAreaScrollbar = (0, _theming.styled)($57acba87d6e25586$export$9a4e88b92edfce6b)(({ offset, horizontal, vertical })=>({
        display: "flex",
        userSelect: "none",
        touchAction: "none",
        background: "transparent",
        transition: "all 0.2s ease-out",
        borderRadius: "var(--scrollbar-size)",
        '&[data-orientation="vertical"]': {
            width: "var(--scrollbar-size)",
            paddingRight: offset,
            marginTop: offset,
            marginBottom: horizontal === "true" && vertical === "true" ? 0 : offset
        },
        '&[data-orientation="horizontal"]': {
            flexDirection: "column",
            height: "var(--scrollbar-size)",
            paddingBottom: offset,
            marginLeft: offset,
            marginRight: horizontal === "true" && vertical === "true" ? 0 : offset
        }
    })), ScrollAreaThumb = (0, _theming.styled)($57acba87d6e25586$export$6521433ed15a34db)(({ theme })=>({
        flex: 1,
        background: theme.textMutedColor,
        opacity: .5,
        borderRadius: "var(--scrollbar-size)",
        position: "relative",
        transition: "opacity 0.2s ease-out",
        "&:hover": {
            opacity: .8
        },
        "::before": {
            content: '""',
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)",
            width: "100%",
            height: "100%",
            minWidth: 44,
            minHeight: 44
        }
    })), ScrollArea = ({ children, horizontal = !1, vertical = !1, offset = 2, scrollbarSize = 6, className })=>(0, _reactDefault.default).createElement(ScrollAreaRoot, {
        scrollbarsize: scrollbarSize,
        offset,
        className
    }, (0, _reactDefault.default).createElement(ScrollAreaViewport, null, children), horizontal && (0, _reactDefault.default).createElement(ScrollAreaScrollbar, {
        orientation: "horizontal",
        offset,
        horizontal: horizontal.toString(),
        vertical: vertical.toString()
    }, (0, _reactDefault.default).createElement(ScrollAreaThumb, null)), vertical && (0, _reactDefault.default).createElement(ScrollAreaScrollbar, {
        orientation: "vertical",
        offset,
        horizontal: horizontal.toString(),
        vertical: vertical.toString()
    }, (0, _reactDefault.default).createElement(ScrollAreaThumb, null)), horizontal && vertical && (0, _reactDefault.default).createElement($57acba87d6e25586$export$ac61190d9fc311a9, null));
var { navigator, document: document2, window: globalWindow } = (0, _global.global);
prism_light_default.registerLanguage("jsextra", js_extras_default);
prism_light_default.registerLanguage("jsx", jsx_default);
prism_light_default.registerLanguage("json", json_default);
prism_light_default.registerLanguage("yml", yaml_default);
prism_light_default.registerLanguage("md", markdown_default);
prism_light_default.registerLanguage("bash", bash_default);
prism_light_default.registerLanguage("css", css_default);
prism_light_default.registerLanguage("html", markup_default);
prism_light_default.registerLanguage("tsx", tsx_default);
prism_light_default.registerLanguage("typescript", typescript_default);
prism_light_default.registerLanguage("graphql", graphql_default);
var themedSyntax = (0, _memoizerificDefault.default)(2)((theme)=>Object.entries(theme.code || {}).reduce((acc, [key, val])=>({
            ...acc,
            [`* .${key}`]: val
        }), {})), copyToClipboard = createCopyToClipboardFunction();
function createCopyToClipboardFunction() {
    return navigator?.clipboard ? (text)=>navigator.clipboard.writeText(text) : async (text)=>{
        let tmp = document2.createElement("TEXTAREA"), focus = document2.activeElement;
        tmp.value = text, document2.body.appendChild(tmp), tmp.select(), document2.execCommand("copy"), document2.body.removeChild(tmp), focus.focus();
    };
}
var Wrapper = (0, _theming.styled).div(({ theme })=>({
        position: "relative",
        overflow: "hidden",
        color: theme.color.defaultText
    }), ({ theme, bordered })=>bordered ? {
        border: `1px solid ${theme.appBorderColor}`,
        borderRadius: theme.borderRadius,
        background: theme.background.content
    } : {}, ({ showLineNumbers })=>showLineNumbers ? {
        ".react-syntax-highlighter-line-number::before": {
            content: "attr(data-line-number)"
        }
    } : {}), UnstyledScroller = ({ children, className })=>(0, _reactDefault.default).createElement(ScrollArea, {
        horizontal: !0,
        vertical: !0,
        className
    }, children), Scroller = (0, _theming.styled)(UnstyledScroller)({
    position: "relative"
}, ({ theme })=>themedSyntax(theme)), Pre = (0, _theming.styled).pre(({ theme, padded })=>({
        display: "flex",
        justifyContent: "flex-start",
        margin: 0,
        padding: padded ? theme.layoutMargin : 0
    })), Code = (0, _theming.styled).div(({ theme })=>({
        flex: 1,
        paddingLeft: 2,
        paddingRight: theme.layoutMargin,
        opacity: 1
    })), processLineNumber = (row)=>{
    let children = [
        ...row.children
    ], lineNumberNode = children[0], lineNumber = lineNumberNode.children[0].value, processedLineNumberNode = {
        ...lineNumberNode,
        children: [],
        properties: {
            ...lineNumberNode.properties,
            "data-line-number": lineNumber,
            style: {
                ...lineNumberNode.properties.style,
                userSelect: "auto"
            }
        }
    };
    return children[0] = processedLineNumberNode, {
        ...row,
        children
    };
}, defaultRenderer2 = ({ rows, stylesheet, useInlineStyles })=>rows.map((node, i)=>createElement({
            node: processLineNumber(node),
            stylesheet,
            useInlineStyles,
            key: `code-segement${i}`
        })), wrapRenderer = (renderer, showLineNumbers)=>showLineNumbers ? renderer ? ({ rows, ...rest })=>renderer({
            rows: rows.map((row)=>processLineNumber(row)),
            ...rest
        }) : defaultRenderer2 : renderer, SyntaxHighlighter2 = ({ children, language = "jsx", copyable = !1, bordered = !1, padded = !1, format = !0, formatter = null, className = null, showLineNumbers = !1, ...rest })=>{
    if (typeof children != "string" || !children.trim()) return null;
    let highlightableCode = formatter ? formatter(format, children) : children.trim(), [copied, setCopied] = (0, _react.useState)(!1), onClick = (0, _react.useCallback)((e)=>{
        e.preventDefault(), copyToClipboard(highlightableCode).then(()=>{
            setCopied(!0), globalWindow.setTimeout(()=>setCopied(!1), 1500);
        }).catch((0, _clientLogger.logger).error);
    }, [
        highlightableCode
    ]), renderer = wrapRenderer(rest.renderer, showLineNumbers);
    return (0, _reactDefault.default).createElement(Wrapper, {
        bordered,
        padded,
        showLineNumbers,
        className
    }, (0, _reactDefault.default).createElement(Scroller, null, (0, _reactDefault.default).createElement(prism_light_default, {
        padded: padded || bordered,
        language,
        showLineNumbers,
        showInlineLineNumbers: showLineNumbers,
        useInlineStyles: !1,
        PreTag: Pre,
        CodeTag: Code,
        lineNumberContainerStyle: {},
        ...rest,
        renderer
    }, highlightableCode)), copyable ? (0, _reactDefault.default).createElement(ActionBar, {
        actionItems: [
            {
                title: copied ? "Copied" : "Copy",
                onClick
            }
        ]
    }) : null);
};
SyntaxHighlighter2.registerLanguage = (...args)=>prism_light_default.registerLanguage(...args);
var syntaxhighlighter_default = SyntaxHighlighter2;

},{"./chunk-MUPK3MH6.mjs":"gwy2u","./chunk-ISRAU5IP.mjs":"5Dv5W","./chunk-YU6L2YXV.mjs":"2gZWj","./chunk-VSDH24NK.mjs":"dWeGM","./chunk-BNQCH2A2.mjs":"6x9ZK","./chunk-HNGDCMHD.mjs":"2OmDN","./chunk-4Y2S2TEP.mjs":"70Qwv","./chunk-CW4JFC2I.mjs":"2AfZu","./chunk-7PYIL73X.mjs":"iMx5F","./chunk-SWV57YYC.mjs":"iAXcz","./chunk-MNLJ4LIX.mjs":"5eeP5","./chunk-DHRX2IL7.mjs":"hGrAv","./chunk-JRLSWQMA.mjs":"cGDqS","react":"jEiK2","@storybook/client-logger":"7OFBO","@storybook/theming":"bYlbs","@storybook/global":"4g4co","memoizerific":"aOMtb","react-dom":"a0ZmT","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"gwy2u":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "require_markdown", ()=>require_markdown);
var _chunkJRLSWQMAMjs = require("./chunk-JRLSWQMA.mjs");
var require_markdown = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/refractor/lang/markdown.js" (exports, module) {
        module.exports = markdown;
        markdown.displayName = "markdown";
        markdown.aliases = [
            "md"
        ];
        function markdown(Prism) {
            (function(Prism2) {
                var inner = /(?:\\.|[^\\\n\r]|(?:\n|\r\n?)(?![\r\n]))/.source;
                function createInline(pattern) {
                    return pattern = pattern.replace(/<inner>/g, function() {
                        return inner;
                    }), RegExp(/((?:^|[^\\])(?:\\{2})*)/.source + "(?:" + pattern + ")");
                }
                var tableCell = /(?:\\.|``(?:[^`\r\n]|`(?!`))+``|`[^`\r\n]+`|[^\\|\r\n`])+/.source, tableRow = /\|?__(?:\|__)+\|?(?:(?:\n|\r\n?)|(?![\s\S]))/.source.replace(/__/g, function() {
                    return tableCell;
                }), tableLine = /\|?[ \t]*:?-{3,}:?[ \t]*(?:\|[ \t]*:?-{3,}:?[ \t]*)+\|?(?:\n|\r\n?)/.source;
                Prism2.languages.markdown = Prism2.languages.extend("markup", {}), Prism2.languages.insertBefore("markdown", "prolog", {
                    "front-matter-block": {
                        pattern: /(^(?:\s*[\r\n])?)---(?!.)[\s\S]*?[\r\n]---(?!.)/,
                        lookbehind: !0,
                        greedy: !0,
                        inside: {
                            punctuation: /^---|---$/,
                            "front-matter": {
                                pattern: /\S+(?:\s+\S+)*/,
                                alias: [
                                    "yaml",
                                    "language-yaml"
                                ],
                                inside: Prism2.languages.yaml
                            }
                        }
                    },
                    blockquote: {
                        pattern: /^>(?:[\t ]*>)*/m,
                        alias: "punctuation"
                    },
                    table: {
                        pattern: RegExp("^" + tableRow + tableLine + "(?:" + tableRow + ")*", "m"),
                        inside: {
                            "table-data-rows": {
                                pattern: RegExp("^(" + tableRow + tableLine + ")(?:" + tableRow + ")*$"),
                                lookbehind: !0,
                                inside: {
                                    "table-data": {
                                        pattern: RegExp(tableCell),
                                        inside: Prism2.languages.markdown
                                    },
                                    punctuation: /\|/
                                }
                            },
                            "table-line": {
                                pattern: RegExp("^(" + tableRow + ")" + tableLine + "$"),
                                lookbehind: !0,
                                inside: {
                                    punctuation: /\||:?-{3,}:?/
                                }
                            },
                            "table-header-row": {
                                pattern: RegExp("^" + tableRow + "$"),
                                inside: {
                                    "table-header": {
                                        pattern: RegExp(tableCell),
                                        alias: "important",
                                        inside: Prism2.languages.markdown
                                    },
                                    punctuation: /\|/
                                }
                            }
                        }
                    },
                    code: [
                        {
                            pattern: /((?:^|\n)[ \t]*\n|(?:^|\r\n?)[ \t]*\r\n?)(?: {4}|\t).+(?:(?:\n|\r\n?)(?: {4}|\t).+)*/,
                            lookbehind: !0,
                            alias: "keyword"
                        },
                        {
                            pattern: /^```[\s\S]*?^```$/m,
                            greedy: !0,
                            inside: {
                                "code-block": {
                                    pattern: /^(```.*(?:\n|\r\n?))[\s\S]+?(?=(?:\n|\r\n?)^```$)/m,
                                    lookbehind: !0
                                },
                                "code-language": {
                                    pattern: /^(```).+/,
                                    lookbehind: !0
                                },
                                punctuation: /```/
                            }
                        }
                    ],
                    title: [
                        {
                            pattern: /\S.*(?:\n|\r\n?)(?:==+|--+)(?=[ \t]*$)/m,
                            alias: "important",
                            inside: {
                                punctuation: /==+$|--+$/
                            }
                        },
                        {
                            pattern: /(^\s*)#.+/m,
                            lookbehind: !0,
                            alias: "important",
                            inside: {
                                punctuation: /^#+|#+$/
                            }
                        }
                    ],
                    hr: {
                        pattern: /(^\s*)([*-])(?:[\t ]*\2){2,}(?=\s*$)/m,
                        lookbehind: !0,
                        alias: "punctuation"
                    },
                    list: {
                        pattern: /(^\s*)(?:[*+-]|\d+\.)(?=[\t ].)/m,
                        lookbehind: !0,
                        alias: "punctuation"
                    },
                    "url-reference": {
                        pattern: /!?\[[^\]]+\]:[\t ]+(?:\S+|<(?:\\.|[^>\\])+>)(?:[\t ]+(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\)))?/,
                        inside: {
                            variable: {
                                pattern: /^(!?\[)[^\]]+/,
                                lookbehind: !0
                            },
                            string: /(?:"(?:\\.|[^"\\])*"|'(?:\\.|[^'\\])*'|\((?:\\.|[^)\\])*\))$/,
                            punctuation: /^[\[\]!:]|[<>]/
                        },
                        alias: "url"
                    },
                    bold: {
                        pattern: createInline(/\b__(?:(?!_)<inner>|_(?:(?!_)<inner>)+_)+__\b|\*\*(?:(?!\*)<inner>|\*(?:(?!\*)<inner>)+\*)+\*\*/.source),
                        lookbehind: !0,
                        greedy: !0,
                        inside: {
                            content: {
                                pattern: /(^..)[\s\S]+(?=..$)/,
                                lookbehind: !0,
                                inside: {}
                            },
                            punctuation: /\*\*|__/
                        }
                    },
                    italic: {
                        pattern: createInline(/\b_(?:(?!_)<inner>|__(?:(?!_)<inner>)+__)+_\b|\*(?:(?!\*)<inner>|\*\*(?:(?!\*)<inner>)+\*\*)+\*/.source),
                        lookbehind: !0,
                        greedy: !0,
                        inside: {
                            content: {
                                pattern: /(^.)[\s\S]+(?=.$)/,
                                lookbehind: !0,
                                inside: {}
                            },
                            punctuation: /[*_]/
                        }
                    },
                    strike: {
                        pattern: createInline(/(~~?)(?:(?!~)<inner>)+\2/.source),
                        lookbehind: !0,
                        greedy: !0,
                        inside: {
                            content: {
                                pattern: /(^~~?)[\s\S]+(?=\1$)/,
                                lookbehind: !0,
                                inside: {}
                            },
                            punctuation: /~~?/
                        }
                    },
                    "code-snippet": {
                        pattern: /(^|[^\\`])(?:``[^`\r\n]+(?:`[^`\r\n]+)*``(?!`)|`[^`\r\n]+`(?!`))/,
                        lookbehind: !0,
                        greedy: !0,
                        alias: [
                            "code",
                            "keyword"
                        ]
                    },
                    url: {
                        pattern: createInline(/!?\[(?:(?!\])<inner>)+\](?:\([^\s)]+(?:[\t ]+"(?:\\.|[^"\\])*")?\)|[ \t]?\[(?:(?!\])<inner>)+\])/.source),
                        lookbehind: !0,
                        greedy: !0,
                        inside: {
                            operator: /^!/,
                            content: {
                                pattern: /(^\[)[^\]]+(?=\])/,
                                lookbehind: !0,
                                inside: {}
                            },
                            variable: {
                                pattern: /(^\][ \t]?\[)[^\]]+(?=\]$)/,
                                lookbehind: !0
                            },
                            url: {
                                pattern: /(^\]\()[^\s)]+/,
                                lookbehind: !0
                            },
                            string: {
                                pattern: /(^[ \t]+)"(?:\\.|[^"\\])*"(?=\)$)/,
                                lookbehind: !0
                            }
                        }
                    }
                }), [
                    "url",
                    "bold",
                    "italic",
                    "strike"
                ].forEach(function(token) {
                    [
                        "url",
                        "bold",
                        "italic",
                        "strike",
                        "code-snippet"
                    ].forEach(function(inside) {
                        token !== inside && (Prism2.languages.markdown[token].inside.content.inside[inside] = Prism2.languages.markdown[inside]);
                    });
                }), Prism2.hooks.add("after-tokenize", function(env) {
                    if (env.language !== "markdown" && env.language !== "md") return;
                    function walkTokens(tokens) {
                        if (!(!tokens || typeof tokens == "string")) for(var i = 0, l = tokens.length; i < l; i++){
                            var token = tokens[i];
                            if (token.type !== "code") {
                                walkTokens(token.content);
                                continue;
                            }
                            var codeLang = token.content[1], codeBlock = token.content[3];
                            if (codeLang && codeBlock && codeLang.type === "code-language" && codeBlock.type === "code-block" && typeof codeLang.content == "string") {
                                var lang = codeLang.content.replace(/\b#/g, "sharp").replace(/\b\+\+/g, "pp");
                                lang = (/[a-z][\w-]*/i.exec(lang) || [
                                    ""
                                ])[0].toLowerCase();
                                var alias = "language-" + lang;
                                codeBlock.alias ? typeof codeBlock.alias == "string" ? codeBlock.alias = [
                                    codeBlock.alias,
                                    alias
                                ] : codeBlock.alias.push(alias) : codeBlock.alias = [
                                    alias
                                ];
                            }
                        }
                    }
                    walkTokens(env.tokens);
                }), Prism2.hooks.add("wrap", function(env) {
                    if (env.type === "code-block") {
                        for(var codeLang = "", i = 0, l = env.classes.length; i < l; i++){
                            var cls = env.classes[i], match = /language-(.+)/.exec(cls);
                            if (match) {
                                codeLang = match[1];
                                break;
                            }
                        }
                        var grammar = Prism2.languages[codeLang];
                        if (grammar) env.content = Prism2.highlight(textContent(env.content.value), grammar, codeLang);
                        else if (codeLang && codeLang !== "none" && Prism2.plugins.autoloader) {
                            var id = "md-" + new Date().valueOf() + "-" + Math.floor(Math.random() * 1e16);
                            env.attributes.id = id, Prism2.plugins.autoloader.loadLanguages(codeLang, function() {
                                var ele = document.getElementById(id);
                                ele && (ele.innerHTML = Prism2.highlight(ele.textContent, Prism2.languages[codeLang], codeLang));
                            });
                        }
                    }
                });
                var tagPattern = RegExp(Prism2.languages.markup.tag.pattern.source, "gi"), KNOWN_ENTITY_NAMES = {
                    amp: "&",
                    lt: "<",
                    gt: ">",
                    quot: '"'
                }, fromCodePoint = String.fromCodePoint || String.fromCharCode;
                function textContent(html) {
                    var text = html.replace(tagPattern, "");
                    return text = text.replace(/&(\w{1,8}|#x?[\da-f]{1,8});/gi, function(m, code) {
                        if (code = code.toLowerCase(), code[0] === "#") {
                            var value;
                            return code[1] === "x" ? value = parseInt(code.slice(2), 16) : value = Number(code.slice(1)), fromCodePoint(value);
                        } else {
                            var known = KNOWN_ENTITY_NAMES[code];
                            return known || m;
                        }
                    }), text;
                }
                Prism2.languages.md = Prism2.languages.markdown;
            })(Prism);
        }
    }
});

},{"./chunk-JRLSWQMA.mjs":"cGDqS","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"cGDqS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__commonJS", ()=>__commonJS);
parcelHelpers.export(exports, "__toESM", ()=>__toESM);
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod)=>function() {
        return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
            exports: {}
        }).exports, mod), mod.exports;
    };
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from == "object" || typeof from == "function") for (let key of __getOwnPropNames(from))!__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, {
        get: ()=>from[key],
        enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
    });
    return to;
};
var __toESM = (mod, isNodeMode, target)=>(target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: !0
    }) : target, mod));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"5Dv5W":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "require_yaml", ()=>require_yaml);
var _chunkJRLSWQMAMjs = require("./chunk-JRLSWQMA.mjs");
var require_yaml = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/refractor/lang/yaml.js" (exports, module) {
        module.exports = yaml;
        yaml.displayName = "yaml";
        yaml.aliases = [
            "yml"
        ];
        function yaml(Prism) {
            (function(Prism2) {
                var anchorOrAlias = /[*&][^\s[\]{},]+/, tag = /!(?:<[\w\-%#;/?:@&=+$,.!~*'()[\]]+>|(?:[a-zA-Z\d-]*!)?[\w\-%#;/?:@&=+$.~*'()]+)?/, properties = "(?:" + tag.source + "(?:[ 	]+" + anchorOrAlias.source + ")?|" + anchorOrAlias.source + "(?:[ 	]+" + tag.source + ")?)", plainKey = /(?:[^\s\x00-\x08\x0e-\x1f!"#%&'*,\-:>?@[\]`{|}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]|[?:-]<PLAIN>)(?:[ \t]*(?:(?![#:])<PLAIN>|:<PLAIN>))*/.source.replace(/<PLAIN>/g, function() {
                    return /[^\s\x00-\x08\x0e-\x1f,[\]{}\x7f-\x84\x86-\x9f\ud800-\udfff\ufffe\uffff]/.source;
                }), string = /"(?:[^"\\\r\n]|\\.)*"|'(?:[^'\\\r\n]|\\.)*'/.source;
                function createValuePattern(value, flags) {
                    flags = (flags || "").replace(/m/g, "") + "m";
                    var pattern = /([:\-,[{]\s*(?:\s<<prop>>[ \t]+)?)(?:<<value>>)(?=[ \t]*(?:$|,|\]|\}|(?:[\r\n]\s*)?#))/.source.replace(/<<prop>>/g, function() {
                        return properties;
                    }).replace(/<<value>>/g, function() {
                        return value;
                    });
                    return RegExp(pattern, flags);
                }
                Prism2.languages.yaml = {
                    scalar: {
                        pattern: RegExp(/([\-:]\s*(?:\s<<prop>>[ \t]+)?[|>])[ \t]*(?:((?:\r?\n|\r)[ \t]+)\S[^\r\n]*(?:\2[^\r\n]+)*)/.source.replace(/<<prop>>/g, function() {
                            return properties;
                        })),
                        lookbehind: !0,
                        alias: "string"
                    },
                    comment: /#.*/,
                    key: {
                        pattern: RegExp(/((?:^|[:\-,[{\r\n?])[ \t]*(?:<<prop>>[ \t]+)?)<<key>>(?=\s*:\s)/.source.replace(/<<prop>>/g, function() {
                            return properties;
                        }).replace(/<<key>>/g, function() {
                            return "(?:" + plainKey + "|" + string + ")";
                        })),
                        lookbehind: !0,
                        greedy: !0,
                        alias: "atrule"
                    },
                    directive: {
                        pattern: /(^[ \t]*)%.+/m,
                        lookbehind: !0,
                        alias: "important"
                    },
                    datetime: {
                        pattern: createValuePattern(/\d{4}-\d\d?-\d\d?(?:[tT]|[ \t]+)\d\d?:\d{2}:\d{2}(?:\.\d*)?(?:[ \t]*(?:Z|[-+]\d\d?(?::\d{2})?))?|\d{4}-\d{2}-\d{2}|\d\d?:\d{2}(?::\d{2}(?:\.\d*)?)?/.source),
                        lookbehind: !0,
                        alias: "number"
                    },
                    boolean: {
                        pattern: createValuePattern(/false|true/.source, "i"),
                        lookbehind: !0,
                        alias: "important"
                    },
                    null: {
                        pattern: createValuePattern(/null|~/.source, "i"),
                        lookbehind: !0,
                        alias: "important"
                    },
                    string: {
                        pattern: createValuePattern(string),
                        lookbehind: !0,
                        greedy: !0
                    },
                    number: {
                        pattern: createValuePattern(/[+-]?(?:0x[\da-f]+|0o[0-7]+|(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?|\.inf|\.nan)/.source, "i"),
                        lookbehind: !0
                    },
                    tag,
                    important: anchorOrAlias,
                    punctuation: /---|[:[\]{}\-,|>?]|\.\.\./
                }, Prism2.languages.yml = Prism2.languages.yaml;
            })(Prism);
        }
    }
});

},{"./chunk-JRLSWQMA.mjs":"cGDqS","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"2gZWj":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "require_tsx", ()=>require_tsx);
var _chunkVSDH24NKMjs = require("./chunk-VSDH24NK.mjs");
var _chunkHNGDCMHDMjs = require("./chunk-HNGDCMHD.mjs");
var _chunkJRLSWQMAMjs = require("./chunk-JRLSWQMA.mjs");
var require_tsx = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/refractor/lang/tsx.js" (exports, module) {
        var refractorJsx = (0, _chunkHNGDCMHDMjs.require_jsx)(), refractorTypescript = (0, _chunkVSDH24NKMjs.require_typescript)();
        module.exports = tsx;
        tsx.displayName = "tsx";
        tsx.aliases = [];
        function tsx(Prism) {
            Prism.register(refractorJsx), Prism.register(refractorTypescript), function(Prism2) {
                var typescript = Prism2.util.clone(Prism2.languages.typescript);
                Prism2.languages.tsx = Prism2.languages.extend("jsx", typescript), delete Prism2.languages.tsx.parameter, delete Prism2.languages.tsx["literal-property"];
                var tag = Prism2.languages.tsx.tag;
                tag.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + "(?:" + tag.pattern.source + ")", tag.pattern.flags), tag.lookbehind = !0;
            }(Prism);
        }
    }
});

},{"./chunk-VSDH24NK.mjs":"dWeGM","./chunk-HNGDCMHD.mjs":"2OmDN","./chunk-JRLSWQMA.mjs":"cGDqS","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"dWeGM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "require_typescript", ()=>require_typescript);
var _chunkJRLSWQMAMjs = require("./chunk-JRLSWQMA.mjs");
var require_typescript = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/refractor/lang/typescript.js" (exports, module) {
        module.exports = typescript;
        typescript.displayName = "typescript";
        typescript.aliases = [
            "ts"
        ];
        function typescript(Prism) {
            (function(Prism2) {
                Prism2.languages.typescript = Prism2.languages.extend("javascript", {
                    "class-name": {
                        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
                        lookbehind: !0,
                        greedy: !0,
                        inside: null
                    },
                    builtin: /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
                }), Prism2.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, /\btype\b(?=\s*(?:[\{*]|$))/), delete Prism2.languages.typescript.parameter, delete Prism2.languages.typescript["literal-property"];
                var typeInside = Prism2.languages.extend("typescript", {});
                delete typeInside["class-name"], Prism2.languages.typescript["class-name"].inside = typeInside, Prism2.languages.insertBefore("typescript", "function", {
                    decorator: {
                        pattern: /@[$\w\xA0-\uFFFF]+/,
                        inside: {
                            at: {
                                pattern: /^@/,
                                alias: "operator"
                            },
                            function: /^[\s\S]+/
                        }
                    },
                    "generic-function": {
                        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
                        greedy: !0,
                        inside: {
                            function: /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
                            generic: {
                                pattern: /<[\s\S]+/,
                                alias: "class-name",
                                inside: typeInside
                            }
                        }
                    }
                }), Prism2.languages.ts = Prism2.languages.typescript;
            })(Prism);
        }
    }
});

},{"./chunk-JRLSWQMA.mjs":"cGDqS","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"2OmDN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "require_jsx", ()=>require_jsx);
var _chunkJRLSWQMAMjs = require("./chunk-JRLSWQMA.mjs");
var require_jsx = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/refractor/lang/jsx.js" (exports, module) {
        module.exports = jsx;
        jsx.displayName = "jsx";
        jsx.aliases = [];
        function jsx(Prism) {
            (function(Prism2) {
                var javascript = Prism2.util.clone(Prism2.languages.javascript), space = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source, braces = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source, spread = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
                function re(source, flags) {
                    return source = source.replace(/<S>/g, function() {
                        return space;
                    }).replace(/<BRACES>/g, function() {
                        return braces;
                    }).replace(/<SPREAD>/g, function() {
                        return spread;
                    }), RegExp(source, flags);
                }
                spread = re(spread).source, Prism2.languages.jsx = Prism2.languages.extend("markup", javascript), Prism2.languages.jsx.tag.pattern = re(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source), Prism2.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/, Prism2.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/, Prism2.languages.jsx.tag.inside.tag.inside["class-name"] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/, Prism2.languages.jsx.tag.inside.comment = javascript.comment, Prism2.languages.insertBefore("inside", "attr-name", {
                    spread: {
                        pattern: re(/<SPREAD>/.source),
                        inside: Prism2.languages.jsx
                    }
                }, Prism2.languages.jsx.tag), Prism2.languages.insertBefore("inside", "special-attr", {
                    script: {
                        pattern: re(/=<BRACES>/.source),
                        alias: "language-javascript",
                        inside: {
                            "script-punctuation": {
                                pattern: /^=(?=\{)/,
                                alias: "punctuation"
                            },
                            rest: Prism2.languages.jsx
                        }
                    }
                }, Prism2.languages.jsx.tag);
                var stringifyToken = function(token) {
                    return token ? typeof token == "string" ? token : typeof token.content == "string" ? token.content : token.content.map(stringifyToken).join("") : "";
                }, walkTokens = function(tokens) {
                    for(var openedTags = [], i = 0; i < tokens.length; i++){
                        var token = tokens[i], notTagNorBrace = !1;
                        if (typeof token != "string" && (token.type === "tag" && token.content[0] && token.content[0].type === "tag" ? token.content[0].content[0].content === "</" ? openedTags.length > 0 && openedTags[openedTags.length - 1].tagName === stringifyToken(token.content[0].content[1]) && openedTags.pop() : token.content[token.content.length - 1].content === "/>" || openedTags.push({
                            tagName: stringifyToken(token.content[0].content[1]),
                            openedBraces: 0
                        }) : openedTags.length > 0 && token.type === "punctuation" && token.content === "{" ? openedTags[openedTags.length - 1].openedBraces++ : openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces > 0 && token.type === "punctuation" && token.content === "}" ? openedTags[openedTags.length - 1].openedBraces-- : notTagNorBrace = !0), (notTagNorBrace || typeof token == "string") && openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces === 0) {
                            var plainText = stringifyToken(token);
                            i < tokens.length - 1 && (typeof tokens[i + 1] == "string" || tokens[i + 1].type === "plain-text") && (plainText += stringifyToken(tokens[i + 1]), tokens.splice(i + 1, 1)), i > 0 && (typeof tokens[i - 1] == "string" || tokens[i - 1].type === "plain-text") && (plainText = stringifyToken(tokens[i - 1]) + plainText, tokens.splice(i - 1, 1), i--), tokens[i] = new Prism2.Token("plain-text", plainText, null, plainText);
                        }
                        token.content && typeof token.content != "string" && walkTokens(token.content);
                    }
                };
                Prism2.hooks.add("after-tokenize", function(env) {
                    env.language !== "jsx" && env.language !== "tsx" || walkTokens(env.tokens);
                });
            })(Prism);
        }
    }
});

},{"./chunk-JRLSWQMA.mjs":"cGDqS","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"6x9ZK":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "require_core", ()=>require_core);
var _chunkUDRSICRZMjs = require("./chunk-UDRSICRZ.mjs");
var _chunkJ6EJ35VBMjs = require("./chunk-J6EJ35VB.mjs");
var _chunkCW4JFC2IMjs = require("./chunk-CW4JFC2I.mjs");
var _chunkDHRX2IL7Mjs = require("./chunk-DHRX2IL7.mjs");
var _chunkJRLSWQMAMjs = require("./chunk-JRLSWQMA.mjs");
var global = arguments[3];
var require_immutable = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/xtend/immutable.js" (exports, module) {
        module.exports = extend;
        var hasOwnProperty = Object.prototype.hasOwnProperty;
        function extend() {
            for(var target = {}, i = 0; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)hasOwnProperty.call(source, key) && (target[key] = source[key]);
            }
            return target;
        }
    }
});
var require_schema = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/property-information/lib/util/schema.js" (exports, module) {
        module.exports = Schema;
        var proto = Schema.prototype;
        proto.space = null;
        proto.normal = {};
        proto.property = {};
        function Schema(property, normal, space) {
            this.property = property, this.normal = normal, space && (this.space = space);
        }
    }
});
var require_merge = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/property-information/lib/util/merge.js" (exports, module) {
        var xtend = require_immutable(), Schema = require_schema();
        module.exports = merge;
        function merge(definitions) {
            for(var length = definitions.length, property = [], normal = [], index = -1, info, space; ++index < length;)info = definitions[index], property.push(info.property), normal.push(info.normal), space = info.space;
            return new Schema(xtend.apply(null, property), xtend.apply(null, normal), space);
        }
    }
});
var require_normalize = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/property-information/normalize.js" (exports, module) {
        module.exports = normalize;
        function normalize(value) {
            return value.toLowerCase();
        }
    }
});
var require_info = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/property-information/lib/util/info.js" (exports, module) {
        module.exports = Info;
        var proto = Info.prototype;
        proto.space = null;
        proto.attribute = null;
        proto.property = null;
        proto.boolean = !1;
        proto.booleanish = !1;
        proto.overloadedBoolean = !1;
        proto.number = !1;
        proto.commaSeparated = !1;
        proto.spaceSeparated = !1;
        proto.commaOrSpaceSeparated = !1;
        proto.mustUseProperty = !1;
        proto.defined = !1;
        function Info(property, attribute) {
            this.property = property, this.attribute = attribute;
        }
    }
});
var require_types = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/property-information/lib/util/types.js" (exports) {
        var powers = 0;
        exports.boolean = increment();
        exports.booleanish = increment();
        exports.overloadedBoolean = increment();
        exports.number = increment();
        exports.spaceSeparated = increment();
        exports.commaSeparated = increment();
        exports.commaOrSpaceSeparated = increment();
        function increment() {
            return Math.pow(2, ++powers);
        }
    }
});
var require_defined_info = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/property-information/lib/util/defined-info.js" (exports, module) {
        var Info = require_info(), types = require_types();
        module.exports = DefinedInfo;
        DefinedInfo.prototype = new Info;
        DefinedInfo.prototype.defined = !0;
        var checks = [
            "boolean",
            "booleanish",
            "overloadedBoolean",
            "number",
            "commaSeparated",
            "spaceSeparated",
            "commaOrSpaceSeparated"
        ], checksLength = checks.length;
        function DefinedInfo(property, attribute, mask, space) {
            var index = -1, check;
            for(mark(this, "space", space), Info.call(this, property, attribute); ++index < checksLength;)check = checks[index], mark(this, check, (mask & types[check]) === types[check]);
        }
        function mark(values, key, value) {
            value && (values[key] = value);
        }
    }
});
var require_create = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/property-information/lib/util/create.js" (exports, module) {
        var normalize = require_normalize(), Schema = require_schema(), DefinedInfo = require_defined_info();
        module.exports = create;
        function create(definition) {
            var space = definition.space, mustUseProperty = definition.mustUseProperty || [], attributes = definition.attributes || {}, props = definition.properties, transform = definition.transform, property = {}, normal = {}, prop, info;
            for(prop in props)info = new DefinedInfo(prop, transform(attributes, prop), props[prop], space), mustUseProperty.indexOf(prop) !== -1 && (info.mustUseProperty = !0), property[prop] = info, normal[normalize(prop)] = prop, normal[normalize(info.attribute)] = prop;
            return new Schema(property, normal, space);
        }
    }
});
var require_xlink = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/property-information/lib/xlink.js" (exports, module) {
        var create = require_create();
        module.exports = create({
            space: "xlink",
            transform: xlinkTransform,
            properties: {
                xLinkActuate: null,
                xLinkArcRole: null,
                xLinkHref: null,
                xLinkRole: null,
                xLinkShow: null,
                xLinkTitle: null,
                xLinkType: null
            }
        });
        function xlinkTransform(_, prop) {
            return "xlink:" + prop.slice(5).toLowerCase();
        }
    }
});
var require_xml = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/property-information/lib/xml.js" (exports, module) {
        var create = require_create();
        module.exports = create({
            space: "xml",
            transform: xmlTransform,
            properties: {
                xmlLang: null,
                xmlBase: null,
                xmlSpace: null
            }
        });
        function xmlTransform(_, prop) {
            return "xml:" + prop.slice(3).toLowerCase();
        }
    }
});
var require_case_sensitive_transform = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/property-information/lib/util/case-sensitive-transform.js" (exports, module) {
        module.exports = caseSensitiveTransform;
        function caseSensitiveTransform(attributes, attribute) {
            return attribute in attributes ? attributes[attribute] : attribute;
        }
    }
});
var require_case_insensitive_transform = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/property-information/lib/util/case-insensitive-transform.js" (exports, module) {
        var caseSensitiveTransform = require_case_sensitive_transform();
        module.exports = caseInsensitiveTransform;
        function caseInsensitiveTransform(attributes, property) {
            return caseSensitiveTransform(attributes, property.toLowerCase());
        }
    }
});
var require_xmlns = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/property-information/lib/xmlns.js" (exports, module) {
        var create = require_create(), caseInsensitiveTransform = require_case_insensitive_transform();
        module.exports = create({
            space: "xmlns",
            attributes: {
                xmlnsxlink: "xmlns:xlink"
            },
            transform: caseInsensitiveTransform,
            properties: {
                xmlns: null,
                xmlnsXLink: null
            }
        });
    }
});
var require_aria = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/property-information/lib/aria.js" (exports, module) {
        var types = require_types(), create = require_create(), booleanish = types.booleanish, number = types.number, spaceSeparated = types.spaceSeparated;
        module.exports = create({
            transform: ariaTransform,
            properties: {
                ariaActiveDescendant: null,
                ariaAtomic: booleanish,
                ariaAutoComplete: null,
                ariaBusy: booleanish,
                ariaChecked: booleanish,
                ariaColCount: number,
                ariaColIndex: number,
                ariaColSpan: number,
                ariaControls: spaceSeparated,
                ariaCurrent: null,
                ariaDescribedBy: spaceSeparated,
                ariaDetails: null,
                ariaDisabled: booleanish,
                ariaDropEffect: spaceSeparated,
                ariaErrorMessage: null,
                ariaExpanded: booleanish,
                ariaFlowTo: spaceSeparated,
                ariaGrabbed: booleanish,
                ariaHasPopup: null,
                ariaHidden: booleanish,
                ariaInvalid: null,
                ariaKeyShortcuts: null,
                ariaLabel: null,
                ariaLabelledBy: spaceSeparated,
                ariaLevel: number,
                ariaLive: null,
                ariaModal: booleanish,
                ariaMultiLine: booleanish,
                ariaMultiSelectable: booleanish,
                ariaOrientation: null,
                ariaOwns: spaceSeparated,
                ariaPlaceholder: null,
                ariaPosInSet: number,
                ariaPressed: booleanish,
                ariaReadOnly: booleanish,
                ariaRelevant: null,
                ariaRequired: booleanish,
                ariaRoleDescription: spaceSeparated,
                ariaRowCount: number,
                ariaRowIndex: number,
                ariaRowSpan: number,
                ariaSelected: booleanish,
                ariaSetSize: number,
                ariaSort: null,
                ariaValueMax: number,
                ariaValueMin: number,
                ariaValueNow: number,
                ariaValueText: null,
                role: null
            }
        });
        function ariaTransform(_, prop) {
            return prop === "role" ? prop : "aria-" + prop.slice(4).toLowerCase();
        }
    }
});
var require_html = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/property-information/lib/html.js" (exports, module) {
        var types = require_types(), create = require_create(), caseInsensitiveTransform = require_case_insensitive_transform(), boolean = types.boolean, overloadedBoolean = types.overloadedBoolean, booleanish = types.booleanish, number = types.number, spaceSeparated = types.spaceSeparated, commaSeparated = types.commaSeparated;
        module.exports = create({
            space: "html",
            attributes: {
                acceptcharset: "accept-charset",
                classname: "class",
                htmlfor: "for",
                httpequiv: "http-equiv"
            },
            transform: caseInsensitiveTransform,
            mustUseProperty: [
                "checked",
                "multiple",
                "muted",
                "selected"
            ],
            properties: {
                abbr: null,
                accept: commaSeparated,
                acceptCharset: spaceSeparated,
                accessKey: spaceSeparated,
                action: null,
                allow: null,
                allowFullScreen: boolean,
                allowPaymentRequest: boolean,
                allowUserMedia: boolean,
                alt: null,
                as: null,
                async: boolean,
                autoCapitalize: null,
                autoComplete: spaceSeparated,
                autoFocus: boolean,
                autoPlay: boolean,
                capture: boolean,
                charSet: null,
                checked: boolean,
                cite: null,
                className: spaceSeparated,
                cols: number,
                colSpan: null,
                content: null,
                contentEditable: booleanish,
                controls: boolean,
                controlsList: spaceSeparated,
                coords: number | commaSeparated,
                crossOrigin: null,
                data: null,
                dateTime: null,
                decoding: null,
                default: boolean,
                defer: boolean,
                dir: null,
                dirName: null,
                disabled: boolean,
                download: overloadedBoolean,
                draggable: booleanish,
                encType: null,
                enterKeyHint: null,
                form: null,
                formAction: null,
                formEncType: null,
                formMethod: null,
                formNoValidate: boolean,
                formTarget: null,
                headers: spaceSeparated,
                height: number,
                hidden: boolean,
                high: number,
                href: null,
                hrefLang: null,
                htmlFor: spaceSeparated,
                httpEquiv: spaceSeparated,
                id: null,
                imageSizes: null,
                imageSrcSet: commaSeparated,
                inputMode: null,
                integrity: null,
                is: null,
                isMap: boolean,
                itemId: null,
                itemProp: spaceSeparated,
                itemRef: spaceSeparated,
                itemScope: boolean,
                itemType: spaceSeparated,
                kind: null,
                label: null,
                lang: null,
                language: null,
                list: null,
                loading: null,
                loop: boolean,
                low: number,
                manifest: null,
                max: null,
                maxLength: number,
                media: null,
                method: null,
                min: null,
                minLength: number,
                multiple: boolean,
                muted: boolean,
                name: null,
                nonce: null,
                noModule: boolean,
                noValidate: boolean,
                onAbort: null,
                onAfterPrint: null,
                onAuxClick: null,
                onBeforePrint: null,
                onBeforeUnload: null,
                onBlur: null,
                onCancel: null,
                onCanPlay: null,
                onCanPlayThrough: null,
                onChange: null,
                onClick: null,
                onClose: null,
                onContextMenu: null,
                onCopy: null,
                onCueChange: null,
                onCut: null,
                onDblClick: null,
                onDrag: null,
                onDragEnd: null,
                onDragEnter: null,
                onDragExit: null,
                onDragLeave: null,
                onDragOver: null,
                onDragStart: null,
                onDrop: null,
                onDurationChange: null,
                onEmptied: null,
                onEnded: null,
                onError: null,
                onFocus: null,
                onFormData: null,
                onHashChange: null,
                onInput: null,
                onInvalid: null,
                onKeyDown: null,
                onKeyPress: null,
                onKeyUp: null,
                onLanguageChange: null,
                onLoad: null,
                onLoadedData: null,
                onLoadedMetadata: null,
                onLoadEnd: null,
                onLoadStart: null,
                onMessage: null,
                onMessageError: null,
                onMouseDown: null,
                onMouseEnter: null,
                onMouseLeave: null,
                onMouseMove: null,
                onMouseOut: null,
                onMouseOver: null,
                onMouseUp: null,
                onOffline: null,
                onOnline: null,
                onPageHide: null,
                onPageShow: null,
                onPaste: null,
                onPause: null,
                onPlay: null,
                onPlaying: null,
                onPopState: null,
                onProgress: null,
                onRateChange: null,
                onRejectionHandled: null,
                onReset: null,
                onResize: null,
                onScroll: null,
                onSecurityPolicyViolation: null,
                onSeeked: null,
                onSeeking: null,
                onSelect: null,
                onSlotChange: null,
                onStalled: null,
                onStorage: null,
                onSubmit: null,
                onSuspend: null,
                onTimeUpdate: null,
                onToggle: null,
                onUnhandledRejection: null,
                onUnload: null,
                onVolumeChange: null,
                onWaiting: null,
                onWheel: null,
                open: boolean,
                optimum: number,
                pattern: null,
                ping: spaceSeparated,
                placeholder: null,
                playsInline: boolean,
                poster: null,
                preload: null,
                readOnly: boolean,
                referrerPolicy: null,
                rel: spaceSeparated,
                required: boolean,
                reversed: boolean,
                rows: number,
                rowSpan: number,
                sandbox: spaceSeparated,
                scope: null,
                scoped: boolean,
                seamless: boolean,
                selected: boolean,
                shape: null,
                size: number,
                sizes: null,
                slot: null,
                span: number,
                spellCheck: booleanish,
                src: null,
                srcDoc: null,
                srcLang: null,
                srcSet: commaSeparated,
                start: number,
                step: null,
                style: null,
                tabIndex: number,
                target: null,
                title: null,
                translate: null,
                type: null,
                typeMustMatch: boolean,
                useMap: null,
                value: booleanish,
                width: number,
                wrap: null,
                align: null,
                aLink: null,
                archive: spaceSeparated,
                axis: null,
                background: null,
                bgColor: null,
                border: number,
                borderColor: null,
                bottomMargin: number,
                cellPadding: null,
                cellSpacing: null,
                char: null,
                charOff: null,
                classId: null,
                clear: null,
                code: null,
                codeBase: null,
                codeType: null,
                color: null,
                compact: boolean,
                declare: boolean,
                event: null,
                face: null,
                frame: null,
                frameBorder: null,
                hSpace: number,
                leftMargin: number,
                link: null,
                longDesc: null,
                lowSrc: null,
                marginHeight: number,
                marginWidth: number,
                noResize: boolean,
                noHref: boolean,
                noShade: boolean,
                noWrap: boolean,
                object: null,
                profile: null,
                prompt: null,
                rev: null,
                rightMargin: number,
                rules: null,
                scheme: null,
                scrolling: booleanish,
                standby: null,
                summary: null,
                text: null,
                topMargin: number,
                valueType: null,
                version: null,
                vAlign: null,
                vLink: null,
                vSpace: number,
                allowTransparency: null,
                autoCorrect: null,
                autoSave: null,
                disablePictureInPicture: boolean,
                disableRemotePlayback: boolean,
                prefix: null,
                property: null,
                results: number,
                security: null,
                unselectable: null
            }
        });
    }
});
var require_html2 = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/property-information/html.js" (exports, module) {
        var merge = require_merge(), xlink = require_xlink(), xml = require_xml(), xmlns = require_xmlns(), aria = require_aria(), html = require_html();
        module.exports = merge([
            xml,
            xlink,
            xmlns,
            aria,
            html
        ]);
    }
});
var require_find = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/property-information/find.js" (exports, module) {
        var normalize = require_normalize(), DefinedInfo = require_defined_info(), Info = require_info(), data = "data";
        module.exports = find;
        var valid = /^data[-\w.:]+$/i, dash = /-[a-z]/g, cap = /[A-Z]/g;
        function find(schema, value) {
            var normal = normalize(value), prop = value, Type = Info;
            return normal in schema.normal ? schema.property[schema.normal[normal]] : (normal.length > 4 && normal.slice(0, 4) === data && valid.test(value) && (value.charAt(4) === "-" ? prop = datasetToProperty(value) : value = datasetToAttribute(value), Type = DefinedInfo), new Type(prop, value));
        }
        function datasetToProperty(attribute) {
            var value = attribute.slice(5).replace(dash, camelcase);
            return data + value.charAt(0).toUpperCase() + value.slice(1);
        }
        function datasetToAttribute(property) {
            var value = property.slice(4);
            return dash.test(value) ? property : (value = value.replace(cap, kebab), value.charAt(0) !== "-" && (value = "-" + value), data + value);
        }
        function kebab($0) {
            return "-" + $0.toLowerCase();
        }
        function camelcase($0) {
            return $0.charAt(1).toUpperCase();
        }
    }
});
var require_hast_util_parse_selector = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/hast-util-parse-selector/index.js" (exports, module) {
        module.exports = parse;
        var search = /[#.]/g;
        function parse(selector, defaultTagName) {
            for(var value = selector || "", name = defaultTagName || "div", props = {}, start = 0, subvalue, previous, match; start < value.length;)search.lastIndex = start, match = search.exec(value), subvalue = value.slice(start, match ? match.index : value.length), subvalue && (previous ? previous === "#" ? props.id = subvalue : props.className ? props.className.push(subvalue) : props.className = [
                subvalue
            ] : name = subvalue, start += subvalue.length), match && (previous = match[0], start++);
            return {
                type: "element",
                tagName: name,
                properties: props,
                children: []
            };
        }
    }
});
var require_space_separated_tokens = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/space-separated-tokens/index.js" (exports) {
        exports.parse = parse;
        exports.stringify = stringify;
        var empty = "", space = " ", whiteSpace = /[ \t\n\r\f]+/g;
        function parse(value) {
            var input = String(value || empty).trim();
            return input === empty ? [] : input.split(whiteSpace);
        }
        function stringify(values) {
            return values.join(space).trim();
        }
    }
});
var require_comma_separated_tokens = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/comma-separated-tokens/index.js" (exports) {
        exports.parse = parse;
        exports.stringify = stringify;
        var comma = ",", space = " ", empty = "";
        function parse(value) {
            for(var values = [], input = String(value || empty), index = input.indexOf(comma), lastIndex = 0, end = !1, val; !end;)index === -1 && (index = input.length, end = !0), val = input.slice(lastIndex, index).trim(), (val || !end) && values.push(val), lastIndex = index + 1, index = input.indexOf(comma, lastIndex);
            return values;
        }
        function stringify(values, options) {
            var settings = options || {}, left = settings.padLeft === !1 ? empty : space, right = settings.padRight ? space : empty;
            return values[values.length - 1] === empty && (values = values.concat(empty)), values.join(right + comma + left).trim();
        }
    }
});
var require_factory = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/hastscript/factory.js" (exports, module) {
        var find = require_find(), normalize = require_normalize(), parseSelector = require_hast_util_parse_selector(), spaces = require_space_separated_tokens().parse, commas = require_comma_separated_tokens().parse;
        module.exports = factory;
        var own = {}.hasOwnProperty;
        function factory(schema, defaultTagName, caseSensitive) {
            var adjust = caseSensitive ? createAdjustMap(caseSensitive) : null;
            return h;
            function h(selector, properties) {
                var node = parseSelector(selector, defaultTagName), children = Array.prototype.slice.call(arguments, 2), name = node.tagName.toLowerCase(), property;
                if (node.tagName = adjust && own.call(adjust, name) ? adjust[name] : name, properties && isChildren(properties, node) && (children.unshift(properties), properties = null), properties) for(property in properties)addProperty(node.properties, property, properties[property]);
                return addChild(node.children, children), node.tagName === "template" && (node.content = {
                    type: "root",
                    children: node.children
                }, node.children = []), node;
            }
            function addProperty(properties, key, value) {
                var info, property, result;
                value == null || value !== value || (info = find(schema, key), property = info.property, result = value, typeof result == "string" && (info.spaceSeparated ? result = spaces(result) : info.commaSeparated ? result = commas(result) : info.commaOrSpaceSeparated && (result = spaces(commas(result).join(" ")))), property === "style" && typeof value != "string" && (result = style(result)), property === "className" && properties.className && (result = properties.className.concat(result)), properties[property] = parsePrimitives(info, property, result));
            }
        }
        function isChildren(value, node) {
            return typeof value == "string" || "length" in value || isNode(node.tagName, value);
        }
        function isNode(tagName, value) {
            var type = value.type;
            return tagName === "input" || !type || typeof type != "string" ? !1 : typeof value.children == "object" && "length" in value.children ? !0 : (type = type.toLowerCase(), tagName === "button" ? type !== "menu" && type !== "submit" && type !== "reset" && type !== "button" : "value" in value);
        }
        function addChild(nodes, value) {
            var index, length;
            if (typeof value == "string" || typeof value == "number") {
                nodes.push({
                    type: "text",
                    value: String(value)
                });
                return;
            }
            if (typeof value == "object" && "length" in value) {
                for(index = -1, length = value.length; ++index < length;)addChild(nodes, value[index]);
                return;
            }
            if (typeof value != "object" || !("type" in value)) throw new Error("Expected node, nodes, or string, got `" + value + "`");
            nodes.push(value);
        }
        function parsePrimitives(info, name, value) {
            var index, length, result;
            if (typeof value != "object" || !("length" in value)) return parsePrimitive(info, name, value);
            for(length = value.length, index = -1, result = []; ++index < length;)result[index] = parsePrimitive(info, name, value[index]);
            return result;
        }
        function parsePrimitive(info, name, value) {
            var result = value;
            return info.number || info.positiveNumber ? !isNaN(result) && result !== "" && (result = Number(result)) : (info.boolean || info.overloadedBoolean) && typeof result == "string" && (result === "" || normalize(value) === normalize(name)) && (result = !0), result;
        }
        function style(value) {
            var result = [], key;
            for(key in value)result.push([
                key,
                value[key]
            ].join(": "));
            return result.join("; ");
        }
        function createAdjustMap(values) {
            for(var length = values.length, index = -1, result = {}, value; ++index < length;)value = values[index], result[value.toLowerCase()] = value;
            return result;
        }
    }
});
var require_html3 = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/hastscript/html.js" (exports, module) {
        var schema = require_html2(), factory = require_factory(), html = factory(schema, "div");
        html.displayName = "html";
        module.exports = html;
    }
});
var require_hastscript = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/hastscript/index.js" (exports, module) {
        module.exports = require_html3();
    }
});
var require_character_entities_legacy = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/parse-entities/node_modules/character-entities-legacy/index.json" (exports, module) {
        module.exports = {
            AElig: "\xC6",
            AMP: "&",
            Aacute: "\xC1",
            Acirc: "\xC2",
            Agrave: "\xC0",
            Aring: "\xC5",
            Atilde: "\xC3",
            Auml: "\xC4",
            COPY: "\xA9",
            Ccedil: "\xC7",
            ETH: "\xD0",
            Eacute: "\xC9",
            Ecirc: "\xCA",
            Egrave: "\xC8",
            Euml: "\xCB",
            GT: ">",
            Iacute: "\xCD",
            Icirc: "\xCE",
            Igrave: "\xCC",
            Iuml: "\xCF",
            LT: "<",
            Ntilde: "\xD1",
            Oacute: "\xD3",
            Ocirc: "\xD4",
            Ograve: "\xD2",
            Oslash: "\xD8",
            Otilde: "\xD5",
            Ouml: "\xD6",
            QUOT: '"',
            REG: "\xAE",
            THORN: "\xDE",
            Uacute: "\xDA",
            Ucirc: "\xDB",
            Ugrave: "\xD9",
            Uuml: "\xDC",
            Yacute: "\xDD",
            aacute: "\xE1",
            acirc: "\xE2",
            acute: "\xB4",
            aelig: "\xE6",
            agrave: "\xE0",
            amp: "&",
            aring: "\xE5",
            atilde: "\xE3",
            auml: "\xE4",
            brvbar: "\xA6",
            ccedil: "\xE7",
            cedil: "\xB8",
            cent: "\xA2",
            copy: "\xA9",
            curren: "\xA4",
            deg: "\xB0",
            divide: "\xF7",
            eacute: "\xE9",
            ecirc: "\xEA",
            egrave: "\xE8",
            eth: "\xF0",
            euml: "\xEB",
            frac12: "\xBD",
            frac14: "\xBC",
            frac34: "\xBE",
            gt: ">",
            iacute: "\xED",
            icirc: "\xEE",
            iexcl: "\xA1",
            igrave: "\xEC",
            iquest: "\xBF",
            iuml: "\xEF",
            laquo: "\xAB",
            lt: "<",
            macr: "\xAF",
            micro: "\xB5",
            middot: "\xB7",
            nbsp: "\xA0",
            not: "\xAC",
            ntilde: "\xF1",
            oacute: "\xF3",
            ocirc: "\xF4",
            ograve: "\xF2",
            ordf: "\xAA",
            ordm: "\xBA",
            oslash: "\xF8",
            otilde: "\xF5",
            ouml: "\xF6",
            para: "\xB6",
            plusmn: "\xB1",
            pound: "\xA3",
            quot: '"',
            raquo: "\xBB",
            reg: "\xAE",
            sect: "\xA7",
            shy: "\xAD",
            sup1: "\xB9",
            sup2: "\xB2",
            sup3: "\xB3",
            szlig: "\xDF",
            thorn: "\xFE",
            times: "\xD7",
            uacute: "\xFA",
            ucirc: "\xFB",
            ugrave: "\xF9",
            uml: "\xA8",
            uuml: "\xFC",
            yacute: "\xFD",
            yen: "\xA5",
            yuml: "\xFF"
        };
    }
});
var require_character_reference_invalid = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/character-reference-invalid/index.json" (exports, module) {
        module.exports = {
            "0": "\uFFFD",
            "128": "\u20AC",
            "130": "\u201A",
            "131": "\u0192",
            "132": "\u201E",
            "133": "\u2026",
            "134": "\u2020",
            "135": "\u2021",
            "136": "\u02C6",
            "137": "\u2030",
            "138": "\u0160",
            "139": "\u2039",
            "140": "\u0152",
            "142": "\u017D",
            "145": "\u2018",
            "146": "\u2019",
            "147": "\u201C",
            "148": "\u201D",
            "149": "\u2022",
            "150": "\u2013",
            "151": "\u2014",
            "152": "\u02DC",
            "153": "\u2122",
            "154": "\u0161",
            "155": "\u203A",
            "156": "\u0153",
            "158": "\u017E",
            "159": "\u0178"
        };
    }
});
var require_is_decimal = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/is-decimal/index.js" (exports, module) {
        module.exports = decimal;
        function decimal(character) {
            var code = typeof character == "string" ? character.charCodeAt(0) : character;
            return code >= 48 && code <= 57;
        }
    }
});
var require_is_hexadecimal = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/is-hexadecimal/index.js" (exports, module) {
        module.exports = hexadecimal;
        function hexadecimal(character) {
            var code = typeof character == "string" ? character.charCodeAt(0) : character;
            return code >= 97 && code <= 102 || code >= 65 && code <= 70 || code >= 48 && code <= 57;
        }
    }
});
var require_is_alphabetical = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/is-alphabetical/index.js" (exports, module) {
        module.exports = alphabetical;
        function alphabetical(character) {
            var code = typeof character == "string" ? character.charCodeAt(0) : character;
            return code >= 97 && code <= 122 || code >= 65 && code <= 90;
        }
    }
});
var require_is_alphanumerical = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/is-alphanumerical/index.js" (exports, module) {
        var alphabetical = require_is_alphabetical(), decimal = require_is_decimal();
        module.exports = alphanumerical;
        function alphanumerical(character) {
            return alphabetical(character) || decimal(character);
        }
    }
});
var require_character_entities = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/parse-entities/node_modules/character-entities/index.json" (exports, module) {
        module.exports = {
            AEli: "\xC6",
            AElig: "\xC6",
            AM: "&",
            AMP: "&",
            Aacut: "\xC1",
            Aacute: "\xC1",
            Abreve: "\u0102",
            Acir: "\xC2",
            Acirc: "\xC2",
            Acy: "\u0410",
            Afr: "\u{1D504}",
            Agrav: "\xC0",
            Agrave: "\xC0",
            Alpha: "\u0391",
            Amacr: "\u0100",
            And: "\u2A53",
            Aogon: "\u0104",
            Aopf: "\u{1D538}",
            ApplyFunction: "\u2061",
            Arin: "\xC5",
            Aring: "\xC5",
            Ascr: "\u{1D49C}",
            Assign: "\u2254",
            Atild: "\xC3",
            Atilde: "\xC3",
            Aum: "\xC4",
            Auml: "\xC4",
            Backslash: "\u2216",
            Barv: "\u2AE7",
            Barwed: "\u2306",
            Bcy: "\u0411",
            Because: "\u2235",
            Bernoullis: "\u212C",
            Beta: "\u0392",
            Bfr: "\u{1D505}",
            Bopf: "\u{1D539}",
            Breve: "\u02D8",
            Bscr: "\u212C",
            Bumpeq: "\u224E",
            CHcy: "\u0427",
            COP: "\xA9",
            COPY: "\xA9",
            Cacute: "\u0106",
            Cap: "\u22D2",
            CapitalDifferentialD: "\u2145",
            Cayleys: "\u212D",
            Ccaron: "\u010C",
            Ccedi: "\xC7",
            Ccedil: "\xC7",
            Ccirc: "\u0108",
            Cconint: "\u2230",
            Cdot: "\u010A",
            Cedilla: "\xB8",
            CenterDot: "\xB7",
            Cfr: "\u212D",
            Chi: "\u03A7",
            CircleDot: "\u2299",
            CircleMinus: "\u2296",
            CirclePlus: "\u2295",
            CircleTimes: "\u2297",
            ClockwiseContourIntegral: "\u2232",
            CloseCurlyDoubleQuote: "\u201D",
            CloseCurlyQuote: "\u2019",
            Colon: "\u2237",
            Colone: "\u2A74",
            Congruent: "\u2261",
            Conint: "\u222F",
            ContourIntegral: "\u222E",
            Copf: "\u2102",
            Coproduct: "\u2210",
            CounterClockwiseContourIntegral: "\u2233",
            Cross: "\u2A2F",
            Cscr: "\u{1D49E}",
            Cup: "\u22D3",
            CupCap: "\u224D",
            DD: "\u2145",
            DDotrahd: "\u2911",
            DJcy: "\u0402",
            DScy: "\u0405",
            DZcy: "\u040F",
            Dagger: "\u2021",
            Darr: "\u21A1",
            Dashv: "\u2AE4",
            Dcaron: "\u010E",
            Dcy: "\u0414",
            Del: "\u2207",
            Delta: "\u0394",
            Dfr: "\u{1D507}",
            DiacriticalAcute: "\xB4",
            DiacriticalDot: "\u02D9",
            DiacriticalDoubleAcute: "\u02DD",
            DiacriticalGrave: "`",
            DiacriticalTilde: "\u02DC",
            Diamond: "\u22C4",
            DifferentialD: "\u2146",
            Dopf: "\u{1D53B}",
            Dot: "\xA8",
            DotDot: "\u20DC",
            DotEqual: "\u2250",
            DoubleContourIntegral: "\u222F",
            DoubleDot: "\xA8",
            DoubleDownArrow: "\u21D3",
            DoubleLeftArrow: "\u21D0",
            DoubleLeftRightArrow: "\u21D4",
            DoubleLeftTee: "\u2AE4",
            DoubleLongLeftArrow: "\u27F8",
            DoubleLongLeftRightArrow: "\u27FA",
            DoubleLongRightArrow: "\u27F9",
            DoubleRightArrow: "\u21D2",
            DoubleRightTee: "\u22A8",
            DoubleUpArrow: "\u21D1",
            DoubleUpDownArrow: "\u21D5",
            DoubleVerticalBar: "\u2225",
            DownArrow: "\u2193",
            DownArrowBar: "\u2913",
            DownArrowUpArrow: "\u21F5",
            DownBreve: "\u0311",
            DownLeftRightVector: "\u2950",
            DownLeftTeeVector: "\u295E",
            DownLeftVector: "\u21BD",
            DownLeftVectorBar: "\u2956",
            DownRightTeeVector: "\u295F",
            DownRightVector: "\u21C1",
            DownRightVectorBar: "\u2957",
            DownTee: "\u22A4",
            DownTeeArrow: "\u21A7",
            Downarrow: "\u21D3",
            Dscr: "\u{1D49F}",
            Dstrok: "\u0110",
            ENG: "\u014A",
            ET: "\xD0",
            ETH: "\xD0",
            Eacut: "\xC9",
            Eacute: "\xC9",
            Ecaron: "\u011A",
            Ecir: "\xCA",
            Ecirc: "\xCA",
            Ecy: "\u042D",
            Edot: "\u0116",
            Efr: "\u{1D508}",
            Egrav: "\xC8",
            Egrave: "\xC8",
            Element: "\u2208",
            Emacr: "\u0112",
            EmptySmallSquare: "\u25FB",
            EmptyVerySmallSquare: "\u25AB",
            Eogon: "\u0118",
            Eopf: "\u{1D53C}",
            Epsilon: "\u0395",
            Equal: "\u2A75",
            EqualTilde: "\u2242",
            Equilibrium: "\u21CC",
            Escr: "\u2130",
            Esim: "\u2A73",
            Eta: "\u0397",
            Eum: "\xCB",
            Euml: "\xCB",
            Exists: "\u2203",
            ExponentialE: "\u2147",
            Fcy: "\u0424",
            Ffr: "\u{1D509}",
            FilledSmallSquare: "\u25FC",
            FilledVerySmallSquare: "\u25AA",
            Fopf: "\u{1D53D}",
            ForAll: "\u2200",
            Fouriertrf: "\u2131",
            Fscr: "\u2131",
            GJcy: "\u0403",
            G: ">",
            GT: ">",
            Gamma: "\u0393",
            Gammad: "\u03DC",
            Gbreve: "\u011E",
            Gcedil: "\u0122",
            Gcirc: "\u011C",
            Gcy: "\u0413",
            Gdot: "\u0120",
            Gfr: "\u{1D50A}",
            Gg: "\u22D9",
            Gopf: "\u{1D53E}",
            GreaterEqual: "\u2265",
            GreaterEqualLess: "\u22DB",
            GreaterFullEqual: "\u2267",
            GreaterGreater: "\u2AA2",
            GreaterLess: "\u2277",
            GreaterSlantEqual: "\u2A7E",
            GreaterTilde: "\u2273",
            Gscr: "\u{1D4A2}",
            Gt: "\u226B",
            HARDcy: "\u042A",
            Hacek: "\u02C7",
            Hat: "^",
            Hcirc: "\u0124",
            Hfr: "\u210C",
            HilbertSpace: "\u210B",
            Hopf: "\u210D",
            HorizontalLine: "\u2500",
            Hscr: "\u210B",
            Hstrok: "\u0126",
            HumpDownHump: "\u224E",
            HumpEqual: "\u224F",
            IEcy: "\u0415",
            IJlig: "\u0132",
            IOcy: "\u0401",
            Iacut: "\xCD",
            Iacute: "\xCD",
            Icir: "\xCE",
            Icirc: "\xCE",
            Icy: "\u0418",
            Idot: "\u0130",
            Ifr: "\u2111",
            Igrav: "\xCC",
            Igrave: "\xCC",
            Im: "\u2111",
            Imacr: "\u012A",
            ImaginaryI: "\u2148",
            Implies: "\u21D2",
            Int: "\u222C",
            Integral: "\u222B",
            Intersection: "\u22C2",
            InvisibleComma: "\u2063",
            InvisibleTimes: "\u2062",
            Iogon: "\u012E",
            Iopf: "\u{1D540}",
            Iota: "\u0399",
            Iscr: "\u2110",
            Itilde: "\u0128",
            Iukcy: "\u0406",
            Ium: "\xCF",
            Iuml: "\xCF",
            Jcirc: "\u0134",
            Jcy: "\u0419",
            Jfr: "\u{1D50D}",
            Jopf: "\u{1D541}",
            Jscr: "\u{1D4A5}",
            Jsercy: "\u0408",
            Jukcy: "\u0404",
            KHcy: "\u0425",
            KJcy: "\u040C",
            Kappa: "\u039A",
            Kcedil: "\u0136",
            Kcy: "\u041A",
            Kfr: "\u{1D50E}",
            Kopf: "\u{1D542}",
            Kscr: "\u{1D4A6}",
            LJcy: "\u0409",
            L: "<",
            LT: "<",
            Lacute: "\u0139",
            Lambda: "\u039B",
            Lang: "\u27EA",
            Laplacetrf: "\u2112",
            Larr: "\u219E",
            Lcaron: "\u013D",
            Lcedil: "\u013B",
            Lcy: "\u041B",
            LeftAngleBracket: "\u27E8",
            LeftArrow: "\u2190",
            LeftArrowBar: "\u21E4",
            LeftArrowRightArrow: "\u21C6",
            LeftCeiling: "\u2308",
            LeftDoubleBracket: "\u27E6",
            LeftDownTeeVector: "\u2961",
            LeftDownVector: "\u21C3",
            LeftDownVectorBar: "\u2959",
            LeftFloor: "\u230A",
            LeftRightArrow: "\u2194",
            LeftRightVector: "\u294E",
            LeftTee: "\u22A3",
            LeftTeeArrow: "\u21A4",
            LeftTeeVector: "\u295A",
            LeftTriangle: "\u22B2",
            LeftTriangleBar: "\u29CF",
            LeftTriangleEqual: "\u22B4",
            LeftUpDownVector: "\u2951",
            LeftUpTeeVector: "\u2960",
            LeftUpVector: "\u21BF",
            LeftUpVectorBar: "\u2958",
            LeftVector: "\u21BC",
            LeftVectorBar: "\u2952",
            Leftarrow: "\u21D0",
            Leftrightarrow: "\u21D4",
            LessEqualGreater: "\u22DA",
            LessFullEqual: "\u2266",
            LessGreater: "\u2276",
            LessLess: "\u2AA1",
            LessSlantEqual: "\u2A7D",
            LessTilde: "\u2272",
            Lfr: "\u{1D50F}",
            Ll: "\u22D8",
            Lleftarrow: "\u21DA",
            Lmidot: "\u013F",
            LongLeftArrow: "\u27F5",
            LongLeftRightArrow: "\u27F7",
            LongRightArrow: "\u27F6",
            Longleftarrow: "\u27F8",
            Longleftrightarrow: "\u27FA",
            Longrightarrow: "\u27F9",
            Lopf: "\u{1D543}",
            LowerLeftArrow: "\u2199",
            LowerRightArrow: "\u2198",
            Lscr: "\u2112",
            Lsh: "\u21B0",
            Lstrok: "\u0141",
            Lt: "\u226A",
            Map: "\u2905",
            Mcy: "\u041C",
            MediumSpace: "\u205F",
            Mellintrf: "\u2133",
            Mfr: "\u{1D510}",
            MinusPlus: "\u2213",
            Mopf: "\u{1D544}",
            Mscr: "\u2133",
            Mu: "\u039C",
            NJcy: "\u040A",
            Nacute: "\u0143",
            Ncaron: "\u0147",
            Ncedil: "\u0145",
            Ncy: "\u041D",
            NegativeMediumSpace: "\u200B",
            NegativeThickSpace: "\u200B",
            NegativeThinSpace: "\u200B",
            NegativeVeryThinSpace: "\u200B",
            NestedGreaterGreater: "\u226B",
            NestedLessLess: "\u226A",
            NewLine: `
`,
            Nfr: "\u{1D511}",
            NoBreak: "\u2060",
            NonBreakingSpace: "\xA0",
            Nopf: "\u2115",
            Not: "\u2AEC",
            NotCongruent: "\u2262",
            NotCupCap: "\u226D",
            NotDoubleVerticalBar: "\u2226",
            NotElement: "\u2209",
            NotEqual: "\u2260",
            NotEqualTilde: "\u2242\u0338",
            NotExists: "\u2204",
            NotGreater: "\u226F",
            NotGreaterEqual: "\u2271",
            NotGreaterFullEqual: "\u2267\u0338",
            NotGreaterGreater: "\u226B\u0338",
            NotGreaterLess: "\u2279",
            NotGreaterSlantEqual: "\u2A7E\u0338",
            NotGreaterTilde: "\u2275",
            NotHumpDownHump: "\u224E\u0338",
            NotHumpEqual: "\u224F\u0338",
            NotLeftTriangle: "\u22EA",
            NotLeftTriangleBar: "\u29CF\u0338",
            NotLeftTriangleEqual: "\u22EC",
            NotLess: "\u226E",
            NotLessEqual: "\u2270",
            NotLessGreater: "\u2278",
            NotLessLess: "\u226A\u0338",
            NotLessSlantEqual: "\u2A7D\u0338",
            NotLessTilde: "\u2274",
            NotNestedGreaterGreater: "\u2AA2\u0338",
            NotNestedLessLess: "\u2AA1\u0338",
            NotPrecedes: "\u2280",
            NotPrecedesEqual: "\u2AAF\u0338",
            NotPrecedesSlantEqual: "\u22E0",
            NotReverseElement: "\u220C",
            NotRightTriangle: "\u22EB",
            NotRightTriangleBar: "\u29D0\u0338",
            NotRightTriangleEqual: "\u22ED",
            NotSquareSubset: "\u228F\u0338",
            NotSquareSubsetEqual: "\u22E2",
            NotSquareSuperset: "\u2290\u0338",
            NotSquareSupersetEqual: "\u22E3",
            NotSubset: "\u2282\u20D2",
            NotSubsetEqual: "\u2288",
            NotSucceeds: "\u2281",
            NotSucceedsEqual: "\u2AB0\u0338",
            NotSucceedsSlantEqual: "\u22E1",
            NotSucceedsTilde: "\u227F\u0338",
            NotSuperset: "\u2283\u20D2",
            NotSupersetEqual: "\u2289",
            NotTilde: "\u2241",
            NotTildeEqual: "\u2244",
            NotTildeFullEqual: "\u2247",
            NotTildeTilde: "\u2249",
            NotVerticalBar: "\u2224",
            Nscr: "\u{1D4A9}",
            Ntild: "\xD1",
            Ntilde: "\xD1",
            Nu: "\u039D",
            OElig: "\u0152",
            Oacut: "\xD3",
            Oacute: "\xD3",
            Ocir: "\xD4",
            Ocirc: "\xD4",
            Ocy: "\u041E",
            Odblac: "\u0150",
            Ofr: "\u{1D512}",
            Ograv: "\xD2",
            Ograve: "\xD2",
            Omacr: "\u014C",
            Omega: "\u03A9",
            Omicron: "\u039F",
            Oopf: "\u{1D546}",
            OpenCurlyDoubleQuote: "\u201C",
            OpenCurlyQuote: "\u2018",
            Or: "\u2A54",
            Oscr: "\u{1D4AA}",
            Oslas: "\xD8",
            Oslash: "\xD8",
            Otild: "\xD5",
            Otilde: "\xD5",
            Otimes: "\u2A37",
            Oum: "\xD6",
            Ouml: "\xD6",
            OverBar: "\u203E",
            OverBrace: "\u23DE",
            OverBracket: "\u23B4",
            OverParenthesis: "\u23DC",
            PartialD: "\u2202",
            Pcy: "\u041F",
            Pfr: "\u{1D513}",
            Phi: "\u03A6",
            Pi: "\u03A0",
            PlusMinus: "\xB1",
            Poincareplane: "\u210C",
            Popf: "\u2119",
            Pr: "\u2ABB",
            Precedes: "\u227A",
            PrecedesEqual: "\u2AAF",
            PrecedesSlantEqual: "\u227C",
            PrecedesTilde: "\u227E",
            Prime: "\u2033",
            Product: "\u220F",
            Proportion: "\u2237",
            Proportional: "\u221D",
            Pscr: "\u{1D4AB}",
            Psi: "\u03A8",
            QUO: '"',
            QUOT: '"',
            Qfr: "\u{1D514}",
            Qopf: "\u211A",
            Qscr: "\u{1D4AC}",
            RBarr: "\u2910",
            RE: "\xAE",
            REG: "\xAE",
            Racute: "\u0154",
            Rang: "\u27EB",
            Rarr: "\u21A0",
            Rarrtl: "\u2916",
            Rcaron: "\u0158",
            Rcedil: "\u0156",
            Rcy: "\u0420",
            Re: "\u211C",
            ReverseElement: "\u220B",
            ReverseEquilibrium: "\u21CB",
            ReverseUpEquilibrium: "\u296F",
            Rfr: "\u211C",
            Rho: "\u03A1",
            RightAngleBracket: "\u27E9",
            RightArrow: "\u2192",
            RightArrowBar: "\u21E5",
            RightArrowLeftArrow: "\u21C4",
            RightCeiling: "\u2309",
            RightDoubleBracket: "\u27E7",
            RightDownTeeVector: "\u295D",
            RightDownVector: "\u21C2",
            RightDownVectorBar: "\u2955",
            RightFloor: "\u230B",
            RightTee: "\u22A2",
            RightTeeArrow: "\u21A6",
            RightTeeVector: "\u295B",
            RightTriangle: "\u22B3",
            RightTriangleBar: "\u29D0",
            RightTriangleEqual: "\u22B5",
            RightUpDownVector: "\u294F",
            RightUpTeeVector: "\u295C",
            RightUpVector: "\u21BE",
            RightUpVectorBar: "\u2954",
            RightVector: "\u21C0",
            RightVectorBar: "\u2953",
            Rightarrow: "\u21D2",
            Ropf: "\u211D",
            RoundImplies: "\u2970",
            Rrightarrow: "\u21DB",
            Rscr: "\u211B",
            Rsh: "\u21B1",
            RuleDelayed: "\u29F4",
            SHCHcy: "\u0429",
            SHcy: "\u0428",
            SOFTcy: "\u042C",
            Sacute: "\u015A",
            Sc: "\u2ABC",
            Scaron: "\u0160",
            Scedil: "\u015E",
            Scirc: "\u015C",
            Scy: "\u0421",
            Sfr: "\u{1D516}",
            ShortDownArrow: "\u2193",
            ShortLeftArrow: "\u2190",
            ShortRightArrow: "\u2192",
            ShortUpArrow: "\u2191",
            Sigma: "\u03A3",
            SmallCircle: "\u2218",
            Sopf: "\u{1D54A}",
            Sqrt: "\u221A",
            Square: "\u25A1",
            SquareIntersection: "\u2293",
            SquareSubset: "\u228F",
            SquareSubsetEqual: "\u2291",
            SquareSuperset: "\u2290",
            SquareSupersetEqual: "\u2292",
            SquareUnion: "\u2294",
            Sscr: "\u{1D4AE}",
            Star: "\u22C6",
            Sub: "\u22D0",
            Subset: "\u22D0",
            SubsetEqual: "\u2286",
            Succeeds: "\u227B",
            SucceedsEqual: "\u2AB0",
            SucceedsSlantEqual: "\u227D",
            SucceedsTilde: "\u227F",
            SuchThat: "\u220B",
            Sum: "\u2211",
            Sup: "\u22D1",
            Superset: "\u2283",
            SupersetEqual: "\u2287",
            Supset: "\u22D1",
            THOR: "\xDE",
            THORN: "\xDE",
            TRADE: "\u2122",
            TSHcy: "\u040B",
            TScy: "\u0426",
            Tab: "	",
            Tau: "\u03A4",
            Tcaron: "\u0164",
            Tcedil: "\u0162",
            Tcy: "\u0422",
            Tfr: "\u{1D517}",
            Therefore: "\u2234",
            Theta: "\u0398",
            ThickSpace: "\u205F\u200A",
            ThinSpace: "\u2009",
            Tilde: "\u223C",
            TildeEqual: "\u2243",
            TildeFullEqual: "\u2245",
            TildeTilde: "\u2248",
            Topf: "\u{1D54B}",
            TripleDot: "\u20DB",
            Tscr: "\u{1D4AF}",
            Tstrok: "\u0166",
            Uacut: "\xDA",
            Uacute: "\xDA",
            Uarr: "\u219F",
            Uarrocir: "\u2949",
            Ubrcy: "\u040E",
            Ubreve: "\u016C",
            Ucir: "\xDB",
            Ucirc: "\xDB",
            Ucy: "\u0423",
            Udblac: "\u0170",
            Ufr: "\u{1D518}",
            Ugrav: "\xD9",
            Ugrave: "\xD9",
            Umacr: "\u016A",
            UnderBar: "_",
            UnderBrace: "\u23DF",
            UnderBracket: "\u23B5",
            UnderParenthesis: "\u23DD",
            Union: "\u22C3",
            UnionPlus: "\u228E",
            Uogon: "\u0172",
            Uopf: "\u{1D54C}",
            UpArrow: "\u2191",
            UpArrowBar: "\u2912",
            UpArrowDownArrow: "\u21C5",
            UpDownArrow: "\u2195",
            UpEquilibrium: "\u296E",
            UpTee: "\u22A5",
            UpTeeArrow: "\u21A5",
            Uparrow: "\u21D1",
            Updownarrow: "\u21D5",
            UpperLeftArrow: "\u2196",
            UpperRightArrow: "\u2197",
            Upsi: "\u03D2",
            Upsilon: "\u03A5",
            Uring: "\u016E",
            Uscr: "\u{1D4B0}",
            Utilde: "\u0168",
            Uum: "\xDC",
            Uuml: "\xDC",
            VDash: "\u22AB",
            Vbar: "\u2AEB",
            Vcy: "\u0412",
            Vdash: "\u22A9",
            Vdashl: "\u2AE6",
            Vee: "\u22C1",
            Verbar: "\u2016",
            Vert: "\u2016",
            VerticalBar: "\u2223",
            VerticalLine: "|",
            VerticalSeparator: "\u2758",
            VerticalTilde: "\u2240",
            VeryThinSpace: "\u200A",
            Vfr: "\u{1D519}",
            Vopf: "\u{1D54D}",
            Vscr: "\u{1D4B1}",
            Vvdash: "\u22AA",
            Wcirc: "\u0174",
            Wedge: "\u22C0",
            Wfr: "\u{1D51A}",
            Wopf: "\u{1D54E}",
            Wscr: "\u{1D4B2}",
            Xfr: "\u{1D51B}",
            Xi: "\u039E",
            Xopf: "\u{1D54F}",
            Xscr: "\u{1D4B3}",
            YAcy: "\u042F",
            YIcy: "\u0407",
            YUcy: "\u042E",
            Yacut: "\xDD",
            Yacute: "\xDD",
            Ycirc: "\u0176",
            Ycy: "\u042B",
            Yfr: "\u{1D51C}",
            Yopf: "\u{1D550}",
            Yscr: "\u{1D4B4}",
            Yuml: "\u0178",
            ZHcy: "\u0416",
            Zacute: "\u0179",
            Zcaron: "\u017D",
            Zcy: "\u0417",
            Zdot: "\u017B",
            ZeroWidthSpace: "\u200B",
            Zeta: "\u0396",
            Zfr: "\u2128",
            Zopf: "\u2124",
            Zscr: "\u{1D4B5}",
            aacut: "\xE1",
            aacute: "\xE1",
            abreve: "\u0103",
            ac: "\u223E",
            acE: "\u223E\u0333",
            acd: "\u223F",
            acir: "\xE2",
            acirc: "\xE2",
            acut: "\xB4",
            acute: "\xB4",
            acy: "\u0430",
            aeli: "\xE6",
            aelig: "\xE6",
            af: "\u2061",
            afr: "\u{1D51E}",
            agrav: "\xE0",
            agrave: "\xE0",
            alefsym: "\u2135",
            aleph: "\u2135",
            alpha: "\u03B1",
            amacr: "\u0101",
            amalg: "\u2A3F",
            am: "&",
            amp: "&",
            and: "\u2227",
            andand: "\u2A55",
            andd: "\u2A5C",
            andslope: "\u2A58",
            andv: "\u2A5A",
            ang: "\u2220",
            ange: "\u29A4",
            angle: "\u2220",
            angmsd: "\u2221",
            angmsdaa: "\u29A8",
            angmsdab: "\u29A9",
            angmsdac: "\u29AA",
            angmsdad: "\u29AB",
            angmsdae: "\u29AC",
            angmsdaf: "\u29AD",
            angmsdag: "\u29AE",
            angmsdah: "\u29AF",
            angrt: "\u221F",
            angrtvb: "\u22BE",
            angrtvbd: "\u299D",
            angsph: "\u2222",
            angst: "\xC5",
            angzarr: "\u237C",
            aogon: "\u0105",
            aopf: "\u{1D552}",
            ap: "\u2248",
            apE: "\u2A70",
            apacir: "\u2A6F",
            ape: "\u224A",
            apid: "\u224B",
            apos: "'",
            approx: "\u2248",
            approxeq: "\u224A",
            arin: "\xE5",
            aring: "\xE5",
            ascr: "\u{1D4B6}",
            ast: "*",
            asymp: "\u2248",
            asympeq: "\u224D",
            atild: "\xE3",
            atilde: "\xE3",
            aum: "\xE4",
            auml: "\xE4",
            awconint: "\u2233",
            awint: "\u2A11",
            bNot: "\u2AED",
            backcong: "\u224C",
            backepsilon: "\u03F6",
            backprime: "\u2035",
            backsim: "\u223D",
            backsimeq: "\u22CD",
            barvee: "\u22BD",
            barwed: "\u2305",
            barwedge: "\u2305",
            bbrk: "\u23B5",
            bbrktbrk: "\u23B6",
            bcong: "\u224C",
            bcy: "\u0431",
            bdquo: "\u201E",
            becaus: "\u2235",
            because: "\u2235",
            bemptyv: "\u29B0",
            bepsi: "\u03F6",
            bernou: "\u212C",
            beta: "\u03B2",
            beth: "\u2136",
            between: "\u226C",
            bfr: "\u{1D51F}",
            bigcap: "\u22C2",
            bigcirc: "\u25EF",
            bigcup: "\u22C3",
            bigodot: "\u2A00",
            bigoplus: "\u2A01",
            bigotimes: "\u2A02",
            bigsqcup: "\u2A06",
            bigstar: "\u2605",
            bigtriangledown: "\u25BD",
            bigtriangleup: "\u25B3",
            biguplus: "\u2A04",
            bigvee: "\u22C1",
            bigwedge: "\u22C0",
            bkarow: "\u290D",
            blacklozenge: "\u29EB",
            blacksquare: "\u25AA",
            blacktriangle: "\u25B4",
            blacktriangledown: "\u25BE",
            blacktriangleleft: "\u25C2",
            blacktriangleright: "\u25B8",
            blank: "\u2423",
            blk12: "\u2592",
            blk14: "\u2591",
            blk34: "\u2593",
            block: "\u2588",
            bne: "=\u20E5",
            bnequiv: "\u2261\u20E5",
            bnot: "\u2310",
            bopf: "\u{1D553}",
            bot: "\u22A5",
            bottom: "\u22A5",
            bowtie: "\u22C8",
            boxDL: "\u2557",
            boxDR: "\u2554",
            boxDl: "\u2556",
            boxDr: "\u2553",
            boxH: "\u2550",
            boxHD: "\u2566",
            boxHU: "\u2569",
            boxHd: "\u2564",
            boxHu: "\u2567",
            boxUL: "\u255D",
            boxUR: "\u255A",
            boxUl: "\u255C",
            boxUr: "\u2559",
            boxV: "\u2551",
            boxVH: "\u256C",
            boxVL: "\u2563",
            boxVR: "\u2560",
            boxVh: "\u256B",
            boxVl: "\u2562",
            boxVr: "\u255F",
            boxbox: "\u29C9",
            boxdL: "\u2555",
            boxdR: "\u2552",
            boxdl: "\u2510",
            boxdr: "\u250C",
            boxh: "\u2500",
            boxhD: "\u2565",
            boxhU: "\u2568",
            boxhd: "\u252C",
            boxhu: "\u2534",
            boxminus: "\u229F",
            boxplus: "\u229E",
            boxtimes: "\u22A0",
            boxuL: "\u255B",
            boxuR: "\u2558",
            boxul: "\u2518",
            boxur: "\u2514",
            boxv: "\u2502",
            boxvH: "\u256A",
            boxvL: "\u2561",
            boxvR: "\u255E",
            boxvh: "\u253C",
            boxvl: "\u2524",
            boxvr: "\u251C",
            bprime: "\u2035",
            breve: "\u02D8",
            brvba: "\xA6",
            brvbar: "\xA6",
            bscr: "\u{1D4B7}",
            bsemi: "\u204F",
            bsim: "\u223D",
            bsime: "\u22CD",
            bsol: "\\",
            bsolb: "\u29C5",
            bsolhsub: "\u27C8",
            bull: "\u2022",
            bullet: "\u2022",
            bump: "\u224E",
            bumpE: "\u2AAE",
            bumpe: "\u224F",
            bumpeq: "\u224F",
            cacute: "\u0107",
            cap: "\u2229",
            capand: "\u2A44",
            capbrcup: "\u2A49",
            capcap: "\u2A4B",
            capcup: "\u2A47",
            capdot: "\u2A40",
            caps: "\u2229\uFE00",
            caret: "\u2041",
            caron: "\u02C7",
            ccaps: "\u2A4D",
            ccaron: "\u010D",
            ccedi: "\xE7",
            ccedil: "\xE7",
            ccirc: "\u0109",
            ccups: "\u2A4C",
            ccupssm: "\u2A50",
            cdot: "\u010B",
            cedi: "\xB8",
            cedil: "\xB8",
            cemptyv: "\u29B2",
            cen: "\xA2",
            cent: "\xA2",
            centerdot: "\xB7",
            cfr: "\u{1D520}",
            chcy: "\u0447",
            check: "\u2713",
            checkmark: "\u2713",
            chi: "\u03C7",
            cir: "\u25CB",
            cirE: "\u29C3",
            circ: "\u02C6",
            circeq: "\u2257",
            circlearrowleft: "\u21BA",
            circlearrowright: "\u21BB",
            circledR: "\xAE",
            circledS: "\u24C8",
            circledast: "\u229B",
            circledcirc: "\u229A",
            circleddash: "\u229D",
            cire: "\u2257",
            cirfnint: "\u2A10",
            cirmid: "\u2AEF",
            cirscir: "\u29C2",
            clubs: "\u2663",
            clubsuit: "\u2663",
            colon: ":",
            colone: "\u2254",
            coloneq: "\u2254",
            comma: ",",
            commat: "@",
            comp: "\u2201",
            compfn: "\u2218",
            complement: "\u2201",
            complexes: "\u2102",
            cong: "\u2245",
            congdot: "\u2A6D",
            conint: "\u222E",
            copf: "\u{1D554}",
            coprod: "\u2210",
            cop: "\xA9",
            copy: "\xA9",
            copysr: "\u2117",
            crarr: "\u21B5",
            cross: "\u2717",
            cscr: "\u{1D4B8}",
            csub: "\u2ACF",
            csube: "\u2AD1",
            csup: "\u2AD0",
            csupe: "\u2AD2",
            ctdot: "\u22EF",
            cudarrl: "\u2938",
            cudarrr: "\u2935",
            cuepr: "\u22DE",
            cuesc: "\u22DF",
            cularr: "\u21B6",
            cularrp: "\u293D",
            cup: "\u222A",
            cupbrcap: "\u2A48",
            cupcap: "\u2A46",
            cupcup: "\u2A4A",
            cupdot: "\u228D",
            cupor: "\u2A45",
            cups: "\u222A\uFE00",
            curarr: "\u21B7",
            curarrm: "\u293C",
            curlyeqprec: "\u22DE",
            curlyeqsucc: "\u22DF",
            curlyvee: "\u22CE",
            curlywedge: "\u22CF",
            curre: "\xA4",
            curren: "\xA4",
            curvearrowleft: "\u21B6",
            curvearrowright: "\u21B7",
            cuvee: "\u22CE",
            cuwed: "\u22CF",
            cwconint: "\u2232",
            cwint: "\u2231",
            cylcty: "\u232D",
            dArr: "\u21D3",
            dHar: "\u2965",
            dagger: "\u2020",
            daleth: "\u2138",
            darr: "\u2193",
            dash: "\u2010",
            dashv: "\u22A3",
            dbkarow: "\u290F",
            dblac: "\u02DD",
            dcaron: "\u010F",
            dcy: "\u0434",
            dd: "\u2146",
            ddagger: "\u2021",
            ddarr: "\u21CA",
            ddotseq: "\u2A77",
            de: "\xB0",
            deg: "\xB0",
            delta: "\u03B4",
            demptyv: "\u29B1",
            dfisht: "\u297F",
            dfr: "\u{1D521}",
            dharl: "\u21C3",
            dharr: "\u21C2",
            diam: "\u22C4",
            diamond: "\u22C4",
            diamondsuit: "\u2666",
            diams: "\u2666",
            die: "\xA8",
            digamma: "\u03DD",
            disin: "\u22F2",
            div: "\xF7",
            divid: "\xF7",
            divide: "\xF7",
            divideontimes: "\u22C7",
            divonx: "\u22C7",
            djcy: "\u0452",
            dlcorn: "\u231E",
            dlcrop: "\u230D",
            dollar: "$",
            dopf: "\u{1D555}",
            dot: "\u02D9",
            doteq: "\u2250",
            doteqdot: "\u2251",
            dotminus: "\u2238",
            dotplus: "\u2214",
            dotsquare: "\u22A1",
            doublebarwedge: "\u2306",
            downarrow: "\u2193",
            downdownarrows: "\u21CA",
            downharpoonleft: "\u21C3",
            downharpoonright: "\u21C2",
            drbkarow: "\u2910",
            drcorn: "\u231F",
            drcrop: "\u230C",
            dscr: "\u{1D4B9}",
            dscy: "\u0455",
            dsol: "\u29F6",
            dstrok: "\u0111",
            dtdot: "\u22F1",
            dtri: "\u25BF",
            dtrif: "\u25BE",
            duarr: "\u21F5",
            duhar: "\u296F",
            dwangle: "\u29A6",
            dzcy: "\u045F",
            dzigrarr: "\u27FF",
            eDDot: "\u2A77",
            eDot: "\u2251",
            eacut: "\xE9",
            eacute: "\xE9",
            easter: "\u2A6E",
            ecaron: "\u011B",
            ecir: "\xEA",
            ecirc: "\xEA",
            ecolon: "\u2255",
            ecy: "\u044D",
            edot: "\u0117",
            ee: "\u2147",
            efDot: "\u2252",
            efr: "\u{1D522}",
            eg: "\u2A9A",
            egrav: "\xE8",
            egrave: "\xE8",
            egs: "\u2A96",
            egsdot: "\u2A98",
            el: "\u2A99",
            elinters: "\u23E7",
            ell: "\u2113",
            els: "\u2A95",
            elsdot: "\u2A97",
            emacr: "\u0113",
            empty: "\u2205",
            emptyset: "\u2205",
            emptyv: "\u2205",
            emsp13: "\u2004",
            emsp14: "\u2005",
            emsp: "\u2003",
            eng: "\u014B",
            ensp: "\u2002",
            eogon: "\u0119",
            eopf: "\u{1D556}",
            epar: "\u22D5",
            eparsl: "\u29E3",
            eplus: "\u2A71",
            epsi: "\u03B5",
            epsilon: "\u03B5",
            epsiv: "\u03F5",
            eqcirc: "\u2256",
            eqcolon: "\u2255",
            eqsim: "\u2242",
            eqslantgtr: "\u2A96",
            eqslantless: "\u2A95",
            equals: "=",
            equest: "\u225F",
            equiv: "\u2261",
            equivDD: "\u2A78",
            eqvparsl: "\u29E5",
            erDot: "\u2253",
            erarr: "\u2971",
            escr: "\u212F",
            esdot: "\u2250",
            esim: "\u2242",
            eta: "\u03B7",
            et: "\xF0",
            eth: "\xF0",
            eum: "\xEB",
            euml: "\xEB",
            euro: "\u20AC",
            excl: "!",
            exist: "\u2203",
            expectation: "\u2130",
            exponentiale: "\u2147",
            fallingdotseq: "\u2252",
            fcy: "\u0444",
            female: "\u2640",
            ffilig: "\uFB03",
            fflig: "\uFB00",
            ffllig: "\uFB04",
            ffr: "\u{1D523}",
            filig: "\uFB01",
            fjlig: "fj",
            flat: "\u266D",
            fllig: "\uFB02",
            fltns: "\u25B1",
            fnof: "\u0192",
            fopf: "\u{1D557}",
            forall: "\u2200",
            fork: "\u22D4",
            forkv: "\u2AD9",
            fpartint: "\u2A0D",
            frac1: "\xBC",
            frac12: "\xBD",
            frac13: "\u2153",
            frac14: "\xBC",
            frac15: "\u2155",
            frac16: "\u2159",
            frac18: "\u215B",
            frac23: "\u2154",
            frac25: "\u2156",
            frac3: "\xBE",
            frac34: "\xBE",
            frac35: "\u2157",
            frac38: "\u215C",
            frac45: "\u2158",
            frac56: "\u215A",
            frac58: "\u215D",
            frac78: "\u215E",
            frasl: "\u2044",
            frown: "\u2322",
            fscr: "\u{1D4BB}",
            gE: "\u2267",
            gEl: "\u2A8C",
            gacute: "\u01F5",
            gamma: "\u03B3",
            gammad: "\u03DD",
            gap: "\u2A86",
            gbreve: "\u011F",
            gcirc: "\u011D",
            gcy: "\u0433",
            gdot: "\u0121",
            ge: "\u2265",
            gel: "\u22DB",
            geq: "\u2265",
            geqq: "\u2267",
            geqslant: "\u2A7E",
            ges: "\u2A7E",
            gescc: "\u2AA9",
            gesdot: "\u2A80",
            gesdoto: "\u2A82",
            gesdotol: "\u2A84",
            gesl: "\u22DB\uFE00",
            gesles: "\u2A94",
            gfr: "\u{1D524}",
            gg: "\u226B",
            ggg: "\u22D9",
            gimel: "\u2137",
            gjcy: "\u0453",
            gl: "\u2277",
            glE: "\u2A92",
            gla: "\u2AA5",
            glj: "\u2AA4",
            gnE: "\u2269",
            gnap: "\u2A8A",
            gnapprox: "\u2A8A",
            gne: "\u2A88",
            gneq: "\u2A88",
            gneqq: "\u2269",
            gnsim: "\u22E7",
            gopf: "\u{1D558}",
            grave: "`",
            gscr: "\u210A",
            gsim: "\u2273",
            gsime: "\u2A8E",
            gsiml: "\u2A90",
            g: ">",
            gt: ">",
            gtcc: "\u2AA7",
            gtcir: "\u2A7A",
            gtdot: "\u22D7",
            gtlPar: "\u2995",
            gtquest: "\u2A7C",
            gtrapprox: "\u2A86",
            gtrarr: "\u2978",
            gtrdot: "\u22D7",
            gtreqless: "\u22DB",
            gtreqqless: "\u2A8C",
            gtrless: "\u2277",
            gtrsim: "\u2273",
            gvertneqq: "\u2269\uFE00",
            gvnE: "\u2269\uFE00",
            hArr: "\u21D4",
            hairsp: "\u200A",
            half: "\xBD",
            hamilt: "\u210B",
            hardcy: "\u044A",
            harr: "\u2194",
            harrcir: "\u2948",
            harrw: "\u21AD",
            hbar: "\u210F",
            hcirc: "\u0125",
            hearts: "\u2665",
            heartsuit: "\u2665",
            hellip: "\u2026",
            hercon: "\u22B9",
            hfr: "\u{1D525}",
            hksearow: "\u2925",
            hkswarow: "\u2926",
            hoarr: "\u21FF",
            homtht: "\u223B",
            hookleftarrow: "\u21A9",
            hookrightarrow: "\u21AA",
            hopf: "\u{1D559}",
            horbar: "\u2015",
            hscr: "\u{1D4BD}",
            hslash: "\u210F",
            hstrok: "\u0127",
            hybull: "\u2043",
            hyphen: "\u2010",
            iacut: "\xED",
            iacute: "\xED",
            ic: "\u2063",
            icir: "\xEE",
            icirc: "\xEE",
            icy: "\u0438",
            iecy: "\u0435",
            iexc: "\xA1",
            iexcl: "\xA1",
            iff: "\u21D4",
            ifr: "\u{1D526}",
            igrav: "\xEC",
            igrave: "\xEC",
            ii: "\u2148",
            iiiint: "\u2A0C",
            iiint: "\u222D",
            iinfin: "\u29DC",
            iiota: "\u2129",
            ijlig: "\u0133",
            imacr: "\u012B",
            image: "\u2111",
            imagline: "\u2110",
            imagpart: "\u2111",
            imath: "\u0131",
            imof: "\u22B7",
            imped: "\u01B5",
            in: "\u2208",
            incare: "\u2105",
            infin: "\u221E",
            infintie: "\u29DD",
            inodot: "\u0131",
            int: "\u222B",
            intcal: "\u22BA",
            integers: "\u2124",
            intercal: "\u22BA",
            intlarhk: "\u2A17",
            intprod: "\u2A3C",
            iocy: "\u0451",
            iogon: "\u012F",
            iopf: "\u{1D55A}",
            iota: "\u03B9",
            iprod: "\u2A3C",
            iques: "\xBF",
            iquest: "\xBF",
            iscr: "\u{1D4BE}",
            isin: "\u2208",
            isinE: "\u22F9",
            isindot: "\u22F5",
            isins: "\u22F4",
            isinsv: "\u22F3",
            isinv: "\u2208",
            it: "\u2062",
            itilde: "\u0129",
            iukcy: "\u0456",
            ium: "\xEF",
            iuml: "\xEF",
            jcirc: "\u0135",
            jcy: "\u0439",
            jfr: "\u{1D527}",
            jmath: "\u0237",
            jopf: "\u{1D55B}",
            jscr: "\u{1D4BF}",
            jsercy: "\u0458",
            jukcy: "\u0454",
            kappa: "\u03BA",
            kappav: "\u03F0",
            kcedil: "\u0137",
            kcy: "\u043A",
            kfr: "\u{1D528}",
            kgreen: "\u0138",
            khcy: "\u0445",
            kjcy: "\u045C",
            kopf: "\u{1D55C}",
            kscr: "\u{1D4C0}",
            lAarr: "\u21DA",
            lArr: "\u21D0",
            lAtail: "\u291B",
            lBarr: "\u290E",
            lE: "\u2266",
            lEg: "\u2A8B",
            lHar: "\u2962",
            lacute: "\u013A",
            laemptyv: "\u29B4",
            lagran: "\u2112",
            lambda: "\u03BB",
            lang: "\u27E8",
            langd: "\u2991",
            langle: "\u27E8",
            lap: "\u2A85",
            laqu: "\xAB",
            laquo: "\xAB",
            larr: "\u2190",
            larrb: "\u21E4",
            larrbfs: "\u291F",
            larrfs: "\u291D",
            larrhk: "\u21A9",
            larrlp: "\u21AB",
            larrpl: "\u2939",
            larrsim: "\u2973",
            larrtl: "\u21A2",
            lat: "\u2AAB",
            latail: "\u2919",
            late: "\u2AAD",
            lates: "\u2AAD\uFE00",
            lbarr: "\u290C",
            lbbrk: "\u2772",
            lbrace: "{",
            lbrack: "[",
            lbrke: "\u298B",
            lbrksld: "\u298F",
            lbrkslu: "\u298D",
            lcaron: "\u013E",
            lcedil: "\u013C",
            lceil: "\u2308",
            lcub: "{",
            lcy: "\u043B",
            ldca: "\u2936",
            ldquo: "\u201C",
            ldquor: "\u201E",
            ldrdhar: "\u2967",
            ldrushar: "\u294B",
            ldsh: "\u21B2",
            le: "\u2264",
            leftarrow: "\u2190",
            leftarrowtail: "\u21A2",
            leftharpoondown: "\u21BD",
            leftharpoonup: "\u21BC",
            leftleftarrows: "\u21C7",
            leftrightarrow: "\u2194",
            leftrightarrows: "\u21C6",
            leftrightharpoons: "\u21CB",
            leftrightsquigarrow: "\u21AD",
            leftthreetimes: "\u22CB",
            leg: "\u22DA",
            leq: "\u2264",
            leqq: "\u2266",
            leqslant: "\u2A7D",
            les: "\u2A7D",
            lescc: "\u2AA8",
            lesdot: "\u2A7F",
            lesdoto: "\u2A81",
            lesdotor: "\u2A83",
            lesg: "\u22DA\uFE00",
            lesges: "\u2A93",
            lessapprox: "\u2A85",
            lessdot: "\u22D6",
            lesseqgtr: "\u22DA",
            lesseqqgtr: "\u2A8B",
            lessgtr: "\u2276",
            lesssim: "\u2272",
            lfisht: "\u297C",
            lfloor: "\u230A",
            lfr: "\u{1D529}",
            lg: "\u2276",
            lgE: "\u2A91",
            lhard: "\u21BD",
            lharu: "\u21BC",
            lharul: "\u296A",
            lhblk: "\u2584",
            ljcy: "\u0459",
            ll: "\u226A",
            llarr: "\u21C7",
            llcorner: "\u231E",
            llhard: "\u296B",
            lltri: "\u25FA",
            lmidot: "\u0140",
            lmoust: "\u23B0",
            lmoustache: "\u23B0",
            lnE: "\u2268",
            lnap: "\u2A89",
            lnapprox: "\u2A89",
            lne: "\u2A87",
            lneq: "\u2A87",
            lneqq: "\u2268",
            lnsim: "\u22E6",
            loang: "\u27EC",
            loarr: "\u21FD",
            lobrk: "\u27E6",
            longleftarrow: "\u27F5",
            longleftrightarrow: "\u27F7",
            longmapsto: "\u27FC",
            longrightarrow: "\u27F6",
            looparrowleft: "\u21AB",
            looparrowright: "\u21AC",
            lopar: "\u2985",
            lopf: "\u{1D55D}",
            loplus: "\u2A2D",
            lotimes: "\u2A34",
            lowast: "\u2217",
            lowbar: "_",
            loz: "\u25CA",
            lozenge: "\u25CA",
            lozf: "\u29EB",
            lpar: "(",
            lparlt: "\u2993",
            lrarr: "\u21C6",
            lrcorner: "\u231F",
            lrhar: "\u21CB",
            lrhard: "\u296D",
            lrm: "\u200E",
            lrtri: "\u22BF",
            lsaquo: "\u2039",
            lscr: "\u{1D4C1}",
            lsh: "\u21B0",
            lsim: "\u2272",
            lsime: "\u2A8D",
            lsimg: "\u2A8F",
            lsqb: "[",
            lsquo: "\u2018",
            lsquor: "\u201A",
            lstrok: "\u0142",
            l: "<",
            lt: "<",
            ltcc: "\u2AA6",
            ltcir: "\u2A79",
            ltdot: "\u22D6",
            lthree: "\u22CB",
            ltimes: "\u22C9",
            ltlarr: "\u2976",
            ltquest: "\u2A7B",
            ltrPar: "\u2996",
            ltri: "\u25C3",
            ltrie: "\u22B4",
            ltrif: "\u25C2",
            lurdshar: "\u294A",
            luruhar: "\u2966",
            lvertneqq: "\u2268\uFE00",
            lvnE: "\u2268\uFE00",
            mDDot: "\u223A",
            mac: "\xAF",
            macr: "\xAF",
            male: "\u2642",
            malt: "\u2720",
            maltese: "\u2720",
            map: "\u21A6",
            mapsto: "\u21A6",
            mapstodown: "\u21A7",
            mapstoleft: "\u21A4",
            mapstoup: "\u21A5",
            marker: "\u25AE",
            mcomma: "\u2A29",
            mcy: "\u043C",
            mdash: "\u2014",
            measuredangle: "\u2221",
            mfr: "\u{1D52A}",
            mho: "\u2127",
            micr: "\xB5",
            micro: "\xB5",
            mid: "\u2223",
            midast: "*",
            midcir: "\u2AF0",
            middo: "\xB7",
            middot: "\xB7",
            minus: "\u2212",
            minusb: "\u229F",
            minusd: "\u2238",
            minusdu: "\u2A2A",
            mlcp: "\u2ADB",
            mldr: "\u2026",
            mnplus: "\u2213",
            models: "\u22A7",
            mopf: "\u{1D55E}",
            mp: "\u2213",
            mscr: "\u{1D4C2}",
            mstpos: "\u223E",
            mu: "\u03BC",
            multimap: "\u22B8",
            mumap: "\u22B8",
            nGg: "\u22D9\u0338",
            nGt: "\u226B\u20D2",
            nGtv: "\u226B\u0338",
            nLeftarrow: "\u21CD",
            nLeftrightarrow: "\u21CE",
            nLl: "\u22D8\u0338",
            nLt: "\u226A\u20D2",
            nLtv: "\u226A\u0338",
            nRightarrow: "\u21CF",
            nVDash: "\u22AF",
            nVdash: "\u22AE",
            nabla: "\u2207",
            nacute: "\u0144",
            nang: "\u2220\u20D2",
            nap: "\u2249",
            napE: "\u2A70\u0338",
            napid: "\u224B\u0338",
            napos: "\u0149",
            napprox: "\u2249",
            natur: "\u266E",
            natural: "\u266E",
            naturals: "\u2115",
            nbs: "\xA0",
            nbsp: "\xA0",
            nbump: "\u224E\u0338",
            nbumpe: "\u224F\u0338",
            ncap: "\u2A43",
            ncaron: "\u0148",
            ncedil: "\u0146",
            ncong: "\u2247",
            ncongdot: "\u2A6D\u0338",
            ncup: "\u2A42",
            ncy: "\u043D",
            ndash: "\u2013",
            ne: "\u2260",
            neArr: "\u21D7",
            nearhk: "\u2924",
            nearr: "\u2197",
            nearrow: "\u2197",
            nedot: "\u2250\u0338",
            nequiv: "\u2262",
            nesear: "\u2928",
            nesim: "\u2242\u0338",
            nexist: "\u2204",
            nexists: "\u2204",
            nfr: "\u{1D52B}",
            ngE: "\u2267\u0338",
            nge: "\u2271",
            ngeq: "\u2271",
            ngeqq: "\u2267\u0338",
            ngeqslant: "\u2A7E\u0338",
            nges: "\u2A7E\u0338",
            ngsim: "\u2275",
            ngt: "\u226F",
            ngtr: "\u226F",
            nhArr: "\u21CE",
            nharr: "\u21AE",
            nhpar: "\u2AF2",
            ni: "\u220B",
            nis: "\u22FC",
            nisd: "\u22FA",
            niv: "\u220B",
            njcy: "\u045A",
            nlArr: "\u21CD",
            nlE: "\u2266\u0338",
            nlarr: "\u219A",
            nldr: "\u2025",
            nle: "\u2270",
            nleftarrow: "\u219A",
            nleftrightarrow: "\u21AE",
            nleq: "\u2270",
            nleqq: "\u2266\u0338",
            nleqslant: "\u2A7D\u0338",
            nles: "\u2A7D\u0338",
            nless: "\u226E",
            nlsim: "\u2274",
            nlt: "\u226E",
            nltri: "\u22EA",
            nltrie: "\u22EC",
            nmid: "\u2224",
            nopf: "\u{1D55F}",
            no: "\xAC",
            not: "\xAC",
            notin: "\u2209",
            notinE: "\u22F9\u0338",
            notindot: "\u22F5\u0338",
            notinva: "\u2209",
            notinvb: "\u22F7",
            notinvc: "\u22F6",
            notni: "\u220C",
            notniva: "\u220C",
            notnivb: "\u22FE",
            notnivc: "\u22FD",
            npar: "\u2226",
            nparallel: "\u2226",
            nparsl: "\u2AFD\u20E5",
            npart: "\u2202\u0338",
            npolint: "\u2A14",
            npr: "\u2280",
            nprcue: "\u22E0",
            npre: "\u2AAF\u0338",
            nprec: "\u2280",
            npreceq: "\u2AAF\u0338",
            nrArr: "\u21CF",
            nrarr: "\u219B",
            nrarrc: "\u2933\u0338",
            nrarrw: "\u219D\u0338",
            nrightarrow: "\u219B",
            nrtri: "\u22EB",
            nrtrie: "\u22ED",
            nsc: "\u2281",
            nsccue: "\u22E1",
            nsce: "\u2AB0\u0338",
            nscr: "\u{1D4C3}",
            nshortmid: "\u2224",
            nshortparallel: "\u2226",
            nsim: "\u2241",
            nsime: "\u2244",
            nsimeq: "\u2244",
            nsmid: "\u2224",
            nspar: "\u2226",
            nsqsube: "\u22E2",
            nsqsupe: "\u22E3",
            nsub: "\u2284",
            nsubE: "\u2AC5\u0338",
            nsube: "\u2288",
            nsubset: "\u2282\u20D2",
            nsubseteq: "\u2288",
            nsubseteqq: "\u2AC5\u0338",
            nsucc: "\u2281",
            nsucceq: "\u2AB0\u0338",
            nsup: "\u2285",
            nsupE: "\u2AC6\u0338",
            nsupe: "\u2289",
            nsupset: "\u2283\u20D2",
            nsupseteq: "\u2289",
            nsupseteqq: "\u2AC6\u0338",
            ntgl: "\u2279",
            ntild: "\xF1",
            ntilde: "\xF1",
            ntlg: "\u2278",
            ntriangleleft: "\u22EA",
            ntrianglelefteq: "\u22EC",
            ntriangleright: "\u22EB",
            ntrianglerighteq: "\u22ED",
            nu: "\u03BD",
            num: "#",
            numero: "\u2116",
            numsp: "\u2007",
            nvDash: "\u22AD",
            nvHarr: "\u2904",
            nvap: "\u224D\u20D2",
            nvdash: "\u22AC",
            nvge: "\u2265\u20D2",
            nvgt: ">\u20D2",
            nvinfin: "\u29DE",
            nvlArr: "\u2902",
            nvle: "\u2264\u20D2",
            nvlt: "<\u20D2",
            nvltrie: "\u22B4\u20D2",
            nvrArr: "\u2903",
            nvrtrie: "\u22B5\u20D2",
            nvsim: "\u223C\u20D2",
            nwArr: "\u21D6",
            nwarhk: "\u2923",
            nwarr: "\u2196",
            nwarrow: "\u2196",
            nwnear: "\u2927",
            oS: "\u24C8",
            oacut: "\xF3",
            oacute: "\xF3",
            oast: "\u229B",
            ocir: "\xF4",
            ocirc: "\xF4",
            ocy: "\u043E",
            odash: "\u229D",
            odblac: "\u0151",
            odiv: "\u2A38",
            odot: "\u2299",
            odsold: "\u29BC",
            oelig: "\u0153",
            ofcir: "\u29BF",
            ofr: "\u{1D52C}",
            ogon: "\u02DB",
            ograv: "\xF2",
            ograve: "\xF2",
            ogt: "\u29C1",
            ohbar: "\u29B5",
            ohm: "\u03A9",
            oint: "\u222E",
            olarr: "\u21BA",
            olcir: "\u29BE",
            olcross: "\u29BB",
            oline: "\u203E",
            olt: "\u29C0",
            omacr: "\u014D",
            omega: "\u03C9",
            omicron: "\u03BF",
            omid: "\u29B6",
            ominus: "\u2296",
            oopf: "\u{1D560}",
            opar: "\u29B7",
            operp: "\u29B9",
            oplus: "\u2295",
            or: "\u2228",
            orarr: "\u21BB",
            ord: "\xBA",
            order: "\u2134",
            orderof: "\u2134",
            ordf: "\xAA",
            ordm: "\xBA",
            origof: "\u22B6",
            oror: "\u2A56",
            orslope: "\u2A57",
            orv: "\u2A5B",
            oscr: "\u2134",
            oslas: "\xF8",
            oslash: "\xF8",
            osol: "\u2298",
            otild: "\xF5",
            otilde: "\xF5",
            otimes: "\u2297",
            otimesas: "\u2A36",
            oum: "\xF6",
            ouml: "\xF6",
            ovbar: "\u233D",
            par: "\xB6",
            para: "\xB6",
            parallel: "\u2225",
            parsim: "\u2AF3",
            parsl: "\u2AFD",
            part: "\u2202",
            pcy: "\u043F",
            percnt: "%",
            period: ".",
            permil: "\u2030",
            perp: "\u22A5",
            pertenk: "\u2031",
            pfr: "\u{1D52D}",
            phi: "\u03C6",
            phiv: "\u03D5",
            phmmat: "\u2133",
            phone: "\u260E",
            pi: "\u03C0",
            pitchfork: "\u22D4",
            piv: "\u03D6",
            planck: "\u210F",
            planckh: "\u210E",
            plankv: "\u210F",
            plus: "+",
            plusacir: "\u2A23",
            plusb: "\u229E",
            pluscir: "\u2A22",
            plusdo: "\u2214",
            plusdu: "\u2A25",
            pluse: "\u2A72",
            plusm: "\xB1",
            plusmn: "\xB1",
            plussim: "\u2A26",
            plustwo: "\u2A27",
            pm: "\xB1",
            pointint: "\u2A15",
            popf: "\u{1D561}",
            poun: "\xA3",
            pound: "\xA3",
            pr: "\u227A",
            prE: "\u2AB3",
            prap: "\u2AB7",
            prcue: "\u227C",
            pre: "\u2AAF",
            prec: "\u227A",
            precapprox: "\u2AB7",
            preccurlyeq: "\u227C",
            preceq: "\u2AAF",
            precnapprox: "\u2AB9",
            precneqq: "\u2AB5",
            precnsim: "\u22E8",
            precsim: "\u227E",
            prime: "\u2032",
            primes: "\u2119",
            prnE: "\u2AB5",
            prnap: "\u2AB9",
            prnsim: "\u22E8",
            prod: "\u220F",
            profalar: "\u232E",
            profline: "\u2312",
            profsurf: "\u2313",
            prop: "\u221D",
            propto: "\u221D",
            prsim: "\u227E",
            prurel: "\u22B0",
            pscr: "\u{1D4C5}",
            psi: "\u03C8",
            puncsp: "\u2008",
            qfr: "\u{1D52E}",
            qint: "\u2A0C",
            qopf: "\u{1D562}",
            qprime: "\u2057",
            qscr: "\u{1D4C6}",
            quaternions: "\u210D",
            quatint: "\u2A16",
            quest: "?",
            questeq: "\u225F",
            quo: '"',
            quot: '"',
            rAarr: "\u21DB",
            rArr: "\u21D2",
            rAtail: "\u291C",
            rBarr: "\u290F",
            rHar: "\u2964",
            race: "\u223D\u0331",
            racute: "\u0155",
            radic: "\u221A",
            raemptyv: "\u29B3",
            rang: "\u27E9",
            rangd: "\u2992",
            range: "\u29A5",
            rangle: "\u27E9",
            raqu: "\xBB",
            raquo: "\xBB",
            rarr: "\u2192",
            rarrap: "\u2975",
            rarrb: "\u21E5",
            rarrbfs: "\u2920",
            rarrc: "\u2933",
            rarrfs: "\u291E",
            rarrhk: "\u21AA",
            rarrlp: "\u21AC",
            rarrpl: "\u2945",
            rarrsim: "\u2974",
            rarrtl: "\u21A3",
            rarrw: "\u219D",
            ratail: "\u291A",
            ratio: "\u2236",
            rationals: "\u211A",
            rbarr: "\u290D",
            rbbrk: "\u2773",
            rbrace: "}",
            rbrack: "]",
            rbrke: "\u298C",
            rbrksld: "\u298E",
            rbrkslu: "\u2990",
            rcaron: "\u0159",
            rcedil: "\u0157",
            rceil: "\u2309",
            rcub: "}",
            rcy: "\u0440",
            rdca: "\u2937",
            rdldhar: "\u2969",
            rdquo: "\u201D",
            rdquor: "\u201D",
            rdsh: "\u21B3",
            real: "\u211C",
            realine: "\u211B",
            realpart: "\u211C",
            reals: "\u211D",
            rect: "\u25AD",
            re: "\xAE",
            reg: "\xAE",
            rfisht: "\u297D",
            rfloor: "\u230B",
            rfr: "\u{1D52F}",
            rhard: "\u21C1",
            rharu: "\u21C0",
            rharul: "\u296C",
            rho: "\u03C1",
            rhov: "\u03F1",
            rightarrow: "\u2192",
            rightarrowtail: "\u21A3",
            rightharpoondown: "\u21C1",
            rightharpoonup: "\u21C0",
            rightleftarrows: "\u21C4",
            rightleftharpoons: "\u21CC",
            rightrightarrows: "\u21C9",
            rightsquigarrow: "\u219D",
            rightthreetimes: "\u22CC",
            ring: "\u02DA",
            risingdotseq: "\u2253",
            rlarr: "\u21C4",
            rlhar: "\u21CC",
            rlm: "\u200F",
            rmoust: "\u23B1",
            rmoustache: "\u23B1",
            rnmid: "\u2AEE",
            roang: "\u27ED",
            roarr: "\u21FE",
            robrk: "\u27E7",
            ropar: "\u2986",
            ropf: "\u{1D563}",
            roplus: "\u2A2E",
            rotimes: "\u2A35",
            rpar: ")",
            rpargt: "\u2994",
            rppolint: "\u2A12",
            rrarr: "\u21C9",
            rsaquo: "\u203A",
            rscr: "\u{1D4C7}",
            rsh: "\u21B1",
            rsqb: "]",
            rsquo: "\u2019",
            rsquor: "\u2019",
            rthree: "\u22CC",
            rtimes: "\u22CA",
            rtri: "\u25B9",
            rtrie: "\u22B5",
            rtrif: "\u25B8",
            rtriltri: "\u29CE",
            ruluhar: "\u2968",
            rx: "\u211E",
            sacute: "\u015B",
            sbquo: "\u201A",
            sc: "\u227B",
            scE: "\u2AB4",
            scap: "\u2AB8",
            scaron: "\u0161",
            sccue: "\u227D",
            sce: "\u2AB0",
            scedil: "\u015F",
            scirc: "\u015D",
            scnE: "\u2AB6",
            scnap: "\u2ABA",
            scnsim: "\u22E9",
            scpolint: "\u2A13",
            scsim: "\u227F",
            scy: "\u0441",
            sdot: "\u22C5",
            sdotb: "\u22A1",
            sdote: "\u2A66",
            seArr: "\u21D8",
            searhk: "\u2925",
            searr: "\u2198",
            searrow: "\u2198",
            sec: "\xA7",
            sect: "\xA7",
            semi: ";",
            seswar: "\u2929",
            setminus: "\u2216",
            setmn: "\u2216",
            sext: "\u2736",
            sfr: "\u{1D530}",
            sfrown: "\u2322",
            sharp: "\u266F",
            shchcy: "\u0449",
            shcy: "\u0448",
            shortmid: "\u2223",
            shortparallel: "\u2225",
            sh: "\xAD",
            shy: "\xAD",
            sigma: "\u03C3",
            sigmaf: "\u03C2",
            sigmav: "\u03C2",
            sim: "\u223C",
            simdot: "\u2A6A",
            sime: "\u2243",
            simeq: "\u2243",
            simg: "\u2A9E",
            simgE: "\u2AA0",
            siml: "\u2A9D",
            simlE: "\u2A9F",
            simne: "\u2246",
            simplus: "\u2A24",
            simrarr: "\u2972",
            slarr: "\u2190",
            smallsetminus: "\u2216",
            smashp: "\u2A33",
            smeparsl: "\u29E4",
            smid: "\u2223",
            smile: "\u2323",
            smt: "\u2AAA",
            smte: "\u2AAC",
            smtes: "\u2AAC\uFE00",
            softcy: "\u044C",
            sol: "/",
            solb: "\u29C4",
            solbar: "\u233F",
            sopf: "\u{1D564}",
            spades: "\u2660",
            spadesuit: "\u2660",
            spar: "\u2225",
            sqcap: "\u2293",
            sqcaps: "\u2293\uFE00",
            sqcup: "\u2294",
            sqcups: "\u2294\uFE00",
            sqsub: "\u228F",
            sqsube: "\u2291",
            sqsubset: "\u228F",
            sqsubseteq: "\u2291",
            sqsup: "\u2290",
            sqsupe: "\u2292",
            sqsupset: "\u2290",
            sqsupseteq: "\u2292",
            squ: "\u25A1",
            square: "\u25A1",
            squarf: "\u25AA",
            squf: "\u25AA",
            srarr: "\u2192",
            sscr: "\u{1D4C8}",
            ssetmn: "\u2216",
            ssmile: "\u2323",
            sstarf: "\u22C6",
            star: "\u2606",
            starf: "\u2605",
            straightepsilon: "\u03F5",
            straightphi: "\u03D5",
            strns: "\xAF",
            sub: "\u2282",
            subE: "\u2AC5",
            subdot: "\u2ABD",
            sube: "\u2286",
            subedot: "\u2AC3",
            submult: "\u2AC1",
            subnE: "\u2ACB",
            subne: "\u228A",
            subplus: "\u2ABF",
            subrarr: "\u2979",
            subset: "\u2282",
            subseteq: "\u2286",
            subseteqq: "\u2AC5",
            subsetneq: "\u228A",
            subsetneqq: "\u2ACB",
            subsim: "\u2AC7",
            subsub: "\u2AD5",
            subsup: "\u2AD3",
            succ: "\u227B",
            succapprox: "\u2AB8",
            succcurlyeq: "\u227D",
            succeq: "\u2AB0",
            succnapprox: "\u2ABA",
            succneqq: "\u2AB6",
            succnsim: "\u22E9",
            succsim: "\u227F",
            sum: "\u2211",
            sung: "\u266A",
            sup: "\u2283",
            sup1: "\xB9",
            sup2: "\xB2",
            sup3: "\xB3",
            supE: "\u2AC6",
            supdot: "\u2ABE",
            supdsub: "\u2AD8",
            supe: "\u2287",
            supedot: "\u2AC4",
            suphsol: "\u27C9",
            suphsub: "\u2AD7",
            suplarr: "\u297B",
            supmult: "\u2AC2",
            supnE: "\u2ACC",
            supne: "\u228B",
            supplus: "\u2AC0",
            supset: "\u2283",
            supseteq: "\u2287",
            supseteqq: "\u2AC6",
            supsetneq: "\u228B",
            supsetneqq: "\u2ACC",
            supsim: "\u2AC8",
            supsub: "\u2AD4",
            supsup: "\u2AD6",
            swArr: "\u21D9",
            swarhk: "\u2926",
            swarr: "\u2199",
            swarrow: "\u2199",
            swnwar: "\u292A",
            szli: "\xDF",
            szlig: "\xDF",
            target: "\u2316",
            tau: "\u03C4",
            tbrk: "\u23B4",
            tcaron: "\u0165",
            tcedil: "\u0163",
            tcy: "\u0442",
            tdot: "\u20DB",
            telrec: "\u2315",
            tfr: "\u{1D531}",
            there4: "\u2234",
            therefore: "\u2234",
            theta: "\u03B8",
            thetasym: "\u03D1",
            thetav: "\u03D1",
            thickapprox: "\u2248",
            thicksim: "\u223C",
            thinsp: "\u2009",
            thkap: "\u2248",
            thksim: "\u223C",
            thor: "\xFE",
            thorn: "\xFE",
            tilde: "\u02DC",
            time: "\xD7",
            times: "\xD7",
            timesb: "\u22A0",
            timesbar: "\u2A31",
            timesd: "\u2A30",
            tint: "\u222D",
            toea: "\u2928",
            top: "\u22A4",
            topbot: "\u2336",
            topcir: "\u2AF1",
            topf: "\u{1D565}",
            topfork: "\u2ADA",
            tosa: "\u2929",
            tprime: "\u2034",
            trade: "\u2122",
            triangle: "\u25B5",
            triangledown: "\u25BF",
            triangleleft: "\u25C3",
            trianglelefteq: "\u22B4",
            triangleq: "\u225C",
            triangleright: "\u25B9",
            trianglerighteq: "\u22B5",
            tridot: "\u25EC",
            trie: "\u225C",
            triminus: "\u2A3A",
            triplus: "\u2A39",
            trisb: "\u29CD",
            tritime: "\u2A3B",
            trpezium: "\u23E2",
            tscr: "\u{1D4C9}",
            tscy: "\u0446",
            tshcy: "\u045B",
            tstrok: "\u0167",
            twixt: "\u226C",
            twoheadleftarrow: "\u219E",
            twoheadrightarrow: "\u21A0",
            uArr: "\u21D1",
            uHar: "\u2963",
            uacut: "\xFA",
            uacute: "\xFA",
            uarr: "\u2191",
            ubrcy: "\u045E",
            ubreve: "\u016D",
            ucir: "\xFB",
            ucirc: "\xFB",
            ucy: "\u0443",
            udarr: "\u21C5",
            udblac: "\u0171",
            udhar: "\u296E",
            ufisht: "\u297E",
            ufr: "\u{1D532}",
            ugrav: "\xF9",
            ugrave: "\xF9",
            uharl: "\u21BF",
            uharr: "\u21BE",
            uhblk: "\u2580",
            ulcorn: "\u231C",
            ulcorner: "\u231C",
            ulcrop: "\u230F",
            ultri: "\u25F8",
            umacr: "\u016B",
            um: "\xA8",
            uml: "\xA8",
            uogon: "\u0173",
            uopf: "\u{1D566}",
            uparrow: "\u2191",
            updownarrow: "\u2195",
            upharpoonleft: "\u21BF",
            upharpoonright: "\u21BE",
            uplus: "\u228E",
            upsi: "\u03C5",
            upsih: "\u03D2",
            upsilon: "\u03C5",
            upuparrows: "\u21C8",
            urcorn: "\u231D",
            urcorner: "\u231D",
            urcrop: "\u230E",
            uring: "\u016F",
            urtri: "\u25F9",
            uscr: "\u{1D4CA}",
            utdot: "\u22F0",
            utilde: "\u0169",
            utri: "\u25B5",
            utrif: "\u25B4",
            uuarr: "\u21C8",
            uum: "\xFC",
            uuml: "\xFC",
            uwangle: "\u29A7",
            vArr: "\u21D5",
            vBar: "\u2AE8",
            vBarv: "\u2AE9",
            vDash: "\u22A8",
            vangrt: "\u299C",
            varepsilon: "\u03F5",
            varkappa: "\u03F0",
            varnothing: "\u2205",
            varphi: "\u03D5",
            varpi: "\u03D6",
            varpropto: "\u221D",
            varr: "\u2195",
            varrho: "\u03F1",
            varsigma: "\u03C2",
            varsubsetneq: "\u228A\uFE00",
            varsubsetneqq: "\u2ACB\uFE00",
            varsupsetneq: "\u228B\uFE00",
            varsupsetneqq: "\u2ACC\uFE00",
            vartheta: "\u03D1",
            vartriangleleft: "\u22B2",
            vartriangleright: "\u22B3",
            vcy: "\u0432",
            vdash: "\u22A2",
            vee: "\u2228",
            veebar: "\u22BB",
            veeeq: "\u225A",
            vellip: "\u22EE",
            verbar: "|",
            vert: "|",
            vfr: "\u{1D533}",
            vltri: "\u22B2",
            vnsub: "\u2282\u20D2",
            vnsup: "\u2283\u20D2",
            vopf: "\u{1D567}",
            vprop: "\u221D",
            vrtri: "\u22B3",
            vscr: "\u{1D4CB}",
            vsubnE: "\u2ACB\uFE00",
            vsubne: "\u228A\uFE00",
            vsupnE: "\u2ACC\uFE00",
            vsupne: "\u228B\uFE00",
            vzigzag: "\u299A",
            wcirc: "\u0175",
            wedbar: "\u2A5F",
            wedge: "\u2227",
            wedgeq: "\u2259",
            weierp: "\u2118",
            wfr: "\u{1D534}",
            wopf: "\u{1D568}",
            wp: "\u2118",
            wr: "\u2240",
            wreath: "\u2240",
            wscr: "\u{1D4CC}",
            xcap: "\u22C2",
            xcirc: "\u25EF",
            xcup: "\u22C3",
            xdtri: "\u25BD",
            xfr: "\u{1D535}",
            xhArr: "\u27FA",
            xharr: "\u27F7",
            xi: "\u03BE",
            xlArr: "\u27F8",
            xlarr: "\u27F5",
            xmap: "\u27FC",
            xnis: "\u22FB",
            xodot: "\u2A00",
            xopf: "\u{1D569}",
            xoplus: "\u2A01",
            xotime: "\u2A02",
            xrArr: "\u27F9",
            xrarr: "\u27F6",
            xscr: "\u{1D4CD}",
            xsqcup: "\u2A06",
            xuplus: "\u2A04",
            xutri: "\u25B3",
            xvee: "\u22C1",
            xwedge: "\u22C0",
            yacut: "\xFD",
            yacute: "\xFD",
            yacy: "\u044F",
            ycirc: "\u0177",
            ycy: "\u044B",
            ye: "\xA5",
            yen: "\xA5",
            yfr: "\u{1D536}",
            yicy: "\u0457",
            yopf: "\u{1D56A}",
            yscr: "\u{1D4CE}",
            yucy: "\u044E",
            yum: "\xFF",
            yuml: "\xFF",
            zacute: "\u017A",
            zcaron: "\u017E",
            zcy: "\u0437",
            zdot: "\u017C",
            zeetrf: "\u2128",
            zeta: "\u03B6",
            zfr: "\u{1D537}",
            zhcy: "\u0436",
            zigrarr: "\u21DD",
            zopf: "\u{1D56B}",
            zscr: "\u{1D4CF}",
            zwj: "\u200D",
            zwnj: "\u200C"
        };
    }
});
var require_decode_entity = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/parse-entities/decode-entity.js" (exports, module) {
        var characterEntities = require_character_entities();
        module.exports = decodeEntity;
        var own = {}.hasOwnProperty;
        function decodeEntity(characters) {
            return own.call(characterEntities, characters) ? characterEntities[characters] : !1;
        }
    }
});
var require_parse_entities = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/parse-entities/index.js" (exports, module) {
        var legacy = require_character_entities_legacy(), invalid = require_character_reference_invalid(), decimal = require_is_decimal(), hexadecimal = require_is_hexadecimal(), alphanumerical = require_is_alphanumerical(), decodeEntity = require_decode_entity();
        module.exports = parseEntities;
        var own = {}.hasOwnProperty, fromCharCode = String.fromCharCode, noop = Function.prototype, defaults = {
            warning: null,
            reference: null,
            text: null,
            warningContext: null,
            referenceContext: null,
            textContext: null,
            position: {},
            additional: null,
            attribute: !1,
            nonTerminated: !0
        }, tab = 9, lineFeed = 10, formFeed = 12, space = 32, ampersand = 38, semicolon = 59, lessThan = 60, equalsTo = 61, numberSign = 35, uppercaseX = 88, lowercaseX = 120, replacementCharacter = 65533, name = "named", hexa = "hexadecimal", deci = "decimal", bases = {};
        bases[hexa] = 16;
        bases[deci] = 10;
        var tests = {};
        tests[name] = alphanumerical;
        tests[deci] = decimal;
        tests[hexa] = hexadecimal;
        var namedNotTerminated = 1, numericNotTerminated = 2, namedEmpty = 3, numericEmpty = 4, namedUnknown = 5, numericDisallowed = 6, numericProhibited = 7, messages = {};
        messages[namedNotTerminated] = "Named character references must be terminated by a semicolon";
        messages[numericNotTerminated] = "Numeric character references must be terminated by a semicolon";
        messages[namedEmpty] = "Named character references cannot be empty";
        messages[numericEmpty] = "Numeric character references cannot be empty";
        messages[namedUnknown] = "Named character references must be known";
        messages[numericDisallowed] = "Numeric character references cannot be disallowed";
        messages[numericProhibited] = "Numeric character references cannot be outside the permissible Unicode range";
        function parseEntities(value, options) {
            var settings = {}, option, key;
            options || (options = {});
            for(key in defaults)option = options[key], settings[key] = option ?? defaults[key];
            return (settings.position.indent || settings.position.start) && (settings.indent = settings.position.indent || [], settings.position = settings.position.start), parse(value, settings);
        }
        function parse(value, settings) {
            var additional = settings.additional, nonTerminated = settings.nonTerminated, handleText = settings.text, handleReference = settings.reference, handleWarning = settings.warning, textContext = settings.textContext, referenceContext = settings.referenceContext, warningContext = settings.warningContext, pos = settings.position, indent = settings.indent || [], length = value.length, index = 0, lines = -1, column = pos.column || 1, line = pos.line || 1, queue = "", result = [], entityCharacters, namedEntity, terminated, characters, character, reference, following, warning, reason, output, entity, begin, start, type, test, prev, next, diff, end;
            for(typeof additional == "string" && (additional = additional.charCodeAt(0)), prev = now(), warning = handleWarning ? parseError : noop, index--, length++; ++index < length;)if (character === lineFeed && (column = indent[lines] || 1), character = value.charCodeAt(index), character === ampersand) {
                if (following = value.charCodeAt(index + 1), following === tab || following === lineFeed || following === formFeed || following === space || following === ampersand || following === lessThan || following !== following || additional && following === additional) {
                    queue += fromCharCode(character), column++;
                    continue;
                }
                for(start = index + 1, begin = start, end = start, following === numberSign ? (end = ++begin, following = value.charCodeAt(end), following === uppercaseX || following === lowercaseX ? (type = hexa, end = ++begin) : type = deci) : type = name, entityCharacters = "", entity = "", characters = "", test = tests[type], end--; ++end < length && (following = value.charCodeAt(end), !!test(following));)characters += fromCharCode(following), type === name && own.call(legacy, characters) && (entityCharacters = characters, entity = legacy[characters]);
                terminated = value.charCodeAt(end) === semicolon, terminated && (end++, namedEntity = type === name ? decodeEntity(characters) : !1, namedEntity && (entityCharacters = characters, entity = namedEntity)), diff = 1 + end - start, !terminated && !nonTerminated || (characters ? type === name ? (terminated && !entity ? warning(namedUnknown, 1) : (entityCharacters !== characters && (end = begin + entityCharacters.length, diff = 1 + end - begin, terminated = !1), terminated || (reason = entityCharacters ? namedNotTerminated : namedEmpty, settings.attribute ? (following = value.charCodeAt(end), following === equalsTo ? (warning(reason, diff), entity = null) : alphanumerical(following) ? entity = null : warning(reason, diff)) : warning(reason, diff))), reference = entity) : (terminated || warning(numericNotTerminated, diff), reference = parseInt(characters, bases[type]), prohibited(reference) ? (warning(numericProhibited, diff), reference = fromCharCode(replacementCharacter)) : reference in invalid ? (warning(numericDisallowed, diff), reference = invalid[reference]) : (output = "", disallowed(reference) && warning(numericDisallowed, diff), reference > 65535 && (reference -= 65536, output += fromCharCode(reference >>> 10 | 55296), reference = 56320 | reference & 1023), reference = output + fromCharCode(reference))) : type !== name && warning(numericEmpty, diff)), reference ? (flush(), prev = now(), index = end - 1, column += end - start + 1, result.push(reference), next = now(), next.offset++, handleReference && handleReference.call(referenceContext, reference, {
                    start: prev,
                    end: next
                }, value.slice(start - 1, end)), prev = next) : (characters = value.slice(start - 1, end), queue += characters, column += characters.length, index = end - 1);
            } else character === 10 && (line++, lines++, column = 0), character === character ? (queue += fromCharCode(character), column++) : flush();
            return result.join("");
            function now() {
                return {
                    line,
                    column,
                    offset: index + (pos.offset || 0)
                };
            }
            function parseError(code, offset) {
                var position = now();
                position.column += offset, position.offset += offset, handleWarning.call(warningContext, messages[code], position, code);
            }
            function flush() {
                queue && (result.push(queue), handleText && handleText.call(textContext, queue, {
                    start: prev,
                    end: now()
                }), queue = "");
            }
        }
        function prohibited(code) {
            return code >= 55296 && code <= 57343 || code > 1114111;
        }
        function disallowed(code) {
            return code >= 1 && code <= 8 || code === 11 || code >= 13 && code <= 31 || code >= 127 && code <= 159 || code >= 64976 && code <= 65007 || (code & 65535) === 65535 || (code & 65535) === 65534;
        }
    }
});
var require_prism_core = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/refractor/node_modules/prismjs/components/prism-core.js" (exports, module) {
        var _self = typeof window < "u" ? window : typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope ? self : {};
        var Prism = function(_self2) {
            var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i, uniqueId = 0, plainTextGrammar = {}, _ = {
                manual: _self2.Prism && _self2.Prism.manual,
                disableWorkerMessageHandler: _self2.Prism && _self2.Prism.disableWorkerMessageHandler,
                util: {
                    encode: function encode(tokens) {
                        return tokens instanceof Token ? new Token(tokens.type, encode(tokens.content), tokens.alias) : Array.isArray(tokens) ? tokens.map(encode) : tokens.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
                    },
                    type: function(o) {
                        return Object.prototype.toString.call(o).slice(8, -1);
                    },
                    objId: function(obj) {
                        return obj.__id || Object.defineProperty(obj, "__id", {
                            value: ++uniqueId
                        }), obj.__id;
                    },
                    clone: function deepClone(o, visited) {
                        visited = visited || {};
                        var clone, id;
                        switch(_.util.type(o)){
                            case "Object":
                                if (id = _.util.objId(o), visited[id]) return visited[id];
                                clone = {}, visited[id] = clone;
                                for(var key in o)o.hasOwnProperty(key) && (clone[key] = deepClone(o[key], visited));
                                return clone;
                            case "Array":
                                return id = _.util.objId(o), visited[id] ? visited[id] : (clone = [], visited[id] = clone, o.forEach(function(v, i) {
                                    clone[i] = deepClone(v, visited);
                                }), clone);
                            default:
                                return o;
                        }
                    },
                    getLanguage: function(element) {
                        for(; element;){
                            var m = lang.exec(element.className);
                            if (m) return m[1].toLowerCase();
                            element = element.parentElement;
                        }
                        return "none";
                    },
                    setLanguage: function(element, language) {
                        element.className = element.className.replace(RegExp(lang, "gi"), ""), element.classList.add("language-" + language);
                    },
                    currentScript: function() {
                        if (typeof document > "u") return null;
                        if ("currentScript" in document && true) return document.currentScript;
                        try {
                            throw new Error;
                        } catch (err) {
                            var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
                            if (src) {
                                var scripts = document.getElementsByTagName("script");
                                for(var i in scripts)if (scripts[i].src == src) return scripts[i];
                            }
                            return null;
                        }
                    },
                    isActive: function(element, className, defaultActivation) {
                        for(var no = "no-" + className; element;){
                            var classList = element.classList;
                            if (classList.contains(className)) return !0;
                            if (classList.contains(no)) return !1;
                            element = element.parentElement;
                        }
                        return !!defaultActivation;
                    }
                },
                languages: {
                    plain: plainTextGrammar,
                    plaintext: plainTextGrammar,
                    text: plainTextGrammar,
                    txt: plainTextGrammar,
                    extend: function(id, redef) {
                        var lang2 = _.util.clone(_.languages[id]);
                        for(var key in redef)lang2[key] = redef[key];
                        return lang2;
                    },
                    insertBefore: function(inside, before, insert, root) {
                        root = root || _.languages;
                        var grammar = root[inside], ret = {};
                        for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                            if (token == before) for(var newToken in insert)insert.hasOwnProperty(newToken) && (ret[newToken] = insert[newToken]);
                            insert.hasOwnProperty(token) || (ret[token] = grammar[token]);
                        }
                        var old = root[inside];
                        return root[inside] = ret, _.languages.DFS(_.languages, function(key, value) {
                            value === old && key != inside && (this[key] = ret);
                        }), ret;
                    },
                    DFS: function DFS(o, callback, type, visited) {
                        visited = visited || {};
                        var objId = _.util.objId;
                        for(var i in o)if (o.hasOwnProperty(i)) {
                            callback.call(o, i, o[i], type || i);
                            var property = o[i], propertyType = _.util.type(property);
                            propertyType === "Object" && !visited[objId(property)] ? (visited[objId(property)] = !0, DFS(property, callback, null, visited)) : propertyType === "Array" && !visited[objId(property)] && (visited[objId(property)] = !0, DFS(property, callback, i, visited));
                        }
                    }
                },
                plugins: {},
                highlightAll: function(async, callback) {
                    _.highlightAllUnder(document, async, callback);
                },
                highlightAllUnder: function(container, async, callback) {
                    var env = {
                        callback,
                        container,
                        selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
                    };
                    _.hooks.run("before-highlightall", env), env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector)), _.hooks.run("before-all-elements-highlight", env);
                    for(var i = 0, element; element = env.elements[i++];)_.highlightElement(element, async === !0, env.callback);
                },
                highlightElement: function(element, async, callback) {
                    var language = _.util.getLanguage(element), grammar = _.languages[language];
                    _.util.setLanguage(element, language);
                    var parent = element.parentElement;
                    parent && parent.nodeName.toLowerCase() === "pre" && _.util.setLanguage(parent, language);
                    var code = element.textContent, env = {
                        element,
                        language,
                        grammar,
                        code
                    };
                    function insertHighlightedCode(highlightedCode) {
                        env.highlightedCode = highlightedCode, _.hooks.run("before-insert", env), env.element.innerHTML = env.highlightedCode, _.hooks.run("after-highlight", env), _.hooks.run("complete", env), callback && callback.call(env.element);
                    }
                    if (_.hooks.run("before-sanity-check", env), parent = env.element.parentElement, parent && parent.nodeName.toLowerCase() === "pre" && !parent.hasAttribute("tabindex") && parent.setAttribute("tabindex", "0"), !env.code) {
                        _.hooks.run("complete", env), callback && callback.call(env.element);
                        return;
                    }
                    if (_.hooks.run("before-highlight", env), !env.grammar) {
                        insertHighlightedCode(_.util.encode(env.code));
                        return;
                    }
                    if (async && _self2.Worker) {
                        var worker = new Worker(_.filename);
                        worker.onmessage = function(evt) {
                            insertHighlightedCode(evt.data);
                        }, worker.postMessage(JSON.stringify({
                            language: env.language,
                            code: env.code,
                            immediateClose: !0
                        }));
                    } else insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
                },
                highlight: function(text, grammar, language) {
                    var env = {
                        code: text,
                        grammar,
                        language
                    };
                    if (_.hooks.run("before-tokenize", env), !env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
                    return env.tokens = _.tokenize(env.code, env.grammar), _.hooks.run("after-tokenize", env), Token.stringify(_.util.encode(env.tokens), env.language);
                },
                tokenize: function(text, grammar) {
                    var rest = grammar.rest;
                    if (rest) {
                        for(var token in rest)grammar[token] = rest[token];
                        delete grammar.rest;
                    }
                    var tokenList = new LinkedList;
                    return addAfter(tokenList, tokenList.head, text), matchGrammar(text, tokenList, grammar, tokenList.head, 0), toArray(tokenList);
                },
                hooks: {
                    all: {},
                    add: function(name, callback) {
                        var hooks = _.hooks.all;
                        hooks[name] = hooks[name] || [], hooks[name].push(callback);
                    },
                    run: function(name, env) {
                        var callbacks = _.hooks.all[name];
                        if (!(!callbacks || !callbacks.length)) for(var i = 0, callback; callback = callbacks[i++];)callback(env);
                    }
                },
                Token
            };
            _self2.Prism = _;
            function Token(type, content, alias, matchedStr) {
                this.type = type, this.content = content, this.alias = alias, this.length = (matchedStr || "").length | 0;
            }
            Token.stringify = function stringify(o, language) {
                if (typeof o == "string") return o;
                if (Array.isArray(o)) {
                    var s = "";
                    return o.forEach(function(e) {
                        s += stringify(e, language);
                    }), s;
                }
                var env = {
                    type: o.type,
                    content: stringify(o.content, language),
                    tag: "span",
                    classes: [
                        "token",
                        o.type
                    ],
                    attributes: {},
                    language
                }, aliases = o.alias;
                aliases && (Array.isArray(aliases) ? Array.prototype.push.apply(env.classes, aliases) : env.classes.push(aliases)), _.hooks.run("wrap", env);
                var attributes = "";
                for(var name in env.attributes)attributes += " " + name + '="' + (env.attributes[name] || "").replace(/"/g, "&quot;") + '"';
                return "<" + env.tag + ' class="' + env.classes.join(" ") + '"' + attributes + ">" + env.content + "</" + env.tag + ">";
            };
            function matchPattern(pattern, pos, text, lookbehind) {
                pattern.lastIndex = pos;
                var match = pattern.exec(text);
                if (match && lookbehind && match[1]) {
                    var lookbehindLength = match[1].length;
                    match.index += lookbehindLength, match[0] = match[0].slice(lookbehindLength);
                }
                return match;
            }
            function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
                for(var token in grammar)if (!(!grammar.hasOwnProperty(token) || !grammar[token])) {
                    var patterns = grammar[token];
                    patterns = Array.isArray(patterns) ? patterns : [
                        patterns
                    ];
                    for(var j = 0; j < patterns.length; ++j){
                        if (rematch && rematch.cause == token + "," + j) return;
                        var patternObj = patterns[j], inside = patternObj.inside, lookbehind = !!patternObj.lookbehind, greedy = !!patternObj.greedy, alias = patternObj.alias;
                        if (greedy && !patternObj.pattern.global) {
                            var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                            patternObj.pattern = RegExp(patternObj.pattern.source, flags + "g");
                        }
                        for(var pattern = patternObj.pattern || patternObj, currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail && !(rematch && pos >= rematch.reach); pos += currentNode.value.length, currentNode = currentNode.next){
                            var str = currentNode.value;
                            if (tokenList.length > text.length) return;
                            if (!(str instanceof Token)) {
                                var removeCount = 1, match;
                                if (greedy) {
                                    if (match = matchPattern(pattern, pos, text, lookbehind), !match || match.index >= text.length) break;
                                    var from = match.index, to = match.index + match[0].length, p = pos;
                                    for(p += currentNode.value.length; from >= p;)currentNode = currentNode.next, p += currentNode.value.length;
                                    if (p -= currentNode.value.length, pos = p, currentNode.value instanceof Token) continue;
                                    for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value == "string"); k = k.next)removeCount++, p += k.value.length;
                                    removeCount--, str = text.slice(pos, p), match.index -= pos;
                                } else if (match = matchPattern(pattern, 0, str, lookbehind), !match) continue;
                                var from = match.index, matchStr = match[0], before = str.slice(0, from), after = str.slice(from + matchStr.length), reach = pos + str.length;
                                rematch && reach > rematch.reach && (rematch.reach = reach);
                                var removeFrom = currentNode.prev;
                                before && (removeFrom = addAfter(tokenList, removeFrom, before), pos += before.length), removeRange(tokenList, removeFrom, removeCount);
                                var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                                if (currentNode = addAfter(tokenList, removeFrom, wrapped), after && addAfter(tokenList, currentNode, after), removeCount > 1) {
                                    var nestedRematch = {
                                        cause: token + "," + j,
                                        reach
                                    };
                                    matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch), rematch && nestedRematch.reach > rematch.reach && (rematch.reach = nestedRematch.reach);
                                }
                            }
                        }
                    }
                }
            }
            function LinkedList() {
                var head = {
                    value: null,
                    prev: null,
                    next: null
                }, tail = {
                    value: null,
                    prev: head,
                    next: null
                };
                head.next = tail, this.head = head, this.tail = tail, this.length = 0;
            }
            function addAfter(list, node, value) {
                var next = node.next, newNode = {
                    value,
                    prev: node,
                    next
                };
                return node.next = newNode, next.prev = newNode, list.length++, newNode;
            }
            function removeRange(list, node, count) {
                for(var next = node.next, i = 0; i < count && next !== list.tail; i++)next = next.next;
                node.next = next, next.prev = node, list.length -= i;
            }
            function toArray(list) {
                for(var array = [], node = list.head.next; node !== list.tail;)array.push(node.value), node = node.next;
                return array;
            }
            if (!_self2.document) return _self2.addEventListener && (_.disableWorkerMessageHandler || _self2.addEventListener("message", function(evt) {
                var message = JSON.parse(evt.data), lang2 = message.language, code = message.code, immediateClose = message.immediateClose;
                _self2.postMessage(_.highlight(code, _.languages[lang2], lang2)), immediateClose && _self2.close();
            }, !1)), _;
            var script = _.util.currentScript();
            script && (_.filename = script.src, script.hasAttribute("data-manual") && (_.manual = !0));
            function highlightAutomaticallyCallback() {
                _.manual || _.highlightAll();
            }
            if (!_.manual) {
                var readyState = document.readyState;
                readyState === "loading" || readyState === "interactive" && script && script.defer ? document.addEventListener("DOMContentLoaded", highlightAutomaticallyCallback) : window.requestAnimationFrame ? window.requestAnimationFrame(highlightAutomaticallyCallback) : window.setTimeout(highlightAutomaticallyCallback, 16);
            }
            return _;
        }(_self);
        typeof module < "u" && module.exports && (module.exports = Prism);
        typeof global < "u" && (global.Prism = Prism);
    }
});
var require_core = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/refractor/core.js" (exports, module) {
        var ctx = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, restore = capture();
        ctx.Prism = {
            manual: !0,
            disableWorkerMessageHandler: !0
        };
        var h = require_hastscript(), decode = require_parse_entities(), Prism = require_prism_core(), markup = (0, _chunkDHRX2IL7Mjs.require_markup)(), css = (0, _chunkCW4JFC2IMjs.require_css)(), clike = (0, _chunkUDRSICRZMjs.require_clike)(), js = (0, _chunkJ6EJ35VBMjs.require_javascript)();
        restore();
        var own = {}.hasOwnProperty;
        function Refractor() {}
        Refractor.prototype = Prism;
        var refract = new Refractor;
        module.exports = refract;
        refract.highlight = highlight;
        refract.register = register;
        refract.alias = alias;
        refract.registered = registered;
        refract.listLanguages = listLanguages;
        register(markup);
        register(css);
        register(clike);
        register(js);
        refract.util.encode = encode;
        refract.Token.stringify = stringify;
        function register(grammar) {
            if (typeof grammar != "function" || !grammar.displayName) throw new Error("Expected `function` for `grammar`, got `" + grammar + "`");
            refract.languages[grammar.displayName] === void 0 && grammar(refract);
        }
        function alias(name, alias2) {
            var languages = refract.languages, map = name, key, list, length, index;
            alias2 && (map = {}, map[name] = alias2);
            for(key in map)for(list = map[key], list = typeof list == "string" ? [
                list
            ] : list, length = list.length, index = -1; ++index < length;)languages[list[index]] = languages[key];
        }
        function highlight(value, name) {
            var sup = Prism.highlight, grammar;
            if (typeof value != "string") throw new Error("Expected `string` for `value`, got `" + value + "`");
            if (refract.util.type(name) === "Object") grammar = name, name = null;
            else {
                if (typeof name != "string") throw new Error("Expected `string` for `name`, got `" + name + "`");
                if (own.call(refract.languages, name)) grammar = refract.languages[name];
                else throw new Error("Unknown language: `" + name + "` is not registered");
            }
            return sup.call(this, value, grammar, name);
        }
        function registered(language) {
            if (typeof language != "string") throw new Error("Expected `string` for `language`, got `" + language + "`");
            return own.call(refract.languages, language);
        }
        function listLanguages() {
            var languages = refract.languages, list = [], language;
            for(language in languages)own.call(languages, language) && typeof languages[language] == "object" && list.push(language);
            return list;
        }
        function stringify(value, language, parent) {
            var env;
            return typeof value == "string" ? {
                type: "text",
                value
            } : refract.util.type(value) === "Array" ? stringifyAll(value, language) : (env = {
                type: value.type,
                content: refract.Token.stringify(value.content, language, parent),
                tag: "span",
                classes: [
                    "token",
                    value.type
                ],
                attributes: {},
                language,
                parent
            }, value.alias && (env.classes = env.classes.concat(value.alias)), refract.hooks.run("wrap", env), h(env.tag + "." + env.classes.join("."), attributes(env.attributes), env.content));
        }
        function stringifyAll(values, language) {
            for(var result = [], length = values.length, index = -1, value; ++index < length;)value = values[index], value !== "" && value !== null && value !== void 0 && result.push(value);
            for(index = -1, length = result.length; ++index < length;)value = result[index], result[index] = refract.Token.stringify(value, language, result);
            return result;
        }
        function encode(tokens) {
            return tokens;
        }
        function attributes(attrs) {
            var key;
            for(key in attrs)attrs[key] = decode(attrs[key]);
            return attrs;
        }
        function capture() {
            var defined = "Prism" in ctx, current = defined ? ctx.Prism : void 0;
            return restore2;
            function restore2() {
                defined ? ctx.Prism = current : delete ctx.Prism, defined = void 0, current = void 0;
            }
        }
    }
});

},{"./chunk-UDRSICRZ.mjs":"f54xE","./chunk-J6EJ35VB.mjs":"7Ry1g","./chunk-CW4JFC2I.mjs":"2AfZu","./chunk-DHRX2IL7.mjs":"hGrAv","./chunk-JRLSWQMA.mjs":"cGDqS","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"f54xE":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "require_clike", ()=>require_clike);
var _chunkJRLSWQMAMjs = require("./chunk-JRLSWQMA.mjs");
var require_clike = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/refractor/lang/clike.js" (exports, module) {
        module.exports = clike;
        clike.displayName = "clike";
        clike.aliases = [];
        function clike(Prism) {
            Prism.languages.clike = {
                comment: [
                    {
                        pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
                        lookbehind: !0,
                        greedy: !0
                    },
                    {
                        pattern: /(^|[^\\:])\/\/.*/,
                        lookbehind: !0,
                        greedy: !0
                    }
                ],
                string: {
                    pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
                    greedy: !0
                },
                "class-name": {
                    pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
                    lookbehind: !0,
                    inside: {
                        punctuation: /[.\\]/
                    }
                },
                keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
                boolean: /\b(?:false|true)\b/,
                function: /\b\w+(?=\()/,
                number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
                operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
                punctuation: /[{}[\];(),.:]/
            };
        }
    }
});

},{"./chunk-JRLSWQMA.mjs":"cGDqS","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"7Ry1g":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "require_javascript", ()=>require_javascript);
var _chunkJRLSWQMAMjs = require("./chunk-JRLSWQMA.mjs");
var require_javascript = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/refractor/lang/javascript.js" (exports, module) {
        module.exports = javascript;
        javascript.displayName = "javascript";
        javascript.aliases = [
            "js"
        ];
        function javascript(Prism) {
            Prism.languages.javascript = Prism.languages.extend("clike", {
                "class-name": [
                    Prism.languages.clike["class-name"],
                    {
                        pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
                        lookbehind: !0
                    }
                ],
                keyword: [
                    {
                        pattern: /((?:^|\})\s*)catch\b/,
                        lookbehind: !0
                    },
                    {
                        pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
                        lookbehind: !0
                    }
                ],
                function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
                number: {
                    pattern: RegExp(/(^|[^\w$])/.source + "(?:" + (/NaN|Infinity/.source + "|" + /0[bB][01]+(?:_[01]+)*n?/.source + "|" + /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + /\d+(?:_\d+)*n/.source + "|" + /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source),
                    lookbehind: !0
                },
                operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
            }), Prism.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, Prism.languages.insertBefore("javascript", "keyword", {
                regex: {
                    pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/,
                    lookbehind: !0,
                    greedy: !0,
                    inside: {
                        "regex-source": {
                            pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                            lookbehind: !0,
                            alias: "language-regex",
                            inside: Prism.languages.regex
                        },
                        "regex-delimiter": /^\/|\/$/,
                        "regex-flags": /^[a-z]+$/
                    }
                },
                "function-variable": {
                    pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
                    alias: "function"
                },
                parameter: [
                    {
                        pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
                        lookbehind: !0,
                        inside: Prism.languages.javascript
                    },
                    {
                        pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
                        lookbehind: !0,
                        inside: Prism.languages.javascript
                    },
                    {
                        pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
                        lookbehind: !0,
                        inside: Prism.languages.javascript
                    },
                    {
                        pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
                        lookbehind: !0,
                        inside: Prism.languages.javascript
                    }
                ],
                constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
            }), Prism.languages.insertBefore("javascript", "string", {
                hashbang: {
                    pattern: /^#!.*/,
                    greedy: !0,
                    alias: "comment"
                },
                "template-string": {
                    pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
                    greedy: !0,
                    inside: {
                        "template-punctuation": {
                            pattern: /^`|`$/,
                            alias: "string"
                        },
                        interpolation: {
                            pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                            lookbehind: !0,
                            inside: {
                                "interpolation-punctuation": {
                                    pattern: /^\$\{|\}$/,
                                    alias: "punctuation"
                                },
                                rest: Prism.languages.javascript
                            }
                        },
                        string: /[\s\S]+/
                    }
                },
                "string-property": {
                    pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
                    lookbehind: !0,
                    greedy: !0,
                    alias: "property"
                }
            }), Prism.languages.insertBefore("javascript", "operator", {
                "literal-property": {
                    pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
                    lookbehind: !0,
                    alias: "property"
                }
            }), Prism.languages.markup && (Prism.languages.markup.tag.addInlined("script", "javascript"), Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, "javascript")), Prism.languages.js = Prism.languages.javascript;
        }
    }
});

},{"./chunk-JRLSWQMA.mjs":"cGDqS","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"2AfZu":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "require_css", ()=>require_css);
var _chunkJRLSWQMAMjs = require("./chunk-JRLSWQMA.mjs");
var require_css = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/refractor/lang/css.js" (exports, module) {
        module.exports = css;
        css.displayName = "css";
        css.aliases = [];
        function css(Prism) {
            (function(Prism2) {
                var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
                Prism2.languages.css = {
                    comment: /\/\*[\s\S]*?\*\//,
                    atrule: {
                        pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
                        inside: {
                            rule: /^@[\w-]+/,
                            "selector-function-argument": {
                                pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                                lookbehind: !0,
                                alias: "selector"
                            },
                            keyword: {
                                pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                                lookbehind: !0
                            }
                        }
                    },
                    url: {
                        pattern: RegExp("\\burl\\((?:" + string.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
                        greedy: !0,
                        inside: {
                            function: /^url/i,
                            punctuation: /^\(|\)$/,
                            string: {
                                pattern: RegExp("^" + string.source + "$"),
                                alias: "url"
                            }
                        }
                    },
                    selector: {
                        pattern: RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + string.source + ")*(?=\\s*\\{)"),
                        lookbehind: !0
                    },
                    string: {
                        pattern: string,
                        greedy: !0
                    },
                    property: {
                        pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
                        lookbehind: !0
                    },
                    important: /!important\b/i,
                    function: {
                        pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
                        lookbehind: !0
                    },
                    punctuation: /[(){};:,]/
                }, Prism2.languages.css.atrule.inside.rest = Prism2.languages.css;
                var markup = Prism2.languages.markup;
                markup && (markup.tag.addInlined("style", "css"), markup.tag.addAttribute("style", "css"));
            })(Prism);
        }
    }
});

},{"./chunk-JRLSWQMA.mjs":"cGDqS","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"hGrAv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "require_markup", ()=>require_markup);
var _chunkJRLSWQMAMjs = require("./chunk-JRLSWQMA.mjs");
var require_markup = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/refractor/lang/markup.js" (exports, module) {
        module.exports = markup;
        markup.displayName = "markup";
        markup.aliases = [
            "html",
            "mathml",
            "svg",
            "xml",
            "ssml",
            "atom",
            "rss"
        ];
        function markup(Prism) {
            Prism.languages.markup = {
                comment: {
                    pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
                    greedy: !0
                },
                prolog: {
                    pattern: /<\?[\s\S]+?\?>/,
                    greedy: !0
                },
                doctype: {
                    pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
                    greedy: !0,
                    inside: {
                        "internal-subset": {
                            pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                            lookbehind: !0,
                            greedy: !0,
                            inside: null
                        },
                        string: {
                            pattern: /"[^"]*"|'[^']*'/,
                            greedy: !0
                        },
                        punctuation: /^<!|>$|[[\]]/,
                        "doctype-tag": /^DOCTYPE/i,
                        name: /[^\s<>'"]+/
                    }
                },
                cdata: {
                    pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                    greedy: !0
                },
                tag: {
                    pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
                    greedy: !0,
                    inside: {
                        tag: {
                            pattern: /^<\/?[^\s>\/]+/,
                            inside: {
                                punctuation: /^<\/?/,
                                namespace: /^[^\s>\/:]+:/
                            }
                        },
                        "special-attr": [],
                        "attr-value": {
                            pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                            inside: {
                                punctuation: [
                                    {
                                        pattern: /^=/,
                                        alias: "attr-equals"
                                    },
                                    /"|'/
                                ]
                            }
                        },
                        punctuation: /\/?>/,
                        "attr-name": {
                            pattern: /[^\s>\/]+/,
                            inside: {
                                namespace: /^[^\s>\/:]+:/
                            }
                        }
                    }
                },
                entity: [
                    {
                        pattern: /&[\da-z]{1,8};/i,
                        alias: "named-entity"
                    },
                    /&#x?[\da-f]{1,8};/i
                ]
            }, Prism.languages.markup.tag.inside["attr-value"].inside.entity = Prism.languages.markup.entity, Prism.languages.markup.doctype.inside["internal-subset"].inside = Prism.languages.markup, Prism.hooks.add("wrap", function(env) {
                env.type === "entity" && (env.attributes.title = env.content.value.replace(/&amp;/, "&"));
            }), Object.defineProperty(Prism.languages.markup.tag, "addInlined", {
                value: function(tagName, lang) {
                    var includedCdataInside = {};
                    includedCdataInside["language-" + lang] = {
                        pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
                        lookbehind: !0,
                        inside: Prism.languages[lang]
                    }, includedCdataInside.cdata = /^<!\[CDATA\[|\]\]>$/i;
                    var inside = {
                        "included-cdata": {
                            pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                            inside: includedCdataInside
                        }
                    };
                    inside["language-" + lang] = {
                        pattern: /[\s\S]+/,
                        inside: Prism.languages[lang]
                    };
                    var def = {};
                    def[tagName] = {
                        pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                            return tagName;
                        }), "i"),
                        lookbehind: !0,
                        greedy: !0,
                        inside
                    }, Prism.languages.insertBefore("markup", "cdata", def);
                }
            }), Object.defineProperty(Prism.languages.markup.tag, "addAttribute", {
                value: function(attrName, lang) {
                    Prism.languages.markup.tag.inside["special-attr"].push({
                        pattern: RegExp(/(^|["'\s])/.source + "(?:" + attrName + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, "i"),
                        lookbehind: !0,
                        inside: {
                            "attr-name": /^[^\s=]+/,
                            "attr-value": {
                                pattern: /=[\s\S]+/,
                                inside: {
                                    value: {
                                        pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                                        lookbehind: !0,
                                        alias: [
                                            lang,
                                            "language-" + lang
                                        ],
                                        inside: Prism.languages[lang]
                                    },
                                    punctuation: [
                                        {
                                            pattern: /^=/,
                                            alias: "attr-equals"
                                        },
                                        /"|'/
                                    ]
                                }
                            }
                        }
                    });
                }
            }), Prism.languages.html = Prism.languages.markup, Prism.languages.mathml = Prism.languages.markup, Prism.languages.svg = Prism.languages.markup, Prism.languages.xml = Prism.languages.extend("markup", {}), Prism.languages.ssml = Prism.languages.xml, Prism.languages.atom = Prism.languages.xml, Prism.languages.rss = Prism.languages.xml;
        }
    }
});

},{"./chunk-JRLSWQMA.mjs":"cGDqS","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"70Qwv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "require_bash", ()=>require_bash);
var _chunkJRLSWQMAMjs = require("./chunk-JRLSWQMA.mjs");
var require_bash = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/refractor/lang/bash.js" (exports, module) {
        module.exports = bash;
        bash.displayName = "bash";
        bash.aliases = [
            "shell"
        ];
        function bash(Prism) {
            (function(Prism2) {
                var envVars = "\\b(?:BASH|BASHOPTS|BASH_ALIASES|BASH_ARGC|BASH_ARGV|BASH_CMDS|BASH_COMPLETION_COMPAT_DIR|BASH_LINENO|BASH_REMATCH|BASH_SOURCE|BASH_VERSINFO|BASH_VERSION|COLORTERM|COLUMNS|COMP_WORDBREAKS|DBUS_SESSION_BUS_ADDRESS|DEFAULTS_PATH|DESKTOP_SESSION|DIRSTACK|DISPLAY|EUID|GDMSESSION|GDM_LANG|GNOME_KEYRING_CONTROL|GNOME_KEYRING_PID|GPG_AGENT_INFO|GROUPS|HISTCONTROL|HISTFILE|HISTFILESIZE|HISTSIZE|HOME|HOSTNAME|HOSTTYPE|IFS|INSTANCE|JOB|LANG|LANGUAGE|LC_ADDRESS|LC_ALL|LC_IDENTIFICATION|LC_MEASUREMENT|LC_MONETARY|LC_NAME|LC_NUMERIC|LC_PAPER|LC_TELEPHONE|LC_TIME|LESSCLOSE|LESSOPEN|LINES|LOGNAME|LS_COLORS|MACHTYPE|MAILCHECK|MANDATORY_PATH|NO_AT_BRIDGE|OLDPWD|OPTERR|OPTIND|ORBIT_SOCKETDIR|OSTYPE|PAPERSIZE|PATH|PIPESTATUS|PPID|PS1|PS2|PS3|PS4|PWD|RANDOM|REPLY|SECONDS|SELINUX_INIT|SESSION|SESSIONTYPE|SESSION_MANAGER|SHELL|SHELLOPTS|SHLVL|SSH_AUTH_SOCK|TERM|UID|UPSTART_EVENTS|UPSTART_INSTANCE|UPSTART_JOB|UPSTART_SESSION|USER|WINDOWID|XAUTHORITY|XDG_CONFIG_DIRS|XDG_CURRENT_DESKTOP|XDG_DATA_DIRS|XDG_GREETER_DATA_DIR|XDG_MENU_PREFIX|XDG_RUNTIME_DIR|XDG_SEAT|XDG_SEAT_PATH|XDG_SESSION_DESKTOP|XDG_SESSION_ID|XDG_SESSION_PATH|XDG_SESSION_TYPE|XDG_VTNR|XMODIFIERS)\\b", commandAfterHeredoc = {
                    pattern: /(^(["']?)\w+\2)[ \t]+\S.*/,
                    lookbehind: !0,
                    alias: "punctuation",
                    inside: null
                }, insideString = {
                    bash: commandAfterHeredoc,
                    environment: {
                        pattern: RegExp("\\$" + envVars),
                        alias: "constant"
                    },
                    variable: [
                        {
                            pattern: /\$?\(\([\s\S]+?\)\)/,
                            greedy: !0,
                            inside: {
                                variable: [
                                    {
                                        pattern: /(^\$\(\([\s\S]+)\)\)/,
                                        lookbehind: !0
                                    },
                                    /^\$\(\(/
                                ],
                                number: /\b0x[\dA-Fa-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:[Ee]-?\d+)?/,
                                operator: /--|\+\+|\*\*=?|<<=?|>>=?|&&|\|\||[=!+\-*/%<>^&|]=?|[?~:]/,
                                punctuation: /\(\(?|\)\)?|,|;/
                            }
                        },
                        {
                            pattern: /\$\((?:\([^)]+\)|[^()])+\)|`[^`]+`/,
                            greedy: !0,
                            inside: {
                                variable: /^\$\(|^`|\)$|`$/
                            }
                        },
                        {
                            pattern: /\$\{[^}]+\}/,
                            greedy: !0,
                            inside: {
                                operator: /:[-=?+]?|[!\/]|##?|%%?|\^\^?|,,?/,
                                punctuation: /[\[\]]/,
                                environment: {
                                    pattern: RegExp("(\\{)" + envVars),
                                    lookbehind: !0,
                                    alias: "constant"
                                }
                            }
                        },
                        /\$(?:\w+|[#?*!@$])/
                    ],
                    entity: /\\(?:[abceEfnrtv\\"]|O?[0-7]{1,3}|U[0-9a-fA-F]{8}|u[0-9a-fA-F]{4}|x[0-9a-fA-F]{1,2})/
                };
                Prism2.languages.bash = {
                    shebang: {
                        pattern: /^#!\s*\/.*/,
                        alias: "important"
                    },
                    comment: {
                        pattern: /(^|[^"{\\$])#.*/,
                        lookbehind: !0
                    },
                    "function-name": [
                        {
                            pattern: /(\bfunction\s+)[\w-]+(?=(?:\s*\(?:\s*\))?\s*\{)/,
                            lookbehind: !0,
                            alias: "function"
                        },
                        {
                            pattern: /\b[\w-]+(?=\s*\(\s*\)\s*\{)/,
                            alias: "function"
                        }
                    ],
                    "for-or-select": {
                        pattern: /(\b(?:for|select)\s+)\w+(?=\s+in\s)/,
                        alias: "variable",
                        lookbehind: !0
                    },
                    "assign-left": {
                        pattern: /(^|[\s;|&]|[<>]\()\w+(?=\+?=)/,
                        inside: {
                            environment: {
                                pattern: RegExp("(^|[\\s;|&]|[<>]\\()" + envVars),
                                lookbehind: !0,
                                alias: "constant"
                            }
                        },
                        alias: "variable",
                        lookbehind: !0
                    },
                    string: [
                        {
                            pattern: /((?:^|[^<])<<-?\s*)(\w+)\s[\s\S]*?(?:\r?\n|\r)\2/,
                            lookbehind: !0,
                            greedy: !0,
                            inside: insideString
                        },
                        {
                            pattern: /((?:^|[^<])<<-?\s*)(["'])(\w+)\2\s[\s\S]*?(?:\r?\n|\r)\3/,
                            lookbehind: !0,
                            greedy: !0,
                            inside: {
                                bash: commandAfterHeredoc
                            }
                        },
                        {
                            pattern: /(^|[^\\](?:\\\\)*)"(?:\\[\s\S]|\$\([^)]+\)|\$(?!\()|`[^`]+`|[^"\\`$])*"/,
                            lookbehind: !0,
                            greedy: !0,
                            inside: insideString
                        },
                        {
                            pattern: /(^|[^$\\])'[^']*'/,
                            lookbehind: !0,
                            greedy: !0
                        },
                        {
                            pattern: /\$'(?:[^'\\]|\\[\s\S])*'/,
                            greedy: !0,
                            inside: {
                                entity: insideString.entity
                            }
                        }
                    ],
                    environment: {
                        pattern: RegExp("\\$?" + envVars),
                        alias: "constant"
                    },
                    variable: insideString.variable,
                    function: {
                        pattern: /(^|[\s;|&]|[<>]\()(?:add|apropos|apt|apt-cache|apt-get|aptitude|aspell|automysqlbackup|awk|basename|bash|bc|bconsole|bg|bzip2|cal|cat|cfdisk|chgrp|chkconfig|chmod|chown|chroot|cksum|clear|cmp|column|comm|composer|cp|cron|crontab|csplit|curl|cut|date|dc|dd|ddrescue|debootstrap|df|diff|diff3|dig|dir|dircolors|dirname|dirs|dmesg|docker|docker-compose|du|egrep|eject|env|ethtool|expand|expect|expr|fdformat|fdisk|fg|fgrep|file|find|fmt|fold|format|free|fsck|ftp|fuser|gawk|git|gparted|grep|groupadd|groupdel|groupmod|groups|grub-mkconfig|gzip|halt|head|hg|history|host|hostname|htop|iconv|id|ifconfig|ifdown|ifup|import|install|ip|jobs|join|kill|killall|less|link|ln|locate|logname|logrotate|look|lpc|lpr|lprint|lprintd|lprintq|lprm|ls|lsof|lynx|make|man|mc|mdadm|mkconfig|mkdir|mke2fs|mkfifo|mkfs|mkisofs|mknod|mkswap|mmv|more|most|mount|mtools|mtr|mutt|mv|nano|nc|netstat|nice|nl|node|nohup|notify-send|npm|nslookup|op|open|parted|passwd|paste|pathchk|ping|pkill|pnpm|podman|podman-compose|popd|pr|printcap|printenv|ps|pushd|pv|quota|quotacheck|quotactl|ram|rar|rcp|reboot|remsync|rename|renice|rev|rm|rmdir|rpm|rsync|scp|screen|sdiff|sed|sendmail|seq|service|sftp|sh|shellcheck|shuf|shutdown|sleep|slocate|sort|split|ssh|stat|strace|su|sudo|sum|suspend|swapon|sync|tac|tail|tar|tee|time|timeout|top|touch|tr|traceroute|tsort|tty|umount|uname|unexpand|uniq|units|unrar|unshar|unzip|update-grub|uptime|useradd|userdel|usermod|users|uudecode|uuencode|v|vcpkg|vdir|vi|vim|virsh|vmstat|wait|watch|wc|wget|whereis|which|who|whoami|write|xargs|xdg-open|yarn|yes|zenity|zip|zsh|zypper)(?=$|[)\s;|&])/,
                        lookbehind: !0
                    },
                    keyword: {
                        pattern: /(^|[\s;|&]|[<>]\()(?:case|do|done|elif|else|esac|fi|for|function|if|in|select|then|until|while)(?=$|[)\s;|&])/,
                        lookbehind: !0
                    },
                    builtin: {
                        pattern: /(^|[\s;|&]|[<>]\()(?:\.|:|alias|bind|break|builtin|caller|cd|command|continue|declare|echo|enable|eval|exec|exit|export|getopts|hash|help|let|local|logout|mapfile|printf|pwd|read|readarray|readonly|return|set|shift|shopt|source|test|times|trap|type|typeset|ulimit|umask|unalias|unset)(?=$|[)\s;|&])/,
                        lookbehind: !0,
                        alias: "class-name"
                    },
                    boolean: {
                        pattern: /(^|[\s;|&]|[<>]\()(?:false|true)(?=$|[)\s;|&])/,
                        lookbehind: !0
                    },
                    "file-descriptor": {
                        pattern: /\B&\d\b/,
                        alias: "important"
                    },
                    operator: {
                        pattern: /\d?<>|>\||\+=|=[=~]?|!=?|<<[<-]?|[&\d]?>>|\d[<>]&?|[<>][&=]?|&[>&]?|\|[&|]?/,
                        inside: {
                            "file-descriptor": {
                                pattern: /^\d/,
                                alias: "important"
                            }
                        }
                    },
                    punctuation: /\$?\(\(?|\)\)?|\.\.|[{}[\];\\]/,
                    number: {
                        pattern: /(^|\s)(?:[1-9]\d*|0)(?:[.,]\d+)?\b/,
                        lookbehind: !0
                    }
                }, commandAfterHeredoc.inside = Prism2.languages.bash;
                for(var toBeCopied = [
                    "comment",
                    "function-name",
                    "for-or-select",
                    "assign-left",
                    "string",
                    "environment",
                    "function",
                    "keyword",
                    "builtin",
                    "boolean",
                    "file-descriptor",
                    "operator",
                    "punctuation",
                    "number"
                ], inside = insideString.variable[1].inside, i = 0; i < toBeCopied.length; i++)inside[toBeCopied[i]] = Prism2.languages.bash[toBeCopied[i]];
                Prism2.languages.shell = Prism2.languages.bash;
            })(Prism);
        }
    }
});

},{"./chunk-JRLSWQMA.mjs":"cGDqS","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"iMx5F":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "require_js_extras", ()=>require_js_extras);
var _chunkJRLSWQMAMjs = require("./chunk-JRLSWQMA.mjs");
var require_js_extras = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/refractor/lang/js-extras.js" (exports, module) {
        module.exports = jsExtras;
        jsExtras.displayName = "jsExtras";
        jsExtras.aliases = [];
        function jsExtras(Prism) {
            (function(Prism2) {
                Prism2.languages.insertBefore("javascript", "function-variable", {
                    "method-variable": {
                        pattern: RegExp("(\\.\\s*)" + Prism2.languages.javascript["function-variable"].pattern.source),
                        lookbehind: !0,
                        alias: [
                            "function-variable",
                            "method",
                            "function",
                            "property-access"
                        ]
                    }
                }), Prism2.languages.insertBefore("javascript", "function", {
                    method: {
                        pattern: RegExp("(\\.\\s*)" + Prism2.languages.javascript.function.source),
                        lookbehind: !0,
                        alias: [
                            "function",
                            "property-access"
                        ]
                    }
                }), Prism2.languages.insertBefore("javascript", "constant", {
                    "known-class-name": [
                        {
                            pattern: /\b(?:(?:Float(?:32|64)|(?:Int|Uint)(?:8|16|32)|Uint8Clamped)?Array|ArrayBuffer|BigInt|Boolean|DataView|Date|Error|Function|Intl|JSON|(?:Weak)?(?:Map|Set)|Math|Number|Object|Promise|Proxy|Reflect|RegExp|String|Symbol|WebAssembly)\b/,
                            alias: "class-name"
                        },
                        {
                            pattern: /\b(?:[A-Z]\w*)Error\b/,
                            alias: "class-name"
                        }
                    ]
                });
                function withId(source, flags) {
                    return RegExp(source.replace(/<ID>/g, function() {
                        return /(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/.source;
                    }), flags);
                }
                Prism2.languages.insertBefore("javascript", "keyword", {
                    imports: {
                        pattern: withId(/(\bimport\b\s*)(?:<ID>(?:\s*,\s*(?:\*\s*as\s+<ID>|\{[^{}]*\}))?|\*\s*as\s+<ID>|\{[^{}]*\})(?=\s*\bfrom\b)/.source),
                        lookbehind: !0,
                        inside: Prism2.languages.javascript
                    },
                    exports: {
                        pattern: withId(/(\bexport\b\s*)(?:\*(?:\s*as\s+<ID>)?(?=\s*\bfrom\b)|\{[^{}]*\})/.source),
                        lookbehind: !0,
                        inside: Prism2.languages.javascript
                    }
                }), Prism2.languages.javascript.keyword.unshift({
                    pattern: /\b(?:as|default|export|from|import)\b/,
                    alias: "module"
                }, {
                    pattern: /\b(?:await|break|catch|continue|do|else|finally|for|if|return|switch|throw|try|while|yield)\b/,
                    alias: "control-flow"
                }, {
                    pattern: /\bnull\b/,
                    alias: [
                        "null",
                        "nil"
                    ]
                }, {
                    pattern: /\bundefined\b/,
                    alias: "nil"
                }), Prism2.languages.insertBefore("javascript", "operator", {
                    spread: {
                        pattern: /\.{3}/,
                        alias: "operator"
                    },
                    arrow: {
                        pattern: /=>/,
                        alias: "operator"
                    }
                }), Prism2.languages.insertBefore("javascript", "punctuation", {
                    "property-access": {
                        pattern: withId(/(\.\s*)#?<ID>/.source),
                        lookbehind: !0
                    },
                    "maybe-class-name": {
                        pattern: /(^|[^$\w\xA0-\uFFFF])[A-Z][$\w\xA0-\uFFFF]+/,
                        lookbehind: !0
                    },
                    dom: {
                        pattern: /\b(?:document|(?:local|session)Storage|location|navigator|performance|window)\b/,
                        alias: "variable"
                    },
                    console: {
                        pattern: /\bconsole(?=\s*\.)/,
                        alias: "class-name"
                    }
                });
                for(var maybeClassNameTokens = [
                    "function",
                    "function-variable",
                    "method",
                    "method-variable",
                    "property-access"
                ], i = 0; i < maybeClassNameTokens.length; i++){
                    var token = maybeClassNameTokens[i], value = Prism2.languages.javascript[token];
                    Prism2.util.type(value) === "RegExp" && (value = Prism2.languages.javascript[token] = {
                        pattern: value
                    });
                    var inside = value.inside || {};
                    value.inside = inside, inside["maybe-class-name"] = /^[A-Z][\s\S]*/;
                }
            })(Prism);
        }
    }
});

},{"./chunk-JRLSWQMA.mjs":"cGDqS","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"iAXcz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "require_json", ()=>require_json);
var _chunkJRLSWQMAMjs = require("./chunk-JRLSWQMA.mjs");
var require_json = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/refractor/lang/json.js" (exports, module) {
        module.exports = json;
        json.displayName = "json";
        json.aliases = [
            "webmanifest"
        ];
        function json(Prism) {
            Prism.languages.json = {
                property: {
                    pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
                    lookbehind: !0,
                    greedy: !0
                },
                string: {
                    pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
                    lookbehind: !0,
                    greedy: !0
                },
                comment: {
                    pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
                    greedy: !0
                },
                number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
                punctuation: /[{}[\],]/,
                operator: /:/,
                boolean: /\b(?:false|true)\b/,
                null: {
                    pattern: /\bnull\b/,
                    alias: "keyword"
                }
            }, Prism.languages.webmanifest = Prism.languages.json;
        }
    }
});

},{"./chunk-JRLSWQMA.mjs":"cGDqS","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"5eeP5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "require_graphql", ()=>require_graphql);
var _chunkJRLSWQMAMjs = require("./chunk-JRLSWQMA.mjs");
var require_graphql = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/refractor/lang/graphql.js" (exports, module) {
        module.exports = graphql;
        graphql.displayName = "graphql";
        graphql.aliases = [];
        function graphql(Prism) {
            Prism.languages.graphql = {
                comment: /#.*/,
                description: {
                    pattern: /(?:"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*")(?=\s*[a-z_])/i,
                    greedy: !0,
                    alias: "string",
                    inside: {
                        "language-markdown": {
                            pattern: /(^"(?:"")?)(?!\1)[\s\S]+(?=\1$)/,
                            lookbehind: !0,
                            inside: Prism.languages.markdown
                        }
                    }
                },
                string: {
                    pattern: /"""(?:[^"]|(?!""")")*"""|"(?:\\.|[^\\"\r\n])*"/,
                    greedy: !0
                },
                number: /(?:\B-|\b)\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
                boolean: /\b(?:false|true)\b/,
                variable: /\$[a-z_]\w*/i,
                directive: {
                    pattern: /@[a-z_]\w*/i,
                    alias: "function"
                },
                "attr-name": {
                    pattern: /\b[a-z_]\w*(?=\s*(?:\((?:[^()"]|"(?:\\.|[^\\"\r\n])*")*\))?:)/i,
                    greedy: !0
                },
                "atom-input": {
                    pattern: /\b[A-Z]\w*Input\b/,
                    alias: "class-name"
                },
                scalar: /\b(?:Boolean|Float|ID|Int|String)\b/,
                constant: /\b[A-Z][A-Z_\d]*\b/,
                "class-name": {
                    pattern: /(\b(?:enum|implements|interface|on|scalar|type|union)\s+|&\s*|:\s*|\[)[A-Z_]\w*/,
                    lookbehind: !0
                },
                fragment: {
                    pattern: /(\bfragment\s+|\.{3}\s*(?!on\b))[a-zA-Z_]\w*/,
                    lookbehind: !0,
                    alias: "function"
                },
                "definition-mutation": {
                    pattern: /(\bmutation\s+)[a-zA-Z_]\w*/,
                    lookbehind: !0,
                    alias: "function"
                },
                "definition-query": {
                    pattern: /(\bquery\s+)[a-zA-Z_]\w*/,
                    lookbehind: !0,
                    alias: "function"
                },
                keyword: /\b(?:directive|enum|extend|fragment|implements|input|interface|mutation|on|query|repeatable|scalar|schema|subscription|type|union)\b/,
                operator: /[!=|&]|\.{3}/,
                "property-query": /\w+(?=\s*\()/,
                object: /\w+(?=\s*\{)/,
                punctuation: /[!(){}\[\]:=,]/,
                property: /\w+/
            }, Prism.hooks.add("after-tokenize", function(env) {
                if (env.language !== "graphql") return;
                var validTokens = env.tokens.filter(function(token) {
                    return typeof token != "string" && token.type !== "comment" && token.type !== "scalar";
                }), currentIndex = 0;
                function getToken(offset) {
                    return validTokens[currentIndex + offset];
                }
                function isTokenType(types, offset) {
                    offset = offset || 0;
                    for(var i2 = 0; i2 < types.length; i2++){
                        var token = getToken(i2 + offset);
                        if (!token || token.type !== types[i2]) return !1;
                    }
                    return !0;
                }
                function findClosingBracket(open, close) {
                    for(var stackHeight = 1, i2 = currentIndex; i2 < validTokens.length; i2++){
                        var token = validTokens[i2], content = token.content;
                        if (token.type === "punctuation" && typeof content == "string") {
                            if (open.test(content)) stackHeight++;
                            else if (close.test(content) && (stackHeight--, stackHeight === 0)) return i2;
                        }
                    }
                    return -1;
                }
                function addAlias(token, alias) {
                    var aliases = token.alias;
                    aliases ? Array.isArray(aliases) || (token.alias = aliases = [
                        aliases
                    ]) : token.alias = aliases = [], aliases.push(alias);
                }
                for(; currentIndex < validTokens.length;){
                    var startToken = validTokens[currentIndex++];
                    if (startToken.type === "keyword" && startToken.content === "mutation") {
                        var inputVariables = [];
                        if (isTokenType([
                            "definition-mutation",
                            "punctuation"
                        ]) && getToken(1).content === "(") {
                            currentIndex += 2;
                            var definitionEnd = findClosingBracket(/^\($/, /^\)$/);
                            if (definitionEnd === -1) continue;
                            for(; currentIndex < definitionEnd; currentIndex++){
                                var t = getToken(0);
                                t.type === "variable" && (addAlias(t, "variable-input"), inputVariables.push(t.content));
                            }
                            currentIndex = definitionEnd + 1;
                        }
                        if (isTokenType([
                            "punctuation",
                            "property-query"
                        ]) && getToken(0).content === "{" && (currentIndex++, addAlias(getToken(0), "property-mutation"), inputVariables.length > 0)) {
                            var mutationEnd = findClosingBracket(/^\{$/, /^\}$/);
                            if (mutationEnd === -1) continue;
                            for(var i = currentIndex; i < mutationEnd; i++){
                                var varToken = validTokens[i];
                                varToken.type === "variable" && inputVariables.indexOf(varToken.content) >= 0 && addAlias(varToken, "variable-input");
                            }
                        }
                    }
                }
            });
        }
    }
});

},{"./chunk-JRLSWQMA.mjs":"cGDqS","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"k5oxb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WithToolTipState", ()=>WithToolTipState);
parcelHelpers.export(exports, "WithTooltipPure", ()=>WithTooltipPure);
parcelHelpers.export(exports, "auto", ()=>auto);
var _chunkJRLSWQMAMjs = require("./chunk-JRLSWQMA.mjs");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _theming = require("@storybook/theming");
var _global = require("@storybook/global");
var _memoizerific = require("memoizerific");
var _memoizerificDefault = parcelHelpers.interopDefault(_memoizerific);
var require_react_fast_compare = (0, _chunkJRLSWQMAMjs.__commonJS)({
    "../../node_modules/react-fast-compare/index.js" (exports, module) {
        var hasElementType = typeof Element < "u", hasMap = typeof Map == "function", hasSet = typeof Set == "function", hasArrayBuffer = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
        function equal(a, b) {
            if (a === b) return !0;
            if (a && b && typeof a == "object" && typeof b == "object") {
                if (a.constructor !== b.constructor) return !1;
                var length, i, keys;
                if (Array.isArray(a)) {
                    if (length = a.length, length != b.length) return !1;
                    for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return !1;
                    return !0;
                }
                var it;
                if (hasMap && a instanceof Map && b instanceof Map) {
                    if (a.size !== b.size) return !1;
                    for(it = a.entries(); !(i = it.next()).done;)if (!b.has(i.value[0])) return !1;
                    for(it = a.entries(); !(i = it.next()).done;)if (!equal(i.value[1], b.get(i.value[0]))) return !1;
                    return !0;
                }
                if (hasSet && a instanceof Set && b instanceof Set) {
                    if (a.size !== b.size) return !1;
                    for(it = a.entries(); !(i = it.next()).done;)if (!b.has(i.value[0])) return !1;
                    return !0;
                }
                if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
                    if (length = a.length, length != b.length) return !1;
                    for(i = length; i-- !== 0;)if (a[i] !== b[i]) return !1;
                    return !0;
                }
                if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
                if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf == "function" && typeof b.valueOf == "function") return a.valueOf() === b.valueOf();
                if (a.toString !== Object.prototype.toString && typeof a.toString == "function" && typeof b.toString == "function") return a.toString() === b.toString();
                if (keys = Object.keys(a), length = keys.length, length !== Object.keys(b).length) return !1;
                for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return !1;
                if (hasElementType && a instanceof Element) return !1;
                for(i = length; i-- !== 0;)if (!((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) && !equal(a[keys[i]], b[keys[i]])) return !1;
                return !0;
            }
            return a !== a && b !== b;
        }
        module.exports = function(a, b) {
            try {
                return equal(a, b);
            } catch (error) {
                if ((error.message || "").match(/stack|recursion/i)) return console.warn("react-fast-compare cannot handle circular refs"), !1;
                throw error;
            }
        };
    }
});
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.keys(source), key, i;
    for(i = 0; i < sourceKeys.length; i++)key = sourceKeys[i], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
    return target;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
        }
        return target;
    }, _extends.apply(this, arguments);
}
var fromEntries = function(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        return acc[key] = value, acc;
    }, {});
}, useIsomorphicLayoutEffect = typeof window < "u" && window.document && window.document.createElement ? _react.useLayoutEffect : _react.useEffect;
var top = "top", bottom = "bottom", right = "right", left = "left", auto = "auto", basePlacements = [
    top,
    bottom,
    right,
    left
], start = "start", end = "end", clippingParents = "clippingParents", viewport = "viewport", popper = "popper", reference = "reference", variationPlacements = basePlacements.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []), placements = [].concat(basePlacements, [
    auto
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []), beforeRead = "beforeRead", read = "read", afterRead = "afterRead", beforeMain = "beforeMain", main = "main", afterMain = "afterMain", beforeWrite = "beforeWrite", write = "write", afterWrite = "afterWrite", modifierPhases = [
    beforeRead,
    read,
    afterRead,
    beforeMain,
    main,
    afterMain,
    beforeWrite,
    write,
    afterWrite
];
function getNodeName(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}
function getWindow(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument && ownerDocument.defaultView || window;
    }
    return node;
}
function isElement(node) {
    var OwnElement = getWindow(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
    var OwnElement = getWindow(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
    if (typeof ShadowRoot > "u") return !1;
    var OwnElement = getWindow(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}
function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {}, attributes = state.attributes[name] || {}, element = state.elements[name];
        !isHTMLElement(element) || !getNodeName(element) || (Object.assign(element.style, style), Object.keys(attributes).forEach(function(name2) {
            var value = attributes[name2];
            value === !1 ? element.removeAttribute(name2) : element.setAttribute(name2, value === !0 ? "" : value);
        }));
    });
}
function effect(_ref2) {
    var state = _ref2.state, initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    return Object.assign(state.elements.popper.style, initialStyles.popper), state.styles = initialStyles, state.elements.arrow && Object.assign(state.elements.arrow.style, initialStyles.arrow), function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name], attributes = state.attributes[name] || {}, styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]), style = styleProperties.reduce(function(style2, property) {
                return style2[property] = "", style2;
            }, {});
            !isHTMLElement(element) || !getNodeName(element) || (Object.assign(element.style, style), Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            }));
        });
    };
}
var applyStyles_default = {
    name: "applyStyles",
    enabled: !0,
    phase: "write",
    fn: applyStyles,
    effect,
    requires: [
        "computeStyles"
    ]
};
function getBasePlacement(placement) {
    return placement.split("-")[0];
}
var max = Math.max, min = Math.min, round = Math.round;
function getUAString() {
    var uaData = navigator.userAgentData;
    return uaData != null && uaData.brands && Array.isArray(uaData.brands) ? uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ") : navigator.userAgent;
}
function isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
    includeScale === void 0 && (includeScale = !1), isFixedStrategy === void 0 && (isFixedStrategy = !1);
    var clientRect = element.getBoundingClientRect(), scaleX = 1, scaleY = 1;
    includeScale && isHTMLElement(element) && (scaleX = element.offsetWidth > 0 && round(clientRect.width) / element.offsetWidth || 1, scaleY = element.offsetHeight > 0 && round(clientRect.height) / element.offsetHeight || 1);
    var _ref = isElement(element) ? getWindow(element) : window, visualViewport = _ref.visualViewport, addVisualOffsets = !isLayoutViewport() && isFixedStrategy, x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX, y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY, width = clientRect.width / scaleX, height = clientRect.height / scaleY;
    return {
        width,
        height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x,
        y
    };
}
function getLayoutRect(element) {
    var clientRect = getBoundingClientRect(element), width = element.offsetWidth, height = element.offsetHeight;
    return Math.abs(clientRect.width - width) <= 1 && (width = clientRect.width), Math.abs(clientRect.height - height) <= 1 && (height = clientRect.height), {
        x: element.offsetLeft,
        y: element.offsetTop,
        width,
        height
    };
}
function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode();
    if (parent.contains(child)) return !0;
    if (rootNode && isShadowRoot(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return !0;
            next = next.parentNode || next.host;
        }while (next);
    }
    return !1;
}
function getComputedStyle(element) {
    return getWindow(element).getComputedStyle(element);
}
function isTableElement(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf(getNodeName(element)) >= 0;
}
function getDocumentElement(element) {
    return ((isElement(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}
function getParentNode(element) {
    return getNodeName(element) === "html" ? element : element.assignedSlot || element.parentNode || (isShadowRoot(element) ? element.host : null) || getDocumentElement(element);
}
function getTrueOffsetParent(element) {
    return !isHTMLElement(element) || getComputedStyle(element).position === "fixed" ? null : element.offsetParent;
}
function getContainingBlock(element) {
    var isFirefox = /firefox/i.test(getUAString()), isIE = /Trident/i.test(getUAString());
    if (isIE && isHTMLElement(element)) {
        var elementCss = getComputedStyle(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = getParentNode(element);
    for(isShadowRoot(currentNode) && (currentNode = currentNode.host); isHTMLElement(currentNode) && [
        "html",
        "body"
    ].indexOf(getNodeName(currentNode)) < 0;){
        var css = getComputedStyle(currentNode);
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        currentNode = currentNode.parentNode;
    }
    return null;
}
function getOffsetParent(element) {
    for(var window2 = getWindow(element), offsetParent = getTrueOffsetParent(element); offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === "static";)offsetParent = getTrueOffsetParent(offsetParent);
    return offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle(offsetParent).position === "static") ? window2 : offsetParent || getContainingBlock(element) || window2;
}
function getMainAxisFromPlacement(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}
function within(min2, value, max2) {
    return max(min2, min(value, max2));
}
function withinMaxClamp(min2, value, max2) {
    var v = within(min2, value, max2);
    return v > max2 ? max2 : v;
}
function getFreshSideObject() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}
function mergePaddingObject(paddingObject) {
    return Object.assign({}, getFreshSideObject(), paddingObject);
}
function expandToHashMap(value, keys) {
    return keys.reduce(function(hashMap, key) {
        return hashMap[key] = value, hashMap;
    }, {});
}
var toPaddingObject = function(padding, state) {
    return padding = typeof padding == "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding, mergePaddingObject(typeof padding != "number" ? padding : expandToHashMap(padding, basePlacements));
};
function arrow(_ref) {
    var _state$modifiersData$, state = _ref.state, name = _ref.name, options = _ref.options, arrowElement = state.elements.arrow, popperOffsets2 = state.modifiersData.popperOffsets, basePlacement = getBasePlacement(state.placement), axis = getMainAxisFromPlacement(basePlacement), isVertical = [
        left,
        right
    ].indexOf(basePlacement) >= 0, len = isVertical ? "height" : "width";
    if (!(!arrowElement || !popperOffsets2)) {
        var paddingObject = toPaddingObject(options.padding, state), arrowRect = getLayoutRect(arrowElement), minProp = axis === "y" ? top : left, maxProp = axis === "y" ? bottom : right, endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets2[axis] - state.rects.popper[len], startDiff = popperOffsets2[axis] - state.rects.reference[axis], arrowOffsetParent = getOffsetParent(arrowElement), clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0, centerToReference = endDiff / 2 - startDiff / 2, min2 = paddingObject[minProp], max2 = clientSize - arrowRect[len] - paddingObject[maxProp], center = clientSize / 2 - arrowRect[len] / 2 + centerToReference, offset2 = within(min2, center, max2), axisProp = axis;
        state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset2, _state$modifiersData$.centerOffset = offset2 - center, _state$modifiersData$);
    }
}
function effect2(_ref2) {
    var state = _ref2.state, options = _ref2.options, _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    arrowElement != null && (typeof arrowElement == "string" && (arrowElement = state.elements.popper.querySelector(arrowElement), !arrowElement) || contains(state.elements.popper, arrowElement) && (state.elements.arrow = arrowElement));
}
var arrow_default = {
    name: "arrow",
    enabled: !0,
    phase: "main",
    fn: arrow,
    effect: effect2,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};
function getVariation(placement) {
    return placement.split("-")[1];
}
var unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
};
function roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y, dpr = win.devicePixelRatio || 1;
    return {
        x: round(x * dpr) / dpr || 0,
        y: round(y * dpr) / dpr || 0
    };
}
function mapToStyles(_ref2) {
    var _Object$assign2, popper2 = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed, _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y, _ref3 = typeof roundOffsets == "function" ? roundOffsets({
        x,
        y
    }) : {
        x,
        y
    };
    x = _ref3.x, y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x"), hasY = offsets.hasOwnProperty("y"), sideX = left, sideY = top, win = window;
    if (adaptive) {
        var offsetParent = getOffsetParent(popper2), heightProp = "clientHeight", widthProp = "clientWidth";
        if (offsetParent === getWindow(popper2) && (offsetParent = getDocumentElement(popper2), getComputedStyle(offsetParent).position !== "static" && position === "absolute" && (heightProp = "scrollHeight", widthProp = "scrollWidth")), offsetParent, placement === top || (placement === left || placement === right) && variation === end) {
            sideY = bottom;
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height, y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === left || (placement === top || placement === bottom) && variation === end) {
            sideX = right;
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width, x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position
    }, adaptive && unsetSides), _ref4 = roundOffsets === !0 ? roundOffsetsByDPR({
        x,
        y
    }, getWindow(popper2)) : {
        x,
        y
    };
    if (x = _ref4.x, y = _ref4.y, gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options, _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? !0 : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? !0 : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? !0 : _options$roundOffsets, commonStyles = {
        placement: getBasePlacement(state.placement),
        variation: getVariation(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    state.modifiersData.popperOffsets != null && (state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive,
        roundOffsets
    })))), state.modifiersData.arrow != null && (state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: !1,
        roundOffsets
    })))), state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
}
var computeStyles_default = {
    name: "computeStyles",
    enabled: !0,
    phase: "beforeWrite",
    fn: computeStyles,
    data: {}
};
var passive = {
    passive: !0
};
function effect3(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options, _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? !0 : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? !0 : _options$resize, window2 = getWindow(state.elements.popper), scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    return scroll && scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, passive);
    }), resize && window2.addEventListener("resize", instance.update, passive), function() {
        scroll && scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, passive);
        }), resize && window2.removeEventListener("resize", instance.update, passive);
    };
}
var eventListeners_default = {
    name: "eventListeners",
    enabled: !0,
    phase: "write",
    fn: function() {},
    effect: effect3,
    data: {}
};
var hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
var hash2 = {
    start: "end",
    end: "start"
};
function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return hash2[matched];
    });
}
function getWindowScroll(node) {
    var win = getWindow(node), scrollLeft = win.pageXOffset, scrollTop = win.pageYOffset;
    return {
        scrollLeft,
        scrollTop
    };
}
function getWindowScrollBarX(element) {
    return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
function getViewportRect(element, strategy) {
    var win = getWindow(element), html = getDocumentElement(element), visualViewport = win.visualViewport, width = html.clientWidth, height = html.clientHeight, x = 0, y = 0;
    if (visualViewport) {
        width = visualViewport.width, height = visualViewport.height;
        var layoutViewport = isLayoutViewport();
        (layoutViewport || !layoutViewport && strategy === "fixed") && (x = visualViewport.offsetLeft, y = visualViewport.offsetTop);
    }
    return {
        width,
        height,
        x: x + getWindowScrollBarX(element),
        y
    };
}
function getDocumentRect(element) {
    var _element$ownerDocumen, html = getDocumentElement(element), winScroll = getWindowScroll(element), body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body, width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0), height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0), x = -winScroll.scrollLeft + getWindowScrollBarX(element), y = -winScroll.scrollTop;
    return getComputedStyle(body || html).direction === "rtl" && (x += max(html.clientWidth, body ? body.clientWidth : 0) - width), {
        width,
        height,
        x,
        y
    };
}
function isScrollParent(element) {
    var _getComputedStyle = getComputedStyle(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getScrollParent(node) {
    return [
        "html",
        "body",
        "#document"
    ].indexOf(getNodeName(node)) >= 0 ? node.ownerDocument.body : isHTMLElement(node) && isScrollParent(node) ? node : getScrollParent(getParentNode(node));
}
function listScrollParents(element, list) {
    var _element$ownerDocumen;
    list === void 0 && (list = []);
    var scrollParent = getScrollParent(element), isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body), win = getWindow(scrollParent), target = isBody ? [
        win
    ].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent, updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
}
function rectToClientRect(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}
function getInnerBoundingClientRect(element, strategy) {
    var rect = getBoundingClientRect(element, !1, strategy === "fixed");
    return rect.top = rect.top + element.clientTop, rect.left = rect.left + element.clientLeft, rect.bottom = rect.top + element.clientHeight, rect.right = rect.left + element.clientWidth, rect.width = element.clientWidth, rect.height = element.clientHeight, rect.x = rect.left, rect.y = rect.top, rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingParents(element) {
    var clippingParents2 = listScrollParents(getParentNode(element)), canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf(getComputedStyle(element).position) >= 0, clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
    return isElement(clipperElement) ? clippingParents2.filter(function(clippingParent) {
        return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== "body";
    }) : [];
}
function getClippingRect(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary), clippingParents2 = [].concat(mainClippingParents, [
        rootBoundary
    ]), firstClippingParent = clippingParents2[0], clippingRect = clippingParents2.reduce(function(accRect, clippingParent) {
        var rect = getClientRectFromMixedType(element, clippingParent, strategy);
        return accRect.top = max(rect.top, accRect.top), accRect.right = min(rect.right, accRect.right), accRect.bottom = min(rect.bottom, accRect.bottom), accRect.left = max(rect.left, accRect.left), accRect;
    }, getClientRectFromMixedType(element, firstClippingParent, strategy));
    return clippingRect.width = clippingRect.right - clippingRect.left, clippingRect.height = clippingRect.bottom - clippingRect.top, clippingRect.x = clippingRect.left, clippingRect.y = clippingRect.top, clippingRect;
}
function computeOffsets(_ref) {
    var reference2 = _ref.reference, element = _ref.element, placement = _ref.placement, basePlacement = placement ? getBasePlacement(placement) : null, variation = placement ? getVariation(placement) : null, commonX = reference2.x + reference2.width / 2 - element.width / 2, commonY = reference2.y + reference2.height / 2 - element.height / 2, offsets;
    switch(basePlacement){
        case top:
            offsets = {
                x: commonX,
                y: reference2.y - element.height
            };
            break;
        case bottom:
            offsets = {
                x: commonX,
                y: reference2.y + reference2.height
            };
            break;
        case right:
            offsets = {
                x: reference2.x + reference2.width,
                y: commonY
            };
            break;
        case left:
            offsets = {
                x: reference2.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference2.x,
                y: reference2.y
            };
    }
    var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case start:
                offsets[mainAxis] = offsets[mainAxis] - (reference2[len] / 2 - element[len] / 2);
                break;
            case end:
                offsets[mainAxis] = offsets[mainAxis] + (reference2[len] / 2 - element[len] / 2);
                break;
        }
    }
    return offsets;
}
function detectOverflow(state, options) {
    options === void 0 && (options = {});
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? !1 : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding, paddingObject = mergePaddingObject(typeof padding != "number" ? padding : expandToHashMap(padding, basePlacements)), altContext = elementContext === popper ? reference : popper, popperRect = state.rects.popper, element = state.elements[altBoundary ? altContext : elementContext], clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy), referenceClientRect = getBoundingClientRect(state.elements.reference), popperOffsets2 = computeOffsets({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement
    }), popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets2)), elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect, overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    }, offsetData = state.modifiersData.offset;
    if (elementContext === popper && offsetData) {
        var offset2 = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                right,
                bottom
            ].indexOf(key) >= 0 ? 1 : -1, axis = [
                top,
                bottom
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset2[axis] * multiply;
        });
    }
    return overflowOffsets;
}
function computeAutoPlacement(state, options) {
    options === void 0 && (options = {});
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP, variation = getVariation(placement), placements2 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement2) {
        return getVariation(placement2) === variation;
    }) : basePlacements, allowedPlacements = placements2.filter(function(placement2) {
        return allowedAutoPlacements.indexOf(placement2) >= 0;
    });
    allowedPlacements.length === 0 && (allowedPlacements = placements2);
    var overflows = allowedPlacements.reduce(function(acc, placement2) {
        return acc[placement2] = detectOverflow(state, {
            placement: placement2,
            boundary,
            rootBoundary,
            padding
        })[getBasePlacement(placement2)], acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}
function getExpandedFallbackPlacements(placement) {
    if (getBasePlacement(placement) === auto) return [];
    var oppositePlacement = getOppositePlacement(placement);
    return [
        getOppositeVariationPlacement(placement),
        oppositePlacement,
        getOppositeVariationPlacement(oppositePlacement)
    ];
}
function flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (!state.modifiersData[name]._skip) {
        for(var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? !0 : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? !0 : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? !0 : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements, preferredPlacement = state.options.placement, basePlacement = getBasePlacement(preferredPlacement), isBasePlacement = basePlacement === preferredPlacement, fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
            getOppositePlacement(preferredPlacement)
        ] : getExpandedFallbackPlacements(preferredPlacement)), placements2 = [
            preferredPlacement
        ].concat(fallbackPlacements).reduce(function(acc, placement2) {
            return acc.concat(getBasePlacement(placement2) === auto ? computeAutoPlacement(state, {
                placement: placement2,
                boundary,
                rootBoundary,
                padding,
                flipVariations,
                allowedAutoPlacements
            }) : placement2);
        }, []), referenceRect = state.rects.reference, popperRect = state.rects.popper, checksMap = new Map, makeFallbackChecks = !0, firstFittingPlacement = placements2[0], i = 0; i < placements2.length; i++){
            var placement = placements2[i], _basePlacement = getBasePlacement(placement), isStartVariation = getVariation(placement) === start, isVertical = [
                top,
                bottom
            ].indexOf(_basePlacement) >= 0, len = isVertical ? "width" : "height", overflow = detectOverflow(state, {
                placement,
                boundary,
                rootBoundary,
                altBoundary,
                padding
            }), mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
            referenceRect[len] > popperRect[len] && (mainVariationSide = getOppositePlacement(mainVariationSide));
            var altVariationSide = getOppositePlacement(mainVariationSide), checks = [];
            if (checkMainAxis && checks.push(overflow[_basePlacement] <= 0), checkAltAxis && checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0), checks.every(function(check) {
                return check;
            })) {
                firstFittingPlacement = placement, makeFallbackChecks = !1;
                break;
            }
            checksMap.set(placement, checks);
        }
        if (makeFallbackChecks) for(var numberOfChecks = flipVariations ? 3 : 1, _loop = function(_i2) {
            var fittingPlacement = placements2.find(function(placement2) {
                var checks2 = checksMap.get(placement2);
                if (checks2) return checks2.slice(0, _i2).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) return firstFittingPlacement = fittingPlacement, "break";
        }, _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
        state.placement !== firstFittingPlacement && (state.modifiersData[name]._skip = !0, state.placement = firstFittingPlacement, state.reset = !0);
    }
}
var flip_default = {
    name: "flip",
    enabled: !0,
    phase: "main",
    fn: flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: !1
    }
};
function getSideOffsets(overflow, rect, preventedOffsets) {
    return preventedOffsets === void 0 && (preventedOffsets = {
        x: 0,
        y: 0
    }), {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function isAnySideFullyClipped(overflow) {
    return [
        top,
        right,
        bottom,
        left
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function hide(_ref) {
    var state = _ref.state, name = _ref.name, referenceRect = state.rects.reference, popperRect = state.rects.popper, preventedOffsets = state.modifiersData.preventOverflow, referenceOverflow = detectOverflow(state, {
        elementContext: "reference"
    }), popperAltOverflow = detectOverflow(state, {
        altBoundary: !0
    }), referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect), popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets), isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets), hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets,
        popperEscapeOffsets,
        isReferenceHidden,
        hasPopperEscaped
    }, state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
}
var hide_default = {
    name: "hide",
    enabled: !0,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: hide
};
function distanceAndSkiddingToXY(placement, rects, offset2) {
    var basePlacement = getBasePlacement(placement), invertDistance = [
        left,
        top
    ].indexOf(basePlacement) >= 0 ? -1 : 1, _ref = typeof offset2 == "function" ? offset2(Object.assign({}, rects, {
        placement
    })) : offset2, skidding = _ref[0], distance = _ref[1];
    return skidding = skidding || 0, distance = (distance || 0) * invertDistance, [
        left,
        right
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name, _options$offset = options.offset, offset2 = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset, data = placements.reduce(function(acc, placement) {
        return acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2), acc;
    }, {}), _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    state.modifiersData.popperOffsets != null && (state.modifiersData.popperOffsets.x += x, state.modifiersData.popperOffsets.y += y), state.modifiersData[name] = data;
}
var offset_default = {
    name: "offset",
    enabled: !0,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: offset
};
function popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    state.modifiersData[name] = computeOffsets({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
}
var popperOffsets_default = {
    name: "popperOffsets",
    enabled: !0,
    phase: "read",
    fn: popperOffsets,
    data: {}
};
function getAltAxis(axis) {
    return axis === "x" ? "y" : "x";
}
function preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name, _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? !0 : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? !1 : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? !0 : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset, overflow = detectOverflow(state, {
        boundary,
        rootBoundary,
        padding,
        altBoundary
    }), basePlacement = getBasePlacement(state.placement), variation = getVariation(state.placement), isBasePlacement = !variation, mainAxis = getMainAxisFromPlacement(basePlacement), altAxis = getAltAxis(mainAxis), popperOffsets2 = state.modifiersData.popperOffsets, referenceRect = state.rects.reference, popperRect = state.rects.popper, tetherOffsetValue = typeof tetherOffset == "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset, normalizedTetherOffsetValue = typeof tetherOffsetValue == "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue), offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null, data = {
        x: 0,
        y: 0
    };
    if (popperOffsets2) {
        if (checkMainAxis) {
            var _offsetModifierState$, mainSide = mainAxis === "y" ? top : left, altSide = mainAxis === "y" ? bottom : right, len = mainAxis === "y" ? "height" : "width", offset2 = popperOffsets2[mainAxis], min2 = offset2 + overflow[mainSide], max2 = offset2 - overflow[altSide], additive = tether ? -popperRect[len] / 2 : 0, minLen = variation === start ? referenceRect[len] : popperRect[len], maxLen = variation === start ? -popperRect[len] : -referenceRect[len], arrowElement = state.elements.arrow, arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
                width: 0,
                height: 0
            }, arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject(), arrowPaddingMin = arrowPaddingObject[mainSide], arrowPaddingMax = arrowPaddingObject[altSide], arrowLen = within(0, referenceRect[len], arrowRect[len]), minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis, maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis, arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow), clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0, offsetModifierValue = (_offsetModifierState$ = offsetModifierState?.[mainAxis]) != null ? _offsetModifierState$ : 0, tetherMin = offset2 + minOffset - offsetModifierValue - clientOffset, tetherMax = offset2 + maxOffset - offsetModifierValue, preventedOffset = within(tether ? min(min2, tetherMin) : min2, offset2, tether ? max(max2, tetherMax) : max2);
            popperOffsets2[mainAxis] = preventedOffset, data[mainAxis] = preventedOffset - offset2;
        }
        if (checkAltAxis) {
            var _offsetModifierState$2, _mainSide = mainAxis === "x" ? top : left, _altSide = mainAxis === "x" ? bottom : right, _offset = popperOffsets2[altAxis], _len = altAxis === "y" ? "height" : "width", _min = _offset + overflow[_mainSide], _max = _offset - overflow[_altSide], isOriginSide = [
                top,
                left
            ].indexOf(basePlacement) !== -1, _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState?.[altAxis]) != null ? _offsetModifierState$2 : 0, _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis, _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max, _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
            popperOffsets2[altAxis] = _preventedOffset, data[altAxis] = _preventedOffset - _offset;
        }
        state.modifiersData[name] = data;
    }
}
var preventOverflow_default = {
    name: "preventOverflow",
    enabled: !0,
    phase: "main",
    fn: preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};
function getHTMLElementScroll(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}
function getNodeScroll(node) {
    return node === getWindow(node) || !isHTMLElement(node) ? getWindowScroll(node) : getHTMLElementScroll(node);
}
function isElementScaled(element) {
    var rect = element.getBoundingClientRect(), scaleX = round(rect.width) / element.offsetWidth || 1, scaleY = round(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    isFixed === void 0 && (isFixed = !1);
    var isOffsetParentAnElement = isHTMLElement(offsetParent), offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent), documentElement = getDocumentElement(offsetParent), rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed), scroll = {
        scrollLeft: 0,
        scrollTop: 0
    }, offsets = {
        x: 0,
        y: 0
    };
    return (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) && ((getNodeName(offsetParent) !== "body" || isScrollParent(documentElement)) && (scroll = getNodeScroll(offsetParent)), isHTMLElement(offsetParent) ? (offsets = getBoundingClientRect(offsetParent, !0), offsets.x += offsetParent.clientLeft, offsets.y += offsetParent.clientTop) : documentElement && (offsets.x = getWindowScrollBarX(documentElement))), {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}
function order(modifiers) {
    var map = new Map, visited = new Set, result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    });
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                depModifier && sort(depModifier);
            }
        }), result.push(modifier);
    }
    return modifiers.forEach(function(modifier) {
        visited.has(modifier.name) || sort(modifier);
    }), result;
}
function orderModifiers(modifiers) {
    var orderedModifiers = order(modifiers);
    return modifierPhases.reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}
function debounce(fn2) {
    var pending;
    return function() {
        return pending || (pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = void 0, resolve(fn2());
            });
        })), pending;
    };
}
function mergeByName(modifiers) {
    var merged = modifiers.reduce(function(merged2, current) {
        var existing = merged2[current.name];
        return merged2[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current, merged2;
    }, {});
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}
var DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect == "function");
    });
}
function popperGenerator(generatorOptions) {
    generatorOptions === void 0 && (generatorOptions = {});
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function(reference2, popper2, options) {
        options === void 0 && (options = defaultOptions);
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference2,
                popper: popper2
            },
            attributes: {},
            styles: {}
        }, effectCleanupFns = [], isDestroyed = !1, instance = {
            state,
            setOptions: function(setOptionsAction) {
                var options2 = typeof setOptionsAction == "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects(), state.options = Object.assign({}, defaultOptions, state.options, options2), state.scrollParents = {
                    reference: isElement(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
                    popper: listScrollParents(popper2)
                };
                var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
                return state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                }), runModifierEffects(), instance.update();
            },
            forceUpdate: function() {
                if (!isDestroyed) {
                    var _state$elements = state.elements, reference3 = _state$elements.reference, popper3 = _state$elements.popper;
                    if (areValidElements(reference3, popper3)) {
                        state.rects = {
                            reference: getCompositeRect(reference3, getOffsetParent(popper3), state.options.strategy === "fixed"),
                            popper: getLayoutRect(popper3)
                        }, state.reset = !1, state.placement = state.options.placement, state.orderedModifiers.forEach(function(modifier) {
                            return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                        });
                        for(var index = 0; index < state.orderedModifiers.length; index++){
                            if (state.reset === !0) {
                                state.reset = !1, index = -1;
                                continue;
                            }
                            var _state$orderedModifie = state.orderedModifiers[index], fn2 = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                            typeof fn2 == "function" && (state = fn2({
                                state,
                                options: _options,
                                name,
                                instance
                            }) || state);
                        }
                    }
                }
            },
            update: debounce(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate(), resolve(state);
                });
            }),
            destroy: function() {
                cleanupModifierEffects(), isDestroyed = !0;
            }
        };
        if (!areValidElements(reference2, popper2)) return instance;
        instance.setOptions(options).then(function(state2) {
            !isDestroyed && options.onFirstUpdate && options.onFirstUpdate(state2);
        });
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options2 = _ref$options === void 0 ? {} : _ref$options, effect4 = _ref.effect;
                if (typeof effect4 == "function") {
                    var cleanupFn = effect4({
                        state,
                        name,
                        instance,
                        options: options2
                    }), noopFn = function() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn2) {
                return fn2();
            }), effectCleanupFns = [];
        }
        return instance;
    };
}
var defaultModifiers = [
    eventListeners_default,
    popperOffsets_default,
    computeStyles_default,
    applyStyles_default,
    offset_default,
    flip_default,
    preventOverflow_default,
    arrow_default,
    hide_default
], createPopper = popperGenerator({
    defaultModifiers
});
var import_react_fast_compare = (0, _chunkJRLSWQMAMjs.__toESM)(require_react_fast_compare());
var EMPTY_MODIFIERS = [], usePopper = function(referenceElement, popperElement, options) {
    options === void 0 && (options = {});
    var prevOptions = _react.useRef(null), optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || EMPTY_MODIFIERS
    }, _React$useState = _react.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1], updateStateModifier = _react.useMemo(function() {
        return {
            name: "updateState",
            enabled: !0,
            phase: "write",
            fn: function(_ref) {
                var state2 = _ref.state, elements = Object.keys(state2.elements);
                _reactDom.flushSync(function() {
                    setState({
                        styles: fromEntries(elements.map(function(element) {
                            return [
                                element,
                                state2.styles[element] || {}
                            ];
                        })),
                        attributes: fromEntries(elements.map(function(element) {
                            return [
                                element,
                                state2.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []), popperOptions = _react.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: !1
                }
            ])
        };
        return (0, import_react_fast_compare.default)(prevOptions.current, newOptions) ? prevOptions.current || newOptions : (prevOptions.current = newOptions, newOptions);
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]), popperInstanceRef = _react.useRef();
    return useIsomorphicLayoutEffect(function() {
        popperInstanceRef.current && popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]), useIsomorphicLayoutEffect(function() {
        if (!(referenceElement == null || popperElement == null)) {
            var createPopper2 = options.createPopper || createPopper, popperInstance = createPopper2(referenceElement, popperElement, popperOptions);
            return popperInstanceRef.current = popperInstance, function() {
                popperInstance.destroy(), popperInstanceRef.current = null;
            };
        }
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]), {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};
function useGetLatest(val) {
    var ref = _react.useRef(val);
    return ref.current = val, _react.useCallback(function() {
        return ref.current;
    }, []);
}
var noop = function() {};
function useControlledState(_ref) {
    var initial = _ref.initial, value = _ref.value, _ref$onChange = _ref.onChange, onChange = _ref$onChange === void 0 ? noop : _ref$onChange;
    if (initial === void 0 && value === void 0) throw new TypeError('Either "value" or "initial" variable must be set. Now both are undefined');
    var _React$useState = _react.useState(initial), state = _React$useState[0], setState = _React$useState[1], getLatest = useGetLatest(state), set = _react.useCallback(function(updater) {
        var state2 = getLatest(), updatedState = typeof updater == "function" ? updater(state2) : updater;
        typeof updatedState.persist == "function" && updatedState.persist(), setState(updatedState), typeof onChange == "function" && onChange(updatedState);
    }, [
        getLatest,
        onChange
    ]), isControlled = value !== void 0;
    return [
        isControlled ? value : state,
        isControlled ? onChange : set
    ];
}
function generateBoundingClientRect(x, y) {
    return x === void 0 && (x = 0), y === void 0 && (y = 0), function() {
        return {
            width: 0,
            height: 0,
            top: y,
            right: x,
            bottom: y,
            left: x,
            x: 0,
            y: 0,
            toJSON: function() {
                return null;
            }
        };
    };
}
var _excluded = [
    "styles",
    "attributes"
], virtualElement = {
    getBoundingClientRect: generateBoundingClientRect()
}, defaultConfig = {
    closeOnOutsideClick: !0,
    closeOnTriggerHidden: !1,
    defaultVisible: !1,
    delayHide: 0,
    delayShow: 0,
    followCursor: !1,
    interactive: !1,
    mutationObserverOptions: {
        attributes: !0,
        childList: !0,
        subtree: !0
    },
    offset: [
        0,
        6
    ],
    trigger: "hover"
};
function usePopperTooltip(config, popperOptions) {
    var _popperProps$state, _popperProps$state$mo, _popperProps$state$mo2;
    config === void 0 && (config = {}), popperOptions === void 0 && (popperOptions = {});
    var finalConfig = Object.keys(defaultConfig).reduce(function(config2, key) {
        var _extends2;
        return _extends({}, config2, (_extends2 = {}, _extends2[key] = config2[key] !== void 0 ? config2[key] : defaultConfig[key], _extends2));
    }, config), defaultModifiers2 = _react.useMemo(function() {
        return [
            {
                name: "offset",
                options: {
                    offset: finalConfig.offset
                }
            }
        ];
    }, Array.isArray(finalConfig.offset) ? finalConfig.offset : []), finalPopperOptions = _extends({}, popperOptions, {
        placement: popperOptions.placement || finalConfig.placement,
        modifiers: popperOptions.modifiers || defaultModifiers2
    }), _React$useState = _react.useState(null), triggerRef = _React$useState[0], setTriggerRef = _React$useState[1], _React$useState2 = _react.useState(null), tooltipRef = _React$useState2[0], setTooltipRef = _React$useState2[1], _useControlledState = useControlledState({
        initial: finalConfig.defaultVisible,
        value: finalConfig.visible,
        onChange: finalConfig.onVisibleChange
    }), visible = _useControlledState[0], setVisible = _useControlledState[1], timer = _react.useRef();
    _react.useEffect(function() {
        return function() {
            return clearTimeout(timer.current);
        };
    }, []);
    var _usePopper = usePopper(finalConfig.followCursor ? virtualElement : triggerRef, tooltipRef, finalPopperOptions), styles = _usePopper.styles, attributes = _usePopper.attributes, popperProps = _objectWithoutPropertiesLoose(_usePopper, _excluded), update = popperProps.update, getLatest = useGetLatest({
        visible,
        triggerRef,
        tooltipRef,
        finalConfig
    }), isTriggeredBy = _react.useCallback(function(trigger) {
        return Array.isArray(finalConfig.trigger) ? finalConfig.trigger.includes(trigger) : finalConfig.trigger === trigger;
    }, Array.isArray(finalConfig.trigger) ? finalConfig.trigger : [
        finalConfig.trigger
    ]), hideTooltip = _react.useCallback(function() {
        clearTimeout(timer.current), timer.current = window.setTimeout(function() {
            return setVisible(!1);
        }, finalConfig.delayHide);
    }, [
        finalConfig.delayHide,
        setVisible
    ]), showTooltip = _react.useCallback(function() {
        clearTimeout(timer.current), timer.current = window.setTimeout(function() {
            return setVisible(!0);
        }, finalConfig.delayShow);
    }, [
        finalConfig.delayShow,
        setVisible
    ]), toggleTooltip = _react.useCallback(function() {
        getLatest().visible ? hideTooltip() : showTooltip();
    }, [
        getLatest,
        hideTooltip,
        showTooltip
    ]);
    _react.useEffect(function() {
        if (getLatest().finalConfig.closeOnOutsideClick) {
            var handleClickOutside = function(event) {
                var _event$composedPath, _getLatest = getLatest(), tooltipRef2 = _getLatest.tooltipRef, triggerRef2 = _getLatest.triggerRef, target = (event.composedPath == null || (_event$composedPath = event.composedPath()) == null ? void 0 : _event$composedPath[0]) || event.target;
                target instanceof Node && tooltipRef2 != null && triggerRef2 != null && !tooltipRef2.contains(target) && !triggerRef2.contains(target) && hideTooltip();
            };
            return document.addEventListener("mousedown", handleClickOutside), function() {
                return document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, [
        getLatest,
        hideTooltip
    ]), _react.useEffect(function() {
        if (!(triggerRef == null || !isTriggeredBy("click"))) return triggerRef.addEventListener("click", toggleTooltip), function() {
            return triggerRef.removeEventListener("click", toggleTooltip);
        };
    }, [
        triggerRef,
        isTriggeredBy,
        toggleTooltip
    ]), _react.useEffect(function() {
        if (!(triggerRef == null || !isTriggeredBy("double-click"))) return triggerRef.addEventListener("dblclick", toggleTooltip), function() {
            return triggerRef.removeEventListener("dblclick", toggleTooltip);
        };
    }, [
        triggerRef,
        isTriggeredBy,
        toggleTooltip
    ]), _react.useEffect(function() {
        if (!(triggerRef == null || !isTriggeredBy("right-click"))) {
            var preventDefaultAndToggle = function(event) {
                event.preventDefault(), toggleTooltip();
            };
            return triggerRef.addEventListener("contextmenu", preventDefaultAndToggle), function() {
                return triggerRef.removeEventListener("contextmenu", preventDefaultAndToggle);
            };
        }
    }, [
        triggerRef,
        isTriggeredBy,
        toggleTooltip
    ]), _react.useEffect(function() {
        if (!(triggerRef == null || !isTriggeredBy("focus"))) return triggerRef.addEventListener("focus", showTooltip), triggerRef.addEventListener("blur", hideTooltip), function() {
            triggerRef.removeEventListener("focus", showTooltip), triggerRef.removeEventListener("blur", hideTooltip);
        };
    }, [
        triggerRef,
        isTriggeredBy,
        showTooltip,
        hideTooltip
    ]), _react.useEffect(function() {
        if (!(triggerRef == null || !isTriggeredBy("hover"))) return triggerRef.addEventListener("mouseenter", showTooltip), triggerRef.addEventListener("mouseleave", hideTooltip), function() {
            triggerRef.removeEventListener("mouseenter", showTooltip), triggerRef.removeEventListener("mouseleave", hideTooltip);
        };
    }, [
        triggerRef,
        isTriggeredBy,
        showTooltip,
        hideTooltip
    ]), _react.useEffect(function() {
        if (!(tooltipRef == null || !isTriggeredBy("hover") || !getLatest().finalConfig.interactive)) return tooltipRef.addEventListener("mouseenter", showTooltip), tooltipRef.addEventListener("mouseleave", hideTooltip), function() {
            tooltipRef.removeEventListener("mouseenter", showTooltip), tooltipRef.removeEventListener("mouseleave", hideTooltip);
        };
    }, [
        tooltipRef,
        isTriggeredBy,
        showTooltip,
        hideTooltip,
        getLatest
    ]);
    var isReferenceHidden = popperProps == null || (_popperProps$state = popperProps.state) == null || (_popperProps$state$mo = _popperProps$state.modifiersData) == null || (_popperProps$state$mo2 = _popperProps$state$mo.hide) == null ? void 0 : _popperProps$state$mo2.isReferenceHidden;
    _react.useEffect(function() {
        finalConfig.closeOnTriggerHidden && isReferenceHidden && hideTooltip();
    }, [
        finalConfig.closeOnTriggerHidden,
        hideTooltip,
        isReferenceHidden
    ]), _react.useEffect(function() {
        if (!finalConfig.followCursor || triggerRef == null) return;
        function setMousePosition(_ref) {
            var clientX = _ref.clientX, clientY = _ref.clientY;
            virtualElement.getBoundingClientRect = generateBoundingClientRect(clientX, clientY), update?.();
        }
        return triggerRef.addEventListener("mousemove", setMousePosition), function() {
            return triggerRef.removeEventListener("mousemove", setMousePosition);
        };
    }, [
        finalConfig.followCursor,
        triggerRef,
        update
    ]), _react.useEffect(function() {
        if (!(tooltipRef == null || update == null || finalConfig.mutationObserverOptions == null)) {
            var observer = new MutationObserver(update);
            return observer.observe(tooltipRef, finalConfig.mutationObserverOptions), function() {
                return observer.disconnect();
            };
        }
    }, [
        finalConfig.mutationObserverOptions,
        tooltipRef,
        update
    ]);
    var getTooltipProps = function(args) {
        return args === void 0 && (args = {}), _extends({}, args, {
            style: _extends({}, args.style, styles.popper)
        }, attributes.popper, {
            "data-popper-interactive": finalConfig.interactive
        });
    }, getArrowProps = function(args) {
        return args === void 0 && (args = {}), _extends({}, args, attributes.arrow, {
            style: _extends({}, args.style, styles.arrow),
            "data-popper-arrow": !0
        });
    };
    return _extends({
        getArrowProps,
        getTooltipProps,
        setTooltipRef,
        setTriggerRef,
        tooltipRef,
        triggerRef,
        visible
    }, popperProps);
}
var match = (0, _memoizerificDefault.default)(1e3)((requests, actual, value, fallback = 0)=>actual.split("-")[0] === requests ? value : fallback), ArrowSpacing = 8, Arrow = (0, _theming.styled).div({
    position: "absolute",
    borderStyle: "solid"
}, ({ placement })=>{
    let x = 0, y = 0;
    switch(!0){
        case placement.startsWith("left") || placement.startsWith("right"):
            y = 8;
            break;
        case placement.startsWith("top") || placement.startsWith("bottom"):
            x = 8;
            break;
    }
    return {
        transform: `translate3d(${x}px, ${y}px, 0px)`
    };
}, ({ theme, color, placement })=>({
        bottom: `${match("top", placement, `${ArrowSpacing * -1}px`, "auto")}`,
        top: `${match("bottom", placement, `${ArrowSpacing * -1}px`, "auto")}`,
        right: `${match("left", placement, `${ArrowSpacing * -1}px`, "auto")}`,
        left: `${match("right", placement, `${ArrowSpacing * -1}px`, "auto")}`,
        borderBottomWidth: `${match("top", placement, "0", ArrowSpacing)}px`,
        borderTopWidth: `${match("bottom", placement, "0", ArrowSpacing)}px`,
        borderRightWidth: `${match("left", placement, "0", ArrowSpacing)}px`,
        borderLeftWidth: `${match("right", placement, "0", ArrowSpacing)}px`,
        borderTopColor: match("top", placement, theme.color[color] || color || theme.base === "light" ? (0, _theming.lighten)(theme.background.app) : theme.background.app, "transparent"),
        borderBottomColor: match("bottom", placement, theme.color[color] || color || theme.base === "light" ? (0, _theming.lighten)(theme.background.app) : theme.background.app, "transparent"),
        borderLeftColor: match("left", placement, theme.color[color] || color || theme.base === "light" ? (0, _theming.lighten)(theme.background.app) : theme.background.app, "transparent"),
        borderRightColor: match("right", placement, theme.color[color] || color || theme.base === "light" ? (0, _theming.lighten)(theme.background.app) : theme.background.app, "transparent")
    })), Wrapper = (0, _theming.styled).div(({ hidden })=>({
        display: hidden ? "none" : "inline-block",
        zIndex: 2147483647
    }), ({ theme, color, hasChrome })=>hasChrome ? {
        background: theme.color[color] || color || theme.base === "light" ? (0, _theming.lighten)(theme.background.app) : theme.background.app,
        filter: `
            drop-shadow(0px 5px 5px rgba(0,0,0,0.05))
            drop-shadow(0 1px 3px rgba(0,0,0,0.1))
          `,
        borderRadius: theme.appBorderRadius,
        fontSize: theme.typography.size.s1
    } : {}), Tooltip = (0, _reactDefault.default).forwardRef(({ placement, hasChrome, children, arrowProps, tooltipRef, color, withArrows, ...props }, ref)=>(0, _reactDefault.default).createElement(Wrapper, {
        "data-testid": "tooltip",
        hasChrome,
        ref,
        ...props,
        color
    }, hasChrome && withArrows && (0, _reactDefault.default).createElement(Arrow, {
        placement,
        ...arrowProps,
        color
    }), children));
Tooltip.displayName = "Tooltip";
Tooltip.defaultProps = {
    color: void 0,
    tooltipRef: void 0,
    hasChrome: !0,
    placement: "top",
    arrowProps: {}
};
var { document: document2 } = (0, _global.global), TargetContainer = (0, _theming.styled).div`
  display: inline-block;
  cursor: ${(props)=>props.trigger === "hover" || props.trigger.includes("hover") ? "default" : "pointer"};
`, TargetSvgContainer = (0, _theming.styled).g`
  cursor: ${(props)=>props.trigger === "hover" || props.trigger.includes("hover") ? "default" : "pointer"};
`, WithTooltipPure = ({ svg, trigger, closeOnOutsideClick, placement, hasChrome, withArrows, offset: offset2, tooltip, children, closeOnTriggerHidden, mutationObserverOptions, closeOnClick, tooltipShown, onVisibilityChange, defaultVisible, delayHide, visible, interactive, delayShow, modifiers, strategy, followCursor, onVisibleChange, ...props })=>{
    let Container = svg ? TargetSvgContainer : TargetContainer, { getArrowProps, getTooltipProps, setTooltipRef, setTriggerRef, visible: isVisible, state } = usePopperTooltip({
        trigger,
        placement,
        defaultVisible: defaultVisible ?? tooltipShown,
        delayHide,
        interactive,
        closeOnOutsideClick: closeOnOutsideClick ?? closeOnClick,
        closeOnTriggerHidden,
        onVisibleChange: (_isVisible)=>{
            onVisibilityChange?.(_isVisible), onVisibleChange?.(_isVisible);
        },
        delayShow,
        followCursor,
        mutationObserverOptions,
        visible,
        offset: offset2
    }, {
        modifiers,
        strategy
    }), tooltipComponent = (0, _reactDefault.default).createElement(Tooltip, {
        placement: state?.placement,
        ref: setTooltipRef,
        hasChrome,
        arrowProps: getArrowProps(),
        withArrows,
        ...getTooltipProps()
    }, typeof tooltip == "function" ? tooltip({
        onHide: ()=>onVisibleChange(!1)
    }) : tooltip);
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement(Container, {
        trigger,
        ref: setTriggerRef,
        ...props
    }, children), isVisible && (0, _reactDomDefault.default).createPortal(tooltipComponent, document2.body));
};
WithTooltipPure.defaultProps = {
    svg: !1,
    trigger: "click",
    closeOnOutsideClick: !1,
    placement: "top",
    modifiers: [
        {
            name: "preventOverflow",
            options: {
                padding: 8
            }
        },
        {
            name: "offset",
            options: {
                offset: [
                    8,
                    8
                ]
            }
        },
        {
            name: "arrow",
            options: {
                padding: 8
            }
        }
    ],
    hasChrome: !0,
    defaultVisible: !1
};
var WithToolTipState = ({ startOpen = !1, onVisibleChange: onChange, ...rest })=>{
    let [tooltipShown, setTooltipShown] = (0, _react.useState)(startOpen), onVisibilityChange = (0, _react.useCallback)((visibility)=>{
        onChange && onChange(visibility) === !1 || setTooltipShown(visibility);
    }, [
        onChange
    ]);
    return (0, _react.useEffect)(()=>{
        let hide2 = ()=>onVisibilityChange(!1);
        document2.addEventListener("keydown", hide2, !1);
        let iframes = Array.from(document2.getElementsByTagName("iframe")), unbinders = [];
        return iframes.forEach((iframe)=>{
            let bind = ()=>{
                try {
                    iframe.contentWindow.document && (iframe.contentWindow.document.addEventListener("click", hide2), unbinders.push(()=>{
                        try {
                            iframe.contentWindow.document.removeEventListener("click", hide2);
                        } catch  {}
                    }));
                } catch  {}
            };
            bind(), iframe.addEventListener("load", bind), unbinders.push(()=>{
                iframe.removeEventListener("load", bind);
            });
        }), ()=>{
            document2.removeEventListener("keydown", hide2), unbinders.forEach((unbind)=>{
                unbind();
            });
        };
    }), (0, _reactDefault.default).createElement(WithTooltipPure, {
        ...rest,
        visible: tooltipShown,
        onVisibleChange: onVisibilityChange
    });
};

},{"./chunk-JRLSWQMA.mjs":"cGDqS","react":"jEiK2","react-dom":"a0ZmT","@storybook/theming":"bYlbs","@storybook/global":"4g4co","memoizerific":"aOMtb","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"ah6gN":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useResizeObserver);
var _react = require("react");
// This could've been more streamlined with internal state instead of abusing
// refs to such extent, but then composing hooks and components could not opt out of unnecessary renders.
function useResolvedElement(subscriber, refOrElement) {
    var lastReportRef = (0, _react.useRef)(null);
    var refOrElementRef = (0, _react.useRef)(null);
    refOrElementRef.current = refOrElement;
    var cbElementRef = (0, _react.useRef)(null); // Calling re-evaluation after each render without using a dep array,
    // as the ref object's current value could've changed since the last render.
    (0, _react.useEffect)(function() {
        evaluateSubscription();
    });
    var evaluateSubscription = (0, _react.useCallback)(function() {
        var cbElement = cbElementRef.current;
        var refOrElement = refOrElementRef.current; // Ugly ternary. But smaller than an if-else block.
        var element = cbElement ? cbElement : refOrElement ? refOrElement instanceof Element ? refOrElement : refOrElement.current : null;
        if (lastReportRef.current && lastReportRef.current.element === element && lastReportRef.current.subscriber === subscriber) return;
        if (lastReportRef.current && lastReportRef.current.cleanup) lastReportRef.current.cleanup();
        lastReportRef.current = {
            element: element,
            subscriber: subscriber,
            // Only calling the subscriber, if there's an actual element to report.
            // Setting cleanup to undefined unless a subscriber returns one, as an existing cleanup function would've been just called.
            cleanup: element ? subscriber(element) : undefined
        };
    }, [
        subscriber
    ]); // making sure we call the cleanup function on unmount
    (0, _react.useEffect)(function() {
        return function() {
            if (lastReportRef.current && lastReportRef.current.cleanup) {
                lastReportRef.current.cleanup();
                lastReportRef.current = null;
            }
        };
    }, []);
    return (0, _react.useCallback)(function(element) {
        cbElementRef.current = element;
        evaluateSubscription();
    }, [
        evaluateSubscription
    ]);
}
// We're only using the first element of the size sequences, until future versions of the spec solidify on how
// exactly it'll be used for fragments in multi-column scenarios:
// From the spec:
// > The box size properties are exposed as FrozenArray in order to support elements that have multiple fragments,
// > which occur in multi-column scenarios. However the current definitions of content rect and border box do not
// > mention how those boxes are affected by multi-column layout. In this spec, there will only be a single
// > ResizeObserverSize returned in the FrozenArray, which will correspond to the dimensions of the first column.
// > A future version of this spec will extend the returned FrozenArray to contain the per-fragment size information.
// (https://drafts.csswg.org/resize-observer/#resize-observer-entry-interface)
//
// Also, testing these new box options revealed that in both Chrome and FF everything is returned in the callback,
// regardless of the "box" option.
// The spec states the following on this:
// > This does not have any impact on which box dimensions are returned to the defined callback when the event
// > is fired, it solely defines which box the author wishes to observe layout changes on.
// (https://drafts.csswg.org/resize-observer/#resize-observer-interface)
// I'm not exactly clear on what this means, especially when you consider a later section stating the following:
// > This section is non-normative. An author may desire to observe more than one CSS box.
// > In this case, author will need to use multiple ResizeObservers.
// (https://drafts.csswg.org/resize-observer/#resize-observer-interface)
// Which is clearly not how current browser implementations behave, and seems to contradict the previous quote.
// For this reason I decided to only return the requested size,
// even though it seems we have access to results for all box types.
// This also means that we get to keep the current api, being able to return a simple { width, height } pair,
// regardless of box option.
function extractSize(entry, boxProp, sizeType) {
    if (!entry[boxProp]) {
        if (boxProp === "contentBoxSize") // The dimensions in `contentBoxSize` and `contentRect` are equivalent according to the spec.
        // See the 6th step in the description for the RO algorithm:
        // https://drafts.csswg.org/resize-observer/#create-and-populate-resizeobserverentry-h
        // > Set this.contentRect to logical this.contentBoxSize given target and observedBox of "content-box".
        // In real browser implementations of course these objects differ, but the width/height values should be equivalent.
        return entry.contentRect[sizeType === "inlineSize" ? "width" : "height"];
        return undefined;
    } // A couple bytes smaller than calling Array.isArray() and just as effective here.
    return entry[boxProp][0] ? entry[boxProp][0][sizeType] : // behaviour of returning objects instead of arrays for `borderBoxSize` and `contentBoxSize`.
    // @ts-ignore
    entry[boxProp][sizeType];
}
function useResizeObserver(opts) {
    if (opts === void 0) opts = {};
    // Saving the callback as a ref. With this, I don't need to put onResize in the
    // effect dep array, and just passing in an anonymous function without memoising
    // will not reinstantiate the hook's ResizeObserver.
    var onResize = opts.onResize;
    var onResizeRef = (0, _react.useRef)(undefined);
    onResizeRef.current = onResize;
    var round = opts.round || Math.round; // Using a single instance throughout the hook's lifetime
    var resizeObserverRef = (0, _react.useRef)();
    var _useState = (0, _react.useState)({
        width: undefined,
        height: undefined
    }), size = _useState[0], setSize = _useState[1]; // In certain edge cases the RO might want to report a size change just after
    // the component unmounted.
    var didUnmount = (0, _react.useRef)(false);
    (0, _react.useEffect)(function() {
        didUnmount.current = false;
        return function() {
            didUnmount.current = true;
        };
    }, []); // Using a ref to track the previous width / height to avoid unnecessary renders.
    var previous = (0, _react.useRef)({
        width: undefined,
        height: undefined
    }); // This block is kinda like a useEffect, only it's called whenever a new
    // element could be resolved based on the ref option. It also has a cleanup
    // function.
    var refCallback = useResolvedElement((0, _react.useCallback)(function(element) {
        // We only use a single Resize Observer instance, and we're instantiating it on demand, only once there's something to observe.
        // This instance is also recreated when the `box` option changes, so that a new observation is fired if there was a previously observed element with a different box option.
        if (!resizeObserverRef.current || resizeObserverRef.current.box !== opts.box || resizeObserverRef.current.round !== round) resizeObserverRef.current = {
            box: opts.box,
            round: round,
            instance: new ResizeObserver(function(entries) {
                var entry = entries[0];
                var boxProp = opts.box === "border-box" ? "borderBoxSize" : opts.box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize";
                var reportedWidth = extractSize(entry, boxProp, "inlineSize");
                var reportedHeight = extractSize(entry, boxProp, "blockSize");
                var newWidth = reportedWidth ? round(reportedWidth) : undefined;
                var newHeight = reportedHeight ? round(reportedHeight) : undefined;
                if (previous.current.width !== newWidth || previous.current.height !== newHeight) {
                    var newSize = {
                        width: newWidth,
                        height: newHeight
                    };
                    previous.current.width = newWidth;
                    previous.current.height = newHeight;
                    if (onResizeRef.current) onResizeRef.current(newSize);
                    else if (!didUnmount.current) setSize(newSize);
                }
            })
        };
        resizeObserverRef.current.instance.observe(element, {
            box: opts.box
        });
        return function() {
            if (resizeObserverRef.current) resizeObserverRef.current.instance.unobserve(element);
        };
    }, [
        opts.box,
        round
    ]), opts.ref);
    return (0, _react.useMemo)(function() {
        return {
            ref: refCallback,
            width: size.width,
            height: size.height
        };
    }, [
        refCallback,
        size.width,
        size.height
    ]);
}

},{"react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"eJzsN":[function(require,module,exports) {
module.exports = require("37a60cd6f0deed0f")(require("1b86cf87a070f990").resolve("6Frmr")).then(()=>module.bundle.root('dsisd'));

},{"37a60cd6f0deed0f":"bvDWj","1b86cf87a070f990":"kK08P"}],"bvDWj":[function(require,module,exports) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"5uDf9"}],"5uDf9":[function(require,module,exports) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"kK08P":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"5TfLM":[function(require,module,exports) {
module.exports = require("3309e609b8424777")(require("63001f18a49acf7c").resolve("fj7es")).then(()=>module.bundle.root('ikE14'));

},{"3309e609b8424777":"bvDWj","63001f18a49acf7c":"kK08P"}],"g2jam":[function(require,module,exports) {
module.exports = require("1c5fdc138b10f011")(require("e7c1466372fe0e98").resolve("922rR")).then(()=>module.bundle.root('f4eak'));

},{"1c5fdc138b10f011":"bvDWj","e7c1466372fe0e98":"kK08P"}],"5ONsA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "adjustHue", ()=>curriedAdjustHue$1);
parcelHelpers.export(exports, "animation", ()=>animation);
parcelHelpers.export(exports, "backgroundImages", ()=>backgroundImages);
parcelHelpers.export(exports, "backgrounds", ()=>backgrounds);
parcelHelpers.export(exports, "between", ()=>between);
parcelHelpers.export(exports, "border", ()=>border);
parcelHelpers.export(exports, "borderColor", ()=>borderColor);
parcelHelpers.export(exports, "borderRadius", ()=>borderRadius);
parcelHelpers.export(exports, "borderStyle", ()=>borderStyle);
parcelHelpers.export(exports, "borderWidth", ()=>borderWidth);
parcelHelpers.export(exports, "buttons", ()=>buttons);
parcelHelpers.export(exports, "clearFix", ()=>clearFix);
parcelHelpers.export(exports, "complement", ()=>complement);
parcelHelpers.export(exports, "cover", ()=>cover);
parcelHelpers.export(exports, "cssVar", ()=>cssVar);
parcelHelpers.export(exports, "darken", ()=>curriedDarken$1);
parcelHelpers.export(exports, "desaturate", ()=>curriedDesaturate$1);
parcelHelpers.export(exports, "directionalProperty", ()=>directionalProperty);
parcelHelpers.export(exports, "easeIn", ()=>easeIn);
parcelHelpers.export(exports, "easeInOut", ()=>easeInOut);
parcelHelpers.export(exports, "easeOut", ()=>easeOut);
parcelHelpers.export(exports, "ellipsis", ()=>ellipsis);
parcelHelpers.export(exports, "em", ()=>em$1);
parcelHelpers.export(exports, "fluidRange", ()=>fluidRange);
parcelHelpers.export(exports, "fontFace", ()=>fontFace);
parcelHelpers.export(exports, "getContrast", ()=>getContrast);
parcelHelpers.export(exports, "getLuminance", ()=>getLuminance);
parcelHelpers.export(exports, "getValueAndUnit", ()=>getValueAndUnit);
parcelHelpers.export(exports, "grayscale", ()=>grayscale);
parcelHelpers.export(exports, "hiDPI", ()=>hiDPI);
parcelHelpers.export(exports, "hideText", ()=>hideText);
parcelHelpers.export(exports, "hideVisually", ()=>hideVisually);
parcelHelpers.export(exports, "hsl", ()=>hsl);
parcelHelpers.export(exports, "hslToColorString", ()=>hslToColorString);
parcelHelpers.export(exports, "hsla", ()=>hsla);
parcelHelpers.export(exports, "important", ()=>important);
parcelHelpers.export(exports, "invert", ()=>invert);
parcelHelpers.export(exports, "lighten", ()=>curriedLighten$1);
parcelHelpers.export(exports, "linearGradient", ()=>linearGradient);
parcelHelpers.export(exports, "margin", ()=>margin);
parcelHelpers.export(exports, "math", ()=>math);
parcelHelpers.export(exports, "meetsContrastGuidelines", ()=>meetsContrastGuidelines);
parcelHelpers.export(exports, "mix", ()=>mix$1);
parcelHelpers.export(exports, "modularScale", ()=>modularScale);
parcelHelpers.export(exports, "normalize", ()=>normalize);
parcelHelpers.export(exports, "opacify", ()=>curriedOpacify$1);
parcelHelpers.export(exports, "padding", ()=>padding);
parcelHelpers.export(exports, "parseToHsl", ()=>parseToHsl);
parcelHelpers.export(exports, "parseToRgb", ()=>parseToRgb);
parcelHelpers.export(exports, "position", ()=>position);
parcelHelpers.export(exports, "radialGradient", ()=>radialGradient);
parcelHelpers.export(exports, "readableColor", ()=>readableColor);
parcelHelpers.export(exports, "rem", ()=>rem$1);
parcelHelpers.export(exports, "remToPx", ()=>remToPx);
parcelHelpers.export(exports, "retinaImage", ()=>retinaImage);
parcelHelpers.export(exports, "rgb", ()=>rgb);
parcelHelpers.export(exports, "rgbToColorString", ()=>rgbToColorString);
parcelHelpers.export(exports, "rgba", ()=>rgba);
parcelHelpers.export(exports, "saturate", ()=>curriedSaturate$1);
parcelHelpers.export(exports, "setHue", ()=>curriedSetHue$1);
parcelHelpers.export(exports, "setLightness", ()=>curriedSetLightness$1);
parcelHelpers.export(exports, "setSaturation", ()=>curriedSetSaturation$1);
parcelHelpers.export(exports, "shade", ()=>curriedShade$1);
parcelHelpers.export(exports, "size", ()=>size);
parcelHelpers.export(exports, "stripUnit", ()=>stripUnit);
parcelHelpers.export(exports, "textInputs", ()=>textInputs);
parcelHelpers.export(exports, "timingFunctions", ()=>timingFunctions);
parcelHelpers.export(exports, "tint", ()=>curriedTint$1);
parcelHelpers.export(exports, "toColorString", ()=>toColorString);
parcelHelpers.export(exports, "transitions", ()=>transitions);
parcelHelpers.export(exports, "transparentize", ()=>curriedTransparentize$1);
parcelHelpers.export(exports, "triangle", ()=>triangle);
parcelHelpers.export(exports, "wordWrap", ()=>wordWrap);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _wrapNativeSuper = require("@babel/runtime/helpers/esm/wrapNativeSuper");
var _wrapNativeSuperDefault = parcelHelpers.interopDefault(_wrapNativeSuper);
var _taggedTemplateLiteralLoose = require("@babel/runtime/helpers/esm/taggedTemplateLiteralLoose");
var _taggedTemplateLiteralLooseDefault = parcelHelpers.interopDefault(_taggedTemplateLiteralLoose);
function last() {
    var _ref;
    return _ref = arguments.length - 1, _ref < 0 || arguments.length <= _ref ? undefined : arguments[_ref];
}
function negation(a) {
    return -a;
}
function addition(a, b) {
    return a + b;
}
function subtraction(a, b) {
    return a - b;
}
function multiplication(a, b) {
    return a * b;
}
function division(a, b) {
    return a / b;
}
function max() {
    return Math.max.apply(Math, arguments);
}
function min() {
    return Math.min.apply(Math, arguments);
}
function comma() {
    return Array.of.apply(Array, arguments);
}
var defaultSymbols = {
    symbols: {
        '*': {
            infix: {
                symbol: '*',
                f: multiplication,
                notation: 'infix',
                precedence: 4,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: '*',
            regSymbol: '\\*'
        },
        '/': {
            infix: {
                symbol: '/',
                f: division,
                notation: 'infix',
                precedence: 4,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: '/',
            regSymbol: '/'
        },
        '+': {
            infix: {
                symbol: '+',
                f: addition,
                notation: 'infix',
                precedence: 2,
                rightToLeft: 0,
                argCount: 2
            },
            prefix: {
                symbol: '+',
                f: last,
                notation: 'prefix',
                precedence: 3,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: '+',
            regSymbol: '\\+'
        },
        '-': {
            infix: {
                symbol: '-',
                f: subtraction,
                notation: 'infix',
                precedence: 2,
                rightToLeft: 0,
                argCount: 2
            },
            prefix: {
                symbol: '-',
                f: negation,
                notation: 'prefix',
                precedence: 3,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: '-',
            regSymbol: '-'
        },
        ',': {
            infix: {
                symbol: ',',
                f: comma,
                notation: 'infix',
                precedence: 1,
                rightToLeft: 0,
                argCount: 2
            },
            symbol: ',',
            regSymbol: ','
        },
        '(': {
            prefix: {
                symbol: '(',
                f: last,
                notation: 'prefix',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: '(',
            regSymbol: '\\('
        },
        ')': {
            postfix: {
                symbol: ')',
                f: undefined,
                notation: 'postfix',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: ')',
            regSymbol: '\\)'
        },
        min: {
            func: {
                symbol: 'min',
                f: min,
                notation: 'func',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: 'min',
            regSymbol: 'min\\b'
        },
        max: {
            func: {
                symbol: 'max',
                f: max,
                notation: 'func',
                precedence: 0,
                rightToLeft: 0,
                argCount: 1
            },
            symbol: 'max',
            regSymbol: 'max\\b'
        }
    }
};
var defaultSymbolMap = defaultSymbols;
// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js
/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */ var ERRORS = {
    "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
    "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
    "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
    "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
    "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
    "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
    "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
    "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
    "9": "Please provide a number of steps to the modularScale helper.\n\n",
    "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
    "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
    "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
    "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
    "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
    "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
    "16": "You must provide a template to this method.\n\n",
    "17": "You passed an unsupported selector state to this method.\n\n",
    "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
    "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
    "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
    "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
    "23": "fontFace expects a name of a font-family.\n\n",
    "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
    "25": "fontFace expects localFonts to be an array.\n\n",
    "26": "fontFace expects fileFormats to be an array.\n\n",
    "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
    "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
    "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
    "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
    "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
    "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
    "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
    "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
    "36": "Property must be a string value.\n\n",
    "37": "Syntax Error at %s.\n\n",
    "38": "Formula contains a function that needs parentheses at %s.\n\n",
    "39": "Formula is missing closing parenthesis at %s.\n\n",
    "40": "Formula has too many closing parentheses at %s.\n\n",
    "41": "All values in a formula must have the same unit or be unitless.\n\n",
    "42": "Please provide a number of steps to the modularScale helper.\n\n",
    "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
    "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
    "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
    "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
    "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
    "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
    "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
    "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
    "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
    "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
    "53": "fontFace expects localFonts to be an array.\n\n",
    "54": "fontFace expects fileFormats to be an array.\n\n",
    "55": "fontFace expects a name of a font-family.\n\n",
    "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
    "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
    "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
    "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
    "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
    "61": "Property must be a string value.\n\n",
    "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
    "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
    "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
    "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
    "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
    "67": "You must provide a template to this method.\n\n",
    "68": "You passed an unsupported selector state to this method.\n\n",
    "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
    "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
    "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
    "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
    "73": "Please provide a valid CSS variable.\n\n",
    "74": "CSS variable not found and no default was provided.\n\n",
    "75": "important requires a valid style object, got a %s instead.\n\n",
    "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
    "77": "remToPx expects a value in \"rem\" but you provided it in \"%s\".\n\n",
    "78": "base must be set in \"px\" or \"%\" but you set it in \"%s\".\n"
};
/**
 * super basic version of sprintf
 * @private
 */ function format() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var a = args[0];
    var b = [];
    var c;
    for(c = 1; c < args.length; c += 1)b.push(args[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */ var PolishedError = /*#__PURE__*/ function(_Error) {
    (0, _inheritsLooseDefault.default)(PolishedError, _Error);
    function PolishedError(code) {
        var _this;
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        _this = _Error.call(this, format.apply(void 0, [
            ERRORS[code]
        ].concat(args))) || this;
        return (0, _assertThisInitializedDefault.default)(_this);
    }
    return PolishedError;
}(/*#__PURE__*/ (0, _wrapNativeSuperDefault.default)(Error));
var unitRegExp = /((?!\w)a|na|hc|mc|dg|me[r]?|xe|ni(?![a-zA-Z])|mm|cp|tp|xp|q(?!s)|hv|xamv|nimv|wv|sm|s(?!\D|$)|ged|darg?|nrut)/g; // Merges additional math functionality into the defaults.
function mergeSymbolMaps(additionalSymbols) {
    var symbolMap = {};
    symbolMap.symbols = additionalSymbols ? (0, _extendsDefault.default)({}, defaultSymbolMap.symbols, additionalSymbols.symbols) : (0, _extendsDefault.default)({}, defaultSymbolMap.symbols);
    return symbolMap;
}
function exec(operators, values) {
    var _ref;
    var op = operators.pop();
    values.push(op.f.apply(op, (_ref = []).concat.apply(_ref, values.splice(-op.argCount))));
    return op.precedence;
}
function calculate(expression, additionalSymbols) {
    var symbolMap = mergeSymbolMaps(additionalSymbols);
    var match;
    var operators = [
        symbolMap.symbols['('].prefix
    ];
    var values = [];
    var pattern = new RegExp("\\d+(?:\\.\\d+)?|" + // ...and patterns for individual operators/function names
    Object.keys(symbolMap.symbols).map(function(key) {
        return symbolMap.symbols[key];
    }) // longer symbols should be listed first
    // $FlowFixMe
    .sort(function(a, b) {
        return b.symbol.length - a.symbol.length;
    }) // $FlowFixMe
    .map(function(val) {
        return val.regSymbol;
    }).join('|') + "|(\\S)", 'g');
    pattern.lastIndex = 0; // Reset regular expression object
    var afterValue = false;
    do {
        match = pattern.exec(expression);
        var _ref2 = match || [
            ')',
            undefined
        ], token = _ref2[0], bad = _ref2[1];
        var notNumber = symbolMap.symbols[token];
        var notNewValue = notNumber && !notNumber.prefix && !notNumber.func;
        var notAfterValue = !notNumber || !notNumber.postfix && !notNumber.infix; // Check for syntax errors:
        if (bad || (afterValue ? notAfterValue : notNewValue)) throw new PolishedError(37, match ? match.index : expression.length, expression);
        if (afterValue) {
            // We either have an infix or postfix operator (they should be mutually exclusive)
            var curr = notNumber.postfix || notNumber.infix;
            do {
                var prev = operators[operators.length - 1];
                if ((curr.precedence - prev.precedence || prev.rightToLeft) > 0) break; // Apply previous operator, since it has precedence over current one
            }while (exec(operators, values)); // Exit loop after executing an opening parenthesis or function
            afterValue = curr.notation === 'postfix';
            if (curr.symbol !== ')') {
                operators.push(curr); // Postfix always has precedence over any operator that follows after it
                if (afterValue) exec(operators, values);
            }
        } else if (notNumber) {
            // prefix operator or function
            operators.push(notNumber.prefix || notNumber.func);
            if (notNumber.func) {
                // Require an opening parenthesis
                match = pattern.exec(expression);
                if (!match || match[0] !== '(') throw new PolishedError(38, match ? match.index : expression.length, expression);
            }
        } else {
            // number
            values.push(+token);
            afterValue = true;
        }
    }while (match && operators.length);
    if (operators.length) throw new PolishedError(39, match ? match.index : expression.length, expression);
    else if (match) throw new PolishedError(40, match ? match.index : expression.length, expression);
    else return values.pop();
}
function reverseString(str) {
    return str.split('').reverse().join('');
}
/**
 * Helper for doing math with CSS Units. Accepts a formula as a string. All values in the formula must have the same unit (or be unitless). Supports complex formulas utliziing addition, subtraction, multiplication, division, square root, powers, factorial, min, max, as well as parentheses for order of operation.
 *
 *In cases where you need to do calculations with mixed units where one unit is a [relative length unit](https://developer.mozilla.org/en-US/docs/Web/CSS/length#Relative_length_units), you will want to use [CSS Calc](https://developer.mozilla.org/en-US/docs/Web/CSS/calc).
 *
 * *warning* While we've done everything possible to ensure math safely evalutes formulas expressed as strings, you should always use extreme caution when passing `math` user provided values.
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: math('12rem + 8rem'),
 *   fontSize: math('(12px + 2px) * 3'),
 *   fontSize: math('3px^2 + sqrt(4)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${math('12rem + 8rem')};
 *   fontSize: ${math('(12px + 2px) * 3')};
 *   fontSize: ${math('3px^2 + sqrt(4)')};
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   fontSize: '20rem',
 *   fontSize: '42px',
 *   fontSize: '11px',
 * }
 */ function math(formula, additionalSymbols) {
    var reversedFormula = reverseString(formula);
    var formulaMatch = reversedFormula.match(unitRegExp); // Check that all units are the same
    if (formulaMatch && !formulaMatch.every(function(unit) {
        return unit === formulaMatch[0];
    })) throw new PolishedError(41);
    var cleanFormula = reverseString(reversedFormula.replace(unitRegExp, ''));
    return "" + calculate(cleanFormula, additionalSymbols) + (formulaMatch ? reverseString(formulaMatch[0]) : '');
}
var cssVariableRegex = /--[\S]*/g;
/**
 * Fetches the value of a passed CSS Variable in the :root scope, or otherwise returns a defaultValue if provided.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'background': cssVar('--background-color'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${cssVar('--background-color')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'background': 'red'
 * }
 */ function cssVar(cssVariable, defaultValue) {
    if (!cssVariable || !cssVariable.match(cssVariableRegex)) throw new PolishedError(73);
    var variableValue;
    /* eslint-disable */ /* istanbul ignore next */ if (typeof document !== 'undefined' && document.documentElement !== null) variableValue = getComputedStyle(document.documentElement).getPropertyValue(cssVariable);
    /* eslint-enable */ if (variableValue) return variableValue.trim();
    else if (defaultValue) return defaultValue;
    throw new PolishedError(74);
}
// @private
function capitalizeString(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var positionMap$1 = [
    'Top',
    'Right',
    'Bottom',
    'Left'
];
function generateProperty(property, position) {
    if (!property) return position.toLowerCase();
    var splitProperty = property.split('-');
    if (splitProperty.length > 1) {
        splitProperty.splice(1, 0, position);
        return splitProperty.reduce(function(acc, val) {
            return "" + acc + capitalizeString(val);
        });
    }
    var joinedProperty = property.replace(/([a-z])([A-Z])/g, "$1" + position + "$2");
    return property === joinedProperty ? "" + property + position : joinedProperty;
}
function generateStyles(property, valuesWithDefaults) {
    var styles = {};
    for(var i = 0; i < valuesWithDefaults.length; i += 1)if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) styles[generateProperty(property, positionMap$1[i])] = valuesWithDefaults[i];
    return styles;
}
/**
 * Enables shorthand for direction-based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function directionalProperty(property) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    //  prettier-ignore
    var firstValue = values[0], _values$ = values[1], secondValue = _values$ === void 0 ? firstValue : _values$, _values$2 = values[2], thirdValue = _values$2 === void 0 ? firstValue : _values$2, _values$3 = values[3], fourthValue = _values$3 === void 0 ? secondValue : _values$3;
    var valuesWithDefaults = [
        firstValue,
        secondValue,
        thirdValue,
        fourthValue
    ];
    return generateStyles(property, valuesWithDefaults);
}
/**
 * Check if a string ends with something
 * @private
 */ function endsWith(string, suffix) {
    return string.substr(-suffix.length) === suffix;
}
var cssRegex$1 = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value minus its unit of measure.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */ function stripUnit(value) {
    if (typeof value !== 'string') return value;
    var matchedValue = value.match(cssRegex$1);
    return matchedValue ? parseFloat(value) : value;
}
/**
 * Factory function that creates pixel-to-x converters
 * @private
 */ var pxtoFactory = function pxtoFactory(to) {
    return function(pxval, base) {
        if (base === void 0) base = '16px';
        var newPxval = pxval;
        var newBase = base;
        if (typeof pxval === 'string') {
            if (!endsWith(pxval, 'px')) throw new PolishedError(69, to, pxval);
            newPxval = stripUnit(pxval);
        }
        if (typeof base === 'string') {
            if (!endsWith(base, 'px')) throw new PolishedError(70, to, base);
            newBase = stripUnit(base);
        }
        if (typeof newPxval === 'string') throw new PolishedError(71, pxval, to);
        if (typeof newBase === 'string') throw new PolishedError(72, base, to);
        return "" + newPxval / newBase + to;
    };
};
var pixelsto = pxtoFactory;
/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */ var em = /*#__PURE__*/ pixelsto('em');
var em$1 = em;
var cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;
/**
 * Returns a given CSS value and its unit as elements of an array.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': getValueAndUnit('100px')[0],
 *   '--unit': getValueAndUnit('100px')[1],
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${getValueAndUnit('100px')[0]};
 *   --unit: ${getValueAndUnit('100px')[1]};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100,
 *   '--unit': 'px',
 * }
 */ function getValueAndUnit(value) {
    if (typeof value !== 'string') return [
        value,
        ''
    ];
    var matchedValue = value.match(cssRegex);
    if (matchedValue) return [
        parseFloat(value),
        matchedValue[2]
    ];
    return [
        value,
        undefined
    ];
}
/**
 * Helper for targeting rules in a style block generated by polished modules that need !important-level specificity. Can optionally specify a rule (or rules) to target specific rules.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...important(cover())
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${important(cover())}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute !important',
 *   'top': '0 !important',
 *   'right: '0 !important',
 *   'bottom': '0 !important',
 *   'left: '0 !important'
 * }
 */ function important(styleBlock, rules) {
    if (typeof styleBlock !== 'object' || styleBlock === null) throw new PolishedError(75, typeof styleBlock);
    var newStyleBlock = {};
    Object.keys(styleBlock).forEach(function(key) {
        if (typeof styleBlock[key] === 'object' && styleBlock[key] !== null) newStyleBlock[key] = important(styleBlock[key], rules);
        else if (!rules || rules && (rules === key || rules.indexOf(key) >= 0)) newStyleBlock[key] = styleBlock[key] + " !important";
        else newStyleBlock[key] = styleBlock[key];
    });
    return newStyleBlock;
}
var ratioNames = {
    minorSecond: 1.067,
    majorSecond: 1.125,
    minorThird: 1.2,
    majorThird: 1.25,
    perfectFourth: 1.333,
    augFourth: 1.414,
    perfectFifth: 1.5,
    minorSixth: 1.6,
    goldenSection: 1.618,
    majorSixth: 1.667,
    minorSeventh: 1.778,
    majorSeventh: 1.875,
    octave: 2,
    majorTenth: 2.5,
    majorEleventh: 2.667,
    majorTwelfth: 3,
    doubleOctave: 4
};
function getRatio(ratioName) {
    return ratioNames[ratioName];
}
/**
 * Establish consistent measurements and spacial relationships throughout your projects by incrementing an em or rem value up or down a defined scale. We provide a list of commonly used scales as pre-defined variables.
 * @example
 * // Styles as object usage
 * const styles = {
 *    // Increment two steps up the default scale
 *   'fontSize': modularScale(2)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *    // Increment two steps up the default scale
 *   fontSize: ${modularScale(2)}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'fontSize': '1.77689em'
 * }
 */ function modularScale(steps, base, ratio) {
    if (base === void 0) base = '1em';
    if (ratio === void 0) ratio = 1.333;
    if (typeof steps !== 'number') throw new PolishedError(42);
    if (typeof ratio === 'string' && !ratioNames[ratio]) throw new PolishedError(43);
    var _ref = typeof base === 'string' ? getValueAndUnit(base) : [
        base,
        ''
    ], realBase = _ref[0], unit = _ref[1];
    var realRatio = typeof ratio === 'string' ? getRatio(ratio) : ratio;
    if (typeof realBase === 'string') throw new PolishedError(44, base);
    return "" + realBase * Math.pow(realRatio, steps) + (unit || '');
}
/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */ var rem = /*#__PURE__*/ pixelsto('rem');
var rem$1 = rem;
var defaultFontSize = 16;
function convertBase(base) {
    var deconstructedValue = getValueAndUnit(base);
    if (deconstructedValue[1] === 'px') return parseFloat(base);
    if (deconstructedValue[1] === '%') return parseFloat(base) / 100 * defaultFontSize;
    throw new PolishedError(78, deconstructedValue[1]);
}
function getBaseFromDoc() {
    /* eslint-disable */ /* istanbul ignore next */ if (typeof document !== 'undefined' && document.documentElement !== null) {
        var rootFontSize = getComputedStyle(document.documentElement).fontSize;
        return rootFontSize ? convertBase(rootFontSize) : defaultFontSize;
    }
    /* eslint-enable */ /* istanbul ignore next */ return defaultFontSize;
}
/**
 * Convert rem values to px. By default, the base value is pulled from the font-size property on the root element (if it is set in % or px). It defaults to 16px if not found on the root. You can also override the base value by providing your own base in % or px.
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': remToPx('1.6rem')
 *   'height': remToPx('1.6rem', '10px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${remToPx('1.6rem')}
 *   height: ${remToPx('1.6rem', '10px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '25.6px',
 *   'height': '16px',
 * }
 */ function remToPx(value, base) {
    var deconstructedValue = getValueAndUnit(value);
    if (deconstructedValue[1] !== 'rem' && deconstructedValue[1] !== '') throw new PolishedError(77, deconstructedValue[1]);
    var newBase = base ? convertBase(base) : getBaseFromDoc();
    return deconstructedValue[0] * newBase + "px";
}
var functionsMap$3 = {
    back: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    circ: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
    cubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
    expo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
    quad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
    quart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
    quint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
    sine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeIn('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeIn('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */ function easeIn(functionName) {
    return functionsMap$3[functionName.toLowerCase().trim()];
}
var functionsMap$2 = {
    back: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    circ: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
    cubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
    expo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
    quad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
    quart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
    quint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
    sine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeInOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeInOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
 * }
 */ function easeInOut(functionName) {
    return functionsMap$2[functionName.toLowerCase().trim()];
}
var functionsMap$1 = {
    back: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
    cubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
    circ: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
    expo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
    quad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
    quart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
    quint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
    sine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)'
};
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': easeOut('quad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${easeOut('quad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
 * }
 */ function easeOut(functionName) {
    return functionsMap$1[functionName.toLowerCase().trim()];
}
/**
 * Returns a CSS calc formula for linear interpolation of a property between two values. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px').
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: between('20px', '100px', '400px', '1000px'),
 *   fontSize: between('20px', '100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${between('20px', '100px', '400px', '1000px')};
 *   fontSize: ${between('20px', '100px')}
 * `
 *
 * // CSS as JS Output
 *
 * h1: {
 *   'fontSize': 'calc(-33.33333333333334px + 13.333333333333334vw)',
 *   'fontSize': 'calc(-9.090909090909093px + 9.090909090909092vw)'
 * }
 */ function between(fromSize, toSize, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = '320px';
    if (maxScreen === void 0) maxScreen = '1200px';
    var _getValueAndUnit = getValueAndUnit(fromSize), unitlessFromSize = _getValueAndUnit[0], fromSizeUnit = _getValueAndUnit[1];
    var _getValueAndUnit2 = getValueAndUnit(toSize), unitlessToSize = _getValueAndUnit2[0], toSizeUnit = _getValueAndUnit2[1];
    var _getValueAndUnit3 = getValueAndUnit(minScreen), unitlessMinScreen = _getValueAndUnit3[0], minScreenUnit = _getValueAndUnit3[1];
    var _getValueAndUnit4 = getValueAndUnit(maxScreen), unitlessMaxScreen = _getValueAndUnit4[0], maxScreenUnit = _getValueAndUnit4[1];
    if (typeof unitlessMinScreen !== 'number' || typeof unitlessMaxScreen !== 'number' || !minScreenUnit || !maxScreenUnit || minScreenUnit !== maxScreenUnit) throw new PolishedError(47);
    if (typeof unitlessFromSize !== 'number' || typeof unitlessToSize !== 'number' || fromSizeUnit !== toSizeUnit) throw new PolishedError(48);
    if (fromSizeUnit !== minScreenUnit || toSizeUnit !== maxScreenUnit) throw new PolishedError(76);
    var slope = (unitlessFromSize - unitlessToSize) / (unitlessMinScreen - unitlessMaxScreen);
    var base = unitlessToSize - slope * unitlessMaxScreen;
    return "calc(" + base.toFixed(2) + (fromSizeUnit || '') + " + " + (100 * slope).toFixed(2) + "vw)";
}
/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */ function clearFix(parent) {
    var _ref;
    if (parent === void 0) parent = '&';
    var pseudoSelector = parent + "::after";
    return _ref = {}, _ref[pseudoSelector] = {
        clear: 'both',
        content: '""',
        display: 'table'
    }, _ref;
}
/**
 * CSS to fully cover an area. Can optionally be passed an offset to act as a "padding".
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...cover()
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${cover()}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute',
 *   'top': '0',
 *   'right: '0',
 *   'bottom': '0',
 *   'left: '0'
 * }
 */ function cover(offset) {
    if (offset === void 0) offset = 0;
    return {
        position: 'absolute',
        top: offset,
        right: offset,
        bottom: offset,
        left: offset
    };
}
/**
 * CSS to represent truncated text with an ellipsis. You can optionally pass a max-width and number of lines before truncating.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */ function ellipsis(width, lines) {
    if (lines === void 0) lines = 1;
    var styles = {
        display: 'inline-block',
        maxWidth: width || '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        wordWrap: 'normal'
    };
    return lines > 1 ? (0, _extendsDefault.default)({}, styles, {
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: lines,
        display: '-webkit-box',
        whiteSpace: 'normal'
    }) : styles;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * Returns a set of media queries that resizes a property (or set of properties) between a provided fromSize and toSize. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px') to constrain the interpolation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...fluidRange(
 *    {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${fluidRange(
 *      {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   "@media (min-width: 1000px)": Object {
 *     "padding": "100px",
 *   },
 *   "@media (min-width: 400px)": Object {
 *     "padding": "calc(-33.33333333333334px + 13.333333333333334vw)",
 *   },
 *   "padding": "20px",
 * }
 */ function fluidRange(cssProp, minScreen, maxScreen) {
    if (minScreen === void 0) minScreen = '320px';
    if (maxScreen === void 0) maxScreen = '1200px';
    if (!Array.isArray(cssProp) && typeof cssProp !== 'object' || cssProp === null) throw new PolishedError(49);
    if (Array.isArray(cssProp)) {
        var mediaQueries = {};
        var fallbacks = {};
        for(var _iterator = _createForOfIteratorHelperLoose(cssProp), _step; !(_step = _iterator()).done;){
            var _extends2, _extends3;
            var obj = _step.value;
            if (!obj.prop || !obj.fromSize || !obj.toSize) throw new PolishedError(50);
            fallbacks[obj.prop] = obj.fromSize;
            mediaQueries["@media (min-width: " + minScreen + ")"] = (0, _extendsDefault.default)({}, mediaQueries["@media (min-width: " + minScreen + ")"], (_extends2 = {}, _extends2[obj.prop] = between(obj.fromSize, obj.toSize, minScreen, maxScreen), _extends2));
            mediaQueries["@media (min-width: " + maxScreen + ")"] = (0, _extendsDefault.default)({}, mediaQueries["@media (min-width: " + maxScreen + ")"], (_extends3 = {}, _extends3[obj.prop] = obj.toSize, _extends3));
        }
        return (0, _extendsDefault.default)({}, fallbacks, mediaQueries);
    } else {
        var _ref, _ref2, _ref3;
        if (!cssProp.prop || !cssProp.fromSize || !cssProp.toSize) throw new PolishedError(51);
        return _ref3 = {}, _ref3[cssProp.prop] = cssProp.fromSize, _ref3["@media (min-width: " + minScreen + ")"] = (_ref = {}, _ref[cssProp.prop] = between(cssProp.fromSize, cssProp.toSize, minScreen, maxScreen), _ref), _ref3["@media (min-width: " + maxScreen + ")"] = (_ref2 = {}, _ref2[cssProp.prop] = cssProp.toSize, _ref2), _ref3;
    }
}
var dataURIRegex = /^\s*data:([a-z]+\/[a-z-]+(;[a-z-]+=[a-z-]+)?)?(;charset=[a-z0-9-]+)?(;base64)?,[a-z0-9!$&',()*+,;=\-._~:@/?%\s]*\s*$/i;
var formatHintMap = {
    woff: 'woff',
    woff2: 'woff2',
    ttf: 'truetype',
    otf: 'opentype',
    eot: 'embedded-opentype',
    svg: 'svg',
    svgz: 'svg'
};
function generateFormatHint(format, formatHint) {
    if (!formatHint) return '';
    return " format(\"" + formatHintMap[format] + "\")";
}
function isDataURI(fontFilePath) {
    return !!fontFilePath.replace(/\s+/g, ' ').match(dataURIRegex);
}
function generateFileReferences(fontFilePath, fileFormats, formatHint) {
    if (isDataURI(fontFilePath)) return "url(\"" + fontFilePath + "\")" + generateFormatHint(fileFormats[0], formatHint);
    var fileFontReferences = fileFormats.map(function(format) {
        return "url(\"" + fontFilePath + "." + format + "\")" + generateFormatHint(format, formatHint);
    });
    return fileFontReferences.join(', ');
}
function generateLocalReferences(localFonts) {
    var localFontReferences = localFonts.map(function(font) {
        return "local(\"" + font + "\")";
    });
    return localFontReferences.join(', ');
}
function generateSources(fontFilePath, localFonts, fileFormats, formatHint) {
    var fontReferences = [];
    if (localFonts) fontReferences.push(generateLocalReferences(localFonts));
    if (fontFilePath) fontReferences.push(generateFileReferences(fontFilePath, fileFormats, formatHint));
    return fontReferences.join(', ');
}
/**
 * CSS for a @font-face declaration. Defaults to check for local copies of the font on the user's machine. You can disable this by passing `null` to localFonts.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro',
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * const GlobalStyle = createGlobalStyle`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro',
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */ function fontFace(_ref) {
    var fontFamily = _ref.fontFamily, fontFilePath = _ref.fontFilePath, fontStretch = _ref.fontStretch, fontStyle = _ref.fontStyle, fontVariant = _ref.fontVariant, fontWeight = _ref.fontWeight, _ref$fileFormats = _ref.fileFormats, fileFormats = _ref$fileFormats === void 0 ? [
        'eot',
        'woff2',
        'woff',
        'ttf',
        'svg'
    ] : _ref$fileFormats, _ref$formatHint = _ref.formatHint, formatHint = _ref$formatHint === void 0 ? false : _ref$formatHint, _ref$localFonts = _ref.localFonts, localFonts = _ref$localFonts === void 0 ? [
        fontFamily
    ] : _ref$localFonts, unicodeRange = _ref.unicodeRange, fontDisplay = _ref.fontDisplay, fontVariationSettings = _ref.fontVariationSettings, fontFeatureSettings = _ref.fontFeatureSettings;
    // Error Handling
    if (!fontFamily) throw new PolishedError(55);
    if (!fontFilePath && !localFonts) throw new PolishedError(52);
    if (localFonts && !Array.isArray(localFonts)) throw new PolishedError(53);
    if (!Array.isArray(fileFormats)) throw new PolishedError(54);
    var fontFaceDeclaration = {
        '@font-face': {
            fontFamily: fontFamily,
            src: generateSources(fontFilePath, localFonts, fileFormats, formatHint),
            unicodeRange: unicodeRange,
            fontStretch: fontStretch,
            fontStyle: fontStyle,
            fontVariant: fontVariant,
            fontWeight: fontWeight,
            fontDisplay: fontDisplay,
            fontVariationSettings: fontVariationSettings,
            fontFeatureSettings: fontFeatureSettings
        }
    }; // Removes undefined fields for cleaner css object.
    return JSON.parse(JSON.stringify(fontFaceDeclaration));
}
/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */ function hideText() {
    return {
        textIndent: '101%',
        overflow: 'hidden',
        whiteSpace: 'nowrap'
    };
}
/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */ function hideVisually() {
    return {
        border: '0',
        clip: 'rect(0 0 0 0)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    };
}
/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */ function hiDPI(ratio) {
    if (ratio === void 0) ratio = 1.3;
    return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}
function constructGradientValue(literals) {
    var template = '';
    for(var _len = arguments.length, substitutions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)substitutions[_key - 1] = arguments[_key];
    for(var i = 0; i < literals.length; i += 1){
        template += literals[i];
        if (i === substitutions.length - 1 && substitutions[i]) {
            var definedValues = substitutions.filter(function(substitute) {
                return !!substitute;
            }); // Adds leading coma if properties preceed color-stops
            if (definedValues.length > 1) {
                template = template.slice(0, -1);
                template += ", " + substitutions[i]; // No trailing space if color-stops is the only param provided
            } else if (definedValues.length === 1) template += "" + substitutions[i];
        } else if (substitutions[i]) template += substitutions[i] + " ";
    }
    return template.trim();
}
var _templateObject$1;
/**
 * CSS for declaring a linear gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${linearGradient({
        colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
        toDirection: 'to top right',
        fallback: '#FFF',
      })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#FFF',
 *   'backgroundImage': 'linear-gradient(to top right, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function linearGradient(_ref) {
    var colorStops = _ref.colorStops, fallback = _ref.fallback, _ref$toDirection = _ref.toDirection, toDirection = _ref$toDirection === void 0 ? '' : _ref$toDirection;
    if (!colorStops || colorStops.length < 2) throw new PolishedError(56);
    return {
        backgroundColor: fallback || colorStops[0].replace(/,\s+/g, ',').split(' ')[0].replace(/,(?=\S)/g, ', '),
        backgroundImage: constructGradientValue(_templateObject$1 || (_templateObject$1 = (0, _taggedTemplateLiteralLooseDefault.default)([
            "linear-gradient(",
            "",
            ")"
        ])), toDirection, colorStops.join(', ').replace(/,(?=\S)/g, ', '))
    };
}
/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * const GlobalStyle = createGlobalStyle`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */ function normalize() {
    var _ref;
    return [
        (_ref = {
            html: {
                lineHeight: '1.15',
                textSizeAdjust: '100%'
            },
            body: {
                margin: '0'
            },
            main: {
                display: 'block'
            },
            h1: {
                fontSize: '2em',
                margin: '0.67em 0'
            },
            hr: {
                boxSizing: 'content-box',
                height: '0',
                overflow: 'visible'
            },
            pre: {
                fontFamily: 'monospace, monospace',
                fontSize: '1em'
            },
            a: {
                backgroundColor: 'transparent'
            },
            'abbr[title]': {
                borderBottom: 'none',
                textDecoration: 'underline'
            }
        }, _ref["b,\n    strong"] = {
            fontWeight: 'bolder'
        }, _ref["code,\n    kbd,\n    samp"] = {
            fontFamily: 'monospace, monospace',
            fontSize: '1em'
        }, _ref.small = {
            fontSize: '80%'
        }, _ref["sub,\n    sup"] = {
            fontSize: '75%',
            lineHeight: '0',
            position: 'relative',
            verticalAlign: 'baseline'
        }, _ref.sub = {
            bottom: '-0.25em'
        }, _ref.sup = {
            top: '-0.5em'
        }, _ref.img = {
            borderStyle: 'none'
        }, _ref["button,\n    input,\n    optgroup,\n    select,\n    textarea"] = {
            fontFamily: 'inherit',
            fontSize: '100%',
            lineHeight: '1.15',
            margin: '0'
        }, _ref["button,\n    input"] = {
            overflow: 'visible'
        }, _ref["button,\n    select"] = {
            textTransform: 'none'
        }, _ref["button,\n    html [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"]"] = {
            WebkitAppearance: 'button'
        }, _ref["button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner"] = {
            borderStyle: 'none',
            padding: '0'
        }, _ref["button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring"] = {
            outline: '1px dotted ButtonText'
        }, _ref.fieldset = {
            padding: '0.35em 0.625em 0.75em'
        }, _ref.legend = {
            boxSizing: 'border-box',
            color: 'inherit',
            display: 'table',
            maxWidth: '100%',
            padding: '0',
            whiteSpace: 'normal'
        }, _ref.progress = {
            verticalAlign: 'baseline'
        }, _ref.textarea = {
            overflow: 'auto'
        }, _ref["[type=\"checkbox\"],\n    [type=\"radio\"]"] = {
            boxSizing: 'border-box',
            padding: '0'
        }, _ref["[type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button"] = {
            height: 'auto'
        }, _ref['[type="search"]'] = {
            WebkitAppearance: 'textfield',
            outlineOffset: '-2px'
        }, _ref['[type="search"]::-webkit-search-decoration'] = {
            WebkitAppearance: 'none'
        }, _ref['::-webkit-file-upload-button'] = {
            WebkitAppearance: 'button',
            font: 'inherit'
        }, _ref.details = {
            display: 'block'
        }, _ref.summary = {
            display: 'list-item'
        }, _ref.template = {
            display: 'none'
        }, _ref['[hidden]'] = {
            display: 'none'
        }, _ref),
        {
            'abbr[title]': {
                textDecoration: 'underline dotted'
            }
        }
    ];
}
var _templateObject;
/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */ function radialGradient(_ref) {
    var colorStops = _ref.colorStops, _ref$extent = _ref.extent, extent = _ref$extent === void 0 ? '' : _ref$extent, fallback = _ref.fallback, _ref$position = _ref.position, position = _ref$position === void 0 ? '' : _ref$position, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? '' : _ref$shape;
    if (!colorStops || colorStops.length < 2) throw new PolishedError(57);
    return {
        backgroundColor: fallback || colorStops[0].split(' ')[0],
        backgroundImage: constructGradientValue(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLooseDefault.default)([
            "radial-gradient(",
            "",
            "",
            "",
            ")"
        ])), position, shape, extent, colorStops.join(', '))
    };
}
/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */ function retinaImage(filename, backgroundSize, extension, retinaFilename, retinaSuffix) {
    var _ref;
    if (extension === void 0) extension = 'png';
    if (retinaSuffix === void 0) retinaSuffix = '_2x';
    if (!filename) throw new PolishedError(58);
     // Replace the dot at the beginning of the passed extension if one exists
    var ext = extension.replace(/^\./, '');
    var rFilename = retinaFilename ? retinaFilename + "." + ext : "" + filename + retinaSuffix + "." + ext;
    return _ref = {
        backgroundImage: "url(" + filename + "." + ext + ")"
    }, _ref[hiDPI()] = (0, _extendsDefault.default)({
        backgroundImage: "url(" + rFilename + ")"
    }, backgroundSize ? {
        backgroundSize: backgroundSize
    } : {}), _ref;
}
/* eslint-disable key-spacing */ var functionsMap = {
    easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
    easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
    easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
    easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
    easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
    easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
    easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
    easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',
    easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
    easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
    easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
    easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
    easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
    easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
    easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
    easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',
    easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
    easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
    easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
    easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
    easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
    easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
    easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
};
/* eslint-enable key-spacing */ function getTimingFunction(functionName) {
    return functionsMap[functionName];
}
/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @deprecated - This will be deprecated in v5 in favor of `easeIn`, `easeOut`, `easeInOut`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': timingFunctions('easeInQuad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */ function timingFunctions(timingFunction) {
    return getTimingFunction(timingFunction);
}
var getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
    var fullWidth = "" + width[0] + (width[1] || '');
    var halfWidth = "" + width[0] / 2 + (width[1] || '');
    var fullHeight = "" + height[0] + (height[1] || '');
    var halfHeight = "" + height[0] / 2 + (height[1] || '');
    switch(pointingDirection){
        case 'top':
            return "0 " + halfWidth + " " + fullHeight + " " + halfWidth;
        case 'topLeft':
            return fullWidth + " " + fullHeight + " 0 0";
        case 'left':
            return halfHeight + " " + fullWidth + " " + halfHeight + " 0";
        case 'bottomLeft':
            return fullWidth + " 0 0 " + fullHeight;
        case 'bottom':
            return fullHeight + " " + halfWidth + " 0 " + halfWidth;
        case 'bottomRight':
            return "0 0 " + fullWidth + " " + fullHeight;
        case 'right':
            return halfHeight + " 0 " + halfHeight + " " + fullWidth;
        case 'topRight':
        default:
            return "0 " + fullWidth + " " + fullHeight + " 0";
    }
};
var getBorderColor = function getBorderColor(pointingDirection, foregroundColor) {
    switch(pointingDirection){
        case 'top':
        case 'bottomRight':
            return {
                borderBottomColor: foregroundColor
            };
        case 'right':
        case 'bottomLeft':
            return {
                borderLeftColor: foregroundColor
            };
        case 'bottom':
        case 'topLeft':
            return {
                borderTopColor: foregroundColor
            };
        case 'left':
        case 'topRight':
            return {
                borderRightColor: foregroundColor
            };
        default:
            throw new PolishedError(59);
    }
};
/**
 * CSS to represent triangle with any pointing direction with an optional background color.
 *
 * @example
 * // Styles as object usage
 *
 * const styles = {
 *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
 * }
 *
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
 *
 *
 * // CSS as JS Output
 *
 * div: {
 *  'borderColor': 'transparent transparent transparent red',
 *  'borderStyle': 'solid',
 *  'borderWidth': '50px 0 50px 100px',
 *  'height': '0',
 *  'width': '0',
 * }
 */ function triangle(_ref) {
    var pointingDirection = _ref.pointingDirection, height = _ref.height, width = _ref.width, foregroundColor = _ref.foregroundColor, _ref$backgroundColor = _ref.backgroundColor, backgroundColor = _ref$backgroundColor === void 0 ? 'transparent' : _ref$backgroundColor;
    var widthAndUnit = getValueAndUnit(width);
    var heightAndUnit = getValueAndUnit(height);
    if (isNaN(heightAndUnit[0]) || isNaN(widthAndUnit[0])) throw new PolishedError(60);
    return (0, _extendsDefault.default)({
        width: '0',
        height: '0',
        borderColor: backgroundColor
    }, getBorderColor(pointingDirection, foregroundColor), {
        borderStyle: 'solid',
        borderWidth: getBorderWidth(pointingDirection, heightAndUnit, widthAndUnit)
    });
}
/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */ function wordWrap(wrap) {
    if (wrap === void 0) wrap = 'break-word';
    var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
    return {
        overflowWrap: wrap,
        wordWrap: wrap,
        wordBreak: wordBreak
    };
}
function colorToInt(color) {
    return Math.round(color * 255);
}
function convertToInt(red, green, blue) {
    return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}
function hslToRgb(hue, saturation, lightness, convert) {
    if (convert === void 0) convert = convertToInt;
    if (saturation === 0) // achromatic
    return convert(lightness, lightness, lightness);
     // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
    var huePrime = (hue % 360 + 360) % 360 / 60;
    var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
    var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    var red = 0;
    var green = 0;
    var blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
        red = chroma;
        green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
        red = secondComponent;
        green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
        green = chroma;
        blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
        green = secondComponent;
        blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
        red = secondComponent;
        blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
        red = chroma;
        blue = secondComponent;
    }
    var lightnessModification = lightness - chroma / 2;
    var finalRed = red + lightnessModification;
    var finalGreen = green + lightnessModification;
    var finalBlue = blue + lightnessModification;
    return convert(finalRed, finalGreen, finalBlue);
}
var namedColorMap = {
    aliceblue: 'f0f8ff',
    antiquewhite: 'faebd7',
    aqua: '00ffff',
    aquamarine: '7fffd4',
    azure: 'f0ffff',
    beige: 'f5f5dc',
    bisque: 'ffe4c4',
    black: '000',
    blanchedalmond: 'ffebcd',
    blue: '0000ff',
    blueviolet: '8a2be2',
    brown: 'a52a2a',
    burlywood: 'deb887',
    cadetblue: '5f9ea0',
    chartreuse: '7fff00',
    chocolate: 'd2691e',
    coral: 'ff7f50',
    cornflowerblue: '6495ed',
    cornsilk: 'fff8dc',
    crimson: 'dc143c',
    cyan: '00ffff',
    darkblue: '00008b',
    darkcyan: '008b8b',
    darkgoldenrod: 'b8860b',
    darkgray: 'a9a9a9',
    darkgreen: '006400',
    darkgrey: 'a9a9a9',
    darkkhaki: 'bdb76b',
    darkmagenta: '8b008b',
    darkolivegreen: '556b2f',
    darkorange: 'ff8c00',
    darkorchid: '9932cc',
    darkred: '8b0000',
    darksalmon: 'e9967a',
    darkseagreen: '8fbc8f',
    darkslateblue: '483d8b',
    darkslategray: '2f4f4f',
    darkslategrey: '2f4f4f',
    darkturquoise: '00ced1',
    darkviolet: '9400d3',
    deeppink: 'ff1493',
    deepskyblue: '00bfff',
    dimgray: '696969',
    dimgrey: '696969',
    dodgerblue: '1e90ff',
    firebrick: 'b22222',
    floralwhite: 'fffaf0',
    forestgreen: '228b22',
    fuchsia: 'ff00ff',
    gainsboro: 'dcdcdc',
    ghostwhite: 'f8f8ff',
    gold: 'ffd700',
    goldenrod: 'daa520',
    gray: '808080',
    green: '008000',
    greenyellow: 'adff2f',
    grey: '808080',
    honeydew: 'f0fff0',
    hotpink: 'ff69b4',
    indianred: 'cd5c5c',
    indigo: '4b0082',
    ivory: 'fffff0',
    khaki: 'f0e68c',
    lavender: 'e6e6fa',
    lavenderblush: 'fff0f5',
    lawngreen: '7cfc00',
    lemonchiffon: 'fffacd',
    lightblue: 'add8e6',
    lightcoral: 'f08080',
    lightcyan: 'e0ffff',
    lightgoldenrodyellow: 'fafad2',
    lightgray: 'd3d3d3',
    lightgreen: '90ee90',
    lightgrey: 'd3d3d3',
    lightpink: 'ffb6c1',
    lightsalmon: 'ffa07a',
    lightseagreen: '20b2aa',
    lightskyblue: '87cefa',
    lightslategray: '789',
    lightslategrey: '789',
    lightsteelblue: 'b0c4de',
    lightyellow: 'ffffe0',
    lime: '0f0',
    limegreen: '32cd32',
    linen: 'faf0e6',
    magenta: 'f0f',
    maroon: '800000',
    mediumaquamarine: '66cdaa',
    mediumblue: '0000cd',
    mediumorchid: 'ba55d3',
    mediumpurple: '9370db',
    mediumseagreen: '3cb371',
    mediumslateblue: '7b68ee',
    mediumspringgreen: '00fa9a',
    mediumturquoise: '48d1cc',
    mediumvioletred: 'c71585',
    midnightblue: '191970',
    mintcream: 'f5fffa',
    mistyrose: 'ffe4e1',
    moccasin: 'ffe4b5',
    navajowhite: 'ffdead',
    navy: '000080',
    oldlace: 'fdf5e6',
    olive: '808000',
    olivedrab: '6b8e23',
    orange: 'ffa500',
    orangered: 'ff4500',
    orchid: 'da70d6',
    palegoldenrod: 'eee8aa',
    palegreen: '98fb98',
    paleturquoise: 'afeeee',
    palevioletred: 'db7093',
    papayawhip: 'ffefd5',
    peachpuff: 'ffdab9',
    peru: 'cd853f',
    pink: 'ffc0cb',
    plum: 'dda0dd',
    powderblue: 'b0e0e6',
    purple: '800080',
    rebeccapurple: '639',
    red: 'f00',
    rosybrown: 'bc8f8f',
    royalblue: '4169e1',
    saddlebrown: '8b4513',
    salmon: 'fa8072',
    sandybrown: 'f4a460',
    seagreen: '2e8b57',
    seashell: 'fff5ee',
    sienna: 'a0522d',
    silver: 'c0c0c0',
    skyblue: '87ceeb',
    slateblue: '6a5acd',
    slategray: '708090',
    slategrey: '708090',
    snow: 'fffafa',
    springgreen: '00ff7f',
    steelblue: '4682b4',
    tan: 'd2b48c',
    teal: '008080',
    thistle: 'd8bfd8',
    tomato: 'ff6347',
    turquoise: '40e0d0',
    violet: 'ee82ee',
    wheat: 'f5deb3',
    white: 'fff',
    whitesmoke: 'f5f5f5',
    yellow: 'ff0',
    yellowgreen: '9acd32'
};
/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */ function nameToHex(color) {
    if (typeof color !== 'string') return color;
    var normalizedColorName = color.toLowerCase();
    return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}
var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */ function parseToRgb(color) {
    if (typeof color !== 'string') throw new PolishedError(3);
    var normalizedColor = nameToHex(color);
    if (normalizedColor.match(hexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
        green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
        blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
    if (normalizedColor.match(hexRgbaRegex)) {
        var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
            green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
            blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
            alpha: alpha
        };
    }
    if (normalizedColor.match(reducedHexRegex)) return {
        red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
        green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
        blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
    if (normalizedColor.match(reducedRgbaHexRegex)) {
        var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
        return {
            red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
            green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
            blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
            alpha: _alpha
        };
    }
    var rgbMatched = rgbRegex.exec(normalizedColor);
    if (rgbMatched) return {
        red: parseInt("" + rgbMatched[1], 10),
        green: parseInt("" + rgbMatched[2], 10),
        blue: parseInt("" + rgbMatched[3], 10)
    };
    var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));
    if (rgbaMatched) return {
        red: parseInt("" + rgbaMatched[1], 10),
        green: parseInt("" + rgbaMatched[2], 10),
        blue: parseInt("" + rgbaMatched[3], 10),
        alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
    var hslMatched = hslRegex.exec(normalizedColor);
    if (hslMatched) {
        var hue = parseInt("" + hslMatched[1], 10);
        var saturation = parseInt("" + hslMatched[2], 10) / 100;
        var lightness = parseInt("" + hslMatched[3], 10) / 100;
        var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
        var hslRgbMatched = rgbRegex.exec(rgbColorString);
        if (!hslRgbMatched) throw new PolishedError(4, normalizedColor, rgbColorString);
        return {
            red: parseInt("" + hslRgbMatched[1], 10),
            green: parseInt("" + hslRgbMatched[2], 10),
            blue: parseInt("" + hslRgbMatched[3], 10)
        };
    }
    var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));
    if (hslaMatched) {
        var _hue = parseInt("" + hslaMatched[1], 10);
        var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
        var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
        var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";
        var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
        if (!_hslRgbMatched) throw new PolishedError(4, normalizedColor, _rgbColorString);
        return {
            red: parseInt("" + _hslRgbMatched[1], 10),
            green: parseInt("" + _hslRgbMatched[2], 10),
            blue: parseInt("" + _hslRgbMatched[3], 10),
            alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
        };
    }
    throw new PolishedError(5);
}
function rgbToHsl(color) {
    // make sure rgb are contained in a set of [0, 255]
    var red = color.red / 255;
    var green = color.green / 255;
    var blue = color.blue / 255;
    var max = Math.max(red, green, blue);
    var min = Math.min(red, green, blue);
    var lightness = (max + min) / 2;
    if (max === min) {
        // achromatic
        if (color.alpha !== undefined) return {
            hue: 0,
            saturation: 0,
            lightness: lightness,
            alpha: color.alpha
        };
        else return {
            hue: 0,
            saturation: 0,
            lightness: lightness
        };
    }
    var hue;
    var delta = max - min;
    var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
    switch(max){
        case red:
            hue = (green - blue) / delta + (green < blue ? 6 : 0);
            break;
        case green:
            hue = (blue - red) / delta + 2;
            break;
        default:
            // blue case
            hue = (red - green) / delta + 4;
            break;
    }
    hue *= 60;
    if (color.alpha !== undefined) return {
        hue: hue,
        saturation: saturation,
        lightness: lightness,
        alpha: color.alpha
    };
    return {
        hue: hue,
        saturation: saturation,
        lightness: lightness
    };
}
/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */ function parseToHsl(color) {
    // Note: At a later stage we can optimize this function as right now a hsl
    // color would be parsed converted to rgb values and converted back to hsl.
    return rgbToHsl(parseToRgb(color));
}
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */ var reduceHexValue = function reduceHexValue(value) {
    if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) return "#" + value[1] + value[3] + value[5];
    return value;
};
var reduceHexValue$1 = reduceHexValue;
function numberToHex(value) {
    var hex = value.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
function colorToHex(color) {
    return numberToHex(Math.round(color * 255));
}
function convertToHex(red, green, blue) {
    return reduceHexValue$1("#" + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}
function hslToHex(hue, saturation, lightness) {
    return hslToRgb(hue, saturation, lightness, convertToHex);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */ function hsl(value, saturation, lightness) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') return hslToHex(value, saturation, lightness);
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined) return hslToHex(value.hue, value.saturation, value.lightness);
    throw new PolishedError(1);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */ function hsla(value, saturation, lightness, alpha) {
    if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') return alpha >= 1 ? hslToHex(value, saturation, lightness) : "rgba(" + hslToRgb(value, saturation, lightness) + "," + alpha + ")";
    else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
    throw new PolishedError(2);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */ function rgb(value, green, blue) {
    if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') return reduceHexValue$1("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
    else if (typeof value === 'object' && green === undefined && blue === undefined) return reduceHexValue$1("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
    throw new PolishedError(6);
}
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */ function rgba(firstValue, secondValue, thirdValue, fourthValue) {
    if (typeof firstValue === 'string' && typeof secondValue === 'number') {
        var rgbValue = parseToRgb(firstValue);
        return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
    } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
    else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
    throw new PolishedError(7);
}
var isRgb = function isRgb(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var isRgba = function isRgba(color) {
    return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};
var isHsl = function isHsl(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var isHsla = function isHsla(color) {
    return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};
/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function toColorString(color) {
    if (typeof color !== 'object') throw new PolishedError(8);
    if (isRgba(color)) return rgba(color);
    if (isRgb(color)) return rgb(color);
    if (isHsla(color)) return hsla(color);
    if (isHsl(color)) return hsl(color);
    throw new PolishedError(8);
}
// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function curried(f, length, acc) {
    return function fn() {
        // eslint-disable-next-line prefer-rest-params
        var combined = acc.concat(Array.prototype.slice.call(arguments));
        return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
    };
} // eslint-disable-next-line no-redeclare
function curry(f) {
    // eslint-disable-line no-redeclare
    return curried(f, f.length, []);
}
/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated around
 * the color wheel, always producing a positive hue value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */ function adjustHue(degree, color) {
    if (color === 'transparent') return color;
    var hslColor = parseToHsl(color);
    return toColorString((0, _extendsDefault.default)({}, hslColor, {
        hue: hslColor.hue + parseFloat(degree)
    }));
} // prettier-ignore
var curriedAdjustHue = /*#__PURE__*/ curry(adjustHue);
var curriedAdjustHue$1 = curriedAdjustHue;
/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function complement(color) {
    if (color === 'transparent') return color;
    var hslColor = parseToHsl(color);
    return toColorString((0, _extendsDefault.default)({}, hslColor, {
        hue: (hslColor.hue + 180) % 360
    }));
}
function guard(lowerBoundary, upperBoundary, value) {
    return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */ function darken(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = parseToHsl(color);
    return toColorString((0, _extendsDefault.default)({}, hslColor, {
        lightness: guard(0, 1, hslColor.lightness - parseFloat(amount))
    }));
} // prettier-ignore
var curriedDarken = /*#__PURE__*/ curry(darken);
var curriedDarken$1 = curriedDarken;
/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */ function desaturate(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = parseToHsl(color);
    return toColorString((0, _extendsDefault.default)({}, hslColor, {
        saturation: guard(0, 1, hslColor.saturation - parseFloat(amount))
    }));
} // prettier-ignore
var curriedDesaturate = /*#__PURE__*/ curry(desaturate);
var curriedDesaturate$1 = curriedDesaturate;
/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */ function getLuminance(color) {
    if (color === 'transparent') return 0;
    var rgbColor = parseToRgb(color);
    var _Object$keys$map = Object.keys(rgbColor).map(function(key) {
        var channel = rgbColor[key] / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    }), r = _Object$keys$map[0], g = _Object$keys$map[1], b = _Object$keys$map[2];
    return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}
/**
 * Returns the contrast ratio between two colors based on
 * [W3's recommended equation for calculating contrast](http://www.w3.org/TR/WCAG20/#contrast-ratiodef).
 *
 * @example
 * const contrastRatio = getContrast('#444', '#fff');
 */ function getContrast(color1, color2) {
    var luminance1 = getLuminance(color1);
    var luminance2 = getLuminance(color2);
    return parseFloat((luminance1 > luminance2 ? (luminance1 + 0.05) / (luminance2 + 0.05) : (luminance2 + 0.05) / (luminance1 + 0.05)).toFixed(2));
}
/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */ function grayscale(color) {
    if (color === 'transparent') return color;
    return toColorString((0, _extendsDefault.default)({}, parseToHsl(color), {
        saturation: 0
    }));
}
/**
 * Converts a HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hslToColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${hslToColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */ function hslToColorString(color) {
    if (typeof color === 'object' && typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number') {
        if (color.alpha && typeof color.alpha === 'number') return hsla({
            hue: color.hue,
            saturation: color.saturation,
            lightness: color.lightness,
            alpha: color.alpha
        });
        return hsl({
            hue: color.hue,
            saturation: color.saturation,
            lightness: color.lightness
        });
    }
    throw new PolishedError(45);
}
/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */ function invert(color) {
    if (color === 'transparent') return color; // parse color string to rgb
    var value = parseToRgb(color);
    return toColorString((0, _extendsDefault.default)({}, value, {
        red: 255 - value.red,
        green: 255 - value.green,
        blue: 255 - value.blue
    }));
}
/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */ function lighten(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = parseToHsl(color);
    return toColorString((0, _extendsDefault.default)({}, hslColor, {
        lightness: guard(0, 1, hslColor.lightness + parseFloat(amount))
    }));
} // prettier-ignore
var curriedLighten = /*#__PURE__*/ curry(lighten);
var curriedLighten$1 = curriedLighten;
/**
 * Determines which contrast guidelines have been met for two colors.
 * Based on the [contrast calculations recommended by W3](https://www.w3.org/WAI/WCAG21/Understanding/contrast-enhanced.html).
 *
 * @example
 * const scores = meetsContrastGuidelines('#444', '#fff');
 */ function meetsContrastGuidelines(color1, color2) {
    var contrastRatio = getContrast(color1, color2);
    return {
        AA: contrastRatio >= 4.5,
        AALarge: contrastRatio >= 3,
        AAA: contrastRatio >= 7,
        AAALarge: contrastRatio >= 4.5
    };
}
/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */ function mix(weight, color, otherColor) {
    if (color === 'transparent') return otherColor;
    if (otherColor === 'transparent') return color;
    if (weight === 0) return otherColor;
    var parsedColor1 = parseToRgb(color);
    var color1 = (0, _extendsDefault.default)({}, parsedColor1, {
        alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
    });
    var parsedColor2 = parseToRgb(otherColor);
    var color2 = (0, _extendsDefault.default)({}, parsedColor2, {
        alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
    }); // The formula is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
    var alphaDelta = color1.alpha - color2.alpha;
    var x = parseFloat(weight) * 2 - 1;
    var y = x * alphaDelta === -1 ? x : x + alphaDelta;
    var z = 1 + x * alphaDelta;
    var weight1 = (y / z + 1) / 2.0;
    var weight2 = 1 - weight1;
    var mixedColor = {
        red: Math.floor(color1.red * weight1 + color2.red * weight2),
        green: Math.floor(color1.green * weight1 + color2.green * weight2),
        blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
        alpha: color1.alpha * parseFloat(weight) + color2.alpha * (1 - parseFloat(weight))
    };
    return rgba(mixedColor);
} // prettier-ignore
var curriedMix = /*#__PURE__*/ curry(mix);
var mix$1 = curriedMix;
/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */ function opacify(amount, color) {
    if (color === 'transparent') return color;
    var parsedColor = parseToRgb(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, _extendsDefault.default)({}, parsedColor, {
        alpha: guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
    });
    return rgba(colorWithAlpha);
} // prettier-ignore
var curriedOpacify = /*#__PURE__*/ curry(opacify);
var curriedOpacify$1 = curriedOpacify;
var defaultReturnIfLightColor = '#000';
var defaultReturnIfDarkColor = '#fff';
/**
 * Returns black or white (or optional passed colors) for best
 * contrast depending on the luminosity of the given color.
 * When passing custom return colors, strict mode ensures that the
 * return color always meets or exceeds WCAG level AA or greater. If this test
 * fails, the default return color (black or white) is returned in place of the
 * custom return color. You can optionally turn off strict mode.
 *
 * Follows [W3C specs for readability](https://www.w3.org/TR/WCAG20-TECHS/G18.html).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('black', '#001', '#ff8'),
 *   color: readableColor('white', '#001', '#ff8'),
 *   color: readableColor('red', '#333', '#ddd', true)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('black', '#001', '#ff8')};
 *   color: ${readableColor('white', '#001', '#ff8')};
 *   color: ${readableColor('red', '#333', '#ddd', true)};
 * `
 *
 * // CSS in JS Output
 * element {
 *   color: "#fff";
 *   color: "#ff8";
 *   color: "#001";
 *   color: "#000";
 * }
 */ function readableColor(color, returnIfLightColor, returnIfDarkColor, strict) {
    if (returnIfLightColor === void 0) returnIfLightColor = defaultReturnIfLightColor;
    if (returnIfDarkColor === void 0) returnIfDarkColor = defaultReturnIfDarkColor;
    if (strict === void 0) strict = true;
    var isColorLight = getLuminance(color) > 0.179;
    var preferredReturnColor = isColorLight ? returnIfLightColor : returnIfDarkColor;
    if (!strict || getContrast(color, preferredReturnColor) >= 4.5) return preferredReturnColor;
    return isColorLight ? defaultReturnIfLightColor : defaultReturnIfDarkColor;
}
/**
 * Converts a RgbColor or RgbaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb` or `rgba`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100 }),
 *   background: rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${rgbToColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 * }
 */ function rgbToColorString(color) {
    if (typeof color === 'object' && typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number') {
        if (typeof color.alpha === 'number') return rgba({
            red: color.red,
            green: color.green,
            blue: color.blue,
            alpha: color.alpha
        });
        return rgb({
            red: color.red,
            green: color.green,
            blue: color.blue
        });
    }
    throw new PolishedError(46);
}
/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */ function saturate(amount, color) {
    if (color === 'transparent') return color;
    var hslColor = parseToHsl(color);
    return toColorString((0, _extendsDefault.default)({}, hslColor, {
        saturation: guard(0, 1, hslColor.saturation + parseFloat(amount))
    }));
} // prettier-ignore
var curriedSaturate = /*#__PURE__*/ curry(saturate);
var curriedSaturate$1 = curriedSaturate;
/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */ function setHue(hue, color) {
    if (color === 'transparent') return color;
    return toColorString((0, _extendsDefault.default)({}, parseToHsl(color), {
        hue: parseFloat(hue)
    }));
} // prettier-ignore
var curriedSetHue = /*#__PURE__*/ curry(setHue);
var curriedSetHue$1 = curriedSetHue;
/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */ function setLightness(lightness, color) {
    if (color === 'transparent') return color;
    return toColorString((0, _extendsDefault.default)({}, parseToHsl(color), {
        lightness: parseFloat(lightness)
    }));
} // prettier-ignore
var curriedSetLightness = /*#__PURE__*/ curry(setLightness);
var curriedSetLightness$1 = curriedSetLightness;
/**
 * Sets the saturation of a color to the provided value. The saturation range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */ function setSaturation(saturation, color) {
    if (color === 'transparent') return color;
    return toColorString((0, _extendsDefault.default)({}, parseToHsl(color), {
        saturation: parseFloat(saturation)
    }));
} // prettier-ignore
var curriedSetSaturation = /*#__PURE__*/ curry(setSaturation);
var curriedSetSaturation$1 = curriedSetSaturation;
/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */ function shade(percentage, color) {
    if (color === 'transparent') return color;
    return mix$1(parseFloat(percentage), 'rgb(0, 0, 0)', color);
} // prettier-ignore
var curriedShade = /*#__PURE__*/ curry(shade);
var curriedShade$1 = curriedShade;
/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */ function tint(percentage, color) {
    if (color === 'transparent') return color;
    return mix$1(parseFloat(percentage), 'rgb(255, 255, 255)', color);
} // prettier-ignore
var curriedTint = /*#__PURE__*/ curry(tint);
var curriedTint$1 = curriedTint;
/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff'),
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')};
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */ function transparentize(amount, color) {
    if (color === 'transparent') return color;
    var parsedColor = parseToRgb(color);
    var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
    var colorWithAlpha = (0, _extendsDefault.default)({}, parsedColor, {
        alpha: guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
    });
    return rgba(colorWithAlpha);
} // prettier-ignore
var curriedTransparentize = /*#__PURE__*/ curry(transparentize);
var curriedTransparentize$1 = curriedTransparentize;
/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */ function animation() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    // Allow single or multiple animations passed
    var multiMode = Array.isArray(args[0]);
    if (!multiMode && args.length > 8) throw new PolishedError(64);
    var code = args.map(function(arg) {
        if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) throw new PolishedError(65);
        if (Array.isArray(arg) && arg.length > 8) throw new PolishedError(66);
        return Array.isArray(arg) ? arg.join(' ') : arg;
    }).join(', ');
    return {
        animation: code
    };
}
/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */ function backgroundImages() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        backgroundImage: properties.join(', ')
    };
}
/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */ function backgrounds() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    return {
        background: properties.join(', ')
    };
}
var sideMap = [
    'top',
    'right',
    'bottom',
    'left'
];
/**
 * Shorthand for the border property that splits out individual properties for use with tools like Fela and Styletron. A side keyword can optionally be passed to target only one side's border properties.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...border('1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderColor': 'red',
 *   'borderStyle': 'solid',
 *   'borderWidth': `1px`,
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...border('top', '1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('top', '1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderTopStyle': 'solid',
 *   'borderTopWidth': `1px`,
 * }
 */ function border(sideKeyword) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if (typeof sideKeyword === 'string' && sideMap.indexOf(sideKeyword) >= 0) {
        var _ref;
        return _ref = {}, _ref["border" + capitalizeString(sideKeyword) + "Width"] = values[0], _ref["border" + capitalizeString(sideKeyword) + "Style"] = values[1], _ref["border" + capitalizeString(sideKeyword) + "Color"] = values[2], _ref;
    } else {
        values.unshift(sideKeyword);
        return {
            borderWidth: values[0],
            borderStyle: values[1],
            borderColor: values[2]
        };
    }
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */ function borderColor() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return directionalProperty.apply(void 0, [
        'borderColor'
    ].concat(values));
}
/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */ function borderRadius(side, radius) {
    var uppercaseSide = capitalizeString(side);
    if (!radius && radius !== 0) throw new PolishedError(62);
    if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
        var _ref;
        return _ref = {}, _ref["border" + uppercaseSide + "RightRadius"] = radius, _ref["border" + uppercaseSide + "LeftRadius"] = radius, _ref;
    }
    if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
        var _ref2;
        return _ref2 = {}, _ref2["borderTop" + uppercaseSide + "Radius"] = radius, _ref2["borderBottom" + uppercaseSide + "Radius"] = radius, _ref2;
    }
    throw new PolishedError(63);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */ function borderStyle() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return directionalProperty.apply(void 0, [
        'borderStyle'
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */ function borderWidth() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return directionalProperty.apply(void 0, [
        'borderWidth'
    ].concat(values));
}
function generateSelectors(template, state) {
    var stateSuffix = state ? ":" + state : '';
    return template(stateSuffix);
}
/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */ function statefulSelectors(states, template, stateMap) {
    if (!template) throw new PolishedError(67);
    if (states.length === 0) return generateSelectors(template, null);
    var selectors = [];
    for(var i = 0; i < states.length; i += 1){
        if (stateMap && stateMap.indexOf(states[i]) < 0) throw new PolishedError(68);
        selectors.push(generateSelectors(template, states[i]));
    }
    selectors = selectors.join(',');
    return selectors;
}
var stateMap$1 = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function template$1(state) {
    return "button" + state + ",\n  input[type=\"button\"]" + state + ",\n  input[type=\"reset\"]" + state + ",\n  input[type=\"submit\"]" + state;
}
/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */ function buttons() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return statefulSelectors(states, template$1, stateMap$1);
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */ function margin() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return directionalProperty.apply(void 0, [
        'margin'
    ].concat(values));
}
/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */ function padding() {
    for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++)values[_key] = arguments[_key];
    return directionalProperty.apply(void 0, [
        'padding'
    ].concat(values));
}
var positionMap = [
    'absolute',
    'fixed',
    'relative',
    'static',
    'sticky'
];
/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */ function position(firstValue) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    if (positionMap.indexOf(firstValue) >= 0 && firstValue) return (0, _extendsDefault.default)({}, directionalProperty.apply(void 0, [
        ''
    ].concat(values)), {
        position: firstValue
    });
    else return directionalProperty.apply(void 0, [
        '',
        firstValue
    ].concat(values));
}
/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */ function size(height, width) {
    if (width === void 0) width = height;
    return {
        height: height,
        width: width
    };
}
var stateMap = [
    undefined,
    null,
    'active',
    'focus',
    'hover'
];
function template(state) {
    return "input[type=\"color\"]" + state + ",\n    input[type=\"date\"]" + state + ",\n    input[type=\"datetime\"]" + state + ",\n    input[type=\"datetime-local\"]" + state + ",\n    input[type=\"email\"]" + state + ",\n    input[type=\"month\"]" + state + ",\n    input[type=\"number\"]" + state + ",\n    input[type=\"password\"]" + state + ",\n    input[type=\"search\"]" + state + ",\n    input[type=\"tel\"]" + state + ",\n    input[type=\"text\"]" + state + ",\n    input[type=\"time\"]" + state + ",\n    input[type=\"url\"]" + state + ",\n    input[type=\"week\"]" + state + ",\n    input:not([type])" + state + ",\n    textarea" + state;
}
/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */ function textInputs() {
    for(var _len = arguments.length, states = new Array(_len), _key = 0; _key < _len; _key++)states[_key] = arguments[_key];
    return statefulSelectors(states, template, stateMap);
}
/**
 * Accepts any number of transition values as parameters for creating a single transition statement. You may also pass an array of properties as the first parameter that you would like to apply the same transition values to (second parameter).
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s'),
 *   ...transitions(['color', 'background-color'], '2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')};
 *   ${transitions(['color', 'background-color'], '2.0s ease-in 2s'),};
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 *   'transition': 'color 2.0s ease-in 2s, background-color 2.0s ease-in 2s',
 * }
 */ function transitions() {
    for(var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++)properties[_key] = arguments[_key];
    if (Array.isArray(properties[0]) && properties.length === 2) {
        var value = properties[1];
        if (typeof value !== 'string') throw new PolishedError(61);
        var transitionsString = properties[0].map(function(property) {
            return property + " " + value;
        }).join(', ');
        return {
            transition: transitionsString
        };
    } else return {
        transition: properties.join(', ')
    };
}

},{"@babel/runtime/helpers/esm/extends":"godgH","@babel/runtime/helpers/esm/assertThisInitialized":"lCRXc","@babel/runtime/helpers/esm/inheritsLoose":"7TmKe","@babel/runtime/helpers/esm/wrapNativeSuper":"fCYmm","@babel/runtime/helpers/esm/taggedTemplateLiteralLoose":"8zSQG","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"godgH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"lCRXc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_assertThisInitialized);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"7TmKe":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inheritsLoose);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    (0, _setPrototypeOfJsDefault.default)(subClass, superClass);
}

},{"./setPrototypeOf.js":"hzu9U","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"hzu9U":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"fCYmm":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_wrapNativeSuper);
var _getPrototypeOfJs = require("./getPrototypeOf.js");
var _getPrototypeOfJsDefault = parcelHelpers.interopDefault(_getPrototypeOfJs);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
var _isNativeFunctionJs = require("./isNativeFunction.js");
var _isNativeFunctionJsDefault = parcelHelpers.interopDefault(_isNativeFunctionJs);
var _constructJs = require("./construct.js");
var _constructJsDefault = parcelHelpers.interopDefault(_constructJs);
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !(0, _isNativeFunctionJsDefault.default)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, _constructJsDefault.default)(Class, arguments, (0, _getPrototypeOfJsDefault.default)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, _setPrototypeOfJsDefault.default)(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}

},{"./getPrototypeOf.js":"dpGnc","./setPrototypeOf.js":"hzu9U","./isNativeFunction.js":"86mZd","./construct.js":"bhQid","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"dpGnc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_getPrototypeOf);
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"86mZd":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isNativeFunction);
function _isNativeFunction(fn) {
    try {
        return Function.toString.call(fn).indexOf("[native code]") !== -1;
    } catch (e) {
        return typeof fn === "function";
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"bhQid":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_construct);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
var _isNativeReflectConstructJs = require("./isNativeReflectConstruct.js");
var _isNativeReflectConstructJsDefault = parcelHelpers.interopDefault(_isNativeReflectConstructJs);
function _construct(t, e, r) {
    if ((0, _isNativeReflectConstructJsDefault.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, _setPrototypeOfJsDefault.default)(p, r.prototype), p;
}

},{"./setPrototypeOf.js":"hzu9U","./isNativeReflectConstruct.js":"kPOqR","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"kPOqR":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isNativeReflectConstruct);
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"8zSQG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_taggedTemplateLiteralLoose);
function _taggedTemplateLiteralLoose(strings, raw) {
    if (!raw) raw = strings.slice(0);
    strings.raw = raw;
    return strings;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"hzDtQ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(n) {
        var r = n.children, t = void 0 === r ? "" : r, a = n.options, o = function(e, n) {
            if (null == e) return {};
            var r, t, i = {}, a = Object.keys(e);
            for(t = 0; t < a.length; t++)n.indexOf(r = a[t]) >= 0 || (i[r] = e[r]);
            return i;
        }(n, i);
        return _react.cloneElement(qe(t, a), o);
    });
parcelHelpers.export(exports, "RuleType", ()=>r);
parcelHelpers.export(exports, "compiler", ()=>qe);
parcelHelpers.export(exports, "slugify", ()=>Ae);
var _react = require("react");
function n() {
    return n = Object.assign ? Object.assign.bind() : function(e) {
        for(var n = 1; n < arguments.length; n++){
            var r = arguments[n];
            for(var t in r)Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
        }
        return e;
    }, n.apply(this, arguments);
}
var r, t, i = [
    "children",
    "options"
];
!function(e) {
    e.blockQuote = "0", e.breakLine = "1", e.breakThematic = "2", e.codeBlock = "3", e.codeFenced = "4", e.codeInline = "5", e.footnote = "6", e.footnoteReference = "7", e.gfmTask = "8", e.heading = "9", e.headingSetext = "10", e.htmlBlock = "11", e.htmlComment = "12", e.htmlSelfClosing = "13", e.image = "14", e.link = "15", e.linkAngleBraceStyleDetector = "16", e.linkBareUrlDetector = "17", e.linkMailtoDetector = "18", e.newlineCoalescer = "19", e.orderedList = "20", e.paragraph = "21", e.ref = "22", e.refImage = "23", e.refLink = "24", e.table = "25", e.tableSeparator = "26", e.text = "27", e.textBolded = "28", e.textEmphasized = "29", e.textEscaped = "30", e.textMarked = "31", e.textStrikethroughed = "32", e.unorderedList = "33";
}(r || (r = {})), function(e) {
    e[e.MAX = 0] = "MAX", e[e.HIGH = 1] = "HIGH", e[e.MED = 2] = "MED", e[e.LOW = 3] = "LOW", e[e.MIN = 4] = "MIN";
}(t || (t = {}));
var a = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "className",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce(function(e, n) {
    return e[n.toLowerCase()] = n, e;
}, {
    for: "htmlFor"
}), o = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, c = [
    "style",
    "script"
], l = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, u = /mailto:/i, s = /\n{2,}$/, f = /^(\s*>[\s\S]*?)(?=\n{2,})/, d = /^ *> ?/gm, p = /^ {2,}\n/, h = /^(?:( *[-*_])){3,} *(?:\n *)+\n/, m = /^\s*(`{3,}|~{3,}) *(\S+)?([^\n]*?)?\n([\s\S]+?)\s*\1 *(?:\n *)*\n?/, g = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, y = /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/, v = /^(?:\n *)*\n/, k = /\r\n?/g, x = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, b = /^\[\^([^\]]+)]/, E = /\f/g, w = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, S = /^\s*?\[(x|\s)\]/, C = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, A = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, O = /^([^\n]+)\n *(=|-){3,} *(?:\n *)+\n/, $ = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, T = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, L = /^<!--[\s\S]*?(?:-->)/, R = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, z = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, M = /^\{.*\}$/, I = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, U = /^<([^ >]+@[^ >]+)>/, j = /^<([^ >]+:\/[^ >]+)>/, B = /-([a-z])?/gi, N = /^(.*\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, H = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, D = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, P = /^\[([^\]]*)\] ?\[([^\]]*)\]/, _ = /(\[|\])/g, F = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, W = /\t/g, G = /(^ *\||\| *$)/g, Z = /^ *:-+: *$/, q = /^ *:-+ *$/, V = /^ *-+: *$/, X = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|~~.*?~~|==.*?==|.|\\n)*?)", Q = new RegExp("^([*_])\\1" + X + "\\1\\1(?!\\1)"), J = new RegExp("^([*_])" + X + "\\1(?!\\1|\\w)"), K = new RegExp("^==" + X + "=="), Y = new RegExp("^~~" + X + "~~"), ee = /^\\([^0-9A-Za-z\s])/, ne = /^[\s\S]+?(?=[^0-9A-Z\s\u00c0-\uffff&#;.()'"]|\d+\.|\n\n| {2,}\n|\w+:\S|$)/i, re = /^\n+/, te = /^([ \t]*)/, ie = /\\([^\\])/g, ae = / *\n+$/, oe = /(?:^|\n)( *)$/, ce = "(?:\\d+\\.)", le = "(?:[*+-])";
function ue(e) {
    return "( *)(" + (1 === e ? ce : le) + ") +";
}
var se = ue(1), fe = ue(2);
function de(e) {
    return new RegExp("^" + (1 === e ? se : fe));
}
var pe = de(1), he = de(2);
function me(e) {
    return new RegExp("^" + (1 === e ? se : fe) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? ce : le) + " )[^\\n]*)*(\\n|$)", "gm");
}
var ge = me(1), ye = me(2);
function ve(e) {
    var n = 1 === e ? ce : le;
    return new RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
}
var ke = ve(1), xe = ve(2);
function be(e, n) {
    var r = 1 === n, t = r ? ke : xe, i = r ? ge : ye, a = r ? pe : he;
    return {
        match: function(e, n, r) {
            var i = oe.exec(r);
            return i && (n.list || !n.inline && !n.simple) ? t.exec(e = i[1] + e) : null;
        },
        order: 1,
        parse: function(e, n, t) {
            var o = r ? +e[2] : void 0, c = e[0].replace(s, "\n").match(i), l = !1;
            return {
                items: c.map(function(e, r) {
                    var i = a.exec(e)[0].length, o = new RegExp("^ {1," + i + "}", "gm"), u = e.replace(o, "").replace(a, ""), s = r === c.length - 1, f = -1 !== u.indexOf("\n\n") || s && l;
                    l = f;
                    var d, p = t.inline, h = t.list;
                    t.list = !0, f ? (t.inline = !1, d = u.replace(ae, "\n\n")) : (t.inline = !0, d = u.replace(ae, ""));
                    var m = n(d, t);
                    return t.inline = p, t.list = h, m;
                }),
                ordered: r,
                start: o
            };
        },
        render: function(n, r, t) {
            return e(n.ordered ? "ol" : "ul", {
                key: t.key,
                start: "20" === n.type ? n.start : void 0
            }, n.items.map(function(n, i) {
                return e("li", {
                    key: i
                }, r(n, t));
            }));
        }
    };
}
var Ee = new RegExp("^\\[((?:\\[[^\\]]*\\]|[^\\[\\]]|\\](?=[^\\[]*\\]))*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), we = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/, Se = [
    f,
    m,
    g,
    C,
    O,
    A,
    L,
    N,
    ge,
    ke,
    ye,
    xe
], Ce = [].concat(Se, [
    /^[^\n]+(?:  \n|\n{2,})/,
    $,
    z
]);
function Ae(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function Oe(e) {
    return V.test(e) ? "right" : Z.test(e) ? "center" : q.test(e) ? "left" : null;
}
function $e(e, n, r, t) {
    var i = r.inTable;
    r.inTable = !0;
    var a = e.trim().split(/( *(?:`[^`]*`|<.*?>.*?<\/.*?>(?!<\/.*?>)|\\\||\|) *)/).reduce(function(e, i) {
        return "|" === i.trim() ? e.push(t ? {
            type: "26"
        } : {
            type: "27",
            text: i
        }) : "" !== i && e.push.apply(e, n(i, r)), e;
    }, []);
    r.inTable = i;
    var o = [
        []
    ];
    return a.forEach(function(e, n) {
        "26" === e.type ? 0 !== n && n !== a.length - 1 && o.push([]) : ("27" !== e.type || null != a[n + 1] && "26" !== a[n + 1].type || (e.text = e.text.trimEnd()), o[o.length - 1].push(e));
    }), o;
}
function Te(e, n, r) {
    r.inline = !0;
    var t = e[2] ? e[2].replace(G, "").split("|").map(Oe) : [], i = e[3] ? function(e, n, r) {
        return e.trim().split("\n").map(function(e) {
            return $e(e, n, r, !0);
        });
    }(e[3], n, r) : [], a = $e(e[1], n, r, !!i.length);
    return r.inline = !1, i.length ? {
        align: t,
        cells: i,
        header: a,
        type: "25"
    } : {
        children: a,
        type: "21"
    };
}
function Le(e, n) {
    return null == e.align[n] ? {} : {
        textAlign: e.align[n]
    };
}
function Re(e) {
    return function(n, r) {
        return r.inline ? e.exec(n) : null;
    };
}
function ze(e) {
    return function(n, r) {
        return r.inline || r.simple ? e.exec(n) : null;
    };
}
function Me(e) {
    return function(n, r) {
        return r.inline || r.simple ? null : e.exec(n);
    };
}
function Ie(e) {
    return function(n) {
        return e.exec(n);
    };
}
function Ue(e, n, r) {
    if (n.inline || n.simple) return null;
    if (r && !r.endsWith("\n")) return null;
    var t = "";
    e.split("\n").every(function(e) {
        return !Se.some(function(n) {
            return n.test(e);
        }) && (t += e + "\n", e.trim());
    });
    var i = t.trimEnd();
    return "" == i ? null : [
        t,
        i
    ];
}
function je(e) {
    try {
        if (decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "").match(/^\s*(javascript|vbscript|data(?!:image)):/i)) return;
    } catch (e) {
        return null;
    }
    return e;
}
function Be(e) {
    return e.replace(ie, "$1");
}
function Ne(e, n, r) {
    var t = r.inline || !1, i = r.simple || !1;
    r.inline = !0, r.simple = !0;
    var a = e(n, r);
    return r.inline = t, r.simple = i, a;
}
function He(e, n, r) {
    var t = r.inline || !1, i = r.simple || !1;
    r.inline = !1, r.simple = !0;
    var a = e(n, r);
    return r.inline = t, r.simple = i, a;
}
function De(e, n, r) {
    var t = r.inline || !1;
    r.inline = !1;
    var i = e(n, r);
    return r.inline = t, i;
}
var Pe = function(e, n, r) {
    return {
        children: Ne(n, e[1], r)
    };
};
function _e() {
    return {};
}
function Fe() {
    return null;
}
function We() {
    return [].slice.call(arguments).filter(Boolean).join(" ");
}
function Ge(e, n, r) {
    for(var t = e, i = n.split("."); i.length && void 0 !== (t = t[i[0]]);)i.shift();
    return t || r;
}
function Ze(e, n) {
    var r = Ge(n, e);
    return r ? "function" == typeof r || "object" == typeof r && "render" in r ? r : Ge(n, e + ".component", e) : e;
}
function qe(r, t) {
    var i;
    void 0 === r && (r = ""), void 0 === t && (t = {}), t.overrides = t.overrides || {}, t.slugify = t.slugify || Ae, t.namedCodesToUnicode = t.namedCodesToUnicode ? n({}, o, t.namedCodesToUnicode) : o;
    var s = t.createElement || _react.createElement;
    function G(e, r) {
        var i = Ge(t.overrides, e + ".props", {});
        return s.apply(void 0, [
            Ze(e, t.overrides),
            n({}, r, i, {
                className: We(null == r ? void 0 : r.className, i.className) || void 0
            })
        ].concat([].slice.call(arguments, 2)));
    }
    function Z(n) {
        n = n.replace(w, "");
        var r = !1;
        t.forceInline ? r = !0 : t.forceBlock || (r = !1 === F.test(n));
        for(var i = ce(oe(r ? n : n.trimEnd().replace(re, "") + "\n\n", {
            inline: r
        })); "string" == typeof i[i.length - 1] && !i[i.length - 1].trim();)i.pop();
        if (null === t.wrapper) return i;
        var a, o = t.wrapper || (r ? "span" : "div");
        if (i.length > 1 || t.forceWrapper) a = i;
        else {
            if (1 === i.length) return "string" == typeof (a = i[0]) ? G("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return _react.createElement(o, {
            key: "outer"
        }, a);
    }
    function q(n) {
        var r = n.match(l);
        return r ? r.reduce(function(n, r, t) {
            var i = r.indexOf("=");
            if (-1 !== i) {
                var o = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match(R) && (e = e.replace(B, function(e, n) {
                        return n.toUpperCase();
                    })), e;
                })(r.slice(0, i)).trim(), c = function(e) {
                    var n = e[0];
                    return ('"' === n || "'" === n) && e.length >= 2 && e[e.length - 1] === n ? e.slice(1, -1) : e;
                }(r.slice(i + 1).trim()), l = a[o] || o, u = n[l] = function(e, n) {
                    return "style" === e ? n.split(/;\s?/).reduce(function(e, n) {
                        var r = n.slice(0, n.indexOf(":"));
                        return e[r.trim().replace(/(-[a-z])/g, function(e) {
                            return e[1].toUpperCase();
                        })] = n.slice(r.length + 1).trim(), e;
                    }, {}) : "href" === e || "src" === e ? je(n) : (n.match(M) && (n = n.slice(1, n.length - 1)), "true" === n || "false" !== n && n);
                }(o, c);
                "string" == typeof u && ($.test(u) || z.test(u)) && (n[l] = _react.cloneElement(Z(u.trim()), {
                    key: t
                }));
            } else "style" !== r && (n[a[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    var V = [], X = {}, ie = ((i = {})[0] = {
        match: Me(f),
        order: 1,
        parse: function(e, n, r) {
            return {
                children: n(e[0].replace(d, ""), r)
            };
        },
        render: function(e, n, r) {
            return G("blockquote", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[1] = {
        match: Ie(p),
        order: 1,
        parse: _e,
        render: function(e, n, r) {
            return G("br", {
                key: r.key
            });
        }
    }, i[2] = {
        match: Me(h),
        order: 1,
        parse: _e,
        render: function(e, n, r) {
            return G("hr", {
                key: r.key
            });
        }
    }, i[3] = {
        match: Me(g),
        order: 0,
        parse: function(e) {
            return {
                lang: void 0,
                text: e[0].replace(/^ {4}/gm, "").replace(/\n+$/, "")
            };
        },
        render: function(e, r, t) {
            return G("pre", {
                key: t.key
            }, G("code", n({}, e.attrs, {
                className: e.lang ? "lang-" + e.lang : ""
            }), e.text));
        }
    }, i[4] = {
        match: Me(m),
        order: 0,
        parse: function(e) {
            return {
                attrs: q(e[3] || ""),
                lang: e[2] || void 0,
                text: e[4],
                type: "3"
            };
        }
    }, i[5] = {
        match: ze(y),
        order: 3,
        parse: function(e) {
            return {
                text: e[2]
            };
        },
        render: function(e, n, r) {
            return G("code", {
                key: r.key
            }, e.text);
        }
    }, i[6] = {
        match: Me(x),
        order: 0,
        parse: function(e) {
            return V.push({
                footnote: e[2],
                identifier: e[1]
            }), {};
        },
        render: Fe
    }, i[7] = {
        match: Re(b),
        order: 1,
        parse: function(e) {
            return {
                target: "#" + t.slugify(e[1]),
                text: e[1]
            };
        },
        render: function(e, n, r) {
            return G("a", {
                key: r.key,
                href: je(e.target)
            }, G("sup", {
                key: r.key
            }, e.text));
        }
    }, i[8] = {
        match: Re(S),
        order: 1,
        parse: function(e) {
            return {
                completed: "x" === e[1].toLowerCase()
            };
        },
        render: function(e, n, r) {
            return G("input", {
                checked: e.completed,
                key: r.key,
                readOnly: !0,
                type: "checkbox"
            });
        }
    }, i[9] = {
        match: Me(t.enforceAtxHeadings ? A : C),
        order: 1,
        parse: function(e, n, r) {
            return {
                children: Ne(n, e[2], r),
                id: t.slugify(e[2]),
                level: e[1].length
            };
        },
        render: function(e, n, r) {
            return G("h" + e.level, {
                id: e.id,
                key: r.key
            }, n(e.children, r));
        }
    }, i[10] = {
        match: Me(O),
        order: 0,
        parse: function(e, n, r) {
            return {
                children: Ne(n, e[1], r),
                level: "=" === e[2] ? 1 : 2,
                type: "9"
            };
        }
    }, i[11] = {
        match: Ie($),
        order: 1,
        parse: function(e, n, r) {
            var t, i = e[3].match(te), a = new RegExp("^" + i[1], "gm"), o = e[3].replace(a, ""), l = (t = o, Ce.some(function(e) {
                return e.test(t);
            }) ? De : Ne), u = e[1].toLowerCase(), s = -1 !== c.indexOf(u), f = {
                attrs: q(e[2]),
                noInnerParse: s,
                tag: (s ? u : e[1]).trim()
            };
            return r.inAnchor = r.inAnchor || "a" === u, s ? f.text = e[3] : f.children = l(n, o, r), r.inAnchor = !1, f;
        },
        render: function(e, r, t) {
            return G(e.tag, n({
                key: t.key
            }, e.attrs), e.text || r(e.children, t));
        }
    }, i[13] = {
        match: Ie(z),
        order: 1,
        parse: function(e) {
            return {
                attrs: q(e[2] || ""),
                tag: e[1].trim()
            };
        },
        render: function(e, r, t) {
            return G(e.tag, n({}, e.attrs, {
                key: t.key
            }));
        }
    }, i[12] = {
        match: Ie(L),
        order: 1,
        parse: function() {
            return {};
        },
        render: Fe
    }, i[14] = {
        match: ze(we),
        order: 1,
        parse: function(e) {
            return {
                alt: e[1],
                target: Be(e[2]),
                title: e[3]
            };
        },
        render: function(e, n, r) {
            return G("img", {
                key: r.key,
                alt: e.alt || void 0,
                title: e.title || void 0,
                src: je(e.target)
            });
        }
    }, i[15] = {
        match: Re(Ee),
        order: 3,
        parse: function(e, n, r) {
            return {
                children: He(n, e[1], r),
                target: Be(e[2]),
                title: e[3]
            };
        },
        render: function(e, n, r) {
            return G("a", {
                key: r.key,
                href: je(e.target),
                title: e.title
            }, n(e.children, r));
        }
    }, i[16] = {
        match: Re(j),
        order: 0,
        parse: function(e) {
            return {
                children: [
                    {
                        text: e[1],
                        type: "27"
                    }
                ],
                target: e[1],
                type: "15"
            };
        }
    }, i[17] = {
        match: function(e, n) {
            return n.inAnchor ? null : Re(I)(e, n);
        },
        order: 0,
        parse: function(e) {
            return {
                children: [
                    {
                        text: e[1],
                        type: "27"
                    }
                ],
                target: e[1],
                title: void 0,
                type: "15"
            };
        }
    }, i[18] = {
        match: Re(U),
        order: 0,
        parse: function(e) {
            var n = e[1], r = e[1];
            return u.test(r) || (r = "mailto:" + r), {
                children: [
                    {
                        text: n.replace("mailto:", ""),
                        type: "27"
                    }
                ],
                target: r,
                type: "15"
            };
        }
    }, i[20] = be(G, 1), i[33] = be(G, 2), i[19] = {
        match: Me(v),
        order: 3,
        parse: _e,
        render: function() {
            return "\n";
        }
    }, i[21] = {
        match: Ue,
        order: 3,
        parse: Pe,
        render: function(e, n, r) {
            return G("p", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[22] = {
        match: Re(H),
        order: 0,
        parse: function(e) {
            return X[e[1]] = {
                target: e[2],
                title: e[4]
            }, {};
        },
        render: Fe
    }, i[23] = {
        match: ze(D),
        order: 0,
        parse: function(e) {
            return {
                alt: e[1] || void 0,
                ref: e[2]
            };
        },
        render: function(e, n, r) {
            return X[e.ref] ? G("img", {
                key: r.key,
                alt: e.alt,
                src: je(X[e.ref].target),
                title: X[e.ref].title
            }) : null;
        }
    }, i[24] = {
        match: Re(P),
        order: 0,
        parse: function(e, n, r) {
            return {
                children: n(e[1], r),
                fallbackChildren: n(e[0].replace(_, "\\$1"), r),
                ref: e[2]
            };
        },
        render: function(e, n, r) {
            return X[e.ref] ? G("a", {
                key: r.key,
                href: je(X[e.ref].target),
                title: X[e.ref].title
            }, n(e.children, r)) : G("span", {
                key: r.key
            }, n(e.fallbackChildren, r));
        }
    }, i[25] = {
        match: Me(N),
        order: 1,
        parse: Te,
        render: function(e, n, r) {
            var t = e;
            return G("table", {
                key: r.key
            }, G("thead", null, G("tr", null, t.header.map(function(e, i) {
                return G("th", {
                    key: i,
                    style: Le(t, i)
                }, n(e, r));
            }))), G("tbody", null, t.cells.map(function(e, i) {
                return G("tr", {
                    key: i
                }, e.map(function(e, i) {
                    return G("td", {
                        key: i,
                        style: Le(t, i)
                    }, n(e, r));
                }));
            })));
        }
    }, i[27] = {
        match: Ie(ne),
        order: 4,
        parse: function(e) {
            return {
                text: e[0].replace(T, function(e, n) {
                    return t.namedCodesToUnicode[n] ? t.namedCodesToUnicode[n] : e;
                })
            };
        },
        render: function(e) {
            return e.text;
        }
    }, i[28] = {
        match: ze(Q),
        order: 2,
        parse: function(e, n, r) {
            return {
                children: n(e[2], r)
            };
        },
        render: function(e, n, r) {
            return G("strong", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[29] = {
        match: ze(J),
        order: 3,
        parse: function(e, n, r) {
            return {
                children: n(e[2], r)
            };
        },
        render: function(e, n, r) {
            return G("em", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[30] = {
        match: ze(ee),
        order: 1,
        parse: function(e) {
            return {
                text: e[1],
                type: "27"
            };
        }
    }, i[31] = {
        match: ze(K),
        order: 3,
        parse: Pe,
        render: function(e, n, r) {
            return G("mark", {
                key: r.key
            }, n(e.children, r));
        }
    }, i[32] = {
        match: ze(Y),
        order: 3,
        parse: Pe,
        render: function(e, n, r) {
            return G("del", {
                key: r.key
            }, n(e.children, r));
        }
    }, i);
    !0 === t.disableParsingRawHTML && (delete ie[11], delete ie[13]);
    var ae, oe = function(e) {
        var n = Object.keys(e);
        function r(t, i) {
            for(var a = [], o = ""; t;)for(var c = 0; c < n.length;){
                var l = n[c], u = e[l], s = u.match(t, i, o);
                if (s) {
                    var f = s[0];
                    t = t.substring(f.length);
                    var d = u.parse(s, r, i);
                    null == d.type && (d.type = l), a.push(d), o = f;
                    break;
                }
                c++;
            }
            return a;
        }
        return n.sort(function(n, r) {
            var t = e[n].order, i = e[r].order;
            return t !== i ? t - i : n < r ? -1 : 1;
        }), function(e, n) {
            return r(function(e) {
                return e.replace(k, "\n").replace(E, "").replace(W, "    ");
            }(e), n);
        };
    }(ie), ce = (ae = function(e, n) {
        return function(r, t, i) {
            var a = e[r.type].render;
            return n ? n(function() {
                return a(r, t, i);
            }, r, t, i) : a(r, t, i);
        };
    }(ie, t.renderRule), function e(n, r) {
        if (void 0 === r && (r = {}), Array.isArray(n)) {
            for(var t = r.key, i = [], a = !1, o = 0; o < n.length; o++){
                r.key = o;
                var c = e(n[o], r), l = "string" == typeof c;
                l && a ? i[i.length - 1] += c : null !== c && i.push(c), a = l;
            }
            return r.key = t, i;
        }
        return ae(n, e, r);
    }), le = Z(r);
    return V.length ? G("div", null, le, G("footer", {
        key: "footer"
    }, V.map(function(e) {
        return G("div", {
            id: t.slugify(e.identifier),
            key: e.identifier
        }, e.identifier, ce(oe(e.footnote, {
            inline: !0
        })));
    }))) : le;
}

},{"react":"jEiK2","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"8xN3e":[function(require,module,exports) {
var baseUniq = require("8e268641906a92b2");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function uniq(array) {
    return array && array.length ? baseUniq(array) : [];
}
module.exports = uniq;

},{"8e268641906a92b2":"42wqW"}],"42wqW":[function(require,module,exports) {
var SetCache = require("56c8470806d11628"), arrayIncludes = require("a1d85be956e037a9"), arrayIncludesWith = require("8cd18f86a4a2c118"), cacheHas = require("3acf9f4a3a78c511"), createSet = require("19b77385b4f7775a"), setToArray = require("4568580f7416eb83");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function baseUniq(array, iteratee, comparator) {
    var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
    } else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) return setToArray(set);
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = baseUniq;

},{"56c8470806d11628":"9Fea0","a1d85be956e037a9":"g3Po2","8cd18f86a4a2c118":"7y3E2","3acf9f4a3a78c511":"74M8n","19b77385b4f7775a":"8Tk8Q","4568580f7416eb83":"8vbub"}],"g3Po2":[function(require,module,exports) {
var baseIndexOf = require("277b2d1a618f2b2f");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
}
module.exports = arrayIncludes;

},{"277b2d1a618f2b2f":"cLnVL"}],"cLnVL":[function(require,module,exports) {
var baseFindIndex = require("badcebec79c8cd4"), baseIsNaN = require("c991ed2b82d165b"), strictIndexOf = require("c0bb8190b05a00a5");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
}
module.exports = baseIndexOf;

},{"badcebec79c8cd4":"9qZUm","c991ed2b82d165b":"5oWIT","c0bb8190b05a00a5":"fG8Ci"}],"9qZUm":[function(require,module,exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = baseFindIndex;

},{}],"5oWIT":[function(require,module,exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function baseIsNaN(value) {
    return value !== value;
}
module.exports = baseIsNaN;

},{}],"fG8Ci":[function(require,module,exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = strictIndexOf;

},{}],"7y3E2":[function(require,module,exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = arrayIncludesWith;

},{}],"8Tk8Q":[function(require,module,exports) {
var Set = require("17777365baf8e16"), noop = require("a02c367b3608ccee"), setToArray = require("cd8d0af6a14b2f7d");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var createSet = !(Set && 1 / setToArray(new Set([
    ,
    -0
]))[1] == INFINITY) ? noop : function(values) {
    return new Set(values);
};
module.exports = createSet;

},{"17777365baf8e16":"893dZ","a02c367b3608ccee":"ahSPy","cd8d0af6a14b2f7d":"8vbub"}],"ahSPy":[function(require,module,exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function noop() {
// No operation performed.
}
module.exports = noop;

},{}],"cxaW8":[function(require,module,exports) {
var baseClone = require("9b38cc9a3ba32230");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}
module.exports = cloneDeep;

},{"9b38cc9a3ba32230":"iHIyk"}],"iHIyk":[function(require,module,exports) {
var Stack = require("c3256a0a192955f9"), arrayEach = require("3a79976eb46af94a"), assignValue = require("bc83a05a4f99d69b"), baseAssign = require("e6b4c3e6c85df6bb"), baseAssignIn = require("f340cc553ba5643c"), cloneBuffer = require("e72e99883a50402d"), copyArray = require("dc840ead07f1054"), copySymbols = require("309288e8ee190af0"), copySymbolsIn = require("687fa30fede0b048"), getAllKeys = require("bb0ba724f98b094d"), getAllKeysIn = require("12bae1dca0e83064"), getTag = require("4c3204eaea28d680"), initCloneArray = require("fd7741200b462cdf"), initCloneByTag = require("f93a1d24ac08e076"), initCloneObject = require("630039e80f692f17"), isArray = require("f37949484ab52dae"), isBuffer = require("ac876cc65d29c86e"), isMap = require("1056c031d98783c0"), isObject = require("1800fb3122907fc2"), isSet = require("31f022f648037bd3"), keys = require("5f3267fbd9848a7d"), keysIn = require("7d3f3bdc4f2e7bb8");
/** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (isSet(value)) value.forEach(function(subValue) {
        result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if (isMap(value)) value.forEach(function(subValue, key) {
        result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
    var props = isArr ? undefined : keysFunc(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = baseClone;

},{"c3256a0a192955f9":"enjqg","3a79976eb46af94a":"iTUGE","bc83a05a4f99d69b":"4PoVN","e6b4c3e6c85df6bb":"lwZCh","f340cc553ba5643c":"7yz7K","e72e99883a50402d":"igTU3","dc840ead07f1054":"46bXb","309288e8ee190af0":"1XkGe","687fa30fede0b048":"kENZ9","bb0ba724f98b094d":"jGJUz","12bae1dca0e83064":"bwb6U","4c3204eaea28d680":"hjkbJ","fd7741200b462cdf":"jYAGe","f93a1d24ac08e076":"65iap","630039e80f692f17":"guHLd","f37949484ab52dae":"dwcs0","ac876cc65d29c86e":"bLdH1","1056c031d98783c0":"imFhY","1800fb3122907fc2":"aI4dY","31f022f648037bd3":"cQD7M","5f3267fbd9848a7d":"fcKpe","7d3f3bdc4f2e7bb8":"5cYT3"}],"iTUGE":[function(require,module,exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = arrayEach;

},{}],"lwZCh":[function(require,module,exports) {
var copyObject = require("c7567f70ddd05963"), keys = require("fcf23a0242ef0da9");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
module.exports = baseAssign;

},{"c7567f70ddd05963":"9JpIX","fcf23a0242ef0da9":"fcKpe"}],"9JpIX":[function(require,module,exports) {
var assignValue = require("51e2769785cbfa78"), baseAssignValue = require("9cddf6ac1a092765");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) baseAssignValue(object, key, newValue);
        else assignValue(object, key, newValue);
    }
    return object;
}
module.exports = copyObject;

},{"51e2769785cbfa78":"4PoVN","9cddf6ac1a092765":"gnpgU"}],"7yz7K":[function(require,module,exports) {
var copyObject = require("6f2a44bcb454186d"), keysIn = require("7697a1565646c93");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssignIn(object, source) {
    return object && copyObject(source, keysIn(source), object);
}
module.exports = baseAssignIn;

},{"6f2a44bcb454186d":"9JpIX","7697a1565646c93":"5cYT3"}],"igTU3":[function(require,module,exports) {
var root = require("5d68e87b918bbcc5");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

},{"5d68e87b918bbcc5":"dvzJn"}],"46bXb":[function(require,module,exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = copyArray;

},{}],"1XkGe":[function(require,module,exports) {
var copyObject = require("4cc37626612884ad"), getSymbols = require("39cbde2205d9399c");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
module.exports = copySymbols;

},{"4cc37626612884ad":"9JpIX","39cbde2205d9399c":"bYz0d"}],"kENZ9":[function(require,module,exports) {
var copyObject = require("73fd77060a6bfcff"), getSymbolsIn = require("9b660e6b0c20d303");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbolsIn(source, object) {
    return copyObject(source, getSymbolsIn(source), object);
}
module.exports = copySymbolsIn;

},{"73fd77060a6bfcff":"9JpIX","9b660e6b0c20d303":"7BzRx"}],"jYAGe":[function(require,module,exports) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = initCloneArray;

},{}],"65iap":[function(require,module,exports) {
var cloneArrayBuffer = require("d24f0b9a34d2e38a"), cloneDataView = require("dbf04edaab2ae376"), cloneRegExp = require("763300f2dd9bdaf3"), cloneSymbol = require("c30e64d90e4b92d1"), cloneTypedArray = require("d1edd8349e9ad54d");
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return new Ctor;
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return new Ctor;
        case symbolTag:
            return cloneSymbol(object);
    }
}
module.exports = initCloneByTag;

},{"d24f0b9a34d2e38a":"MwSF1","dbf04edaab2ae376":"103oQ","763300f2dd9bdaf3":"lHHoh","c30e64d90e4b92d1":"a4TZh","d1edd8349e9ad54d":"hTk4M"}],"MwSF1":[function(require,module,exports) {
var Uint8Array = require("c50984a96481fd62");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
module.exports = cloneArrayBuffer;

},{"c50984a96481fd62":"lgATB"}],"103oQ":[function(require,module,exports) {
var cloneArrayBuffer = require("55b473c4a5622b5a");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = cloneDataView;

},{"55b473c4a5622b5a":"MwSF1"}],"lHHoh":[function(require,module,exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = cloneRegExp;

},{}],"a4TZh":[function(require,module,exports) {
var Symbol = require("b88cf659c1f1d984");
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
module.exports = cloneSymbol;

},{"b88cf659c1f1d984":"iDKv6"}],"hTk4M":[function(require,module,exports) {
var cloneArrayBuffer = require("b3183de060e04548");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = cloneTypedArray;

},{"b3183de060e04548":"MwSF1"}],"guHLd":[function(require,module,exports) {
var baseCreate = require("4a25a11eb90445e8"), getPrototype = require("8c92276927b7c3e0"), isPrototype = require("e939f15d7a0f64a5");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
module.exports = initCloneObject;

},{"4a25a11eb90445e8":"c2vj5","8c92276927b7c3e0":"c5KIq","e939f15d7a0f64a5":"81Qi0"}],"c2vj5":[function(require,module,exports) {
var isObject = require("2c87f13f7934e7bd");
/** Built-in value references. */ var objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!isObject(proto)) return {};
        if (objectCreate) return objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = baseCreate;

},{"2c87f13f7934e7bd":"aI4dY"}],"imFhY":[function(require,module,exports) {
var baseIsMap = require("bcb4b5290583d129"), baseUnary = require("6a7e6b1a2d9fb1d5"), nodeUtil = require("7d4f449dd306450f");
/* Node.js helper references. */ var nodeIsMap = nodeUtil && nodeUtil.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
module.exports = isMap;

},{"bcb4b5290583d129":"7ATW3","6a7e6b1a2d9fb1d5":"k85OI","7d4f449dd306450f":"gAEjC"}],"7ATW3":[function(require,module,exports) {
var getTag = require("f59b9932854175ea"), isObjectLike = require("88260e33e0003386");
/** `Object#toString` result references. */ var mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function baseIsMap(value) {
    return isObjectLike(value) && getTag(value) == mapTag;
}
module.exports = baseIsMap;

},{"f59b9932854175ea":"hjkbJ","88260e33e0003386":"kcpfl"}],"cQD7M":[function(require,module,exports) {
var baseIsSet = require("efa5963001bed2f4"), baseUnary = require("3cb35dba719c68b1"), nodeUtil = require("7a3e899a332ff7be");
/* Node.js helper references. */ var nodeIsSet = nodeUtil && nodeUtil.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
module.exports = isSet;

},{"efa5963001bed2f4":"1BPH7","3cb35dba719c68b1":"k85OI","7a3e899a332ff7be":"gAEjC"}],"1BPH7":[function(require,module,exports) {
var getTag = require("3451ecb010f954cc"), isObjectLike = require("b6fc875bc5f351c9");
/** `Object#toString` result references. */ var setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function baseIsSet(value) {
    return isObjectLike(value) && getTag(value) == setTag;
}
module.exports = baseIsSet;

},{"3451ecb010f954cc":"hjkbJ","b6fc875bc5f351c9":"kcpfl"}],"7RlvG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "destroy", ()=>(0, _indexEsmJs.destroy));
parcelHelpers.export(exports, "init", ()=>(0, _indexEsmJs.init));
parcelHelpers.export(exports, "refresh", ()=>(0, _indexEsmJs.refresh));
var _indexEsmJs = require("./src/js/index-esm.js");
const tocbot = {
    destroy: (0, _indexEsmJs.destroy),
    init: (0, _indexEsmJs.init),
    refresh: (0, _indexEsmJs.refresh)
};
exports.default = tocbot;

},{"./src/js/index-esm.js":"djVlM","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"djVlM":[function(require,module,exports) {
/* eslint no-var: off */ /**
 * Tocbot
 * Tocbot creates a table of contents based on HTML headings on a page,
 * this allows users to easily jump to different sections of the document.
 * Tocbot was inspired by tocify (http://gregfranko.com/jquery.tocify.js/).
 * The main differences are that it works natively without any need for jquery or jquery UI).
 *
 * @author Tim Scanlin
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_options", ()=>_options);
parcelHelpers.export(exports, "_buildHtml", ()=>_buildHtml);
parcelHelpers.export(exports, "_parseContent", ()=>_parseContent);
parcelHelpers.export(exports, "_headingsArray", ()=>_headingsArray);
parcelHelpers.export(exports, "_scrollListener", ()=>_scrollListener);
/**
 * Initialize tocbot.
 * @param {object} customOptions
 */ parcelHelpers.export(exports, "init", ()=>init);
/**
 * Destroy tocbot.
 */ parcelHelpers.export(exports, "destroy", ()=>destroy);
/**
 * Refresh tocbot.
 */ parcelHelpers.export(exports, "refresh", ()=>refresh);
var _buildHtmlJs = require("./build-html.js");
var _buildHtmlJsDefault = parcelHelpers.interopDefault(_buildHtmlJs);
var _defaultOptionsJs = require("./default-options.js");
var _defaultOptionsJsDefault = parcelHelpers.interopDefault(_defaultOptionsJs);
var _parseContentJs = require("./parse-content.js");
var _parseContentJsDefault = parcelHelpers.interopDefault(_parseContentJs);
var _indexJs = require("./scroll-smooth/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _updateTocScrollJs = require("./update-toc-scroll.js");
var _updateTocScrollJsDefault = parcelHelpers.interopDefault(_updateTocScrollJs);
let _options = {} // Object to store current options.
;
let _buildHtml;
let _parseContent;
let _headingsArray;
let _scrollListener;
let clickListener;
function init(customOptions) {
    // Merge defaults with user options.
    // Set to options variable at the top.
    _options = extend((0, _defaultOptionsJsDefault.default), customOptions || {});
    // Init smooth scroll if enabled (default).
    if (_options.scrollSmooth) {
        _options.duration = _options.scrollSmoothDuration;
        _options.offset = _options.scrollSmoothOffset;
        (0, _indexJsDefault.default)(_options);
    }
    // Pass options to these modules.
    _buildHtml = (0, _buildHtmlJsDefault.default)(_options);
    _parseContent = (0, _parseContentJsDefault.default)(_options);
    // Destroy it if it exists first.
    destroy();
    const contentElement = getContentElement(_options);
    if (contentElement === null) return;
    const tocElement = getTocElement(_options);
    if (tocElement === null) return;
    // Get headings array.
    _headingsArray = _parseContent.selectHeadings(contentElement, _options.headingSelector);
    // Return if no headings are found.
    if (_headingsArray === null) return;
    // Build nested headings array.
    const nestedHeadingsObj = _parseContent.nestHeadingsArray(_headingsArray);
    const nestedHeadings = nestedHeadingsObj.nest;
    // Render.
    if (!_options.skipRendering) _buildHtml.render(tocElement, nestedHeadings);
    else // No need to attach listeners if skipRendering is true, this was causing errors.
    return this;
    // Update Sidebar and bind listeners.
    _scrollListener = throttle(function(e) {
        _buildHtml.updateToc(_headingsArray);
        !_options.disableTocScrollSync && (0, _updateTocScrollJsDefault.default)(_options);
        const isTop = e && e.target && e.target.scrollingElement && e.target.scrollingElement.scrollTop === 0;
        if (e && (e.eventPhase === 0 || e.currentTarget === null) || isTop) {
            _buildHtml.updateToc(_headingsArray);
            if (_options.scrollEndCallback) _options.scrollEndCallback(e);
        }
    }, _options.throttleTimeout);
    _scrollListener();
    if (_options.scrollContainer && document.querySelector(_options.scrollContainer)) {
        document.querySelector(_options.scrollContainer).addEventListener('scroll', _scrollListener, false);
        document.querySelector(_options.scrollContainer).addEventListener('resize', _scrollListener, false);
    } else {
        document.addEventListener('scroll', _scrollListener, false);
        document.addEventListener('resize', _scrollListener, false);
    }
    // Bind click listeners to disable animation.
    let timeout = null;
    clickListener = throttle(function(event) {
        if (_options.scrollSmooth) _buildHtml.disableTocAnimation(event);
        _buildHtml.updateToc(_headingsArray);
        // Timeout to re-enable the animation.
        timeout && clearTimeout(timeout);
        timeout = setTimeout(function() {
            _buildHtml.enableTocAnimation();
        }, _options.scrollSmoothDuration);
    }, _options.throttleTimeout);
    if (_options.scrollContainer && document.querySelector(_options.scrollContainer)) document.querySelector(_options.scrollContainer).addEventListener('click', clickListener, false);
    else document.addEventListener('click', clickListener, false);
}
function destroy() {
    const tocElement = getTocElement(_options);
    if (tocElement === null) return;
    if (!_options.skipRendering) // Clear HTML.
    {
        if (tocElement) tocElement.innerHTML = '';
    }
    // Remove event listeners.
    if (_options.scrollContainer && document.querySelector(_options.scrollContainer)) {
        document.querySelector(_options.scrollContainer).removeEventListener('scroll', _scrollListener, false);
        document.querySelector(_options.scrollContainer).removeEventListener('resize', _scrollListener, false);
        if (_buildHtml) document.querySelector(_options.scrollContainer).removeEventListener('click', clickListener, false);
    } else {
        document.removeEventListener('scroll', _scrollListener, false);
        document.removeEventListener('resize', _scrollListener, false);
        if (_buildHtml) document.removeEventListener('click', clickListener, false);
    }
}
function refresh(customOptions) {
    destroy();
    init(customOptions || _options);
}
// From: https://github.com/Raynos/xtend
const hasOwnProperty = Object.prototype.hasOwnProperty;
function extend() {
    const target = {};
    for(let i = 0; i < arguments.length; i++){
        const source = arguments[i];
        for(const key in source)if (hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}
// From: https://remysharp.com/2010/07/21/throttling-function-calls
function throttle(fn, threshold, scope) {
    threshold || (threshold = 250);
    let last;
    let deferTimer;
    return function() {
        const context = scope || this;
        const now = +new Date();
        const args = arguments;
        if (last && now < last + threshold) {
            // hold on to it
            clearTimeout(deferTimer);
            deferTimer = setTimeout(function() {
                last = now;
                fn.apply(context, args);
            }, threshold);
        } else {
            last = now;
            fn.apply(context, args);
        }
    };
}
function getContentElement(options) {
    try {
        return options.contentElement || document.querySelector(options.contentSelector);
    } catch (e) {
        console.warn('Contents element not found: ' + options.contentSelector) // eslint-disable-line
        ;
        return null;
    }
}
function getTocElement(options) {
    try {
        return options.tocElement || document.querySelector(options.tocSelector);
    } catch (e) {
        console.warn('TOC element not found: ' + options.tocSelector) // eslint-disable-line
        ;
        return null;
    }
}

},{"./build-html.js":"7eTMg","./default-options.js":"1UkWh","./parse-content.js":"fvhew","./scroll-smooth/index.js":"9g4Ak","./update-toc-scroll.js":"npnsi","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"7eTMg":[function(require,module,exports) {
/* eslint no-var: off */ /**
 * This file is responsible for building the DOM and updating DOM state.
 *
 * @author Tim Scanlin
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>function(options) {
        var forEach = [].forEach;
        var some = [].some;
        var body = document.body;
        var tocElement;
        var currentlyHighlighting = true;
        var SPACE_CHAR = ' ';
        /**
   * Create link and list elements.
   * @param {Object} d
   * @param {HTMLElement} container
   * @return {HTMLElement}
   */ function createEl(d, container) {
            var link = container.appendChild(createLink(d));
            if (d.children.length) {
                var list = createList(d.isCollapsed);
                d.children.forEach(function(child) {
                    createEl(child, list);
                });
                link.appendChild(list);
            }
        }
        /**
   * Render nested heading array data into a given element.
   * @param {HTMLElement} parent Optional. If provided updates the {@see tocElement} to match.
   * @param {Array} data
   * @return {HTMLElement}
   */ function render(parent, data) {
            var collapsed = false;
            var container = createList(collapsed);
            data.forEach(function(d) {
                createEl(d, container);
            });
            // Return if no TOC element is provided or known.
            tocElement = parent || tocElement;
            if (tocElement === null) return;
            // Remove existing child if it exists.
            if (tocElement.firstChild) tocElement.removeChild(tocElement.firstChild);
            // Just return the parent and don't append the list if no links are found.
            if (data.length === 0) return tocElement;
            // Append the Elements that have been created
            return tocElement.appendChild(container);
        }
        /**
   * Create link element.
   * @param {Object} data
   * @return {HTMLElement}
   */ function createLink(data) {
            var item = document.createElement('li');
            var a = document.createElement('a');
            if (options.listItemClass) item.setAttribute('class', options.listItemClass);
            if (options.onClick) a.onclick = options.onClick;
            if (options.includeTitleTags) a.setAttribute('title', data.textContent);
            if (options.includeHtml && data.childNodes.length) forEach.call(data.childNodes, function(node) {
                a.appendChild(node.cloneNode(true));
            });
            else // Default behavior. Set to textContent to keep tests happy.
            a.textContent = data.textContent;
            a.setAttribute('href', options.basePath + '#' + data.id);
            a.setAttribute('class', options.linkClass + SPACE_CHAR + 'node-name--' + data.nodeName + SPACE_CHAR + options.extraLinkClasses);
            item.appendChild(a);
            return item;
        }
        /**
   * Create list element.
   * @param {Boolean} isCollapsed
   * @return {HTMLElement}
   */ function createList(isCollapsed) {
            var listElement = options.orderedList ? 'ol' : 'ul';
            var list = document.createElement(listElement);
            var classes = options.listClass + SPACE_CHAR + options.extraListClasses;
            if (isCollapsed) {
                // No plus/equals here fixes compilation issue.
                classes = classes + SPACE_CHAR + options.collapsibleClass;
                classes = classes + SPACE_CHAR + options.isCollapsedClass;
            }
            list.setAttribute('class', classes);
            return list;
        }
        /**
   * Update fixed sidebar class.
   * @return {HTMLElement}
   */ function updateFixedSidebarClass() {
            if (options.scrollContainer && document.querySelector(options.scrollContainer)) {
                var top;
                top = document.querySelector(options.scrollContainer).scrollTop;
            } else top = document.documentElement.scrollTop || body.scrollTop;
            var posFixedEl = document.querySelector(options.positionFixedSelector);
            if (options.fixedSidebarOffset === 'auto') options.fixedSidebarOffset = tocElement.offsetTop;
            if (top > options.fixedSidebarOffset) {
                if (posFixedEl.className.indexOf(options.positionFixedClass) === -1) posFixedEl.className += SPACE_CHAR + options.positionFixedClass;
            } else posFixedEl.className = posFixedEl.className.replace(SPACE_CHAR + options.positionFixedClass, '');
        }
        /**
   * Get top position of heading
   * @param {HTMLElement} obj
   * @return {int} position
   */ function getHeadingTopPos(obj) {
            var position = 0;
            if (obj !== null) {
                position = obj.offsetTop;
                if (options.hasInnerContainers) position += getHeadingTopPos(obj.offsetParent);
            }
            return position;
        }
        /**
   * Update className only when changed.
   * @param {HTMLElement} obj
   * @param {string} className
   * @return {HTMLElement} obj
   */ function updateClassname(obj, className) {
            if (obj && obj.className !== className) obj.className = className;
            return obj;
        }
        /**
   * Update TOC highlighting and collapsed groupings.
   */ function updateToc(headingsArray) {
            // If a fixed content container was set
            if (options.scrollContainer && document.querySelector(options.scrollContainer)) {
                var top;
                top = document.querySelector(options.scrollContainer).scrollTop;
            } else top = document.documentElement.scrollTop || body.scrollTop;
            // Add fixed class at offset
            if (options.positionFixedSelector) updateFixedSidebarClass();
            // Get the top most heading currently visible on the page so we know what to highlight.
            var headings = headingsArray;
            var topHeader;
            // Using some instead of each so that we can escape early.
            if (currentlyHighlighting && tocElement !== null && headings.length > 0) {
                some.call(headings, function(heading, i) {
                    if (getHeadingTopPos(heading) > top + options.headingsOffset + 10) {
                        // Don't allow negative index value.
                        var index = i === 0 ? i : i - 1;
                        topHeader = headings[index];
                        return true;
                    } else if (i === headings.length - 1) {
                        // This allows scrolling for the last heading on the page.
                        topHeader = headings[headings.length - 1];
                        return true;
                    }
                });
                var oldActiveTocLink = tocElement.querySelector('.' + options.activeLinkClass);
                var activeTocLink = tocElement.querySelector('.' + options.linkClass + '.node-name--' + topHeader.nodeName + '[href="' + options.basePath + '#' + topHeader.id.replace(/([ #;&,.+*~':"!^$[\]()=>|/\\@])/g, '\\$1') + '"]');
                // Performance improvement to only change the classes
                // for the toc if a new link should be highlighted.
                if (oldActiveTocLink === activeTocLink) return;
                // Remove the active class from the other tocLinks.
                var tocLinks = tocElement.querySelectorAll('.' + options.linkClass);
                forEach.call(tocLinks, function(tocLink) {
                    updateClassname(tocLink, tocLink.className.replace(SPACE_CHAR + options.activeLinkClass, ''));
                });
                var tocLis = tocElement.querySelectorAll('.' + options.listItemClass);
                forEach.call(tocLis, function(tocLi) {
                    updateClassname(tocLi, tocLi.className.replace(SPACE_CHAR + options.activeListItemClass, ''));
                });
                // Add the active class to the active tocLink.
                if (activeTocLink && activeTocLink.className.indexOf(options.activeLinkClass) === -1) activeTocLink.className += SPACE_CHAR + options.activeLinkClass;
                var li = activeTocLink && activeTocLink.parentNode;
                if (li && li.className.indexOf(options.activeListItemClass) === -1) li.className += SPACE_CHAR + options.activeListItemClass;
                var tocLists = tocElement.querySelectorAll('.' + options.listClass + '.' + options.collapsibleClass);
                // Collapse the other collapsible lists.
                forEach.call(tocLists, function(list) {
                    if (list.className.indexOf(options.isCollapsedClass) === -1) list.className += SPACE_CHAR + options.isCollapsedClass;
                });
                // Expand the active link's collapsible list and its sibling if applicable.
                if (activeTocLink && activeTocLink.nextSibling && activeTocLink.nextSibling.className.indexOf(options.isCollapsedClass) !== -1) updateClassname(activeTocLink.nextSibling, activeTocLink.nextSibling.className.replace(SPACE_CHAR + options.isCollapsedClass, ''));
                removeCollapsedFromParents(activeTocLink && activeTocLink.parentNode.parentNode);
            }
        }
        /**
   * Remove collapsed class from parent elements.
   * @param {HTMLElement} element
   * @return {HTMLElement}
   */ function removeCollapsedFromParents(element) {
            if (element && element.className.indexOf(options.collapsibleClass) !== -1 && element.className.indexOf(options.isCollapsedClass) !== -1) {
                updateClassname(element, element.className.replace(SPACE_CHAR + options.isCollapsedClass, ''));
                return removeCollapsedFromParents(element.parentNode.parentNode);
            }
            return element;
        }
        /**
   * Disable TOC Animation when a link is clicked.
   * @param {Event} event
   */ function disableTocAnimation(event) {
            var target = event.target || event.srcElement;
            if (typeof target.className !== 'string' || target.className.indexOf(options.linkClass) === -1) return;
            // Bind to tocLink clicks to temporarily disable highlighting
            // while smoothScroll is animating.
            currentlyHighlighting = false;
        }
        /**
   * Enable TOC Animation.
   */ function enableTocAnimation() {
            currentlyHighlighting = true;
        }
        return {
            enableTocAnimation,
            disableTocAnimation,
            render,
            updateToc
        };
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"1UkWh":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    // Where to render the table of contents.
    tocSelector: '.js-toc',
    // Where to grab the headings to build the table of contents.
    contentSelector: '.js-toc-content',
    // Which headings to grab inside of the contentSelector element.
    headingSelector: 'h1, h2, h3',
    // Headings that match the ignoreSelector will be skipped.
    ignoreSelector: '.js-toc-ignore',
    // For headings inside relative or absolute positioned containers within content
    hasInnerContainers: false,
    // Main class to add to links.
    linkClass: 'toc-link',
    // Extra classes to add to links.
    extraLinkClasses: '',
    // Class to add to active links,
    // the link corresponding to the top most heading on the page.
    activeLinkClass: 'is-active-link',
    // Main class to add to lists.
    listClass: 'toc-list',
    // Extra classes to add to lists.
    extraListClasses: '',
    // Class that gets added when a list should be collapsed.
    isCollapsedClass: 'is-collapsed',
    // Class that gets added when a list should be able
    // to be collapsed but isn't necessarily collapsed.
    collapsibleClass: 'is-collapsible',
    // Class to add to list items.
    listItemClass: 'toc-list-item',
    // Class to add to active list items.
    activeListItemClass: 'is-active-li',
    // How many heading levels should not be collapsed.
    // For example, number 6 will show everything since
    // there are only 6 heading levels and number 0 will collapse them all.
    // The sections that are hidden will open
    // and close as you scroll to headings within them.
    collapseDepth: 0,
    // Smooth scrolling enabled.
    scrollSmooth: true,
    // Smooth scroll duration.
    scrollSmoothDuration: 420,
    // Smooth scroll offset.
    scrollSmoothOffset: 0,
    // Callback for scroll end.
    scrollEndCallback: function(e) {},
    // Headings offset between the headings and the top of the document (this is meant for minor adjustments).
    headingsOffset: 1,
    // Timeout between events firing to make sure it's
    // not too rapid (for performance reasons).
    throttleTimeout: 50,
    // Element to add the positionFixedClass to.
    positionFixedSelector: null,
    // Fixed position class to add to make sidebar fixed after scrolling
    // down past the fixedSidebarOffset.
    positionFixedClass: 'is-position-fixed',
    // fixedSidebarOffset can be any number but by default is set
    // to auto which sets the fixedSidebarOffset to the sidebar
    // element's offsetTop from the top of the document on init.
    fixedSidebarOffset: 'auto',
    // includeHtml can be set to true to include the HTML markup from the
    // heading node instead of just including the innerText.
    includeHtml: false,
    // includeTitleTags automatically sets the html title tag of the link
    // to match the title. This can be useful for SEO purposes or
    // when truncating titles.
    includeTitleTags: false,
    // onclick function to apply to all links in toc. will be called with
    // the event as the first parameter, and this can be used to stop,
    // propagation, prevent default or perform action
    onClick: function(e) {},
    // orderedList can be set to false to generate unordered lists (ul)
    // instead of ordered lists (ol)
    orderedList: true,
    // If there is a fixed article scroll container, set to calculate titles' offset
    scrollContainer: null,
    // prevent ToC DOM rendering if it's already rendered by an external system
    skipRendering: false,
    // Optional callback to change heading labels.
    // For example it can be used to cut down and put ellipses on multiline headings you deem too long.
    // Called each time a heading is parsed. Expects a string and returns the modified label to display.
    // Additionally, the attribute `data-heading-label` may be used on a heading to specify
    // a shorter string to be used in the TOC.
    // function (string) => string
    headingLabelCallback: false,
    // ignore headings that are hidden in DOM
    ignoreHiddenElements: false,
    // Optional callback to modify properties of parsed headings.
    // The heading element is passed in node parameter and information parsed by default parser is provided in obj parameter.
    // Function has to return the same or modified obj.
    // The heading will be excluded from TOC if nothing is returned.
    // function (object, HTMLElement) => object | void
    headingObjectCallback: null,
    // Set the base path, useful if you use a `base` tag in `head`.
    basePath: '',
    // Only takes affect when `tocSelector` is scrolling,
    // keep the toc scroll position in sync with the content.
    disableTocScrollSync: false,
    // Offset for the toc scroll (top) position when scrolling the page.
    // Only effective if `disableTocScrollSync` is false.
    tocScrollOffset: 0
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"fvhew":[function(require,module,exports) {
/* eslint no-var: off */ /**
 * This file is responsible for parsing the content from the DOM and making
 * sure data is nested properly.
 *
 * @author Tim Scanlin
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseContent);
function parseContent(options) {
    var reduce = [].reduce;
    /**
   * Get the last item in an array and return a reference to it.
   * @param {Array} array
   * @return {Object}
   */ function getLastItem(array) {
        return array[array.length - 1];
    }
    /**
   * Get heading level for a heading dom node.
   * @param {HTMLElement} heading
   * @return {Number}
   */ function getHeadingLevel(heading) {
        return +heading.nodeName.toUpperCase().replace('H', '');
    }
    /**
   * Determine whether the object is an HTML Element.
   * Also works inside iframes. HTML Elements might be created by the parent document.
   * @param {Object} maybeElement
   * @return {Number}
   */ function isHTMLElement(maybeElement) {
        try {
            return maybeElement instanceof window.HTMLElement || maybeElement instanceof window.parent.HTMLElement;
        } catch (e) {
            return maybeElement instanceof window.HTMLElement;
        }
    }
    /**
   * Get important properties from a heading element and store in a plain object.
   * @param {HTMLElement} heading
   * @return {Object}
   */ function getHeadingObject(heading) {
        // each node is processed twice by this method because nestHeadingsArray() and addNode() calls it
        // first time heading is real DOM node element, second time it is obj
        // that is causing problem so I am processing only original DOM node
        if (!isHTMLElement(heading)) return heading;
        if (options.ignoreHiddenElements && (!heading.offsetHeight || !heading.offsetParent)) return null;
        const headingLabel = heading.getAttribute('data-heading-label') || (options.headingLabelCallback ? String(options.headingLabelCallback(heading.innerText)) : (heading.innerText || heading.textContent).trim());
        var obj = {
            id: heading.id,
            children: [],
            nodeName: heading.nodeName,
            headingLevel: getHeadingLevel(heading),
            textContent: headingLabel
        };
        if (options.includeHtml) obj.childNodes = heading.childNodes;
        if (options.headingObjectCallback) return options.headingObjectCallback(obj, heading);
        return obj;
    }
    /**
   * Add a node to the nested array.
   * @param {Object} node
   * @param {Array} nest
   * @return {Array}
   */ function addNode(node, nest) {
        var obj = getHeadingObject(node);
        var level = obj.headingLevel;
        var array = nest;
        var lastItem = getLastItem(array);
        var lastItemLevel = lastItem ? lastItem.headingLevel : 0;
        var counter = level - lastItemLevel;
        while(counter > 0){
            lastItem = getLastItem(array);
            // Handle case where there are multiple h5+ in a row.
            if (lastItem && level === lastItem.headingLevel) break;
            else if (lastItem && lastItem.children !== undefined) array = lastItem.children;
            counter--;
        }
        if (level >= options.collapseDepth) obj.isCollapsed = true;
        array.push(obj);
        return array;
    }
    /**
   * Select headings in content area, exclude any selector in options.ignoreSelector
   * @param {HTMLElement} contentElement
   * @param {Array} headingSelector
   * @return {Array}
   */ function selectHeadings(contentElement, headingSelector) {
        var selectors = headingSelector;
        if (options.ignoreSelector) selectors = headingSelector.split(',').map(function mapSelectors(selector) {
            return selector.trim() + ':not(' + options.ignoreSelector + ')';
        });
        try {
            return contentElement.querySelectorAll(selectors);
        } catch (e) {
            console.warn('Headers not found with selector: ' + selectors); // eslint-disable-line
            return null;
        }
    }
    /**
   * Nest headings array into nested arrays with 'children' property.
   * @param {Array} headingsArray
   * @return {Object}
   */ function nestHeadingsArray(headingsArray) {
        return reduce.call(headingsArray, function reducer(prev, curr) {
            var currentHeading = getHeadingObject(curr);
            if (currentHeading) addNode(currentHeading, prev.nest);
            return prev;
        }, {
            nest: []
        });
    }
    return {
        nestHeadingsArray,
        selectHeadings
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"9g4Ak":[function(require,module,exports) {
/* eslint no-var: off */ /* globals location, requestAnimationFrame */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>initSmoothScrolling);
function initSmoothScrolling(options) {
    // if (isCssSmoothSCrollSupported()) { return }
    var duration = options.duration;
    var offset = options.offset;
    var pageUrl = location.hash ? stripHash(location.href) : location.href;
    delegatedLinkHijacking();
    function delegatedLinkHijacking() {
        document.body.addEventListener('click', onClick, false);
        function onClick(e) {
            if (!isInPageLink(e.target) || e.target.className.indexOf('no-smooth-scroll') > -1 || e.target.href.charAt(e.target.href.length - 2) === '#' && e.target.href.charAt(e.target.href.length - 1) === '!' || e.target.className.indexOf(options.linkClass) === -1) return;
            // Don't prevent default or hash doesn't change.
            // e.preventDefault()
            jump(e.target.hash, {
                duration,
                offset,
                callback: function() {
                    setFocus(e.target.hash);
                }
            });
        }
    }
    function isInPageLink(n) {
        return n.tagName.toLowerCase() === 'a' && (n.hash.length > 0 || n.href.charAt(n.href.length - 1) === '#') && (stripHash(n.href) === pageUrl || stripHash(n.href) + '#' === pageUrl);
    }
    function stripHash(url) {
        return url.slice(0, url.lastIndexOf('#'));
    }
    // function isCssSmoothSCrollSupported () {
    //   return 'scrollBehavior' in document.documentElement.style
    // }
    // Adapted from:
    // https://www.nczonline.net/blog/2013/01/15/fixing-skip-to-content-links/
    function setFocus(hash) {
        var element = document.getElementById(hash.substring(1));
        if (element) {
            if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) element.tabIndex = -1;
            element.focus();
        }
    }
}
function jump(target, options) {
    var start = window.pageYOffset;
    var opt = {
        duration: options.duration,
        offset: options.offset || 0,
        callback: options.callback,
        easing: options.easing || easeInOutQuad
    };
    // This makes ids that start with a number work: ('[id="' + decodeURI(target).split('#').join('') + '"]')
    // DecodeURI for nonASCII hashes, they was encoded, but id was not encoded, it lead to not finding the tgt element by id.
    // And this is for IE: document.body.scrollTop
    // Handle decoded and non-decoded URIs since sometimes URLs automatically transform them (support for internation chars).
    var tgt = document.querySelector('[id="' + decodeURI(target).split('#').join('') + '"]') || document.querySelector('[id="' + target.split('#').join('') + '"]');
    var distance = typeof target === 'string' ? opt.offset + (target ? tgt && tgt.getBoundingClientRect().top || 0 // handle non-existent links better.
     : -(document.documentElement.scrollTop || document.body.scrollTop)) : target;
    var duration = typeof opt.duration === 'function' ? opt.duration(distance) : opt.duration;
    var timeStart;
    var timeElapsed;
    requestAnimationFrame(function(time) {
        timeStart = time;
        loop(time);
    });
    function loop(time) {
        timeElapsed = time - timeStart;
        window.scrollTo(0, opt.easing(timeElapsed, start, distance, duration));
        if (timeElapsed < duration) requestAnimationFrame(loop);
        else end();
    }
    function end() {
        window.scrollTo(0, start + distance);
        if (typeof opt.callback === 'function') opt.callback();
    }
    // Robert Penner's easeInOutQuad - http://robertpenner.com/easing/
    function easeInOutQuad(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"npnsi":[function(require,module,exports) {
/* eslint no-var: off */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>updateTocScroll);
const SCROLL_LEEWAY = 30;
function updateTocScroll(options) {
    var toc = options.tocElement || document.querySelector(options.tocSelector);
    if (toc && toc.scrollHeight > toc.clientHeight) {
        var activeItem = toc.querySelector('.' + options.activeListItemClass);
        if (activeItem) {
            // Determine container top and bottom
            var cTop = toc.scrollTop;
            var cBottom = cTop + toc.clientHeight;
            // Determine element top and bottom
            var eTop = activeItem.offsetTop;
            var eBottom = eTop + activeItem.clientHeight;
            // Check if out of view
            // Above scroll view
            if (eTop < cTop + options.tocScrollOffset) toc.scrollTop -= cTop - eTop + options.tocScrollOffset;
            else if (eBottom > cBottom - options.tocScrollOffset - SCROLL_LEEWAY) toc.scrollTop += eBottom - cBottom + options.tocScrollOffset + 2 * SCROLL_LEEWAY;
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"lDgfX":[function(require,module,exports) {
module.exports = Promise.resolve(module.bundle.root("2BItW"));

},{}],"lFuTV":[function(require,module,exports) {
module.exports = require("466a203511334c1d")(require("26ac869239a18448").resolve("bhJYu")).then(()=>module.bundle.root('iDabs'));

},{"466a203511334c1d":"bvDWj","26ac869239a18448":"kK08P"}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=preview.2041b5be.js.map
